/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(60);
	
	var _store = __webpack_require__(226);
	
	var _store2 = _interopRequireDefault(_store);
	
	// import AppContainer from './containers/AppContainer';
	
	var _reduxDevtoolsLibReact = __webpack_require__(450);
	
	var _immutable = __webpack_require__(47);
	
	var store = (0, _store2['default'])();
	console.log(store.getState(), store.getState().route.get('route'), { store: store });
	// console.log(AppContainer);
	
	var Router = (function (_Component) {
	  _inherits(Router, _Component);
	
	  function Router() {
	    _classCallCheck(this, Router);
	
	    _get(Object.getPrototypeOf(Router.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Router, [{
	    key: 'render',
	    value: function render() {
	      store.subscribe(this.forceUpdate.bind(this));
	      return _react2['default'].createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2['default'].createElement(store.getState().route.get('route'), { store: store })
	      );
	    }
	  }]);
	
	  return Router;
	})(_react.Component);
	
	_reactDom2['default'].render(_react2['default'].createElement(Router, null), document.getElementById('root'));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(170);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This mixin isn't necessary and will be removed soon. DO NOT USE!
	 *
	 * All internal components that use this mixin should be switched to the
	 * `styleUtils` that this mixin now wraps. Notice the method signature of
	 * the `prepareStyles()` function of this mixin is different than the method
	 * signature of the `prepareStyles()` function in `styleUtils`.
	 *
	 * See `../utils/styles.js` for more details.
	 */
	exports.default = {
	
	  propTypes: {
	    style: _react2.default.PropTypes.object
	  },
	
	  mergeStyles: _styles.mergeStyles,
	
	  mergeAndPrefix: _styles.mergeAndPrefix,
	
	  prepareStyles: function prepareStyles() {
	    var _ref = this.state && this.state.muiTheme || this.context && this.context.muiTheme || this.props && this.props.muiTheme || {};
	
	    var _ref$prepareStyles = _ref.prepareStyles;
	    var prepareStyles = _ref$prepareStyles === undefined ? function (style) {
	      return style;
	    } : _ref$prepareStyles;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return prepareStyles(_styles.mergeStyles.apply(undefined, [{}].concat(args)));
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(164);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _lightBaseTheme = __webpack_require__(100);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(150);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _transformers = __webpack_require__(293);
	
	var _lodash3 = __webpack_require__(343);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(baseTheme, muiTheme) {
	  baseTheme = (0, _lodash2.default)({}, _lightBaseTheme2.default, baseTheme);
	  var _baseTheme = baseTheme;
	  var palette = _baseTheme.palette;
	  var spacing = _baseTheme.spacing;
	
	  muiTheme = (0, _lodash2.default)({
	    isRtl: false,
	    userAgent: undefined,
	    zIndex: _zIndex2.default,
	    baseTheme: baseTheme,
	    rawTheme: baseTheme, // To provide backward compatibility.
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement
	    },
	    avatar: {
	      borderColor: 'rgba(0, 0, 0, 0.08)'
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.accent1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.primary1Color,
	      secondaryTextColor: palette.alternateTextColor
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    flatButton: {
	      color: _colors2.default.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: _colorManipulator2.default.fade(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.accent1Color,
	      secondaryTextColor: palette.primary1Color
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.accent1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.primary1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor
	    },
	    gridTile: {
	      textColor: _colors2.default.white
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    leftNav: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: 'rgba(0, 0, 0, .035)',
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    paper: {
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + _colorManipulator2.default.fade(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + _colorManipulator2.default.fade(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.accent1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.primary1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: _colorManipulator2.default.darken(palette.alternateTextColor, 0.1),
	      disabledTextColor: _colorManipulator2.default.fade(palette.textColor, 0.3)
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: _colorManipulator2.default.lighten(palette.primary1Color, 0.55),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.accent3Color,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: _colorManipulator2.default.fade(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: _colorManipulator2.default.fade(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      backgroundColor: _colorManipulator2.default.darken(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: 'rgba(0, 0, 0, .40)',
	      separatorColor: 'rgba(0, 0, 0, .175)',
	      menuHoverColor: 'rgba(0, 0, 0, .10)'
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: _colorManipulator2.default.fade(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.textColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors2.default.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    }
	  }, muiTheme);
	
	  var transformers = [_transformers.autoprefixer, _transformers.rtl, _transformers.callOnce].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	  muiTheme.prefix = _autoPrefix2.default.getTransform(muiTheme.userAgent);
	  muiTheme.prepareStyles = _lodash4.default.apply(undefined, _toConsumableArray(transformers));
	
	  return muiTheme;
	}
	module.exports = exports['default'];

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(173);


/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(384);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Paper = _react2.default.createClass({
	  displayName: 'Paper',
	
	  propTypes: {
	    /**
	     * Children passed into the paper element.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Set to true to generate a circlular paper container.
	     */
	    circle: _react2.default.PropTypes.bool,
	
	    /**
	     * By default, the paper container will have a border radius.
	     * Set this to false to generate a container with sharp corners.
	     */
	    rounded: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Set to false to disable CSS transitions for the paper element.
	     */
	    transitionEnabled: _react2.default.PropTypes.bool,
	
	    /**
	     * This number represents the zDepth of the paper shadow.
	     */
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      circle: false,
	      rounded: true,
	      transitionEnabled: true,
	      zDepth: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var circle = _props.circle;
	    var rounded = _props.rounded;
	    var style = _props.style;
	    var transitionEnabled = _props.transitionEnabled;
	    var zDepth = _props.zDepth;
	
	    var other = _objectWithoutProperties(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	
	    var styles = {
	      backgroundColor: this.state.muiTheme.paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: this.state.muiTheme.rawTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	      boxShadow: this.state.muiTheme.paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles, style) }),
	      children
	    );
	  }
	});
	
	exports.default = Paper;
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  red50: '#ffebee',
	  red100: '#ffcdd2',
	  red200: '#ef9a9a',
	  red300: '#e57373',
	  red400: '#ef5350',
	  red500: '#f44336',
	  red600: '#e53935',
	  red700: '#d32f2f',
	  red800: '#c62828',
	  red900: '#b71c1c',
	  redA100: '#ff8a80',
	  redA200: '#ff5252',
	  redA400: '#ff1744',
	  redA700: '#d50000',
	
	  pink50: '#fce4ec',
	  pink100: '#f8bbd0',
	  pink200: '#f48fb1',
	  pink300: '#f06292',
	  pink400: '#ec407a',
	  pink500: '#e91e63',
	  pink600: '#d81b60',
	  pink700: '#c2185b',
	  pink800: '#ad1457',
	  pink900: '#880e4f',
	  pinkA100: '#ff80ab',
	  pinkA200: '#ff4081',
	  pinkA400: '#f50057',
	  pinkA700: '#c51162',
	
	  purple50: '#f3e5f5',
	  purple100: '#e1bee7',
	  purple200: '#ce93d8',
	  purple300: '#ba68c8',
	  purple400: '#ab47bc',
	  purple500: '#9c27b0',
	  purple600: '#8e24aa',
	  purple700: '#7b1fa2',
	  purple800: '#6a1b9a',
	  purple900: '#4a148c',
	  purpleA100: '#ea80fc',
	  purpleA200: '#e040fb',
	  purpleA400: '#d500f9',
	  purpleA700: '#aa00ff',
	
	  deepPurple50: '#ede7f6',
	  deepPurple100: '#d1c4e9',
	  deepPurple200: '#b39ddb',
	  deepPurple300: '#9575cd',
	  deepPurple400: '#7e57c2',
	  deepPurple500: '#673ab7',
	  deepPurple600: '#5e35b1',
	  deepPurple700: '#512da8',
	  deepPurple800: '#4527a0',
	  deepPurple900: '#311b92',
	  deepPurpleA100: '#b388ff',
	  deepPurpleA200: '#7c4dff',
	  deepPurpleA400: '#651fff',
	  deepPurpleA700: '#6200ea',
	
	  indigo50: '#e8eaf6',
	  indigo100: '#c5cae9',
	  indigo200: '#9fa8da',
	  indigo300: '#7986cb',
	  indigo400: '#5c6bc0',
	  indigo500: '#3f51b5',
	  indigo600: '#3949ab',
	  indigo700: '#303f9f',
	  indigo800: '#283593',
	  indigo900: '#1a237e',
	  indigoA100: '#8c9eff',
	  indigoA200: '#536dfe',
	  indigoA400: '#3d5afe',
	  indigoA700: '#304ffe',
	
	  blue50: '#e3f2fd',
	  blue100: '#bbdefb',
	  blue200: '#90caf9',
	  blue300: '#64b5f6',
	  blue400: '#42a5f5',
	  blue500: '#2196f3',
	  blue600: '#1e88e5',
	  blue700: '#1976d2',
	  blue800: '#1565c0',
	  blue900: '#0d47a1',
	  blueA100: '#82b1ff',
	  blueA200: '#448aff',
	  blueA400: '#2979ff',
	  blueA700: '#2962ff',
	
	  lightBlue50: '#e1f5fe',
	  lightBlue100: '#b3e5fc',
	  lightBlue200: '#81d4fa',
	  lightBlue300: '#4fc3f7',
	  lightBlue400: '#29b6f6',
	  lightBlue500: '#03a9f4',
	  lightBlue600: '#039be5',
	  lightBlue700: '#0288d1',
	  lightBlue800: '#0277bd',
	  lightBlue900: '#01579b',
	  lightBlueA100: '#80d8ff',
	  lightBlueA200: '#40c4ff',
	  lightBlueA400: '#00b0ff',
	  lightBlueA700: '#0091ea',
	
	  cyan50: '#e0f7fa',
	  cyan100: '#b2ebf2',
	  cyan200: '#80deea',
	  cyan300: '#4dd0e1',
	  cyan400: '#26c6da',
	  cyan500: '#00bcd4',
	  cyan600: '#00acc1',
	  cyan700: '#0097a7',
	  cyan800: '#00838f',
	  cyan900: '#006064',
	  cyanA100: '#84ffff',
	  cyanA200: '#18ffff',
	  cyanA400: '#00e5ff',
	  cyanA700: '#00b8d4',
	
	  teal50: '#e0f2f1',
	  teal100: '#b2dfdb',
	  teal200: '#80cbc4',
	  teal300: '#4db6ac',
	  teal400: '#26a69a',
	  teal500: '#009688',
	  teal600: '#00897b',
	  teal700: '#00796b',
	  teal800: '#00695c',
	  teal900: '#004d40',
	  tealA100: '#a7ffeb',
	  tealA200: '#64ffda',
	  tealA400: '#1de9b6',
	  tealA700: '#00bfa5',
	
	  green50: '#e8f5e9',
	  green100: '#c8e6c9',
	  green200: '#a5d6a7',
	  green300: '#81c784',
	  green400: '#66bb6a',
	  green500: '#4caf50',
	  green600: '#43a047',
	  green700: '#388e3c',
	  green800: '#2e7d32',
	  green900: '#1b5e20',
	  greenA100: '#b9f6ca',
	  greenA200: '#69f0ae',
	  greenA400: '#00e676',
	  greenA700: '#00c853',
	
	  lightGreen50: '#f1f8e9',
	  lightGreen100: '#dcedc8',
	  lightGreen200: '#c5e1a5',
	  lightGreen300: '#aed581',
	  lightGreen400: '#9ccc65',
	  lightGreen500: '#8bc34a',
	  lightGreen600: '#7cb342',
	  lightGreen700: '#689f38',
	  lightGreen800: '#558b2f',
	  lightGreen900: '#33691e',
	  lightGreenA100: '#ccff90',
	  lightGreenA200: '#b2ff59',
	  lightGreenA400: '#76ff03',
	  lightGreenA700: '#64dd17',
	
	  lime50: '#f9fbe7',
	  lime100: '#f0f4c3',
	  lime200: '#e6ee9c',
	  lime300: '#dce775',
	  lime400: '#d4e157',
	  lime500: '#cddc39',
	  lime600: '#c0ca33',
	  lime700: '#afb42b',
	  lime800: '#9e9d24',
	  lime900: '#827717',
	  limeA100: '#f4ff81',
	  limeA200: '#eeff41',
	  limeA400: '#c6ff00',
	  limeA700: '#aeea00',
	
	  yellow50: '#fffde7',
	  yellow100: '#fff9c4',
	  yellow200: '#fff59d',
	  yellow300: '#fff176',
	  yellow400: '#ffee58',
	  yellow500: '#ffeb3b',
	  yellow600: '#fdd835',
	  yellow700: '#fbc02d',
	  yellow800: '#f9a825',
	  yellow900: '#f57f17',
	  yellowA100: '#ffff8d',
	  yellowA200: '#ffff00',
	  yellowA400: '#ffea00',
	  yellowA700: '#ffd600',
	
	  amber50: '#fff8e1',
	  amber100: '#ffecb3',
	  amber200: '#ffe082',
	  amber300: '#ffd54f',
	  amber400: '#ffca28',
	  amber500: '#ffc107',
	  amber600: '#ffb300',
	  amber700: '#ffa000',
	  amber800: '#ff8f00',
	  amber900: '#ff6f00',
	  amberA100: '#ffe57f',
	  amberA200: '#ffd740',
	  amberA400: '#ffc400',
	  amberA700: '#ffab00',
	
	  orange50: '#fff3e0',
	  orange100: '#ffe0b2',
	  orange200: '#ffcc80',
	  orange300: '#ffb74d',
	  orange400: '#ffa726',
	  orange500: '#ff9800',
	  orange600: '#fb8c00',
	  orange700: '#f57c00',
	  orange800: '#ef6c00',
	  orange900: '#e65100',
	  orangeA100: '#ffd180',
	  orangeA200: '#ffab40',
	  orangeA400: '#ff9100',
	  orangeA700: '#ff6d00',
	
	  deepOrange50: '#fbe9e7',
	  deepOrange100: '#ffccbc',
	  deepOrange200: '#ffab91',
	  deepOrange300: '#ff8a65',
	  deepOrange400: '#ff7043',
	  deepOrange500: '#ff5722',
	  deepOrange600: '#f4511e',
	  deepOrange700: '#e64a19',
	  deepOrange800: '#d84315',
	  deepOrange900: '#bf360c',
	  deepOrangeA100: '#ff9e80',
	  deepOrangeA200: '#ff6e40',
	  deepOrangeA400: '#ff3d00',
	  deepOrangeA700: '#dd2c00',
	
	  brown50: '#efebe9',
	  brown100: '#d7ccc8',
	  brown200: '#bcaaa4',
	  brown300: '#a1887f',
	  brown400: '#8d6e63',
	  brown500: '#795548',
	  brown600: '#6d4c41',
	  brown700: '#5d4037',
	  brown800: '#4e342e',
	  brown900: '#3e2723',
	
	  blueGrey50: '#eceff1',
	  blueGrey100: '#cfd8dc',
	  blueGrey200: '#b0bec5',
	  blueGrey300: '#90a4ae',
	  blueGrey400: '#78909c',
	  blueGrey500: '#607d8b',
	  blueGrey600: '#546e7a',
	  blueGrey700: '#455a64',
	  blueGrey800: '#37474f',
	  blueGrey900: '#263238',
	
	  grey50: '#fafafa',
	  grey100: '#f5f5f5',
	  grey200: '#eeeeee',
	  grey300: '#e0e0e0',
	  grey400: '#bdbdbd',
	  grey500: '#9e9e9e',
	  grey600: '#757575',
	  grey700: '#616161',
	  grey800: '#424242',
	  grey900: '#212121',
	
	  black: '#000000',
	  white: '#ffffff',
	
	  transparent: 'rgba(0, 0, 0, 0)',
	  fullBlack: 'rgba(0, 0, 0, 1)',
	  darkBlack: 'rgba(0, 0, 0, 0.87)',
	  lightBlack: 'rgba(0, 0, 0, 0.54)',
	  minBlack: 'rgba(0, 0, 0, 0.26)',
	  faintBlack: 'rgba(0, 0, 0, 0.12)',
	  fullWhite: 'rgba(255, 255, 255, 1)',
	  darkWhite: 'rgba(255, 255, 255, 0.87)',
	  lightWhite: 'rgba(255, 255, 255, 0.54)'
	};
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(32);
	
	var assign = __webpack_require__(7);
	var canDefineProperty = __webpack_require__(81);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactDOMFeatureFlags = __webpack_require__(174);
	var ReactElement = __webpack_require__(14);
	var ReactEmptyComponentRegistry = __webpack_require__(181);
	var ReactInstanceHandles = __webpack_require__(51);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactMarkupChecksum = __webpack_require__(184);
	var ReactPerf = __webpack_require__(20);
	var ReactReconciler = __webpack_require__(44);
	var ReactUpdateQueue = __webpack_require__(114);
	var ReactUpdates = __webpack_require__(21);
	
	var assign = __webpack_require__(7);
	var emptyObject = __webpack_require__(65);
	var containsNode = __webpack_require__(197);
	var instantiateReactComponent = __webpack_require__(121);
	var invariant = __webpack_require__(5);
	var setInnerHTML = __webpack_require__(83);
	var shouldUpdateReactComponent = __webpack_require__(124);
	var validateDOMNesting = __webpack_require__(126);
	var warning = __webpack_require__(8);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SvgIcon = _react2.default.createClass({
	  displayName: 'SvgIcon',
	
	  propTypes: {
	    /**
	     * Elements passed into the SVG Icon.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * This is the fill color of the svg icon.
	     * If not specified, this component will default
	     * to muiTheme.palette.textColor.
	     */
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * This is the icon color when the mouse hovers over the icon.
	     */
	    hoverColor: _react2.default.PropTypes.string,
	
	    /**
	     * Function called when mouse enters this element.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Function called when mouse leaves this element.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Allows you to redifine what the coordinates
	     * without units mean inside an svg element. For example,
	     * if the SVG element is 500 (width) by 200 (height), and you
	     * pass viewBox="0 0 50 20", this means that the coordinates inside
	     * the svg will go from the top left corner (0,0) to bottom right (50,20)
	     * and each unit will be worth 10px.
	     */
	    viewBox: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {},
	      viewBox: '0 0 24 24'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    this.props.onMouseLeave(e);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    this.setState({ hovered: true });
	    this.props.onMouseEnter(e);
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var color = _props.color;
	    var hoverColor = _props.hoverColor;
	    var onMouseEnter = _props.onMouseEnter;
	    var onMouseLeave = _props.onMouseLeave;
	    var style = _props.style;
	    var viewBox = _props.viewBox;
	
	    var other = _objectWithoutProperties(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	
	    var offColor = color ? color : style && style.fill ? style.fill : this.state.muiTheme.rawTheme.palette.textColor;
	    var onColor = hoverColor ? hoverColor : offColor;
	
	    var mergedStyles = this.mergeStyles({
	      display: 'inline-block',
	      height: 24,
	      width: 24,
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }, style, {
	      // Make sure our fill color overrides fill provided in props.style
	      fill: this.state.hovered ? onColor : offColor
	    });
	
	    var events = hoverColor ? {
	      onMouseEnter: this._handleMouseEnter,
	      onMouseLeave: this._handleMouseLeave
	    } : {};
	
	    return _react2.default.createElement(
	      'svg',
	      _extends({}, other, events, {
	        style: this.prepareStyles(mergedStyles),
	        viewBox: viewBox
	      }),
	      children
	    );
	  }
	});
	
	exports.default = SvgIcon;
	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inlineStylePrefixer = __webpack_require__(327);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixers = {};
	
	var hasWarnedAboutUserAgent = false;
	
	exports.default = {
	  getTransform: function getTransform(userAgent) {
	    if (userAgent === undefined && typeof navigator !== 'undefined') {
	      userAgent = navigator.userAgent;
	    }
	
	    if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	       false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n        for server-side rendering.') : undefined;
	
	      hasWarnedAboutUserAgent = true;
	    }
	
	    if (userAgent === false) {
	      // Disabled autoprefixer
	      return function (style) {
	        return style;
	      };
	    } else if (userAgent === 'all' || userAgent === undefined) {
	      // Prefix for all user agent
	      return _inlineStylePrefixer2.default.prefixAll;
	    } else {
	      var _ret = function () {
	        var prefixer = new _inlineStylePrefixer2.default({
	          userAgent: userAgent
	        });
	
	        return {
	          v: function v(style) {
	            return prefixer.prefix(style);
	          }
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	  },
	  getPrefixer: function getPrefixer() {
	     false ? (0, _warning2.default)(false, 'Material-UI: getPrefixer() is no longer used. Do not use it.') : undefined;
	
	    if (typeof navigator === 'undefined') {
	       false ? (0, _warning2.default)(false, 'Material-UI expects the global navigator.userAgent to be defined\n        for server-side rendering. Set this property when receiving the request headers.') : undefined;
	
	      return null;
	    }
	
	    var userAgent = navigator.userAgent;
	
	    // Get prefixing instance for this user agent
	    var prefixer = prefixers[userAgent];
	    // None found, create a new instance
	    if (!prefixer) {
	      prefixer = new _inlineStylePrefixer2.default({ userAgent: userAgent });
	      prefixers[userAgent] = prefixer;
	    }
	
	    return prefixer;
	  },
	  all: function all(style) {
	    if (!style) {
	      return {};
	    }
	
	     false ? (0, _warning2.default)(false, 'Material-UI: all() is no longer used, it will be removed. Do not use it') : undefined;
	
	    var prefixer = this.getPrefixer();
	
	    if (prefixer) {
	      return prefixer.prefix(style);
	    } else {
	      return _inlineStylePrefixer2.default.prefixAll(style);
	    }
	  },
	  set: function set(style, key, value, muiTheme) {
	    style[key] = value;
	
	    if (muiTheme) {
	      style = muiTheme.prefix(style);
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide the muiTheme to the autoPrefix.set()') : undefined;
	
	      var prefixer = this.getPrefixer();
	
	      if (prefixer) {
	        style = prefixer.prefix(style);
	      } else {
	        style = _inlineStylePrefixer2.default.prefixAll(style);
	      }
	    }
	  },
	  getPrefix: function getPrefix(key) {
	     false ? (0, _warning2.default)(false, 'Material-UI: getPrefix() is no longer used, it will be removed. Do not use it') : undefined;
	
	    var style = {};
	    style[key] = true;
	
	    var prefixer = this.getPrefixer();
	    var prefixes = undefined;
	
	    if (prefixer) {
	      prefixes = Object.keys(prefixer.prefix(style));
	    } else {
	      prefixes = Object.keys(_inlineStylePrefixer2.default.prefixAll(style));
	    }
	
	    return prefixes ? prefixes[0] : key;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  DOWN: 40,
	  ESC: 27,
	  ENTER: 13,
	  LEFT: 37,
	  RIGHT: 39,
	  SPACE: 32,
	  TAB: 9,
	  UP: 38
	};
	module.exports = exports['default'];

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(107);
	var PooledClass = __webpack_require__(36);
	var ReactPerf = __webpack_require__(20);
	var ReactReconciler = __webpack_require__(44);
	var Transaction = __webpack_require__(80);
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  componentDidMount: function componentDidMount() {
	    var listeners = this.windowListeners;
	
	    for (var eventName in listeners) {
	      var callbackName = listeners[eventName];
	      _events2.default.on(window, eventName, this[callbackName]);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var listeners = this.windowListeners;
	
	    for (var eventName in listeners) {
	      var callbackName = listeners[eventName];
	      _events2.default.off(window, eventName, this[callbackName]);
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  /**
	   * The relative brightness of any point in a colorspace, normalized to 0 for
	   * darkest black and 1 for lightest white. RGB colors only. Does not take
	   * into account alpha values.
	   *
	   * TODO:
	   * - Take into account alpha values.
	   * - Identify why there are minor discrepancies for some use cases
	   *   (i.e. #F0F & #FFF). Note that these cases rarely occur.
	   *
	   * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	   */
	
	  _luminance: function _luminance(color) {
	    color = this._decomposeColor(color);
	
	    if (color.type.indexOf('rgb') > -1) {
	      var rgb = color.values.map(function (val) {
	        val /= 255; // normalized
	        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	      });
	
	      return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
	    } else {
	       false ? (0, _warning2.default)(false, 'Calculating the relative luminance is not available\n        for HSL and HSLA.') : undefined;
	
	      return -1;
	    }
	  },
	
	  /**
	   * @params:
	   * additionalValue = An extra value that has been calculated but not included
	   *                   with the original color object, such as an alpha value.
	   */
	  _convertColorToString: function _convertColorToString(color, additonalValue) {
	    var str = color.type + '(' + parseInt(color.values[0]) + ',' + parseInt(color.values[1]) + ',' + parseInt(color.values[2]);
	
	    if (additonalValue !== undefined) {
	      str += ',' + additonalValue + ')';
	    } else if (color.values.length === 4) {
	      str += ',' + color.values[3] + ')';
	    } else {
	      str += ')';
	    }
	
	    return str;
	  },
	
	  // Converts a color from hex format to rgb format.
	  _convertHexToRGB: function _convertHexToRGB(color) {
	    if (color.length === 4) {
	      var extendedColor = '#';
	      for (var i = 1; i < color.length; i++) {
	        extendedColor += color.charAt(i) + color.charAt(i);
	      }
	      color = extendedColor;
	    }
	
	    var values = {
	      r: parseInt(color.substr(1, 2), 16),
	      g: parseInt(color.substr(3, 2), 16),
	      b: parseInt(color.substr(5, 2), 16)
	    };
	
	    return 'rgb(' + values.r + ',' + values.g + ',' + values.b + ')';
	  },
	
	  // Returns the type and values of a color of any given type.
	  _decomposeColor: function _decomposeColor(color) {
	    if (color.charAt(0) === '#') {
	      return this._decomposeColor(this._convertHexToRGB(color));
	    }
	
	    var marker = color.indexOf('(');
	    var type = color.substring(0, marker);
	    var values = color.substring(marker + 1, color.length - 1).split(',');
	
	    return { type: type, values: values };
	  },
	
	  // Set the absolute transparency of a color.
	  // Any existing alpha values are overwritten.
	  fade: function fade(color, amount) {
	    color = this._decomposeColor(color);
	    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
	    return this._convertColorToString(color, amount);
	  },
	
	  // Desaturates rgb and sets opacity to 0.15
	  lighten: function lighten(color, amount) {
	    color = this._decomposeColor(color);
	
	    if (color.type.indexOf('hsl') > -1) {
	      color.values[2] += amount;
	      return this._decomposeColor(this._convertColorToString(color));
	    } else if (color.type.indexOf('rgb') > -1) {
	      for (var i = 0; i < 3; i++) {
	        color.values[i] *= 1 + amount;
	        if (color.values[i] > 255) color.values[i] = 255;
	      }
	    }
	
	    if (color.type.indexOf('a') <= -1) color.type += 'a';
	
	    return this._convertColorToString(color, '0.15');
	  },
	  darken: function darken(color, amount) {
	    color = this._decomposeColor(color);
	
	    if (color.type.indexOf('hsl') > -1) {
	      color.values[2] += amount;
	      return this._decomposeColor(this._convertColorToString(color));
	    } else if (color.type.indexOf('rgb') > -1) {
	      for (var i = 0; i < 3; i++) {
	        color.values[i] *= 1 - amount;
	        if (color.values[i] < 0) color.values[i] = 0;
	      }
	    }
	
	    return this._convertColorToString(color);
	  },
	
	  // Calculates the contrast ratio between two colors.
	  //
	  // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	  contrastRatio: function contrastRatio(background, foreground) {
	    var lumA = this._luminance(background);
	    var lumB = this._luminance(foreground);
	
	    if (lumA >= lumB) {
	      return ((lumA + 0.05) / (lumB + 0.05)).toFixed(2);
	    } else {
	      return ((lumB + 0.05) / (lumA + 0.05)).toFixed(2);
	    }
	  },
	
	  /**
	   * Determines how readable a color combination is based on its level.
	   * Levels are defined from @LeaVerou:
	   * https://github.com/LeaVerou/contrast-ratio/blob/gh-pages/contrast-ratio.js
	   */
	  contrastRatioLevel: function contrastRatioLevel(background, foreground) {
	    var levels = {
	      'fail': {
	        range: [0, 3],
	        color: 'hsl(0, 100%, 40%)'
	      },
	      'aa-large': {
	        range: [3, 4.5],
	        color: 'hsl(40, 100%, 45%)'
	      },
	      'aa': {
	        range: [4.5, 7],
	        color: 'hsl(80, 60%, 45%)'
	      },
	      'aaa': {
	        range: [7, 22],
	        color: 'hsl(95, 60%, 41%)'
	      }
	    };
	
	    var ratio = this.contrastRatio(background, foreground);
	
	    for (var level in levels) {
	      var range = levels[level].range;
	      if (ratio >= range[0] && ratio <= range[1]) return level;
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _react2.default.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react2.default.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react2.default.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react2.default.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react2.default.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	
	  zDepth: _react2.default.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};
	module.exports = exports['default'];

/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(505)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(506)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(509)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _children = __webpack_require__(59);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _focusRipple = __webpack_require__(69);
	
	var _focusRipple2 = _interopRequireDefault(_focusRipple);
	
	var _touchRipple = __webpack_require__(99);
	
	var _touchRipple2 = _interopRequireDefault(_touchRipple);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (e) {
	      tabPressed = e.keyCode === _keyCode2.default.TAB;
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = _react2.default.createClass({
	  displayName: 'EnhancedButton',
	
	  propTypes: {
	    centerRipple: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.node,
	    containerElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]),
	    disableFocusRipple: _react2.default.PropTypes.bool,
	    disableKeyboardFocus: _react2.default.PropTypes.bool,
	    disableTouchRipple: _react2.default.PropTypes.bool,
	    disabled: _react2.default.PropTypes.bool,
	    focusRippleColor: _react2.default.PropTypes.string,
	    focusRippleOpacity: _react2.default.PropTypes.number,
	    keyboardFocused: _react2.default.PropTypes.bool,
	    linkButton: _react2.default.PropTypes.bool,
	    onBlur: _react2.default.PropTypes.func,
	    onFocus: _react2.default.PropTypes.func,
	    onKeyDown: _react2.default.PropTypes.func,
	    onKeyUp: _react2.default.PropTypes.func,
	    onKeyboardFocus: _react2.default.PropTypes.func,
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    tabIndex: _react2.default.PropTypes.number,
	    touchRippleColor: _react2.default.PropTypes.string,
	    touchRippleOpacity: _react2.default.PropTypes.number,
	    type: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      containerElement: 'button',
	      onBlur: function onBlur() {},
	      onFocus: function onFocus() {},
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onKeyDown: function onKeyDown() {},
	      onKeyUp: function onKeyUp() {},
	      onTouchTap: function onTouchTap() {},
	      tabIndex: 0,
	      type: 'button'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isKeyboardFocused: !this.props.disabled && this.props.keyboardFocused && !this.props.disableKeyboardFocus,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    injectStyle();
	    listenForTabPresses();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	      this.setState({ isKeyboardFocused: false });
	      if (nextProps.onKeyboardFocus) {
	        nextProps.onKeyboardFocus(null, false);
	      }
	    }
	  },
	  isKeyboardFocused: function isKeyboardFocused() {
	    return this.state.isKeyboardFocused;
	  },
	  removeKeyboardFocus: function removeKeyboardFocus(e) {
	    if (this.state.isKeyboardFocused) {
	      this.setState({ isKeyboardFocused: false });
	      this.props.onKeyboardFocus(e, false);
	    }
	  },
	  setKeyboardFocus: function setKeyboardFocus(e) {
	    if (!this.state.isKeyboardFocused) {
	      this.setState({ isKeyboardFocused: true });
	      this.props.onKeyboardFocus(e, true);
	    }
	  },
	  _cancelFocusTimeout: function _cancelFocusTimeout() {
	    if (this._focusTimeout) {
	      clearTimeout(this._focusTimeout);
	      this._focusTimeout = null;
	    }
	  },
	  _createButtonChildren: function _createButtonChildren() {
	    var _props = this.props;
	    var centerRipple = _props.centerRipple;
	    var children = _props.children;
	    var disabled = _props.disabled;
	    var disableFocusRipple = _props.disableFocusRipple;
	    var disableKeyboardFocus = _props.disableKeyboardFocus;
	    var disableTouchRipple = _props.disableTouchRipple;
	    var focusRippleColor = _props.focusRippleColor;
	    var focusRippleOpacity = _props.focusRippleOpacity;
	    var touchRippleColor = _props.touchRippleColor;
	    var touchRippleOpacity = _props.touchRippleOpacity;
	    var isKeyboardFocused = this.state.isKeyboardFocused;
	
	    //Focus Ripple
	
	    var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_focusRipple2.default, {
	      color: focusRippleColor,
	      muiTheme: this.state.muiTheme,
	      opacity: focusRippleOpacity,
	      show: isKeyboardFocused
	    }) : undefined;
	
	    //Touch Ripple
	    var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	      _touchRipple2.default,
	      {
	        centerRipple: centerRipple,
	        color: touchRippleColor,
	        muiTheme: this.state.muiTheme,
	        opacity: touchRippleOpacity
	      },
	      children
	    ) : undefined;
	
	    return _children2.default.create({
	      focusRipple: focusRipple,
	      touchRipple: touchRipple,
	      children: touchRipple ? undefined : children
	    });
	  },
	  _handleKeyDown: function _handleKeyDown(e) {
	    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
	      if (e.keyCode === _keyCode2.default.ENTER && this.state.isKeyboardFocused) {
	        this._handleTouchTap(e);
	      }
	    }
	    this.props.onKeyDown(e);
	  },
	  _handleKeyUp: function _handleKeyUp(e) {
	    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
	      if (e.keyCode === _keyCode2.default.SPACE && this.state.isKeyboardFocused) {
	        this._handleTouchTap(e);
	      }
	    }
	    this.props.onKeyUp(e);
	  },
	  _handleBlur: function _handleBlur(e) {
	    this._cancelFocusTimeout();
	    this.removeKeyboardFocus(e);
	    this.props.onBlur(e);
	  },
	  _handleFocus: function _handleFocus(e) {
	    var _this = this;
	
	    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
	      //setTimeout is needed because the focus event fires first
	      //Wait so that we can capture if this was a keyboard focus
	      //or touch focus
	      this._focusTimeout = setTimeout(function () {
	        if (tabPressed) {
	          _this.setKeyboardFocus(e);
	        }
	      }, 150);
	
	      this.props.onFocus(e);
	    }
	  },
	  _handleTouchTap: function _handleTouchTap(e) {
	    this._cancelFocusTimeout();
	    if (!this.props.disabled) {
	      tabPressed = false;
	      this.removeKeyboardFocus(e);
	      this.props.onTouchTap(e);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var centerRipple = _props2.centerRipple;
	    var children = _props2.children;
	    var containerElement = _props2.containerElement;
	    var disabled = _props2.disabled;
	    var disableFocusRipple = _props2.disableFocusRipple;
	    var disableKeyboardFocus = _props2.disableKeyboardFocus;
	    var disableTouchRipple = _props2.disableTouchRipple;
	    var focusRippleColor = _props2.focusRippleColor;
	    var focusRippleOpacity = _props2.focusRippleOpacity;
	    var linkButton = _props2.linkButton;
	    var touchRippleColor = _props2.touchRippleColor;
	    var touchRippleOpacity = _props2.touchRippleOpacity;
	    var onBlur = _props2.onBlur;
	    var onFocus = _props2.onFocus;
	    var onKeyUp = _props2.onKeyUp;
	    var onKeyDown = _props2.onKeyDown;
	    var onTouchTap = _props2.onTouchTap;
	    var style = _props2.style;
	    var tabIndex = _props2.tabIndex;
	    var type = _props2.type;
	
	    var other = _objectWithoutProperties(_props2, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'linkButton', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onFocus', 'onKeyUp', 'onKeyDown', 'onTouchTap', 'style', 'tabIndex', 'type']);
	
	    var mergedStyles = this.mergeStyles({
	      border: 10,
	      background: 'none',
	      boxSizing: 'border-box',
	      display: 'inline-block',
	      font: 'inherit',
	      fontFamily: this.state.muiTheme.rawTheme.fontFamily,
	      tapHighlightColor: _colors2.default.transparent,
	      appearance: linkButton ? null : 'button',
	      cursor: disabled ? 'default' : 'pointer',
	      textDecoration: 'none',
	      outline: 'none',
	      /*
	        This is needed so that ripples do not bleed
	        past border radius.
	        See: http://stackoverflow.com/questions/17298739/
	          css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
	       */
	      transform: disableTouchRipple && disableFocusRipple ? null : 'translate3d(0, 0, 0)',
	      verticalAlign: other.hasOwnProperty('href') ? 'middle' : null
	    }, style);
	
	    if (disabled && linkButton) {
	      return _react2.default.createElement(
	        'span',
	        _extends({}, other, {
	          style: mergedStyles
	        }),
	        children
	      );
	    }
	
	    var buttonProps = _extends({}, other, {
	      style: this.prepareStyles(mergedStyles),
	      disabled: disabled,
	      onBlur: this._handleBlur,
	      onFocus: this._handleFocus,
	      onTouchTap: this._handleTouchTap,
	      onKeyUp: this._handleKeyUp,
	      onKeyDown: this._handleKeyDown,
	      tabIndex: tabIndex,
	      type: type
	    });
	    var buttonChildren = this._createButtonChildren();
	
	    // Provides backward compatibity. Added to support wrapping around <a> element.
	    var targetLinkElement = buttonProps.hasOwnProperty('href') ? 'a' : 'span';
	
	    return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, buttonProps, buttonChildren) : _react2.default.createElement(linkButton ? targetLinkElement : containerElement, buttonProps, buttonChildren);
	  }
	});
	
	exports.default = EnhancedButton;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeStyles = mergeStyles;
	exports.mergeAndPrefix = mergeAndPrefix;
	exports.prepareStyles = prepareStyles;
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _reactAddonsUpdate = __webpack_require__(75);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	function mergeSingle(objA, objB) {
	  if (!objA) return objB;
	  if (!objB) return objA;
	  return (0, _reactAddonsUpdate2.default)(objA, { $merge: objB });
	}
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function ensureDirection(muiTheme, style) {
	  if (false) {
	    process.env.NODE_ENV !== "production" ? (0, _warning2.default)(!style.didFlip, 'You\'re calling ensureDirection() on the same style\n      object twice.') : undefined;
	
	    style = mergeStyles({
	      didFlip: 'true'
	    }, style);
	  }
	
	  // Left to right is the default. No need to flip anything.
	  if (!muiTheme || !muiTheme.isRtl) return style;
	
	  var flippedAttributes = {
	    // Keys and their replacements.
	    right: 'left',
	    left: 'right',
	    marginRight: 'marginLeft',
	    marginLeft: 'marginRight',
	    paddingRight: 'paddingLeft',
	    paddingLeft: 'paddingRight',
	    borderRight: 'borderLeft',
	    borderLeft: 'borderRight'
	  };
	
	  var newStyle = {};
	
	  Object.keys(style).forEach(function (attribute) {
	    var value = style[attribute];
	    var key = attribute;
	
	    if (flippedAttributes.hasOwnProperty(attribute)) {
	      key = flippedAttributes[attribute];
	    }
	
	    switch (attribute) {
	      case 'float':
	      case 'textAlign':
	        if (value === 'right') {
	          value = 'left';
	        } else if (value === 'left') {
	          value = 'right';
	        }
	        break;
	
	      case 'direction':
	        if (value === 'ltr') {
	          value = 'rtl';
	        } else if (value === 'rtl') {
	          value = 'ltr';
	        }
	        break;
	
	      case 'transform':
	        var matches = undefined;
	        if (matches = value.match(reTranslate)) {
	          value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	        }
	        if (matches = value.match(reSkew)) {
	          value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ',' + -parseFloat(matches[7]) + matches[8] : '');
	        }
	        break;
	
	      case 'transformOrigin':
	        if (value.indexOf('right') > -1) {
	          value = value.replace('right', 'left');
	        } else if (value.indexOf('left') > -1) {
	          value = value.replace('left', 'right');
	        }
	        break;
	    }
	
	    newStyle[key] = value;
	  });
	
	  return newStyle;
	}
	
	function mergeStyles(base) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  for (var i = 0; i < args.length; i++) {
	    if (args[i]) {
	      base = mergeSingle(base, args[i]);
	    }
	  }
	  return base;
	}
	
	/**
	 * `mergeAndPrefix` is used to merge styles and autoprefix them. It has has been deprecated
	 *  and should no longer be used.
	 */
	function mergeAndPrefix() {
	   false ? (0, _warning2.default)(false, 'Use of mergeAndPrefix() has been deprecated. ' + 'Please use mergeStyles() for merging styles, and then prepareStyles() for prefixing and ensuring direction.') : undefined;
	  return _autoPrefix2.default.all(mergeStyles.apply(undefined, arguments));
	}
	
	/**
	 * `prepareStyles` is used to merge multiple styles, make sure they are flipped
	 * to rtl if needed, and then autoprefix them.
	 *
	 * Never call this on the same style object twice. As a rule of thumb, only
	 * call it when passing style attribute to html elements.
	 *
	 * If this method detects you called it twice on the same style object, it
	 * will produce a warning in the console.
	 */
	function prepareStyles(muiTheme) {
	  var style = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  for (var _len2 = arguments.length, styles = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    styles[_key2 - 2] = arguments[_key2];
	  }
	
	  if (styles) {
	    //warning(false, 'Providing more than one style argument to prepareStyles has been deprecated. ' +
	    //  'Please pass a single style, such as the result from mergeStyles(...styles).');
	    style = mergeStyles.apply(undefined, [style].concat(styles));
	  }
	
	  var flipped = ensureDirection(muiTheme, style);
	  return muiTheme.prefix(flipped);
	}
	
	exports.default = {
	  mergeStyles: mergeStyles,
	  mergeAndPrefix: mergeAndPrefix,
	  prepareStyles: prepareStyles
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(84);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 33 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shallowEqual = __webpack_require__(325);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function relevantContextKeysEqual(classObject, currentContext, nextContext) {
	
	  //Get those keys from current object's context that we care
	  //about and check whether those keys have changed or not
	  if (classObject.getRelevantContextKeys) {
	    var currentContextKeys = classObject.getRelevantContextKeys(currentContext);
	    var nextContextKeys = classObject.getRelevantContextKeys(nextContext);
	
	    if (!(0, _shallowEqual2.default)(currentContextKeys, nextContextKeys)) {
	      return false;
	    }
	  }
	
	  //Check if children context keys changed
	  if (classObject.getChildrenClasses) {
	    var childrenArray = classObject.getChildrenClasses();
	    for (var i = 0; i < childrenArray.length; i++) {
	      if (!relevantContextKeysEqual(childrenArray[i], currentContext, nextContext)) {
	        return false;
	      }
	    }
	  }
	
	  //context keys are equal
	  return true;
	}
	
	exports.default = {
	
	  //Don't update if state, prop, and context are equal
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	
	    //If either the props or state have changed, component should update
	    if (!(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState)) {
	      return true;
	    }
	
	    //If current theme and next theme are both undefined, do not update
	    if (!this.context.muiTheme && !nextContext.muiTheme) {
	      return false;
	    }
	
	    //If both themes exist, compare keys only if current theme is not static
	    if (this.context.muiTheme && nextContext.muiTheme) {
	      return !this.context.muiTheme.static && !relevantContextKeysEqual(this.constructor, this.context.muiTheme, nextContext.muiTheme);
	    }
	
	    //At this point it is guaranteed that exactly one theme is undefined so simply update
	    return true;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Typography = function Typography() {
	  _classCallCheck(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors2.default.fullBlack;
	  this.textDarkBlack = _colors2.default.darkBlack;
	  this.textLightBlack = _colors2.default.lightBlack;
	  this.textMinBlack = _colors2.default.minBlack;
	  this.textFullWhite = _colors2.default.fullWhite;
	  this.textDarkWhite = _colors2.default.darkWhite;
	  this.textLightWhite = _colors2.default.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequire = __webpack_require__(512)['default'];
	
	exports.__esModule = true;
	
	var _squashClickEvent = __webpack_require__(500);
	
	exports.SquashClickEventMixin = _interopRequire(_squashClickEvent);
	
	var _expandedStateHandler = __webpack_require__(499);
	
	exports.ExpandedStateHandlerMixin = _interopRequire(_expandedStateHandler);

/***/ },
/* 38 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 39 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var mixin = __webpack_require__(546);
	var assign = __webpack_require__(545);
	
	var mixinProto = mixin({
	  // lifecycle stuff is as you'd expect
	  componentDidMount: mixin.MANY,
	  componentWillMount: mixin.MANY,
	  componentWillReceiveProps: mixin.MANY,
	  shouldComponentUpdate: mixin.ONCE,
	  componentWillUpdate: mixin.MANY,
	  componentDidUpdate: mixin.MANY,
	  componentWillUnmount: mixin.MANY,
	  getChildContext: mixin.MANY_MERGED
	});
	
	function setDefaultProps(reactMixin) {
	  var getDefaultProps = reactMixin.getDefaultProps;
	
	  if (getDefaultProps) {
	    reactMixin.defaultProps = getDefaultProps();
	
	    delete reactMixin.getDefaultProps;
	  }
	}
	
	function setInitialState(reactMixin) {
	  var getInitialState = reactMixin.getInitialState;
	  var componentWillMount = reactMixin.componentWillMount;
	
	  function applyInitialState(instance) {
	    var state = instance.state || {};
	    assign(state, getInitialState.call(instance));
	    instance.state = state;
	  }
	
	  if (getInitialState) {
	    if (!componentWillMount) {
	      reactMixin.componentWillMount = function() {
	        applyInitialState(this);
	      };
	    } else {
	      reactMixin.componentWillMount = function() {
	        applyInitialState(this);
	        componentWillMount.call(this);
	      };
	    }
	
	    delete reactMixin.getInitialState;
	  }
	}
	
	function mixinClass(reactClass, reactMixin) {
	  setDefaultProps(reactMixin);
	  setInitialState(reactMixin);
	
	  var prototypeMethods = {};
	  var staticProps = {};
	
	  Object.keys(reactMixin).forEach(function(key) {
	    if (key === 'mixins') {
	      return; // Handled below to ensure proper order regardless of property iteration order
	    }
	    if (key === 'statics') {
	      return; // gets special handling
	    } else if (typeof reactMixin[key] === 'function') {
	      prototypeMethods[key] = reactMixin[key];
	    } else {
	      staticProps[key] = reactMixin[key];
	    }
	  });
	
	  mixinProto(reactClass.prototype, prototypeMethods);
	
	  var mergePropTypes = function(left, right, key) {
	    if (!left) return right;
	    if (!right) return left;
	
	    var result = {};
	    Object.keys(left).forEach(function(leftKey) {
	      if (!right[leftKey]) {
	        result[leftKey] = left[leftKey];
	      }
	    });
	
	    Object.keys(right).forEach(function(rightKey) {
	      if (left[rightKey]) {
	        result[rightKey] = function checkBothContextTypes() {
	          return right[rightKey].apply(this, arguments) && left[rightKey].apply(this, arguments);
	        };
	      } else {
	        result[rightKey] = right[rightKey];
	      }
	    });
	
	    return result;
	  };
	
	  mixin({
	    childContextTypes: mergePropTypes,
	    contextTypes: mergePropTypes,
	    propTypes: mixin.MANY_MERGED_LOOSE,
	    defaultProps: mixin.MANY_MERGED_LOOSE
	  })(reactClass, staticProps);
	
	  // statics is a special case because it merges directly onto the class
	  if (reactMixin.statics) {
	    Object.getOwnPropertyNames(reactMixin.statics).forEach(function(key) {
	      var left = reactClass[key];
	      var right = reactMixin.statics[key];
	
	      if (left !== undefined && right !== undefined) {
	        throw new TypeError('Cannot mixin statics because statics.' + key + ' and Component.' + key + ' are defined.');
	      }
	
	      reactClass[key] = left !== undefined ? left : right;
	    });
	  }
	
	  // If more mixins are defined, they need to run. This emulate's react's behavior.
	  // See behavior in code at:
	  // https://github.com/facebook/react/blob/41aa3496aa632634f650edbe10d617799922d265/src/isomorphic/classic/class/ReactClass.js#L468
	  // Note the .reverse(). In React, a fresh constructor is created, then all mixins are mixed in recursively,
	  // then the actual spec is mixed in last.
	  //
	  // With ES6 classes, the properties are already there, so smart-mixin mixes functions (a, b) -> b()a(), which is
	  // the opposite of how React does it. If we reverse this array, we basically do the whole logic in reverse,
	  // which makes the result the same. See the test for more.
	  // See also:
	  // https://github.com/facebook/react/blob/41aa3496aa632634f650edbe10d617799922d265/src/isomorphic/classic/class/ReactClass.js#L853
	  if (reactMixin.mixins) {
	    reactMixin.mixins.reverse().forEach(mixinClass.bind(null, reactClass));
	  }
	
	  return reactClass;
	}
	
	module.exports = (function() {
	  var reactMixin = mixinProto;
	
	  reactMixin.onClass = function(reactClass, mixin) {
	    return mixinClass(reactClass, mixin);
	  };
	
	  reactMixin.decorate = function(mixin) {
	    return function(reactClass) {
	      return reactMixin.onClass(reactClass, mixin);
	    };
	  };
	
	  return reactMixin;
	})();


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(216);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(557);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(556);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(555);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(215);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(217);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] != null) {
	       false ? (0, _warning2.default)(false, '"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation) : undefined;
	    }
	
	    return propType(props, propName, componentName);
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(e) {
	      e.target.removeEventListener(e.type, recursiveFunction);
	      return callback(e);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(e) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(e.type) !== -1;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(402);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(36);
	
	var assign = __webpack_require__(7);
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(8);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var DUMMY_INCREMENT_ACTION = 'DUMMY_INCREMENT_ACTION';
	
	exports.DUMMY_INCREMENT_ACTION = DUMMY_INCREMENT_ACTION;
	// Routing
	var CHANGE_ROUTE_ACTION = 'CHANGE_ROUTE_ACTION';
	
	exports.CHANGE_ROUTE_ACTION = CHANGE_ROUTE_ACTION;
	var ADD_SPIRAL_DATA_ACTION = 'ADD_SPIRAL_DATA_ACTION';
	exports.ADD_SPIRAL_DATA_ACTION = ADD_SPIRAL_DATA_ACTION;
	var ADD_TAG_ACTION = 'ADD_TAG_ACTION';
	exports.ADD_TAG_ACTION = ADD_TAG_ACTION;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _dom = __webpack_require__(72);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  //When the component mounts, listen to click events and check if we need to
	  //Call the componentClickAway function.
	
	  componentDidMount: function componentDidMount() {
	    if (!this.manuallyBindClickAway) this._bindClickAway();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unbindClickAway();
	  },
	  _checkClickAway: function _checkClickAway(event) {
	    if (this.isMounted()) {
	      var el = _reactDom2.default.findDOMNode(this);
	
	      // Check if the target is inside the current component
	      if (event.target !== el && !_dom2.default.isDescendant(el, event.target) && document.documentElement.contains(event.target)) {
	        if (this.componentClickAway) this.componentClickAway(event);
	      }
	    }
	  },
	  _bindClickAway: function _bindClickAway() {
	    // On touch-enabled devices, both events fire, and the handler is called twice,
	    // but it's fine since all operations for which the mixin is used
	    // are idempotent.
	    _events2.default.on(document, 'mouseup', this._checkClickAway);
	    _events2.default.on(document, 'touchend', this._checkClickAway);
	  },
	  _unbindClickAway: function _unbindClickAway() {
	    _events2.default.off(document, 'mouseup', this._checkClickAway);
	    _events2.default.off(document, 'touchend', this._checkClickAway);
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function DateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Wrong usage of DateTimeFormat. The ' + locale + ' locale is not supported.') : undefined;
	
	  this.format = function (date) {
	    var output = undefined;
	
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	
	      output = dayList[date.getDay()] + ', ';
	      output += monthList[date.getMonth()] + ' ';
	      output += date.getDate();
	    } else if (options.month === 'long' && options.year === 'numeric') {
	      output = monthLongList[date.getMonth()];
	      output += ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      output = dayAbbreviation[date.getDay()];
	    } else {
	       false ? (0, _warning2.default)(false, 'Wrong usage of DateTimeFormat') : undefined;
	    }
	
	    return output;
	  };
	}
	
	exports.default = {
	  DateTimeFormat: DateTimeFormat,
	
	  addDays: function addDays(d, days) {
	    var newDate = this.clone(d);
	    newDate.setDate(d.getDate() + days);
	    return newDate;
	  },
	  addMonths: function addMonths(d, months) {
	    var newDate = this.clone(d);
	    newDate.setMonth(d.getMonth() + months);
	    return newDate;
	  },
	  addYears: function addYears(d, years) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(d.getFullYear() + years);
	    return newDate;
	  },
	  clone: function clone(d) {
	    return new Date(d.getTime());
	  },
	  cloneAsDate: function cloneAsDate(d) {
	    var clonedDate = this.clone(d);
	    clonedDate.setHours(0, 0, 0, 0);
	    return clonedDate;
	  },
	  getDaysInMonth: function getDaysInMonth(d) {
	    var resultDate = this.getFirstDayOfMonth(d);
	
	    resultDate.setMonth(resultDate.getMonth() + 1);
	    resultDate.setDate(resultDate.getDate() - 1);
	
	    return resultDate.getDate();
	  },
	  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
	    return new Date(d.getFullYear(), d.getMonth(), 1);
	  },
	  getFirstDayOfWeek: function getFirstDayOfWeek() {
	    var now = new Date();
	    return new Date(now.setDate(now.getDate() - now.getDay()));
	  },
	  getWeekArray: function getWeekArray(d, firstDayOfWeek) {
	    var dayArray = [];
	    var daysInMonth = this.getDaysInMonth(d);
	    var weekArray = [];
	    var week = [];
	
	    for (var i = 1; i <= daysInMonth; i++) {
	      dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	    }
	
	    var addWeek = function addWeek(week) {
	      var emptyDays = 7 - week.length;
	      for (var i = 0; i < emptyDays; ++i) {
	        week[weekArray.length ? 'push' : 'unshift'](null);
	      }
	      weekArray.push(week);
	    };
	
	    dayArray.forEach(function (day) {
	      if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	        addWeek(week);
	        week = [];
	      }
	      week.push(day);
	      if (dayArray.indexOf(day) === dayArray.length - 1) {
	        addWeek(week);
	      }
	    });
	
	    return weekArray;
	  },
	  localizedWeekday: function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	    var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	    var firstDayDate = this.getFirstDayOfWeek();
	
	    return weekdayFormatter.format(this.addDays(firstDayDate, day + firstDayOfWeek));
	  },
	  format: function format(date) {
	    var m = date.getMonth() + 1;
	    var d = date.getDate();
	    var y = date.getFullYear();
	    return m + '/' + d + '/' + y;
	  },
	  isEqualDate: function isEqualDate(d1, d2) {
	    return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	  },
	  isBeforeDate: function isBeforeDate(d1, d2) {
	    var date1 = this.cloneAsDate(d1);
	    var date2 = this.cloneAsDate(d2);
	
	    return date1.getTime() < date2.getTime();
	  },
	  isAfterDate: function isAfterDate(d1, d2) {
	    var date1 = this.cloneAsDate(d1);
	    var date2 = this.cloneAsDate(d2);
	
	    return date1.getTime() > date2.getTime();
	  },
	  isBetweenDates: function isBetweenDates(dateToCheck, startDate, endDate) {
	    return !this.isBeforeDate(dateToCheck, startDate) && !this.isAfterDate(dateToCheck, endDate);
	  },
	  isDateObject: function isDateObject(d) {
	    return d instanceof Date;
	  },
	  monthDiff: function monthDiff(d1, d2) {
	    var m = undefined;
	    m = (d1.getFullYear() - d2.getFullYear()) * 12;
	    m += d1.getMonth();
	    m -= d2.getMonth();
	    return m;
	  },
	  yearDiff: function yearDiff(d1, d2) {
	    return ~ ~(this.monthDiff(d1, d2) / 12);
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(189);
	
	var invariant = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(533)('wks')
	  , uid    = __webpack_require__(537)
	  , Symbol = __webpack_require__(131).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _beforeAfterWrapper = __webpack_require__(140);
	
	var _beforeAfterWrapper2 = _interopRequireDefault(_beforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style;
	  var children = _ref.children;
	
	  var other = _objectWithoutProperties(_ref, ['style', 'children']);
	
	  return _react2.default.createElement(
	    _beforeAfterWrapper2.default,
	    _extends({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.displayName = 'ClearFix';
	
	ClearFix.propTypes = {
	  children: _react2.default.PropTypes.node,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object
	};
	
	exports.default = ClearFix;
	module.exports = exports['default'];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _children = __webpack_require__(59);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _styles = __webpack_require__(30);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _flatButtonLabel = __webpack_require__(243);
	
	var _flatButtonLabel2 = _interopRequireDefault(_flatButtonLabel);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function validateLabel(props, propName, componentName) {
	  if (!props.children && !props.label) {
	    return new Error('Required prop label or children was not ' + 'specified in ' + componentName + '.');
	  }
	}
	
	var FlatButton = _react2.default.createClass({
	  displayName: 'FlatButton',
	
	  propTypes: {
	    /**
	     * Color of button when mouse is not hovering over it.
	     */
	    backgroundColor: _react2.default.PropTypes.string,
	
	    /**
	     * This is what will be displayed inside the button.
	     * If a label is specified, the text within the label prop will
	     * be displayed. Otherwise, the component will expect children
	     * which will then be displayed. (In our example,
	     * we are nesting an `<input type="file" />` and a `span`
	     * that acts as our label to be displayed.) This only
	     * applies to flat and raised buttons.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Disables the button if set to true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Color of button when mouse hovers over.
	     */
	    hoverColor: _react2.default.PropTypes.string,
	
	    /**
	     * URL to link to when button clicked if `linkButton` is set to true.
	     */
	    href: _react2.default.PropTypes.string,
	
	    /**
	     * Use this property to display an icon.
	     */
	    icon: _react2.default.PropTypes.node,
	
	    /**
	     * Label for the button.
	     */
	    label: validateLabel,
	
	    /**
	     * Place label before or after the passed children.
	     */
	    labelPosition: _react2.default.PropTypes.oneOf(['before', 'after']),
	
	    /**
	     * Override the inline-styles of the button's label element.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Enables use of `href` property to provide a URL to link to if set to true.
	     */
	    linkButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Called when element is focused by the keyboard.
	     */
	    onKeyboardFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Called when the mouse enters the element.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Called when the mouse leaves the element.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a touch event is started inside the element.
	     */
	    onTouchStart: _react2.default.PropTypes.func,
	
	    /**
	     * If true, colors button according to
	     * primaryTextColor from the Theme.
	     */
	    primary: _react2.default.PropTypes.bool,
	
	    /**
	     * Color for the ripple after button is clicked.
	     */
	    rippleColor: _react2.default.PropTypes.string,
	
	    /**
	     * If true, colors button according to secondaryTextColor from the theme.
	     * The primary prop has precendent if set to true.
	     */
	    secondary: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_contextPure2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      var buttonTheme = muiTheme.button;
	      var flatButtonTheme = muiTheme.flatButton;
	
	      return {
	        buttonColor: flatButtonTheme.color,
	        buttonFilterColor: flatButtonTheme.buttonFilterColor,
	        buttonHeight: buttonTheme.height,
	        buttonMinWidth: buttonTheme.minWidth,
	        disabledTextColor: flatButtonTheme.disabledTextColor,
	        primaryTextColor: flatButtonTheme.primaryTextColor,
	        secondaryTextColor: flatButtonTheme.secondaryTextColor,
	        textColor: flatButtonTheme.textColor,
	        textTransform: flatButtonTheme.textTransform ? flatButtonTheme.textTransform : buttonTheme.textTransform ? buttonTheme.textTransform : 'uppercase'
	      };
	    },
	    getChildrenClasses: function getChildrenClasses() {
	      return [_enhancedButton2.default, _flatButtonLabel2.default];
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      labelStyle: {},
	      labelPosition: 'after',
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {},
	      onTouchStart: function onTouchStart() {},
	      primary: false,
	      secondary: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, isKeyboardFocused) {
	    this.setState({ isKeyboardFocused: isKeyboardFocused });
	    this.props.onKeyboardFocus(e, isKeyboardFocused);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    //Cancel hover styles for touch devices
	    if (!this.state.touch) this.setState({ hovered: true });
	    this.props.onMouseEnter(e);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    this.props.onMouseLeave(e);
	  },
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({ touch: true });
	    this.props.onTouchStart(e);
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var disabled = _props.disabled;
	    var hoverColor = _props.hoverColor;
	    var backgroundColor = _props.backgroundColor;
	    var icon = _props.icon;
	    var label = _props.label;
	    var labelStyle = _props.labelStyle;
	    var labelPosition = _props.labelPosition;
	    var primary = _props.primary;
	    var rippleColor = _props.rippleColor;
	    var secondary = _props.secondary;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	
	    var _constructor$getRelev = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var buttonColor = _constructor$getRelev.buttonColor;
	    var buttonHeight = _constructor$getRelev.buttonHeight;
	    var buttonMinWidth = _constructor$getRelev.buttonMinWidth;
	    var disabledTextColor = _constructor$getRelev.disabledTextColor;
	    var buttonFilterColor = _constructor$getRelev.buttonFilterColor;
	    var primaryTextColor = _constructor$getRelev.primaryTextColor;
	    var secondaryTextColor = _constructor$getRelev.secondaryTextColor;
	    var textColor = _constructor$getRelev.textColor;
	    var textTransform = _constructor$getRelev.textTransform;
	
	    var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	    var defaultHoverColor = _colorManipulator2.default.fade(buttonFilterColor, 0.2);
	    var defaultRippleColor = buttonFilterColor;
	    var buttonHoverColor = hoverColor || defaultHoverColor;
	    var buttonRippleColor = rippleColor || defaultRippleColor;
	    var buttonBackgroundColor = backgroundColor || buttonColor;
	    var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	    var mergedRootStyles = (0, _styles.mergeStyles)({
	      color: defaultTextColor,
	      transition: _transitions2.default.easeOut(),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      letterSpacing: 0,
	      textTransform: textTransform,
	      fontWeight: _typography2.default.fontWeightMedium,
	      borderRadius: 2,
	      userSelect: 'none',
	      position: 'relative',
	      overflow: 'hidden',
	      backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	      lineHeight: buttonHeight + 'px',
	      minWidth: buttonMinWidth,
	      padding: 0,
	      margin: 0
	    }, style);
	
	    var iconCloned = undefined;
	    var labelStyleIcon = {};
	
	    if (icon) {
	      iconCloned = _react2.default.cloneElement(icon, {
	        color: mergedRootStyles.color,
	        style: {
	          verticalAlign: 'middle',
	          marginLeft: labelPosition === 'before' ? 0 : 12,
	          marginRight: labelPosition === 'before' ? 12 : 0
	        }
	      });
	
	      if (labelPosition === 'before') {
	        labelStyleIcon.paddingRight = 8;
	      } else {
	        labelStyleIcon.paddingLeft = 8;
	      }
	    }
	
	    var labelElement = label ? _react2.default.createElement(_flatButtonLabel2.default, { label: label, style: (0, _styles.mergeStyles)(labelStyleIcon, labelStyle) }) : undefined;
	
	    // Place label before or after children.
	    var childrenFragment = labelPosition === 'before' ? {
	      labelElement: labelElement,
	      iconCloned: iconCloned,
	      children: children
	    } : {
	      children: children,
	      iconCloned: iconCloned,
	      labelElement: labelElement
	    };
	    var enhancedButtonChildren = _children2.default.create(childrenFragment);
	
	    return _react2.default.createElement(
	      _enhancedButton2.default,
	      _extends({}, other, {
	        disabled: disabled,
	        focusRippleColor: buttonRippleColor,
	        focusRippleOpacity: 0.3,
	        onKeyboardFocus: this._handleKeyboardFocus,
	        onMouseLeave: this._handleMouseLeave,
	        onMouseEnter: this._handleMouseEnter,
	        onTouchStart: this._handleTouchStart,
	        style: mergedRootStyles,
	        touchRippleColor: buttonRippleColor,
	        touchRippleOpacity: 0.3
	      }),
	      enhancedButtonChildren
	    );
	  }
	});
	
	exports.default = FlatButton;
	module.exports = exports['default'];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FontIcon = _react2.default.createClass({
	  displayName: 'FontIcon',
	
	  propTypes: {
	    /**
	     * This is the font color of the font icon. If not specified,
	     * this component will default to muiTheme.palette.textColor.
	     */
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * This is the icon color when the mouse hovers over the icon.
	     */
	    hoverColor: _react2.default.PropTypes.string,
	
	    /**
	     * Function called when mouse enters this element.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Function called when mouse leaves this element.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    // hover is needed only when a hoverColor is defined
	    if (this.props.hoverColor !== undefined) this.setState({ hovered: false });
	    if (this.props.onMouseLeave) {
	      this.props.onMouseLeave(e);
	    }
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    // hover is needed only when a hoverColor is defined
	    if (this.props.hoverColor !== undefined) this.setState({ hovered: true });
	    if (this.props.onMouseEnter) {
	      this.props.onMouseEnter(e);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var hoverColor = _props.hoverColor;
	    var onMouseLeave = _props.onMouseLeave;
	    var onMouseEnter = _props.onMouseEnter;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['color', 'hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	
	    var spacing = this.state.muiTheme.rawTheme.spacing;
	    var offColor = color ? color : style && style.color ? style.color : this.state.muiTheme.rawTheme.palette.textColor;
	    var onColor = hoverColor ? hoverColor : offColor;
	
	    var mergedStyles = this.mergeStyles({
	      position: 'relative',
	      fontSize: spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }, style, {
	      color: this.state.hovered ? onColor : offColor
	    });
	
	    return _react2.default.createElement('span', _extends({}, other, {
	      onMouseLeave: this._handleMouseLeave,
	      onMouseEnter: this._handleMouseEnter,
	      style: this.prepareStyles(mergedStyles)
	    }));
	  }
	});
	
	exports.default = FontIcon;
	module.exports = exports['default'];

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _fontIcon = __webpack_require__(55);
	
	var _fontIcon2 = _interopRequireDefault(_fontIcon);
	
	var _tooltip = __webpack_require__(103);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _children = __webpack_require__(59);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconButton = _react2.default.createClass({
	  displayName: 'IconButton',
	
	  propTypes: {
	    /**
	     * Can be used to pass a font icon as the icon for the button.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Disables the icon button.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * If you are using a stylesheet for your
	     * icons, enter the class name for the icon to be used here.
	     */
	    iconClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the icon element.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Callback function for when the component loses focus.
	     */
	    onBlur: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the component gains focus.
	     */
	    onFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the component
	     * receives keyboard focus.
	     */
	    onKeyboardFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when mouse enters element.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when mouse leaves element.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The tooltip text to show.
	     */
	    tooltip: _react2.default.PropTypes.node,
	
	    /**
	     * Allows the tooltip to be viewed with different
	     * alignments: "bottom-center", "top-center",
	     * "bottom-right", "top-right", "bottom-left" and "top-left".
	     */
	    tooltipPosition: _propTypes2.default.cornersAndCenter,
	
	    /**
	     * Styles prop passed down to the tooltip.
	     */
	    tooltipStyles: _react2.default.PropTypes.object,
	
	    /**
	     * Prop for tooltip to make it larger for mobile.
	     */
	    touch: _react2.default.PropTypes.bool
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _contextPure2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      var spacing = muiTheme.rawTheme.spacing;
	      var palette = muiTheme.rawTheme.palette;
	
	      return {
	        iconSize: spacing.iconSize,
	        textColor: palette.textColor,
	        disabledColor: palette.disabledColor
	      };
	    },
	    getChildrenClasses: function getChildrenClasses() {
	      return [_enhancedButton2.default, _fontIcon2.default, _tooltip2.default];
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      iconStyle: {},
	      tooltipPosition: 'bottom-center',
	      touch: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      tooltipShown: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    var _constructor$getRelev = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var iconSize = _constructor$getRelev.iconSize;
	    var textColor = _constructor$getRelev.textColor;
	    var disabledColor = _constructor$getRelev.disabledColor;
	
	    var styles = {
	      root: {
	        position: 'relative',
	        boxSizing: 'border-box',
	        transition: _transitions2.default.easeOut(),
	        padding: iconSize / 2,
	        width: iconSize * 2,
	        height: iconSize * 2,
	        fontSize: 0
	      },
	      tooltip: {
	        boxSizing: 'border-box'
	      },
	      icon: {
	        color: textColor,
	        fill: textColor
	      },
	      overlay: {
	        position: 'relative',
	        top: 0,
	        width: '100%',
	        height: '100%',
	        background: disabledColor
	      },
	      disabled: {
	        color: disabledColor,
	        fill: disabledColor
	      }
	    };
	
	    return styles;
	  },
	  setKeyboardFocus: function setKeyboardFocus() {
	    this.refs.button.setKeyboardFocus();
	  },
	  _showTooltip: function _showTooltip() {
	    if (this.props.tooltip) {
	      this.setState({ tooltipShown: true });
	    }
	  },
	  _hideTooltip: function _hideTooltip() {
	    if (this.props.tooltip) this.setState({ tooltipShown: false });
	  },
	  _handleBlur: function _handleBlur(e) {
	    this._hideTooltip();
	    if (this.props.onBlur) this.props.onBlur(e);
	  },
	  _handleFocus: function _handleFocus(e) {
	    this._showTooltip();
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.refs.button.isKeyboardFocused()) this._hideTooltip();
	    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    this._showTooltip();
	    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (keyboardFocused && !this.props.disabled) {
	      this._showTooltip();
	      if (this.props.onFocus) this.props.onFocus(e);
	    } else if (!this.state.hovered) {
	      this._hideTooltip();
	      if (this.props.onBlur) this.props.onBlur(e);
	    }
	
	    if (this.props.onKeyboardFocus) this.props.onKeyboardFocus(e, keyboardFocused);
	  },
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var iconClassName = _props.iconClassName;
	    var tooltip = _props.tooltip;
	    var touch = _props.touch;
	    var iconStyle = _props.iconStyle;
	
	    var other = _objectWithoutProperties(_props, ['disabled', 'iconClassName', 'tooltip', 'touch', 'iconStyle']);
	
	    var fonticon = undefined;
	
	    var styles = this.getStyles();
	    var tooltipPosition = this.props.tooltipPosition.split('-');
	
	    var tooltipElement = tooltip ? _react2.default.createElement(_tooltip2.default, {
	      ref: 'tooltip',
	      label: tooltip,
	      show: this.state.tooltipShown,
	      touch: touch,
	      style: this.mergeStyles(styles.tooltip, this.props.tooltipStyles),
	      verticalPosition: tooltipPosition[0],
	      horizontalPosition: tooltipPosition[1]
	    }) : null;
	
	    if (iconClassName) {
	      var iconHoverColor = iconStyle.iconHoverColor;
	
	      var iconStyleFontIcon = _objectWithoutProperties(iconStyle, ['iconHoverColor']);
	
	      fonticon = _react2.default.createElement(
	        _fontIcon2.default,
	        {
	          className: iconClassName,
	          hoverColor: disabled ? null : iconHoverColor,
	          style: this.mergeStyles(styles.icon, disabled ? styles.disabled : {}, iconStyleFontIcon)
	        },
	        this.props.children
	      );
	    }
	
	    var childrenStyle = disabled ? this.mergeStyles(iconStyle, styles.disabled) : iconStyle;
	
	    return _react2.default.createElement(
	      _enhancedButton2.default,
	      _extends({}, other, {
	        ref: 'button',
	        centerRipple: true,
	        disabled: disabled,
	        style: this.mergeStyles(styles.root, this.props.style),
	        onBlur: this._handleBlur,
	        onFocus: this._handleFocus,
	        onMouseLeave: this._handleMouseLeave,
	        onMouseEnter: this._handleMouseEnter,
	        onKeyboardFocus: this._handleKeyboardFocus
	      }),
	      tooltipElement,
	      fonticon,
	      _children2.default.extend(this.props.children, {
	        style: childrenStyle
	      })
	    );
	  }
	});
	
	exports.default = IconButton;
	module.exports = exports['default'];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsUpdate = __webpack_require__(75);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _clickAwayable = __webpack_require__(48);
	
	var _clickAwayable2 = _interopRequireDefault(_clickAwayable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _list = __webpack_require__(96);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Menu = _react2.default.createClass({
	  displayName: 'Menu',
	
	  propTypes: {
	    /**
	     * If true, the menu will apply transitions when added it
	     * gets added to the DOM. In order for transitions to
	     * work, wrap the menu inside a ReactTransitionGroup.
	     */
	    animated: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the width will automatically be
	     * set according to the items inside the menu
	     * using the proper keyline increment.
	     */
	    autoWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * Children for the Menu. Usually MenuItems.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Indicates if the menu should render with compact desktop styles.
	     */
	    desktop: _react2.default.PropTypes.bool,
	
	    /**
	     * True if this item should be focused by the keyboard initially.
	     */
	    initiallyKeyboardFocused: _react2.default.PropTypes.bool,
	
	    /**
	     * The style object to use to override underlying list style.
	     */
	    listStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The maxHeight of the menu in pixels. If
	     * specified, the menu will scroll if larger than the maxHeight.
	     */
	    maxHeight: _react2.default.PropTypes.number,
	
	    /**
	     * If true, the value can an array and allow the menu to be a multi-select.
	     */
	    multiple: _react2.default.PropTypes.bool,
	
	    /**
	     * Fired when a menu item is touchTapped and the menu item
	     * value is not equal to the current menu value.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when an Esc key is keyed down.
	     */
	    onEscKeyDown: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when a menu item is touchTapped.
	     */
	    onItemTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when a key is pressed.
	     */
	    onKeyDown: _react2.default.PropTypes.func,
	
	    /**
	     * This is the placement of the menu relative to the IconButton.
	     */
	    openDirection: _propTypes2.default.corners,
	
	    /**
	     * Style for the selected Menu Item.
	     */
	    selectedMenuItemStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of the selected menu item. If passed in,
	     * this will make the menu a controlled component.
	     * This component also supports valueLink.
	     */
	    value: _react2.default.PropTypes.any,
	
	    /**
	     * ValueLink for this component when controlled.
	     */
	    valueLink: _react2.default.PropTypes.object,
	
	    /**
	     * Sets the width of the menu. If not specified, the menu
	     * width will be dictated by its children. The rendered
	     * width will always be a keyline increment
	     * (64px for desktop, 56px otherwise).
	     */
	    width: _propTypes2.default.stringOrNumber,
	
	    /**
	     * Sets the width of the menu. If not specified,
	     * the menu width will be dictated by its children.
	     * The rendered width will always be a keyline increment
	     * (64px for desktop, 56px otherwise).
	     */
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _clickAwayable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animated: false,
	      autoWidth: true,
	      desktop: false,
	      initiallyKeyboardFocused: false,
	      maxHeight: null,
	      multiple: false,
	      onChange: function onChange() {},
	      onEscKeyDown: function onEscKeyDown() {},
	      onItemTouchTap: function onItemTouchTap() {},
	      onKeyDown: function onKeyDown() {},
	      openDirection: 'bottom-left',
	      zDepth: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    var filteredChildren = this._getFilteredChildren(this.props.children);
	    var selectedIndex = this._getSelectedIndex(this.props, filteredChildren);
	
	    return {
	      focusIndex: selectedIndex >= 0 ? selectedIndex : 0,
	      isKeyboardFocused: this.props.initiallyKeyboardFocused,
	      keyWidth: this.props.desktop ? 64 : 56,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.autoWidth) this._setWidth();
	    if (!this.props.animated) this._animateOpen();
	    this._setScollPosition();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var filteredChildren = this._getFilteredChildren(nextProps.children);
	    var selectedIndex = this._getSelectedIndex(nextProps, filteredChildren);
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    this.setState({
	      focusIndex: selectedIndex >= 0 ? selectedIndex : 0,
	      keyWidth: nextProps.desktop ? 64 : 56,
	      muiTheme: newMuiTheme
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.autoWidth) this._setWidth();
	  },
	  componentClickAway: function componentClickAway(e) {
	    if (e.defaultPrevented) return;
	    this._setFocusIndex(-1, false);
	  },
	
	  // Do not use outside of this component, it will be removed once valueLink is deprecated
	  getValueLink: function getValueLink(props) {
	    return props.valueLink || {
	      value: props.value,
	      requestChange: props.onChange
	    };
	  },
	  setKeyboardFocused: function setKeyboardFocused(keyboardFocused) {
	    this.setState({
	      isKeyboardFocused: keyboardFocused
	    });
	  },
	  _getFilteredChildren: function _getFilteredChildren(children) {
	    var filteredChildren = [];
	    _react2.default.Children.forEach(children, function (child) {
	      if (child) {
	        filteredChildren.push(child);
	      }
	    });
	    return filteredChildren;
	  },
	  _animateOpen: function _animateOpen() {
	    var rootStyle = _reactDom2.default.findDOMNode(this).style;
	    var scrollContainerStyle = _reactDom2.default.findDOMNode(this.refs.scrollContainer).style;
	    var menuContainers = _reactDom2.default.findDOMNode(this.refs.list).childNodes;
	
	    _autoPrefix2.default.set(rootStyle, 'transform', 'scaleX(1)', this.state.muiTheme);
	    _autoPrefix2.default.set(scrollContainerStyle, 'transform', 'scaleY(1)', this.state.muiTheme);
	    scrollContainerStyle.opacity = 1;
	
	    for (var i = 0; i < menuContainers.length; ++i) {
	      menuContainers[i].style.opacity = 1;
	    }
	  },
	  _cloneMenuItem: function _cloneMenuItem(child, childIndex, styles) {
	    var _this = this;
	
	    var _props = this.props;
	    var desktop = _props.desktop;
	    var selectedMenuItemStyle = _props.selectedMenuItemStyle;
	
	    var selected = this._isChildSelected(child, this.props);
	    var selectedChildrenStyles = {};
	
	    if (selected) {
	      selectedChildrenStyles = this.mergeStyles(styles.selectedMenuItem, selectedMenuItemStyle);
	    }
	
	    var mergedChildrenStyles = this.mergeStyles(child.props.style || {}, selectedChildrenStyles);
	
	    var isFocused = childIndex === this.state.focusIndex;
	    var focusState = 'none';
	    if (isFocused) {
	      focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	    }
	
	    return _react2.default.cloneElement(child, {
	      desktop: desktop,
	      focusState: focusState,
	      onTouchTap: function onTouchTap(e) {
	        _this._handleMenuItemTouchTap(e, child);
	        if (child.props.onTouchTap) child.props.onTouchTap(e);
	      },
	      ref: isFocused ? 'focusedMenuItem' : null,
	      style: mergedChildrenStyles
	    });
	  },
	  _decrementKeyboardFocusIndex: function _decrementKeyboardFocusIndex() {
	    var index = this.state.focusIndex;
	
	    index--;
	    if (index < 0) index = 0;
	
	    this._setFocusIndex(index, true);
	  },
	  _getCascadeChildrenCount: function _getCascadeChildrenCount(filteredChildren) {
	    var _props2 = this.props;
	    var desktop = _props2.desktop;
	    var maxHeight = _props2.maxHeight;
	
	    var count = 1;
	    var currentHeight = desktop ? 16 : 8;
	    var menuItemHeight = desktop ? 32 : 48;
	
	    //MaxHeight isn't set - cascade all of the children
	    if (!maxHeight) return filteredChildren.length;
	
	    //Count all the children that will fit inside the
	    //max menu height
	    filteredChildren.forEach(function (child) {
	      if (currentHeight < maxHeight) {
	        var childIsADivider = child.type && child.type.displayName === 'Divider';
	
	        currentHeight += childIsADivider ? 16 : menuItemHeight;
	        count++;
	      }
	    });
	
	    return count;
	  },
	  _getMenuItemCount: function _getMenuItemCount(filteredChildren) {
	    var menuItemCount = 0;
	    filteredChildren.forEach(function (child) {
	      var childIsADivider = child.type && child.type.displayName === 'Divider';
	      var childIsDisabled = child.props.disabled;
	      if (!childIsADivider && !childIsDisabled) menuItemCount++;
	    });
	    return menuItemCount;
	  },
	  _getSelectedIndex: function _getSelectedIndex(props, filteredChildren) {
	    var _this2 = this;
	
	    var selectedIndex = -1;
	    var menuItemIndex = 0;
	
	    filteredChildren.forEach(function (child) {
	      var childIsADivider = child.type && child.type.displayName === 'Divider';
	
	      if (_this2._isChildSelected(child, props)) selectedIndex = menuItemIndex;
	      if (!childIsADivider) menuItemIndex++;
	    });
	
	    return selectedIndex;
	  },
	  _handleKeyDown: function _handleKeyDown(e) {
	    var filteredChildren = this._getFilteredChildren(this.props.children);
	    switch (e.keyCode) {
	      case _keyCode2.default.DOWN:
	        e.preventDefault();
	        this._incrementKeyboardFocusIndex(filteredChildren);
	        break;
	      case _keyCode2.default.ESC:
	        this.props.onEscKeyDown(e);
	        break;
	      case _keyCode2.default.TAB:
	        e.preventDefault();
	        if (e.shiftKey) {
	          this._decrementKeyboardFocusIndex();
	        } else {
	          this._incrementKeyboardFocusIndex(filteredChildren);
	        }
	        break;
	      case _keyCode2.default.UP:
	        e.preventDefault();
	        this._decrementKeyboardFocusIndex();
	        break;
	    }
	    this.props.onKeyDown(e);
	  },
	  _handleMenuItemTouchTap: function _handleMenuItemTouchTap(e, item) {
	    var children = this.props.children;
	    var multiple = this.props.multiple;
	    var valueLink = this.getValueLink(this.props);
	    var menuValue = valueLink.value;
	    var itemValue = item.props.value;
	    var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	    this._setFocusIndex(focusIndex, false);
	
	    if (multiple) {
	      var index = menuValue.indexOf(itemValue);
	      var newMenuValue = index === -1 ? (0, _reactAddonsUpdate2.default)(menuValue, { $push: [itemValue] }) : (0, _reactAddonsUpdate2.default)(menuValue, { $splice: [[index, 1]] });
	
	      valueLink.requestChange(e, newMenuValue);
	    } else if (!multiple && itemValue !== menuValue) {
	      valueLink.requestChange(e, itemValue);
	    }
	
	    this.props.onItemTouchTap(e, item);
	  },
	  _incrementKeyboardFocusIndex: function _incrementKeyboardFocusIndex(filteredChildren) {
	    var index = this.state.focusIndex;
	    var maxIndex = this._getMenuItemCount(filteredChildren) - 1;
	
	    index++;
	    if (index > maxIndex) index = maxIndex;
	
	    this._setFocusIndex(index, true);
	  },
	  _isChildSelected: function _isChildSelected(child, props) {
	    var multiple = props.multiple;
	    var menuValue = this.getValueLink(props).value;
	    var childValue = child.props.value;
	
	    return multiple && menuValue.length && menuValue.indexOf(childValue) !== -1 || !multiple && menuValue && menuValue === childValue;
	  },
	  _setFocusIndex: function _setFocusIndex(newIndex, isKeyboardFocused) {
	    this.setState({
	      focusIndex: newIndex,
	      isKeyboardFocused: isKeyboardFocused
	    });
	  },
	  _setScollPosition: function _setScollPosition() {
	    var desktop = this.props.desktop;
	    var focusedMenuItem = this.refs.focusedMenuItem;
	    var menuItemHeight = desktop ? 32 : 48;
	
	    if (focusedMenuItem) {
	      var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	      //Make the focused item be the 2nd item in the list the
	      //user sees
	      var scrollTop = selectedOffSet - menuItemHeight;
	      if (scrollTop < menuItemHeight) scrollTop = 0;
	
	      _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	    }
	  },
	  _setWidth: function _setWidth() {
	    var el = _reactDom2.default.findDOMNode(this);
	    var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	    var elWidth = el.offsetWidth;
	    var keyWidth = this.state.keyWidth;
	    var minWidth = keyWidth * 1.5;
	    var keyIncrements = elWidth / keyWidth;
	    var newWidth = undefined;
	
	    keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	    newWidth = keyIncrements * keyWidth;
	
	    if (newWidth < minWidth) newWidth = minWidth;
	
	    el.style.width = newWidth + 'px';
	    listEl.style.width = newWidth + 'px';
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var _props3 = this.props;
	    var animated = _props3.animated;
	    var autoWidth = _props3.autoWidth;
	    var children = _props3.children;
	    var desktop = _props3.desktop;
	    var initiallyKeyboardFocused = _props3.initiallyKeyboardFocused;
	    var listStyle = _props3.listStyle;
	    var maxHeight = _props3.maxHeight;
	    var multiple = _props3.multiple;
	    var openDirection = _props3.openDirection;
	    var selectedMenuItemStyle = _props3.selectedMenuItemStyle;
	    var style = _props3.style;
	    var value = _props3.value;
	    var valueLink = _props3.valueLink;
	    var width = _props3.width;
	    var zDepth = _props3.zDepth;
	
	    var other = _objectWithoutProperties(_props3, ['animated', 'autoWidth', 'children', 'desktop', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'openDirection', 'selectedMenuItemStyle', 'style', 'value', 'valueLink', 'width', 'zDepth']);
	
	    var openDown = openDirection.split('-')[0] === 'bottom';
	    var openLeft = openDirection.split('-')[1] === 'left';
	
	    var muiTheme = this.state.muiTheme;
	    var rawTheme = muiTheme.rawTheme;
	
	    var styles = {
	      root: {
	        //Nested div bacause the List scales x faster than
	        //it scales y
	        transition: animated ? _transitions2.default.easeOut('250ms', 'transform') : null,
	        zIndex: muiTheme.zIndex.menu,
	        top: openDown ? 0 : null,
	        bottom: !openDown ? 0 : null,
	        left: !openLeft ? 0 : null,
	        right: openLeft ? 0 : null,
	        transform: 'scaleX(0)',
	        transformOrigin: openLeft ? 'right' : 'left'
	      },
	
	      divider: {
	        marginTop: 7,
	        marginBottom: 8
	      },
	
	      list: {
	        display: 'table-cell',
	        paddingBottom: desktop ? 16 : 8,
	        paddingTop: desktop ? 16 : 8,
	        userSelect: 'none',
	        width: width
	      },
	
	      menuItemContainer: {
	        transition: animated ? _transitions2.default.easeOut(null, 'opacity') : null,
	        opacity: 0
	      },
	
	      paper: {
	        transition: animated ? _transitions2.default.easeOut('500ms', ['transform', 'opacity']) : null,
	        transform: 'scaleY(0)',
	        transformOrigin: openDown ? 'top' : 'bottom',
	        opacity: 0,
	        maxHeight: maxHeight,
	        overflowY: maxHeight ? 'auto' : null
	      },
	
	      selectedMenuItem: {
	        color: rawTheme.palette.accent1Color
	      }
	    };
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	    var mergedListStyles = this.mergeStyles(styles.list, listStyle);
	
	    var filteredChildren = this._getFilteredChildren(children);
	
	    //Cascade children opacity
	    var cumulativeDelay = openDown ? 175 : 325;
	    var cascadeChildrenCount = this._getCascadeChildrenCount(filteredChildren);
	    var cumulativeDelayIncrement = Math.ceil(150 / cascadeChildrenCount);
	
	    var menuItemIndex = 0;
	    var newChildren = _react2.default.Children.map(filteredChildren, function (child) {
	      var childIsADivider = child.type && child.type.displayName === 'Divider';
	      var childIsDisabled = child.props.disabled;
	      var childrenContainerStyles = {};
	
	      if (animated) {
	        var focusIndex = _this3.state.focusIndex;
	        var transitionDelay = 0;
	
	        //Only cascade the visible menu items
	        if (menuItemIndex >= focusIndex - 1 && menuItemIndex <= focusIndex + cascadeChildrenCount - 1) {
	          cumulativeDelay = openDown ? cumulativeDelay + cumulativeDelayIncrement : cumulativeDelay - cumulativeDelayIncrement;
	          transitionDelay = cumulativeDelay;
	        }
	
	        childrenContainerStyles = _this3.mergeStyles(styles.menuItemContainer, {
	          transitionDelay: transitionDelay + 'ms'
	        });
	      }
	
	      var clonedChild = childIsADivider ? _react2.default.cloneElement(child, { style: styles.divider }) : childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this3._cloneMenuItem(child, menuItemIndex, styles);
	
	      if (!childIsADivider && !childIsDisabled) menuItemIndex++;
	
	      return animated ? _react2.default.createElement(
	        'div',
	        { style: _this3.prepareStyles(childrenContainerStyles) },
	        clonedChild
	      ) : clonedChild;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        onKeyDown: this._handleKeyDown,
	        style: this.prepareStyles(mergedRootStyles)
	      },
	      _react2.default.createElement(
	        _paper2.default,
	        {
	          ref: 'scrollContainer',
	          style: styles.paper,
	          zDepth: zDepth
	        },
	        _react2.default.createElement(
	          _list2.default,
	          _extends({}, other, {
	            ref: 'list',
	            style: mergedListStyles
	          }),
	          newChildren
	        )
	      )
	    );
	  }
	});
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _renderToLayer = __webpack_require__(147);
	
	var _renderToLayer2 = _interopRequireDefault(_renderToLayer);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _lodash = __webpack_require__(357);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _popoverDefaultAnimation = __webpack_require__(279);
	
	var _popoverDefaultAnimation2 = _interopRequireDefault(_popoverDefaultAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Popover = _react2.default.createClass({
	  displayName: 'Popover',
	
	  propTypes: {
	    /**
	     * This is the DOM element that will be used to set the position of the
	     * component.
	     */
	    anchorEl: _react2.default.PropTypes.object,
	
	    /**
	     * This is the point on the anchor where the popover
	     * targetOrigin will stick to.
	     * Options:
	     * vertical: [top, middle, bottom]
	     * horizontal: [left, center, right]
	     */
	    anchorOrigin: _propTypes2.default.origin,
	
	    /**
	     * If true, the popover will apply transitions when
	     * added it gets added to the DOM.
	     */
	    animated: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the default animation component used.
	     */
	    animation: _react2.default.PropTypes.func,
	
	    /**
	     * If true, the popover will hide when the anchor scrolls off the screen
	     */
	    autoCloseWhenOffScreen: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the popover (potentially) ignores targetOrigin
	     * and anchorOrigin to make itself fit on screen,
	     * which is useful for mobile devices.
	     */
	    canAutoPosition: _react2.default.PropTypes.bool,
	
	    /**
	     * Use this property to render your component inside the `Popover`.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * This is a callback that fires when the popover
	     * thinks it should close. (e.g. clickAway or offScreen)
	     *
	     * @param {string} reason Determines what triggered this request.
	     */
	    onRequestClose: _react2.default.PropTypes.func,
	
	    /**
	     * Controls the visibility of the popover.
	     */
	    open: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * This is the point on the popover which will stick to
	     * the anchors origin.
	     * Options:
	     * vertical: [top, middle, bottom]
	     * horizontal: [left, center, right]
	     */
	    targetOrigin: _propTypes2.default.origin,
	
	    /**
	     * If true, the popover will render on top of an invisible
	     * layer, which will prevent clicks to the underlying
	     * elements, and trigger an onRequestClose(clickAway) event.
	     */
	    useLayerForClickAway: _react2.default.PropTypes.bool,
	
	    /**
	     * This number represents the zDepth of the paper shadow.
	     */
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      anchorOrigin: {
	        vertical: 'bottom',
	        horizontal: 'left'
	      },
	      animated: true,
	      autoCloseWhenOffScreen: true,
	      canAutoPosition: true,
	      onRequestClose: function onRequestClose() {},
	      open: false,
	      style: {
	        overflowY: 'auto'
	      },
	      targetOrigin: {
	        vertical: 'top',
	        horizontal: 'left'
	      },
	      useLayerForClickAway: true,
	      zDepth: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.setPlacementThrottled = (0, _lodash2.default)(this.setPlacement, 100);
	    this.setPlacementThrottledScrolled = (0, _lodash2.default)(this.setPlacement.bind(this, true), 100);
	
	    return {
	      open: this.props.open,
	      closing: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var _this = this;
	
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    if (nextProps.open !== this.state.open) {
	      if (nextProps.open) {
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false,
	          muiTheme: newMuiTheme
	        });
	      } else {
	        if (nextProps.animated) {
	          this.setState({ closing: true });
	          this._timeout = setTimeout(function () {
	            if (_this.isMounted()) {
	              _this.setState({
	                open: false,
	                muiTheme: newMuiTheme
	              });
	            }
	          }, 500);
	        } else {
	          this.setState({
	            open: false,
	            muiTheme: newMuiTheme
	          });
	        }
	      }
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.setPlacement();
	  },
	
	  windowListeners: {
	    resize: 'setPlacementThrottled',
	    scroll: 'setPlacementThrottledScrolled'
	  },
	
	  renderLayer: function renderLayer() {
	    var _props = this.props;
	    var animated = _props.animated;
	    var animation = _props.animation;
	    var children = _props.children;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['animated', 'animation', 'children', 'style']);
	
	    var Animation = animation || _popoverDefaultAnimation2.default;
	
	    if (!Animation) {
	      Animation = _paper2.default;
	      style = {
	        position: 'fixed'
	      };
	      if (!this.state.open) {
	        return null;
	      }
	    }
	
	    return _react2.default.createElement(
	      Animation,
	      _extends({}, other, { style: style, open: this.state.open && !this.state.closing }),
	      children
	    );
	  },
	  requestClose: function requestClose(reason) {
	    if (this.props.onRequestClose) {
	      this.props.onRequestClose(reason);
	    }
	  },
	  componentClickAway: function componentClickAway() {
	    this.requestClose('clickAway');
	  },
	  _resizeAutoPosition: function _resizeAutoPosition() {
	    this.setPlacement();
	  },
	  getAnchorPosition: function getAnchorPosition(el) {
	    if (!el) {
	      el = _reactDom2.default.findDOMNode(this);
	    }
	
	    var rect = el.getBoundingClientRect();
	    var a = {
	      top: rect.top,
	      left: rect.left,
	      width: el.offsetWidth,
	      height: el.offsetHeight
	    };
	
	    a.right = rect.right || a.left + a.width;
	    a.bottom = rect.bottom || a.top + a.height;
	    a.middle = a.left + (a.right - a.left) / 2;
	    a.center = a.top + (a.bottom - a.top) / 2;
	
	    return a;
	  },
	  getTargetPosition: function getTargetPosition(targetEl) {
	    return {
	      top: 0,
	      center: targetEl.offsetHeight / 2,
	      bottom: targetEl.offsetHeight,
	      left: 0,
	      middle: targetEl.offsetWidth / 2,
	      right: targetEl.offsetWidth
	    };
	  },
	  setPlacement: function setPlacement(scrolling) {
	    if (!this.state.open) {
	      return;
	    }
	
	    var anchorEl = this.props.anchorEl || this.anchorEl;
	
	    if (!this.refs.layer.getLayer()) {
	      return;
	    }
	
	    var targetEl = this.refs.layer.getLayer().children[0];
	    if (!targetEl) {
	      return;
	    }
	
	    var _props2 = this.props;
	    var targetOrigin = _props2.targetOrigin;
	    var anchorOrigin = _props2.anchorOrigin;
	
	    var anchor = this.getAnchorPosition(anchorEl);
	    var target = this.getTargetPosition(targetEl);
	
	    var targetPosition = {
	      top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	      left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	    };
	
	    if (scrolling && this.props.autoCloseWhenOffScreen) {
	      this.autoCloseWhenOffScreen(anchor);
	    }
	
	    if (this.props.canAutoPosition) {
	      target = this.getTargetPosition(targetEl); // update as height may have changed
	      targetPosition = this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	    }
	
	    targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	    targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	    targetEl.style.maxHeight = window.innerHeight + 'px';
	  },
	  autoCloseWhenOffScreen: function autoCloseWhenOffScreen(anchorPosition) {
	    if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWith) {
	      this.requestClose('offScreen');
	    }
	  },
	  getOverlapMode: function getOverlapMode(anchor, target, median) {
	    if ([anchor, target].indexOf(median) >= 0) return 'auto';
	    if (anchor === target) return 'inclusive';
	    return 'exclusive';
	  },
	  getPositions: function getPositions(anchor, target) {
	    var a = _extends({}, anchor);
	    var t = _extends({}, target);
	
	    var positions = {
	      x: ['left', 'right'].filter(function (p) {
	        return p !== t.horizontal;
	      }),
	      y: ['top', 'bottom'].filter(function (p) {
	        return p !== t.vertical;
	      })
	    };
	
	    var overlap = {
	      x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	      y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	    };
	
	    positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	    positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	    if (overlap.y !== 'auto') {
	      a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	      if (overlap.y === 'inclusive') {
	        t.vertical = t.vertical;
	      }
	    }
	
	    if (overlap.x !== 'auto') {
	      a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	      if (overlap.y === 'inclusive') {
	        t.horizontal = t.horizontal;
	      }
	    }
	
	    return {
	      positions: positions,
	      anchorPos: a
	    };
	  },
	  applyAutoPositionIfNeeded: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	    var _getPositions = this.getPositions(anchorOrigin, targetOrigin);
	
	    var positions = _getPositions.positions;
	    var anchorPos = _getPositions.anchorPos;
	
	    if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	      var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	      if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);else {
	        newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	        if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);
	      }
	    }
	    if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	      var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	      if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);else {
	        newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	        if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);
	      }
	    }
	    return targetPosition;
	  },
	  render: function render() {
	    return _react2.default.createElement(_renderToLayer2.default, {
	      ref: 'layer',
	      open: this.state.open,
	      componentClickAway: this.componentClickAway,
	      useLayerForClickAway: this.props.useLayerForClickAway,
	      render: this.renderLayer
	    });
	  }
	});
	
	exports.default = Popover;
	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(360);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  create: function create(fragments) {
	    var newFragments = {};
	    var validChildrenCount = 0;
	    var firstKey = undefined;
	
	    //Only create non-empty key fragments
	    for (var key in fragments) {
	      var currentChild = fragments[key];
	
	      if (currentChild) {
	        if (validChildrenCount === 0) firstKey = key;
	        newFragments[key] = currentChild;
	        validChildrenCount++;
	      }
	    }
	
	    if (validChildrenCount === 0) return undefined;
	    if (validChildrenCount === 1) return newFragments[firstKey];
	    return (0, _reactAddonsCreateFragment2.default)(newFragments);
	  },
	  extend: function extend(children, extendedProps, extendedChildren) {
	
	    return _react2.default.isValidElement(children) ? _react2.default.Children.map(children, function (child) {
	
	      var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	      var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	      return _react2.default.cloneElement(child, newProps, newChildren);
	    }) : children;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(362);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(363);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(169);
	var EventPluginUtils = __webpack_require__(379);
	var ReactErrorUtils = __webpack_require__(182);
	
	var accumulateInto = __webpack_require__(191);
	var forEachAccumulated = __webpack_require__(193);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPluginHub = __webpack_require__(61);
	
	var warning = __webpack_require__(8);
	
	var accumulateInto = __webpack_require__(191);
	var forEachAccumulated = __webpack_require__(193);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(45);
	
	var getEventTarget = __webpack_require__(119);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports["default"] = function (hex) {
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? {
	    r: parseInt(result[1], 16),
	    g: parseInt(result[2], 16),
	    b: parseInt(result[3], 16)
	  } : null;
	};
	
	module.exports = exports["default"];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(131)
	  , core      = __webpack_require__(38)
	  , ctx       = __webpack_require__(205)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(41);
	
	var _actionsDummyActions = __webpack_require__(87);
	
	var DummyActions = _interopRequireWildcard(_actionsDummyActions);
	
	var _componentsDummyComponentDummyComponent = __webpack_require__(89);
	
	var _componentsDummyComponentDummyComponent2 = _interopRequireDefault(_componentsDummyComponentDummyComponent);
	
	var AppContainer = (function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    _get(Object.getPrototypeOf(AppContainer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var dummy = _props.dummy;
	      var dummyActions = _props.dummyActions;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsDummyComponentDummyComponent2['default'], { dummy: dummy, dummyActions: dummyActions })
	      );
	    }
	  }]);
	
	  return AppContainer;
	})(_react.Component);
	
	function mapState(state) {
	  return {
	    dummy: state.dummy.toJS()
	  };
	}
	
	function mapDispatch(dispatch) {
	  return {
	    dummyActions: (0, _redux.bindActionCreators)(DummyActions, dispatch)
	  };
	}
	
	AppContainer.propTypes = {
	  dummyActions: _react.PropTypes.object,
	  dummy: _react.PropTypes.object
	};
	
	exports['default'] = (0, _reactRedux.connect)(mapState, mapDispatch)(AppContainer);
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _scaleIn = __webpack_require__(322);
	
	var _scaleIn2 = _interopRequireDefault(_scaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = _react2.default.createClass({
	  displayName: 'FocusRipple',
	
	  propTypes: {
	    color: _react2.default.PropTypes.string,
	    innerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The material-ui theme applied to this component.
	     */
	    muiTheme: _react2.default.PropTypes.object.isRequired,
	
	    opacity: _react2.default.PropTypes.number,
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: _colors2.default.darkBlack
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this._setRippleSize();
	      this._pulsate();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.show) {
	      this._setRippleSize();
	      this._pulsate();
	    } else {
	      if (this._timeout) clearTimeout(this._timeout);
	    }
	  },
	  _getRippleElement: function _getRippleElement(props) {
	    var color = props.color;
	    var innerStyle = props.innerStyle;
	    var opacity = props.opacity;
	
	    var innerStyles = this.mergeStyles({
	      position: 'absolute',
	      height: '100%',
	      width: '100%',
	      borderRadius: '50%',
	      opacity: opacity ? opacity : 0.16,
	      backgroundColor: color,
	      transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	    }, innerStyle);
	
	    return _react2.default.createElement('div', { ref: 'innerCircle', style: this.prepareStyles(innerStyles) });
	  },
	  _pulsate: function _pulsate() {
	    if (!this.isMounted()) return;
	
	    var innerCircle = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	    if (!innerCircle) return;
	
	    var startScale = 'scale(1)';
	    var endScale = 'scale(0.85)';
	    var currentScale = innerCircle.style.transform;
	    var nextScale = undefined;
	
	    currentScale = currentScale || startScale;
	    nextScale = currentScale === startScale ? endScale : startScale;
	
	    _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale, this.props.muiTheme);
	    this._timeout = setTimeout(this._pulsate, pulsateDuration);
	  },
	  _setRippleSize: function _setRippleSize() {
	    var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	    var height = el.offsetHeight;
	    var width = el.offsetWidth;
	    var size = Math.max(height, width);
	
	    var oldTop = 0;
	    // For browsers that don't support endsWith()
	    if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	      oldTop = parseInt(el.style.top);
	    }
	    el.style.height = size + 'px';
	    el.style.top = height / 2 - size / 2 + oldTop + 'px';
	  },
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var style = _props.style;
	
	    var mergedRootStyles = this.mergeStyles({
	      height: '100%',
	      width: '100%',
	      position: 'absolute',
	      top: 0,
	      left: 0
	    }, style);
	
	    var ripple = show ? this._getRippleElement(this.props) : null;
	
	    return _react2.default.createElement(
	      _scaleIn2.default,
	      {
	        maxScale: 0.85,
	        style: mergedRootStyles
	      },
	      ripple
	    );
	  }
	});
	
	exports.default = FocusRipple;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZIndex = exports.getMuiTheme = exports.ThemeDecorator = exports.DarkRawTheme = exports.LightRawTheme = exports.lightBaseTheme = exports.Typography = exports.Transitions = exports.ThemeManager = exports.Spacing = exports.Colors = exports.AutoPrefix = undefined;
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _spacing = __webpack_require__(101);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _themeManager = __webpack_require__(290);
	
	var _themeManager2 = _interopRequireDefault(_themeManager);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _lightRawTheme = __webpack_require__(288);
	
	var _lightRawTheme2 = _interopRequireDefault(_lightRawTheme);
	
	var _lightBaseTheme = __webpack_require__(100);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _darkRawTheme = __webpack_require__(287);
	
	var _darkRawTheme2 = _interopRequireDefault(_darkRawTheme);
	
	var _darkBaseTheme = __webpack_require__(149);
	
	var _darkBaseTheme2 = _interopRequireDefault(_darkBaseTheme);
	
	var _themeDecorator = __webpack_require__(289);
	
	var _themeDecorator2 = _interopRequireDefault(_themeDecorator);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _zIndex = __webpack_require__(150);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AutoPrefix = _autoPrefix2.default;
	exports.Colors = _colors2.default;
	exports.Spacing = _spacing2.default;
	exports.ThemeManager = _themeManager2.default;
	exports.Transitions = _transitions2.default;
	exports.Typography = _typography2.default;
	exports.lightBaseTheme = _lightBaseTheme2.default;
	exports.LightRawTheme = _lightRawTheme2.default;
	exports.DarkRawTheme = _darkRawTheme2.default;
	exports.ThemeDecorator = _themeDecorator2.default;
	exports.getMuiTheme = _getMuiTheme2.default;
	exports.ZIndex = _zIndex2.default;
	exports.default = {
	  AutoPrefix: _autoPrefix2.default,
	  Colors: _colors2.default,
	  Spacing: _spacing2.default,
	  ThemeManager: _themeManager2.default,
	  Transitions: _transitions2.default,
	  Typography: _typography2.default,
	  lightBaseTheme: _lightBaseTheme2.default,
	  LightRawTheme: _lightRawTheme2.default,
	  darkBaseTheme: _darkBaseTheme2.default,
	  DarkRawTheme: _darkRawTheme2.default,
	  ThemeDecorator: _themeDecorator2.default,
	  getMuiTheme: _getMuiTheme2.default,
	  ZIndex: _zIndex2.default
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextField = __webpack_require__(138);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  },
	
	  getStyleAttributeAsNumber: function getStyleAttributeAsNumber(el, attr) {
	    var attrStyle = el.style[attr];
	    var attrNum = 0;
	    if (attrStyle && attrStyle.length) {
	      attrNum = parseInt(attrStyle);
	    }
	
	    return attrNum;
	  },
	
	  addClass: function addClass(el, className) {
	    if (el.classList) el.classList.add(className);else el.className += ' ' + className;
	  },
	  removeClass: function removeClass(el, className) {
	    if (el.classList) {
	      el.classList.remove(className);
	    } else {
	      el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	    }
	  },
	  hasClass: function hasClass(el, className) {
	    if (el.classList) return el.classList.contains(className);else return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	  },
	  toggleClass: function toggleClass(el, className) {
	    if (this.hasClass(el, className)) this.removeClass(el, className);else this.addClass(el, className);
	  },
	  forceRedraw: function forceRedraw(el) {
	    var originalDisplay = el.style.display;
	
	    el.style.display = 'none';
	    el.style.display = originalDisplay;
	  },
	  withoutTransition: function withoutTransition(el, callback) {
	    var originalTransition = el.style.transition;
	
	    //turn off transition
	    el.style.transition = null;
	
	    callback();
	
	    //force a redraw
	    this.forceRedraw(el);
	
	    //put the transition back
	    el.style.transition = originalTransition;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.6 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null &&
	    !(typeof value == 'function' && isFunction(value)) && isLength(getLength(value));
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array constructors, and
	  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(407);

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(429);

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPluginHub = __webpack_require__(61);
	var EventPluginRegistry = __webpack_require__(169);
	var ReactEventEmitterMixin = __webpack_require__(394);
	var ReactPerf = __webpack_require__(20);
	var ViewportMetrics = __webpack_require__(190);
	
	var assign = __webpack_require__(7);
	var isEventSupported = __webpack_require__(122);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(84);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	var ViewportMetrics = __webpack_require__(190);
	
	var getEventModifierState = __webpack_require__(118);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objType = __webpack_require__(501);
	
	var _objType2 = _interopRequireDefault(_objType);
	
	var _JSONObjectNode = __webpack_require__(497);
	
	var _JSONObjectNode2 = _interopRequireDefault(_JSONObjectNode);
	
	var _JSONArrayNode = __webpack_require__(491);
	
	var _JSONArrayNode2 = _interopRequireDefault(_JSONArrayNode);
	
	var _JSONIterableNode = __webpack_require__(494);
	
	var _JSONIterableNode2 = _interopRequireDefault(_JSONIterableNode);
	
	var _JSONStringNode = __webpack_require__(498);
	
	var _JSONStringNode2 = _interopRequireDefault(_JSONStringNode);
	
	var _JSONNumberNode = __webpack_require__(496);
	
	var _JSONNumberNode2 = _interopRequireDefault(_JSONNumberNode);
	
	var _JSONBooleanNode = __webpack_require__(492);
	
	var _JSONBooleanNode2 = _interopRequireDefault(_JSONBooleanNode);
	
	var _JSONNullNode = __webpack_require__(495);
	
	var _JSONNullNode2 = _interopRequireDefault(_JSONNullNode);
	
	var _JSONDateNode = __webpack_require__(493);
	
	var _JSONDateNode2 = _interopRequireDefault(_JSONDateNode);
	
	exports['default'] = function (key, value, prevValue, theme) {
	  var initialExpanded = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
	
	  var nodeType = _objType2['default'](value);
	  if (nodeType === 'Object') {
	    return _react2['default'].createElement(_JSONObjectNode2['default'], { data: value, previousData: prevValue, theme: theme, initialExpanded: initialExpanded, keyName: key, key: key });
	  } else if (nodeType === 'Array') {
	    return _react2['default'].createElement(_JSONArrayNode2['default'], { data: value, previousData: prevValue, theme: theme, initialExpanded: initialExpanded, keyName: key, key: key });
	  } else if (nodeType === 'Iterable') {
	    return _react2['default'].createElement(_JSONIterableNode2['default'], { data: value, previousData: prevValue, theme: theme, initialExpanded: initialExpanded, keyName: key, key: key });
	  } else if (nodeType === 'String') {
	    return _react2['default'].createElement(_JSONStringNode2['default'], { keyName: key, previousValue: prevValue, theme: theme, value: value, key: key });
	  } else if (nodeType === 'Number') {
	    return _react2['default'].createElement(_JSONNumberNode2['default'], { keyName: key, previousValue: prevValue, theme: theme, value: value, key: key });
	  } else if (nodeType === 'Boolean') {
	    return _react2['default'].createElement(_JSONBooleanNode2['default'], { keyName: key, previousValue: prevValue, theme: theme, value: value, key: key });
	  } else if (nodeType === 'Date') {
	    return _react2['default'].createElement(_JSONDateNode2['default'], { keyName: key, previousValue: prevValue, theme: theme, value: value, key: key });
	  } else if (nodeType === 'Null') {
	    return _react2['default'].createElement(_JSONNullNode2['default'], { keyName: key, previousValue: prevValue, theme: theme, value: value, key: key });
	  }
	  return false;
	};
	
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.increment = increment;
	
	var _constantsActionConstants = __webpack_require__(46);
	
	function increment() {
	  return {
	    type: _constantsActionConstants.DUMMY_INCREMENT_ACTION
	  };
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.add_ping_data = add_ping_data;
	exports.add_tag = add_tag;
	
	var _constantsActionConstants = __webpack_require__(46);
	
	function add_ping_data(tags) {
	  console.log('adding ping data');
	  return {
	    type: _constantsActionConstants.ADD_SPIRAL_DATA_ACTION,
	    ping: {
	      tags: tags,
	      time: new Date().getTime()
	    }
	  };
	}
	
	function add_tag(label) {
	  console.log('adding tag action');
	  return {
	    type: _constantsActionConstants.ADD_TAG_ACTION,
	    label: label
	  };
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DummyComponent = (function (_Component) {
	  _inherits(DummyComponent, _Component);
	
	  function DummyComponent() {
	    _classCallCheck(this, DummyComponent);
	
	    _get(Object.getPrototypeOf(DummyComponent.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(DummyComponent, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "div",
	        null,
	        _react2["default"].createElement(
	          "div",
	          { className: "counter", onClick: this.props.dummyActions.increment.bind(this) },
	          this.props.dummy.counter
	        )
	      );
	    }
	  }]);
	
	  return DummyComponent;
	})(_react.Component);
	
	DummyComponent.propTypes = {
	  dummyActions: _react.PropTypes.object,
	  dummy: _react.PropTypes.object
	};
	
	exports["default"] = DummyComponent;
	module.exports = exports["default"];

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(41);
	
	var _actionsDummyActions = __webpack_require__(87);
	
	var DummyActions = _interopRequireWildcard(_actionsDummyActions);
	
	var _actionsRouteActions = __webpack_require__(134);
	
	var RouteActions = _interopRequireWildcard(_actionsRouteActions);
	
	var _actionsHomeActions = __webpack_require__(219);
	
	var _actionsHomeActions2 = _interopRequireDefault(_actionsHomeActions);
	
	var _AppContainerJs = __webpack_require__(68);
	
	var _AppContainerJs2 = _interopRequireDefault(_AppContainerJs);
	
	var _componentsDummyComponentDummyComponent = __webpack_require__(89);
	
	var _componentsDummyComponentDummyComponent2 = _interopRequireDefault(_componentsDummyComponentDummyComponent);
	
	var _componentsHomeSpiral = __webpack_require__(135);
	
	var _componentsHomeSpiral2 = _interopRequireDefault(_componentsHomeSpiral);
	
	var _actionsSpiralActions = __webpack_require__(88);
	
	var SpiralActions = _interopRequireWildcard(_actionsSpiralActions);
	
	var _PingContainer = __webpack_require__(220);
	
	var _PingContainer2 = _interopRequireDefault(_PingContainer);
	
	var _materialUi = __webpack_require__(95);
	
	var _materialUi2 = _interopRequireDefault(_materialUi);
	
	var _componentsTag = __webpack_require__(136);
	
	var _componentsTag2 = _interopRequireDefault(_componentsTag);
	
	var RaisedButton = _materialUi2['default'].RaisedButton;
	
	var HomeContainer = (function (_Component) {
	  _inherits(HomeContainer, _Component);
	
	  function HomeContainer() {
	    _classCallCheck(this, HomeContainer);
	
	    _get(Object.getPrototypeOf(HomeContainer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HomeContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var spiral = _props.spiral;
	      var spiralActions = _props.spiralActions;
	      var routeActions = _props.routeActions;
	      var store = _props.store;
	
	      var stats = aggregateTagData(spiral.pings, spiral.tags);
	      return _react2['default'].createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        _react2['default'].createElement(_componentsHomeSpiral2['default'], { data: spiral.pings }),
	        _react2['default'].createElement(RaisedButton, { label: "Take A Data Sample", primary: true, onClick: function () {
	            routeActions.setRoute(_PingContainer2['default']);
	          } }),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	          'div',
	          null,
	          stats.map(function (pair) {
	            return _react2['default'].createElement(_componentsTag2['default'], { tag: { label: pair[0].label + ' ' + Math.round(pair[1] * 100) + '%', color: pair[0].color }, selected: true });
	          })
	        )
	      );
	    }
	  }]);
	
	  return HomeContainer;
	})(_react.Component);
	
	function aggregateTagData(pings, tags) {
	  var newTags = [];
	  for (var i = 0; i < tags.length; i++) {
	    newTags.push([tags[i], 0]);
	  }
	  var total = 0;
	  for (var i = 0; i < pings.length; i++) {
	    for (var k = 0; k < pings[i].tags.length; k++) {
	      for (var j = 0; j < newTags.length; j++) {
	        if (newTags[j][0].label === pings[i].tags[k].label) {
	          newTags[j][1] += 1;
	        }
	        total += 1;
	      }
	    }
	  }
	  console.log(total);
	  if (total > 0) {
	    for (var i = 0; i < tags.length; i++) {
	      newTags[i][1] /= total;
	    }
	  }
	  return newTags;
	}
	
	function mapState(state) {
	  console.log(state);
	  return {
	    home: state.home.toJS(),
	    route: state.route.toJS(),
	    spiral: state.spiral.toJS()
	  };
	}
	
	function mapDispatch(dispatch) {
	  return {
	    homeActions: (0, _redux.bindActionCreators)(_actionsHomeActions2['default'], dispatch),
	    routeActions: (0, _redux.bindActionCreators)(RouteActions, dispatch),
	    spiralActions: (0, _redux.bindActionCreators)(SpiralActions, dispatch)
	  };
	}
	
	HomeContainer.propTypes = {
	  homeActions: _react.PropTypes.object,
	  home: _react.PropTypes.object,
	  store: _react.PropTypes.object,
	  routeActions: _react.PropTypes.object,
	  route: _react.PropTypes.object,
	  spiralActions: _react.PropTypes.object,
	  spiral: _react.PropTypes.object
	};
	
	exports['default'] = (0, _reactRedux.connect)(mapState, mapDispatch)(HomeContainer);
	module.exports = exports['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enhancedSwitch = __webpack_require__(94);
	
	var _enhancedSwitch2 = _interopRequireDefault(_enhancedSwitch);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(299);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(300);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Checkbox = _react2.default.createClass({
	  displayName: 'Checkbox',
	
	  propTypes: {
	    /**
	     * Checkbox is checked if true.
	     */
	    checked: _react2.default.PropTypes.bool,
	
	    /**
	     * The SvgIcon to use for the checked state.
	     * This is useful to create icon toggles.
	     */
	    checkedIcon: _react2.default.PropTypes.element,
	
	    /**
	     * The default state of our checkbox component.
	     */
	    defaultChecked: _react2.default.PropTypes.bool,
	
	    /**
	     * Disabled if true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Overrides the inline-styles of the icon element.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Where the label will be placed next to the checkbox.
	     */
	    labelPosition: _react2.default.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * Overrides the inline-styles of the Checkbox element label.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Callback function that is fired when the checkbox is checked.
	     */
	    onCheck: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The SvgIcon to use for the unchecked state.
	     * This is useful to create icon toggles.
	     */
	    unCheckedIcon: _react2.default.PropTypes.element,
	
	    /**
	     * ValueLink for when using controlled checkbox.
	     */
	    valueLink: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultChecked: false,
	      labelPosition: 'right',
	      disabled: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      switched: this.props.checked || this.props.defaultChecked || this.props.valueLink && this.props.valueLink.value || false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      muiTheme: newMuiTheme,
	      switched: this.props.checked !== nextProps.checked ? nextProps.checked : this.state.switched
	    });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.checkbox;
	  },
	  getStyles: function getStyles() {
	    var checkboxSize = 24;
	    var styles = {
	      icon: {
	        height: checkboxSize,
	        width: checkboxSize
	      },
	      check: {
	        position: 'absolute',
	        opacity: 0,
	        transform: 'scale(0)',
	        transitionOrigin: '50% 50%',
	        transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	        fill: this.getTheme().checkedColor
	      },
	      box: {
	        position: 'absolute',
	        opacity: 1,
	        fill: this.getTheme().boxColor,
	        transition: _transitions2.default.easeOut('2s', null, '200ms')
	      },
	      checkWhenSwitched: {
	        opacity: 1,
	        transform: 'scale(1)',
	        transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	      },
	      boxWhenSwitched: {
	        transition: _transitions2.default.easeOut('100ms', null, '0ms'),
	        fill: this.getTheme().checkedColor
	      },
	      checkWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      boxWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      label: {
	        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
	      }
	    };
	
	    return styles;
	  },
	  isChecked: function isChecked() {
	    return this.refs.enhancedSwitch.isSwitched();
	  },
	  setChecked: function setChecked(newCheckedValue) {
	    this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	  },
	  _handleCheck: function _handleCheck(e, isInputChecked) {
	    if (this.props.onCheck) this.props.onCheck(e, isInputChecked);
	  },
	  _handleStateChange: function _handleStateChange(newSwitched) {
	    this.setState({ switched: newSwitched });
	  },
	  render: function render() {
	    var _props = this.props;
	    var iconStyle = _props.iconStyle;
	    var onCheck = _props.onCheck;
	    var checkedIcon = _props.checkedIcon;
	    var unCheckedIcon = _props.unCheckedIcon;
	
	    var other = _objectWithoutProperties(_props, ['iconStyle', 'onCheck', 'checkedIcon', 'unCheckedIcon']);
	
	    var styles = this.getStyles();
	    var boxStyles = this.mergeStyles(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	    var checkStyles = this.mergeStyles(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	    var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	      style: this.mergeStyles(checkStyles, checkedIcon.props.style)
	    }) : _react2.default.createElement(_checkBox2.default, {
	      style: checkStyles
	    });
	
	    var unCheckedElement = unCheckedIcon ? _react2.default.cloneElement(unCheckedIcon, {
	      style: this.mergeStyles(boxStyles, unCheckedIcon.props.style)
	    }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	      style: boxStyles
	    });
	
	    var checkboxElement = _react2.default.createElement(
	      'div',
	      null,
	      unCheckedElement,
	      checkedElement
	    );
	
	    var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	    var mergedIconStyle = this.mergeStyles(styles.icon, iconStyle);
	
	    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);
	
	    var enhancedSwitchProps = {
	      ref: 'enhancedSwitch',
	      inputType: 'checkbox',
	      switched: this.state.switched,
	      switchElement: checkboxElement,
	      rippleColor: rippleColor,
	      iconStyle: mergedIconStyle,
	      onSwitch: this._handleCheck,
	      labelStyle: labelStyle,
	      onParentShouldUpdate: this._handleStateChange,
	      defaultSwitched: this.props.defaultChecked,
	      labelPosition: this.props.labelPosition
	    };
	
	    return _react2.default.createElement(_enhancedSwitch2.default, _extends({}, other, enhancedSwitchProps));
	  }
	});
	
	exports.default = Checkbox;
	module.exports = exports['default'];

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _flatButton = __webpack_require__(54);
	
	var _flatButton2 = _interopRequireDefault(_flatButton);
	
	var _overlay = __webpack_require__(98);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _renderToLayer = __webpack_require__(147);
	
	var _renderToLayer2 = _interopRequireDefault(_renderToLayer);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _reactAddonsTransitionGroup = __webpack_require__(74);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TransitionItem = _react2.default.createClass({
	  displayName: 'TransitionItem',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      style: {},
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentWillEnter: function componentWillEnter(callback) {
	    this.componentWillAppear(callback);
	  },
	  componentWillAppear: function componentWillAppear(callback) {
	    var spacing = this.state.muiTheme.rawTheme.spacing;
	
	    this.setState({
	      style: {
	        opacity: 1,
	        transform: 'translate3d(0, ' + spacing.desktopKeylineIncrement + 'px, 0)'
	      }
	    });
	
	    setTimeout(callback, 450); // matches transition duration
	  },
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    this.setState({
	      style: {
	        opacity: 0,
	        transform: 'translate3d(0, 0, 0)'
	      }
	    });
	
	    setTimeout(function () {
	      if (_this.isMounted()) callback();
	    }, 450); // matches transition duration
	  },
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var children = _props.children;
	
	    var other = _objectWithoutProperties(_props, ['style', 'children']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(this.state.style, style) }),
	      children
	    );
	  }
	});
	
	var DialogInline = _react2.default.createClass({
	  displayName: 'DialogInline',
	
	  propTypes: {
	    actionFocus: _react2.default.PropTypes.string,
	    actions: _react2.default.PropTypes.node,
	    actionsContainerClassName: _react2.default.PropTypes.string,
	    actionsContainerStyle: _react2.default.PropTypes.object,
	    autoDetectWindowHeight: _react2.default.PropTypes.bool,
	    autoScrollBodyContent: _react2.default.PropTypes.bool,
	    bodyClassName: _react2.default.PropTypes.string,
	    bodyStyle: _react2.default.PropTypes.object,
	    children: _react2.default.PropTypes.node,
	    className: _react2.default.PropTypes.string,
	    contentClassName: _react2.default.PropTypes.string,
	    contentStyle: _react2.default.PropTypes.object,
	    modal: _react2.default.PropTypes.bool,
	    onRequestClose: _react2.default.PropTypes.func,
	    open: _react2.default.PropTypes.bool.isRequired,
	    overlayClassName: _react2.default.PropTypes.string,
	    overlayStyle: _react2.default.PropTypes.object,
	    repositionOnUpdate: _react2.default.PropTypes.bool,
	    style: _react2.default.PropTypes.object,
	    title: _react2.default.PropTypes.node,
	    titleClassName: _react2.default.PropTypes.string,
	    titleStyle: _react2.default.PropTypes.object,
	    width: _react2.default.PropTypes.any
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_windowListenable2.default, _stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._positionDialog();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._positionDialog();
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp',
	    resize: '_handleResize'
	  },
	
	  getStyles: function getStyles() {
	    var _props2 = this.props;
	    var autoScrollBodyContent = _props2.autoScrollBodyContent;
	    var open = _props2.open;
	    var width = _props2.width;
	
	    var muiTheme = this.state.muiTheme;
	    var rawTheme = muiTheme.rawTheme;
	    var spacing = rawTheme.spacing;
	    var gutter = spacing.desktopGutter;
	
	    return {
	      root: {
	        position: 'fixed',
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        zIndex: muiTheme.zIndex.dialog,
	        top: 0,
	        left: open ? 0 : -10000,
	        width: '100%',
	        height: '100%',
	        transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	      },
	      content: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        transition: _transitions2.default.easeOut(),
	        position: 'relative',
	        width: width || '75%',
	        maxWidth: spacing.desktopKeylineIncrement * 12,
	        margin: '0 auto',
	        zIndex: muiTheme.zIndex.dialog
	      },
	      body: {
	        padding: spacing.desktopGutter,
	        overflowY: autoScrollBodyContent ? 'auto' : 'hidden',
	        overflowX: 'hidden'
	      },
	      actionsContainer: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        padding: 8,
	        marginBottom: 8,
	        width: '100%',
	        textAlign: 'right'
	      },
	      paper: {
	        background: rawTheme.palette.canvasColor
	      },
	      overlay: {
	        zIndex: muiTheme.zIndex.dialogOverlay
	      },
	      title: {
	        margin: 0,
	        padding: gutter + 'px ' + gutter + 'px 0 ' + gutter + 'px',
	        color: rawTheme.palette.textColor,
	        fontSize: 24,
	        lineHeight: '32px',
	        fontWeight: 400
	      }
	    };
	  },
	  _getAction: function _getAction(actionJSON) {
	    var _this2 = this;
	
	     false ? (0, _warning2.default)(false, 'using actionsJSON is deprecated on Dialog, please provide an array of\n buttons, or any other components instead. For more information please refer to documentations.') : undefined;
	    var props = {
	      secondary: true,
	      onClick: actionJSON.onClick,
	      onTouchTap: function onTouchTap() {
	        if (actionJSON.onTouchTap) {
	          actionJSON.onTouchTap.call(undefined);
	        }
	        if (!(actionJSON.onClick || actionJSON.onTouchTap)) {
	          _this2._requestClose(true);
	        }
	      },
	      label: actionJSON.text,
	      style: {
	        marginRight: 8
	      }
	    };
	
	    if (actionJSON.ref) {
	      props.ref = actionJSON.ref;
	      props.keyboardFocused = actionJSON.ref === this.props.actionFocus;
	    }
	    if (actionJSON.id) {
	      props.id = actionJSON.id;
	    }
	
	    return _react2.default.createElement(_flatButton2.default, props);
	  },
	  _getActionObjects: function _getActionObjects(actions) {
	    var _this3 = this;
	
	    var actionObjects = [];
	
	    // ------- Replace this selction with:
	    //
	    // React.Children.forEach(actions, action => {
	    //   if (React.isValidElement(action)) {
	    //     actionObjects.push(action);
	    //   }
	    // });
	    //
	    // Also the return element will not need a call to React.Children.toArray
	    //
	    // for the 0.15.0 release
	
	    if (actions) {
	
	      if (_react2.default.isValidElement(actions)) {
	        actionObjects.push(actions);
	      } else {
	        actions.forEach(function (action) {
	          if (action) {
	            if (!_react2.default.isValidElement(action)) {
	              action = _this3._getAction(action);
	            }
	            actionObjects.push(action);
	          }
	        });
	      }
	    }
	
	    // ------- End of section
	
	    return actionObjects;
	  },
	  _getActionsContainer: function _getActionsContainer(actions, styles, className) {
	    var actionObjects = this._getActionObjects(actions);
	
	    return actionObjects.length > 0 && _react2.default.createElement(
	      'div',
	      { className: className, style: this.prepareStyles(styles) },
	      _react2.default.Children.toArray(actionObjects)
	    );
	  },
	  _positionDialog: function _positionDialog() {
	    var _props3 = this.props;
	    var actions = _props3.actions;
	    var autoDetectWindowHeight = _props3.autoDetectWindowHeight;
	    var autoScrollBodyContent = _props3.autoScrollBodyContent;
	    var bodyStyle = _props3.bodyStyle;
	    var open = _props3.open;
	    var repositionOnUpdate = _props3.repositionOnUpdate;
	    var title = _props3.title;
	
	    if (!open) {
	      return;
	    }
	
	    var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	    var container = _reactDom2.default.findDOMNode(this);
	    var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	    var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	    var minPaddingTop = 16;
	
	    //Reset the height in case the window was resized.
	    dialogWindow.style.height = '';
	    dialogContent.style.height = '';
	
	    var dialogWindowHeight = dialogWindow.offsetHeight;
	    var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	    if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	    //Vertically center the dialog window, but make sure it doesn't
	    //transition to that position.
	    if (repositionOnUpdate || !container.style.paddingTop) {
	      container.style.paddingTop = paddingTop + 'px';
	    }
	
	    // Force a height if the dialog is taller than clientHeight
	    if (autoDetectWindowHeight || autoScrollBodyContent) {
	      var styles = this.getStyles();
	      styles.body = this.mergeStyles(styles.body, bodyStyle);
	      var maxDialogContentHeight = clientHeight - 2 * (styles.body.padding + 64);
	
	      if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	      var hasActions = this._getActionObjects(actions).length > 0;
	      if (hasActions) maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	
	      dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	    }
	  },
	  _requestClose: function _requestClose(buttonClicked) {
	
	    if (!buttonClicked && this.props.modal) {
	      return;
	    }
	
	    if (this.props.onRequestClose) {
	      this.props.onRequestClose(!!buttonClicked);
	    }
	  },
	  _handleOverlayTouchTap: function _handleOverlayTouchTap() {
	    this._requestClose(false);
	  },
	  _handleWindowKeyUp: function _handleWindowKeyUp(event) {
	    if (event.keyCode === _keyCode2.default.ESC) {
	      this._requestClose(false);
	    }
	  },
	  _handleResize: function _handleResize() {
	    if (this.props.open) {
	      this._positionDialog();
	    }
	  },
	  render: function render() {
	    var _props4 = this.props;
	    var actions = _props4.actions;
	    var actionsContainerClassName = _props4.actionsContainerClassName;
	    var actionsContainerStyle = _props4.actionsContainerStyle;
	    var bodyClassName = _props4.bodyClassName;
	    var bodyStyle = _props4.bodyStyle;
	    var children = _props4.children;
	    var className = _props4.className;
	    var contentClassName = _props4.contentClassName;
	    var contentStyle = _props4.contentStyle;
	    var overlayClassName = _props4.overlayClassName;
	    var overlayStyle = _props4.overlayStyle;
	    var open = _props4.open;
	    var titleClassName = _props4.titleClassName;
	    var titleStyle = _props4.titleStyle;
	    var title = _props4.title;
	    var style = _props4.style;
	
	    var styles = this.getStyles();
	
	    styles.root = this.mergeStyles(styles.root, style);
	    styles.content = this.mergeStyles(styles.content, contentStyle);
	    styles.body = this.mergeStyles(styles.body, bodyStyle);
	    styles.actionsContainer = this.mergeStyles(styles.actionsContainer, actionsContainerStyle);
	    styles.overlay = this.mergeStyles(styles.overlay, overlayStyle);
	    styles.title = this.mergeStyles(styles.title, titleStyle);
	
	    var actionsContainer = this._getActionsContainer(actions, styles.actionsContainer, actionsContainerClassName);
	
	    var titleElement = typeof title === 'string' ? _react2.default.createElement(
	      'h3',
	      { className: titleClassName, style: this.prepareStyles(styles.title) },
	      title
	    ) : title;
	
	    return _react2.default.createElement(
	      'div',
	      { className: className, style: this.prepareStyles(styles.root) },
	      _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        {
	          component: 'div', ref: 'dialogWindow',
	          transitionAppear: true, transitionAppearTimeout: 450,
	          transitionEnter: true, transitionEnterTimeout: 450
	        },
	        open && _react2.default.createElement(
	          TransitionItem,
	          {
	            className: contentClassName,
	            style: styles.content
	          },
	          _react2.default.createElement(
	            _paper2.default,
	            {
	              style: styles.paper,
	              zDepth: 4
	            },
	            titleElement,
	            _react2.default.createElement(
	              'div',
	              {
	                ref: 'dialogContent',
	                className: bodyClassName,
	                style: this.prepareStyles(styles.body)
	              },
	              children
	            ),
	            actionsContainer
	          )
	        )
	      ),
	      _react2.default.createElement(_overlay2.default, {
	        show: open,
	        className: overlayClassName,
	        style: styles.overlay,
	        onTouchTap: this._handleOverlayTouchTap
	      })
	    );
	  }
	});
	
	var Dialog = _react2.default.createClass({
	  displayName: 'Dialog',
	
	  propTypes: {
	    /**
	     * The `ref` of the action to focus on when the `Dialog` is displayed.
	     */
	    actionFocus: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'Instead, use a custom `actions` property.'),
	
	    /**
	     * This prop can be either a JSON object containing the actions to render (This is **DEPRECATED**),
	     * a react elements, or an array of react elements.
	     */
	    actions: _react2.default.PropTypes.node,
	
	    /**
	     * The `className` to add to the actions container's root element.
	     */
	    actionsContainerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the actions container's root element.
	     */
	    actionsContainerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * If set to true, the height of the `Dialog` will be auto detected. A max height
	     * will be enforced so that the content does not extend beyond the viewport.
	     */
	    autoDetectWindowHeight: _react2.default.PropTypes.bool,
	
	    /**
	     * If set to true, the body content of the `Dialog` will be scrollable.
	     */
	    autoScrollBodyContent: _react2.default.PropTypes.bool,
	
	    /**
	     * The `className` to add to the content's root element under the title.
	     */
	    bodyClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the content's root element under the title.
	     */
	    bodyStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The contents of the `Dialog`.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * The `className` to add to the content container.
	     */
	    contentClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the content container.
	     */
	    contentStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Force the user to use one of the actions in the `Dialog`.
	     * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	     */
	    modal: _react2.default.PropTypes.bool,
	
	    /**
	     * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	     *
	     * @param {bool} buttonClicked Determines whether a button click triggered this request.
	     */
	    onRequestClose: _react2.default.PropTypes.func,
	
	    /**
	     * Controls whether the Dialog is opened or not.
	     */
	    open: _react2.default.PropTypes.bool.isRequired,
	
	    /**
	     * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	     */
	    overlayClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	     */
	    overlayStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	     */
	    repositionOnUpdate: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	     */
	    title: _react2.default.PropTypes.node,
	
	    /**
	     * The `className` to add to the title's root container element.
	     */
	    titleClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the title's root container element.
	     */
	    titleStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Changes the width of the `Dialog`.
	     */
	    width: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.any, 'Use the contentStyle.')
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoDetectWindowHeight: true,
	      autoScrollBodyContent: false,
	      modal: false,
	      repositionOnUpdate: true
	    };
	  },
	  renderLayer: function renderLayer() {
	    return _react2.default.createElement(DialogInline, this.props);
	  },
	  render: function render() {
	    return _react2.default.createElement(_renderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	  }
	});
	
	exports.default = Dialog;
	module.exports = exports['default'];

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _muiThemeable = __webpack_require__(277);
	
	var _muiThemeable2 = _interopRequireDefault(_muiThemeable);
	
	var _styles = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react2.default.PropTypes.string,
	
	  /**
	   * If true, the `Divider` will be indented `72px`.
	   */
	  inset: _react2.default.PropTypes.bool,
	
	  /**
	   * The material-ui theme applied to this component.
	   * @ignore
	   */
	  muiTheme: _react2.default.PropTypes.object.isRequired,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object
	};
	
	var defaultProps = {
	  inset: false
	};
	
	var Divider = function Divider(props) {
	  var inset = props.inset;
	  var muiTheme = props.muiTheme;
	  var style = props.style;
	
	  var other = _objectWithoutProperties(props, ['inset', 'muiTheme', 'style']);
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: muiTheme.rawTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', _extends({}, other, { style: (0, _styles.prepareStyles)(muiTheme, (0, _styles.mergeStyles)(styles.root, style)) }));
	};
	
	Divider.displayName = 'Divider';
	Divider.propTypes = propTypes;
	Divider.defaultProps = defaultProps;
	Divider = (0, _muiThemeable2.default)(Divider);
	
	exports.default = Divider;
	module.exports = exports['default'];

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _uniqueId = __webpack_require__(105);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _clearfix = __webpack_require__(53);
	
	var _clearfix2 = _interopRequireDefault(_clearfix);
	
	var _focusRipple = __webpack_require__(69);
	
	var _focusRipple2 = _interopRequireDefault(_focusRipple);
	
	var _touchRipple = __webpack_require__(99);
	
	var _touchRipple2 = _interopRequireDefault(_touchRipple);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var EnhancedSwitch = _react2.default.createClass({
	  displayName: 'EnhancedSwitch',
	
	  propTypes: {
	    checked: _react2.default.PropTypes.bool,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	    defaultSwitched: _react2.default.PropTypes.bool,
	    disableFocusRipple: _react2.default.PropTypes.bool,
	    disableTouchRipple: _react2.default.PropTypes.bool,
	    disabled: _react2.default.PropTypes.bool,
	    iconStyle: _react2.default.PropTypes.object,
	    id: _react2.default.PropTypes.string,
	    inputType: _react2.default.PropTypes.string.isRequired,
	    label: _react2.default.PropTypes.node,
	    labelPosition: _react2.default.PropTypes.oneOf(['left', 'right']),
	    labelStyle: _react2.default.PropTypes.object,
	    name: _react2.default.PropTypes.string,
	    onBlur: _react2.default.PropTypes.func,
	    onFocus: _react2.default.PropTypes.func,
	    onMouseDown: _react2.default.PropTypes.func,
	    onMouseLeave: _react2.default.PropTypes.func,
	    onMouseUp: _react2.default.PropTypes.func,
	    onParentShouldUpdate: _react2.default.PropTypes.func.isRequired,
	    onSwitch: _react2.default.PropTypes.func,
	    onTouchEnd: _react2.default.PropTypes.func,
	    onTouchStart: _react2.default.PropTypes.func,
	    required: _react2.default.PropTypes.bool,
	    rippleColor: _react2.default.PropTypes.string,
	    rippleStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    switchElement: _react2.default.PropTypes.element.isRequired,
	    switched: _react2.default.PropTypes.bool.isRequired,
	    thumbStyle: _react2.default.PropTypes.object,
	    trackStyle: _react2.default.PropTypes.object,
	    value: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_windowListenable2.default, _stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      isKeyboardFocused: false,
	      parentWidth: 100,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var inputNode = _reactDom2.default.findDOMNode(this.refs.checkbox);
	    if (!this.props.switched || inputNode.checked !== this.props.switched) {
	      this.props.onParentShouldUpdate(inputNode.checked);
	    }
	
	    window.addEventListener('resize', this._handleResize);
	
	    this._handleResize();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var hasCheckedLinkProp = nextProps.hasOwnProperty('checkedLink');
	    var hasCheckedProp = nextProps.hasOwnProperty('checked');
	    var hasToggledProp = nextProps.hasOwnProperty('toggled');
	    var hasNewDefaultProp = nextProps.hasOwnProperty('defaultSwitched') && nextProps.defaultSwitched !== this.props.defaultSwitched;
	    var newState = {};
	    newState.muiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    if (hasCheckedProp) {
	      newState.switched = nextProps.checked;
	    } else if (hasToggledProp) {
	      newState.switched = nextProps.toggled;
	    } else if (hasCheckedLinkProp) {
	      newState.switched = nextProps.checkedLink.value;
	    } else if (hasNewDefaultProp) {
	      newState.switched = nextProps.defaultSwitched;
	    }
	
	    if (newState.switched !== undefined && newState.switched !== this.props.switched) {
	      this.props.onParentShouldUpdate(newState.switched);
	    }
	
	    this.setState(newState);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this._handleResize);
	  },
	
	  windowListeners: {
	    keydown: '_handleWindowKeydown',
	    keyup: '_handleWindowKeyup'
	  },
	
	  getEvenWidth: function getEvenWidth() {
	    return parseInt(window.getComputedStyle(_reactDom2.default.findDOMNode(this.refs.root)).getPropertyValue('width'), 10);
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.rawTheme.palette;
	  },
	  getStyles: function getStyles() {
	    var spacing = this.state.muiTheme.rawTheme.spacing;
	    var switchWidth = 60 - spacing.desktopGutterLess;
	    var labelWidth = 'calc(100% - 60px)';
	    var styles = {
	      root: {
	        position: 'relative',
	        cursor: this.props.disabled ? 'default' : 'pointer',
	        overflow: 'visible',
	        display: 'table',
	        height: 'auto',
	        width: '100%'
	      },
	      input: {
	        position: 'absolute',
	        cursor: this.props.disabled ? 'default' : 'pointer',
	        pointerEvents: 'all',
	        opacity: 0,
	        width: '100%',
	        height: '100%',
	        zIndex: 2,
	        left: 0,
	        boxSizing: 'border-box',
	        padding: 0,
	        margin: 0
	      },
	      controls: {
	        width: '100%',
	        height: '100%'
	      },
	      label: {
	        float: 'left',
	        position: 'relative',
	        display: 'block',
	        width: labelWidth,
	        lineHeight: '24px',
	        color: this.getTheme().textColor,
	        fontFamily: this.state.muiTheme.rawTheme.fontFamily
	      },
	      wrap: {
	        transition: _transitions2.default.easeOut(),
	        float: 'left',
	        position: 'relative',
	        display: 'block',
	        width: switchWidth,
	        marginRight: this.props.labelPosition === 'right' ? spacing.desktopGutterLess : 0,
	        marginLeft: this.props.labelPosition === 'left' ? spacing.desktopGutterLess : 0
	      },
	      ripple: {
	        height: '200%',
	        width: '200%',
	        top: -12,
	        left: -12
	      }
	    };
	
	    return styles;
	  },
	  isSwitched: function isSwitched() {
	    return _reactDom2.default.findDOMNode(this.refs.checkbox).checked;
	  },
	
	  // no callback here because there is no event
	  setSwitched: function setSwitched(newSwitchedValue) {
	    if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	      this.props.onParentShouldUpdate(newSwitchedValue);
	      _reactDom2.default.findDOMNode(this.refs.checkbox).checked = newSwitchedValue;
	    } else {
	       false ? (0, _warning2.default)(false, 'Cannot call set method while checked is defined as a property.') : undefined;
	    }
	  },
	  getValue: function getValue() {
	    return _reactDom2.default.findDOMNode(this.refs.checkbox).value;
	  },
	  isKeyboardFocused: function isKeyboardFocused() {
	    return this.state.isKeyboardFocused;
	  },
	  _handleChange: function _handleChange(e) {
	    this._tabPressed = false;
	    this.setState({
	      isKeyboardFocused: false
	    });
	
	    var isInputChecked = _reactDom2.default.findDOMNode(this.refs.checkbox).checked;
	
	    if (!this.props.hasOwnProperty('checked')) {
	      this.props.onParentShouldUpdate(isInputChecked);
	    }
	    if (this.props.onSwitch) {
	      this.props.onSwitch(e, isInputChecked);
	    }
	  },
	
	  // Checkbox inputs only use SPACE to change their state. Using ENTER will
	  // update the ui but not the input.
	  _handleWindowKeydown: function _handleWindowKeydown(e) {
	    if (e.keyCode === _keyCode2.default.TAB) {
	      this._tabPressed = true;
	    }
	    if (e.keyCode === _keyCode2.default.SPACE && this.state.isKeyboardFocused) {
	      this._handleChange(e);
	    }
	  },
	  _handleWindowKeyup: function _handleWindowKeyup(e) {
	    if (e.keyCode === _keyCode2.default.SPACE && this.state.isKeyboardFocused) {
	      this._handleChange(e);
	    }
	  },
	
	  /**
	   * Because both the ripples and the checkbox input cannot share pointer
	   * events, the checkbox input takes control of pointer events and calls
	   * ripple animations manually.
	   */
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) {
	      this.refs.touchRipple.start(e);
	    }
	  },
	  _handleMouseUp: function _handleMouseUp() {
	    this.refs.touchRipple.end();
	  },
	  _handleMouseLeave: function _handleMouseLeave() {
	    this.refs.touchRipple.end();
	  },
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.refs.touchRipple.start(e);
	  },
	  _handleTouchEnd: function _handleTouchEnd() {
	    this.refs.touchRipple.end();
	  },
	  _handleBlur: function _handleBlur(e) {
	    this.setState({
	      isKeyboardFocused: false
	    });
	
	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	  },
	  _handleFocus: function _handleFocus(e) {
	    var _this = this;
	
	    //setTimeout is needed becuase the focus event fires first
	    //Wait so that we can capture if this was a keyboard focus
	    //or touch focus
	    setTimeout(function () {
	      if (_this._tabPressed) {
	        _this.setState({
	          isKeyboardFocused: true
	        });
	      }
	    }, 150);
	
	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	  },
	  _handleResize: function _handleResize() {
	    this.setState({ parentWidth: this.getEvenWidth() });
	  },
	  render: function render() {
	    var _props = this.props;
	    var name = _props.name;
	    var value = _props.value;
	    var label = _props.label;
	    var onSwitch = _props.onSwitch;
	    var defaultSwitched = _props.defaultSwitched;
	    var onBlur = _props.onBlur;
	    var onFocus = _props.onFocus;
	    var onMouseUp = _props.onMouseUp;
	    var onMouseDown = _props.onMouseDown;
	    var onMouseLeave = _props.onMouseLeave;
	    var onTouchStart = _props.onTouchStart;
	    var onTouchEnd = _props.onTouchEnd;
	    var disableTouchRipple = _props.disableTouchRipple;
	    var disableFocusRipple = _props.disableFocusRipple;
	    var className = _props.className;
	
	    var other = _objectWithoutProperties(_props, ['name', 'value', 'label', 'onSwitch', 'defaultSwitched', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'disableTouchRipple', 'disableFocusRipple', 'className']);
	
	    var styles = this.getStyles();
	    var wrapStyles = this.mergeStyles(styles.wrap, this.props.iconStyle);
	    var rippleStyle = this.mergeStyles(styles.ripple, this.props.rippleStyle);
	    var rippleColor = this.props.hasOwnProperty('rippleColor') ? this.props.rippleColor : this.getTheme().primary1Color;
	
	    if (this.props.thumbStyle) {
	      wrapStyles.marginLeft /= 2;
	      wrapStyles.marginRight /= 2;
	    }
	
	    var inputId = this.props.id || _uniqueId2.default.generate();
	
	    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);
	    var labelElement = this.props.label ? _react2.default.createElement(
	      'label',
	      { style: this.prepareStyles(labelStyle), htmlFor: inputId },
	      this.props.label
	    ) : null;
	
	    var inputProps = {
	      ref: 'checkbox',
	      type: this.props.inputType,
	      style: this.prepareStyles(styles.input),
	      name: this.props.name,
	      value: this.props.value,
	      defaultChecked: this.props.defaultSwitched,
	      onBlur: this._handleBlur,
	      onFocus: this._handleFocus
	    };
	
	    var hideTouchRipple = this.props.disabled || disableTouchRipple;
	
	    if (!hideTouchRipple) {
	      inputProps.onMouseUp = this._handleMouseUp;
	      inputProps.onMouseDown = this._handleMouseDown;
	      inputProps.onMouseLeave = this._handleMouseLeave;
	      inputProps.onTouchStart = this._handleTouchStart;
	      inputProps.onTouchEnd = this._handleTouchEnd;
	    }
	
	    if (!this.props.hasOwnProperty('checkedLink')) {
	      inputProps.onChange = this._handleChange;
	    }
	
	    var inputElement = _react2.default.createElement('input', _extends({}, other, inputProps));
	
	    var touchRipple = _react2.default.createElement(_touchRipple2.default, {
	      ref: 'touchRipple',
	      key: 'touchRipple',
	      style: rippleStyle,
	      color: rippleColor,
	      muiTheme: this.state.muiTheme,
	      centerRipple: true
	    });
	
	    var focusRipple = _react2.default.createElement(_focusRipple2.default, {
	      key: 'focusRipple',
	      innerStyle: rippleStyle,
	      color: rippleColor,
	      muiTheme: this.state.muiTheme,
	      show: this.state.isKeyboardFocused
	    });
	
	    var ripples = [hideTouchRipple ? null : touchRipple, this.props.disabled || disableFocusRipple ? null : focusRipple];
	
	    // If toggle component (indicated by whether the style includes thumb) manually lay out
	    // elements in order to nest ripple elements
	    var switchElement = !this.props.thumbStyle ? _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(wrapStyles) },
	      this.props.switchElement,
	      ripples
	    ) : _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(wrapStyles) },
	      _react2.default.createElement('div', { style: this.prepareStyles(this.props.trackStyle) }),
	      _react2.default.createElement(
	        _paper2.default,
	        { style: this.props.thumbStyle, zDepth: 1, circle: true },
	        ' ',
	        ripples,
	        ' '
	      )
	    );
	
	    var labelPositionExist = this.props.labelPosition;
	
	    // Position is left if not defined or invalid.
	    var elementsInOrder = labelPositionExist && this.props.labelPosition.toUpperCase() === 'RIGHT' ? _react2.default.createElement(
	      _clearfix2.default,
	      { style: styles.controls },
	      switchElement,
	      labelElement
	    ) : _react2.default.createElement(
	      _clearfix2.default,
	      { style: styles.controls },
	      labelElement,
	      switchElement
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'root', className: className, style: this.prepareStyles(styles.root, this.props.style) },
	      inputElement,
	      elementsInOrder
	    );
	  }
	});
	
	exports.default = EnhancedSwitch;
	module.exports = exports['default'];

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Icons = exports.Utils = exports.Tooltip = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.TextField = exports.TimePicker = exports.ThemeWrapper = exports.Toggle = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tabs = exports.Tab = exports.Snackbar = exports.Styles = exports.SvgIcon = exports.Slider = exports.SelectableContainerEnhance = exports.SelectField = exports.Ripples = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.Overlay = exports.Mixins = exports.MenuItem = exports.Menu = exports.ListItem = exports.ListDivider = exports.List = exports.LinearProgress = exports.LeftNav = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.EnhancedButton = exports.DropDownMenu = exports.DropDownIcon = exports.Divider = exports.Dialog = exports.DatePickerDialog = exports.DatePicker = exports.ClearFix = exports.CircularProgress = exports.Checkbox = exports.CardTitle = exports.CardText = exports.CardMedia = exports.CardHeader = exports.CardExpandable = exports.CardActions = exports.Card = exports.BeforeAfterWrapper = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppCanvas = exports.AppBar = undefined;
	
	var _appBar = __webpack_require__(239);
	
	var _appBar2 = _interopRequireDefault(_appBar);
	
	var _appCanvas = __webpack_require__(240);
	
	var _appCanvas2 = _interopRequireDefault(_appCanvas);
	
	var _autoComplete = __webpack_require__(241);
	
	var _autoComplete2 = _interopRequireDefault(_autoComplete);
	
	var _avatar = __webpack_require__(139);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _badge = __webpack_require__(242);
	
	var _badge2 = _interopRequireDefault(_badge);
	
	var _beforeAfterWrapper = __webpack_require__(140);
	
	var _beforeAfterWrapper2 = _interopRequireDefault(_beforeAfterWrapper);
	
	var _card = __webpack_require__(249);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _cardActions = __webpack_require__(244);
	
	var _cardActions2 = _interopRequireDefault(_cardActions);
	
	var _cardExpandable = __webpack_require__(141);
	
	var _cardExpandable2 = _interopRequireDefault(_cardExpandable);
	
	var _cardHeader = __webpack_require__(245);
	
	var _cardHeader2 = _interopRequireDefault(_cardHeader);
	
	var _cardMedia = __webpack_require__(246);
	
	var _cardMedia2 = _interopRequireDefault(_cardMedia);
	
	var _cardText = __webpack_require__(247);
	
	var _cardText2 = _interopRequireDefault(_cardText);
	
	var _cardTitle = __webpack_require__(248);
	
	var _cardTitle2 = _interopRequireDefault(_cardTitle);
	
	var _checkbox = __webpack_require__(91);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _circularProgress = __webpack_require__(250);
	
	var _circularProgress2 = _interopRequireDefault(_circularProgress);
	
	var _clearfix = __webpack_require__(53);
	
	var _clearfix2 = _interopRequireDefault(_clearfix);
	
	var _datePicker = __webpack_require__(257);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _datePickerDialog = __webpack_require__(142);
	
	var _datePickerDialog2 = _interopRequireDefault(_datePickerDialog);
	
	var _dialog = __webpack_require__(92);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _divider = __webpack_require__(93);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _dropDownIcon = __webpack_require__(260);
	
	var _dropDownIcon2 = _interopRequireDefault(_dropDownIcon);
	
	var _dropDownMenu = __webpack_require__(261);
	
	var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _flatButton = __webpack_require__(54);
	
	var _flatButton2 = _interopRequireDefault(_flatButton);
	
	var _floatingActionButton = __webpack_require__(263);
	
	var _floatingActionButton2 = _interopRequireDefault(_floatingActionButton);
	
	var _fontIcon = __webpack_require__(55);
	
	var _fontIcon2 = _interopRequireDefault(_fontIcon);
	
	var _gridList = __webpack_require__(264);
	
	var _gridList2 = _interopRequireDefault(_gridList);
	
	var _gridTile = __webpack_require__(265);
	
	var _gridTile2 = _interopRequireDefault(_gridTile);
	
	var _iconButton = __webpack_require__(56);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	var _iconMenu = __webpack_require__(275);
	
	var _iconMenu2 = _interopRequireDefault(_iconMenu);
	
	var _leftNav = __webpack_require__(268);
	
	var _leftNav2 = _interopRequireDefault(_leftNav);
	
	var _linearProgress = __webpack_require__(269);
	
	var _linearProgress2 = _interopRequireDefault(_linearProgress);
	
	var _list = __webpack_require__(96);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _listDivider = __webpack_require__(270);
	
	var _listDivider2 = _interopRequireDefault(_listDivider);
	
	var _listItem = __webpack_require__(143);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	var _menu = __webpack_require__(57);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menuItem = __webpack_require__(97);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _mixins = __webpack_require__(276);
	
	var _mixins2 = _interopRequireDefault(_mixins);
	
	var _overlay = __webpack_require__(98);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _popover = __webpack_require__(58);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _radioButton = __webpack_require__(146);
	
	var _radioButton2 = _interopRequireDefault(_radioButton);
	
	var _radioButtonGroup = __webpack_require__(280);
	
	var _radioButtonGroup2 = _interopRequireDefault(_radioButtonGroup);
	
	var _raisedButton = __webpack_require__(281);
	
	var _raisedButton2 = _interopRequireDefault(_raisedButton);
	
	var _refreshIndicator = __webpack_require__(282);
	
	var _refreshIndicator2 = _interopRequireDefault(_refreshIndicator);
	
	var _ripples = __webpack_require__(283);
	
	var _ripples2 = _interopRequireDefault(_ripples);
	
	var _selectField = __webpack_require__(284);
	
	var _selectField2 = _interopRequireDefault(_selectField);
	
	var _selectableEnhance = __webpack_require__(266);
	
	var _selectableEnhance2 = _interopRequireDefault(_selectableEnhance);
	
	var _slider = __webpack_require__(285);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	var _styles = __webpack_require__(70);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _snackbar = __webpack_require__(286);
	
	var _snackbar2 = _interopRequireDefault(_snackbar);
	
	var _tab = __webpack_require__(308);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _tabs = __webpack_require__(310);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _table = __webpack_require__(307);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _tableBody = __webpack_require__(303);
	
	var _tableBody2 = _interopRequireDefault(_tableBody);
	
	var _tableFooter = __webpack_require__(304);
	
	var _tableFooter2 = _interopRequireDefault(_tableFooter);
	
	var _tableHeader = __webpack_require__(305);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	var _tableHeaderColumn = __webpack_require__(155);
	
	var _tableHeaderColumn2 = _interopRequireDefault(_tableHeaderColumn);
	
	var _tableRow = __webpack_require__(306);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	var _tableRowColumn = __webpack_require__(102);
	
	var _tableRowColumn2 = _interopRequireDefault(_tableRowColumn);
	
	var _toggle = __webpack_require__(158);
	
	var _toggle2 = _interopRequireDefault(_toggle);
	
	var _themeWrapper = __webpack_require__(311);
	
	var _themeWrapper2 = _interopRequireDefault(_themeWrapper);
	
	var _timePicker = __webpack_require__(315);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _TextField = __webpack_require__(138);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _toolbar = __webpack_require__(160);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _toolbarGroup = __webpack_require__(159);
	
	var _toolbarGroup2 = _interopRequireDefault(_toolbarGroup);
	
	var _toolbarSeparator = __webpack_require__(319);
	
	var _toolbarSeparator2 = _interopRequireDefault(_toolbarSeparator);
	
	var _toolbarTitle = __webpack_require__(320);
	
	var _toolbarTitle2 = _interopRequireDefault(_toolbarTitle);
	
	var _tooltip = __webpack_require__(103);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _utils = __webpack_require__(324);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _menu3 = __webpack_require__(154);
	
	var _menu4 = _interopRequireDefault(_menu3);
	
	var _chevronLeft = __webpack_require__(152);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(153);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _appBar2.default;
	exports.AppCanvas = _appCanvas2.default;
	exports.AutoComplete = _autoComplete2.default;
	exports.Avatar = _avatar2.default;
	exports.Badge = _badge2.default;
	exports.BeforeAfterWrapper = _beforeAfterWrapper2.default;
	exports.Card = _card2.default;
	exports.CardActions = _cardActions2.default;
	exports.CardExpandable = _cardExpandable2.default;
	exports.CardHeader = _cardHeader2.default;
	exports.CardMedia = _cardMedia2.default;
	exports.CardText = _cardText2.default;
	exports.CardTitle = _cardTitle2.default;
	exports.Checkbox = _checkbox2.default;
	exports.CircularProgress = _circularProgress2.default;
	exports.ClearFix = _clearfix2.default;
	exports.DatePicker = _datePicker2.default;
	exports.DatePickerDialog = _datePickerDialog2.default;
	exports.Dialog = _dialog2.default;
	exports.Divider = _divider2.default;
	exports.DropDownIcon = _dropDownIcon2.default;
	exports.DropDownMenu = _dropDownMenu2.default;
	exports.EnhancedButton = _enhancedButton2.default;
	exports.FlatButton = _flatButton2.default;
	exports.FloatingActionButton = _floatingActionButton2.default;
	exports.FontIcon = _fontIcon2.default;
	exports.GridList = _gridList2.default;
	exports.GridTile = _gridTile2.default;
	exports.IconButton = _iconButton2.default;
	exports.IconMenu = _iconMenu2.default;
	exports.LeftNav = _leftNav2.default;
	exports.LinearProgress = _linearProgress2.default;
	exports.List = _list2.default;
	exports.ListDivider = _listDivider2.default;
	exports.ListItem = _listItem2.default;
	exports.Menu = _menu2.default;
	exports.MenuItem = _menuItem2.default;
	exports.Mixins = _mixins2.default;
	exports.Overlay = _overlay2.default;
	exports.Paper = _paper2.default;
	exports.Popover = _popover2.default;
	exports.RadioButton = _radioButton2.default;
	exports.RadioButtonGroup = _radioButtonGroup2.default;
	exports.RaisedButton = _raisedButton2.default;
	exports.RefreshIndicator = _refreshIndicator2.default;
	exports.Ripples = _ripples2.default;
	exports.SelectField = _selectField2.default;
	exports.SelectableContainerEnhance = _selectableEnhance2.default;
	exports.Slider = _slider2.default;
	exports.SvgIcon = _svgIcon2.default;
	exports.Styles = _styles2.default;
	exports.Snackbar = _snackbar2.default;
	exports.Tab = _tab2.default;
	exports.Tabs = _tabs2.default;
	exports.Table = _table2.default;
	exports.TableBody = _tableBody2.default;
	exports.TableFooter = _tableFooter2.default;
	exports.TableHeader = _tableHeader2.default;
	exports.TableHeaderColumn = _tableHeaderColumn2.default;
	exports.TableRow = _tableRow2.default;
	exports.TableRowColumn = _tableRowColumn2.default;
	exports.Toggle = _toggle2.default;
	exports.ThemeWrapper = _themeWrapper2.default;
	exports.TimePicker = _timePicker2.default;
	exports.TextField = _TextField2.default;
	exports.Toolbar = _toolbar2.default;
	exports.ToolbarGroup = _toolbarGroup2.default;
	exports.ToolbarSeparator = _toolbarSeparator2.default;
	exports.ToolbarTitle = _toolbarTitle2.default;
	exports.Tooltip = _tooltip2.default;
	exports.Utils = _utils2.default;
	var Icons = exports.Icons = {
	  NavigationMenu: _menu4.default,
	  NavigationChevronLeft: _chevronLeft2.default,
	  NavigationChevronRight: _chevronRight2.default
	};
	
	exports.default = {
	  AppBar: _appBar2.default,
	  AppCanvas: _appCanvas2.default,
	  AutoComplete: _autoComplete2.default,
	  Avatar: _avatar2.default,
	  Badge: _badge2.default,
	  BeforeAfterWrapper: _beforeAfterWrapper2.default,
	  Card: _card2.default,
	  CardActions: _cardActions2.default,
	  CardExpandable: _cardExpandable2.default,
	  CardHeader: _cardHeader2.default,
	  CardMedia: _cardMedia2.default,
	  CardText: _cardText2.default,
	  CardTitle: _cardTitle2.default,
	  Checkbox: _checkbox2.default,
	  CircularProgress: _circularProgress2.default,
	  ClearFix: _clearfix2.default,
	  DatePicker: _datePicker2.default,
	  DatePickerDialog: _datePickerDialog2.default,
	  Dialog: _dialog2.default,
	  Divider: _divider2.default,
	  DropDownIcon: _dropDownIcon2.default,
	  DropDownMenu: _dropDownMenu2.default,
	  EnhancedButton: _enhancedButton2.default,
	  FlatButton: _flatButton2.default,
	  FloatingActionButton: _floatingActionButton2.default,
	  FontIcon: _fontIcon2.default,
	  GridList: _gridList2.default,
	  GridTile: _gridTile2.default,
	  IconButton: _iconButton2.default,
	  IconMenu: _iconMenu2.default,
	  LeftNav: _leftNav2.default,
	  LinearProgress: _linearProgress2.default,
	  List: _list2.default,
	  ListDivider: _listDivider2.default,
	  ListItem: _listItem2.default,
	  Menu: _menu2.default,
	  MenuItem: _menuItem2.default,
	  Mixins: _mixins2.default,
	  Overlay: _overlay2.default,
	  Paper: _paper2.default,
	  Popover: _popover2.default,
	  RadioButton: _radioButton2.default,
	  RadioButtonGroup: _radioButtonGroup2.default,
	  RaisedButton: _raisedButton2.default,
	  RefreshIndicator: _refreshIndicator2.default,
	  Ripples: _ripples2.default,
	  SelectField: _selectField2.default,
	  SelectableContainerEnhance: _selectableEnhance2.default,
	  Slider: _slider2.default,
	  SvgIcon: _svgIcon2.default,
	  Styles: _styles2.default,
	  Snackbar: _snackbar2.default,
	  Tab: _tab2.default,
	  Tabs: _tabs2.default,
	  Table: _table2.default,
	  TableBody: _tableBody2.default,
	  TableFooter: _tableFooter2.default,
	  TableHeader: _tableHeader2.default,
	  TableHeaderColumn: _tableHeaderColumn2.default,
	  TableRow: _tableRow2.default,
	  TableRowColumn: _tableRowColumn2.default,
	  Toggle: _toggle2.default,
	  ThemeWrapper: _themeWrapper2.default,
	  TimePicker: _timePicker2.default,
	  TextField: _TextField2.default,
	  Toolbar: _toolbar2.default,
	  ToolbarGroup: _toolbarGroup2.default,
	  ToolbarSeparator: _toolbarSeparator2.default,
	  ToolbarTitle: _toolbarTitle2.default,
	  Tooltip: _tooltip2.default,
	  Utils: _utils2.default
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var List = _react2.default.createClass({
	  displayName: 'List',
	
	  propTypes: {
	    /**
	     * These are usually ListItems that are passed to
	     * be part of the list.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * If true, the subheader will be indented by 72px.
	     */
	    insetSubheader: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The subheader string that will be displayed at the top of the list.
	     */
	    subheader: _react2.default.PropTypes.node,
	
	    /**
	     * The style object to override subheader styles.
	     */
	    subheaderStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The zDepth prop passed to the Paper element inside list.
	     */
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      insetSubheader: false,
	      zDepth: 0
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var insetSubheader = _props.insetSubheader;
	    var style = _props.style;
	    var subheader = _props.subheader;
	    var subheaderStyle = _props.subheaderStyle;
	    var zDepth = _props.zDepth;
	
	    var other = _objectWithoutProperties(_props, ['children', 'insetSubheader', 'style', 'subheader', 'subheaderStyle', 'zDepth']);
	
	    var styles = {
	      root: {
	        padding: 0,
	        paddingBottom: 8,
	        paddingTop: subheader ? 0 : 8
	      },
	
	      subheader: {
	        color: _typography2.default.textLightBlack,
	        fontSize: 14,
	        fontWeight: _typography2.default.fontWeightMedium,
	        lineHeight: '48px',
	        paddingLeft: insetSubheader ? 72 : 16
	      }
	    };
	
	    var subheaderElement = undefined;
	    if (subheader) {
	      var mergedSubheaderStyles = this.mergeStyles(styles.subheader, subheaderStyle);
	      subheaderElement = _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(mergedSubheaderStyles) },
	        subheader
	      );
	    }
	
	    return _react2.default.createElement(
	      _paper2.default,
	      _extends({}, other, {
	        style: this.mergeStyles(styles.root, style),
	        zDepth: zDepth
	      }),
	      subheaderElement,
	      children
	    );
	  }
	});
	
	exports.default = List;
	module.exports = exports['default'];

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _popover = __webpack_require__(58);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _check = __webpack_require__(298);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _listItem = __webpack_require__(143);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _menu = __webpack_require__(57);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	var MenuItem = _react2.default.createClass({
	  displayName: 'MenuItem',
	
	  propTypes: {
	    /**
	     * If true, a left check mark will be rendered.
	     */
	    checked: _react2.default.PropTypes.bool,
	
	    /**
	     * Elements passed as children to inner ListItem.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Indicates if the menu should render with compact desktop styles.
	     */
	    desktop: _react2.default.PropTypes.bool,
	
	    /**
	     * Disables a menu item.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Prop passed down to ListItem that tells it what kind of focus it has.
	     */
	    focusState: _react2.default.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	
	    /**
	     * Style overrides for the inner div.
	     */
	    innerDivStyle: _react2.default.PropTypes.object,
	
	    /**
	     * If true, the children will be indented.
	     * Only needed when there is no leftIcon.
	     */
	    insetChildren: _react2.default.PropTypes.bool,
	
	    /**
	     * This is the SvgIcon or FontIcon to be displayed on the left side.
	     */
	    leftIcon: _react2.default.PropTypes.element,
	
	    /**
	     * Nested MenuItems for this MenuItem. Used to make nested menus.
	     */
	    menuItems: _react2.default.PropTypes.node,
	
	    /**
	     * Fired when the element is touchTapped.
	     */
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * This is the SvgIcon or FontIcon to be displayed on the right side.
	     */
	    rightIcon: _react2.default.PropTypes.element,
	
	    /**
	     * This is the block element that contains the secondary text.
	     * If a string is passed in, a div tag will be rendered.
	     */
	    secondaryText: _react2.default.PropTypes.node,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of the menu item.
	     */
	    value: _react2.default.PropTypes.any
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      checked: false,
	      desktop: false,
	      disabled: false,
	      focusState: 'none',
	      insetChildren: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      open: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._applyFocusState();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (this.state.open && nextProps.focusState === 'none') {
	      this._onRequestClose();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._applyFocusState();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.state.open) {
	      this.setState({
	        open: false
	      });
	    }
	  },
	  _applyFocusState: function _applyFocusState() {
	    this.refs.listItem.applyFocusState(this.props.focusState);
	  },
	  _cloneMenuItem: function _cloneMenuItem(item) {
	    var _this = this;
	
	    return _react2.default.cloneElement(item, {
	      onTouchTap: function onTouchTap(event) {
	        if (!item.props.menuItems) {
	          _this._onRequestClose();
	        }
	
	        if (item.props.onTouchTap) {
	          item.props.onTouchTap(event);
	        }
	      },
	      onRequestClose: this._onRequestClose
	    });
	  },
	  _onTouchTap: function _onTouchTap(event) {
	    event.preventDefault();
	
	    this.setState({
	      open: true,
	      anchorEl: _reactDom2.default.findDOMNode(this)
	    });
	
	    if (this.props.onTouchTap) {
	      this.props.onTouchTap(event);
	    }
	  },
	  _onRequestClose: function _onRequestClose() {
	    this.setState({
	      open: false,
	      anchorEl: null
	    });
	  },
	  render: function render() {
	    var _props = this.props;
	    var checked = _props.checked;
	    var children = _props.children;
	    var desktop = _props.desktop;
	    var disabled = _props.disabled;
	    var focusState = _props.focusState;
	    var innerDivStyle = _props.innerDivStyle;
	    var insetChildren = _props.insetChildren;
	    var leftIcon = _props.leftIcon;
	    var menuItems = _props.menuItems;
	    var rightIcon = _props.rightIcon;
	    var secondaryText = _props.secondaryText;
	    var style = _props.style;
	    var value = _props.value;
	
	    var other = _objectWithoutProperties(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'value']);
	
	    var disabledColor = this.state.muiTheme.rawTheme.palette.disabledColor;
	    var textColor = this.state.muiTheme.rawTheme.palette.textColor;
	    var leftIndent = desktop ? 64 : 72;
	    var sidePadding = desktop ? 24 : 16;
	
	    var styles = {
	      root: {
	        color: disabled ? disabledColor : textColor,
	        lineHeight: desktop ? '32px' : '48px',
	        fontSize: desktop ? 15 : 16,
	        whiteSpace: 'nowrap'
	      },
	
	      innerDivStyle: {
	        paddingLeft: leftIcon || insetChildren || checked ? leftIndent : sidePadding,
	        paddingRight: sidePadding,
	        paddingBottom: 0,
	        paddingTop: 0
	      },
	
	      secondaryText: {
	        float: 'right'
	      },
	
	      leftIconDesktop: {
	        margin: 0,
	        left: 24,
	        top: 4
	      },
	
	      rightIconDesktop: {
	        margin: 0,
	        right: 24,
	        top: 4,
	        fill: _colors2.default.grey600
	      }
	    };
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	    var mergedInnerDivStyles = this.mergeStyles(styles.innerDivStyle, innerDivStyle);
	
	    //Left Icon
	    var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	    if (leftIconElement && desktop) {
	      var mergedLeftIconStyles = this.mergeStyles(styles.leftIconDesktop, leftIconElement.props.style);
	      leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	    }
	
	    //Right Icon
	    var rightIconElement = undefined;
	    if (rightIcon) {
	      var mergedRightIconStyles = desktop ? this.mergeStyles(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	      rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	    }
	
	    //Secondary Text
	    var secondaryTextElement = undefined;
	    if (secondaryText) {
	      var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	      var mergedSecondaryTextStyles = secondaryTextIsAnElement ? this.mergeStyles(styles.secondaryText, secondaryText.props.style) : null;
	
	      secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.secondaryText) },
	        secondaryText
	      );
	    }
	    var childMenuPopover = undefined;
	    if (menuItems) {
	      childMenuPopover = _react2.default.createElement(
	        _popover2.default,
	        {
	          anchorOrigin: { horizontal: 'right', vertical: 'top' },
	          anchorEl: this.state.anchorEl,
	          open: this.state.open,
	          useLayerForClickAway: false,
	          onRequestClose: this._onRequestClose
	        },
	        _react2.default.createElement(
	          _menu2.default,
	          { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	          _react2.default.Children.map(menuItems, this._cloneMenuItem)
	        )
	      );
	      other.onTouchTap = this._onTouchTap;
	    }
	
	    return _react2.default.createElement(
	      _listItem2.default,
	      _extends({}, other, {
	        disabled: disabled,
	        innerDivStyle: mergedInnerDivStyles,
	        insetChildren: insetChildren,
	        leftIcon: leftIconElement,
	        ref: 'listItem',
	        rightIcon: rightIconElement,
	        style: mergedRootStyles
	      }),
	      children,
	      secondaryTextElement,
	      childMenuPopover
	    );
	  }
	});
	
	exports.default = MenuItem;
	module.exports = exports['default'];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Overlay = _react2.default.createClass({
	  displayName: 'Overlay',
	
	  propTypes: {
	    autoLockScrolling: _react2.default.PropTypes.bool,
	    show: _react2.default.PropTypes.bool.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    transitionEnabled: _react2.default.PropTypes.bool
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoLockScrolling: true,
	      transitionEnabled: true,
	      style: {}
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this._applyAutoLockScrolling(this.props);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.show !== nextProps.show) {
	      this._applyAutoLockScrolling(nextProps);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.show === true) {
	      this._allowScrolling();
	    }
	  },
	
	  _originalBodyOverflow: '',
	
	  setOpacity: function setOpacity(opacity) {
	    var overlay = _reactDom2.default.findDOMNode(this);
	    overlay.style.opacity = opacity;
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        position: 'fixed',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: '-100%',
	        opacity: 0,
	        backgroundColor: _colors2.default.lightBlack,
	        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	
	        // Two ways to promote overlay to its own render layer
	        willChange: 'opacity',
	        transform: 'translateZ(0)',
	
	        transition: this.props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ',' + _transitions2.default.easeOut('400ms', 'opacity')
	      },
	      rootWhenShown: {
	        left: '0',
	        opacity: 1,
	        transition: this.props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left') + ',' + _transitions2.default.easeOut('400ms', 'opacity')
	      }
	    };
	  },
	  _applyAutoLockScrolling: function _applyAutoLockScrolling(props) {
	    if (props.autoLockScrolling) {
	      if (props.show) {
	        this._preventScrolling();
	      } else {
	        this._allowScrolling();
	      }
	    }
	  },
	  _preventScrolling: function _preventScrolling() {
	    var body = document.getElementsByTagName('body')[0];
	    this._originalBodyOverflow = body.style.overflow;
	
	    body.style.overflow = 'hidden';
	  },
	  _allowScrolling: function _allowScrolling() {
	    var body = document.getElementsByTagName('body')[0];
	    body.style.overflow = this._originalBodyOverflow || '';
	  },
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['show', 'style']);
	
	    var styles = this.mergeStyles(this.getStyles().root, style, show && this.getStyles().rootWhenShown);
	
	    return _react2.default.createElement('div', _extends({}, other, { style: this.prepareStyles(styles) }));
	  }
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _reactAddonsTransitionGroup = __webpack_require__(74);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _dom = __webpack_require__(72);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _circleRipple = __webpack_require__(148);
	
	var _circleRipple2 = _interopRequireDefault(_circleRipple);
	
	var _reactAddonsUpdate = __webpack_require__(75);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function push(array, obj) {
	  var newObj = Array.isArray(obj) ? obj : [obj];
	  return (0, _reactAddonsUpdate2.default)(array, { $push: newObj });
	}
	
	function shift(array) {
	  return (0, _reactAddonsUpdate2.default)(array, { $splice: [[0, 1]] });
	}
	
	var TouchRipple = _react2.default.createClass({
	  displayName: 'TouchRipple',
	
	  propTypes: {
	    centerRipple: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.node,
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * The material-ui theme applied to this component.
	     */
	    muiTheme: _react2.default.PropTypes.object.isRequired,
	
	    opacity: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    //Touch start produces a mouse down event for compat reasons. To avoid
	    //showing ripples twice we skip showing a ripple for the first mouse down
	    //after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    //to avoid re-rendering when we change it
	    this._ignoreNextMouseDown = false;
	
	    return {
	      //This prop allows us to only render the ReactTransitionGroup
	      //on the first click of the component, making the inital
	      //render faster
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	  },
	  start: function start(e, isRippleTouchGenerated) {
	    if (this._ignoreNextMouseDown && !isRippleTouchGenerated) {
	      this._ignoreNextMouseDown = false;
	      return;
	    }
	
	    var ripples = this.state.ripples;
	
	    //Add a ripple to the ripples array
	    ripples = push(ripples, _react2.default.createElement(_circleRipple2.default, {
	      key: this.state.nextKey,
	      muiTheme: this.props.muiTheme,
	      style: !this.props.centerRipple ? this._getRippleStyle(e) : {},
	      color: this.props.color,
	      opacity: this.props.opacity,
	      touchGenerated: isRippleTouchGenerated
	    }));
	
	    this._ignoreNextMouseDown = isRippleTouchGenerated;
	    this.setState({
	      hasRipples: true,
	      nextKey: this.state.nextKey + 1,
	      ripples: ripples
	    });
	  },
	  end: function end() {
	    var currentRipples = this.state.ripples;
	    this.setState({
	      ripples: shift(currentRipples)
	    });
	  },
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) this.start(e, false);
	  },
	  _handleMouseUp: function _handleMouseUp() {
	    this.end();
	  },
	  _handleMouseLeave: function _handleMouseLeave() {
	    this.end();
	  },
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.start(e, true);
	  },
	  _handleTouchEnd: function _handleTouchEnd() {
	    this.end();
	  },
	  _getRippleStyle: function _getRippleStyle(e) {
	    var style = {};
	    var el = _reactDom2.default.findDOMNode(this);
	    var elHeight = el.offsetHeight;
	    var elWidth = el.offsetWidth;
	    var offset = _dom2.default.offset(el);
	    var isTouchEvent = e.touches && e.touches.length;
	    var pageX = isTouchEvent ? e.touches[0].pageX : e.pageX;
	    var pageY = isTouchEvent ? e.touches[0].pageY : e.pageY;
	    var pointerX = pageX - offset.left;
	    var pointerY = pageY - offset.top;
	    var topLeftDiag = this._calcDiag(pointerX, pointerY);
	    var topRightDiag = this._calcDiag(elWidth - pointerX, pointerY);
	    var botRightDiag = this._calcDiag(elWidth - pointerX, elHeight - pointerY);
	    var botLeftDiag = this._calcDiag(pointerX, elHeight - pointerY);
	    var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	    var rippleSize = rippleRadius * 2;
	    var left = pointerX - rippleRadius;
	    var top = pointerY - rippleRadius;
	
	    style.height = rippleSize + 'px';
	    style.width = rippleSize + 'px';
	    style.top = top + 'px';
	    style.left = left + 'px';
	
	    return style;
	  },
	  _calcDiag: function _calcDiag(a, b) {
	    return Math.sqrt(a * a + b * b);
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var style = _props.style;
	    var _state = this.state;
	    var hasRipples = _state.hasRipples;
	    var ripples = _state.ripples;
	
	    var rippleGroup = undefined;
	    if (hasRipples) {
	      var mergedStyles = this.mergeStyles({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        overflow: 'hidden'
	      }, style);
	
	      rippleGroup = _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        { style: this.prepareStyles(mergedStyles) },
	        ripples
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        onMouseUp: this._handleMouseUp,
	        onMouseDown: this._handleMouseDown,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchStart: this._handleTouchStart,
	        onTouchEnd: this._handleTouchEnd
	      },
	      rippleGroup,
	      children
	    );
	  }
	});
	
	exports.default = TouchRipple;
	module.exports = exports['default'];

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _spacing = __webpack_require__(101);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors2.default.cyan500,
	    primary2Color: _colors2.default.cyan700,
	    primary3Color: _colors2.default.grey400,
	    accent1Color: _colors2.default.pinkA200,
	    accent2Color: _colors2.default.grey100,
	    accent3Color: _colors2.default.grey500,
	    textColor: _colors2.default.darkBlack,
	    alternateTextColor: _colors2.default.white,
	    canvasColor: _colors2.default.white,
	    borderColor: _colors2.default.grey300,
	    disabledColor: _colorManipulator2.default.fade(_colors2.default.darkBlack, 0.3),
	    pickerHeaderColor: _colors2.default.cyan500,
	    clockCircleColor: _colorManipulator2.default.fade(_colors2.default.darkBlack, 0.07),
	    shadowColor: _colors2.default.fullBlack
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 101 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopLeftNavMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};
	module.exports = exports['default'];

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TableRowColumn = _react2.default.createClass({
	  displayName: 'TableRowColumn',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Number to identify the header row. This property
	     * is automatically populated when used with TableHeader.
	     */
	    columnNumber: _react2.default.PropTypes.number,
	
	    /**
	     * If true, this column responds to hover events.
	     */
	    hoverable: _react2.default.PropTypes.bool,
	
	    /**
	     * Key for this element.
	     */
	    key: _react2.default.PropTypes.string,
	
	    /**
	     * Callback function for click event.
	     */
	    onClick: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for hover event.
	     */
	    onHover: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for hover exit event.
	     */
	    onHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hoverable: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      hovered: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.tableRowColumn;
	  },
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var styles = {
	      root: {
	        paddingLeft: theme.spacing,
	        paddingRight: theme.spacing,
	        height: theme.height,
	        textAlign: 'left',
	        fontSize: 13,
	        overflow: 'hidden',
	        whiteSpace: 'nowrap',
	        textOverflow: 'ellipsis'
	      }
	    };
	
	    if (_react2.default.Children.count(this.props.children) === 1 && !isNaN(this.props.children)) {
	      styles.textAlign = 'right';
	    }
	
	    return styles;
	  },
	  _onClick: function _onClick(e) {
	    if (this.props.onClick) this.props.onClick(e, this.props.columnNumber);
	  },
	  _onMouseEnter: function _onMouseEnter(e) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: true });
	      if (this.props.onHover) this.props.onHover(e, this.props.columnNumber);
	    }
	  },
	  _onMouseLeave: function _onMouseLeave(e) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: false });
	      if (this.props.onHoverExit) this.props.onHoverExit(e, this.props.columnNumber);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var columnNumber = _props.columnNumber;
	    var hoverable = _props.hoverable;
	    var onClick = _props.onClick;
	    var onHover = _props.onHover;
	    var onHoverExit = _props.onHoverExit;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	
	    var styles = this.getStyles();
	    var handlers = {
	      onClick: this._onClick,
	      onMouseEnter: this._onMouseEnter,
	      onMouseLeave: this._onMouseLeave
	    };
	
	    return _react2.default.createElement(
	      'td',
	      _extends({
	        key: this.props.key,
	        className: className,
	        style: this.prepareStyles(styles.root, style)
	      }, handlers, other),
	      this.props.children
	    );
	  }
	});
	
	exports.default = TableRowColumn;
	module.exports = exports['default'];

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tooltip = _react2.default.createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	    horizontalPosition: _react2.default.PropTypes.oneOf(['left', 'right', 'center']),
	    label: _react2.default.PropTypes.node.isRequired,
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    touch: _react2.default.PropTypes.bool,
	    verticalPosition: _react2.default.PropTypes.oneOf(['top', 'bottom'])
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      offsetWidth: null,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._setRippleSize();
	    this._setTooltipPosition();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    this._setTooltipPosition();
	
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._setRippleSize();
	  },
	  getStyles: function getStyles() {
	    var verticalPosition = this.props.verticalPosition;
	    var horizontalPosition = this.props.horizontalPosition;
	    var touchMarginOffset = this.props.touch ? 10 : 0;
	    var touchOffsetTop = this.props.touch ? -20 : -10;
	    var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	    var muiTheme = this.state.muiTheme;
	    var rawTheme = muiTheme.rawTheme;
	
	    var styles = {
	      root: {
	        position: 'absolute',
	        fontFamily: rawTheme.fontFamily,
	        fontSize: '10px',
	        lineHeight: '22px',
	        padding: '0 8px',
	        zIndex: muiTheme.zIndex.tooltip,
	        color: _colors2.default.white,
	        overflow: 'hidden',
	        top: -10000,
	        borderRadius: 2,
	        userSelect: 'none',
	        opacity: 0,
	        right: horizontalPosition === 'left' ? 12 : null,
	        left: horizontalPosition === 'center' ? (this.state.offsetWidth - 48) / 2 * -1 : null,
	        transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ',' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ',' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	      },
	      label: {
	        position: 'relative',
	        whiteSpace: 'nowrap'
	      },
	      ripple: {
	        position: 'absolute',
	        left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	        top: verticalPosition === 'bottom' ? 0 : '100%',
	        transform: 'translate(-50%, -50%)',
	        borderRadius: '50%',
	        backgroundColor: 'transparent',
	        transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ',' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ',' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	      },
	      rootWhenShown: {
	        top: verticalPosition === 'top' ? touchOffsetTop : 36,
	        opacity: 0.9,
	        transform: 'translate3d(0px, ' + offset + 'px, 0px)',
	        transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ',' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ',' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	      },
	      rootWhenTouched: {
	        fontSize: '14px',
	        lineHeight: '32px',
	        padding: '0 16px'
	      },
	      rippleWhenShown: {
	        backgroundColor: _colors2.default.grey700,
	        transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ',' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ',' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	      }
	    };
	
	    return styles;
	  },
	  _setRippleSize: function _setRippleSize() {
	    var ripple = _reactDom2.default.findDOMNode(this.refs.ripple);
	    var tooltip = window.getComputedStyle(_reactDom2.default.findDOMNode(this));
	    var tooltipWidth = parseInt(tooltip.getPropertyValue('width'), 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	    var tooltipHeight = parseInt(tooltip.getPropertyValue('height'), 10);
	
	    var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	    if (this.props.show) {
	      ripple.style.height = rippleDiameter + 'px';
	      ripple.style.width = rippleDiameter + 'px';
	    } else {
	      ripple.style.width = '0px';
	      ripple.style.height = '0px';
	    }
	  },
	  _setTooltipPosition: function _setTooltipPosition() {
	    var tooltip = _reactDom2.default.findDOMNode(this);
	    this.setState({ offsetWidth: tooltip.offsetWidth });
	  },
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	
	    var other = _objectWithoutProperties(_props, ['label']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, {
	        style: this.prepareStyles(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style)
	      }),
	      _react2.default.createElement('div', {
	        ref: 'ripple',
	        style: this.prepareStyles(styles.ripple, this.props.show && styles.rippleWhenShown)
	      }),
	      _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.label) },
	        label
	      )
	    );
	  }
	});
	
	exports.default = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(74);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _slideInChild = __webpack_require__(323);
	
	var _slideInChild2 = _interopRequireDefault(_slideInChild);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SlideIn = _react2.default.createClass({
	  displayName: 'SlideIn',
	
	  propTypes: {
	    childStyle: _react2.default.PropTypes.object,
	    children: _react2.default.PropTypes.node,
	    direction: _react2.default.PropTypes.oneOf(['left', 'right', 'up', 'down']),
	    enterDelay: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0,
	      direction: 'left'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  _getLeaveDirection: function _getLeaveDirection() {
	    return this.props.direction;
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var enterDelay = _props.enterDelay;
	    var children = _props.children;
	    var childStyle = _props.childStyle;
	    var direction = _props.direction;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	
	    var mergedRootStyles = this.mergeStyles({
	      position: 'relative',
	      overflow: 'hidden',
	      height: '100%'
	    }, style);
	
	    var newChildren = _react2.default.Children.map(children, function (child) {
	      return _react2.default.createElement(
	        _slideInChild2.default,
	        {
	          key: child.key,
	          direction: direction,
	          enterDelay: enterDelay,
	          getLeaveDirection: _this._getLeaveDirection,
	          style: childStyle
	        },
	        child
	      );
	    }, this);
	
	    return _react2.default.createElement(
	      _reactAddonsTransitionGroup2.default,
	      _extends({}, other, {
	        style: this.prepareStyles(mergedRootStyles),
	        component: 'div'
	      }),
	      newChildren
	    );
	  }
	});
	
	exports.default = SlideIn;
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var index = 0;
	
	exports.default = {
	  generate: function generate() {
	    return 'mui-id-' + index++;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(36);
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	var ReactPerf = __webpack_require__(20);
	
	var quoteAttributeValueForBrowser = __webpack_require__(426);
	var warning = __webpack_require__(8);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(188);
	var ReactPropTypeLocations = __webpack_require__(78);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(36);
	var ReactElement = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(18);
	var traverseAllChildren = __webpack_require__(125);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(113);
	var ReactMount = __webpack_require__(15);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(168);
	var DOMPropertyOperations = __webpack_require__(108);
	var ReactMount = __webpack_require__(15);
	var ReactPerf = __webpack_require__(20);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactElement = __webpack_require__(14);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactUpdates = __webpack_require__(21);
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.7';

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactMount = __webpack_require__(15);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(385);
	var ReactEmptyComponent = __webpack_require__(180);
	var ReactNativeComponent = __webpack_require__(186);
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	var escapeTextContentForBrowser = __webpack_require__(82);
	var setInnerHTML = __webpack_require__(83);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactElement = __webpack_require__(14);
	var ReactInstanceHandles = __webpack_require__(51);
	
	var getIteratorFn = __webpack_require__(120);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(7);
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(8);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var styles = {
	  base: {
	    display: 'inline-block',
	    marginLeft: 0,
	    marginTop: 8,
	    marginRight: 5,
	    'float': 'left',
	    transition: '150ms',
	    WebkitTransition: '150ms',
	    MozTransition: '150ms',
	    borderLeft: '5px solid transparent',
	    borderRight: '5px solid transparent',
	    borderTopWidth: 5,
	    borderTopStyle: 'solid',
	    WebkitTransform: 'rotateZ(-90deg)',
	    MozTransform: 'rotateZ(-90deg)',
	    transform: 'rotateZ(-90deg)'
	  },
	  open: {
	    WebkitTransform: 'rotateZ(0deg)',
	    MozTransform: 'rotateZ(0deg)',
	    transform: 'rotateZ(0deg)'
	  }
	};
	
	var JSONArrow = (function (_React$Component) {
	  _inherits(JSONArrow, _React$Component);
	
	  function JSONArrow() {
	    _classCallCheck(this, JSONArrow);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  JSONArrow.prototype.render = function render() {
	    var style = _extends({}, styles.base, {
	      borderTopColor: this.props.theme.base0D
	    });
	    if (this.props.open) {
	      style = _extends({}, style, styles.open);
	    }
	    return _react2['default'].createElement('div', { style: style, onClick: this.props.onClick });
	  };
	
	  return JSONArrow;
	})(_react2['default'].Component);
	
	exports['default'] = JSONArrow;
	module.exports = exports['default'];

/***/ },
/* 129 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 131 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(39)
	  , createDesc = __webpack_require__(209);
	module.exports = __webpack_require__(524) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 133 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.setRoute = setRoute;
	
	var _constantsActionConstants = __webpack_require__(46);
	
	function setRoute(route) {
	  console.log('setting route', route);
	  return {
	    type: _constantsActionConstants.CHANGE_ROUTE_ACTION,
	    route: route
	  };
	}

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(41);
	
	var _actionsSpiralActions = __webpack_require__(88);
	
	var SpiralActions = _interopRequireWildcard(_actionsSpiralActions);
	
	var _p5 = __webpack_require__(361);
	
	var _p52 = _interopRequireDefault(_p5);
	
	var data = [];
	
	function P5Spiral(p5) {
	  var timeOffset = 0;
	  var targetTimeOffset = 0;
	  var timeFactor = 60000 * 60;
	  var memory = 5;
	  var hw = undefined,
	      hh = undefined,
	      r = undefined;
	  p5.setup = function () {
	    var dim = p5.min(p5.windowWidth, p5.windowHeight);
	    p5.createCanvas(dim, dim);
	    p5.randomSeed(0);
	    hw = p5.width / 2;
	    hh = p5.height / 2;
	    r = p5.min(hw, hh);
	  };
	
	  var getDatum = function getDatum(time) {
	    for (var i = data.length - 1; i >= 0; i--) {
	      if (data[i].time / timeFactor <= time) {
	        return data[i];
	      }
	    }
	    return null;
	  };
	
	  p5.mousePressed = function () {
	    var dx = hw - p5.mouseX;
	    var dy = hh - p5.mouseY;
	    var dist = p5.min(r, p5.sqrt(dx * dx + dy * dy)) + r / memory / 2;
	    targetTimeOffset = p5.min(0, targetTimeOffset + dist / r * memory - memory / 2);
	  };
	  p5.draw = function () {
	    var speed = 1 / 1.0;
	    var curTime = speed * (new Date().getTime() / timeFactor);
	    // timeOffset += (-(memory * p5.mouseY) / p5.height - timeOffset) * 0.1;
	    timeOffset += (targetTimeOffset - timeOffset) * 0.1;
	    curTime = curTime + timeOffset + 1 / 10 / memory;
	    p5.background(255);
	    var n = memory * 24 * 4; // one cell for every 1/4 hour
	    var startAngle = curTime;
	    var px = r * p5.cos(startAngle);
	    var py = r * p5.sin(startAngle);
	    for (var i = 0; i < n; i++) {
	      var p = 1 - i / n;
	      var angle = p * memory * 2 * p5.PI;
	      var x = r * p * p5.cos(startAngle + angle);
	      var y = r * p * p5.sin(startAngle + angle);
	      var datum = getDatum(curTime - (1 - p) * memory);
	      p5.noStroke();
	      if (datum != null) {
	        p5.fill(datum.color[0], datum.color[1], datum.color[2]);
	        //p5.stroke(datum.color[0], datum.color[1], datum.color[2]);
	      } else {
	          p5.fill(255);
	          //p5.stroke(255);
	        }
	      p5.strokeWeight(1);
	      p5.triangle(hw + px, hh + py, hw + x, hh + y, hw, hh);
	      p5.stroke(255);
	      p5.strokeWeight(2);
	      p5.line(hw + px, hh + py, hw + x, hh + y);
	      px = x;
	      py = y;
	    }
	  };
	};
	
	var instance = null;
	
	var Spiral = (function (_Component) {
	  _inherits(Spiral, _Component);
	
	  function Spiral(props) {
	    _classCallCheck(this, Spiral);
	
	    _get(Object.getPrototypeOf(Spiral.prototype), 'constructor', this).call(this, props);
	    this.state = null;
	  }
	
	  _createClass(Spiral, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log('didmount');
	      if (!this.state) {
	        this.state = new _p52['default'](P5Spiral, 'spiral_container');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      data = this.props.data;
	      return _react2['default'].createElement('div', { id: 'spiral_container' });
	    }
	  }]);
	
	  return Spiral;
	})(_react.Component);
	
	exports['default'] = Spiral;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _color = __webpack_require__(227);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialUi = __webpack_require__(95);
	
	var _materialUi2 = _interopRequireDefault(_materialUi);
	
	var FlatButton = _materialUi2['default'].FlatButton;
	var RaisedButton = _materialUi2['default'].RaisedButton;
	
	var Tag = (function (_Component) {
	  _inherits(Tag, _Component);
	
	  function Tag() {
	    _classCallCheck(this, Tag);
	
	    _get(Object.getPrototypeOf(Tag.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Tag, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var tag = _props.tag;
	      var selected = _props.selected;
	      var onChange = _props.onChange;
	
	      var button = undefined;
	      var c = (0, _color2['default'])({ r: tag.color[0], g: tag.color[1], b: tag.color[2] }).hexString();
	      var style = { margin: 5 };
	      if (selected) {
	        button = _react2['default'].createElement(RaisedButton, { style: style, label: tag.label, primary: true, onClick: onChange, backgroundColor: c });
	      } else {
	        button = _react2['default'].createElement(FlatButton, { style: style, label: tag.label, primary: true, onClick: onChange, style: { color: c } });
	      }
	      return button;
	    }
	  }]);
	
	  return Tag;
	})(_react.Component);
	
	exports['default'] = Tag;
	module.exports = exports['default'];

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DropDownMenu = __webpack_require__(232);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DropDownMenu2.default;
	module.exports = exports['default'];

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextField = __webpack_require__(235);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Avatar = _react2.default.createClass({
	  displayName: 'Avatar',
	
	  propTypes: {
	    /**
	     * The backgroundColor of the avatar. Does not apply to image avatars.
	     */
	    backgroundColor: _react2.default.PropTypes.string,
	
	    /**
	     * Can be used, for instance, to render a letter inside the avatar.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root `div` or `img` element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * The icon or letter's color.
	     */
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * This is the SvgIcon or FontIcon to be used inside the avatar.
	     */
	    icon: _react2.default.PropTypes.element,
	
	    /**
	     * This is the size of the avatar in pixels.
	     */
	    size: _react2.default.PropTypes.number,
	
	    /**
	     * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	     */
	    src: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      backgroundColor: _colors2.default.grey400,
	      color: _colors2.default.white,
	      size: 40
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _props = this.props;
	    var backgroundColor = _props.backgroundColor;
	    var color = _props.color;
	    var icon = _props.icon;
	    var size = _props.size;
	    var src = _props.src;
	    var style = _props.style;
	    var className = _props.className;
	
	    var other = _objectWithoutProperties(_props, ['backgroundColor', 'color', 'icon', 'size', 'src', 'style', 'className']);
	
	    var styles = {
	      root: {
	        height: size,
	        width: size,
	        userSelect: 'none',
	        borderRadius: '50%',
	        display: 'inline-block'
	      }
	    };
	
	    if (src) {
	      var borderColor = this.state.muiTheme.avatar.borderColor;
	
	      if (borderColor) {
	        styles.root = this.mergeStyles(styles.root, {
	          height: size - 2,
	          width: size - 2,
	          border: 'solid 1px ' + borderColor
	        });
	      }
	
	      return _react2.default.createElement('img', _extends({}, other, {
	        src: src,
	        style: this.prepareStyles(styles.root, style),
	        className: className
	      }));
	    } else {
	      styles.root = this.mergeStyles(styles.root, {
	        backgroundColor: backgroundColor,
	        textAlign: 'center',
	        lineHeight: size + 'px',
	        fontSize: size / 2 + 4,
	        color: color
	      });
	
	      var styleIcon = {
	        margin: 8
	      };
	
	      var iconElement = icon ? _react2.default.cloneElement(icon, {
	        color: color,
	        style: this.mergeStyles(styleIcon, icon.props.style)
	      }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, {
	          style: this.prepareStyles(styles.root, style),
	          className: className
	        }),
	        iconElement,
	        this.props.children
	      );
	    }
	  }
	});
	
	exports.default = Avatar;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var BeforeAfterWrapper = _react2.default.createClass({
	  displayName: 'BeforeAfterWrapper',
	
	  propTypes: {
	    afterElementType: _react2.default.PropTypes.string,
	    afterStyle: _react2.default.PropTypes.object,
	    beforeElementType: _react2.default.PropTypes.string,
	    beforeStyle: _react2.default.PropTypes.object,
	    children: _react2.default.PropTypes.node,
	    elementType: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      beforeElementType: 'div',
	      afterElementType: 'div',
	      elementType: 'div'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _props = this.props;
	    var beforeStyle = _props.beforeStyle;
	    var afterStyle = _props.afterStyle;
	    var beforeElementType = _props.beforeElementType;
	    var afterElementType = _props.afterElementType;
	    var elementType = _props.elementType;
	
	    var other = _objectWithoutProperties(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	
	    var beforeElement = undefined;
	    var afterElement = undefined;
	
	    beforeStyle = {
	      boxSizing: 'border-box'
	    };
	
	    afterStyle = {
	      boxSizing: 'border-box'
	    };
	
	    if (this.props.beforeStyle) beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	      style: this.prepareStyles(beforeStyle, this.props.beforeStyle),
	      key: '::before'
	    });
	    if (this.props.afterStyle) afterElement = _react2.default.createElement(this.props.afterElementType, {
	      style: this.prepareStyles(afterStyle, this.props.afterStyle),
	      key: '::after'
	    });
	
	    var children = [beforeElement, this.props.children, afterElement];
	
	    var props = other;
	    props.style = this.prepareStyles(this.props.style);
	
	    return _react2.default.createElement(this.props.elementType, props, children);
	  }
	});
	
	exports.default = BeforeAfterWrapper;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keyboardArrowUp = __webpack_require__(296);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(295);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _iconButton = __webpack_require__(56);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardExpandable = _react2.default.createClass({
	  displayName: 'CardExpandable',
	
	  propTypes: {
	    expanded: _react2.default.PropTypes.bool,
	    onExpanding: _react2.default.PropTypes.func.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _contextPure2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      return {
	        isRtl: muiTheme.isRtl
	      };
	    },
	    getChildrenClasses: function getChildrenClasses() {
	      return [_iconButton2.default];
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    var contextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var directionStyle = contextKeys.isRtl ? {
	      left: 4
	    } : {
	      right: 4
	    };
	
	    return {
	      root: this.mergeStyles({
	        top: 0,
	        bottom: 0,
	        margin: 'auto',
	        position: 'absolute'
	      }, directionStyle)
	    };
	  },
	  render: function render() {
	    var styles = this.getStyles();
	
	    var expandable = undefined;
	    if (this.props.expanded === true) expandable = _react2.default.createElement(_keyboardArrowUp2.default, null);else expandable = _react2.default.createElement(_keyboardArrowDown2.default, null);
	
	    var mergedStyles = this.mergeStyles(styles.root, this.props.style);
	
	    var expandableBtn = _react2.default.createElement(
	      _iconButton2.default,
	      {
	        style: mergedStyles,
	        onTouchTap: this.props.onExpanding
	      },
	      expandable
	    );
	
	    return expandableBtn;
	  }
	});
	
	exports.default = CardExpandable;
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _calendar = __webpack_require__(254);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _dialog = __webpack_require__(92);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _datePickerInline = __webpack_require__(256);
	
	var _datePickerInline2 = _interopRequireDefault(_datePickerInline);
	
	var _flatButton = __webpack_require__(54);
	
	var _flatButton2 = _interopRequireDefault(_flatButton);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _dateTime = __webpack_require__(49);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DatePickerDialog = _react2.default.createClass({
	  displayName: 'DatePickerDialog',
	
	  propTypes: {
	    DateTimeFormat: _react2.default.PropTypes.func,
	    autoOk: _react2.default.PropTypes.bool,
	    container: _react2.default.PropTypes.oneOf(['dialog', 'inline']),
	    disableYearSelection: _react2.default.PropTypes.bool,
	    firstDayOfWeek: _react2.default.PropTypes.number,
	    initialDate: _react2.default.PropTypes.object,
	    locale: _react2.default.PropTypes.string,
	    maxDate: _react2.default.PropTypes.object,
	    minDate: _react2.default.PropTypes.object,
	    mode: _react2.default.PropTypes.oneOf(['portrait', 'landscape']),
	    onAccept: _react2.default.PropTypes.func,
	    onDismiss: _react2.default.PropTypes.func,
	    onShow: _react2.default.PropTypes.func,
	    shouldDisableDate: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    wordings: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default, _contextPure2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      return {
	        calendarTextColor: muiTheme.datePicker.calendarTextColor
	      };
	    },
	    getChildrenClasses: function getChildrenClasses() {
	      return [_calendar2.default, _dialog2.default];
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      DateTimeFormat: _dateTime2.default.DateTimeFormat,
	      container: 'dialog',
	      locale: 'en-US',
	      wordings: {
	        ok: 'OK',
	        cancel: 'Cancel'
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp'
	  },
	
	  show: function show() {
	    if (this.props.onShow && !this.state.open) this.props.onShow();
	    this.setState({
	      open: true
	    });
	  },
	  dismiss: function dismiss() {
	    if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	    this.setState({
	      open: false
	    });
	  },
	  _onDayTouchTap: function _onDayTouchTap() {
	    if (this.props.autoOk) {
	      setTimeout(this._handleOKTouchTap, 300);
	    }
	  },
	  _handleCancelTouchTap: function _handleCancelTouchTap() {
	    this.dismiss();
	  },
	  _handleOKTouchTap: function _handleOKTouchTap() {
	    if (this.props.onAccept && !this.refs.calendar.isSelectedDateDisabled()) {
	      this.props.onAccept(this.refs.calendar.getSelectedDate());
	    }
	
	    this.dismiss();
	  },
	  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
	    if (this.state.open) {
	      switch (e.keyCode) {
	        case _keyCode2.default.ENTER:
	          this._handleOKTouchTap();
	          break;
	      }
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var DateTimeFormat = _props.DateTimeFormat;
	    var locale = _props.locale;
	    var wordings = _props.wordings;
	    var initialDate = _props.initialDate;
	    var onAccept = _props.onAccept;
	    var style = _props.style;
	    var container = _props.container;
	    var firstDayOfWeek = _props.firstDayOfWeek;
	
	    var other = _objectWithoutProperties(_props, ['DateTimeFormat', 'locale', 'wordings', 'initialDate', 'onAccept', 'style', 'container', 'firstDayOfWeek']);
	
	    var _constructor$getRelev = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var calendarTextColor = _constructor$getRelev.calendarTextColor;
	
	    var styles = {
	      root: {
	        fontSize: 14,
	        color: calendarTextColor
	      },
	
	      dialogContent: {
	        width: this.props.mode === 'landscape' ? 480 : 320
	      },
	
	      dialogBodyContent: {
	        padding: 0
	      },
	
	      actions: {
	        marginRight: 8
	      }
	    };
	
	    var actions = [_react2.default.createElement(_flatButton2.default, {
	      key: 0,
	      label: wordings.cancel,
	      secondary: true,
	      style: styles.actions,
	      onTouchTap: this._handleCancelTouchTap
	    })];
	
	    if (!this.props.autoOk) {
	      actions.push(_react2.default.createElement(_flatButton2.default, {
	        key: 1,
	        label: wordings.ok,
	        secondary: true,
	        disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	        style: styles.actions,
	        onTouchTap: this._handleOKTouchTap
	      }));
	    }
	
	    // will change later when Popover is available.
	    var Container = container === 'inline' ? _datePickerInline2.default : _dialog2.default;
	    return _react2.default.createElement(
	      Container,
	      _extends({}, other, {
	        ref: 'dialog',
	        style: styles.root,
	        contentStyle: styles.dialogContent,
	        bodyStyle: styles.dialogBodyContent,
	        actions: actions,
	        repositionOnUpdate: false,
	        open: this.state.open,
	        onRequestClose: this.dismiss
	      }),
	      _react2.default.createElement(_calendar2.default, {
	        DateTimeFormat: DateTimeFormat,
	        firstDayOfWeek: firstDayOfWeek,
	        locale: locale,
	        ref: 'calendar',
	        onDayTouchTap: this._onDayTouchTap,
	        initialDate: this.props.initialDate,
	        open: this.state.open,
	        minDate: this.props.minDate,
	        maxDate: this.props.maxDate,
	        shouldDisableDate: this.props.shouldDisableDate,
	        disableYearSelection: this.props.disableYearSelection,
	        mode: this.props.mode
	      })
	    );
	  }
	});
	
	exports.default = DatePickerDialog;
	module.exports = exports['default'];

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _iconButton = __webpack_require__(56);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	var _arrowDropUp = __webpack_require__(297);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _arrowDropDown = __webpack_require__(151);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _nestedList = __webpack_require__(271);
	
	var _nestedList2 = _interopRequireDefault(_nestedList);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ListItem = _react2.default.createClass({
	  displayName: 'ListItem',
	
	  propTypes: {
	    /**
	     * Generate a nested list indicator icon when
	     * nested list items are detected. Set to false
	     * if you do not want an indicator auto-generated.
	     * Note that an indicator will not be created if a
	     * rightIcon/Button has been specified.
	     */
	    autoGenerateNestedIndicator: _react2.default.PropTypes.bool,
	
	    /**
	     * Children passed into the ListItem.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Does not allow the element to be focused by the keyboard.
	     */
	    disableKeyboardFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the list-item will not be clickable
	     * and will not display hover affects.
	     * This is automatically disabled if leftCheckbox
	     * or rightToggle is set.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Controls whether or not the child ListItems are initially displayed.
	     */
	    initiallyOpen: _react2.default.PropTypes.bool,
	
	    /**
	     * Style prop for the innder div element.
	     */
	    innerDivStyle: _react2.default.PropTypes.object,
	
	    /**
	     * If true, the children will be indented by 72px.
	     * Only needed if there is no left avatar or left icon.
	     */
	    insetChildren: _react2.default.PropTypes.bool,
	
	    /**
	     * This is the Avatar element to be displayed on the left side.
	     */
	    leftAvatar: _react2.default.PropTypes.element,
	
	    /**
	     * This is the Checkbox element to be displayed on the left side.
	     */
	    leftCheckbox: _react2.default.PropTypes.element,
	
	    /**
	     * This is the SvgIcon or FontIcon to be displayed on the left side.
	     */
	    leftIcon: _react2.default.PropTypes.element,
	
	    /**
	     * An array of ListItems to nest underneath the current ListItem.
	     */
	    nestedItems: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element),
	
	    /**
	     * Controls how deep a ListItem appears.
	     * This property is automatically managed so modify at your own risk.
	     */
	    nestedLevel: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the nestedItems NestedList.
	     */
	    nestedListStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Called when the ListItem has keyboard focus.
	     */
	    onKeyboardFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Called when the mouse is over the ListItem.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Called when the mouse is no longer over the ListItem.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Called when the ListItem toggles its nested ListItems.
	     */
	    onNestedListToggle: _react2.default.PropTypes.func,
	
	    /**
	     * Called when touches start.
	     */
	    onTouchStart: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a touch tap event occures on the component.
	     */
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * This is the block element that contains the primary text.
	     * If a string is passed in, a div tag will be rendered.
	     */
	    primaryText: _react2.default.PropTypes.node,
	
	    /**
	     * If provided, tapping on the primary text
	     * of the item toggles the nested list.
	     */
	    primaryTogglesNestedList: _react2.default.PropTypes.bool,
	
	    /**
	     * This is the avatar element to be displayed on the right side.
	     */
	    rightAvatar: _react2.default.PropTypes.element,
	
	    /**
	     * This is the SvgIcon or FontIcon to be displayed on the right side.
	     */
	    rightIcon: _react2.default.PropTypes.element,
	
	    /**
	     * This is the IconButton to be displayed on the right side.
	     * Hovering over this button will remove the ListItem hover.
	     * Also, clicking on this button will not trigger a
	     * ListItem ripple. The event will be stopped and prevented
	     * from bubbling up to cause a ListItem click.
	     */
	    rightIconButton: _react2.default.PropTypes.element,
	
	    /**
	     * This is the Toggle element to display on the right side.
	     */
	    rightToggle: _react2.default.PropTypes.element,
	
	    /**
	     * This is the block element that contains the secondary text.
	     * If a string is passed in, a div tag will be rendered.
	     */
	    secondaryText: _react2.default.PropTypes.node,
	
	    /**
	     * Can be 1 or 2. This is the number of secondary
	     * text lines before ellipsis will show.
	     */
	    secondaryTextLines: _react2.default.PropTypes.oneOf([1, 2]),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoGenerateNestedIndicator: true,
	      disableKeyboardFocus: false,
	      disabled: false,
	      initiallyOpen: false,
	      insetChildren: false,
	      nestedItems: [],
	      nestedLevel: 0,
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {},
	      onNestedListToggle: function onNestedListToggle() {},
	      onTouchStart: function onTouchStart() {},
	      primaryTogglesNestedList: false,
	      secondaryTextLines: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: this.props.initiallyOpen,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  applyFocusState: function applyFocusState(focusState) {
	    var button = this.refs.enhancedButton;
	    var buttonEl = _reactDom2.default.findDOMNode(button);
	
	    if (button) {
	      switch (focusState) {
	        case 'none':
	          buttonEl.blur();
	          break;
	        case 'focused':
	          buttonEl.focus();
	          break;
	        case 'keyboard-focused':
	          button.setKeyboardFocus();
	          buttonEl.focus();
	          break;
	      }
	    }
	  },
	  _createDisabledElement: function _createDisabledElement(styles, contentChildren, additionalProps) {
	    var _props = this.props;
	    var innerDivStyle = _props.innerDivStyle;
	    var style = _props.style;
	
	    var mergedDivStyles = this.mergeStyles(styles.root, styles.innerDiv, innerDivStyle, style);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, additionalProps, {
	        style: this.prepareStyles(mergedDivStyles)
	      }),
	      contentChildren
	    );
	  },
	  _createLabelElement: function _createLabelElement(styles, contentChildren, additionalProps) {
	    var _props2 = this.props;
	    var innerDivStyle = _props2.innerDivStyle;
	    var style = _props2.style;
	
	    var mergedLabelStyles = this.mergeStyles(styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	    return _react2.default.createElement(
	      'label',
	      _extends({}, additionalProps, {
	        style: this.prepareStyles(mergedLabelStyles)
	      }),
	      contentChildren
	    );
	  },
	  _createTextElement: function _createTextElement(styles, data, key) {
	    var isAnElement = _react2.default.isValidElement(data);
	    var mergedStyles = isAnElement ? this.mergeStyles(styles, data.props.style) : null;
	
	    return isAnElement ? _react2.default.cloneElement(data, {
	      key: key,
	      style: this.prepareStyles(mergedStyles)
	    }) : _react2.default.createElement(
	      'div',
	      { key: key, style: this.prepareStyles(styles) },
	      data
	    );
	  },
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, isKeyboardFocused) {
	    this.setState({ isKeyboardFocused: isKeyboardFocused });
	    this.props.onKeyboardFocus(e, isKeyboardFocused);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.state.touch) this.setState({ hovered: true });
	    this.props.onMouseEnter(e);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    this.props.onMouseLeave(e);
	  },
	  _handleNestedListToggle: function _handleNestedListToggle(e) {
	    e.stopPropagation();
	    this.setState({ open: !this.state.open });
	    this.props.onNestedListToggle(this);
	  },
	  _handleRightIconButtonKeyboardFocus: function _handleRightIconButtonKeyboardFocus(e, isKeyboardFocused) {
	    var iconButton = this.props.rightIconButton;
	    var newState = {};
	
	    newState.rightIconButtonKeyboardFocused = isKeyboardFocused;
	    if (isKeyboardFocused) newState.isKeyboardFocused = false;
	    this.setState(newState);
	
	    if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(e, isKeyboardFocused);
	  },
	  _handleRightIconButtonMouseDown: function _handleRightIconButtonMouseDown(e) {
	    var iconButton = this.props.rightIconButton;
	    e.stopPropagation();
	    if (iconButton && iconButton.props.onMouseDown) iconButton.props.onMouseDown(e);
	  },
	  _handleRightIconButtonMouseLeave: function _handleRightIconButtonMouseLeave(e) {
	    var iconButton = this.props.rightIconButton;
	    this.setState({ rightIconButtonHovered: false });
	    if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(e);
	  },
	  _handleRightIconButtonMouseEnter: function _handleRightIconButtonMouseEnter(e) {
	    var iconButton = this.props.rightIconButton;
	    this.setState({ rightIconButtonHovered: true });
	    if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(e);
	  },
	  _handleRightIconButtonMouseUp: function _handleRightIconButtonMouseUp(e) {
	    var iconButton = this.props.rightIconButton;
	    e.stopPropagation();
	    if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(e);
	  },
	  _handleRightIconButtonTouchTap: function _handleRightIconButtonTouchTap(e) {
	    var iconButton = this.props.rightIconButton;
	
	    //Stop the event from bubbling up to the list-item
	    e.stopPropagation();
	    if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(e);
	  },
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({ touch: true });
	    this.props.onTouchStart(e);
	  },
	  _pushElement: function _pushElement(children, element, baseStyles, additionalProps) {
	    if (element) {
	      var styles = this.mergeStyles(baseStyles, element.props.style);
	      children.push(_react2.default.cloneElement(element, _extends({
	        key: children.length,
	        style: styles
	      }, additionalProps)));
	    }
	  },
	  render: function render() {
	    var _props3 = this.props;
	    var autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator;
	    var children = _props3.children;
	    var disabled = _props3.disabled;
	    var disableKeyboardFocus = _props3.disableKeyboardFocus;
	    var innerDivStyle = _props3.innerDivStyle;
	    var insetChildren = _props3.insetChildren;
	    var leftAvatar = _props3.leftAvatar;
	    var leftCheckbox = _props3.leftCheckbox;
	    var leftIcon = _props3.leftIcon;
	    var nestedItems = _props3.nestedItems;
	    var nestedLevel = _props3.nestedLevel;
	    var nestedListStyle = _props3.nestedListStyle;
	    var onKeyboardFocus = _props3.onKeyboardFocus;
	    var onMouseLeave = _props3.onMouseLeave;
	    var onMouseEnter = _props3.onMouseEnter;
	    var onTouchStart = _props3.onTouchStart;
	    var onTouchTap = _props3.onTouchTap;
	    var rightAvatar = _props3.rightAvatar;
	    var rightIcon = _props3.rightIcon;
	    var rightIconButton = _props3.rightIconButton;
	    var rightToggle = _props3.rightToggle;
	    var primaryText = _props3.primaryText;
	    var primaryTogglesNestedList = _props3.primaryTogglesNestedList;
	    var secondaryText = _props3.secondaryText;
	    var secondaryTextLines = _props3.secondaryTextLines;
	    var style = _props3.style;
	
	    var other = _objectWithoutProperties(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseLeave', 'onMouseEnter', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	
	    var textColor = this.state.muiTheme.rawTheme.palette.textColor;
	    var hoverColor = _colorManipulator2.default.fade(textColor, 0.1);
	    var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	    var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	    var twoLine = secondaryText && secondaryTextLines === 1;
	    var threeLine = secondaryText && secondaryTextLines > 1;
	    var hasCheckbox = leftCheckbox || rightToggle;
	
	    var styles = {
	      root: {
	        backgroundColor: (this.state.isKeyboardFocused || this.state.hovered) && !this.state.rightIconButtonHovered && !this.state.rightIconButtonKeyboardFocused ? hoverColor : null,
	        color: textColor,
	        display: 'block',
	        fontSize: 16,
	        lineHeight: '16px',
	        position: 'relative',
	        transition: _transitions2.default.easeOut()
	      },
	
	      //This inner div is needed so that ripples will span the entire container
	      innerDiv: {
	        marginLeft: nestedLevel * this.state.muiTheme.listItem.nestedLevelDepth,
	        paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	        paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	        paddingBottom: singleAvatar ? 20 : 16,
	        paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	        position: 'relative'
	      },
	
	      icons: {
	        height: 24,
	        width: 24,
	        display: 'block',
	        position: 'absolute',
	        top: twoLine ? 12 : singleAvatar ? 4 : 0,
	        margin: 12
	      },
	
	      leftIcon: {
	        color: _colors2.default.grey600,
	        fill: _colors2.default.grey600,
	        left: 4
	      },
	
	      rightIcon: {
	        color: _colors2.default.grey400,
	        fill: _colors2.default.grey400,
	        right: 4
	      },
	
	      avatars: {
	        position: 'absolute',
	        top: singleAvatar ? 8 : 16
	      },
	
	      label: {
	        cursor: 'pointer'
	      },
	
	      leftAvatar: {
	        left: 16
	      },
	
	      rightAvatar: {
	        right: 16
	      },
	
	      leftCheckbox: {
	        position: 'absolute',
	        display: 'block',
	        width: 24,
	        top: twoLine ? 24 : singleAvatar ? 16 : 12,
	        left: 16
	      },
	
	      primaryText: {},
	
	      rightIconButton: {
	        position: 'absolute',
	        display: 'block',
	        top: twoLine ? 12 : singleAvatar ? 4 : 0,
	        right: 4
	      },
	
	      rightToggle: {
	        position: 'absolute',
	        display: 'block',
	        width: 54,
	        top: twoLine ? 25 : singleAvatar ? 17 : 13,
	        right: 8
	      },
	
	      secondaryText: {
	        fontSize: 14,
	        lineHeight: threeLine ? '18px' : '16px',
	        height: threeLine ? 36 : 16,
	        margin: 0,
	        marginTop: 4,
	        color: _typography2.default.textLightBlack,
	
	        //needed for 2 and 3 line ellipsis
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        whiteSpace: threeLine ? null : 'nowrap',
	        display: threeLine ? '-webkit-box' : null,
	        WebkitLineClamp: threeLine ? 2 : null,
	        WebkitBoxOrient: threeLine ? 'vertical' : null
	      }
	    };
	
	    var contentChildren = [children];
	
	    if (leftIcon) {
	      this._pushElement(contentChildren, leftIcon, this.mergeStyles(styles.icons, styles.leftIcon));
	    }
	
	    if (rightIcon) {
	      this._pushElement(contentChildren, rightIcon, this.mergeStyles(styles.icons, styles.rightIcon));
	    }
	
	    if (leftAvatar) {
	      this._pushElement(contentChildren, leftAvatar, this.mergeStyles(styles.avatars, styles.leftAvatar));
	    }
	
	    if (rightAvatar) {
	      this._pushElement(contentChildren, rightAvatar, this.mergeStyles(styles.avatars, styles.rightAvatar));
	    }
	
	    if (leftCheckbox) {
	      this._pushElement(contentChildren, leftCheckbox, this.mergeStyles(styles.leftCheckbox));
	    }
	
	    //RightIconButtonElement
	    var hasNestListItems = nestedItems.length;
	    var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	    var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	    if (rightIconButton || needsNestedIndicator) {
	      var rightIconButtonElement = rightIconButton;
	      var rightIconButtonHandlers = {
	        onKeyboardFocus: this._handleRightIconButtonKeyboardFocus,
	        onMouseEnter: this._handleRightIconButtonMouseEnter,
	        onMouseLeave: this._handleRightIconButtonMouseLeave,
	        onTouchTap: this._handleRightIconButtonTouchTap,
	        onMouseDown: this._handleRightIconButtonMouseUp,
	        onMouseUp: this._handleRightIconButtonMouseUp
	      };
	
	      // Create a nested list indicator icon if we don't have an icon on the right
	      if (needsNestedIndicator) {
	        rightIconButtonElement = this.state.open ? _react2.default.createElement(
	          _iconButton2.default,
	          null,
	          _react2.default.createElement(_arrowDropUp2.default, null)
	        ) : _react2.default.createElement(
	          _iconButton2.default,
	          null,
	          _react2.default.createElement(_arrowDropDown2.default, null)
	        );
	        rightIconButtonHandlers.onTouchTap = this._handleNestedListToggle;
	      }
	
	      this._pushElement(contentChildren, rightIconButtonElement, this.mergeStyles(styles.rightIconButton), rightIconButtonHandlers);
	    }
	
	    if (rightToggle) {
	      this._pushElement(contentChildren, rightToggle, this.mergeStyles(styles.rightToggle));
	    }
	
	    if (primaryText) {
	      var secondaryTextElement = this._createTextElement(styles.primaryText, primaryText, 'primaryText');
	      contentChildren.push(secondaryTextElement);
	    }
	
	    if (secondaryText) {
	      var secondaryTextElement = this._createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	      contentChildren.push(secondaryTextElement);
	    }
	
	    var nestedList = nestedItems.length ? _react2.default.createElement(
	      _nestedList2.default,
	      { nestedLevel: nestedLevel + 1, open: this.state.open, style: nestedListStyle },
	      nestedItems
	    ) : undefined;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      hasCheckbox ? this._createLabelElement(styles, contentChildren, other) : disabled ? this._createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	        _enhancedButton2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	          linkButton: true,
	          onKeyboardFocus: this._handleKeyboardFocus,
	          onMouseLeave: this._handleMouseLeave,
	          onMouseEnter: this._handleMouseEnter,
	          onTouchStart: this._handleTouchStart,
	          onTouchTap: primaryTogglesNestedList ? this._handleNestedListToggle : onTouchTap,
	          ref: 'enhancedButton',
	          style: this.mergeStyles(styles.root, style)
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(styles.innerDiv, innerDivStyle) },
	          contentChildren
	        )
	      ),
	      nestedList
	    );
	  }
	});
	
	exports.default = ListItem;
	module.exports = exports['default'];

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _cssEvent = __webpack_require__(161);
	
	var _cssEvent2 = _interopRequireDefault(_cssEvent);
	
	var _keyLine = __webpack_require__(162);
	
	var _keyLine2 = _interopRequireDefault(_keyLine);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _clickAwayable = __webpack_require__(48);
	
	var _clickAwayable2 = _interopRequireDefault(_clickAwayable);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _menuItem2 = __webpack_require__(273);
	
	var _menuItem3 = _interopRequireDefault(_menuItem2);
	
	var _linkMenuItem = __webpack_require__(272);
	
	var _linkMenuItem2 = _interopRequireDefault(_linkMenuItem);
	
	var _subheaderMenuItem = __webpack_require__(274);
	
	var _subheaderMenuItem2 = _interopRequireDefault(_subheaderMenuItem);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*eslint-disable */
	
	/***********************
	* Nested Menu Component
	***********************/
	var NestedMenuItem = _react2.default.createClass({
	  displayName: 'NestedMenuItem',
	
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    disabled: _react2.default.PropTypes.bool,
	    index: _react2.default.PropTypes.number.isRequired,
	    menuItemStyle: _react2.default.PropTypes.object,
	    menuItems: _react2.default.PropTypes.array.isRequired,
	    onItemTap: _react2.default.PropTypes.func,
	    onMouseOut: _react2.default.PropTypes.func,
	    onMouseOver: _react2.default.PropTypes.func,
	    style: _react2.default.PropTypes.object,
	    text: _react2.default.PropTypes.string,
	    zDepth: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_clickAwayable2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      open: false,
	      activeIndex: 0
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._positionNestedMenu();
	    _reactDom2.default.findDOMNode(this).focus();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._positionNestedMenu();
	  },
	  componentClickAway: function componentClickAway() {
	    this._closeNestedMenu();
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        userSelect: 'none',
	        cursor: 'pointer',
	        lineHeight: this.getTheme().height + 'px',
	        color: this.state.muiTheme.rawTheme.palette.textColor
	      },
	      icon: {
	        float: 'left',
	        lineHeight: this.getTheme().height + 'px',
	        marginRight: this.getSpacing().desktopGutter
	      },
	      toggle: {
	        marginTop: (this.getTheme().height - this.state.muiTheme.radioButton.size) / 2,
	        float: 'right',
	        width: 42
	      },
	      rootWhenHovered: {
	        backgroundColor: this.getTheme().hoverColor
	      },
	      rootWhenSelected: {
	        color: this.getTheme().selectedTextColor
	      },
	      rootWhenDisabled: {
	        cursor: 'default',
	        color: this.state.muiTheme.rawTheme.palette.disabledColor
	      }
	    };
	
	    return styles;
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.menuItem;
	  },
	  toggleNestedMenu: function toggleNestedMenu() {
	    if (!this.props.disabled) this.setState({ open: !this.state.open });
	  },
	  isOpen: function isOpen() {
	    return this.state.open;
	  },
	  _positionNestedMenu: function _positionNestedMenu() {
	    var el = _reactDom2.default.findDOMNode(this);
	    var nestedMenu = _reactDom2.default.findDOMNode(this.refs.nestedMenu);
	    nestedMenu.style.left = el.offsetWidth + 'px';
	  },
	  _openNestedMenu: function _openNestedMenu() {
	    if (!this.props.disabled) this.setState({ open: true });
	  },
	  _closeNestedMenu: function _closeNestedMenu() {
	    this.setState({ open: false });
	    _reactDom2.default.findDOMNode(this).focus();
	  },
	  _onParentItemTap: function _onParentItemTap() {
	    this.toggleNestedMenu();
	  },
	  _onMenuItemTap: function _onMenuItemTap(e, index, menuItem) {
	    if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
	    this._closeNestedMenu();
	  },
	  _handleMouseOver: function _handleMouseOver(e) {
	    if (!this.props.disabled && this.props.onMouseOver) this.props.onMouseOver(e, this.props.index);
	  },
	  _handleMouseOut: function _handleMouseOut(e) {
	    if (!this.props.disabled && this.props.onMouseOut) this.props.onMouseOut(e, this.props.index);
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    styles = this.mergeStyles(styles.root, this.props.active && !this.props.disabled && styles.rootWhenHovered, {
	      position: 'relative'
	    }, this.props.style);
	
	    var iconCustomArrowDropRight = {
	      marginRight: this.getSpacing().desktopGutterMini * -1,
	      color: this.state.muiTheme.dropDownMenu.accentColor
	    };
	
	    var _props = this.props;
	    var index = _props.index;
	    var menuItemStyle = _props.menuItemStyle;
	
	    var other = _objectWithoutProperties(_props, ['index', 'menuItemStyle']);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: 'root',
	        style: this.prepareStyles(styles),
	        onMouseEnter: this._openNestedMenu,
	        onMouseLeave: this._closeNestedMenu,
	        onMouseOver: this._handleMouseOver,
	        onMouseOut: this._handleMouseOut },
	      _react2.default.createElement(
	        _menuItem3.default,
	        {
	          index: index,
	          style: menuItemStyle,
	          disabled: this.props.disabled,
	          iconRightStyle: iconCustomArrowDropRight,
	          iconRightClassName: 'muidocs-icon-custom-arrow-drop-right',
	          onTouchTap: this._onParentItemTap },
	        this.props.text
	      ),
	      _react2.default.createElement(Menu, _extends({}, other, {
	        ref: 'nestedMenu',
	        menuItems: this.props.menuItems,
	        menuItemStyle: menuItemStyle,
	        onItemTap: this._onMenuItemTap,
	        hideable: true,
	        visible: this.state.open,
	        onRequestClose: this._closeNestedMenu,
	        zDepth: this.props.zDepth + 1 }))
	    );
	  }
	});
	
	/****************
	* Menu Component
	****************/
	var Menu = _react2.default.createClass({
	  displayName: 'Menu',
	
	  propTypes: {
	    autoWidth: _react2.default.PropTypes.bool,
	    hideable: _react2.default.PropTypes.bool,
	    menuItemClassName: _react2.default.PropTypes.string,
	    menuItemClassNameLink: _react2.default.PropTypes.string,
	    menuItemClassNameSubheader: _react2.default.PropTypes.string,
	    menuItemStyle: _react2.default.PropTypes.object,
	    menuItemStyleLink: _react2.default.PropTypes.object,
	    menuItemStyleSubheader: _react2.default.PropTypes.object,
	    menuItems: _react2.default.PropTypes.array.isRequired,
	    onItemTap: _react2.default.PropTypes.func,
	    onItemToggle: _react2.default.PropTypes.func,
	    onRequestClose: _react2.default.PropTypes.func,
	    onToggle: _react2.default.PropTypes.func,
	    selectedIndex: _react2.default.PropTypes.number,
	    style: _react2.default.PropTypes.object,
	    visible: _react2.default.PropTypes.bool,
	    zDepth: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoWidth: true,
	      hideable: false,
	      visible: true,
	      zDepth: 1,
	      onRequestClose: function onRequestClose() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	     false ? (0, _warning2.default)(false, 'This menu component is deprecated use menus/menu instead.') : undefined;
	
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      nestedMenuShown: false,
	      activeIndex: 0
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var el = _reactDom2.default.findDOMNode(this);
	
	    //Set the menu width
	    this._setKeyWidth(el);
	
	    //Show or Hide the menu according to visibility
	    this._renderVisibility();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    //Set the menu width
	    this._setKeyWidth(_reactDom2.default.findDOMNode(this));
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.visible !== prevProps.visible || this.props.menuItems.length !== prevProps.menuItems.length) {
	      this._renderVisibility();
	    }
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.menu;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        backgroundColor: this.getTheme().containerBackgroundColor,
	        paddingTop: this.getSpacing().desktopGutterMini,
	        paddingBottom: this.getSpacing().desktopGutterMini,
	        transition: _transitions2.default.easeOut(null, 'height'),
	        outline: 'none !important'
	      },
	      subheader: {
	        paddingLeft: this.state.muiTheme.menuSubheader.padding,
	        paddingRight: this.state.muiTheme.menuSubheader.padding
	      },
	      hideable: {
	        overflow: 'hidden',
	        position: 'absolute',
	        top: 0,
	        zIndex: 1
	      },
	      item: {
	        height: 34
	      }
	    };
	
	    return styles;
	  },
	  _getChildren: function _getChildren() {
	    var menuItem = undefined;
	    var itemComponent = undefined;
	    var isDisabled = undefined;
	
	    var styles = this.getStyles();
	
	    this._children = [];
	    //This array is used to keep track of all nested menu refs
	    this._nestedChildren = [];
	
	    for (var i = 0; i < this.props.menuItems.length; i++) {
	      menuItem = this.props.menuItems[i];
	      isDisabled = menuItem.disabled === undefined ? false : menuItem.disabled;
	
	      var _menuItem = menuItem;
	      var icon = _menuItem.icon;
	      var data = _menuItem.data;
	      var attribute = _menuItem.attribute;
	      var number = _menuItem.number;
	      var toggle = _menuItem.toggle;
	      var onTouchTap = _menuItem.onTouchTap;
	
	      var other = _objectWithoutProperties(_menuItem, ['icon', 'data', 'attribute', 'number', 'toggle', 'onTouchTap']);
	
	      switch (menuItem.type) {
	
	        case _menuItem3.default.Types.LINK:
	          itemComponent = _react2.default.createElement(_linkMenuItem2.default, {
	            key: i,
	            index: i,
	            active: this.state.activeIndex === i,
	            text: menuItem.text,
	            disabled: isDisabled,
	            className: this.props.menuItemClassNameLink,
	            style: this.props.menuItemStyleLink,
	            payload: menuItem.payload,
	            target: menuItem.target });
	          break;
	
	        case _menuItem3.default.Types.SUBHEADER:
	          itemComponent = _react2.default.createElement(_subheaderMenuItem2.default, {
	            key: i,
	            index: i,
	            className: this.props.menuItemClassNameSubheader,
	            style: this.mergeStyles(styles.subheader, this.props.menuItemStyleSubheader),
	            firstChild: i === 0,
	            text: menuItem.text });
	          break;
	
	        case _menuItem3.default.Types.NESTED:
	          var _props2 = this.props;
	          var zDepth = _props2.zDepth;
	
	          var other = _objectWithoutProperties(_props2, ['zDepth']);
	
	          itemComponent = _react2.default.createElement(NestedMenuItem, _extends({}, other, {
	            ref: i,
	            key: i,
	            index: i,
	            nested: true,
	            active: this.state.activeIndex === i,
	            text: menuItem.text,
	            disabled: isDisabled,
	            menuItems: menuItem.items,
	            menuItemStyle: this.props.menuItemStyle,
	            zDepth: this.props.zDepth,
	            onMouseEnter: this._onItemActivated,
	            onMouseLeave: this._onItemDeactivated,
	            onItemTap: this._onNestedItemTap }));
	          this._nestedChildren.push(i);
	          break;
	
	        default:
	          itemComponent = _react2.default.createElement(
	            _menuItem3.default,
	            _extends({}, other, {
	              selected: this.props.selectedIndex === i,
	              key: i,
	              index: i,
	              active: this.state.activeIndex === i,
	              icon: menuItem.icon,
	              data: menuItem.data,
	              className: this.props.menuItemClassName,
	              style: this.props.menuItemStyle,
	              attribute: menuItem.attribute,
	              number: menuItem.number,
	              toggle: menuItem.toggle,
	              onToggle: this.props.onToggle,
	              disabled: isDisabled,
	              onTouchTap: this._onItemTap,
	              onMouseEnter: this._onItemActivated,
	              onMouseLeave: this._onItemDeactivated
	            }),
	            menuItem.text
	          );
	      }
	      this._children.push(itemComponent);
	    }
	
	    return this._children;
	  },
	  _setKeyWidth: function _setKeyWidth(el) {
	    //Update the menu width
	    var menuWidth = '100%';
	
	    if (this.props.autoWidth) {
	      el.style.width = 'auto';
	      menuWidth = _keyLine2.default.getIncrementalDim(el.offsetWidth) + 'px';
	    }
	
	    el.style.width = menuWidth;
	  },
	  _renderVisibility: function _renderVisibility() {
	    if (this.props.hideable) {
	      if (this.props.visible) this._expandHideableMenu();else this._collapseHideableMenu();
	    }
	  },
	  _expandHideableMenu: function _expandHideableMenu() {
	    var _this = this;
	
	    var el = _reactDom2.default.findDOMNode(this);
	    var container = _reactDom2.default.findDOMNode(this.refs.paperContainer);
	    var padding = this.getSpacing().desktopGutterMini;
	    var height = this._getHiddenMenuHeight(el, padding);
	
	    //Add transition
	    if (!el.style.transition) {
	      el.style.transition = _transitions2.default.easeOut();
	    }
	
	    this._nextAnimationFrame(function () {
	      container.style.overflow = 'hidden';
	
	      // Yeild to the DOM, then apply height and padding. This makes the transition smoother.
	      el.style.paddingTop = padding + 'px';
	      el.style.paddingBottom = padding + 'px';
	      el.style.height = height + 'px';
	      el.style.opacity = 1;
	
	      //Set the overflow to visible after the animation is done so
	      //that other nested menus can be shown
	      _cssEvent2.default.onTransitionEnd(el, function () {
	        //Make sure the menu is open before setting the overflow.
	        //This is to accout for fast clicks
	        if (_this.props.visible) container.style.overflow = 'visible';
	        el.style.transition = null;
	        el.focus();
	      });
	    });
	  },
	  _getHiddenMenuHeight: function _getHiddenMenuHeight(el, padding) {
	    //Add padding to the offset height, because it is not yet set in the style.
	    var height = padding * 2;
	
	    //Hide the element and allow the browser to automatically resize it.
	    el.style.visibility = 'hidden';
	    el.style.height = 'auto';
	
	    //Determine the height of the menu.
	    height += el.offsetHeight;
	
	    //Unhide the menu with the height set back to zero.
	    el.style.height = '0px';
	    el.style.visibility = 'visible';
	
	    return height;
	  },
	  _collapseHideableMenu: function _collapseHideableMenu() {
	    var el = _reactDom2.default.findDOMNode(this);
	    var container = _reactDom2.default.findDOMNode(this.refs.paperContainer);
	    var originalOpacity = el.style.opacity;
	
	    //Add transition
	    if (!el.style.transition && originalOpacity !== '') {
	      el.style.transition = _transitions2.default.easeOut();
	    }
	
	    this._nextAnimationFrame(function () {
	      //Set the overflow to hidden so that animation works properly
	      container.style.overflow = 'hidden';
	
	      //Close the menu
	      el.style.opacity = 0;
	      el.style.height = '0px';
	      el.style.paddingTop = '0px';
	      el.style.paddingBottom = '0px';
	
	      var end = function end() {
	        el.style.transition = null;
	      };
	
	      if (originalOpacity === '') end();else _cssEvent2.default.onTransitionEnd(el, end);
	    });
	  },
	  _nextAnimationFrame: function _nextAnimationFrame(func) {
	    if (window.requestAnimationFrame) {
	      return window.requestAnimationFrame(func);
	    }
	    return setTimeout(func, 16);
	  },
	  _onNestedItemTap: function _onNestedItemTap(e, index, menuItem) {
	    if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
	  },
	  _onItemTap: function _onItemTap(e, index) {
	    if (this.props.onItemTap) this.props.onItemTap(e, index, this.props.menuItems[index]);
	  },
	  _onItemToggle: function _onItemToggle(e, index, toggled) {
	    if (this.props.onItemToggle) this.props.onItemToggle(e, index, this.props.menuItems[index], toggled);
	  },
	  _onItemActivated: function _onItemActivated(e, index) {
	    this.setState({ activeIndex: index });
	  },
	  _onItemDeactivated: function _onItemDeactivated(e, index) {
	    if (this.state.activeKey === index) this.setState({ activeIndex: 0 });
	  },
	  _onKeyDown: function _onKeyDown(e) {
	    if (!(this.state.open || this.props.visible)) return;
	
	    var nested = this._children[this.state.activeIndex];
	    if (nested && nested.props.nested && this.refs[this.state.activeIndex].isOpen()) return;
	
	    switch (e.which) {
	      case _keyCode2.default.UP:
	        this._activatePreviousItem();
	        break;
	      case _keyCode2.default.DOWN:
	        this._activateNextItem();
	        break;
	      case _keyCode2.default.RIGHT:
	        this._tryToggleNested(this.state.activeIndex);
	        break;
	      case _keyCode2.default.LEFT:
	        this._close();
	        break;
	      case _keyCode2.default.ESC:
	        this._close();
	        break;
	      case _keyCode2.default.TAB:
	        this._close();
	        return; // so the tab key can propagate
	      case _keyCode2.default.ENTER:
	      case _keyCode2.default.SPACE:
	        e.stopPropagation(); // needs called before the close
	        this._triggerSelection(e);
	        break;
	      default:
	        return; //important
	    }
	    e.preventDefault();
	    e.stopPropagation();
	  },
	  _activatePreviousItem: function _activatePreviousItem() {
	    var active = this.state.activeIndex || 0;
	    active = Math.max(active - 1, 0);
	    this.setState({ activeIndex: active });
	  },
	  _activateNextItem: function _activateNextItem() {
	    var active = this.state.activeIndex || 0;
	    active = Math.min(active + 1, this._children.length - 1);
	    this.setState({ activeIndex: active });
	  },
	  _triggerSelection: function _triggerSelection(e) {
	    var index = this.state.activeIndex || 0;
	    this._onItemTap(e, index);
	  },
	  _close: function _close() {
	    this.props.onRequestClose();
	  },
	  _tryToggleNested: function _tryToggleNested(index) {
	    var item = this.refs[index];
	    if (item && item.toggleNestedMenu) item.toggleNestedMenu();
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    return _react2.default.createElement(
	      _paper2.default,
	      {
	        ref: 'paperContainer',
	        tabIndex: '0',
	        onKeyDown: this._onKeyDown,
	        zDepth: this.props.zDepth,
	        style: this.mergeStyles(styles.root, this.props.hideable && styles.hideable, this.props.style) },
	      this._getChildren()
	    );
	  }
	});
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sizes = {
	  SMALL: 1,
	  MEDIUM: 2,
	  LARGE: 3
	};
	
	exports.default = {
	
	  statics: {
	    Sizes: Sizes
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      deviceSize: Sizes.SMALL
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._updateDeviceSize();
	    if (!this.manuallyBindResize) this._bindResize();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unbindResize();
	  },
	  isDeviceSize: function isDeviceSize(desiredSize) {
	    return this.state.deviceSize >= desiredSize;
	  },
	  _updateDeviceSize: function _updateDeviceSize() {
	    var width = window.innerWidth;
	
	    if (width >= 992) {
	      this.setState({ deviceSize: Sizes.LARGE });
	    } else if (width >= 768) {
	      this.setState({ deviceSize: Sizes.MEDIUM });
	    } else {
	      // width < 768
	      this.setState({ deviceSize: Sizes.SMALL });
	    }
	  },
	  _bindResize: function _bindResize() {
	    _events2.default.on(window, 'resize', this._updateDeviceSize);
	  },
	  _unbindResize: function _unbindResize() {
	    _events2.default.off(window, 'resize', this._updateDeviceSize);
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _enhancedSwitch = __webpack_require__(94);
	
	var _enhancedSwitch2 = _interopRequireDefault(_enhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(302);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(301);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RadioButton = _react2.default.createClass({
	  displayName: 'RadioButton',
	
	  propTypes: {
	    /**
	     * Used internally by `RadioButtonGroup`.
	     */
	    /* Checked if true. */
	    checked: _react2.default.PropTypes.bool,
	
	    /**
	     * Disabled if true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Overrides the inline-styles of the icon element.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	     */
	    /* Where the label will be placed next to the radio button. */
	    labelPosition: _react2.default.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * Overrides the inline-styles of the RadioButton element label.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Callback function for checked event.
	     */
	    onCheck: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of our radio button component.
	     */
	    value: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      checked: false,
	      disabled: false,
	      labelPosition: 'right'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.radioButton;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      icon: {
	        height: this.getTheme().size,
	        width: this.getTheme().size
	      },
	      target: {
	        transition: _transitions2.default.easeOut(),
	        position: 'absolute',
	        opacity: 1,
	        transform: 'scale(1)',
	        fill: this.getTheme().borderColor
	      },
	      fill: {
	        position: 'absolute',
	        opacity: 1,
	        transform: 'scale(0)',
	        transformOrigin: '50% 50%',
	        transition: _transitions2.default.easeOut(),
	        fill: this.getTheme().checkedColor
	      },
	      targetWhenChecked: {
	        opacity: 0,
	        transform: 'scale(0)'
	      },
	      fillWhenChecked: {
	        opacity: 1,
	        transform: 'scale(1)'
	      },
	      targetWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      fillWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      label: {
	        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
	      }
	    };
	
	    return styles;
	  },
	
	  // Only called when selected, not when unselected.
	  _handleCheck: function _handleCheck(e) {
	    if (this.props.onCheck) this.props.onCheck(e, this.props.value);
	  },
	  _handleStateChange: function _handleStateChange() {},
	  isChecked: function isChecked() {
	    return this.refs.enhancedSwitch.isSwitched();
	  },
	
	  // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	  // RadioButton's checked value.
	  setChecked: function setChecked(newCheckedValue) {
	    this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	  },
	  getValue: function getValue() {
	    return this.refs.enhancedSwitch.getValue();
	  },
	  render: function render() {
	    var _props = this.props;
	    var onCheck = _props.onCheck;
	
	    var other = _objectWithoutProperties(_props, ['onCheck']);
	
	    var styles = this.getStyles();
	    var onStyles = this.mergeStyles(styles.target, this.props.checked && styles.targetWhenChecked, this.props.iconStyle, this.props.disabled && styles.targetWhenDisabled);
	    var offStyles = this.mergeStyles(styles.fill, this.props.checked && styles.fillWhenChecked, this.props.iconStyle, this.props.disabled && styles.fillWhenDisabled);
	
	    var radioButtonElement = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_radioButtonUnchecked2.default, { style: onStyles }),
	      _react2.default.createElement(_radioButtonChecked2.default, { style: offStyles })
	    );
	
	    var rippleColor = this.props.checked ? this.getTheme().checkedColor : this.getTheme().borderColor;
	
	    var iconStyle = this.mergeStyles(styles.icon, this.props.iconStyle);
	
	    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);
	
	    var enhancedSwitchProps = {
	      ref: 'enhancedSwitch',
	      inputType: 'radio',
	      switched: this.props.checked,
	      switchElement: radioButtonElement,
	      rippleColor: rippleColor,
	      iconStyle: iconStyle,
	      labelStyle: labelStyle,
	      onSwitch: this._handleCheck,
	      onParentShouldUpdate: this._handleStateChange,
	      labelPosition: this.props.labelPosition
	    };
	
	    return _react2.default.createElement(_enhancedSwitch2.default, _extends({}, other, enhancedSwitchProps));
	  }
	});
	
	exports.default = RadioButton;
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _dom = __webpack_require__(72);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = _react2.default.createClass({
	  displayName: 'RenderToLayer',
	
	  propTypes: {
	    componentClickAway: _react2.default.PropTypes.func,
	    open: _react2.default.PropTypes.bool.isRequired,
	    render: _react2.default.PropTypes.func.isRequired,
	    useLayerForClickAway: _react2.default.PropTypes.bool
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      useLayerForClickAway: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._renderLayer();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      muiTheme: newMuiTheme
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderLayer();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderLayer();
	  },
	  onClickAway: function onClickAway(event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    if (!this.props.componentClickAway) {
	      return;
	    }
	
	    if (!this.props.open) {
	      return;
	    }
	
	    var el = this._layer;
	    if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	      this.props.componentClickAway(event);
	    }
	  },
	  getLayer: function getLayer() {
	    return this._layer;
	  },
	
	  _unrenderLayer: function _unrenderLayer() {
	    if (!this._layer) {
	      return;
	    }
	
	    if (this.props.useLayerForClickAway) {
	      this._layer.style.position = 'relative';
	      this._layer.removeEventListener('touchstart', this.onClickAway);
	      this._layer.removeEventListener('click', this.onClickAway);
	    } else {
	      window.removeEventListener('touchstart', this.onClickAway);
	      window.removeEventListener('click', this.onClickAway);
	    }
	
	    _reactDom2.default.unmountComponentAtNode(this._layer);
	    document.body.removeChild(this._layer);
	    this._layer = null;
	  },
	
	  _renderLayer: function _renderLayer() {
	    var _this = this;
	
	    var _props = this.props;
	    var open = _props.open;
	    var render = _props.render;
	
	    if (open) {
	      if (!this._layer) {
	        this._layer = document.createElement('div');
	        document.body.appendChild(this._layer);
	
	        if (this.props.useLayerForClickAway) {
	          this._layer.addEventListener('touchstart', this.onClickAway);
	          this._layer.addEventListener('click', this.onClickAway);
	          this._layer.style.position = 'fixed';
	          this._layer.style.top = 0;
	          this._layer.style.bottom = 0;
	          this._layer.style.left = 0;
	          this._layer.style.right = 0;
	          this._layer.style.zIndex = this.state.muiTheme.zIndex.layer;
	        } else {
	          setTimeout(function () {
	            window.addEventListener('touchstart', _this.onClickAway);
	            window.addEventListener('click', _this.onClickAway);
	          }, 0);
	        }
	      }
	
	      // By calling this method in componentDidMount() and
	      // componentDidUpdate(), you're effectively creating a "wormhole" that
	      // funnels React's hierarchical updates through to a DOM node on an
	      // entirely different part of the page.
	
	      var layerElement = render();
	
	      if (layerElement === null) {
	        this.layerElement = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, null, this._layer);
	      } else {
	        this.layerElement = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, layerElement, this._layer);
	      }
	    } else {
	      this._unrenderLayer();
	    }
	  },
	  render: function render() {
	    return null;
	  }
	});
	
	exports.default = RenderToLayer;
	module.exports = exports['default'];

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CircleRipple = _react2.default.createClass({
	  displayName: 'CircleRipple',
	
	  propTypes: {
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * The material-ui theme applied to this component.
	     */
	    muiTheme: _react2.default.PropTypes.object.isRequired,
	
	    opacity: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: _colors2.default.darkBlack,
	      opacity: 0.16
	    };
	  },
	  componentWillAppear: function componentWillAppear(callback) {
	    this._initializeAnimation(callback);
	  },
	  componentWillEnter: function componentWillEnter(callback) {
	    this._initializeAnimation(callback);
	  },
	  componentDidAppear: function componentDidAppear() {
	    this._animate();
	  },
	  componentDidEnter: function componentDidEnter() {
	    this._animate();
	  },
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    var style = _reactDom2.default.findDOMNode(this).style;
	    style.opacity = 0;
	    setTimeout(function () {
	      if (_this.isMounted()) callback();
	    }, 2000);
	  },
	  _animate: function _animate() {
	    var style = _reactDom2.default.findDOMNode(this).style;
	    var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ',' + _transitions2.default.easeOut('1s', 'transform');
	    _autoPrefix2.default.set(style, 'transition', transitionValue, this.props.muiTheme);
	    _autoPrefix2.default.set(style, 'transform', 'scale(1)', this.props.muiTheme);
	  },
	  _initializeAnimation: function _initializeAnimation(callback) {
	    var _this2 = this;
	
	    var style = _reactDom2.default.findDOMNode(this).style;
	    style.opacity = this.props.opacity;
	    _autoPrefix2.default.set(style, 'transform', 'scale(0)', this.props.muiTheme);
	    setTimeout(function () {
	      if (_this2.isMounted()) callback();
	    }, 0);
	  },
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var opacity = _props.opacity;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['color', 'opacity', 'style']);
	
	    var mergedStyles = this.mergeStyles({
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%',
	      borderRadius: '50%',
	      backgroundColor: color
	    }, style);
	
	    return _react2.default.createElement('div', _extends({}, other, { style: this.prepareStyles(mergedStyles) }));
	  }
	});
	
	exports.default = CircleRipple;
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _spacing = __webpack_require__(101);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors2.default.cyan700,
	    primary2Color: _colors2.default.cyan700,
	    primary3Color: _colors2.default.grey600,
	    accent1Color: _colors2.default.pinkA200,
	    accent2Color: _colors2.default.pinkA400,
	    accent3Color: _colors2.default.pinkA100,
	    textColor: _colors2.default.fullWhite,
	    alternateTextColor: '#303030',
	    canvasColor: '#303030',
	    borderColor: _colorManipulator2.default.fade(_colors2.default.fullWhite, 0.3),
	    disabledColor: _colorManipulator2.default.fade(_colors2.default.fullWhite, 0.3),
	    pickerHeaderColor: _colorManipulator2.default.fade(_colors2.default.fullWhite, 0.12),
	    clockCircleColor: _colorManipulator2.default.fade(_colors2.default.fullWhite, 0.12)
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  leftNavOverlay: 1200,
	  leftNav: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};
	module.exports = exports['default'];

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = _react2.default.createClass({
	  displayName: 'NavigationArrowDropDown',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	    );
	  }
	});
	
	exports.default = NavigationArrowDropDown;
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = _react2.default.createClass({
	  displayName: 'NavigationChevronLeft',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	    );
	  }
	});
	
	exports.default = NavigationChevronLeft;
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = _react2.default.createClass({
	  displayName: 'NavigationChevronRight',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	    );
	  }
	});
	
	exports.default = NavigationChevronRight;
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = _react2.default.createClass({
	  displayName: 'NavigationMenu',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	    );
	  }
	});
	
	exports.default = NavigationMenu;
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _tooltip = __webpack_require__(103);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TableHeaderColumn = _react2.default.createClass({
	  displayName: 'TableHeaderColumn',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Number to identify the header row. This property
	     * is automatically populated when used with TableHeader.
	     */
	    columnNumber: _react2.default.PropTypes.number,
	
	    /**
	     * Key prop for table header column.
	     */
	    key: _react2.default.PropTypes.string,
	
	    /**
	     * Callback function for click event.
	     */
	    onClick: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The string to supply to the tooltip. If not
	     * string is supplied no tooltip will be shown.
	     */
	    tooltip: _react2.default.PropTypes.string,
	
	    /**
	     * Additional styling that can be applied to the tooltip.
	     */
	    tooltipStyle: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      hovered: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.tableHeaderColumn;
	  },
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var styles = {
	      root: {
	        fontWeight: 'normal',
	        fontSize: 12,
	        paddingLeft: theme.spacing,
	        paddingRight: theme.spacing,
	        height: theme.height,
	        textAlign: 'left',
	        whiteSpace: 'nowrap',
	        textOverflow: 'ellipsis',
	        color: this.getTheme().textColor,
	        position: 'relative'
	      },
	      tooltip: {
	        boxSizing: 'border-box',
	        marginTop: theme.height / 2
	      }
	    };
	
	    return styles;
	  },
	  _onMouseEnter: function _onMouseEnter() {
	    if (this.props.tooltip !== undefined) this.setState({ hovered: true });
	  },
	  _onMouseLeave: function _onMouseLeave() {
	    if (this.props.tooltip !== undefined) this.setState({ hovered: false });
	  },
	  _onClick: function _onClick(e) {
	    if (this.props.onClick) this.props.onClick(e, this.props.columnNumber);
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    var handlers = {
	      onMouseEnter: this._onMouseEnter,
	      onMouseLeave: this._onMouseLeave,
	      onClick: this._onClick
	    };
	    var _props = this.props;
	    var className = _props.className;
	    var columnNumber = _props.columnNumber;
	    var onClick = _props.onClick;
	    var style = _props.style;
	    var tooltip = _props.tooltip;
	    var tooltipStyle = _props.tooltipStyle;
	
	    var other = _objectWithoutProperties(_props, ['className', 'columnNumber', 'onClick', 'style', 'tooltip', 'tooltipStyle']);
	
	    if (this.props.tooltip !== undefined) {
	      tooltip = _react2.default.createElement(_tooltip2.default, {
	        label: this.props.tooltip,
	        show: this.state.hovered,
	        style: this.mergeStyles(styles.tooltip, tooltipStyle)
	      });
	    }
	
	    return _react2.default.createElement(
	      'th',
	      _extends({
	        key: this.props.key,
	        className: className,
	        style: this.prepareStyles(styles.root, style)
	      }, handlers, other),
	      tooltip,
	      this.props.children
	    );
	  }
	});
	
	exports.default = TableHeaderColumn;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockNumber = _react2.default.createClass({
	  displayName: 'ClockNumber',
	
	  propTypes: {
	    isSelected: _react2.default.PropTypes.bool,
	    onSelected: _react2.default.PropTypes.func,
	    type: _react2.default.PropTypes.oneOf(['hour', 'minute']),
	    value: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: 0,
	      type: 'minute',
	      isSelected: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.timePicker;
	  },
	  render: function render() {
	    var pos = this.props.value;
	    var inner = false;
	
	    if (this.props.type === 'hour') {
	      inner = pos < 1 || pos > 12;
	      pos %= 12;
	    } else {
	      pos = pos / 5;
	    }
	
	    var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	    var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	    var styles = {
	      root: {
	        display: 'inline-block',
	        position: 'absolute',
	        width: 32,
	        height: 32,
	        borderRadius: '100%',
	        left: 'calc(50% - 16px)',
	        top: 10,
	        textAlign: 'center',
	        paddingTop: 5,
	        userSelect: 'none', /* Chrome all / Safari all */
	        fontSize: '1.1em',
	        pointerEvents: 'none',
	        boxSizing: 'border-box'
	      }
	    };
	
	    if (this.props.isSelected) {
	      styles.root.backgroundColor = this.getTheme().accentColor;
	      styles.root.color = this.getTheme().selectTextColor;
	    }
	
	    var transformPos = positions[pos];
	
	    if (inner) {
	      styles.root.width = 28;
	      styles.root.height = 28;
	      styles.root.left = 'calc(50% - 14px)';
	      transformPos = innerPositions[pos];
	    }
	
	    var _transformPos = transformPos;
	
	    var _transformPos2 = _slicedToArray(_transformPos, 2);
	
	    var x = _transformPos2[0];
	    var y = _transformPos2[1];
	
	    styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	    return _react2.default.createElement(
	      'span',
	      { style: this.prepareStyles(styles.root) },
	      this.props.value
	    );
	  }
	});
	
	exports.default = ClockNumber;
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockPointer = _react2.default.createClass({
	  displayName: 'ClockPointer',
	
	  propTypes: {
	    hasSelected: _react2.default.PropTypes.bool,
	    type: _react2.default.PropTypes.oneOf(['hour', 'minute']),
	    value: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: null,
	      type: 'minute',
	      hasSelected: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      inner: this.isInner(this.props.value),
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      inner: this.isInner(nextProps.value),
	      muiTheme: newMuiTheme
	    });
	  },
	  isInner: function isInner(value) {
	    if (this.props.type !== 'hour') {
	      return false;
	    }
	    return value < 1 || value > 12;
	  },
	  getAngle: function getAngle() {
	    if (this.props.type === 'hour') {
	      return this.calcAngle(this.props.value, 12);
	    }
	
	    return this.calcAngle(this.props.value, 60);
	  },
	  calcAngle: function calcAngle(value, base) {
	    value %= base;
	    var angle = 360 / base * value;
	    return angle;
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.timePicker;
	  },
	  render: function render() {
	    if (this.props.value === null) {
	      return _react2.default.createElement('span', null);
	    }
	
	    var angle = this.getAngle();
	
	    var styles = {
	      root: {
	        height: '30%',
	        background: this.getTheme().accentColor,
	        width: 2,
	        left: 'calc(50% - 1px)',
	        position: 'absolute',
	        bottom: '50%',
	        transformOrigin: 'bottom',
	        pointerEvents: 'none',
	        transform: 'rotateZ(' + angle + 'deg)'
	      },
	      mark: {
	        background: this.getTheme().selectTextColor,
	        border: '4px solid ' + this.getTheme().accentColor,
	        width: 7,
	        height: 7,
	        position: 'absolute',
	        top: -5,
	        left: -6,
	        borderRadius: '100%'
	      }
	    };
	
	    if (!this.state.inner) {
	      styles.root.height = '40%';
	    }
	
	    if (this.props.hasSelected) {
	      styles.mark.display = 'none';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(styles.root) },
	      _react2.default.createElement('div', { style: this.prepareStyles(styles.mark) })
	    );
	  }
	});
	
	exports.default = ClockPointer;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _enhancedSwitch = __webpack_require__(94);
	
	var _enhancedSwitch2 = _interopRequireDefault(_enhancedSwitch);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Toggle = _react2.default.createClass({
	  displayName: 'Toggle',
	
	  propTypes: {
	    /**
	     * Determines whether the Toggle is initially turned on.
	     */
	    defaultToggled: _react2.default.PropTypes.bool,
	
	    /**
	     * Will disable the toggle if true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Overrides the inline-styles of the Toggle element.
	     */
	    elementStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Overrides the inline-styles of the Icon element.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Where the label will be placed next to the toggle.
	     */
	    labelPosition: _react2.default.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * Overrides the inline-styles of the Toggle element label.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Callback function that is fired when the toggle switch is toggled.
	     */
	    onToggle: _react2.default.PropTypes.func,
	
	    /**
	     * Override style of ripple.
	     */
	    rippleStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Override style for thumb.
	     */
	    thumbStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Toggled if set to true.
	     */
	    toggled: _react2.default.PropTypes.bool,
	
	    /**
	     * Override style for track.
	     */
	    trackStyle: _react2.default.PropTypes.object,
	
	    /**
	     * ValueLink prop for when using controlled toggle.
	     */
	    valueLink: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultToggled: false,
	      disabled: false,
	      labelPosition: 'left'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      switched: this.props.toggled || this.props.defaultToggled || this.props.valueLink && this.props.valueLink.value || false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.toggle;
	  },
	  getStyles: function getStyles() {
	    var toggleSize = 20;
	    var toggleTrackWidth = 36;
	    var styles = {
	      icon: {
	        width: 36,
	        padding: '4px 0px 6px 2px'
	      },
	      toggleElement: {
	        width: toggleTrackWidth
	      },
	      track: {
	        transition: _transitions2.default.easeOut(),
	        width: '100%',
	        height: 14,
	        borderRadius: 30,
	        backgroundColor: this.getTheme().trackOffColor
	      },
	      thumb: {
	        transition: _transitions2.default.easeOut(),
	        position: 'absolute',
	        top: 1,
	        left: 0,
	        width: toggleSize,
	        height: toggleSize,
	        lineHeight: '24px',
	        borderRadius: '50%',
	        backgroundColor: this.getTheme().thumbOffColor
	      },
	      trackWhenSwitched: {
	        backgroundColor: this.getTheme().trackOnColor
	      },
	      thumbWhenSwitched: {
	        backgroundColor: this.getTheme().thumbOnColor,
	        left: '100%'
	      },
	      trackWhenDisabled: {
	        backgroundColor: this.getTheme().trackDisabledColor
	      },
	      thumbWhenDisabled: {
	        backgroundColor: this.getTheme().thumbDisabledColor
	      },
	      label: {
	        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor,
	        width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	      }
	    };
	
	    return styles;
	  },
	  isToggled: function isToggled() {
	    return this.refs.enhancedSwitch.isSwitched();
	  },
	  setToggled: function setToggled(newToggledValue) {
	    this.refs.enhancedSwitch.setSwitched(newToggledValue);
	  },
	  _handleToggle: function _handleToggle(e, isInputChecked) {
	    if (this.props.onToggle) this.props.onToggle(e, isInputChecked);
	  },
	  _handleStateChange: function _handleStateChange(newSwitched) {
	    this.setState({ switched: newSwitched });
	  },
	  render: function render() {
	    var _props = this.props;
	    var onToggle = _props.onToggle;
	
	    var other = _objectWithoutProperties(_props, ['onToggle']);
	
	    var styles = this.getStyles();
	
	    var trackStyles = this.mergeStyles(styles.track, this.props.trackStyle, this.state.switched && styles.trackWhenSwitched, this.props.disabled && styles.trackWhenDisabled);
	
	    var thumbStyles = this.mergeStyles(styles.thumb, this.props.thumbStyle, this.state.switched && styles.thumbWhenSwitched, this.props.disabled && styles.thumbWhenDisabled);
	
	    if (this.state.switched) {
	      thumbStyles.marginLeft = '-' + thumbStyles.width;
	    }
	
	    var toggleElementStyles = this.mergeStyles(styles.toggleElement, this.props.elementStyle);
	
	    var toggleElement = _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(toggleElementStyles) },
	      _react2.default.createElement('div', { style: this.prepareStyles(trackStyles) }),
	      _react2.default.createElement(_paper2.default, { style: thumbStyles, circle: true, zDepth: 1 })
	    );
	
	    var customRippleStyle = this.mergeStyles({
	      top: -10,
	      left: -10
	    }, this.props.rippleStyle);
	
	    var rippleColor = this.state.switched ? this.getTheme().thumbOnColor : this.state.muiTheme.textColor;
	
	    var iconStyle = this.mergeStyles(styles.icon, this.props.iconStyle);
	
	    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);
	
	    var enhancedSwitchProps = {
	      ref: 'enhancedSwitch',
	      inputType: 'checkbox',
	      switchElement: toggleElement,
	      rippleStyle: customRippleStyle,
	      rippleColor: rippleColor,
	      iconStyle: iconStyle,
	      trackStyle: trackStyles,
	      thumbStyle: thumbStyles,
	      labelStyle: labelStyle,
	      switched: this.state.switched,
	      onSwitch: this._handleToggle,
	      onParentShouldUpdate: this._handleStateChange,
	      defaultSwitched: this.props.defaultToggled,
	      labelPosition: this.props.labelPosition
	    };
	
	    if (this.props.hasOwnProperty('toggled')) enhancedSwitchProps.checked = this.props.toggled;
	
	    return _react2.default.createElement(_enhancedSwitch2.default, _extends({}, other, enhancedSwitchProps));
	  }
	});
	
	exports.default = Toggle;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ToolbarGroup = _react2.default.createClass({
	  displayName: 'ToolbarGroup',
	
	  propTypes: {
	    /**
	     * Can be any node or number of nodes.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	     * to prevent setting the left gap.
	     */
	    firstChild: _react2.default.PropTypes.bool,
	
	    /**
	     * Determines the side the `ToolbarGroup` will snap to. Either 'left' or 'right'.
	     */
	    float: _react2.default.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	     * to prevent setting the right gap.
	     */
	    lastChild: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      firstChild: false,
	      float: 'left',
	      lastChild: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.toolbar;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    var _props = this.props;
	    var firstChild = _props.firstChild;
	    var float = _props.float;
	    var lastChild = _props.lastChild;
	
	    var marginHorizontal = this.getSpacing().desktopGutter;
	    var marginVertical = (this.getTheme().height - this.state.muiTheme.button.height) / 2;
	    var styles = {
	      root: {
	        float: float,
	        position: 'relative',
	        marginLeft: firstChild ? -marginHorizontal : undefined,
	        marginRight: lastChild ? -marginHorizontal : undefined
	      },
	      dropDownMenu: {
	        root: {
	          float: 'left',
	          color: _colors2.default.lightBlack, // removes hover color change, we want to keep it
	          display: 'inline-block',
	          marginRight: this.getSpacing().desktopGutter
	        },
	        controlBg: {
	          backgroundColor: this.getTheme().menuHoverColor,
	          borderRadius: 0
	        },
	        underline: {
	          display: 'none'
	        }
	      },
	      button: {
	        float: 'left',
	        margin: marginVertical + 'px ' + marginHorizontal + 'px',
	        position: 'relative'
	      },
	      icon: {
	        root: {
	          float: 'left',
	          cursor: 'pointer',
	          color: this.getTheme().iconColor,
	          lineHeight: this.getTheme().height + 'px',
	          paddingLeft: this.getSpacing().desktopGutter
	        },
	        hover: {
	          color: _colors2.default.darkBlack
	        }
	      },
	      span: {
	        float: 'left',
	        color: this.getTheme().iconColor,
	        lineHeight: this.getTheme().height + 'px'
	      }
	    };
	
	    return styles;
	  },
	  _handleMouseEnterDropDownMenu: function _handleMouseEnterDropDownMenu(e) {
	    e.target.style.zIndex = this.getStyles().icon.hover.zIndex;
	    e.target.style.color = this.getStyles().icon.hover.color;
	  },
	  _handleMouseLeaveDropDownMenu: function _handleMouseLeaveDropDownMenu(e) {
	    e.target.style.zIndex = 'auto';
	    e.target.style.color = this.getStyles().icon.root.color;
	  },
	  _handleMouseEnterFontIcon: function _handleMouseEnterFontIcon(e) {
	    e.target.style.zIndex = this.getStyles().icon.hover.zIndex;
	    e.target.style.color = this.getStyles().icon.hover.color;
	  },
	  _handleMouseLeaveFontIcon: function _handleMouseLeaveFontIcon(e) {
	    e.target.style.zIndex = 'auto';
	    e.target.style.color = this.getStyles().icon.root.color;
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var children = _props2.children;
	    var className = _props2.className;
	    var style = _props2.style;
	
	    var other = _objectWithoutProperties(_props2, ['children', 'className', 'style']);
	
	    var styles = this.getStyles();
	    var newChildren = _react2.default.Children.map(children, function (currentChild) {
	      if (!currentChild) {
	        return null;
	      }
	      if (!currentChild.type) {
	        return currentChild;
	      }
	      switch (currentChild.type.displayName) {
	        case 'DropDownMenu':
	          return _react2.default.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.dropDownMenu.root, currentChild.props.style),
	            styleControlBg: styles.dropDownMenu.controlBg,
	            styleUnderline: styles.dropDownMenu.underline
	          });
	        case 'DropDownIcon':
	          return _react2.default.cloneElement(currentChild, {
	            style: _this.mergeStyles({ float: 'left' }, currentChild.props.style),
	            iconStyle: styles.icon.root,
	            onMouseEnter: _this._handleMouseEnterDropDownMenu,
	            onMouseLeave: _this._handleMouseLeaveDropDownMenu
	          });
	        case 'RaisedButton':
	        case 'FlatButton':
	          return _react2.default.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.button, currentChild.props.style)
	          });
	        case 'FontIcon':
	          return _react2.default.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.icon.root, currentChild.props.style),
	            onMouseEnter: _this._handleMouseEnterFontIcon,
	            onMouseLeave: _this._handleMouseLeaveFontIcon
	          });
	        case 'ToolbarSeparator':
	        case 'ToolbarTitle':
	          return _react2.default.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.span, currentChild.props.style)
	          });
	        default:
	          return currentChild;
	      }
	    }, this);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { className: className, style: this.prepareStyles(styles.root, style) }),
	      newChildren
	    );
	  }
	});
	
	exports.default = ToolbarGroup;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Toolbar = _react2.default.createClass({
	  displayName: 'Toolbar',
	
	  propTypes: {
	    /**
	     * Can be a `ToolbarGroup` to render a group of related items.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Do not apply `desktopGutter` to the `Toolbar`.
	     */
	    noGutter: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      noGutter: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.toolbar;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        backgroundColor: this.getTheme().backgroundColor,
	        height: this.getTheme().height,
	        width: '100%',
	        padding: this.props.noGutter ? 0 : '0px ' + this.getSpacing().desktopGutter + 'px'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'className', 'style']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { className: className, style: this.prepareStyles(styles.root, style) }),
	      children
	    );
	  }
	});
	
	exports.default = Toolbar;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  _testSupportedProps: function _testSupportedProps(props) {
	    var i = undefined;
	    var el = document.createElement('div');
	
	    for (i in props) {
	      if (props.hasOwnProperty(i) && el.style[i] !== undefined) {
	        return props[i];
	      }
	    }
	  },
	
	  //Returns the correct event name to use
	  transitionEndEventName: function transitionEndEventName() {
	    return this._testSupportedProps({
	      'transition': 'transitionend',
	      'OTransition': 'otransitionend',
	      'MozTransition': 'transitionend',
	      'WebkitTransition': 'webkitTransitionEnd'
	    });
	  },
	  animationEndEventName: function animationEndEventName() {
	    return this._testSupportedProps({
	      'animation': 'animationend',
	      '-o-animation': 'oAnimationEnd',
	      '-moz-animation': 'animationend',
	      '-webkit-animation': 'webkitAnimationEnd'
	    });
	  },
	  onTransitionEnd: function onTransitionEnd(el, callback) {
	    var transitionEnd = this.transitionEndEventName();
	
	    _events2.default.once(el, transitionEnd, function () {
	      return callback();
	    });
	  },
	  onAnimationEnd: function onAnimationEnd(el, callback) {
	    var animationEnd = this.animationEndEventName();
	
	    _events2.default.once(el, animationEnd, function () {
	      return callback();
	    });
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  Desktop: {
	    GUTTER: 24,
	    GUTTER_LESS: 16,
	    INCREMENT: 64,
	    MENU_ITEM_HEIGHT: 32
	  },
	
	  getIncrementalDim: function getIncrementalDim(dim) {
	    return Math.ceil(dim / this.Desktop.INCREMENT) * this.Desktop.INCREMENT;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports) {

	// helper to capitalize strings
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports["default"] = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.3.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var arrayCopy = __webpack_require__(344),
	    arrayEach = __webpack_require__(345),
	    createAssigner = __webpack_require__(346),
	    isArguments = __webpack_require__(73),
	    isArray = __webpack_require__(106),
	    isPlainObject = __webpack_require__(351),
	    isTypedArray = __webpack_require__(353),
	    keys = __webpack_require__(354),
	    toPlainObject = __webpack_require__(355);
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.merge` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {Object} Returns `object`.
	 */
	function baseMerge(object, source, customizer, stackA, stackB) {
	  if (!isObject(object)) {
	    return object;
	  }
	  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	      props = isSrcArr ? undefined : keys(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObjectLike(srcValue)) {
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	    }
	    else {
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	      }
	      if ((result !== undefined || (isSrcArr && !(key in object))) &&
	          (isCommon || (result === result ? (result !== value) : (value === value)))) {
	        object[key] = result;
	      }
	    }
	  });
	  return object;
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	  var length = stackA.length,
	      srcValue = source[key];
	
	  while (length--) {
	    if (stackA[length] == srcValue) {
	      object[key] = stackB[length];
	      return;
	    }
	  }
	  var value = object[key],
	      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	      isCommon = result === undefined;
	
	  if (isCommon) {
	    result = srcValue;
	    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	      result = isArray(value)
	        ? value
	        : (isArrayLike(value) ? arrayCopy(value) : []);
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      result = isArguments(value)
	        ? toPlainObject(value)
	        : (isPlainObject(value) ? value : {});
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate
	  // it with its merged value.
	  stackA.push(srcValue);
	  stackB.push(result);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	  } else if (result === result ? (result !== value) : (value === value)) {
	    object[key] = result;
	  }
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Recursively merges own enumerable properties of the source object(s), that
	 * don't resolve to `undefined` into the destination object. Subsequent sources
	 * overwrite property assignments of previous sources. If `customizer` is
	 * provided it is invoked to produce the merged values of the destination and
	 * source properties. If `customizer` returns `undefined` merging is handled
	 * by the method instead. The `customizer` is bound to `thisArg` and invoked
	 * with five arguments: (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 *
	 * // using a customizer callback
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.merge(object, other, function(a, b) {
	 *   if (_.isArray(a)) {
	 *     return a.concat(b);
	 *   }
	 * });
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var merge = createAssigner(baseMerge);
	
	module.exports = merge;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(73),
	    isArray = __webpack_require__(106);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(376);
	var ReactMultiChildUpdateTypes = __webpack_require__(185);
	var ReactPerf = __webpack_require__(20);
	
	var setInnerHTML = __webpack_require__(83);
	var setTextContent = __webpack_require__(123);
	var invariant = __webpack_require__(5);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(173);
	var ReactDOMServer = __webpack_require__(392);
	var ReactIsomorphic = __webpack_require__(398);
	
	var assign = __webpack_require__(7);
	var deprecated = __webpack_require__(422);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(172);
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocations = __webpack_require__(78);
	var ReactPropTypeLocationNames = __webpack_require__(77);
	var ReactNoopUpdateQueue = __webpack_require__(187);
	
	var assign = __webpack_require__(7);
	var emptyObject = __webpack_require__(65);
	var invariant = __webpack_require__(5);
	var keyMirror = __webpack_require__(84);
	var keyOf = __webpack_require__(33);
	var warning = __webpack_require__(8);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(187);
	
	var canDefineProperty = __webpack_require__(81);
	var emptyObject = __webpack_require__(65);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactDOMTextComponent = __webpack_require__(176);
	var ReactDefaultInjection = __webpack_require__(178);
	var ReactInstanceHandles = __webpack_require__(51);
	var ReactMount = __webpack_require__(15);
	var ReactPerf = __webpack_require__(20);
	var ReactReconciler = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(21);
	var ReactVersion = __webpack_require__(115);
	
	var findDOMNode = __webpack_require__(116);
	var renderSubtreeIntoContainer = __webpack_require__(427);
	var warning = __webpack_require__(8);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(109);
	var ReactMount = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(21);
	
	var assign = __webpack_require__(7);
	var warning = __webpack_require__(8);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(168);
	var DOMPropertyOperations = __webpack_require__(108);
	var ReactComponentBrowserEnvironment = __webpack_require__(111);
	var ReactMount = __webpack_require__(15);
	
	var assign = __webpack_require__(7);
	var escapeTextContentForBrowser = __webpack_require__(82);
	var setTextContent = __webpack_require__(123);
	var validateDOMNesting = __webpack_require__(126);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(21);
	var Transaction = __webpack_require__(80);
	
	var assign = __webpack_require__(7);
	var emptyFunction = __webpack_require__(18);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(372);
	var ChangeEventPlugin = __webpack_require__(374);
	var ClientReactRootIndex = __webpack_require__(375);
	var DefaultEventPluginOrder = __webpack_require__(377);
	var EnterLeaveEventPlugin = __webpack_require__(378);
	var ExecutionEnvironment = __webpack_require__(13);
	var HTMLDOMPropertyConfig = __webpack_require__(381);
	var ReactBrowserComponentMixin = __webpack_require__(382);
	var ReactComponentBrowserEnvironment = __webpack_require__(111);
	var ReactDefaultBatchingStrategy = __webpack_require__(177);
	var ReactDOMComponent = __webpack_require__(387);
	var ReactDOMTextComponent = __webpack_require__(176);
	var ReactEventListener = __webpack_require__(395);
	var ReactInjection = __webpack_require__(397);
	var ReactInstanceHandles = __webpack_require__(51);
	var ReactMount = __webpack_require__(15);
	var ReactReconcileTransaction = __webpack_require__(401);
	var SelectEventPlugin = __webpack_require__(409);
	var ServerReactRootIndex = __webpack_require__(410);
	var SimpleEventPlugin = __webpack_require__(411);
	var SVGDOMPropertyConfig = __webpack_require__(408);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocations = __webpack_require__(78);
	var ReactPropTypeLocationNames = __webpack_require__(77);
	var ReactCurrentOwner = __webpack_require__(32);
	
	var canDefineProperty = __webpack_require__(81);
	var getIteratorFn = __webpack_require__(120);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactEmptyComponentRegistry = __webpack_require__(181);
	var ReactReconciler = __webpack_require__(44);
	
	var assign = __webpack_require__(7);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(391);
	
	var containsNode = __webpack_require__(197);
	var focusNode = __webpack_require__(198);
	var getActiveElement = __webpack_require__(199);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(420);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(84);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(8);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocationNames = __webpack_require__(77);
	
	var emptyFunction = __webpack_require__(18);
	var getIteratorFn = __webpack_require__(120);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 189 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 190 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(125);
	var warning = __webpack_require__(8);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 193 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(438);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = devTools;
	var ActionTypes = {
	  PERFORM_ACTION: 'PERFORM_ACTION',
	  RESET: 'RESET',
	  ROLLBACK: 'ROLLBACK',
	  COMMIT: 'COMMIT',
	  SWEEP: 'SWEEP',
	  TOGGLE_ACTION: 'TOGGLE_ACTION',
	  JUMP_TO_STATE: 'JUMP_TO_STATE',
	  SET_MONITOR_STATE: 'SET_MONITOR_STATE',
	  RECOMPUTE_STATES: 'RECOMPUTE_STATES'
	};
	
	var INIT_ACTION = {
	  type: '@@INIT'
	};
	
	function toggle(obj, key) {
	  var clone = _extends({}, obj);
	  if (clone[key]) {
	    delete clone[key];
	  } else {
	    clone[key] = true;
	  }
	  return clone;
	}
	
	/**
	 * Computes the next entry in the log by applying an action.
	 */
	function computeNextEntry(reducer, action, state, error) {
	  if (error) {
	    return {
	      state: state,
	      error: 'Interrupted by an error up the chain'
	    };
	  }
	
	  var nextState = state;
	  var nextError = undefined;
	  try {
	    nextState = reducer(state, action);
	  } catch (err) {
	    nextError = err.toString();
	    console.error(err.stack || err);
	  }
	
	  return {
	    state: nextState,
	    error: nextError
	  };
	}
	
	/**
	 * Runs the reducer on all actions to get a fresh computation log.
	 * It's probably a good idea to do this only if the code has changed,
	 * but until we have some tests we'll just do it every time an action fires.
	 */
	function recomputeStates(reducer, committedState, stagedActions, skippedActions) {
	  var computedStates = [];
	
	  for (var i = 0; i < stagedActions.length; i++) {
	    var action = stagedActions[i];
	
	    var previousEntry = computedStates[i - 1];
	    var previousState = previousEntry ? previousEntry.state : committedState;
	    var previousError = previousEntry ? previousEntry.error : undefined;
	
	    var shouldSkip = Boolean(skippedActions[i]);
	    var entry = shouldSkip ? previousEntry : computeNextEntry(reducer, action, previousState, previousError);
	
	    computedStates.push(entry);
	  }
	
	  return computedStates;
	}
	
	/**
	 * Lifts the app state reducer into a DevTools state reducer.
	 */
	function liftReducer(reducer, initialState) {
	  var initialLiftedState = {
	    committedState: initialState,
	    stagedActions: [INIT_ACTION],
	    skippedActions: {},
	    currentStateIndex: 0,
	    monitorState: {
	      isVisible: true
	    },
	    timestamps: [Date.now()]
	  };
	
	  /**
	   * Manages how the DevTools actions modify the DevTools state.
	   */
	  return function liftedReducer(liftedState, liftedAction) {
	    if (liftedState === undefined) liftedState = initialLiftedState;
	
	    var shouldRecomputeStates = true;
	    var committedState = liftedState.committedState;
	    var stagedActions = liftedState.stagedActions;
	    var skippedActions = liftedState.skippedActions;
	    var computedStates = liftedState.computedStates;
	    var currentStateIndex = liftedState.currentStateIndex;
	    var monitorState = liftedState.monitorState;
	    var timestamps = liftedState.timestamps;
	
	    switch (liftedAction.type) {
	      case ActionTypes.RESET:
	        committedState = initialState;
	        stagedActions = [INIT_ACTION];
	        skippedActions = {};
	        currentStateIndex = 0;
	        timestamps = [liftedAction.timestamp];
	        break;
	      case ActionTypes.COMMIT:
	        committedState = computedStates[currentStateIndex].state;
	        stagedActions = [INIT_ACTION];
	        skippedActions = {};
	        currentStateIndex = 0;
	        timestamps = [liftedAction.timestamp];
	        break;
	      case ActionTypes.ROLLBACK:
	        stagedActions = [INIT_ACTION];
	        skippedActions = {};
	        currentStateIndex = 0;
	        timestamps = [liftedAction.timestamp];
	        break;
	      case ActionTypes.TOGGLE_ACTION:
	        skippedActions = toggle(skippedActions, liftedAction.index);
	        break;
	      case ActionTypes.JUMP_TO_STATE:
	        currentStateIndex = liftedAction.index;
	        // Optimization: we know the history has not changed.
	        shouldRecomputeStates = false;
	        break;
	      case ActionTypes.SWEEP:
	        stagedActions = stagedActions.filter(function (_, i) {
	          return !skippedActions[i];
	        });
	        timestamps = timestamps.filter(function (_, i) {
	          return !skippedActions[i];
	        });
	        skippedActions = {};
	        currentStateIndex = Math.min(currentStateIndex, stagedActions.length - 1);
	        break;
	      case ActionTypes.PERFORM_ACTION:
	        if (currentStateIndex === stagedActions.length - 1) {
	          currentStateIndex++;
	        }
	
	        stagedActions = [].concat(stagedActions, [liftedAction.action]);
	        timestamps = [].concat(timestamps, [liftedAction.timestamp]);
	
	        // Optimization: we know that the past has not changed.
	        shouldRecomputeStates = false;
	        // Instead of recomputing the states, append the next one.
	        var previousEntry = computedStates[computedStates.length - 1];
	        var nextEntry = computeNextEntry(reducer, liftedAction.action, previousEntry.state, previousEntry.error);
	        computedStates = [].concat(computedStates, [nextEntry]);
	        break;
	      case ActionTypes.SET_MONITOR_STATE:
	        monitorState = liftedAction.monitorState;
	        break;
	      case ActionTypes.RECOMPUTE_STATES:
	        stagedActions = liftedAction.stagedActions;
	        timestamps = liftedAction.timestamps;
	        committedState = liftedAction.committedState;
	        currentStateIndex = stagedActions.length - 1;
	        skippedActions = {};
	        break;
	      default:
	        break;
	    }
	
	    if (shouldRecomputeStates) {
	      computedStates = recomputeStates(reducer, committedState, stagedActions, skippedActions);
	    }
	
	    return {
	      committedState: committedState,
	      stagedActions: stagedActions,
	      skippedActions: skippedActions,
	      computedStates: computedStates,
	      currentStateIndex: currentStateIndex,
	      monitorState: monitorState,
	      timestamps: timestamps
	    };
	  };
	}
	
	/**
	 * Lifts an app action to a DevTools action.
	 */
	function liftAction(action) {
	  var liftedAction = {
	    type: ActionTypes.PERFORM_ACTION,
	    action: action,
	    timestamp: Date.now()
	  };
	  return liftedAction;
	}
	
	/**
	 * Unlifts the DevTools state to the app state.
	 */
	function unliftState(liftedState) {
	  var computedStates = liftedState.computedStates;
	  var currentStateIndex = liftedState.currentStateIndex;
	  var state = computedStates[currentStateIndex].state;
	
	  return state;
	}
	
	/**
	 * Unlifts the DevTools store to act like the app's store.
	 */
	function unliftStore(liftedStore, reducer) {
	  var lastDefinedState = undefined;
	  return _extends({}, liftedStore, {
	    devToolsStore: liftedStore,
	    dispatch: function dispatch(action) {
	      liftedStore.dispatch(liftAction(action));
	      return action;
	    },
	    getState: function getState() {
	      var state = unliftState(liftedStore.getState());
	      if (state !== undefined) {
	        lastDefinedState = state;
	      }
	      return lastDefinedState;
	    },
	    getReducer: function getReducer() {
	      return reducer;
	    },
	    replaceReducer: function replaceReducer(nextReducer) {
	      liftedStore.replaceReducer(liftReducer(nextReducer));
	    }
	  });
	}
	
	/**
	 * Action creators to change the DevTools state.
	 */
	var ActionCreators = {
	  reset: function reset() {
	    return { type: ActionTypes.RESET, timestamp: Date.now() };
	  },
	  rollback: function rollback() {
	    return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
	  },
	  commit: function commit() {
	    return { type: ActionTypes.COMMIT, timestamp: Date.now() };
	  },
	  sweep: function sweep() {
	    return { type: ActionTypes.SWEEP };
	  },
	  toggleAction: function toggleAction(index) {
	    return { type: ActionTypes.TOGGLE_ACTION, index: index };
	  },
	  jumpToState: function jumpToState(index) {
	    return { type: ActionTypes.JUMP_TO_STATE, index: index };
	  },
	  setMonitorState: function setMonitorState(monitorState) {
	    return { type: ActionTypes.SET_MONITOR_STATE, monitorState: monitorState };
	  },
	  recomputeStates: function recomputeStates(committedState, stagedActions) {
	    return {
	      type: ActionTypes.RECOMPUTE_STATES,
	      committedState: committedState,
	      stagedActions: stagedActions
	    };
	  }
	};
	
	exports.ActionCreators = ActionCreators;
	/**
	 * Redux DevTools middleware.
	 */
	
	function devTools() {
	  return function (next) {
	    return function (reducer, initialState) {
	      var liftedReducer = liftReducer(reducer, initialState);
	      var liftedStore = next(liftedReducer);
	      var store = unliftStore(liftedStore, reducer);
	      return store;
	    };
	  };
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// ES6 + inline style port of JSONViewer https://bitbucket.org/davevedder/react-json-viewer/
	// all credits and original code to the author
	// Dave Vedder <veddermatic@gmail.com> http://www.eskimospy.com/
	// port by Daniele Zannotti http://www.github.com/dzannotti <dzannotti@me.com>
	
	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _createClass = __webpack_require__(511)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grabNode = __webpack_require__(85);
	
	var _grabNode2 = _interopRequireDefault(_grabNode);
	
	var _themesSolarized = __webpack_require__(502);
	
	var _themesSolarized2 = _interopRequireDefault(_themesSolarized);
	
	var styles = {
	  tree: {
	    border: 0,
	    padding: 0,
	    marginTop: 8,
	    marginBottom: 8,
	    marginLeft: 2,
	    marginRight: 0,
	    fontSize: '0.90em',
	    listStyle: 'none',
	    MozUserSelect: 'none',
	    WebkitUserSelect: 'none'
	  }
	};
	
	var JSONTree = (function (_React$Component) {
	  _inherits(JSONTree, _React$Component);
	
	  _createClass(JSONTree, null, [{
	    key: 'propTypes',
	    value: {
	      data: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]).isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      theme: _themesSolarized2['default']
	    },
	    enumerable: true
	  }]);
	
	  function JSONTree(props) {
	    _classCallCheck(this, JSONTree);
	
	    _React$Component.call(this, props);
	  }
	
	  JSONTree.prototype.render = function render() {
	    var keyName = this.props.keyName || 'root';
	    var rootNode = _grabNode2['default'](keyName, this.props.data, this.props.previousData, this.props.theme, true);
	    return _react2['default'].createElement(
	      'ul',
	      { style: _extends({}, styles.tree, this.props.style) },
	      rootNode
	    );
	  };
	
	  return JSONTree;
	})(_react2['default'].Component);
	
	exports['default'] = JSONTree;
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(133);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 204 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(521);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 206 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(204);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(528)
	  , $export        = __webpack_require__(67)
	  , redefine       = __webpack_require__(531)
	  , hide           = __webpack_require__(132)
	  , has            = __webpack_require__(206)
	  , Iterators      = __webpack_require__(86)
	  , $iterCreate    = __webpack_require__(526)
	  , setToStringTag = __webpack_require__(210)
	  , getProto       = __webpack_require__(39).getProto
	  , ITERATOR       = __webpack_require__(52)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 209 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(39).setDesc
	  , has = __webpack_require__(206)
	  , TAG = __webpack_require__(52)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(129);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(534)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(208)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(540);
	var Iterators = __webpack_require__(86);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ },
/* 214 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createStoreShape;
	
	function createStoreShape(PropTypes) {
	  return PropTypes.shape({
	    subscribe: PropTypes.func.isRequired,
	    dispatch: PropTypes.func.isRequired,
	    getState: PropTypes.func.isRequired
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 215 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing functions from right to
	 * left. For example, compose(f, g, h) is identical to arg => f(g(h(arg))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function () {
	    if (funcs.length === 0) {
	      return arguments.length <= 0 ? undefined : arguments[0];
	    }
	
	    var last = funcs[funcs.length - 1];
	    var rest = funcs.slice(0, -1);
	
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(218);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all states changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  };
	}

/***/ },
/* 217 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var isHostObject = __webpack_require__(558),
	    isObjectLike = __webpack_require__(559);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = objectProto;
	  if (typeof value.constructor == 'function') {
	    proto = getPrototypeOf(value);
	  }
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";

	// import {} from '../constants/action-constants';

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(41);
	
	var _actionsDummyActions = __webpack_require__(87);
	
	var DummyActions = _interopRequireWildcard(_actionsDummyActions);
	
	var _actionsRouteActions = __webpack_require__(134);
	
	var RouteActions = _interopRequireWildcard(_actionsRouteActions);
	
	var _AppContainerJs = __webpack_require__(68);
	
	var _AppContainerJs2 = _interopRequireDefault(_AppContainerJs);
	
	var _componentsDummyComponentDummyComponent = __webpack_require__(89);
	
	var _componentsDummyComponentDummyComponent2 = _interopRequireDefault(_componentsDummyComponentDummyComponent);
	
	var _componentsHomeSpiral = __webpack_require__(135);
	
	var _componentsHomeSpiral2 = _interopRequireDefault(_componentsHomeSpiral);
	
	var _actionsSpiralActions = __webpack_require__(88);
	
	var SpiralActions = _interopRequireWildcard(_actionsSpiralActions);
	
	var _HomeContainer = __webpack_require__(90);
	
	var _HomeContainer2 = _interopRequireDefault(_HomeContainer);
	
	var _componentsTag = __webpack_require__(136);
	
	var _componentsTag2 = _interopRequireDefault(_componentsTag);
	
	var _immutable = __webpack_require__(47);
	
	var _materialUi = __webpack_require__(95);
	
	var _materialUi2 = _interopRequireDefault(_materialUi);
	
	var RaisedButton = _materialUi2['default'].RaisedButton;
	var TextField = _materialUi2['default'].TextField;
	
	var PingContainer = (function (_Component) {
	  _inherits(PingContainer, _Component);
	
	  function PingContainer(props) {
	    _classCallCheck(this, PingContainer);
	
	    _get(Object.getPrototypeOf(PingContainer.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      pingTime: new Date(),
	      selected: (0, _immutable.Set)(),
	      newTag: ''
	    };
	  }
	
	  _createClass(PingContainer, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var handleTagTap = function handleTagTap(tag) {
	        return function () {
	          if (_this.state.selected.includes(tag)) {
	            _this.setState({ selected: _this.state.selected['delete'](tag) });
	          } else {
	            _this.setState({ selected: _this.state.selected.add(tag) });
	          }
	        };
	      };
	      console.log(this.state.selected);
	      var tagSelected = function tagSelected(tag) {
	        return _this.state.selected.includes(tag);
	      };
	      var makeTag = function makeTag(tag) {
	        return _react2['default'].createElement(_componentsTag2['default'], { tag: tag, selected: tagSelected(tag), onChange: handleTagTap(tag) });
	      };
	      var _props = this.props;
	      var spiral = _props.spiral;
	      var spiralActions = _props.spiralActions;
	      var route = _props.route;
	      var routeActions = _props.routeActions;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(TextField, { hintText: 'New Tag', value: this.state.newTag, onChange: function (v) {
	              return _this.setState({ newTag: v.target.value });
	            } }),
	          _react2['default'].createElement(RaisedButton, { label: 'Add Tag', onClick: function () {
	              if (_this.state.newTag && !spiral.tags.find(function (t) {
	                return t.label === _this.state.newTag;
	              })) {
	                spiralActions.add_tag(_this.state.newTag);
	              }
	            } })
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          spiral.tags.map(makeTag)
	        ),
	        _react2['default'].createElement(RaisedButton, {
	          label: 'Create Data Point',
	          primary: true,
	          style: { float: 'right' }, onClick: function () {
	            spiralActions.add_ping_data(_this.state.selected.toList().toJS());
	            routeActions.setRoute(_HomeContainer2['default']);
	          } })
	      );
	    }
	  }]);
	
	  return PingContainer;
	})(_react.Component);
	
	function mapState(state) {
	  console.log(state);
	  return {
	    route: state.route.toJS(),
	    spiral: state.spiral.toJS()
	  };
	}
	
	function mapDispatch(dispatch) {
	  return {
	    routeActions: (0, _redux.bindActionCreators)(RouteActions, dispatch),
	    spiralActions: (0, _redux.bindActionCreators)(SpiralActions, dispatch)
	  };
	}
	
	exports['default'] = (0, _reactRedux.connect)(mapState, mapDispatch)(PingContainer);
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var _constantsActionConstants = __webpack_require__(46);
	
	var initialState = new _immutable.Map({
	  list: new _immutable.List([]),
	  map: new _immutable.Map(),
	  counter: 0
	});
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    case _constantsActionConstants.DUMMY_INCREMENT_ACTION:
	      return state.set('counter', state.get('counter') + 1);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = reducer;
	
	var _immutable = __webpack_require__(47);
	
	var initialState = (0, _immutable.Map)({
	  inHere: true
	});
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(41);
	
	var _dummy = __webpack_require__(221);
	
	var _dummy2 = _interopRequireDefault(_dummy);
	
	var _route = __webpack_require__(224);
	
	var _route2 = _interopRequireDefault(_route);
	
	var _home = __webpack_require__(222);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _spiral = __webpack_require__(225);
	
	var _spiral2 = _interopRequireDefault(_spiral);
	
	exports['default'] = (0, _redux.combineReducers)({
	  route: _route2['default'],
	  dummy: _dummy2['default'],
	  home: _home2['default'],
	  spiral: _spiral2['default']
	});
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = reducer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__(47);
	
	var _constantsActionConstants = __webpack_require__(46);
	
	var _containersAppContainerJs = __webpack_require__(68);
	
	var _containersAppContainerJs2 = _interopRequireDefault(_containersAppContainerJs);
	
	var _containersHomeContainerJs = __webpack_require__(90);
	
	var _containersHomeContainerJs2 = _interopRequireDefault(_containersHomeContainerJs);
	
	var initialState = new _immutable.Map({
	  route: _containersHomeContainerJs2['default']
	});
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    case _constantsActionConstants.CHANGE_ROUTE_ACTION:
	      console.log('changing route', action);
	      return state.set('route', action.route);
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = reducer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__(47);
	
	var _constantsActionConstants = __webpack_require__(46);
	
	var _containersAppContainerJs = __webpack_require__(68);
	
	var _containersAppContainerJs2 = _interopRequireDefault(_containersAppContainerJs);
	
	var _containersHomeContainerJs = __webpack_require__(90);
	
	var _containersHomeContainerJs2 = _interopRequireDefault(_containersHomeContainerJs);
	
	function loadPings() {
	  var local = localStorage.getItem('pings');
	  if (local) {
	    return (0, _immutable.List)(JSON.parse(local));
	  } else {
	    return (0, _immutable.List)();
	  }
	}
	
	function writePings(pings) {
	  localStorage.setItem('pings', JSON.stringify(pings.toJS()));
	}
	
	function loadTags() {
	  var local = localStorage.getItem('tags');
	  if (local) {
	    return (0, _immutable.List)(JSON.parse(local));
	  } else {
	    return (0, _immutable.List)();
	  }
	}
	
	function writeTags(tags) {
	  localStorage.setItem('tags', JSON.stringify(tags.toJS()));
	}
	
	var initialState = new _immutable.Map({
	  pings: loadPings(),
	  tags: loadTags()
	});
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    case _constantsActionConstants.ADD_TAG_ACTION:
	      console.log('creating new tag');
	      var tag = {
	        label: action.label,
	        freq: 0,
	        color: [Math.random() * 255, Math.random() * 255, Math.random() * 255]
	      };
	      return state.update('tags', function (tags) {
	        var newTags = tags.push(tag);
	        writeTags(newTags);
	        return newTags;
	      });
	    case _constantsActionConstants.ADD_SPIRAL_DATA_ACTION:
	      console.log('Adding spiral data', action);
	      var ping = {
	        tags: action.ping.tags,
	        time: action.ping.time,
	        color: computeColor(action.ping.tags)
	      };
	      return state.update('pings', function (pings) {
	        var newPings = pings.push(ping);
	        writePings(newPings);
	        return newPings;
	      });
	    default:
	      return state;
	  }
	}
	
	function computeColor(tags) {
	  var avg = [0, 0, 0];
	  for (var i = 0; i < tags.length; i++) {
	    var tag = tags[i].color;
	    avg[0] += tag[0];
	    avg[1] += tag[1];
	    avg[2] += tag[2];
	  }
	  avg[0] /= tags.length;
	  avg[1] /= tags.length;
	  avg[2] /= tags.length;
	
	  return avg;
	}
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = configureStore;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _redux = __webpack_require__(41);
	
	var _reduxDevtools = __webpack_require__(443);
	
	var _reducersReducer = __webpack_require__(223);
	
	var _reducersReducer2 = _interopRequireDefault(_reducersReducer);
	
	function configureStore(initialState) {
	  return (0, _redux.createStore)(_reducersReducer2['default'], initialState);
	}
	
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(229),
	    string = __webpack_require__(230);
	
	var Color = function(obj) {
	  if (obj instanceof Color) return obj;
	  if (! (this instanceof Color)) return new Color(obj);
	
	   this.values = {
	      rgb: [0, 0, 0],
	      hsl: [0, 0, 0],
	      hsv: [0, 0, 0],
	      hwb: [0, 0, 0],
	      cmyk: [0, 0, 0, 0],
	      alpha: 1
	   }
	
	   // parse Color() argument
	   if (typeof obj == "string") {
	      var vals = string.getRgba(obj);
	      if (vals) {
	         this.setValues("rgb", vals);
	      }
	      else if(vals = string.getHsla(obj)) {
	         this.setValues("hsl", vals);
	      }
	      else if(vals = string.getHwb(obj)) {
	         this.setValues("hwb", vals);
	      }
	      else {
	        throw new Error("Unable to parse color from string \"" + obj + "\"");
	      }
	   }
	   else if (typeof obj == "object") {
	      var vals = obj;
	      if(vals["r"] !== undefined || vals["red"] !== undefined) {
	         this.setValues("rgb", vals)
	      }
	      else if(vals["l"] !== undefined || vals["lightness"] !== undefined) {
	         this.setValues("hsl", vals)
	      }
	      else if(vals["v"] !== undefined || vals["value"] !== undefined) {
	         this.setValues("hsv", vals)
	      }
	      else if(vals["w"] !== undefined || vals["whiteness"] !== undefined) {
	         this.setValues("hwb", vals)
	      }
	      else if(vals["c"] !== undefined || vals["cyan"] !== undefined) {
	         this.setValues("cmyk", vals)
	      }
	      else {
	        throw new Error("Unable to parse color from object " + JSON.stringify(obj));
	      }
	   }
	}
	
	Color.prototype = {
	   rgb: function (vals) {
	      return this.setSpace("rgb", arguments);
	   },
	   hsl: function(vals) {
	      return this.setSpace("hsl", arguments);
	   },
	   hsv: function(vals) {
	      return this.setSpace("hsv", arguments);
	   },
	   hwb: function(vals) {
	      return this.setSpace("hwb", arguments);
	   },
	   cmyk: function(vals) {
	      return this.setSpace("cmyk", arguments);
	   },
	
	   rgbArray: function() {
	      return this.values.rgb;
	   },
	   hslArray: function() {
	      return this.values.hsl;
	   },
	   hsvArray: function() {
	      return this.values.hsv;
	   },
	   hwbArray: function() {
	      if (this.values.alpha !== 1) {
	        return this.values.hwb.concat([this.values.alpha])
	      }
	      return this.values.hwb;
	   },
	   cmykArray: function() {
	      return this.values.cmyk;
	   },
	   rgbaArray: function() {
	      var rgb = this.values.rgb;
	      return rgb.concat([this.values.alpha]);
	   },
	   hslaArray: function() {
	      var hsl = this.values.hsl;
	      return hsl.concat([this.values.alpha]);
	   },
	   alpha: function(val) {
	      if (val === undefined) {
	         return this.values.alpha;
	      }
	      this.setValues("alpha", val);
	      return this;
	   },
	
	   red: function(val) {
	      return this.setChannel("rgb", 0, val);
	   },
	   green: function(val) {
	      return this.setChannel("rgb", 1, val);
	   },
	   blue: function(val) {
	      return this.setChannel("rgb", 2, val);
	   },
	   hue: function(val) {
	      return this.setChannel("hsl", 0, val);
	   },
	   saturation: function(val) {
	      return this.setChannel("hsl", 1, val);
	   },
	   lightness: function(val) {
	      return this.setChannel("hsl", 2, val);
	   },
	   saturationv: function(val) {
	      return this.setChannel("hsv", 1, val);
	   },
	   whiteness: function(val) {
	      return this.setChannel("hwb", 1, val);
	   },
	   blackness: function(val) {
	      return this.setChannel("hwb", 2, val);
	   },
	   value: function(val) {
	      return this.setChannel("hsv", 2, val);
	   },
	   cyan: function(val) {
	      return this.setChannel("cmyk", 0, val);
	   },
	   magenta: function(val) {
	      return this.setChannel("cmyk", 1, val);
	   },
	   yellow: function(val) {
	      return this.setChannel("cmyk", 2, val);
	   },
	   black: function(val) {
	      return this.setChannel("cmyk", 3, val);
	   },
	
	   hexString: function() {
	      return string.hexString(this.values.rgb);
	   },
	   rgbString: function() {
	      return string.rgbString(this.values.rgb, this.values.alpha);
	   },
	   rgbaString: function() {
	      return string.rgbaString(this.values.rgb, this.values.alpha);
	   },
	   percentString: function() {
	      return string.percentString(this.values.rgb, this.values.alpha);
	   },
	   hslString: function() {
	      return string.hslString(this.values.hsl, this.values.alpha);
	   },
	   hslaString: function() {
	      return string.hslaString(this.values.hsl, this.values.alpha);
	   },
	   hwbString: function() {
	      return string.hwbString(this.values.hwb, this.values.alpha);
	   },
	   keyword: function() {
	      return string.keyword(this.values.rgb, this.values.alpha);
	   },
	
	   rgbNumber: function() {
	      return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	   },
	
	   luminosity: function() {
	      // http://www.w3.org/TR/WCAG20/#relativeluminancedef
	      var rgb = this.values.rgb;
	      var lum = [];
	      for (var i = 0; i < rgb.length; i++) {
	         var chan = rgb[i] / 255;
	         lum[i] = (chan <= 0.03928) ? chan / 12.92
	                  : Math.pow(((chan + 0.055) / 1.055), 2.4)
	      }
	      return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	   },
	
	   contrast: function(color2) {
	      // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
	      var lum1 = this.luminosity();
	      var lum2 = color2.luminosity();
	      if (lum1 > lum2) {
	         return (lum1 + 0.05) / (lum2 + 0.05)
	      };
	      return (lum2 + 0.05) / (lum1 + 0.05);
	   },
	
	   level: function(color2) {
	     var contrastRatio = this.contrast(color2);
	     return (contrastRatio >= 7.1)
	       ? 'AAA'
	       : (contrastRatio >= 4.5)
	        ? 'AA'
	        : '';
	   },
	
	   dark: function() {
	      // YIQ equation from http://24ways.org/2010/calculating-color-contrast
	      var rgb = this.values.rgb,
	          yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
	      return yiq < 128;
	   },
	
	   light: function() {
	      return !this.dark();
	   },
	
	   negate: function() {
	      var rgb = []
	      for (var i = 0; i < 3; i++) {
	         rgb[i] = 255 - this.values.rgb[i];
	      }
	      this.setValues("rgb", rgb);
	      return this;
	   },
	
	   lighten: function(ratio) {
	      this.values.hsl[2] += this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   darken: function(ratio) {
	      this.values.hsl[2] -= this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   saturate: function(ratio) {
	      this.values.hsl[1] += this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   desaturate: function(ratio) {
	      this.values.hsl[1] -= this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   whiten: function(ratio) {
	      this.values.hwb[1] += this.values.hwb[1] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   blacken: function(ratio) {
	      this.values.hwb[2] += this.values.hwb[2] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   greyscale: function() {
	      var rgb = this.values.rgb;
	      // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
	      var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
	      this.setValues("rgb", [val, val, val]);
	      return this;
	   },
	
	   clearer: function(ratio) {
	      this.setValues("alpha", this.values.alpha - (this.values.alpha * ratio));
	      return this;
	   },
	
	   opaquer: function(ratio) {
	      this.setValues("alpha", this.values.alpha + (this.values.alpha * ratio));
	      return this;
	   },
	
	   rotate: function(degrees) {
	      var hue = this.values.hsl[0];
	      hue = (hue + degrees) % 360;
	      hue = hue < 0 ? 360 + hue : hue;
	      this.values.hsl[0] = hue;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   /**
	    * Ported from sass implementation in C
	    * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	    */
	   mix: function(mixinColor, weight) {
	      var color1 = this;
	      var color2 = mixinColor;
	      var p = weight !== undefined ? weight : 0.5;
	
	      var w = 2 * p - 1;
	      var a = color1.alpha() - color2.alpha();
	
	      var w1 = (((w * a == -1) ? w : (w + a)/(1 + w*a)) + 1) / 2.0;
	      var w2 = 1 - w1;
	
	      return this
	        .rgb(
	          w1 * color1.red() + w2 * color2.red(),
	          w1 * color1.green() + w2 * color2.green(),
	          w1 * color1.blue() + w2 * color2.blue()
	        )
	        .alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	   },
	
	   toJSON: function() {
	     return this.rgb();
	   },
	
	   clone: function() {
	     return new Color(this.rgb());
	   }
	}
	
	
	Color.prototype.getValues = function(space) {
	   var vals = {};
	   for (var i = 0; i < space.length; i++) {
	      vals[space.charAt(i)] = this.values[space][i];
	   }
	   if (this.values.alpha != 1) {
	      vals["a"] = this.values.alpha;
	   }
	   // {r: 255, g: 255, b: 255, a: 0.4}
	   return vals;
	}
	
	Color.prototype.setValues = function(space, vals) {
	   var spaces = {
	      "rgb": ["red", "green", "blue"],
	      "hsl": ["hue", "saturation", "lightness"],
	      "hsv": ["hue", "saturation", "value"],
	      "hwb": ["hue", "whiteness", "blackness"],
	      "cmyk": ["cyan", "magenta", "yellow", "black"]
	   };
	
	   var maxes = {
	      "rgb": [255, 255, 255],
	      "hsl": [360, 100, 100],
	      "hsv": [360, 100, 100],
	      "hwb": [360, 100, 100],
	      "cmyk": [100, 100, 100, 100]
	   };
	
	   var alpha = 1;
	   if (space == "alpha") {
	      alpha = vals;
	   }
	   else if (vals.length) {
	      // [10, 10, 10]
	      this.values[space] = vals.slice(0, space.length);
	      alpha = vals[space.length];
	   }
	   else if (vals[space.charAt(0)] !== undefined) {
	      // {r: 10, g: 10, b: 10}
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[space.charAt(i)];
	      }
	      alpha = vals.a;
	   }
	   else if (vals[spaces[space][0]] !== undefined) {
	      // {red: 10, green: 10, blue: 10}
	      var chans = spaces[space];
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[chans[i]];
	      }
	      alpha = vals.alpha;
	   }
	   this.values.alpha = Math.max(0, Math.min(1, (alpha !== undefined ? alpha : this.values.alpha) ));
	   if (space == "alpha") {
	      return;
	   }
	
	   // cap values of the space prior converting all values
	   for (var i = 0; i < space.length; i++) {
	      var capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
	      this.values[space][i] = Math.round(capped);
	   }
	
	   // convert to all the other color spaces
	   for (var sname in spaces) {
	      if (sname != space) {
	         this.values[sname] = convert[space][sname](this.values[space])
	      }
	
	      // cap values
	      for (var i = 0; i < sname.length; i++) {
	         var capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
	         this.values[sname][i] = Math.round(capped);
	      }
	   }
	   return true;
	}
	
	Color.prototype.setSpace = function(space, args) {
	   var vals = args[0];
	   if (vals === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof vals == "number") {
	      vals = Array.prototype.slice.call(args);
	   }
	   this.setValues(space, vals);
	   return this;
	}
	
	Color.prototype.setChannel = function(space, index, val) {
	   if (val === undefined) {
	      // color.red()
	      return this.values[space][index];
	   }
	   // color.red(100)
	   this.values[space][index] = val;
	   this.setValues(space, this.values[space]);
	   return this;
	}
	
	module.exports = Color;


/***/ },
/* 228 */
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(228);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(231);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/,
	       hex =  /^#([a-fA-F0-9]{6})$/,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       keyword = /(\D+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 231 */
/***/ function(module, exports) {

	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(151);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _menu = __webpack_require__(57);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menuItem = __webpack_require__(97);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _clearfix = __webpack_require__(53);
	
	var _clearfix2 = _interopRequireDefault(_clearfix);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _popover = __webpack_require__(58);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _popoverAnimationFromTop = __webpack_require__(278);
	
	var _popoverAnimationFromTop2 = _interopRequireDefault(_popoverAnimationFromTop);
	
	var _styles = __webpack_require__(30);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DropDownMenu = _react2.default.createClass({
	  displayName: 'DropDownMenu',
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	  propTypes: {
	    /**
	     * The width will automatically be set according to the items inside the menu.
	     * To control this width in css instead, set this prop to false.
	     */
	    autoWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	     * prop `label` that value will be used to render the representation of that
	     * item within the field.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Disables the menu.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * `DropDownMenu` will use this member to display
	     * the name of the item.
	     */
	    displayMember: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'Instead, use composability.'),
	
	    /**
	     * Overrides the styles of icon element.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * `DropDownMenu` will use this member to display
	     * the name of the item on the label.
	     */
	    labelMember: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'Instead, use composability.'),
	
	    /**
	     * Overrides the styles of label when the `DropDownMenu` is inactive.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The maximum height of the `Menu` when it is displayed.
	     */
	    maxHeight: _react2.default.PropTypes.number,
	
	    /**
	     * JSON data representing all menu items in the dropdown.
	     */
	    menuItems: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.array, 'Instead, use composability.'),
	
	    /**
	     * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	     */
	    menuStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Fired when a menu item is clicked that is not the one currently selected.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Set to true to have the `DropDownMenu` automatically open on mount.
	     */
	    openImmediately: _react2.default.PropTypes.bool,
	
	    /**
	     * Index of the item selected.
	     */
	    selectedIndex: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.number, 'Use value instead to control the component.'),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Overrides the inline-styles of the underline.
	     */
	    underlineStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The value that is currently selected.
	     */
	    value: _react2.default.PropTypes.any,
	
	    /**
	     * Two-way binding link.
	     */
	    valueLink: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.object, 'It\'s deprecated by React too.'),
	
	    /**
	     * `DropDownMenu` will use this member as the value representing an item.
	     */
	    valueMember: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'Instead, use composability.')
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoWidth: true,
	      disabled: false,
	      openImmediately: false,
	      maxHeight: 500
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      open: this.props.openImmediately,
	      selectedIndex: this._isControlled() ? null : this.props.selectedIndex || 0,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.autoWidth) this._setWidth();
	    if (this.props.hasOwnProperty('selectedIndex')) this._setSelectedIndex(this.props.selectedIndex);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (this.props.autoWidth) this._setWidth();
	    if (nextProps.hasOwnProperty('value') || nextProps.hasOwnProperty('valueLink')) {
	      return;
	    } else if (nextProps.hasOwnProperty('selectedIndex')) {
	      this._setSelectedIndex(nextProps.selectedIndex);
	    }
	  },
	  getStyles: function getStyles() {
	    var disabled = this.props.disabled;
	
	    var spacing = this.state.muiTheme.rawTheme.spacing;
	    var palette = this.state.muiTheme.rawTheme.palette;
	    var accentColor = this.state.muiTheme.dropDownMenu.accentColor;
	    return {
	      control: {
	        cursor: disabled ? 'not-allowed' : 'pointer',
	        height: '100%',
	        position: 'relative',
	        width: '100%'
	      },
	      icon: {
	        fill: accentColor,
	        position: 'absolute',
	        right: spacing.desktopGutterLess,
	        top: (spacing.desktopToolbarHeight - 24) / 2
	      },
	      label: {
	        color: disabled ? palette.disabledColor : palette.textColor,
	        lineHeight: spacing.desktopToolbarHeight + 'px',
	        opacity: 1,
	        position: 'relative',
	        paddingLeft: spacing.desktopGutter,
	        paddingRight: spacing.iconSize + spacing.desktopGutterLess + spacing.desktopGutterMini,
	        top: 0
	      },
	      labelWhenOpen: {
	        opacity: 0,
	        top: spacing.desktopToolbarHeight / 8
	      },
	      rootWhenOpen: {
	        opacity: 1
	      },
	      root: {
	        display: 'inline-block',
	        fontSize: spacing.desktopDropDownMenuFontSize,
	        height: spacing.desktopSubheaderHeight,
	        fontFamily: this.state.muiTheme.rawTheme.fontFamily,
	        outline: 'none',
	        position: 'relative',
	        transition: _transitions2.default.easeOut()
	      },
	      underline: {
	        borderTop: 'solid 1px ' + accentColor,
	        bottom: 1,
	        left: 0,
	        margin: '-1px ' + spacing.desktopGutter + 'px',
	        right: 0,
	        position: 'absolute'
	      }
	    };
	  },
	
	  /**
	   * This method is deprecated but still here because the TextField
	   * need it in order to work. That will be addressed later.
	   */
	  getInputNode: function getInputNode() {
	    var _this = this;
	
	    var root = this.refs.root;
	    var item = this.props.menuItems && this.props.menuItems[this.state.selectedIndex];
	    if (item) {
	      root.value = item[this.props.displayMember || 'text'];
	    }
	
	    root.focus = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.refs.root
	        });
	      }
	    };
	
	    return root;
	  },
	  _setWidth: function _setWidth() {
	    var el = this.refs.root;
	    if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	      el.style.width = 'auto';
	    }
	  },
	  _setSelectedIndex: function _setSelectedIndex(index) {
	     false ? (0, _warning2.default)(index >= 0, 'Cannot set selectedIndex to a negative index.') : undefined;
	    this.setState({ selectedIndex: index >= 0 ? index : 0 });
	  },
	  _onControlTouchTap: function _onControlTouchTap(event) {
	    event.preventDefault();
	    if (!this.props.disabled) {
	      this.setState({
	        open: !this.state.open,
	        anchorEl: this.refs.root
	      });
	    }
	  },
	  _onMenuItemTouchTap: function _onMenuItemTouchTap(key, payload, e) {
	    var _props = this.props;
	    var onChange = _props.onChange;
	    var menuItems = _props.menuItems;
	    var value = _props.value;
	    var valueLink = _props.valueLink;
	    var valueMember = _props.valueMember;
	
	    if (menuItems && (this.state.selectedIndex !== key || e.target.value !== value)) {
	      var selectedItem = menuItems[key];
	      if (selectedItem) {
	        e.target.value = selectedItem[valueMember || 'payload'];
	      }
	      this._onMenuRequestClose();
	    }
	
	    if (valueLink) {
	      valueLink.requestChange(e.target.value);
	    } else if (onChange) {
	      onChange(e, key, payload);
	    }
	
	    this.setState({
	      selectedIndex: key,
	      open: false
	    });
	  },
	  _onMenuRequestClose: function _onMenuRequestClose() {
	    this.setState({
	      open: false,
	      anchorEl: null
	    });
	  },
	  _isControlled: function _isControlled() {
	    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props2 = this.props;
	    var autoWidth = _props2.autoWidth;
	    var children = _props2.children;
	    var className = _props2.className;
	    var displayMember = _props2.displayMember;
	    var iconStyle = _props2.iconStyle;
	    var labelMember = _props2.labelMember;
	    var labelStyle = _props2.labelStyle;
	    var maxHeight = _props2.maxHeight;
	    var menuItems = _props2.menuItems;
	    var menuStyle = _props2.menuStyle;
	    var style = _props2.style;
	    var underlineStyle = _props2.underlineStyle;
	    var valueLink = _props2.valueLink;
	    var _props2$valueMember = _props2.valueMember;
	    var valueMember = _props2$valueMember === undefined ? 'payload' : _props2$valueMember;
	
	    var other = _objectWithoutProperties(_props2, ['autoWidth', 'children', 'className', 'displayMember', 'iconStyle', 'labelMember', 'labelStyle', 'maxHeight', 'menuItems', 'menuStyle', 'style', 'underlineStyle', 'valueLink', 'valueMember']);
	
	    var _state = this.state;
	    var anchorEl = _state.anchorEl;
	    var open = _state.open;
	    var muiTheme = _state.muiTheme;
	
	    var styles = this.getStyles();
	
	    var value = undefined;
	    var selectedIndex = this._isControlled() ? null : this.state.selectedIndex;
	
	    if (menuItems && typeof selectedIndex === 'number') {
	       false ? (0, _warning2.default)(menuItems[selectedIndex], 'SelectedIndex of ' + selectedIndex + ' does not exist in menuItems.') : undefined;
	    }
	
	    if (valueMember && this._isControlled()) {
	      value = this.props.hasOwnProperty('value') ? this.props.value : valueLink.value;
	      if (menuItems && value !== null && value !== undefined) {
	        for (var i = 0; i < menuItems.length; i++) {
	          if (menuItems[i][valueMember] === value) {
	            selectedIndex = i;
	          }
	        }
	      }
	    }
	
	    var displayValue = '';
	    if (menuItems) {
	      var selectedItem = menuItems[selectedIndex];
	      if (selectedItem) {
	        displayValue = selectedItem[labelMember || 'text'] || selectedItem[displayMember || 'text'];
	      }
	    } else {
	      _react2.default.Children.forEach(children, function (child) {
	        if (value === child.props.value) {
	          // This will need to be improved (in case primaryText is a node)
	          displayValue = child.props.label || child.props.primaryText;
	        }
	      });
	    }
	
	    var index = 0;
	    var menuItemElements = menuItems ? menuItems.map(function (item, idx) {
	      return _react2.default.createElement(_menuItem2.default, {
	        key: idx,
	        primaryText: item[displayMember || 'text'],
	        value: item[valueMember],
	        onTouchTap: _this2._onMenuItemTouchTap.bind(_this2, idx, item)
	      });
	    }) : _react2.default.Children.map(children, function (child) {
	      var clone = _react2.default.cloneElement(child, {
	        onTouchTap: _this2._onMenuItemTouchTap.bind(_this2, index, child.props.value)
	      }, child.props.children);
	      index += 1;
	      return clone;
	    });
	
	    var popoverStyle = undefined;
	    if (anchorEl && !autoWidth) {
	      popoverStyle = { width: anchorEl.clientWidth };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, {
	        ref: 'root',
	        className: className,
	        style: (0, _styles.prepareStyles)(muiTheme, (0, _styles.mergeStyles)(styles.root, open && styles.rootWhenOpen, style))
	      }),
	      _react2.default.createElement(
	        _clearfix2.default,
	        { style: (0, _styles.mergeStyles)(styles.control), onTouchTap: this._onControlTouchTap },
	        _react2.default.createElement(
	          'div',
	          { style: (0, _styles.prepareStyles)(muiTheme, (0, _styles.mergeStyles)(styles.label, open && styles.labelWhenOpen, labelStyle)) },
	          displayValue
	        ),
	        _react2.default.createElement(_arrowDropDown2.default, { style: (0, _styles.mergeStyles)(styles.icon, iconStyle) }),
	        _react2.default.createElement('div', { style: (0, _styles.prepareStyles)(muiTheme, (0, _styles.mergeStyles)(styles.underline, underlineStyle)) })
	      ),
	      _react2.default.createElement(
	        _popover2.default,
	        {
	          anchorOrigin: { horizontal: 'left', vertical: 'top' },
	          anchorEl: anchorEl,
	          style: popoverStyle,
	          animation: _popoverAnimationFromTop2.default,
	          open: open,
	          onRequestClose: this._onMenuRequestClose
	        },
	        _react2.default.createElement(
	          _menu2.default,
	          {
	            maxHeight: maxHeight,
	            desktop: true,
	            value: value,
	            style: menuStyle
	          },
	          menuItemElements
	        )
	      )
	    );
	  }
	});
	
	exports.default = DropDownMenu;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _textField = __webpack_require__(71);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _DropDownMenu = __webpack_require__(137);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SelectField = _react2.default.createClass({
	  displayName: 'SelectField',
	
	  propTypes: {
	    /**
	     * The width will automatically be set according to the
	     * items inside the menu. To control this width in css
	     * instead, set this prop to `false`.
	     */
	    autoWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * The `MenuItem` elements to populate the `Menu` with.
	     * If the MenuItems have the prop `label` that value will
	     * be used to render the representation of that
	     * item within the field.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Disables the select field if set to true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * The style object to use to override error styles.
	     */
	    errorStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The error content to display.
	     */
	    errorText: _react2.default.PropTypes.node,
	
	    /**
	     * The style object to use to override floating label styles.
	     */
	    floatingLabelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The content to use for the floating label element.
	     */
	    floatingLabelText: _react2.default.PropTypes.node,
	
	    /**
	     * If true, the field receives the property width 100%.
	     */
	    fullWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * The style object to use to override hint styles.
	     */
	    hintStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The hint content to display.
	     */
	    hintText: _react2.default.PropTypes.node,
	
	    /**
	     * Overrides the styles of the icon element.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * `SelectField` will use text as default value,
	     * with this property you can choose another name.
	     */
	    labelMember: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'to promote composability.'),
	
	    /**
	     * Overrides the styles of label when the `SelectField` is inactive.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * JSON data representing all menu items in the dropdown.
	     */
	    menuItems: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.array, 'to promote composability.'),
	
	    /**
	     * Callback function that is fired when the `SelectField` loses focus.
	     */
	    onBlur: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the value changes.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the `SelectField` gains focus.
	     */
	    onFocus: _react2.default.PropTypes.func,
	
	    /**
	     * The style object to use to override the `DropDownMenu`.
	     */
	    selectFieldRoot: _react2.default.PropTypes.object, // Must be changed!
	
	    /**
	     * Index of the item selected.
	     */
	    selectedIndex: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.number, 'with menuItems.'),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the underline element when disabled.
	     */
	    underlineDisabledStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the underline element when focused.
	     */
	    underlineFocusStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Overrides the styles of the underline element.
	     */
	    underlineStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The value that is currently selected.
	     */
	    value: _react2.default.PropTypes.any
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _contextPure2.default],
	
	  statics: {
	    getChildrenClasses: function getChildrenClasses() {
	      return [_textField2.default, _DropDownMenu2.default];
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoWidth: false,
	      disabled: false,
	      fullWidth: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    var floatingLabelText = this.props.floatingLabelText;
	
	    return {
	      label: {
	        paddingLeft: 0,
	        top: floatingLabelText ? 6 : -4
	      },
	      icon: {
	        right: 0,
	        top: floatingLabelText ? 22 : 14
	      },
	      hideDropDownUnderline: {
	        borderTop: 'none'
	      }
	    };
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    var _props = this.props;
	    var autoWidth = _props.autoWidth;
	    var children = _props.children;
	    var style = _props.style;
	    var labelStyle = _props.labelStyle;
	    var iconStyle = _props.iconStyle;
	    var underlineDisabledStyle = _props.underlineDisabledStyle;
	    var underlineFocusStyle = _props.underlineFocusStyle;
	    var underlineStyle = _props.underlineStyle;
	    var errorStyle = _props.errorStyle;
	    var selectFieldRoot = _props.selectFieldRoot;
	    var disabled = _props.disabled;
	    var floatingLabelText = _props.floatingLabelText;
	    var floatingLabelStyle = _props.floatingLabelStyle;
	    var hintStyle = _props.hintStyle;
	    var hintText = _props.hintText;
	    var fullWidth = _props.fullWidth;
	    var errorText = _props.errorText;
	    var onFocus = _props.onFocus;
	    var onBlur = _props.onBlur;
	    var onChange = _props.onChange;
	    var value = _props.value;
	
	    var other = _objectWithoutProperties(_props, ['autoWidth', 'children', 'style', 'labelStyle', 'iconStyle', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineStyle', 'errorStyle', 'selectFieldRoot', 'disabled', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'onFocus', 'onBlur', 'onChange', 'value']);
	
	    return _react2.default.createElement(
	      _textField2.default,
	      {
	        style: style,
	        floatingLabelText: floatingLabelText,
	        floatingLabelStyle: floatingLabelStyle,
	        hintStyle: hintStyle,
	        hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	        fullWidth: fullWidth,
	        errorText: errorText,
	        underlineStyle: underlineStyle,
	        errorStyle: errorStyle,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        underlineDisabledStyle: underlineDisabledStyle,
	        underlineFocusStyle: underlineFocusStyle
	      },
	      _react2.default.createElement(
	        _DropDownMenu2.default,
	        _extends({
	          disabled: disabled,
	          style: selectFieldRoot,
	          labelStyle: this.mergeStyles(styles.label, labelStyle),
	          iconStyle: this.mergeStyles(styles.icon, iconStyle),
	          underlineStyle: styles.hideDropDownUnderline,
	          autoWidth: autoWidth,
	          value: value,
	          onChange: onChange
	        }, other),
	        children
	      )
	    );
	  }
	});
	
	exports.default = SelectField;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectField = __webpack_require__(233);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _uniqueId = __webpack_require__(105);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _enhancedTextarea = __webpack_require__(262);
	
	var _enhancedTextarea2 = _interopRequireDefault(_enhancedTextarea);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _TextFieldHint = __webpack_require__(236);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(237);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(238);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return Boolean(value || value === 0);
	}
	
	var TextField = _react2.default.createClass({
	  displayName: 'TextField',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * The text string to use for the default value.
	     */
	    defaultValue: _react2.default.PropTypes.any,
	
	    /**
	     * Disables the text field if set to true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * The style object to use to override error styles.
	     */
	    errorStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The error content to display.
	     */
	    errorText: _react2.default.PropTypes.node,
	
	    /**
	     * The style object to use to override floating label styles.
	     */
	    floatingLabelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The content to use for the floating label element.
	     */
	    floatingLabelText: _react2.default.PropTypes.node,
	
	    /**
	     * If true, the field receives the property width 100%.
	     */
	    fullWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the TextField's hint text element.
	     */
	    hintStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The hint content to display.
	     */
	    hintText: _react2.default.PropTypes.node,
	
	    /**
	     * The id prop for the text field.
	     */
	    id: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the TextField's input element.
	     */
	    inputStyle: _react2.default.PropTypes.object,
	
	    /**
	     * If true, a textarea element will be rendered.
	     * The textarea also grows and shrinks according to the number of lines.
	     */
	    multiLine: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback function that is fired when the textfield loses focus.
	     */
	    onBlur: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the textfield's value changes.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * The function to call when the user presses the Enter key.
	     */
	    onEnterKeyDown: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the textfield gains focus.
	     */
	    onFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function fired when key is pressed down.
	     */
	    onKeyDown: _react2.default.PropTypes.func,
	
	    /**
	     * Number of rows to display when multiLine option is set to true.
	     */
	    rows: _react2.default.PropTypes.number,
	
	    /**
	     * Maximum number of rows to display when
	     * multiLine option is set to true.
	     */
	    rowsMax: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Specifies the type of input to display
	     * such as "password" or "text".
	     */
	    type: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the
	     * TextField's underline element when disabled.
	     */
	    underlineDisabledStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the TextField's
	     * underline element when focussed.
	     */
	    underlineFocusStyle: _react2.default.PropTypes.object,
	
	    /**
	     * If true, shows the underline for the text field.
	     */
	    underlineShow: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the TextField's underline element.
	     */
	    underlineStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The value of the text field.
	     */
	    value: _react2.default.PropTypes.any
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_contextPure2.default, _stylePropable2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      var textFieldTheme = muiTheme.textField;
	
	      return {
	        floatingLabelColor: textFieldTheme.floatingLabelColor,
	        focusColor: textFieldTheme.focusColor,
	        textColor: textFieldTheme.textColor,
	        disabledTextColor: textFieldTheme.disabledTextColor,
	        backgroundColor: textFieldTheme.backgroundColor,
	        hintColor: textFieldTheme.hintColor,
	        errorColor: textFieldTheme.errorColor
	      };
	    },
	    getChildrenClasses: function getChildrenClasses() {
	      return [_enhancedTextarea2.default];
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      multiLine: false,
	      fullWidth: false,
	      type: 'text',
	      underlineShow: true,
	      rows: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props.children ? this.props.children.props : this.props;
	
	    return {
	      isFocused: false,
	      errorText: this.props.errorText,
	      hasValue: isValid(props.value) || isValid(props.defaultValue) || props.valueLink && isValid(props.valueLink.value),
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._uniqueId = _uniqueId2.default.generate();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newState = {};
	    newState.muiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    newState.errorText = nextProps.errorText;
	    if (nextProps.children && nextProps.children.props) {
	      nextProps = nextProps.children.props;
	    }
	
	    var hasValueLinkProp = nextProps.hasOwnProperty('valueLink');
	    var hasValueProp = nextProps.hasOwnProperty('value');
	    var hasNewDefaultValue = nextProps.defaultValue !== this.props.defaultValue;
	
	    if (hasValueLinkProp) {
	      newState.hasValue = isValid(nextProps.valueLink.value);
	    } else if (hasValueProp) {
	      newState.hasValue = isValid(nextProps.value);
	    } else if (hasNewDefaultValue) {
	      newState.hasValue = isValid(nextProps.defaultValue);
	    }
	
	    if (newState) this.setState(newState);
	  },
	  getStyles: function getStyles() {
	    var props = this.props;
	
	    var _constructor$getRelev = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var floatingLabelColor = _constructor$getRelev.floatingLabelColor;
	    var focusColor = _constructor$getRelev.focusColor;
	    var textColor = _constructor$getRelev.textColor;
	    var disabledTextColor = _constructor$getRelev.disabledTextColor;
	    var backgroundColor = _constructor$getRelev.backgroundColor;
	    var hintColor = _constructor$getRelev.hintColor;
	    var errorColor = _constructor$getRelev.errorColor;
	
	    var styles = {
	      root: {
	        fontSize: 16,
	        lineHeight: '24px',
	        width: props.fullWidth ? '100%' : 256,
	        height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	        display: 'inline-block',
	        position: 'relative',
	        backgroundColor: backgroundColor,
	        fontFamily: this.state.muiTheme.rawTheme.fontFamily,
	        transition: _transitions2.default.easeOut('200ms', 'height')
	      },
	      error: {
	        position: 'relative',
	        bottom: 2,
	        fontSize: 12,
	        lineHeight: '12px',
	        color: errorColor,
	        transition: _transitions2.default.easeOut()
	      },
	      floatingLabel: {
	        color: hintColor
	      },
	      input: {
	        tapHighlightColor: 'rgba(0,0,0,0)',
	        padding: 0,
	        position: 'relative',
	        width: '100%',
	        height: '100%',
	        border: 'none',
	        outline: 'none',
	        backgroundColor: 'transparent',
	        color: props.disabled ? disabledTextColor : textColor,
	        font: 'inherit'
	      }
	    };
	
	    styles.error = this.mergeStyles(styles.error, props.errorStyle);
	
	    styles.textarea = this.mergeStyles(styles.input, {
	      marginTop: props.floatingLabelText ? 36 : 12,
	      marginBottom: props.floatingLabelText ? -36 : -12,
	      boxSizing: 'border-box',
	      font: 'inherit'
	    });
	
	    if (this.state.isFocused) {
	      styles.floatingLabel.color = focusColor;
	    }
	
	    if (this.state.hasValue) {
	      styles.floatingLabel.color = _colorManipulator2.default.fade(props.disabled ? disabledTextColor : floatingLabelColor, 0.5);
	    }
	
	    if (props.floatingLabelText) {
	      styles.input.boxSizing = 'border-box';
	
	      if (!props.multiLine) {
	        styles.input.marginTop = 14;
	      }
	
	      if (this.state.errorText) {
	        styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	      }
	    }
	
	    if (this.state.errorText) {
	      if (this.state.isFocused) {
	        styles.floatingLabel.color = styles.error.color;
	      }
	    }
	
	    return styles;
	  },
	  blur: function blur() {
	    if (this.isMounted()) this._getInputNode().blur();
	  },
	  clearValue: function clearValue() {
	    this.setValue('');
	  },
	  focus: function focus() {
	    if (this.isMounted()) this._getInputNode().focus();
	  },
	  getValue: function getValue() {
	    return this.isMounted() ? this._getInputNode().value : undefined;
	  },
	  setErrorText: function setErrorText(newErrorText) {
	     false ? (0, _warning2.default)(false, 'setErrorText() method is deprecated. Use the errorText property instead.') : undefined;
	
	    if (this.isMounted()) {
	      this.setState({ errorText: newErrorText });
	    }
	  },
	  setValue: function setValue(newValue) {
	     false ? (0, _warning2.default)(false, 'setValue() method is deprecated. Use the defaultValue property instead.\n      Or use the TextField as a controlled component with the value property.') : undefined;
	
	    if (this.isMounted()) {
	      if (this.props.multiLine) {
	        this.refs.input.setValue(newValue);
	      } else {
	        this._getInputNode().value = newValue;
	      }
	
	      this.setState({ hasValue: isValid(newValue) });
	    }
	  },
	  _getInputNode: function _getInputNode() {
	    return this.props.children || this.props.multiLine ? this.refs.input.getInputNode() : _reactDom2.default.findDOMNode(this.refs.input);
	  },
	  _handleInputBlur: function _handleInputBlur(e) {
	    this.setState({ isFocused: false });
	    if (this.props.onBlur) this.props.onBlur(e);
	  },
	  _handleInputChange: function _handleInputChange(e) {
	    this.setState({ hasValue: isValid(e.target.value) });
	    if (this.props.onChange) this.props.onChange(e);
	  },
	  _handleInputFocus: function _handleInputFocus(e) {
	    if (this.props.disabled) return;
	    this.setState({ isFocused: true });
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	  _handleInputKeyDown: function _handleInputKeyDown(e) {
	    if (e.keyCode === 13 && this.props.onEnterKeyDown) this.props.onEnterKeyDown(e);
	    if (this.props.onKeyDown) this.props.onKeyDown(e);
	  },
	  _handleTextAreaHeightChange: function _handleTextAreaHeightChange(e, height) {
	    var newHeight = height + 24;
	    if (this.props.floatingLabelText) newHeight += 24;
	    _reactDom2.default.findDOMNode(this).style.height = newHeight + 'px';
	  },
	  _isControlled: function _isControlled() {
	    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var disabled = _props.disabled;
	    var errorStyle = _props.errorStyle;
	    var errorText = _props.errorText;
	    var floatingLabelText = _props.floatingLabelText;
	    var fullWidth = _props.fullWidth;
	    var hintText = _props.hintText;
	    var hintStyle = _props.hintStyle;
	    var id = _props.id;
	    var multiLine = _props.multiLine;
	    var onBlur = _props.onBlur;
	    var onChange = _props.onChange;
	    var onFocus = _props.onFocus;
	    var style = _props.style;
	    var type = _props.type;
	    var underlineDisabledStyle = _props.underlineDisabledStyle;
	    var underlineFocusStyle = _props.underlineFocusStyle;
	    var underlineShow = _props.underlineShow;
	    var underlineStyle = _props.underlineStyle;
	    var rows = _props.rows;
	    var rowsMax = _props.rowsMax;
	
	    var other = _objectWithoutProperties(_props, ['className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax']);
	
	    var styles = this.getStyles();
	
	    var inputId = id || this._uniqueId;
	
	    var errorTextElement = this.state.errorText ? _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(styles.error) },
	      this.state.errorText
	    ) : null;
	
	    var floatingLabelTextElement = floatingLabelText ? _react2.default.createElement(
	      _TextFieldLabel2.default,
	      {
	        muiTheme: this.state.muiTheme,
	        style: this.mergeStyles(styles.floatingLabel, this.props.floatingLabelStyle),
	        htmlFor: inputId,
	        shrink: this.state.hasValue || this.state.isFocused,
	        disabled: disabled,
	        onTouchTap: this.focus
	      },
	      floatingLabelText
	    ) : null;
	
	    var inputProps = undefined;
	    var inputElement = undefined;
	
	    inputProps = {
	      id: inputId,
	      ref: 'input',
	      onBlur: this._handleInputBlur,
	      onFocus: this._handleInputFocus,
	      disabled: this.props.disabled,
	      onKeyDown: this._handleInputKeyDown
	    };
	    var inputStyle = this.mergeStyles(styles.input, this.props.inputStyle);
	
	    if (!this.props.hasOwnProperty('valueLink')) {
	      inputProps.onChange = this._handleInputChange;
	    }
	
	    if (this.props.children) {
	      inputElement = _react2.default.cloneElement(this.props.children, _extends({}, inputProps, this.props.children.props, {
	        style: this.mergeStyles(inputStyle, this.props.children.props.style)
	      }));
	    } else {
	      inputElement = multiLine ? _react2.default.createElement(_enhancedTextarea2.default, _extends({}, other, inputProps, {
	        style: inputStyle,
	        rows: rows,
	        rowsMax: rowsMax,
	        onHeightChange: this._handleTextAreaHeightChange,
	        textareaStyle: styles.textarea
	      })) : _react2.default.createElement('input', _extends({}, other, inputProps, {
	        style: this.prepareStyles(inputStyle),
	        type: type
	      }));
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: className, style: this.prepareStyles(styles.root, this.props.style) },
	      floatingLabelTextElement,
	      hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	        muiTheme: this.state.muiTheme,
	        show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused),
	        style: hintStyle,
	        text: hintText
	      }) : null,
	      inputElement,
	      underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	        disabled: disabled,
	        disabledStyle: underlineDisabledStyle,
	        error: this.state.errorText ? true : false,
	        errorStyle: errorStyle,
	        focus: this.state.isFocused,
	        focusStyle: underlineFocusStyle,
	        muiTheme: this.state.muiTheme,
	        style: underlineStyle
	      }) : null,
	      errorTextElement
	    );
	  }
	});
	
	exports.default = TextField;
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _styles = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react2.default.PropTypes.object.isRequired,
	
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object,
	
	  /**
	   * The hint text displayed.
	   */
	  text: _react2.default.PropTypes.node
	};
	
	var defaultProps = {
	  show: true
	};
	
	var TextFieldHint = function TextFieldHint(props) {
	  var muiTheme = props.muiTheme;
	  var show = props.show;
	  var style = props.style;
	  var text = props.text;
	  var hintColor = muiTheme.textField.hintColor;
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: (0, _styles.prepareStyles)(muiTheme, (0, _styles.mergeStyles)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes = propTypes;
	TextFieldHint.defaultProps = defaultProps;
	
	exports.default = TextFieldHint;
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _styles = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react2.default.PropTypes.object.isRequired,
	
	  /**
	   * The css class name of the root element.
	   */
	  className: _react2.default.PropTypes.string,
	
	  /**
	   * The label contents.
	   */
	  children: _react2.default.PropTypes.node,
	
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react2.default.PropTypes.bool,
	
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react2.default.PropTypes.bool,
	
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react2.default.PropTypes.string,
	
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   */
	  onTouchTap: _react2.default.PropTypes.func,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme;
	  var className = props.className;
	  var children = props.children;
	  var disabled = props.disabled;
	  var shrink = props.shrink;
	  var htmlFor = props.htmlFor;
	  var style = props.style;
	  var onTouchTap = props.onTouchTap;
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      lineHeight: '22px',
	      top: 38,
	      transition: _transitions2.default.easeOut(),
	      zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	      cursor: disabled ? 'default' : 'text',
	      transform: shrink ? 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)' : 'scale(1) translate3d(0, 0, 0)',
	      transformOrigin: 'left top',
	      pointerEvents: shrink ? 'none' : 'auto',
	      userSelect: 'none'
	    }
	  };
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: (0, _styles.prepareStyles)(muiTheme, (0, _styles.mergeStyles)(styles.root, style)),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes = propTypes;
	TextFieldLabel.defaultProps = defaultProps;
	
	exports.default = TextFieldLabel;
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _styles = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react2.default.PropTypes.bool,
	
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react2.default.PropTypes.object,
	
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react2.default.PropTypes.bool,
	
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react2.default.PropTypes.object,
	
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react2.default.PropTypes.bool,
	
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react2.default.PropTypes.object,
	
	  /**
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react2.default.PropTypes.object.isRequired,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled;
	  var disabledStyle = props.disabledStyle;
	  var error = props.error;
	  var errorStyle = props.errorStyle;
	  var focus = props.focus;
	  var focusStyle = props.focusStyle;
	  var muiTheme = props.muiTheme;
	  var style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var _muiTheme$textField = muiTheme.textField;
	  var borderColor = _muiTheme$textField.borderColor;
	  var disabledTextColor = _muiTheme$textField.disabledTextColor;
	  var errorColor = _muiTheme$textField.errorColor;
	  var focusColor = _muiTheme$textField.focusColor;
	
	  var styles = {
	    root: {
	      border: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _styles.mergeStyles)(styles.root, style);
	  var focusedUnderline = (0, _styles.mergeStyles)(underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _styles.mergeStyles)(underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _styles.mergeStyles)(focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _styles.mergeStyles)(focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: (0, _styles.prepareStyles)(muiTheme, underline) }),
	    _react2.default.createElement('hr', { style: (0, _styles.prepareStyles)(muiTheme, focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes = propTypes;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _iconButton = __webpack_require__(56);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	var _menu = __webpack_require__(154);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AppBar = _react2.default.createClass({
	  displayName: 'AppBar',
	
	  propTypes: {
	    /**
	     * Can be used to render a tab inside an app bar for instance.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Applied to the app bar's root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * The classname of the icon on the left of the app bar.
	     * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	     */
	    iconClassNameLeft: _react2.default.PropTypes.string,
	
	    /**
	     * Similiar to the iconClassNameLeft prop except that
	     * it applies to the icon displayed on the right of the app bar.
	     */
	    iconClassNameRight: _react2.default.PropTypes.string,
	
	    /**
	     * The custom element to be displayed on the left side of the
	     * app bar such as an SvgIcon.
	     */
	    iconElementLeft: _react2.default.PropTypes.element,
	
	    /**
	     * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	     */
	    iconElementRight: _react2.default.PropTypes.element,
	
	    /**
	     * Override the inline-styles of the element displayed on the right side of the app bar.
	     */
	    iconStyleRight: _react2.default.PropTypes.object,
	
	    /**
	     * Callback function for when the left icon is selected via a touch tap.
	     */
	    onLeftIconButtonTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the right icon is selected via a touch tap.
	     */
	    onRightIconButtonTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the title text is selected via a touch tap.
	     */
	    onTitleTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Determines whether or not to display the Menu icon next to the title.
	     * Setting this prop to false will hide the icon.
	     */
	    showMenuIconButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The title to display on the app bar.
	     */
	    title: _react2.default.PropTypes.node,
	
	    /**
	     * Override the inline-styles of the app bar's title element.
	     */
	    titleStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The zDepth of the component.
	     * The shadow of the app bar is also dependent on this property.
	     */
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showMenuIconButton: true,
	      title: '',
	      zDepth: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	     false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : undefined;
	
	     false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : undefined;
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    var muiTheme = this.state.muiTheme;
	    var rawTheme = muiTheme.rawTheme;
	
	    var themeVariables = muiTheme.appBar;
	    var iconButtonSize = muiTheme.button.iconButtonSize;
	    var flatButtonSize = 36;
	
	    var styles = {
	      root: {
	        position: 'relative',
	        zIndex: muiTheme.zIndex.appBar,
	        width: '100%',
	        display: 'flex',
	        minHeight: themeVariables.height,
	        backgroundColor: themeVariables.color,
	        paddingLeft: rawTheme.spacing.desktopGutter,
	        paddingRight: rawTheme.spacing.desktopGutter
	      },
	      title: {
	        whiteSpace: 'nowrap',
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        margin: 0,
	        paddingTop: 0,
	        letterSpacing: 0,
	        fontSize: 24,
	        fontWeight: _typography2.default.fontWeightNormal,
	        color: themeVariables.textColor,
	        lineHeight: themeVariables.height + 'px'
	      },
	      mainElement: {
	        boxFlex: 1,
	        flex: '1'
	      },
	      iconButton: {
	        style: {
	          marginTop: (themeVariables.height - iconButtonSize) / 2,
	          marginRight: 8,
	          marginLeft: -16
	        },
	        iconStyle: {
	          fill: themeVariables.textColor,
	          color: themeVariables.textColor
	        }
	      },
	      flatButton: {
	        color: themeVariables.textColor,
	        marginTop: (iconButtonSize - flatButtonSize) / 2 + 2
	      }
	    };
	
	    return styles;
	  },
	  _onLeftIconButtonTouchTap: function _onLeftIconButtonTouchTap(event) {
	    if (this.props.onLeftIconButtonTouchTap) {
	      this.props.onLeftIconButtonTouchTap(event);
	    }
	  },
	  _onRightIconButtonTouchTap: function _onRightIconButtonTouchTap(event) {
	    if (this.props.onRightIconButtonTouchTap) {
	      this.props.onRightIconButtonTouchTap(event);
	    }
	  },
	  _onTitleTouchTap: function _onTitleTouchTap(event) {
	    if (this.props.onTitleTouchTap) {
	      this.props.onTitleTouchTap(event);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var title = _props.title;
	    var titleStyle = _props.titleStyle;
	    var iconStyleRight = _props.iconStyleRight;
	    var showMenuIconButton = _props.showMenuIconButton;
	    var iconElementLeft = _props.iconElementLeft;
	    var iconElementRight = _props.iconElementRight;
	    var iconClassNameLeft = _props.iconClassNameLeft;
	    var iconClassNameRight = _props.iconClassNameRight;
	    var className = _props.className;
	    var style = _props.style;
	    var zDepth = _props.zDepth;
	    var children = _props.children;
	
	    var other = _objectWithoutProperties(_props, ['title', 'titleStyle', 'iconStyleRight', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'className', 'style', 'zDepth', 'children']);
	
	    var menuElementLeft = undefined;
	    var menuElementRight = undefined;
	    var styles = this.getStyles();
	    var iconRightStyle = this.mergeStyles(styles.iconButton.style, {
	      marginRight: -16,
	      marginLeft: 'auto'
	    }, iconStyleRight);
	    var titleElement = undefined;
	
	    if (title) {
	      // If the title is a string, wrap in an h1 tag.
	      // If not, just use it as a node.
	      titleElement = typeof title === 'string' || title instanceof String ? _react2.default.createElement(
	        'h1',
	        {
	          onTouchTap: this._onTitleTouchTap,
	          style: this.prepareStyles(styles.title, styles.mainElement, titleStyle)
	        },
	        title
	      ) : _react2.default.createElement(
	        'div',
	        {
	          onTouchTap: this._onTitleTouchTap,
	          style: this.prepareStyles(styles.title, styles.mainElement, titleStyle)
	        },
	        title
	      );
	    }
	
	    if (showMenuIconButton) {
	      if (iconElementLeft) {
	        switch (iconElementLeft.type.displayName) {
	          case 'IconButton':
	            iconElementLeft = _react2.default.cloneElement(iconElementLeft, {
	              iconStyle: this.mergeStyles(styles.iconButton.iconStyle, iconElementLeft.props.iconStyle)
	            });
	            break;
	        }
	
	        menuElementLeft = _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(styles.iconButton.style) },
	          iconElementLeft
	        );
	      } else {
	        var child = iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: this.mergeStyles(styles.iconButton.iconStyle) });
	        menuElementLeft = _react2.default.createElement(
	          _iconButton2.default,
	          {
	            style: this.mergeStyles(styles.iconButton.style),
	            iconStyle: this.mergeStyles(styles.iconButton.iconStyle),
	            iconClassName: iconClassNameLeft,
	            onTouchTap: this._onLeftIconButtonTouchTap
	          },
	          child
	        );
	      }
	    }
	
	    if (iconElementRight) {
	      switch (iconElementRight.type.displayName) {
	        case 'IconMenu':
	        case 'IconButton':
	          iconElementRight = _react2.default.cloneElement(iconElementRight, {
	            iconStyle: this.mergeStyles(styles.iconButton.iconStyle, iconElementRight.props.iconStyle)
	          });
	          break;
	
	        case 'FlatButton':
	          iconElementRight = _react2.default.cloneElement(iconElementRight, {
	            style: this.mergeStyles(styles.flatButton, iconElementRight.props.style)
	          });
	          break;
	      }
	
	      menuElementRight = _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(iconRightStyle) },
	        iconElementRight
	      );
	    } else if (iconClassNameRight) {
	      menuElementRight = _react2.default.createElement(_iconButton2.default, {
	        style: iconRightStyle,
	        iconStyle: this.mergeStyles(styles.iconButton.iconStyle),
	        iconClassName: iconClassNameRight,
	        onTouchTap: this._onRightIconButtonTouchTap
	      });
	    }
	
	    return _react2.default.createElement(
	      _paper2.default,
	      _extends({}, other, {
	        rounded: false,
	        className: className,
	        style: this.mergeStyles(styles.root, style),
	        zDepth: zDepth
	      }),
	      menuElementLeft,
	      titleElement,
	      menuElementRight,
	      children
	    );
	  }
	});
	
	exports.default = AppBar;
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppCanvas = _react2.default.createClass({
	  displayName: 'AppCanvas',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _this = this;
	
	    var styles = {
	      height: '100%',
	      backgroundColor: this.state.muiTheme.rawTheme.palette.canvasColor,
	      direction: 'ltr'
	    };
	
	    var newChildren = _react2.default.Children.map(this.props.children, function (currentChild) {
	      if (!currentChild) {
	        // If undefined, skip it
	        return null;
	      }
	
	      switch (currentChild.type.displayName) {
	        case 'AppBar':
	          return _react2.default.cloneElement(currentChild, {
	            style: _this.mergeStyles(currentChild.props.style, {
	              position: 'fixed'
	            })
	          });
	        default:
	          return currentChild;
	      }
	    }, this);
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(styles) },
	      newChildren
	    );
	  }
	});
	
	exports.default = AppCanvas;
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _textField = __webpack_require__(71);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _menu = __webpack_require__(57);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _menuItem = __webpack_require__(97);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _divider = __webpack_require__(93);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _popover = __webpack_require__(58);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AutoComplete = _react2.default.createClass({
	  displayName: 'AutoComplete',
	
	  propTypes: {
	    /**
	     * Location of the anchor for the auto complete.
	     */
	    anchorOrigin: _propTypes2.default.origin,
	
	    /**
	     * Whether or not the auto complete is animated as it is toggled.
	     */
	    animated: _react2.default.PropTypes.bool,
	
	    /**
	     * Array of strings or nodes used to populate the list.
	     */
	    dataSource: _react2.default.PropTypes.array,
	
	    /**
	     * Disables focus ripple when true.
	     */
	    disableFocusRipple: _react2.default.PropTypes.bool,
	
	    /**
	     * Override style prop for error.
	     */
	    errorStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The error content to display.
	     */
	    errorText: _react2.default.PropTypes.string,
	
	    /**
	     * Function used to filter the auto complete.
	     */
	    filter: _react2.default.PropTypes.func,
	
	    /**
	     * The content to use for adding floating label element.
	     */
	    floatingLabelText: _react2.default.PropTypes.string,
	
	    /**
	     * If true, the field receives the property `width: 100%`.
	     */
	    fullWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * The hint content to display.
	     */
	    hintText: _react2.default.PropTypes.string,
	
	    /**
	     * Override style for list.
	     */
	    listStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Delay for closing time of the menu.
	     */
	    menuCloseDelay: _react2.default.PropTypes.number,
	
	    /**
	     * Props to be passed to menu.
	     */
	    menuProps: _react2.default.PropTypes.object,
	
	    /**
	     * Override style for menu.
	     */
	    menuStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Gets called when list item is clicked or pressed enter.
	     */
	    onNewRequest: _react2.default.PropTypes.func,
	
	    /**
	     * Gets called each time the user updates the text field.
	     */
	    onUpdateInput: _react2.default.PropTypes.func,
	
	    /**
	     * Auto complete menu is open if true.
	     */
	    open: _react2.default.PropTypes.bool,
	
	    /**
	     * Text being input to auto complete.
	     */
	    searchText: _react2.default.PropTypes.string,
	    showAllItems: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.bool, 'showAllItems is deprecated, use noFilter instead'),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Origin for location of target.
	     */
	    targetOrigin: _propTypes2.default.origin,
	
	    /**
	     * Delay for touch tap event closing of auto complete.
	     */
	    touchTapCloseDelay: _react2.default.PropTypes.number,
	
	    /**
	     * If true, will update when focus event triggers.
	     */
	    triggerUpdateOnFocus: _react2.default.PropTypes.bool,
	    updateWhenFocused: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.bool, 'updateWhenFocused has been renamed to triggerUpdateOnFocus')
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      anchorOrigin: {
	        vertical: 'bottom',
	        horizontal: 'left'
	      },
	      targetOrigin: {
	        vertical: 'top',
	        horizontal: 'left'
	      },
	      animated: true,
	      fullWidth: false,
	      open: false,
	      searchText: '',
	      menuCloseDelay: 100,
	      disableFocusRipple: true,
	      onUpdateInput: function onUpdateInput() {},
	      onNewRequest: function onNewRequest() {},
	      filter: function filter(searchText, key) {
	        return searchText !== '' && key.includes(searchText);
	      },
	      triggerUpdateOnFocus: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      searchText: this.props.searchText,
	      open: this.props.open,
	      anchorEl: null,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.focusOnInput = false;
	    this.requestsList = [];
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.searchText !== nextProps.searchText) {
	      this.setState({
	        searchText: nextProps.searchText
	      });
	    }
	  },
	
	  componentClickAway: function componentClickAway() {
	    this._close();
	    this.focusOnInput = false;
	  },
	  _open: function _open() {
	    this.setState({
	      open: true,
	      anchorEl: _reactDom2.default.findDOMNode(this.refs.searchTextField)
	    });
	  },
	  _close: function _close() {
	    this.setState({
	      open: false,
	      anchorEl: null
	    });
	  },
	  setValue: function setValue(textValue) {
	    this.setState({
	      searchText: textValue
	    });
	  },
	  getValue: function getValue() {
	    return this.state.searchText;
	  },
	  _updateRequests: function _updateRequests(searchText) {
	
	    this.setState({
	      searchText: searchText,
	      open: true,
	      anchorEl: _reactDom2.default.findDOMNode(this.refs.searchTextField)
	    });
	
	    this.focusOnInput = true;
	
	    this.props.onUpdateInput(searchText, this.props.dataSource);
	  },
	  _handleItemTouchTap: function _handleItemTouchTap(e, child) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this._close();
	    }, this.props.touchTapCloseDelay);
	
	    var dataSource = this.props.dataSource;
	
	    var chosenRequest = undefined;
	    var index = undefined;
	    var searchText = undefined;
	    if (typeof dataSource[0] === 'string') {
	      chosenRequest = this.requestsList[parseInt(child.key, 10)];
	      index = dataSource.indexOf(chosenRequest);
	      searchText = dataSource[index];
	    } else {
	      chosenRequest = child.key;
	      index = dataSource.indexOf(dataSource.filter(function (item) {
	        return chosenRequest === item.text;
	      })[0]);
	      searchText = chosenRequest;
	    }
	
	    this.setState({ searchText: searchText });
	
	    this.props.onNewRequest(chosenRequest, index, dataSource);
	  },
	  _handleKeyDown: function _handleKeyDown(e) {
	    switch (e.keyCode) {
	      case _keyCode2.default.ESC:
	        this._close();
	        break;
	      case _keyCode2.default.DOWN:
	        if (this.focusOnInput && this.state.open) {
	          e.preventDefault();
	          this.focusOnInput = false;
	          this._open();
	        }
	        break;
	      default:
	        break;
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props = this.props;
	    var anchorOrigin = _props.anchorOrigin;
	    var animated = _props.animated;
	    var style = _props.style;
	    var errorStyle = _props.errorStyle;
	    var floatingLabelText = _props.floatingLabelText;
	    var hintText = _props.hintText;
	    var fullWidth = _props.fullWidth;
	    var menuStyle = _props.menuStyle;
	    var menuProps = _props.menuProps;
	    var listStyle = _props.listStyle;
	    var targetOrigin = _props.targetOrigin;
	
	    var other = _objectWithoutProperties(_props, ['anchorOrigin', 'animated', 'style', 'errorStyle', 'floatingLabelText', 'hintText', 'fullWidth', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin']);
	
	    var _state = this.state;
	    var open = _state.open;
	    var anchorEl = _state.anchorEl;
	
	    var styles = {
	      root: {
	        display: 'inline-block',
	        position: 'relative',
	        width: this.props.fullWidth ? '100%' : 256
	      },
	      input: {},
	      error: {},
	      menu: {
	        width: '100%'
	      },
	      list: {
	        display: 'block',
	        width: this.props.fullWidth ? '100%' : 256
	      }
	    };
	
	    var textFieldProps = {
	      style: this.mergeStyles(styles.input, style),
	      floatingLabelText: floatingLabelText,
	      hintText: !hintText && !floatingLabelText ? '' : hintText,
	      fullWidth: true,
	      multiLine: false,
	      errorStyle: this.mergeStyles(styles.error, errorStyle)
	    };
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	    var mergedMenuStyles = this.mergeStyles(styles.menu, menuStyle);
	
	    var requestsList = [];
	
	    this.props.dataSource.map(function (item) {
	      //showAllItems is deprecated, will be removed in the future
	      if (_this2.props.showAllItems) {
	        requestsList.push(item);
	        return;
	      }
	
	      switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
	        case 'string':
	          if (_this2.props.filter(_this2.state.searchText, item, item)) {
	            requestsList.push(item);
	          }
	          break;
	        case 'object':
	          if (typeof item.text === 'string') {
	            if (_this2.props.filter(_this2.state.searchText, item.text, item)) {
	              requestsList.push(item);
	            }
	          }
	          break;
	      }
	    });
	
	    this.requestsList = requestsList;
	
	    var menu = open && requestsList.length > 0 ? _react2.default.createElement(
	      _menu2.default,
	      _extends({}, menuProps, {
	        ref: 'menu',
	        key: 'dropDownMenu',
	        autoWidth: false,
	        onEscKeyDown: this._close,
	        initiallyKeyboardFocused: false,
	        onItemTouchTap: this._handleItemTouchTap,
	        listStyle: this.mergeStyles(styles.list, listStyle),
	        style: mergedMenuStyles
	      }),
	      requestsList.map(function (request, index) {
	        switch (typeof request === 'undefined' ? 'undefined' : _typeof(request)) {
	          case 'string':
	            return _react2.default.createElement(_menuItem2.default, {
	              disableFocusRipple: _this2.props.disableFocusRipple,
	              innerDivStyle: { overflow: 'hidden' },
	              key: index,
	              value: request,
	              primaryText: request
	            });
	          case 'object':
	            if (typeof request.text === 'string') {
	              return _react2.default.cloneElement(request.value, {
	                key: request.text,
	                disableFocusRipple: _this2.props.disableFocusRipple
	              });
	            }
	            return _react2.default.cloneElement(request, {
	              key: index,
	              disableFocusRipple: _this2.props.disableFocusRipple
	            });
	          default:
	            return null;
	        }
	      })
	    ) : null;
	
	    var popoverStyle = undefined;
	    if (anchorEl && fullWidth) {
	      popoverStyle = { width: anchorEl.clientWidth };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: this.prepareStyles(mergedRootStyles),
	        onKeyDown: this._handleKeyDown
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            width: '100%'
	          }
	        },
	        _react2.default.createElement(_textField2.default, _extends({}, other, {
	          ref: 'searchTextField',
	          value: this.state.searchText,
	          onEnterKeyDown: function onEnterKeyDown() {
	            setTimeout(function () {
	              _this2._close();
	            }, _this2.props.touchTapCloseDelay);
	            _this2.props.onNewRequest(_this2.state.searchText);
	          },
	          onChange: function onChange(e) {
	            var searchText = e.target.value;
	            _this2._updateRequests(searchText);
	          },
	          onBlur: function onBlur() {
	            if (_this2.focusOnInput && open) _this2.refs.searchTextField.focus();
	          },
	          onFocus: function onFocus() {
	            if (!open && (_this2.props.triggerUpdateOnFocus || _this2.props.updateWhenFocused //this line will be removed in the future
	             || _this2.requestsList > 0)) {
	              _this2._updateRequests(_this2.state.searchText);
	            }
	            _this2.focusOnInput = true;
	          }
	
	        }, textFieldProps))
	      ),
	      _react2.default.createElement(
	        _popover2.default,
	        {
	          style: popoverStyle,
	          anchorOrigin: anchorOrigin,
	          targetOrigin: targetOrigin,
	          open: open,
	          anchorEl: anchorEl,
	          useLayerForClickAway: false,
	          onRequestClose: this._close
	        },
	        menu
	      )
	    );
	  }
	});
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = undefined;
	  var value = undefined;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.includes(searchText);
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().includes(searchText.toLowerCase());
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) return AutoComplete.levenshteinDistance;else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  if (searchText.length === 0) return false;
	  var subMatchKey = key.substring(0, searchText.length);
	  var distance = AutoComplete.levenshteinDistance(searchText.toLowerCase(), subMatchKey.toLowerCase());
	  return searchText.length > 3 ? distance < 2 : distance === 0;
	};
	
	AutoComplete.Item = _menuItem2.default;
	AutoComplete.Divider = _divider2.default;
	
	exports.default = AutoComplete;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Badge
	var Badge = _react2.default.createClass({
	  displayName: 'Badge',
	
	  propTypes: {
	    /**
	     * This is the content rendered within the badge.
	     */
	    badgeContent: _react2.default.PropTypes.node.isRequired,
	
	    /**
	     * Override the inline-styles of the badge element.
	     */
	    badgeStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The badge will be added relativelty to this node.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * If true, the badge will use the primary badge colors.
	     */
	    primary: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the badge will use the secondary badge colors.
	     */
	    secondary: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	  mixins: [_stylePropable2.default],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      primary: false,
	      secondary: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      muiTheme: newMuiTheme
	    });
	  },
	  getStyles: function getStyles() {
	    var theme = this.state.muiTheme.badge;
	
	    var badgeBackgroundColor = this.props.primary ? theme.primaryColor : this.props.secondary ? theme.secondaryColor : theme.color;
	
	    var badgeTextColor = this.props.primary ? theme.primaryTextColor : this.props.secondary ? theme.secondaryTextColor : theme.textColor;
	
	    var radius = 12;
	    var radius2x = Math.floor(2 * radius);
	
	    return {
	      root: {
	        position: 'relative',
	        display: 'inline-block',
	        padding: [radius2x + 'px', radius2x + 'px', radius + 'px', radius + 'px'].join(' ')
	      },
	      badge: {
	        display: 'flex',
	        flexDirection: 'row',
	        flexWrap: 'wrap',
	        justifyContent: 'center',
	        alignContent: 'center',
	        alignItems: 'center',
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        fontWeight: _typography2.default.fontWeightMedium,
	        fontSize: radius,
	        width: radius2x,
	        height: radius2x,
	        borderRadius: '50%',
	        backgroundColor: badgeBackgroundColor,
	        color: badgeTextColor
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var children = _props.children;
	    var badgeContent = _props.badgeContent;
	    var badgeStyle = _props.badgeStyle;
	
	    var other = _objectWithoutProperties(_props, ['style', 'children', 'badgeContent', 'badgeStyle']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
	      children,
	      _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.badge, badgeStyle) },
	        badgeContent
	      )
	    );
	  }
	});
	
	exports.default = Badge;
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlatButtonLabel = _react2.default.createClass({
	  displayName: 'FlatButtonLabel',
	
	  propTypes: {
	    label: _react2.default.PropTypes.node,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_contextPure2.default, _stylePropable2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      return {
	        spacingDesktopGutterLess: muiTheme.rawTheme.spacing.desktopGutterLess
	      };
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	    var style = _props.style;
	
	    var contextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var mergedRootStyles = this.mergeStyles({
	      position: 'relative',
	      paddingLeft: contextKeys.spacingDesktopGutterLess,
	      paddingRight: contextKeys.spacingDesktopGutterLess
	    }, style);
	
	    return _react2.default.createElement(
	      'span',
	      { style: this.prepareStyles(mergedRootStyles) },
	      label
	    );
	  }
	
	});
	
	exports.default = FlatButtonLabel;
	module.exports = exports['default'];

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardActions = _react2.default.createClass({
	  displayName: 'CardActions',
	
	  propTypes: {
	    actAsExpander: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.node,
	    expandable: _react2.default.PropTypes.bool,
	    showExpandableButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        padding: 8,
	        position: 'relative'
	      }
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var styles = this.getStyles();
	
	    var children = _react2.default.Children.map(this.props.children, function (child) {
	      return _react2.default.cloneElement(child, {
	        style: _this.mergeStyles({ marginRight: 8 }, child.props.style)
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, this.props, { style: this.prepareStyles(styles.root, this.props.style) }),
	      children
	    );
	  }
	});
	
	exports.default = CardActions;
	module.exports = exports['default'];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(70);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _avatar = __webpack_require__(139);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardHeader = _react2.default.createClass({
	  displayName: 'CardHeader',
	
	  propTypes: {
	    actAsExpander: _react2.default.PropTypes.bool,
	    avatar: _react2.default.PropTypes.node,
	    children: _react2.default.PropTypes.node,
	    expandable: _react2.default.PropTypes.bool,
	    showExpandableButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    subtitle: _react2.default.PropTypes.node,
	    subtitleColor: _react2.default.PropTypes.string,
	    subtitleStyle: _react2.default.PropTypes.object,
	    textStyle: _react2.default.PropTypes.object,
	    title: _react2.default.PropTypes.node,
	    titleColor: _react2.default.PropTypes.string,
	    titleStyle: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      titleColor: _styles2.default.Colors.darkBlack,
	      subtitleColor: _styles2.default.Colors.lightBlack,
	      avatar: null
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        height: 72,
	        padding: 16,
	        fontWeight: _styles2.default.Typography.fontWeightMedium,
	        boxSizing: 'border-box',
	        position: 'relative'
	      },
	      text: {
	        display: 'inline-block',
	        verticalAlign: 'top'
	      },
	      avatar: {
	        marginRight: 16
	      },
	      title: {
	        color: this.props.titleColor,
	        display: 'block',
	        fontSize: 15
	      },
	      subtitle: {
	        color: this.props.subtitleColor,
	        display: 'block',
	        fontSize: 14
	      }
	    };
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    var rootStyle = this.mergeStyles(styles.root, this.props.style);
	    var textStyle = this.mergeStyles(styles.text, this.props.textStyle);
	    var titleStyle = this.mergeStyles(styles.title, this.props.titleStyle);
	    var subtitleStyle = this.mergeStyles(styles.subtitle, this.props.subtitleStyle);
	
	    var avatar = this.props.avatar;
	    if (_react2.default.isValidElement(this.props.avatar)) {
	      var avatarMergedStyle = this.mergeStyles(styles.avatar, avatar.props.style);
	      avatar = _react2.default.cloneElement(avatar, { style: avatarMergedStyle });
	    } else if (avatar !== null) {
	      avatar = _react2.default.createElement(_avatar2.default, { src: this.props.avatar, style: styles.avatar });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, this.props, { style: this.prepareStyles(rootStyle) }),
	      avatar,
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(textStyle) },
	        _react2.default.createElement(
	          'span',
	          { style: this.prepareStyles(titleStyle) },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: this.prepareStyles(subtitleStyle) },
	          this.props.subtitle
	        )
	      ),
	      this.props.children
	    );
	  }
	});
	
	exports.default = CardHeader;
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(70);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardMedia = _react2.default.createClass({
	  displayName: 'CardMedia',
	
	  propTypes: {
	    actAsExpander: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.node,
	    expandable: _react2.default.PropTypes.bool,
	    mediaStyle: _react2.default.PropTypes.object,
	    overlay: _react2.default.PropTypes.node,
	    overlayContainerStyle: _react2.default.PropTypes.object,
	    overlayContentStyle: _react2.default.PropTypes.object,
	    overlayStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        position: 'relative'
	      },
	      overlayContainer: {
	        position: 'absolute',
	        top: 0,
	        bottom: 0,
	        right: 0,
	        left: 0
	      },
	      overlay: {
	        height: '100%',
	        position: 'relative'
	      },
	      overlayContent: {
	        position: 'absolute',
	        bottom: 0,
	        right: 0,
	        left: 0,
	        paddingTop: 8,
	        background: _styles2.default.Colors.lightBlack
	      },
	      media: {},
	      mediaChild: {
	        verticalAlign: 'top',
	        maxWidth: '100%',
	        minWidth: '100%',
	        width: '100%'
	      }
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var styles = this.getStyles();
	    var rootStyle = this.mergeStyles(styles.root, this.props.style);
	    var mediaStyle = this.mergeStyles(styles.media, this.props.mediaStyle);
	    var overlayContainerStyle = this.mergeStyles(styles.overlayContainer, this.props.overlayContainerStyle);
	    var overlayContentStyle = this.mergeStyles(styles.overlayContent, this.props.overlayContentStyle);
	    var overlayStyle = this.mergeStyles(styles.overlay, this.props.overlayStyle);
	
	    var children = _react2.default.Children.map(this.props.children, function (child) {
	      return _react2.default.cloneElement(child, { style: _this.prepareStyles(styles.mediaChild, child.props.style) });
	    });
	
	    var overlayChildren = _react2.default.Children.map(this.props.overlay, function (child) {
	      if (child.type.displayName === 'CardHeader' || child.type.displayName === 'CardTitle') {
	        return _react2.default.cloneElement(child, {
	          titleColor: _styles2.default.Colors.darkWhite,
	          subtitleColor: _styles2.default.Colors.lightWhite
	        });
	      } else if (child.type.displayName === 'CardText') {
	        return _react2.default.cloneElement(child, {
	          color: _styles2.default.Colors.darkWhite
	        });
	      } else {
	        return child;
	      }
	    });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, this.props, { style: this.prepareStyles(rootStyle) }),
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(mediaStyle) },
	        children
	      ),
	      this.props.overlay ? _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(overlayContainerStyle) },
	        _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(overlayStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: this.prepareStyles(overlayContentStyle) },
	            overlayChildren
	          )
	        )
	      ) : ''
	    );
	  }
	});
	
	exports.default = CardMedia;
	module.exports = exports['default'];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardText = _react2.default.createClass({
	  displayName: 'CardText',
	
	  propTypes: {
	    actAsExpander: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.node,
	    color: _react2.default.PropTypes.string,
	    expandable: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    var themeVariables = this.state.muiTheme.cardText;
	    return {
	      root: {
	        padding: 16,
	        fontSize: '14px',
	        color: this.props.color ? this.props.color : themeVariables.textColor
	      }
	    };
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    var rootStyle = this.mergeStyles(styles.root, this.props.style);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, this.props, { style: this.prepareStyles(rootStyle) }),
	      this.props.children
	    );
	  }
	});
	
	exports.default = CardText;
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(70);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardTitle = _react2.default.createClass({
	  displayName: 'CardTitle',
	
	  propTypes: {
	    actAsExpander: _react2.default.PropTypes.bool,
	    children: _react2.default.PropTypes.node,
	    expandable: _react2.default.PropTypes.bool,
	    showExpandableButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    subtitle: _react2.default.PropTypes.node,
	    subtitleColor: _react2.default.PropTypes.string,
	    subtitleStyle: _react2.default.PropTypes.object,
	    title: _react2.default.PropTypes.node,
	    titleColor: _react2.default.PropTypes.string,
	    titleStyle: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      titleColor: _styles2.default.Colors.darkBlack,
	      subtitleColor: _styles2.default.Colors.lightBlack
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      muiTheme: newMuiTheme
	    });
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        padding: 16,
	        position: 'relative'
	      },
	      title: {
	        fontSize: 24,
	        color: this.props.titleColor,
	        display: 'block',
	        lineHeight: '36px'
	      },
	      subtitle: {
	        fontSize: 14,
	        color: this.props.subtitleColor,
	        display: 'block'
	      }
	    };
	  },
	  render: function render() {
	    var styles = this.getStyles();
	    var rootStyle = this.mergeStyles(styles.root, this.props.style);
	    var titleStyle = this.mergeStyles(styles.title, this.props.titleStyle);
	    var subtitleStyle = this.mergeStyles(styles.subtitle, this.props.subtitleStyle);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, this.props, { style: this.prepareStyles(rootStyle) }),
	      _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(titleStyle) },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(subtitleStyle) },
	        this.props.subtitle
	      ),
	      this.props.children
	    );
	  }
	});
	
	exports.default = CardTitle;
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _cardExpandable = __webpack_require__(141);
	
	var _cardExpandable2 = _interopRequireDefault(_cardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Card = _react2.default.createClass({
	  displayName: 'Card',
	
	  propTypes: {
	    /**
	     * Whether a click on this card component expands the card. Can be set on any child of the Card component.
	     */
	    actAsExpander: _react2.default.PropTypes.bool,
	
	    /**
	     * Can be used to render elements inside the Card.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Whether this card component is expandable. Can be set on any child of the Card component.
	     */
	    expandable: _react2.default.PropTypes.bool,
	
	    /**
	     * Whether this card is initially expanded.
	     */
	    initiallyExpanded: _react2.default.PropTypes.bool,
	
	    /**
	     * Fired when the expandable state changes.
	     */
	    onExpandChange: _react2.default.PropTypes.func,
	
	    /**
	     * Whether this card component include a button to expand the card. CardTitle,
	     * CardHeader and CardActions implement showExpandableButton. Any child component
	     * of Card can implements showExpandableButton or forwards the property to a child
	     * component supporting it.
	     */
	    showExpandableButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      expandable: false,
	      initiallyExpanded: false,
	      actAsExpander: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      expanded: this.props.initiallyExpanded ? true : false
	    };
	  },
	  _onExpandable: function _onExpandable(event) {
	    event.preventDefault();
	    var newExpandedState = !(this.state.expanded === true);
	    this.setState({ expanded: newExpandedState });
	    if (this.props.onExpandChange) this.props.onExpandChange(newExpandedState);
	  },
	  render: function render() {
	    var _this = this;
	
	    var lastElement = undefined;
	    var newChildren = _react2.default.Children.map(this.props.children, function (currentChild) {
	      var doClone = false;
	      var newChild = undefined;
	      var newProps = {};
	      var element = currentChild;
	      if (!currentChild || !currentChild.props) {
	        return null;
	      }
	      if (_this.state.expanded === false && currentChild.props.expandable === true) return;
	      if (currentChild.props.actAsExpander === true) {
	        doClone = true;
	        newProps.onTouchTap = _this._onExpandable;
	        newProps.style = _this.mergeStyles({ cursor: 'pointer' }, currentChild.props.style);
	      }
	      if (currentChild.props.showExpandableButton === true) {
	        doClone = true;
	        newChild = _react2.default.createElement(_cardExpandable2.default, { expanded: _this.state.expanded, onExpanding: _this._onExpandable });
	      }
	      if (doClone) {
	        element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	      }
	      return element;
	    }, this);
	
	    // If the last element is text or a title we should add
	    // 8px padding to the bottom of the card
	    var addBottomPadding = lastElement && (lastElement.type.displayName === 'CardText' || lastElement.type.displayName === 'CardTitle');
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    var mergedStyles = this.mergeStyles({
	      overflow: 'hidden',
	      zIndex: 1
	    }, style);
	
	    return _react2.default.createElement(
	      _paper2.default,
	      _extends({}, other, { style: mergedStyles }),
	      _react2.default.createElement(
	        'div',
	        { style: { paddingBottom: addBottomPadding ? 8 : 0 } },
	        newChildren
	      )
	    );
	  }
	});
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CircularProgress = _react2.default.createClass({
	  displayName: 'CircularProgress',
	
	  propTypes: {
	    /**
	     * Override the progress's color.
	     */
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * Style for inner wrapper div.
	     */
	    innerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The max value of progress, only works in determinate mode.
	     */
	    max: _react2.default.PropTypes.number,
	
	    /**
	     * The min value of progress, only works in determinate mode.
	     */
	    min: _react2.default.PropTypes.number,
	
	    /**
	     * The mode of show your progress, indeterminate
	     * for when there is no value for progress.
	     */
	    mode: _react2.default.PropTypes.oneOf(['determinate', 'indeterminate']),
	
	    /**
	     * The size of the progress.
	     */
	    size: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of progress, only works in determinate mode.
	     */
	    value: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      mode: 'indeterminate',
	      value: 0,
	      min: 0,
	      max: 100,
	      size: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var wrapper = _reactDom2.default.findDOMNode(this.refs.wrapper);
	    var path = _reactDom2.default.findDOMNode(this.refs.path);
	
	    this._scalePath(path);
	    this._rotateWrapper(wrapper);
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.scalePathTimer);
	    clearTimeout(this.rotateWrapperTimer);
	  },
	  _getRelativeValue: function _getRelativeValue() {
	    var value = this.props.value;
	    var min = this.props.min;
	    var max = this.props.max;
	
	    var clampedValue = Math.min(Math.max(min, value), max);
	    var rangeValue = max - min;
	    var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
	    return relValue * 100;
	  },
	
	  scalePathTimer: undefined,
	  rotateWrapperTimer: undefined,
	
	  _scalePath: function _scalePath(path, step) {
	    var _this = this;
	
	    if (this.props.mode !== 'indeterminate') return;
	
	    step = step || 0;
	    step %= 3;
	
	    if (step === 0) {
	      path.style.strokeDasharray = '1, 200';
	      path.style.strokeDashoffset = 0;
	      path.style.transitionDuration = '0ms';
	    } else if (step === 1) {
	      path.style.strokeDasharray = '89, 200';
	      path.style.strokeDashoffset = -35;
	      path.style.transitionDuration = '750ms';
	    } else {
	      path.style.strokeDasharray = '89,200';
	      path.style.strokeDashoffset = -124;
	      path.style.transitionDuration = '850ms';
	    }
	
	    this.scalePathTimer = setTimeout(function () {
	      return _this._scalePath(path, step + 1);
	    }, step ? 750 : 250);
	  },
	  _rotateWrapper: function _rotateWrapper(wrapper) {
	    var _this2 = this;
	
	    if (this.props.mode !== 'indeterminate') return;
	
	    _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)', this.state.muiTheme);
	    _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms', this.state.muiTheme);
	
	    setTimeout(function () {
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)', _this2.state.muiTheme);
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s', _this2.state.muiTheme);
	      _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear', _this2.state.muiTheme);
	    }, 50);
	
	    this.rotateWrapperTimer = setTimeout(function () {
	      return _this2._rotateWrapper(wrapper);
	    }, 10050);
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.rawTheme.palette;
	  },
	  getStyles: function getStyles(zoom) {
	    zoom *= 1.4;
	    var size = '50px';
	
	    var margin = Math.round((50 * zoom - 50) / 2);
	
	    if (margin < 0) margin = 0;
	
	    var styles = {
	      root: {
	        position: 'relative',
	        margin: margin + 'px',
	        display: 'inline-block',
	        width: size,
	        height: size
	      },
	      wrapper: {
	        width: size,
	        height: size,
	        display: 'inline-block',
	        transition: _transitions2.default.create('transform', '20s', null, 'linear')
	      },
	      svg: {
	        height: size,
	        position: 'relative',
	        transform: 'scale(' + zoom + ')',
	        width: size
	      },
	      path: {
	        strokeDasharray: '89,200',
	        strokeDashoffset: 0,
	        stroke: this.props.color || this.getTheme().primary1Color,
	        strokeLinecap: 'round',
	        transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	      }
	    };
	
	    _autoPrefix2.default.set(styles.wrapper, 'transitionTimingFunction', 'linear', this.state.muiTheme);
	
	    if (this.props.mode === 'determinate') {
	      var relVal = this._getRelativeValue();
	      styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	      styles.path.strokeDasharray = Math.round(relVal * 1.25) + ',200';
	    }
	
	    return styles;
	  },
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var innerStyle = _props.innerStyle;
	    var size = _props.size;
	
	    var other = _objectWithoutProperties(_props, ['style', 'innerStyle', 'size']);
	
	    var styles = this.getStyles(size || 1);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
	      _react2.default.createElement(
	        'div',
	        { ref: 'wrapper', style: this.prepareStyles(styles.wrapper, innerStyle) },
	        _react2.default.createElement(
	          'svg',
	          { style: this.prepareStyles(styles.svg) },
	          _react2.default.createElement('circle', {
	            ref: 'path', style: this.prepareStyles(styles.path), cx: '25',
	            cy: '25', r: '20', fill: 'none',
	            strokeWidth: '2.5', strokeMiterlimit: '10'
	          })
	        )
	      )
	    );
	  }
	});
	
	exports.default = CircularProgress;
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateTime = __webpack_require__(49);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	var _dayButton = __webpack_require__(258);
	
	var _dayButton2 = _interopRequireDefault(_dayButton);
	
	var _clearfix = __webpack_require__(53);
	
	var _clearfix2 = _interopRequireDefault(_clearfix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarMonth = _react2.default.createClass({
	  displayName: 'CalendarMonth',
	
	  propTypes: {
	    autoOk: _react2.default.PropTypes.bool,
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    firstDayOfWeek: _react2.default.PropTypes.number,
	    maxDate: _react2.default.PropTypes.object,
	    minDate: _react2.default.PropTypes.object,
	    onDayTouchTap: _react2.default.PropTypes.func,
	    selectedDate: _react2.default.PropTypes.object.isRequired,
	    shouldDisableDate: _react2.default.PropTypes.func
	  },
	
	  isSelectedDateDisabled: function isSelectedDateDisabled() {
	    return this._selectedDateDisabled;
	  },
	  _getWeekElements: function _getWeekElements() {
	    var _this = this;
	
	    var weekArray = _dateTime2.default.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);
	
	    return weekArray.map(function (week, i) {
	      return _react2.default.createElement(
	        _clearfix2.default,
	        { key: i },
	        _this._getDayElements(week, i)
	      );
	    }, this);
	  },
	  _getDayElements: function _getDayElements(week, i) {
	    var _this2 = this;
	
	    return week.map(function (day, j) {
	      var isSameDate = _dateTime2.default.isEqualDate(_this2.props.selectedDate, day);
	      var disabled = _this2._shouldDisableDate(day);
	      var selected = !disabled && isSameDate;
	
	      if (isSameDate) {
	        if (disabled) {
	          _this2._selectedDateDisabled = true;
	        } else {
	          _this2._selectedDateDisabled = false;
	        }
	      }
	
	      return _react2.default.createElement(_dayButton2.default, {
	        key: 'db' + i + j,
	        date: day,
	        onTouchTap: _this2._handleDayTouchTap,
	        selected: selected,
	        disabled: disabled
	      });
	    }, this);
	  },
	  _handleDayTouchTap: function _handleDayTouchTap(e, date) {
	    if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
	  },
	  _shouldDisableDate: function _shouldDisableDate(day) {
	    if (day === null) return false;
	    var disabled = !_dateTime2.default.isBetweenDates(day, this.props.minDate, this.props.maxDate);
	    if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	    return disabled;
	  },
	  render: function render() {
	    var styles = {
	      lineHeight: '32px',
	      textAlign: 'center',
	      padding: '16px 14px 0 14px'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: styles },
	      this._getWeekElements()
	    );
	  }
	});
	
	exports.default = CalendarMonth;
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconButton = __webpack_require__(56);
	
	var _iconButton2 = _interopRequireDefault(_iconButton);
	
	var _toolbar = __webpack_require__(160);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _toolbarGroup = __webpack_require__(159);
	
	var _toolbarGroup2 = _interopRequireDefault(_toolbarGroup);
	
	var _chevronLeft = __webpack_require__(152);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(153);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _slideIn = __webpack_require__(104);
	
	var _slideIn2 = _interopRequireDefault(_slideIn);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    position: 'relative',
	    padding: 0,
	    backgroundColor: 'inherit'
	  },
	  title: {
	    position: 'absolute',
	    top: 17,
	    lineHeight: '14px',
	    fontSize: 14,
	    height: 14,
	    width: '100%',
	    fontWeight: '500',
	    textAlign: 'center'
	  }
	};
	
	var CalendarToolbar = _react2.default.createClass({
	  displayName: 'CalendarToolbar',
	
	  propTypes: {
	    DateTimeFormat: _react2.default.PropTypes.func.isRequired,
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    locale: _react2.default.PropTypes.string.isRequired,
	    nextMonth: _react2.default.PropTypes.bool,
	    onMonthChange: _react2.default.PropTypes.func,
	    prevMonth: _react2.default.PropTypes.bool
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      nextMonth: true,
	      prevMonth: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      transitionDirection: 'up'
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    var direction = undefined;
	
	    if (nextProps.displayDate !== this.props.displayDate) {
	      direction = nextProps.displayDate > this.props.displayDate ? 'up' : 'down';
	      this.setState({
	        transitionDirection: direction
	      });
	    }
	  },
	  _prevMonthTouchTap: function _prevMonthTouchTap() {
	    if (this.props.onMonthChange && this.props.prevMonth) this.props.onMonthChange(-1);
	  },
	  _nextMonthTouchTap: function _nextMonthTouchTap() {
	    if (this.props.onMonthChange && this.props.nextMonth) this.props.onMonthChange(1);
	  },
	  render: function render() {
	    var _props = this.props;
	    var DateTimeFormat = _props.DateTimeFormat;
	    var locale = _props.locale;
	    var displayDate = _props.displayDate;
	
	    var dateTimeFormatted = new DateTimeFormat(locale, {
	      month: 'long',
	      year: 'numeric'
	    }).format(displayDate);
	
	    var nextButtonIcon = this.state.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);
	    var prevButtonIcon = this.state.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
	
	    return _react2.default.createElement(
	      _toolbar2.default,
	      { style: styles.root, noGutter: true },
	      _react2.default.createElement(
	        _slideIn2.default,
	        {
	          style: styles.title,
	          direction: this.state.transitionDirection
	        },
	        _react2.default.createElement(
	          'div',
	          { key: dateTimeFormatted },
	          dateTimeFormatted
	        )
	      ),
	      _react2.default.createElement(
	        _toolbarGroup2.default,
	        { key: 0, float: 'left' },
	        _react2.default.createElement(
	          _iconButton2.default,
	          {
	            style: styles.button,
	            disabled: !this.props.prevMonth,
	            onTouchTap: this._prevMonthTouchTap
	          },
	          nextButtonIcon
	        )
	      ),
	      _react2.default.createElement(
	        _toolbarGroup2.default,
	        { key: 1, float: 'right' },
	        _react2.default.createElement(
	          _iconButton2.default,
	          {
	            style: styles.button,
	            disabled: !this.props.nextMonth,
	            onTouchTap: this._nextMonthTouchTap
	          },
	          prevButtonIcon
	        )
	      )
	    );
	  }
	});
	
	exports.default = CalendarToolbar;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _dateTime = __webpack_require__(49);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	var _yearButton = __webpack_require__(259);
	
	var _yearButton2 = _interopRequireDefault(_yearButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = _react2.default.createClass({
	  displayName: 'CalendarYear',
	
	  propTypes: {
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    maxDate: _react2.default.PropTypes.object,
	    minDate: _react2.default.PropTypes.object,
	    onYearTouchTap: _react2.default.PropTypes.func,
	    selectedDate: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_stylePropable2.default],
	
	  componentDidMount: function componentDidMount() {
	    this._scrollToSelectedYear();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._scrollToSelectedYear();
	  },
	  _getYears: function _getYears() {
	    var minYear = this.props.minDate.getFullYear();
	    var maxYear = this.props.maxDate.getFullYear();
	
	    var years = [];
	    var dateCheck = _dateTime2.default.clone(this.props.selectedDate);
	    for (var year = minYear; year <= maxYear; year++) {
	      dateCheck.setFullYear(year);
	      if (!_dateTime2.default.isBetweenDates(dateCheck, this.props.minDate, this.props.maxDate)) continue;
	      var selected = this.props.selectedDate.getFullYear() === year;
	      var selectedProps = {};
	      if (selected) {
	        selectedProps = { ref: 'selectedYearButton' };
	      }
	
	      var yearButton = _react2.default.createElement(_yearButton2.default, _extends({
	        key: 'yb' + year,
	        year: year,
	        onTouchTap: this._handleYearTouchTap,
	        selected: selected
	      }, selectedProps));
	
	      years.push(yearButton);
	    }
	
	    return years;
	  },
	  _scrollToSelectedYear: function _scrollToSelectedYear() {
	    if (this.refs.selectedYearButton === undefined) return;
	
	    var container = _reactDom2.default.findDOMNode(this);
	    var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	    var containerHeight = container.clientHeight;
	    var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	    var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	    container.scrollTop = scrollYOffset;
	  },
	  _handleYearTouchTap: function _handleYearTouchTap(e, year) {
	    if (this.props.onYearTouchTap) this.props.onYearTouchTap(e, year);
	  },
	  render: function render() {
	    var years = this._getYears();
	    var styles = {
	      position: 'relative',
	      height: 'inherit',
	      lineHeight: '36px',
	      textAlign: 'center',
	      padding: '8px 14px 0 14px',
	      backgroundColor: _colors2.default.white,
	      overflowX: 'hidden',
	      overflowY: 'scroll'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: styles },
	      years
	    );
	  }
	});
	
	exports.default = CalendarYear;
	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _dateTime = __webpack_require__(49);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _calendarMonth = __webpack_require__(251);
	
	var _calendarMonth2 = _interopRequireDefault(_calendarMonth);
	
	var _calendarYear = __webpack_require__(253);
	
	var _calendarYear2 = _interopRequireDefault(_calendarYear);
	
	var _calendarToolbar = __webpack_require__(252);
	
	var _calendarToolbar2 = _interopRequireDefault(_calendarToolbar);
	
	var _dateDisplay = __webpack_require__(255);
	
	var _dateDisplay2 = _interopRequireDefault(_dateDisplay);
	
	var _slideIn = __webpack_require__(104);
	
	var _slideIn2 = _interopRequireDefault(_slideIn);
	
	var _clearfix = __webpack_require__(53);
	
	var _clearfix2 = _interopRequireDefault(_clearfix);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var daysArray = [].concat(_toConsumableArray(Array(7)));
	
	var Calendar = _react2.default.createClass({
	  displayName: 'Calendar',
	
	  propTypes: {
	    DateTimeFormat: _react2.default.PropTypes.func.isRequired,
	    disableYearSelection: _react2.default.PropTypes.bool,
	    firstDayOfWeek: _react2.default.PropTypes.number,
	    initialDate: _react2.default.PropTypes.object,
	    locale: _react2.default.PropTypes.string.isRequired,
	    maxDate: _react2.default.PropTypes.object,
	    minDate: _react2.default.PropTypes.object,
	    mode: _react2.default.PropTypes.oneOf(['portrait', 'landscape']),
	    onDayTouchTap: _react2.default.PropTypes.func,
	    open: _react2.default.PropTypes.bool,
	    shouldDisableDate: _react2.default.PropTypes.func
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disableYearSelection: false,
	      initialDate: new Date(),
	      minDate: _dateTime2.default.addYears(new Date(), -100),
	      maxDate: _dateTime2.default.addYears(new Date(), 100)
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      displayDate: _dateTime2.default.getFirstDayOfMonth(this.props.initialDate),
	      displayMonthDay: true,
	      selectedDate: this.props.initialDate,
	      transitionDirection: 'left',
	      transitionEnter: true
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (nextProps.initialDate !== this.props.initialDate) {
	      var d = nextProps.initialDate || new Date();
	      this.setState({
	        displayDate: _dateTime2.default.getFirstDayOfMonth(d),
	        selectedDate: d
	      });
	    }
	  },
	
	  windowListeners: {
	    keydown: '_handleWindowKeyDown'
	  },
	
	  _yearSelector: function _yearSelector() {
	    if (this.props.disableYearSelection) return;
	
	    return _react2.default.createElement(_calendarYear2.default, {
	      key: 'years',
	      displayDate: this.state.displayDate,
	      onYearTouchTap: this._handleYearTouchTap,
	      selectedDate: this.state.selectedDate,
	      minDate: this.props.minDate,
	      maxDate: this.props.maxDate
	    });
	  },
	  getSelectedDate: function getSelectedDate() {
	    return this.state.selectedDate;
	  },
	  isSelectedDateDisabled: function isSelectedDateDisabled() {
	    if (!this.state.displayMonthDay) {
	      return false;
	    }
	
	    return this.refs.calendar.isSelectedDateDisabled();
	  },
	  _addSelectedDays: function _addSelectedDays(days) {
	    this._setSelectedDate(_dateTime2.default.addDays(this.state.selectedDate, days));
	  },
	  _addSelectedMonths: function _addSelectedMonths(months) {
	    this._setSelectedDate(_dateTime2.default.addMonths(this.state.selectedDate, months));
	  },
	  _addSelectedYears: function _addSelectedYears(years) {
	    this._setSelectedDate(_dateTime2.default.addYears(this.state.selectedDate, years));
	  },
	  _setDisplayDate: function _setDisplayDate(d, newSelectedDate) {
	    var newDisplayDate = _dateTime2.default.getFirstDayOfMonth(d);
	    var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	    if (newDisplayDate !== this.state.displayDate) {
	      this.setState({
	        displayDate: newDisplayDate,
	        transitionDirection: direction,
	        selectedDate: newSelectedDate || this.state.selectedDate
	      });
	    }
	  },
	  _setSelectedDate: function _setSelectedDate(date) {
	    var adjustedDate = date;
	    if (_dateTime2.default.isBeforeDate(date, this.props.minDate)) {
	      adjustedDate = this.props.minDate;
	    } else if (_dateTime2.default.isAfterDate(date, this.props.maxDate)) {
	      adjustedDate = this.props.maxDate;
	    }
	
	    var newDisplayDate = _dateTime2.default.getFirstDayOfMonth(adjustedDate);
	    if (newDisplayDate !== this.state.displayDate) {
	      this._setDisplayDate(newDisplayDate, adjustedDate);
	    } else {
	      this.setState({
	        selectedDate: adjustedDate
	      });
	    }
	  },
	  _handleDayTouchTap: function _handleDayTouchTap(e, date) {
	    this._setSelectedDate(date);
	    if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
	  },
	  _handleMonthChange: function _handleMonthChange(months) {
	    this.setState({
	      transitionDirection: months >= 0 ? 'left' : 'right',
	      displayDate: _dateTime2.default.addMonths(this.state.displayDate, months)
	    });
	  },
	  _handleYearTouchTap: function _handleYearTouchTap(e, year) {
	    var date = _dateTime2.default.clone(this.state.selectedDate);
	    date.setFullYear(year);
	    this._setSelectedDate(date, e);
	  },
	  _getToolbarInteractions: function _getToolbarInteractions() {
	    return {
	      prevMonth: _dateTime2.default.monthDiff(this.state.displayDate, this.props.minDate) > 0,
	      nextMonth: _dateTime2.default.monthDiff(this.state.displayDate, this.props.maxDate) < 0
	    };
	  },
	  _handleMonthDayClick: function _handleMonthDayClick() {
	    this.setState({
	      displayMonthDay: true
	    });
	  },
	  _handleYearClick: function _handleYearClick() {
	    this.setState({
	      displayMonthDay: false
	    });
	  },
	  _handleWindowKeyDown: function _handleWindowKeyDown(e) {
	    if (this.props.open) {
	
	      switch (e.keyCode) {
	        case _keyCode2.default.UP:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(-1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(-1);
	          } else {
	            this._addSelectedDays(-7);
	          }
	          break;
	
	        case _keyCode2.default.DOWN:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(1);
	          } else {
	            this._addSelectedDays(7);
	          }
	          break;
	
	        case _keyCode2.default.RIGHT:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(1);
	          } else {
	            this._addSelectedDays(1);
	          }
	          break;
	
	        case _keyCode2.default.LEFT:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(-1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(-1);
	          } else {
	            this._addSelectedDays(-1);
	          }
	          break;
	      }
	    }
	  },
	  render: function render() {
	    var yearCount = _dateTime2.default.yearDiff(this.props.maxDate, this.props.minDate) + 1;
	    var weekCount = _dateTime2.default.getWeekArray(this.state.displayDate, this.props.firstDayOfWeek).length;
	    var toolbarInteractions = this._getToolbarInteractions();
	    var isLandscape = this.props.mode === 'landscape';
	    var styles = {
	      root: {
	        fontSize: 12
	      },
	      calendarContainer: {
	        width: isLandscape ? 320 : '100%',
	        height: weekCount === 5 ? 284 : weekCount === 6 ? 324 : 244,
	        float: isLandscape ? 'right' : 'none',
	        transition: _transitions2.default.easeOut('150ms', 'height'),
	        overflow: 'hidden'
	      },
	      yearContainer: {
	        width: 280,
	        overflow: 'hidden',
	        height: yearCount < 6 ? yearCount * 56 + 10 : weekCount === 5 ? 284 : weekCount === 6 ? 324 : 244,
	        float: isLandscape ? 'right' : 'none'
	      },
	      dateDisplay: {
	        width: isLandscape ? 120 : '',
	        height: isLandscape ? weekCount === 5 ? 238 : weekCount === 6 ? 278 : 198 : 'auto',
	        float: isLandscape ? 'left' : 'none'
	      },
	      weekTitle: {
	        padding: '0 14px',
	        lineHeight: '12px',
	        opacity: '0.5',
	        height: 12,
	        fontWeight: '500',
	        margin: 0
	      },
	      weekTitleDay: {
	        listStyle: 'none',
	        float: 'left',
	        width: 37,
	        textAlign: 'center',
	        margin: '0 2px'
	      }
	    };
	
	    var weekTitleDayStyle = this.prepareStyles(styles.weekTitleDay);
	    var _props = this.props;
	    var DateTimeFormat = _props.DateTimeFormat;
	    var locale = _props.locale;
	    var firstDayOfWeek = _props.firstDayOfWeek;
	
	    return _react2.default.createElement(
	      _clearfix2.default,
	      { style: this.mergeStyles(styles.root) },
	      _react2.default.createElement(_dateDisplay2.default, {
	        DateTimeFormat: DateTimeFormat,
	        locale: locale,
	        disableYearSelection: this.props.disableYearSelection,
	        style: styles.dateDisplay,
	        selectedDate: this.state.selectedDate,
	        handleMonthDayClick: this._handleMonthDayClick,
	        handleYearClick: this._handleYearClick,
	        monthDaySelected: this.state.displayMonthDay,
	        mode: this.props.mode,
	        weekCount: weekCount
	      }),
	      this.state.displayMonthDay && _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.calendarContainer) },
	        _react2.default.createElement(_calendarToolbar2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          displayDate: this.state.displayDate,
	          onMonthChange: this._handleMonthChange,
	          prevMonth: toolbarInteractions.prevMonth,
	          nextMonth: toolbarInteractions.nextMonth
	        }),
	        _react2.default.createElement(
	          _clearfix2.default,
	          {
	            elementType: 'ul',
	            style: styles.weekTitle
	          },
	          daysArray.map(function (e, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i, style: weekTitleDayStyle },
	              _dateTime2.default.localizedWeekday(DateTimeFormat, locale, i, firstDayOfWeek)
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _slideIn2.default,
	          { direction: this.state.transitionDirection },
	          _react2.default.createElement(_calendarMonth2.default, {
	            key: this.state.displayDate.toDateString(),
	            ref: 'calendar',
	            displayDate: this.state.displayDate,
	            onDayTouchTap: this._handleDayTouchTap,
	            selectedDate: this.state.selectedDate,
	            minDate: this.props.minDate,
	            maxDate: this.props.maxDate,
	            shouldDisableDate: this.props.shouldDisableDate,
	            firstDayOfWeek: this.props.firstDayOfWeek
	          })
	        )
	      ),
	      !this.state.displayMonthDay && _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.yearContainer) },
	        this._yearSelector()
	      )
	    );
	  }
	});
	
	exports.default = Calendar;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _slideIn = __webpack_require__(104);
	
	var _slideIn2 = _interopRequireDefault(_slideIn);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DateDisplay = _react2.default.createClass({
	  displayName: 'DateDisplay',
	
	  propTypes: {
	    DateTimeFormat: _react2.default.PropTypes.func.isRequired,
	    disableYearSelection: _react2.default.PropTypes.bool,
	    handleMonthDayClick: _react2.default.PropTypes.func,
	    handleYearClick: _react2.default.PropTypes.func,
	    locale: _react2.default.PropTypes.string.isRequired,
	    mode: _react2.default.PropTypes.oneOf(['portrait', 'landscape']),
	    monthDaySelected: _react2.default.PropTypes.bool,
	    selectedDate: _react2.default.PropTypes.object.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    weekCount: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disableYearSelection: false,
	      monthDaySelected: true,
	      weekCount: 4
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      selectedYear: !this.props.monthDaySelected,
	      transitionDirection: 'up',
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    var direction = undefined;
	
	    if (nextProps.selectedDate !== this.props.selectedDate) {
	      direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	      this.setState({
	        transitionDirection: direction
	      });
	    }
	
	    if (nextProps.monthDaySelected !== undefined) {
	      this.setState({ selectedYear: !nextProps.monthDaySelected });
	    }
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.datePicker;
	  },
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var isLandscape = this.props.mode === 'landscape';
	
	    var styles = {
	      root: {
	        backgroundColor: theme.selectColor,
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        color: theme.textColor,
	        height: 60,
	        padding: 20
	      },
	
	      monthDay: {
	        root: {
	          display: 'inline-block',
	          fontSize: 36,
	          fontWeight: '400',
	          lineHeight: '36px',
	          height: isLandscape ? 76 : 38,
	          opacity: this.state.selectedYear ? 0.7 : 1.0,
	          transition: _transitions2.default.easeOut(),
	          width: '100%'
	        },
	
	        title: {
	          cursor: !this.state.selectedYear ? 'default' : 'pointer'
	        }
	      },
	
	      year: {
	        root: {
	          margin: 0,
	          fontSize: 16,
	          fontWeight: '400',
	          lineHeight: '16px',
	          height: 16,
	          opacity: this.state.selectedYear ? 1.0 : 0.7,
	          transition: _transitions2.default.easeOut(),
	          marginBottom: 10
	        },
	
	        title: {
	          cursor: this.state.selectedYear && !this.props.disableYearSelection ? 'pointer' : 'default'
	        }
	      }
	    };
	
	    return styles;
	  },
	  _handleMonthDayClick: function _handleMonthDayClick() {
	    if (this.props.handleMonthDayClick && this.state.selectedYear) {
	      this.props.handleMonthDayClick();
	    }
	
	    this.setState({ selectedYear: false });
	  },
	  _handleYearClick: function _handleYearClick() {
	    if (this.props.handleYearClick && !this.props.disableYearSelection && !this.state.selectedYear) {
	      this.props.handleYearClick();
	    }
	
	    if (!this.props.disableYearSelection) {
	      this.setState({ selectedYear: true });
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var DateTimeFormat = _props.DateTimeFormat;
	    var locale = _props.locale;
	    var selectedDate = _props.selectedDate;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['DateTimeFormat', 'locale', 'selectedDate', 'style']);
	
	    var year = this.props.selectedDate.getFullYear();
	    var styles = this.getStyles();
	
	    var dateTimeFormatted = new DateTimeFormat(locale, {
	      month: 'short',
	      weekday: 'short',
	      day: '2-digit'
	    }).format(this.props.selectedDate);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles.root, this.props.style) }),
	      _react2.default.createElement(
	        _slideIn2.default,
	        {
	          style: styles.year.root,
	          direction: this.state.transitionDirection
	        },
	        _react2.default.createElement(
	          'div',
	          { key: year, style: styles.year.title, onTouchTap: this._handleYearClick },
	          year
	        )
	      ),
	      _react2.default.createElement(
	        _slideIn2.default,
	        {
	          style: styles.monthDay.root,
	          direction: this.state.transitionDirection
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            key: dateTimeFormatted,
	            style: styles.monthDay.title,
	            onTouchTap: this._handleMonthDayClick
	          },
	          dateTimeFormatted
	        )
	      )
	    );
	  }
	});
	
	exports.default = DateDisplay;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  actions: {
	    marginRight: 8,
	    paddingBottom: 12,
	    textAlign: 'right'
	  },
	  container: {
	    zIndex: 3,
	    width: '100%',
	    position: 'relative',
	    display: 'block'
	  },
	  subContainer: {
	    position: 'absolute',
	    height: 'auto'
	  }
	};
	
	var DatePickerInline = function (_React$Component) {
	  _inherits(DatePickerInline, _React$Component);
	
	  function DatePickerInline() {
	    _classCallCheck(this, DatePickerInline);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DatePickerInline).apply(this, arguments));
	  }
	
	  _createClass(DatePickerInline, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var actions = _props.actions;
	      var children = _props.children;
	      var open = _props.open;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['actions', 'children', 'open', 'style']);
	
	      if (!open) {
	        return _react2.default.createElement('span', null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _react2.default.createElement(
	          'div',
	          { style: styles.subContainer },
	          _react2.default.createElement(
	            _paper2.default,
	            other,
	            children,
	            _react2.default.createElement(
	              'div',
	              { style: styles.actions },
	              actions
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DatePickerInline;
	}(_react2.default.Component);
	
	DatePickerInline.propTypes = {
	  actions: _react2.default.PropTypes.node,
	  children: _react2.default.PropTypes.node,
	  open: _react2.default.PropTypes.bool,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object
	};
	DatePickerInline.defaultProps = {
	  open: false
	};
	exports.default = DatePickerInline;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _dateTime = __webpack_require__(49);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	var _datePickerDialog = __webpack_require__(142);
	
	var _datePickerDialog2 = _interopRequireDefault(_datePickerDialog);
	
	var _textField = __webpack_require__(71);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DatePicker = _react2.default.createClass({
	  displayName: 'DatePicker',
	
	  propTypes: {
	    /**
	     * Constructor for time formatting.
	     * Follow this specificaction: ECMAScript Internationalization API 1.0 (ECMA-402).
	     */
	    DateTimeFormat: _react2.default.PropTypes.func,
	
	    /**
	     * If true, automatically accept and close the picker on select a date.
	     */
	    autoOk: _react2.default.PropTypes.bool,
	
	    /**
	     * Used to control how the DatePicker will be displayed when a user tries to set a date.
	     * `dialog` (default) displays the DatePicker as a dialog with a modal.
	     * `inline` displays the DatePicker below the input field (similar to auto complete).
	     */
	    container: _react2.default.PropTypes.oneOf(['dialog', 'inline']),
	
	    /**
	     * This is the initial date value of the component.
	     * If either `value` or `valueLink` is provided they will override this
	     * prop with `value` taking precedence.
	     */
	    defaultDate: _react2.default.PropTypes.object,
	
	    /**
	     * Disables the year selection in the date picker.
	     */
	    disableYearSelection: _react2.default.PropTypes.bool,
	
	    /**
	     * Disables the DatePicker.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Used to change the first day of week. It drastically varies from
	     * Saturday to Monday (could even be Friday) between different locales.
	     * The allowed range is 0 (Sunday) to 6 (Saturday).
	     */
	    firstDayOfWeek: _react2.default.PropTypes.number,
	
	    /**
	     * This function is called to format the date to display in the input box.
	     * By default, date objects are formatted to MM/DD/YYYY.
	     */
	    formatDate: _react2.default.PropTypes.func,
	
	    /**
	     * Locale used for formatting date. If you are not using the default value, you
	     * have to provide a DateTimeFormat that supports it. You can use Intl.DateTimeFormat
	     * if it's supported by your environment.
	     * https://github.com/andyearnshaw/Intl.js is a good polyfill.
	     */
	    locale: _react2.default.PropTypes.string,
	
	    /**
	     * The ending of a range of valid dates. The range includes the endDate.
	     * The default value is current date + 100 years.
	     */
	    maxDate: _react2.default.PropTypes.object,
	
	    /**
	     * The beginning of a range of valid dates. The range includes the startDate.
	     * The default value is current date - 100 years.
	     */
	    minDate: _react2.default.PropTypes.object,
	
	    /**
	     * Tells the component to display the picker in portrait or landscape mode.
	     */
	    mode: _react2.default.PropTypes.oneOf(['portrait', 'landscape']),
	
	    /**
	     * Callback function that is fired when the date value changes. Since there
	     * is no particular event associated with the change the first argument
	     * will always be null and the second argument will be the new Date instance.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when the datepicker dialog is dismissed.
	     */
	    onDismiss: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the datepicker field gains focus.
	     */
	    onFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when the datepicker dialog is shown.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * Called when touch tap event occurs on text-field.
	     */
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Called during render time of a given day. If this method returns
	     * false the day is disabled otherwise it is displayed normally.
	     */
	    shouldDisableDate: _react2.default.PropTypes.func,
	
	    /**
	     *  Enables the year selection in the date picker.
	     */
	    showYearSelector: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.bool, 'Instead, use disableYearSelection.'),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of DatePicker's TextField element.
	     */
	    textFieldStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Sets the date for the Date Picker programmatically.
	     */
	    value: _react2.default.PropTypes.any,
	
	    /**
	     * Creates a ValueLink with the value of date picker.
	     */
	    valueLink: _react2.default.PropTypes.object,
	
	    /**
	     * Wordings used inside the button of the dialog.
	     */
	    wordings: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      formatDate: _dateTime2.default.format,
	      autoOk: false,
	      disableYearSelection: false,
	      style: {},
	      firstDayOfWeek: 0,
	      disabled: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      date: this._isControlled() ? this._getControlledDate() : this.props.defaultDate,
	      dialogDate: new Date(),
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    if (nextContext.muiTheme) {
	      this.setState({ muiTheme: nextContext.muiTheme });
	    }
	
	    if (this._isControlled()) {
	      var newDate = this._getControlledDate(nextProps);
	      if (!_dateTime2.default.isEqualDate(this.state.date, newDate)) {
	        this.setState({
	          date: newDate
	        });
	      }
	    }
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp'
	  },
	
	  getDate: function getDate() {
	    return this.state.date;
	  },
	  setDate: function setDate(date) {
	     false ? (0, _warning2.default)(false, 'setDate() method is deprecated. Use the defaultDate property instead.\n      Or use the DatePicker as a controlled component with the value property.') : undefined;
	
	    this.setState({
	      date: date
	    });
	  },
	
	  /**
	   * Open the date-picker dialog programmatically from a parent.
	   */
	  openDialog: function openDialog() {
	    this.setState({
	      dialogDate: this.getDate()
	    }, this.refs.dialogWindow.show);
	  },
	
	  /**
	   * Alias for `openDialog()` for an api consistent with TextField.
	   */
	  focus: function focus() {
	    this.openDialog();
	  },
	  _handleDialogAccept: function _handleDialogAccept(date) {
	    if (!this._isControlled()) {
	      this.setState({
	        date: date
	      });
	    }
	    if (this.props.onChange) this.props.onChange(null, date);
	    if (this.props.valueLink) this.props.valueLink.requestChange(date);
	  },
	  _handleInputFocus: function _handleInputFocus(e) {
	    e.target.blur();
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	
	  _handleInputTouchTap: function _handleInputTouchTap(event) {
	    var _this = this;
	
	    if (this.props.onTouchTap) this.props.onTouchTap(event);
	
	    if (!this.props.disabled) setTimeout(function () {
	      _this.openDialog();
	    }, 0);
	  },
	
	  _handleWindowKeyUp: function _handleWindowKeyUp() {
	    //TO DO: open the dialog if input has focus
	  },
	  _isControlled: function _isControlled() {
	    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
	  },
	  _getControlledDate: function _getControlledDate() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	    if (_dateTime2.default.isDateObject(props.value)) {
	      return props.value;
	    } else if (props.valueLink && _dateTime2.default.isDateObject(props.valueLink.value)) {
	      return props.valueLink.value;
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var container = _props.container;
	    var DateTimeFormat = _props.DateTimeFormat;
	    var locale = _props.locale;
	    var wordings = _props.wordings;
	    var autoOk = _props.autoOk;
	    var defaultDate = _props.defaultDate;
	    var formatDate = _props.formatDate;
	    var maxDate = _props.maxDate;
	    var minDate = _props.minDate;
	    var mode = _props.mode;
	    var onDismiss = _props.onDismiss;
	    var onFocus = _props.onFocus;
	    var onShow = _props.onShow;
	    var onTouchTap = _props.onTouchTap;
	    var disableYearSelection = _props.disableYearSelection;
	    var style = _props.style;
	    var textFieldStyle = _props.textFieldStyle;
	    var valueLink = _props.valueLink;
	    var firstDayOfWeek = _props.firstDayOfWeek;
	
	    var other = _objectWithoutProperties(_props, ['container', 'DateTimeFormat', 'locale', 'wordings', 'autoOk', 'defaultDate', 'formatDate', 'maxDate', 'minDate', 'mode', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'disableYearSelection', 'style', 'textFieldStyle', 'valueLink', 'firstDayOfWeek']);
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(style) },
	      _react2.default.createElement(_textField2.default, _extends({}, other, {
	        style: textFieldStyle,
	        ref: 'input',
	        value: this.state.date ? formatDate(this.state.date) : undefined,
	        onFocus: this._handleInputFocus,
	        onTouchTap: this._handleInputTouchTap
	      })),
	      _react2.default.createElement(_datePickerDialog2.default, {
	        container: container,
	        ref: 'dialogWindow',
	        DateTimeFormat: DateTimeFormat,
	        locale: locale,
	        wordings: wordings,
	        mode: mode,
	        initialDate: this.state.dialogDate,
	        onAccept: this._handleDialogAccept,
	        onShow: onShow,
	        onDismiss: onDismiss,
	        minDate: minDate,
	        maxDate: maxDate,
	        autoOk: autoOk,
	        disableYearSelection: disableYearSelection,
	        shouldDisableDate: this.props.shouldDisableDate,
	        firstDayOfWeek: firstDayOfWeek
	      })
	    );
	  }
	});
	
	exports.default = DatePicker;
	module.exports = exports['default'];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateTime = __webpack_require__(49);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DayButton = _react2.default.createClass({
	  displayName: 'DayButton',
	
	  propTypes: {
	    date: _react2.default.PropTypes.object,
	    disabled: _react2.default.PropTypes.bool,
	    onKeyboardFocus: _react2.default.PropTypes.func,
	    onTouchTap: _react2.default.PropTypes.func,
	    selected: _react2.default.PropTypes.bool
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false,
	      disabled: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      hover: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.datePicker;
	  },
	  _handleMouseEnter: function _handleMouseEnter() {
	    if (!this.props.disabled) this.setState({ hover: true });
	  },
	  _handleMouseLeave: function _handleMouseLeave() {
	    if (!this.props.disabled) this.setState({ hover: false });
	  },
	  _handleTouchTap: function _handleTouchTap(e) {
	    if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.date);
	  },
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (!this.props.disabled && this.props.onKeyboardFocus) {
	      this.props.onKeyboardFocus(e, keyboardFocused, this.props.date);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var date = _props.date;
	    var onTouchTap = _props.onTouchTap;
	    var selected = _props.selected;
	
	    var other = _objectWithoutProperties(_props, ['date', 'onTouchTap', 'selected']);
	
	    var styles = {
	      root: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        position: 'relative',
	        float: 'left',
	        width: 41,
	        padding: '4px 2px'
	      },
	
	      label: {
	        position: 'relative',
	        color: this.state.muiTheme.rawTheme.palette.textColor
	      },
	
	      buttonState: {
	        position: 'absolute',
	        height: 36,
	        width: 36,
	        top: 2,
	        opacity: 0,
	        borderRadius: '50%',
	        transform: 'scale(0)',
	        transition: _transitions2.default.easeOut(),
	        backgroundColor: this.getTheme().selectColor
	      }
	    };
	
	    if (this.state.hover) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = '0.6';
	      styles.buttonState.transform = 'scale(1)';
	    }
	
	    if (this.props.selected) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = 1;
	      styles.buttonState.transform = 'scale(1)';
	    } else if (this.props.disabled) {
	      styles.root.opacity = '0.6';
	    }
	
	    if (_dateTime2.default.isEqualDate(this.props.date, new Date()) && !this.props.selected) {
	      styles.label.color = this.getTheme().color;
	    }
	
	    return this.props.date ? _react2.default.createElement(
	      _enhancedButton2.default,
	      _extends({}, other, {
	        style: styles.root,
	        hoverStyle: styles.hover,
	        disabled: this.props.disabled,
	        disableFocusRipple: true,
	        disableTouchRipple: true,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchTap: this._handleTouchTap,
	        onKeyboardFocus: this._handleKeyboardFocus
	      }),
	      _react2.default.createElement('div', { style: this.prepareStyles(styles.buttonState) }),
	      _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.label) },
	        this.props.date.getDate()
	      )
	    ) : _react2.default.createElement('span', { style: this.prepareStyles(styles.root) });
	  }
	});
	
	exports.default = DayButton;
	module.exports = exports['default'];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var YearButton = _react2.default.createClass({
	  displayName: 'YearButton',
	
	  propTypes: {
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	    onTouchTap: _react2.default.PropTypes.func,
	    selected: _react2.default.PropTypes.bool,
	    year: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      hover: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.datePicker;
	  },
	  _handleMouseEnter: function _handleMouseEnter() {
	    this.setState({ hover: true });
	  },
	  _handleMouseLeave: function _handleMouseLeave() {
	    this.setState({ hover: false });
	  },
	  _handleTouchTap: function _handleTouchTap(e) {
	    if (this.props.onTouchTap) this.props.onTouchTap(e, this.props.year);
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var year = _props.year;
	    var onTouchTap = _props.onTouchTap;
	    var selected = _props.selected;
	
	    var other = _objectWithoutProperties(_props, ['className', 'year', 'onTouchTap', 'selected']);
	
	    var styles = {
	      root: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        position: 'relative',
	        display: 'block',
	        margin: '0 auto',
	        width: 36,
	        fontSize: 14,
	        padding: '8px 2px'
	      },
	
	      label: {
	        position: 'relative',
	        top: -1,
	        color: this.state.muiTheme.rawTheme.palette.textColor
	      },
	
	      buttonState: {
	        position: 'absolute',
	        height: 32,
	        width: 32,
	        opacity: 0,
	        borderRadius: '50%',
	        transform: 'scale(0)',
	        backgroundColor: this.getTheme().selectColor
	      }
	    };
	
	    if (this.state.hover) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = 0.6;
	      styles.buttonState.transform = 'scale(1.5)';
	    }
	
	    if (selected) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = 1;
	      styles.buttonState.transform = 'scale(1.5)';
	    }
	
	    if (year === new Date().getFullYear()) {
	      styles.root.color = this.getTheme().color;
	    }
	
	    return _react2.default.createElement(
	      _enhancedButton2.default,
	      _extends({}, other, {
	        style: styles.root,
	        disableFocusRipple: true,
	        disableTouchRipple: true,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchTap: this._handleTouchTap
	      }),
	      _react2.default.createElement('div', { style: this.prepareStyles(styles.buttonState) }),
	      _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.label) },
	        year
	      )
	    );
	  }
	});
	
	exports.default = YearButton;
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _clickAwayable = __webpack_require__(48);
	
	var _clickAwayable2 = _interopRequireDefault(_clickAwayable);
	
	var _fontIcon = __webpack_require__(55);
	
	var _fontIcon2 = _interopRequireDefault(_fontIcon);
	
	var _menu = __webpack_require__(144);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DropDownIcon = _react2.default.createClass({
	  displayName: 'DropDownIcon',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    closeOnMenuItemTouchTap: _react2.default.PropTypes.bool,
	    iconClassName: _react2.default.PropTypes.string,
	    iconLigature: _react2.default.PropTypes.string,
	    iconStyle: _react2.default.PropTypes.object,
	    menuItems: _react2.default.PropTypes.array.isRequired,
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _clickAwayable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeOnMenuItemTouchTap: true
	    };
	  },
	  getInitialState: function getInitialState() {
	     false ? (0, _warning2.default)(false, 'DropDownIcon has been deprecated and will be removed in an upcoming verion.' + ' Please use IconMenu instead.') : undefined;
	
	    return {
	      open: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentClickAway: function componentClickAway() {
	    this.setState({ open: false });
	  },
	  getStyles: function getStyles() {
	    var spacing = this.state.muiTheme.rawTheme.spacing;
	    var iconWidth = 48;
	    var styles = {
	      root: {
	        display: 'inline-block',
	        width: iconWidth + 'px !important',
	        position: 'relative',
	        height: spacing.desktopToolbarHeight,
	        fontSize: spacing.desktopDropDownMenuFontSize,
	        cursor: 'pointer'
	      },
	      menu: {
	        transition: _transitions2.default.easeOut(),
	        right: '-14px !important',
	        top: '9px !important',
	        opacity: this.state.open ? 1 : 0
	      },
	      menuItem: { // similair to drop down menu's menu item styles
	        paddingRight: spacing.iconSize + spacing.desktopGutterLess * 2,
	        height: spacing.desktopDropDownMenuItemHeight,
	        lineHeight: spacing.desktopDropDownMenuItemHeight + 'px'
	      }
	    };
	    return styles;
	  },
	  _onControlClick: function _onControlClick() {
	    this.setState({ open: !this.state.open });
	  },
	  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
	    if (this.props.onChange) this.props.onChange(e, key, payload);
	
	    if (this.props.closeOnMenuItemTouchTap) {
	      this.setState({ open: false });
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var children = _props.children;
	    var menuItems = _props.menuItems;
	    var closeOnMenuItemTouchTap = _props.closeOnMenuItemTouchTap;
	    var iconStyle = _props.iconStyle;
	    var iconLigature = _props.iconLigature;
	    var iconClassName = _props.iconClassName;
	
	    var other = _objectWithoutProperties(_props, ['style', 'children', 'menuItems', 'closeOnMenuItemTouchTap', 'iconStyle', 'iconLigature', 'iconClassName']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
	      _react2.default.createElement(
	        'div',
	        { onTouchTap: this._onControlClick },
	        _react2.default.createElement(
	          _fontIcon2.default,
	          {
	            className: iconClassName,
	            style: iconStyle
	          },
	          iconLigature
	        ),
	        children
	      ),
	      _react2.default.createElement(_menu2.default, {
	        ref: 'menuItems',
	        style: styles.menu,
	        menuItems: menuItems,
	        menuItemStyle: styles.menuItem,
	        hideable: true,
	        visible: this.state.open,
	        onItemTap: this._onMenuItemClick
	      })
	    );
	  }
	});
	
	exports.default = DropDownIcon;
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DropDownMenu = __webpack_require__(137);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DropDownMenu2.default;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var rowsHeight = 24;
	
	var styles = {
	  textarea: {
	    width: '100%',
	    resize: 'none',
	    font: 'inherit',
	    padding: 0
	  },
	  shadow: {
	    width: '100%',
	    resize: 'none',
	    // Overflow also needed to here to remove the extra row
	    // added to textareas in Firefox.
	    overflow: 'hidden',
	    // Visibility needed to hide the extra text area on ipads
	    visibility: 'hidden',
	    font: 'inherit',
	    padding: 0,
	    position: 'absolute'
	  }
	};
	
	var EnhancedTextarea = _react2.default.createClass({
	  displayName: 'EnhancedTextarea',
	
	  propTypes: {
	    defaultValue: _react2.default.PropTypes.any,
	    disabled: _react2.default.PropTypes.bool,
	    onChange: _react2.default.PropTypes.func,
	    onHeightChange: _react2.default.PropTypes.func,
	    rows: _react2.default.PropTypes.number,
	    rowsMax: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    textareaStyle: _react2.default.PropTypes.object,
	    value: _react2.default.PropTypes.string,
	    valueLink: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      rows: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      height: this.props.rows * rowsHeight,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._syncHeightWithShadow();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    if (nextProps.value !== this.props.value) {
	      this._syncHeightWithShadow(nextProps.value);
	    }
	    var newState = {};
	    newState.muiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	  },
	  getInputNode: function getInputNode() {
	    return _reactDom2.default.findDOMNode(this.refs.input);
	  },
	  setValue: function setValue(value) {
	    this.getInputNode().value = value;
	    this._syncHeightWithShadow(value);
	  },
	  _syncHeightWithShadow: function _syncHeightWithShadow(newValue, e) {
	    var shadow = _reactDom2.default.findDOMNode(this.refs.shadow);
	
	    if (newValue !== undefined) {
	      shadow.value = newValue;
	    }
	
	    var newHeight = shadow.scrollHeight;
	
	    if (this.props.rowsMax >= this.props.rows) {
	      newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
	    }
	
	    newHeight = Math.max(newHeight, rowsHeight);
	
	    if (this.state.height !== newHeight) {
	      this.setState({
	        height: newHeight
	      });
	
	      if (this.props.onHeightChange) {
	        this.props.onHeightChange(e, newHeight);
	      }
	    }
	  },
	  _handleChange: function _handleChange(e) {
	    this._syncHeightWithShadow(e.target.value);
	
	    if (this.props.hasOwnProperty('valueLink')) {
	      this.props.valueLink.requestChange(e.target.value);
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(e);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var onChange = _props.onChange;
	    var onHeightChange = _props.onHeightChange;
	    var rows = _props.rows;
	    var style = _props.style;
	    var textareaStyle = _props.textareaStyle;
	    var valueLink = _props.valueLink;
	
	    var other = _objectWithoutProperties(_props, ['onChange', 'onHeightChange', 'rows', 'style', 'textareaStyle', 'valueLink']);
	
	    var textareaStyles = this.mergeStyles(styles.textarea, textareaStyle, {
	      height: this.state.height
	    });
	
	    var shadowStyles = styles.shadow;
	
	    if (this.props.hasOwnProperty('valueLink')) {
	      other.value = this.props.valueLink.value;
	    }
	
	    if (this.props.disabled) {
	      style.cursor = 'default';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(this.props.style) },
	      _react2.default.createElement('textarea', {
	        ref: 'shadow',
	        style: this.prepareStyles(shadowStyles),
	        tabIndex: '-1',
	        rows: this.props.rows,
	        defaultValue: this.props.defaultValue,
	        readOnly: true,
	        value: this.props.value,
	        valueLink: this.props.valueLink
	      }),
	      _react2.default.createElement('textarea', _extends({}, other, {
	        ref: 'input',
	        rows: this.props.rows,
	        style: this.prepareStyles(textareaStyles),
	        onChange: this._handleChange
	      }))
	    );
	  }
	});
	
	exports.default = EnhancedTextarea;
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _fontIcon = __webpack_require__(55);
	
	var _fontIcon2 = _interopRequireDefault(_fontIcon);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _children = __webpack_require__(59);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FloatingActionButton = _react2.default.createClass({
	  displayName: 'FloatingActionButton',
	
	  propTypes: {
	    /**
	     * This value will override the default background color for the button.
	     * However it will not override the default disabled background color.
	     * This has to be set separately using the disabledColor attribute.
	     */
	    backgroundColor: _react2.default.PropTypes.string,
	
	    /**
	     * This is what displayed inside the floating action button; for example, a SVG Icon.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Disables the button if set to true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * This value will override the default background color for the button when it is disabled.
	     */
	    disabledColor: _react2.default.PropTypes.string,
	
	    /**
	     * URL to link to when button clicked if `linkButton` is set to true.
	     */
	    href: _react2.default.PropTypes.string,
	
	    /**
	     * The icon within the FloatingActionButton is a FontIcon component.
	     * This property is the classname of the icon to be displayed inside the button.
	     * An alternative to adding an iconClassName would be to manually insert a
	     * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	     */
	    iconClassName: _react2.default.PropTypes.string,
	
	    /**
	     * This is the equivalent to iconClassName except that it is used for
	     * overriding the inline-styles of the FontIcon component.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Enables use of `href` property to provide a URL to link to if set to true.
	     */
	    linkButton: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the button will be a small floating action button.
	     */
	    mini: _react2.default.PropTypes.bool,
	
	    /**
	     * Called when mouse down event occurs on the button.
	     */
	    onMouseDown: _react2.default.PropTypes.func,
	
	    /**
	     * Called when mouse enter event occurs on the button.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Called when mouse leave event occurs on the button.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Called when mouse up event occurs on the button.
	     */
	    onMouseUp: _react2.default.PropTypes.func,
	
	    /**
	     * Called when touch end event occurs on the button.
	     */
	    onTouchEnd: _react2.default.PropTypes.func,
	
	    /**
	     * Called when touch start event occurs on the button.
	     */
	    onTouchStart: _react2.default.PropTypes.func,
	
	    /**
	     * If true, the button will use the secondary button colors.
	     */
	    secondary: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      disabledColor: _colors2.default.grey300,
	      mini: false,
	      secondary: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    var zDepth = this.props.disabled ? 0 : 2;
	
	    return {
	      hovered: false,
	      initialZDepth: zDepth,
	      touch: false,
	      zDepth: zDepth,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	     false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : undefined;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (newProps.disabled !== this.props.disabled) {
	      var zDepth = newProps.disabled ? 0 : 2;
	
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  },
	  _getBackgroundColor: function _getBackgroundColor() {
	    return this.props.disabled ? this.props.disabledColor || this.getTheme().disabledColor : this.props.backgroundColor ? this.props.backgroundColor : this.props.secondary ? this.getTheme().secondaryColor : this.getTheme().color;
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.floatingActionButton;
	  },
	  _getIconColor: function _getIconColor() {
	    return this.props.disabled ? this.getTheme().disabledTextColor : this.props.secondary ? this.getTheme().secondaryIconColor : this.getTheme().iconColor;
	  },
	  getStyles: function getStyles() {
	    var themeVariables = this.state.muiTheme.floatingActionButton;
	
	    var styles = {
	      root: {
	        transition: _transitions2.default.easeOut(),
	        display: 'inline-block'
	      },
	      container: {
	        transition: _transitions2.default.easeOut(),
	        position: 'relative',
	        height: themeVariables.buttonSize,
	        width: themeVariables.buttonSize,
	        padding: 0,
	        overflow: 'hidden',
	        backgroundColor: this._getBackgroundColor(),
	        borderRadius: '50%',
	        textAlign: 'center',
	        verticalAlign: 'bottom'
	      },
	      containerWhenMini: {
	        height: themeVariables.miniSize,
	        width: themeVariables.miniSize
	      },
	      overlay: {
	        transition: _transitions2.default.easeOut(),
	        top: 0
	      },
	      overlayWhenHovered: {
	        backgroundColor: _colorManipulator2.default.fade(this._getIconColor(), 0.4)
	      },
	      icon: {
	        height: themeVariables.buttonSize,
	        lineHeight: themeVariables.buttonSize + 'px',
	        fill: themeVariables.iconColor,
	        color: this._getIconColor()
	      },
	      iconWhenMini: {
	        height: themeVariables.miniSize,
	        lineHeight: themeVariables.miniSize + 'px'
	      }
	    };
	    return styles;
	  },
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	    }
	    if (this.props.onMouseDown) this.props.onMouseDown(e);
	  },
	  _handleMouseUp: function _handleMouseUp(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onMouseUp) this.props.onMouseUp(e);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.refs.container.isKeyboardFocused()) this.setState({ zDepth: this.state.initialZDepth, hovered: false });
	    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.refs.container.isKeyboardFocused() && !this.state.touch) {
	      this.setState({ hovered: true });
	    }
	    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({
	      touch: true,
	      zDepth: this.state.initialZDepth + 1
	    });
	    if (this.props.onTouchStart) this.props.onTouchStart(e);
	  },
	  _handleTouchEnd: function _handleTouchEnd(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onTouchEnd) this.props.onTouchEnd(e);
	  },
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (keyboardFocused && !this.props.disabled) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	      _reactDom2.default.findDOMNode(this.refs.overlay).style.backgroundColor = _colorManipulator2.default.fade(this.getStyles().icon.color, 0.4);
	    } else if (!this.state.hovered) {
	      this.setState({ zDepth: this.state.initialZDepth });
	      _reactDom2.default.findDOMNode(this.refs.overlay).style.backgroundColor = 'transparent';
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var mini = _props.mini;
	    var secondary = _props.secondary;
	    var iconStyle = _props.iconStyle;
	    var iconClassName = _props.iconClassName;
	
	    var other = _objectWithoutProperties(_props, ['disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName']);
	
	    var styles = this.getStyles();
	
	    var iconElement = undefined;
	    if (iconClassName) {
	      iconElement = _react2.default.createElement(_fontIcon2.default, {
	        className: iconClassName,
	        style: this.mergeStyles(styles.icon, mini && styles.iconWhenMini, iconStyle)
	      });
	    }
	
	    var children = _children2.default.extend(this.props.children, {
	      style: this.mergeStyles(styles.icon, mini && styles.iconWhenMini, iconStyle)
	    });
	
	    var buttonEventHandlers = disabled ? null : {
	      onMouseDown: this._handleMouseDown,
	      onMouseUp: this._handleMouseUp,
	      onMouseLeave: this._handleMouseLeave,
	      onMouseEnter: this._handleMouseEnter,
	      onTouchStart: this._handleTouchStart,
	      onTouchEnd: this._handleTouchEnd,
	      onKeyboardFocus: this._handleKeyboardFocus
	    };
	
	    return _react2.default.createElement(
	      _paper2.default,
	      {
	        style: this.mergeStyles(styles.root, this.props.style),
	        zDepth: this.state.zDepth,
	        circle: true
	      },
	      _react2.default.createElement(
	        _enhancedButton2.default,
	        _extends({}, other, buttonEventHandlers, {
	          ref: 'container',
	          disabled: disabled,
	          style: this.mergeStyles(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	          focusRippleColor: styles.icon.color,
	          touchRippleColor: styles.icon.color
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'overlay',
	            style: this.prepareStyles(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered)
	          },
	          iconElement,
	          children
	        )
	      )
	    );
	  }
	});
	
	exports.default = FloatingActionButton;
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GridList = _react2.default.createClass({
	  displayName: 'GridList',
	
	  propTypes: {
	    /**
	     * Number of px for one cell height.
	     */
	    cellHeight: _react2.default.PropTypes.number,
	
	    /**
	     * Grid Tiles that will be in Grid List.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Number of columns.
	     */
	    cols: _react2.default.PropTypes.number,
	
	    /**
	     * Number of px for the padding/spacing between items.
	     */
	    padding: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      cols: 2,
	      padding: 4,
	      cellHeight: 180
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        display: 'flex',
	        flexWrap: 'wrap',
	        margin: -this.props.padding / 2
	      },
	      item: {
	        boxSizing: 'border-box',
	        padding: this.props.padding / 2
	      }
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var cols = _props.cols;
	    var padding = _props.padding;
	    var cellHeight = _props.cellHeight;
	    var children = _props.children;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	
	    var styles = this.getStyles();
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	
	    var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	      var childCols = currentChild.props.cols || 1;
	      var childRows = currentChild.props.rows || 1;
	      var itemStyle = _this.mergeStyles(styles.item, {
	        width: 100 / cols * childCols + '%',
	        height: cellHeight * childRows + padding
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _this.prepareStyles(itemStyle) },
	        currentChild
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ style: this.prepareStyles(mergedRootStyles) }, other),
	      wrappedChildren
	    );
	  }
	});
	
	exports.default = GridList;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GridTile = _react2.default.createClass({
	  displayName: 'GridTile',
	
	  propTypes: {
	    /**
	     * An IconButton element to be used as secondary action target
	     * (primary action target is the tile itself).
	     */
	    actionIcon: _react2.default.PropTypes.element,
	
	    /**
	     * Position of secondary action IconButton.
	     */
	    actionPosition: _react2.default.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * Theoretically you can pass any node as children, but the main use case is to pass an img,
	     * in whichcase GridTile takes care of making the image "cover" available space
	     * (similar to background-size: cover or to object-fit:cover).
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * Width of the tile in number of grid cells.
	     */
	    cols: _react2.default.PropTypes.number,
	
	    /**
	     * Either a string used as tag name for the tile root element, or a ReactComponent.
	     * This is useful when you have, for example, a custom implementation of
	     * a navigation link (that knowsabout your routes) and you want to use it as primary tile action.
	     * In case you pass a ReactComponent, please make sure that it passes all props,
	     * accepts styles overrides and render it's children.
	     */
	    rootClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	
	    /**
	     * Height of the tile in number of grid cells.
	     */
	    rows: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * String or element serving as subtitle (support text).
	     */
	    subtitle: _react2.default.PropTypes.node,
	
	    /**
	     * Title to be displayed on tile.
	     */
	    title: _react2.default.PropTypes.node,
	
	    /**
	     * Style used for title bar background.
	     * Useful for setting custom gradients for example
	     */
	    titleBackground: _react2.default.PropTypes.string,
	
	    /**
	     * Position of the title bar (container of title, subtitle and action icon).
	     */
	    titlePosition: _react2.default.PropTypes.oneOf(['top', 'bottom'])
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      titlePosition: 'bottom',
	      titleBackground: 'rgba(0, 0, 0, 0.4)',
	      actionPosition: 'right',
	      cols: 1,
	      rows: 1,
	      rootClass: 'div'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._ensureImageCover();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getStyles: function getStyles() {
	    var _titleBar;
	
	    var spacing = this.state.muiTheme.rawTheme.spacing;
	    var themeVariables = this.state.muiTheme.gridTile;
	    var actionPos = this.props.actionIcon ? this.props.actionPosition : null;
	    var gutterLess = spacing.desktopGutterLess;
	
	    var styles = {
	      root: {
	        position: 'relative',
	        display: 'block',
	        height: '100%',
	        overflow: 'hidden'
	      },
	      titleBar: (_titleBar = {
	        position: 'absolute',
	        left: 0,
	        right: 0
	      }, _defineProperty(_titleBar, this.props.titlePosition, 0), _defineProperty(_titleBar, 'height', this.props.subtitle ? 68 : 48), _defineProperty(_titleBar, 'background', this.props.titleBackground), _defineProperty(_titleBar, 'display', 'flex'), _defineProperty(_titleBar, 'alignItems', 'center'), _titleBar),
	      titleWrap: {
	        flexGrow: 1,
	        marginLeft: actionPos !== 'left' ? gutterLess : 0,
	        marginRight: actionPos === 'left' ? gutterLess : 0,
	        color: themeVariables.textColor,
	        overflow: 'hidden'
	      },
	      title: {
	        fontSize: '16px',
	        textOverflow: 'ellipsis',
	        overflow: 'hidden',
	        whiteSpace: 'nowrap'
	      },
	      subtitle: {
	        fontSize: '12px',
	        textOverflow: 'ellipsis',
	        overflow: 'hidden',
	        whiteSpace: 'nowrap'
	      },
	      actionIcon: {
	        order: actionPos === 'left' ? -1 : 1
	      },
	      childImg: {
	        height: '100%',
	        transform: 'translateX(-50%)',
	        position: 'relative',
	        left: '50%'
	      }
	    };
	    return styles;
	  },
	  componeneDidUpdate: function componeneDidUpdate() {
	    this._ensureImageCover();
	  },
	  _ensureImageCover: function _ensureImageCover() {
	    var imgEl = _reactDom2.default.findDOMNode(this.refs.img);
	
	    if (imgEl) {
	      (function () {
	        var fit = function fit() {
	          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	            imgEl.style.height = 'auto';
	            imgEl.style.left = '0';
	            imgEl.style.width = '100%';
	            imgEl.style.top = '50%';
	            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	          }
	          imgEl.removeEventListener('load', fit);
	          imgEl = null; // prevent closure memory leak
	        };
	        if (imgEl.complete) {
	          fit();
	        } else {
	          imgEl.addEventListener('load', fit);
	        }
	      })();
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var title = _props.title;
	    var subtitle = _props.subtitle;
	    var titlePosition = _props.titlePosition;
	    var titleBackground = _props.titleBackground;
	    var actionIcon = _props.actionIcon;
	    var actionPosition = _props.actionPosition;
	    var style = _props.style;
	    var children = _props.children;
	    var rootClass = _props.rootClass;
	
	    var other = _objectWithoutProperties(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'actionIcon', 'actionPosition', 'style', 'children', 'rootClass']);
	
	    var styles = this.getStyles();
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	
	    var titleBar = null;
	
	    if (title) {
	      titleBar = _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.titleBar) },
	        _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(styles.titleWrap) },
	          _react2.default.createElement(
	            'div',
	            { style: this.prepareStyles(styles.title) },
	            title
	          ),
	          subtitle ? _react2.default.createElement(
	            'div',
	            { style: this.prepareStyles(styles.subtitle) },
	            subtitle
	          ) : null
	        ),
	        actionIcon ? _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(styles.actionIcon) },
	          actionIcon
	        ) : null
	      );
	    }
	
	    var newChildren = children;
	
	    // if there is an image passed as children
	    // clone it an put our styles
	    if (_react2.default.Children.count(children) === 1) {
	      newChildren = _react2.default.Children.map(children, function (child) {
	        if (child.type === 'img') {
	          return _react2.default.cloneElement(child, {
	            ref: 'img',
	            style: _this.prepareStyles(styles.childImg, child.props.style)
	          });
	        } else {
	          return child;
	        }
	      });
	    }
	
	    var RootTag = rootClass;
	    return _react2.default.createElement(
	      RootTag,
	      _extends({ style: this.prepareStyles(mergedRootStyles) }, other),
	      newChildren,
	      titleBar
	    );
	  }
	});
	
	exports.default = GridTile;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectableContainerEnhance = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectableContainerEnhance = exports.SelectableContainerEnhance = function SelectableContainerEnhance(Component) {
	  var composed = _react2.default.createClass({
	
	    displayName: 'Selectable' + Component.displayName,
	
	    propTypes: {
	      children: _react2.default.PropTypes.node,
	      selectedItemStyle: _react2.default.PropTypes.object,
	      valueLink: _react2.default.PropTypes.shape({
	        value: _react2.default.PropTypes.any,
	        requestChange: _react2.default.PropTypes.func
	      }).isRequired
	    },
	
	    contextTypes: {
	      muiTheme: _react2.default.PropTypes.object
	    },
	
	    childContextTypes: {
	      muiTheme: _react2.default.PropTypes.object
	    },
	
	    mixins: [_stylePropable2.default],
	
	    getInitialState: function getInitialState() {
	      return {
	        muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    },
	    getChildContext: function getChildContext() {
	      return {
	        muiTheme: this.state.muiTheme
	      };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	      var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	      this.setState({ muiTheme: newMuiTheme });
	    },
	
	    getValueLink: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    },
	
	    extendChild: function extendChild(child, styles, selectedItemStyle) {
	      var _this = this;
	
	      if (child && child.type && child.type.displayName === 'ListItem') {
	        var selected = this.isChildSelected(child, this.props);
	        var selectedChildrenStyles = {};
	        if (selected) {
	          selectedChildrenStyles = this.mergeStyles(styles, selectedItemStyle);
	        }
	
	        var mergedChildrenStyles = this.mergeStyles(child.props.style || {}, selectedChildrenStyles);
	
	        this.keyIndex += 1;
	
	        return _react2.default.cloneElement(child, {
	          onTouchTap: function onTouchTap(e) {
	            _this.handleItemTouchTap(e, child);
	            if (child.props.onTouchTap) {
	              child.props.onTouchTap(e);
	            }
	          },
	          key: this.keyIndex,
	          style: mergedChildrenStyles,
	          nestedItems: child.props.nestedItems.map(function (child) {
	            return _this.extendChild(child, styles, selectedItemStyle);
	          }),
	          initiallyOpen: this.isInitiallyOpen(child)
	        });
	      } else {
	        return child;
	      }
	    },
	    isInitiallyOpen: function isInitiallyOpen(child) {
	      if (child.props.initiallyOpen) {
	        return child.props.initiallyOpen;
	      }
	      return this.hasSelectedDescendant(false, child);
	    },
	    hasSelectedDescendant: function hasSelectedDescendant(previousValue, child) {
	      if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	        return child.props.nestedItems.reduce(this.hasSelectedDescendant, previousValue);
	      }
	      return previousValue || this.isChildSelected(child, this.props);
	    },
	    isChildSelected: function isChildSelected(child, props) {
	      var itemValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      return itemValue === childValue;
	    },
	    handleItemTouchTap: function handleItemTouchTap(e, item) {
	      var valueLink = this.getValueLink(this.props);
	      var itemValue = item.props.value;
	      var menuValue = valueLink.value;
	      if (itemValue !== menuValue) {
	        valueLink.requestChange(e, itemValue);
	      }
	    },
	    render: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var children = _props.children;
	      var selectedItemStyle = _props.selectedItemStyle;
	
	      this.keyIndex = 0;
	      var styles = {};
	
	      if (!selectedItemStyle) {
	        var textColor = this.state.muiTheme.rawTheme.palette.textColor;
	        var selectedColor = _colorManipulator2.default.fade(textColor, 0.2);
	        styles = {
	          backgroundColor: selectedColor
	        };
	      }
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _this2.extendChild(child, styles, selectedItemStyle);
	      });
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, this.props, this.state),
	        newChildren
	      );
	    }
	  });
	
	  return composed;
	};
	
	exports.default = SelectableContainerEnhance;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var InkBar = _react2.default.createClass({
	  displayName: 'InkBar',
	
	  propTypes: {
	    color: _react2.default.PropTypes.string,
	    left: _react2.default.PropTypes.string.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    width: _react2.default.PropTypes.string.isRequired
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var left = _props.left;
	    var width = _props.width;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['color', 'left', 'width', 'style']);
	
	    var colorStyle = color ? { backgroundColor: color } : undefined;
	    var styles = this.mergeStyles({
	      left: left,
	      width: width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: this.state.muiTheme.inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }, this.props.style, colorStyle);
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(styles) },
	      ' '
	    );
	  }
	});
	
	exports.default = InkBar;
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _overlay = __webpack_require__(98);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _menu = __webpack_require__(144);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var LeftNav = _react2.default.createClass({
	  displayName: 'LeftNav',
	
	  propTypes: {
	    /**
	     * The contents of the `LeftNav`
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Indicates whether swiping sideways when the `LeftNav` is closed should open it.
	     */
	    disableSwipeToOpen: _react2.default.PropTypes.bool,
	
	    /**
	     * Indicates that the `LeftNav` should be docked. In this state, the overlay won't
	     * show and clicking on a menu item will not close the `LeftNav`.
	     */
	    docked: _react2.default.PropTypes.bool,
	
	    /**
	     * A react component that will be displayed above all the menu items.
	     * Usually, this is used for a logo or a profile image.
	     */
	    header: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.element, 'Instead, use composability.'),
	
	    /**
	     * Class name for the menuItem.
	     */
	    menuItemClassName: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'It will be removed with menuItems.'),
	
	    /**
	     * Class name for the link menuItem.
	     */
	    menuItemClassNameLink: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'It will be removed with menuItems.'),
	
	    /**
	     * Class name for the subheader menuItem.
	     */
	    menuItemClassNameSubheader: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.string, 'It will be removed with menuItems.'),
	
	    /**
	     * JSON data representing all menu items to render.
	     */
	    menuItems: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.array, 'Instead, use composability.'),
	
	    /**
	     * Fired when a menu item is clicked that is not the
	     * one currently selected. Note that this requires the `injectTapEventPlugin`
	     * component. See the "Get Started" section for more detail.
	     */
	    onChange: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.func, 'It will be removed with menuItems.'),
	
	    /**
	     * Fired when the component is opened.
	     */
	    onNavClose: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.func, 'Instead, use onRequestChange.'),
	
	    /**
	     * Fired when the component is closed.
	     */
	    onNavOpen: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.func, 'Instead, use onRequestChange.'),
	
	    /**
	     * Callback function that is fired when the open state of the `LeftNav` is
	     * requested to be changed. The provided open argument determines whether
	     * the `LeftNav` is requested to be opened or closed. Also, the reason
	     * argument states why the `LeftNav` got closed or opend. It can be either
	     * `'clickaway'` for menuItem and overlay clicks, `'escape'` for pressing the
	     * escape key and 'swipe' for swiping. For opening the reason is always `'swipe'`.
	     */
	    onRequestChange: _react2.default.PropTypes.func,
	
	    /**
	     * Indicates that the `LeftNav` should be opened, closed or uncontrolled.
	     * Providing a boolean will turn the `LeftNav` into a controlled component.
	     */
	    open: _react2.default.PropTypes.bool,
	
	    /**
	     * Positions the `LeftNav` to open from the right side.
	     */
	    openRight: _react2.default.PropTypes.bool,
	
	    /**
	     * The `className` to add to the `Overlay` component that is rendered behind the `LeftNav`.
	     */
	    overlayClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Overrides the inline-styles of the `Overlay` component that is rendered behind the `LeftNav`.
	     */
	    overlayStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Indicates the particular item in the menuItems array that is currently selected.
	     */
	    selectedIndex: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.number, 'It will be removed with menuItems.'),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The width of the left most (or right most) area in pixels where the `LeftNav` can be
	     * swiped open from. Setting this to `null` spans that area to the entire page
	     * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	     * swipeable `Tabs`, use at your own risk).
	     */
	    swipeAreaWidth: _react2.default.PropTypes.number,
	
	    /**
	     * The width of the `LeftNav` in pixels. Defaults to using the values from theme.
	     */
	    width: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disableSwipeToOpen: false,
	      docked: true,
	      open: null,
	      openRight: false,
	      swipeAreaWidth: 30,
	      width: null
	    };
	  },
	  getInitialState: function getInitialState() {
	    this._maybeSwiping = false;
	    this._touchStartX = null;
	    this._touchStartY = null;
	    this._swipeStartX = null;
	
	    return {
	      open: this.props.open !== null ? this.props.open : this.props.docked,
	      swiping: null,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this._updateMenuHeight();
	    this._enableSwipeHandling();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    var newState = { muiTheme: newMuiTheme };
	
	    // If docked is changed, change the open state for when uncontrolled.
	    if (this.props.docked !== nextProps.docked) newState.open = nextProps.docked;
	
	    // If controlled then the open prop takes precedence.
	    if (nextProps.open !== null) newState.open = nextProps.open;
	
	    this.setState(newState);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._updateMenuHeight();
	    this._enableSwipeHandling();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._disableSwipeHandling();
	  },
	
	  windowListeners: {
	    keyup: '_onWindowKeyUp',
	    resize: '_onWindowResize'
	  },
	
	  toggle: function toggle() {
	     false ? (0, _warning2.default)(false, 'using methods on left nav has been deprecated. Please refer to documentations.') : undefined;
	    if (this.state.open) this.close();else this.open();
	    return this;
	  },
	  close: function close() {
	     false ? (0, _warning2.default)(false, 'using methods on left nav has been deprecated. Please refer to documentations.') : undefined;
	    this.setState({ open: false });
	    if (this.props.onNavClose) this.props.onNavClose();
	    return this;
	  },
	  open: function open() {
	     false ? (0, _warning2.default)(false, 'using methods on left nav has been deprecated. Please refer to documentations.') : undefined;
	    this.setState({ open: true });
	    if (this.props.onNavOpen) this.props.onNavOpen();
	    return this;
	  },
	  getStyles: function getStyles() {
	    var muiTheme = this.state.muiTheme;
	    var theme = muiTheme.leftNav;
	    var rawTheme = muiTheme.rawTheme;
	
	    var x = this._getTranslateMultiplier() * (this.state.open ? 0 : this._getMaxTranslateX());
	
	    var styles = {
	      root: {
	        height: '100%',
	        width: this.props.width || theme.width,
	        position: 'fixed',
	        zIndex: muiTheme.zIndex.leftNav,
	        left: 0,
	        top: 0,
	        transform: 'translate3d(' + x + 'px, 0, 0)',
	        transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	        backgroundColor: theme.color,
	        overflow: 'auto'
	      },
	      menu: {
	        overflowY: 'auto',
	        overflowX: 'hidden',
	        height: '100%',
	        borderRadius: '0'
	      },
	      overlay: {
	        zIndex: muiTheme.zIndex.leftNavOverlay,
	        pointerEvents: this.state.open ? 'auto' : 'none' },
	      // Bypass mouse events when left nav is closing.
	      menuItem: {
	        height: rawTheme.spacing.desktopLeftNavMenuItemHeight,
	        lineHeight: rawTheme.spacing.desktopLeftNavMenuItemHeight + 'px'
	      },
	      rootWhenOpenRight: {
	        left: 'auto',
	        right: 0
	      }
	    };
	
	    styles.menuItemLink = this.mergeStyles(styles.menuItem, {
	      display: 'block',
	      textDecoration: 'none',
	      color: rawTheme.palette.textColor
	    });
	    styles.menuItemSubheader = this.mergeStyles(styles.menuItem, {
	      overflow: 'hidden'
	    });
	
	    return styles;
	  },
	  _shouldShow: function _shouldShow() {
	    return this.state.open || !!this.state.swiping; // component is swiping
	  },
	  _close: function _close(reason) {
	    if (this.props.open === null) this.setState({ open: false });
	    if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	    return this;
	  },
	  _open: function _open(reason) {
	    if (this.props.open === null) this.setState({ open: true });
	    if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	    return this;
	  },
	  _updateMenuHeight: function _updateMenuHeight() {
	    if (this.props.header) {
	      var menu = _reactDom2.default.findDOMNode(this.refs.menuItems);
	      if (menu) {
	        var container = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	        var menuHeight = container.clientHeight - menu.offsetTop;
	        menu.style.height = menuHeight + 'px';
	      }
	    }
	  },
	  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
	    if (this.props.onChange && this.props.selectedIndex !== key) {
	      this.props.onChange(e, key, payload);
	    }
	    if (!this.props.docked) this._close('clickaway');
	  },
	  _onOverlayTouchTap: function _onOverlayTouchTap(event) {
	    event.preventDefault();
	    this._close('clickaway');
	  },
	  _onWindowKeyUp: function _onWindowKeyUp(e) {
	    if (e.keyCode === _keyCode2.default.ESC && !this.props.docked && this.state.open) {
	      this._close('escape');
	    }
	  },
	  _onWindowResize: function _onWindowResize() {
	    this._updateMenuHeight();
	  },
	  _getMaxTranslateX: function _getMaxTranslateX() {
	    var width = this.props.width || this.state.muiTheme.leftNav.width;
	    return width + 10;
	  },
	  _getTranslateMultiplier: function _getTranslateMultiplier() {
	    return this.props.openRight ? 1 : -1;
	  },
	  _enableSwipeHandling: function _enableSwipeHandling() {
	    if (!this.props.docked) {
	      document.body.addEventListener('touchstart', this._onBodyTouchStart);
	      if (!openNavEventHandler) {
	        openNavEventHandler = this._onBodyTouchStart;
	      }
	    } else {
	      this._disableSwipeHandling();
	    }
	  },
	  _disableSwipeHandling: function _disableSwipeHandling() {
	    document.body.removeEventListener('touchstart', this._onBodyTouchStart);
	    if (openNavEventHandler === this._onBodyTouchStart) {
	      openNavEventHandler = null;
	    }
	  },
	  _onBodyTouchStart: function _onBodyTouchStart(e) {
	
	    var swipeAreaWidth = this.props.swipeAreaWidth;
	
	    var touchStartX = e.touches[0].pageX;
	    var touchStartY = e.touches[0].pageY;
	
	    // Open only if swiping from far left (or right) while closed
	    if (swipeAreaWidth !== null && !this.state.open) {
	      if (this.props.openRight) {
	        // If openRight is true calculate from the far right
	        if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	      } else {
	        // If openRight is false calculate from the far left
	        if (touchStartX > swipeAreaWidth) return;
	      }
	    }
	
	    if (!this.state.open && (openNavEventHandler !== this._onBodyTouchStart || this.props.disableSwipeToOpen)) {
	      return;
	    }
	
	    this._maybeSwiping = true;
	    this._touchStartX = touchStartX;
	    this._touchStartY = touchStartY;
	
	    document.body.addEventListener('touchmove', this._onBodyTouchMove);
	    document.body.addEventListener('touchend', this._onBodyTouchEnd);
	    document.body.addEventListener('touchcancel', this._onBodyTouchEnd);
	  },
	  _setPosition: function _setPosition(translateX) {
	    var leftNav = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	    var transformCSS = 'translate3d(' + this._getTranslateMultiplier() * translateX + 'px, 0, 0)';
	    this.refs.overlay.setOpacity(1 - translateX / this._getMaxTranslateX());
	    _autoPrefix2.default.set(leftNav.style, 'transform', transformCSS, this.state.muiTheme);
	  },
	  _getTranslateX: function _getTranslateX(currentX) {
	    return Math.min(Math.max(this.state.swiping === 'closing' ? this._getTranslateMultiplier() * (currentX - this._swipeStartX) : this._getMaxTranslateX() - this._getTranslateMultiplier() * (this._swipeStartX - currentX), 0), this._getMaxTranslateX());
	  },
	  _onBodyTouchMove: function _onBodyTouchMove(e) {
	    var currentX = e.touches[0].pageX;
	    var currentY = e.touches[0].pageY;
	
	    if (this.state.swiping) {
	      e.preventDefault();
	      this._setPosition(this._getTranslateX(currentX));
	    } else if (this._maybeSwiping) {
	      var dXAbs = Math.abs(currentX - this._touchStartX);
	      var dYAbs = Math.abs(currentY - this._touchStartY);
	      // If the user has moved his thumb ten pixels in either direction,
	      // we can safely make an assumption about whether he was intending
	      // to swipe or scroll.
	      var threshold = 10;
	
	      if (dXAbs > threshold && dYAbs <= threshold) {
	        this._swipeStartX = currentX;
	        this.setState({
	          swiping: this.state.open ? 'closing' : 'opening'
	        });
	        this._setPosition(this._getTranslateX(currentX));
	      } else if (dXAbs <= threshold && dYAbs > threshold) {
	        this._onBodyTouchEnd();
	      }
	    }
	  },
	  _onBodyTouchEnd: function _onBodyTouchEnd(e) {
	    if (this.state.swiping) {
	      var currentX = e.changedTouches[0].pageX;
	      var translateRatio = this._getTranslateX(currentX) / this._getMaxTranslateX();
	
	      this._maybeSwiping = false;
	      var swiping = this.state.swiping;
	      this.setState({
	        swiping: null
	      });
	
	      // We have to open or close after setting swiping to null,
	      // because only then CSS transition is enabled.
	      if (translateRatio > 0.5) {
	        if (swiping === 'opening') {
	          this._setPosition(this._getMaxTranslateX());
	        } else {
	          this._close('swipe');
	        }
	      } else {
	        if (swiping === 'opening') {
	          this._open('swipe');
	        } else {
	          this._setPosition(0);
	        }
	      }
	    } else {
	      this._maybeSwiping = false;
	    }
	
	    document.body.removeEventListener('touchmove', this._onBodyTouchMove);
	    document.body.removeEventListener('touchend', this._onBodyTouchEnd);
	    document.body.removeEventListener('touchcancel', this._onBodyTouchEnd);
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var docked = _props.docked;
	    var header = _props.header;
	    var menuItemClassName = _props.menuItemClassName;
	    var menuItemClassNameSubheader = _props.menuItemClassNameSubheader;
	    var menuItemClassNameLink = _props.menuItemClassNameLink;
	    var menuItems = _props.menuItems;
	    var openRight = _props.openRight;
	    var overlayClassName = _props.overlayClassName;
	    var overlayStyle = _props.overlayStyle;
	    var selectedIndex = _props.selectedIndex;
	    var style = _props.style;
	
	    var styles = this.getStyles();
	
	    var overlay = undefined;
	    if (!docked) {
	      overlay = _react2.default.createElement(_overlay2.default, {
	        ref: 'overlay',
	        show: this._shouldShow(),
	        className: overlayClassName,
	        style: this.mergeStyles(styles.overlay, overlayStyle),
	        transitionEnabled: !this.state.swiping,
	        onTouchTap: this._onOverlayTouchTap
	      });
	    }
	    var children = undefined;
	    if (menuItems === undefined) {
	      children = this.props.children;
	    } else {
	      children = _react2.default.createElement(_menu2.default, {
	        ref: 'menuItems',
	        style: this.mergeStyles(styles.menu),
	        zDepth: 0,
	        menuItems: menuItems,
	        menuItemStyle: this.mergeStyles(styles.menuItem),
	        menuItemStyleLink: this.mergeStyles(styles.menuItemLink),
	        menuItemStyleSubheader: this.mergeStyles(styles.menuItemSubheader),
	        menuItemClassName: menuItemClassName,
	        menuItemClassNameSubheader: menuItemClassNameSubheader,
	        menuItemClassNameLink: menuItemClassNameLink,
	        selectedIndex: selectedIndex,
	        onItemTap: this._onMenuItemClick
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      overlay,
	      _react2.default.createElement(
	        _paper2.default,
	        {
	          ref: 'clickAwayableElement',
	          zDepth: 2,
	          rounded: false,
	          transitionEnabled: !this.state.swiping,
	          className: className,
	          style: this.mergeStyles(styles.root, openRight && styles.rootWhenOpenRight, style)
	        },
	        header,
	        children
	      )
	    );
	  }
	});
	
	exports.default = LeftNav;
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LinearProgress = _react2.default.createClass({
	  displayName: 'LinearProgress',
	
	  propTypes: {
	    /**
	     * The mode of show your progress, indeterminate for
	     * when there is no value for progress.
	     */
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * The max value of progress, only works in determinate mode.
	     */
	    max: _react2.default.PropTypes.number,
	
	    /**
	     * The min value of progress, only works in determinate mode.
	     */
	    min: _react2.default.PropTypes.number,
	
	    /**
	     * The mode of show your progress, indeterminate for when
	     * there is no value for progress.
	     */
	    mode: _react2.default.PropTypes.oneOf(['determinate', 'indeterminate']),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of progress, only works in determinate mode.
	     */
	    value: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      mode: 'indeterminate',
	      value: 0,
	      min: 0,
	      max: 100
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var bar1 = _reactDom2.default.findDOMNode(this.refs.bar1);
	    var bar2 = _reactDom2.default.findDOMNode(this.refs.bar2);
	
	    this.timers.bar1 = this._barUpdate('bar1', 0, bar1, [[-35, 100], [100, -90]]);
	
	    this.timers.bar2 = setTimeout(function () {
	      _this._barUpdate('bar2', 0, bar2, [[-200, 100], [107, -8]]);
	    }, 850);
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timers.bar1);
	    clearTimeout(this.timers.bar2);
	  },
	
	  timers: {
	    bar1: undefined,
	    bar2: undefined
	  },
	
	  _barUpdate: function _barUpdate(id, step, barElement, stepValues) {
	    var _this2 = this;
	
	    if (this.props.mode !== 'indeterminate') return;
	
	    step = step || 0;
	    step %= 4;
	
	    var right = this.state.muiTheme.isRtl ? 'left' : 'right';
	    var left = this.state.muiTheme.isRtl ? 'right' : 'left';
	
	    if (step === 0) {
	      barElement.style[left] = stepValues[0][0] + '%';
	      barElement.style[right] = stepValues[0][1] + '%';
	    } else if (step === 1) {
	      barElement.style.transitionDuration = '840ms';
	    } else if (step === 2) {
	      barElement.style[left] = stepValues[1][0] + '%';
	      barElement.style[right] = stepValues[1][1] + '%';
	    } else if (step === 3) {
	      barElement.style.transitionDuration = '0ms';
	    }
	    this.timers[id] = setTimeout(function () {
	      return _this2._barUpdate(id, step + 1, barElement, stepValues);
	    }, 420);
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.rawTheme.palette;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        position: 'relative',
	        height: 4,
	        display: 'block',
	        width: '100%',
	        backgroundColor: this.getTheme().primary3Color,
	        borderRadius: 2,
	        margin: 0,
	        overflow: 'hidden'
	      },
	      bar: {
	        height: '100%'
	      },
	      barFragment1: {},
	      barFragment2: {}
	    };
	
	    if (this.props.mode === 'indeterminate') {
	      styles.barFragment1 = {
	        position: 'absolute',
	        backgroundColor: this.props.color || this.getTheme().primary1Color,
	        top: 0,
	        left: 0,
	        bottom: 0,
	        transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	      };
	
	      styles.barFragment2 = {
	        position: 'absolute',
	        backgroundColor: this.props.color || this.getTheme().primary1Color,
	        top: 0,
	        left: 0,
	        bottom: 0,
	        transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	      };
	    } else {
	      styles.bar.backgroundColor = this.props.color || this.getTheme().primary1Color;
	      styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	      styles.bar.width = this._getRelativeValue() + '%';
	    }
	
	    return styles;
	  },
	  _getRelativeValue: function _getRelativeValue() {
	    var value = this.props.value;
	    var min = this.props.min;
	    var max = this.props.max;
	
	    var clampedValue = Math.min(Math.max(min, value), max);
	    var rangeValue = max - min;
	    var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
	    return relValue * 100;
	  },
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.bar) },
	        _react2.default.createElement('div', { ref: 'bar1', style: this.prepareStyles(styles.barFragment1) }),
	        _react2.default.createElement('div', { ref: 'bar2', style: this.prepareStyles(styles.barFragment2) })
	      )
	    );
	  }
	});
	
	exports.default = LinearProgress;
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _divider = __webpack_require__(93);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListDivider = _react2.default.createClass({
	  displayName: 'ListDivider',
	  getInitialState: function getInitialState() {
	     false ? (0, _warning2.default)(false, '<ListDivider /> has been deprecated. Please use the <Divider /> component.') : undefined;
	    return null;
	  },
	  render: function render() {
	    return _react2.default.createElement(_divider2.default, this.props);
	  }
	});
	
	exports.default = ListDivider;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(30);
	
	var _list = __webpack_require__(96);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NestedList = function (_React$Component) {
	  _inherits(NestedList, _React$Component);
	
	  function NestedList() {
	    _classCallCheck(this, NestedList);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NestedList).apply(this, arguments));
	  }
	
	  _createClass(NestedList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var open = _props.open;
	      var nestedLevel = _props.nestedLevel;
	      var style = _props.style;
	
	      var styles = {
	        root: {
	          display: open ? null : 'none'
	        }
	      };
	
	      return _react2.default.createElement(
	        _list2.default,
	        { style: (0, _styles.mergeStyles)(styles.root, style) },
	        _react2.default.Children.map(children, function (child) {
	          return _react2.default.isValidElement(child) ? _react2.default.cloneElement(child, {
	            nestedLevel: nestedLevel + 1
	          }) : child;
	        })
	      );
	    }
	  }]);
	
	  return NestedList;
	}(_react2.default.Component);
	
	NestedList.propTypes = {
	  children: _react2.default.PropTypes.node,
	  nestedLevel: _react2.default.PropTypes.number,
	  open: _react2.default.PropTypes.bool,
	
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react2.default.PropTypes.object
	};
	NestedList.defaultProps = {
	  nestedLevel: 1,
	  open: false
	};
	exports.default = NestedList;
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*eslint-disable */
	
	var LinkMenuItem = _react2.default.createClass({
	  displayName: 'LinkMenuItem',
	
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    className: _react2.default.PropTypes.string,
	    disabled: _react2.default.PropTypes.bool,
	    index: _react2.default.PropTypes.number.isRequired,
	    onMouseEnter: _react2.default.PropTypes.func,
	    onMouseLeave: _react2.default.PropTypes.func,
	    payload: _react2.default.PropTypes.string.isRequired,
	    selected: _react2.default.PropTypes.bool,
	    style: _react2.default.PropTypes.object,
	    target: _react2.default.PropTypes.string,
	    text: _react2.default.PropTypes.string.isRequired
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      hovered: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.menuItem;
	  },
	  getStyles: function getStyles() {
	    var style = {
	      root: {
	        userSelect: 'none',
	        cursor: 'pointer',
	        display: 'block',
	        lineHeight: this.getTheme().height + 'px',
	        paddingLeft: this.getTheme().padding,
	        paddingRight: this.getTheme().padding
	      },
	      rootWhenHovered: {
	        backgroundColor: this.getTheme().hoverColor
	      },
	      rootWhenSelected: {
	        color: this.getTheme().selectedTextColor
	      },
	      rootWhenDisabled: {
	        cursor: 'default',
	        color: this.state.muiTheme.rawTheme.palette.disabledColor
	      }
	    };
	
	    return style;
	  },
	  _stopLink: function _stopLink(event) {
	    event.preventDefault();
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    this.setState({ hovered: true });
	    if (!this.props.disabled && this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    if (!this.props.disabled && this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	  render: function render() {
	    var onClickHandler = this.props.disabled ? this._stopLink : undefined;
	    // Prevent context menu 'Open In New Tab/Window'
	    var linkAttribute = this.props.disabled ? 'data-href' : 'href';
	    var link = {};
	    link[linkAttribute] = this.props.payload;
	
	    var styles = this.getStyles();
	
	    var linkStyles = this.prepareStyles(styles.root, this.props.selected && styles.rootWhenSelected, this.props.selected && styles.rootWhenSelected, this.props.active && !this.props.disabled && styles.rootWhenHovered, this.props.style, this.props.disabled && styles.rootWhenDisabled);
	
	    return _react2.default.createElement(
	      'a',
	      _extends({
	        key: this.props.index,
	        target: this.props.target,
	        style: linkStyles }, link, {
	        className: this.props.className,
	        onClick: onClickHandler,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave }),
	      this.props.text
	    );
	  }
	});
	
	exports.default = LinkMenuItem;
	module.exports = exports['default'];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _fontIcon = __webpack_require__(55);
	
	var _fontIcon2 = _interopRequireDefault(_fontIcon);
	
	var _toggle = __webpack_require__(158);
	
	var _toggle2 = _interopRequireDefault(_toggle);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*eslint-disable */
	
	var Types = {
	  LINK: 'LINK',
	  SUBHEADER: 'SUBHEADER',
	  NESTED: 'NESTED'
	};
	
	var MenuItem = _react2.default.createClass({
	  displayName: 'MenuItem',
	
	  propTypes: {
	    active: _react2.default.PropTypes.bool,
	    attribute: _react2.default.PropTypes.string,
	    children: _react2.default.PropTypes.node,
	    className: _react2.default.PropTypes.string,
	    data: _react2.default.PropTypes.string,
	    disabled: _react2.default.PropTypes.bool,
	    icon: _react2.default.PropTypes.node,
	    iconClassName: _react2.default.PropTypes.string,
	    iconRightClassName: _react2.default.PropTypes.string,
	    iconRightStyle: _react2.default.PropTypes.object,
	    iconStyle: _react2.default.PropTypes.object,
	    index: _react2.default.PropTypes.number.isRequired,
	    number: _react2.default.PropTypes.string,
	    onMouseEnter: _react2.default.PropTypes.func,
	    onMouseLeave: _react2.default.PropTypes.func,
	    onToggle: _react2.default.PropTypes.func,
	    onTouchTap: _react2.default.PropTypes.func,
	    selected: _react2.default.PropTypes.bool,
	    style: _react2.default.PropTypes.object,
	    toggle: _react2.default.PropTypes.bool
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  statics: {
	    Types: Types
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      toggle: false,
	      disabled: false,
	      active: false
	    };
	  },
	  getInitialState: function getInitialState() {
	     false ? (0, _warning2.default)(false, 'This menu item component is deprecated use menus/menu-item instead.') : undefined;
	
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.menuItem;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    var _data;
	
	    var isRtl = this.context.muiTheme.isRtl;
	
	    var right = isRtl ? 'left' : 'right';
	    var left = isRtl ? 'right' : 'left';
	
	    var marginRight = isRtl ? 'marginLeft' : 'marginRight';
	    var paddingLeft = isRtl ? 'paddingRight' : 'paddingLeft';
	
	    var styles = {
	      root: {
	        userSelect: 'none',
	        cursor: 'pointer',
	        lineHeight: this.getTheme().height + 'px',
	        paddingLeft: this.getTheme().padding,
	        paddingRight: this.getTheme().padding,
	        color: this.state.muiTheme.rawTheme.palette.textColor
	      },
	      number: {
	        float: right,
	        width: 24,
	        textAlign: 'center'
	      },
	      attribute: {
	        float: right
	      },
	      iconRight: {
	        lineHeight: this.getTheme().height + 'px',
	        float: right
	      },
	      icon: _defineProperty({
	        float: left,
	        lineHeight: this.getTheme().height + 'px'
	      }, marginRight, this.getSpacing().desktopGutter),
	      data: (_data = {
	        display: 'block'
	      }, _defineProperty(_data, paddingLeft, this.getSpacing().desktopGutter * 2), _defineProperty(_data, 'lineHeight', this.getTheme().dataHeight + 'px'), _defineProperty(_data, 'height', this.getTheme().dataHeight + 'px'), _defineProperty(_data, 'verticalAlign', 'top'), _defineProperty(_data, 'top', -12), _defineProperty(_data, 'position', 'relative'), _defineProperty(_data, 'fontWeight', 300), _defineProperty(_data, 'color', this.state.muiTheme.rawTheme.palette.textColor), _data),
	      toggle: {
	        marginTop: (this.getTheme().height - this.state.muiTheme.radioButton.size) / 2,
	        float: right,
	        width: 42
	      },
	      rootWhenHovered: {
	        backgroundColor: this.getTheme().hoverColor
	      },
	      rootWhenSelected: {
	        color: this.getTheme().selectedTextColor
	      },
	      rootWhenDisabled: {
	        cursor: 'default',
	        color: this.state.muiTheme.rawTheme.palette.disabledColor
	      }
	    };
	
	    return styles;
	  },
	  _handleTouchTap: function _handleTouchTap(e) {
	    if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.index);
	  },
	  _handleToggle: function _handleToggle(e, toggled) {
	    if (!this.props.disabled && this.props.onToggle) this.props.onToggle(e, this.props.index, toggled);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.props.disabled && this.props.onMouseEnter) this.props.onMouseEnter(e, this.props.index);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.props.disabled && this.props.onMouseLeave) this.props.onMouseLeave(e, this.props.index);
	  },
	  render: function render() {
	    var icon = undefined;
	    var data = undefined;
	    var iconRight = undefined;
	    var attribute = undefined;
	    var number = undefined;
	    var toggleElement = undefined;
	    var styles = this.getStyles();
	
	    if (this.props.iconClassName) {
	      icon = _react2.default.createElement(_fontIcon2.default, { style: this.mergeStyles(styles.icon, this.props.iconStyle, this.props.selected && styles.rootWhenSelected),
	        className: this.props.iconClassName });
	    }
	    if (this.props.iconRightClassName) {
	      iconRight = _react2.default.createElement(_fontIcon2.default, { style: this.mergeStyles(styles.iconRight, this.props.iconRightStyle),
	        className: this.props.iconRightClassName });
	    }
	    if (this.props.data) data = _react2.default.createElement(
	      'span',
	      { style: this.prepareStyles(styles.data) },
	      this.props.data
	    );
	    if (this.props.number !== undefined) {
	      number = _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.number) },
	        this.props.number
	      );
	    }
	    if (this.props.attribute !== undefined) {
	      attribute = _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.style) },
	        this.props.attribute
	      );
	    }
	    if (this.props.icon) icon = this.props.icon;
	
	    if (this.props.toggle) {
	      var _props = this.props;
	      var toggle = _props.toggle;
	      var onTouchTap = _props.onTouchTap;
	      var onToggle = _props.onToggle;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseLeave = _props.onMouseLeave;
	      var children = _props.children;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['toggle', 'onTouchTap', 'onToggle', 'onMouseEnter', 'onMouseLeave', 'children', 'style']);
	
	      toggleElement = _react2.default.createElement(_toggle2.default, _extends({}, other, { onToggle: this._handleToggle, style: styles.toggle }));
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        key: this.props.index,
	        className: this.props.className,
	        onTouchTap: this._handleTouchTap,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave,
	        style: this.prepareStyles(styles.root, this.props.selected && styles.rootWhenSelected, this.props.active && !this.props.disabled && styles.rootWhenHovered, this.props.style, this.props.disabled && styles.rootWhenDisabled) },
	      icon,
	      this.props.children,
	      number,
	      attribute,
	      data,
	      toggleElement,
	      iconRight
	    );
	  }
	});
	
	exports.default = MenuItem;
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubheaderMenuItem = _react2.default.createClass({
	  displayName: 'SubheaderMenuItem',
	
	  propTypes: {
	    className: _react2.default.PropTypes.string,
	    firstChild: _react2.default.PropTypes.bool,
	    index: _react2.default.PropTypes.number.isRequired,
	    style: _react2.default.PropTypes.object,
	    text: _react2.default.PropTypes.string.isRequired
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.menuSubheader;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    var gutterMini = this.getSpacing().desktopGutterMini;
	    var subheaderHeight = this.getSpacing().desktopSubheaderHeight;
	    var styles = {
	      root: {
	        boxSizing: 'border-box',
	        fontSize: '13px',
	        letterSpacing: 0,
	        fontWeight: _typography2.default.fontWeightMedium,
	        margin: 0,
	        height: subheaderHeight + gutterMini,
	        lineHeight: subheaderHeight + 'px',
	        color: this.getTheme().textColor,
	        borderTop: 'solid 1px ' + this.getTheme().borderColor,
	        paddingTop: gutterMini,
	        marginTop: gutterMini
	      },
	      rootWhenFirstChild: {
	        height: subheaderHeight,
	        borderTop: 'none',
	        paddingTop: 0,
	        marginTop: 0
	      }
	    };
	
	    return styles;
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        key: this.props.index,
	        className: this.props.className,
	        style: this.prepareStyles(this.getStyles().root, this.props.firstChild && this.getStyles().rootWhenFirstChild, this.props.style)
	      },
	      this.props.text
	    );
	  }
	});
	
	exports.default = SubheaderMenuItem;
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _menu = __webpack_require__(57);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _popover = __webpack_require__(58);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconMenu = _react2.default.createClass({
	  displayName: 'IconMenu',
	
	  propTypes: {
	    /**
	     * This is the point on the icon where the menu
	     * targetOrigin will stick to.
	     * Options:
	     * vertical: [top, middle, bottom]
	     * horizontal: [left, center, right].
	     */
	    anchorOrigin: _propTypes2.default.origin,
	
	    /**
	     * Should be used to pass `MenuItem` components.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * If true, menu will close after an item is touchTapped.
	     */
	    closeOnItemTouchTap: _react2.default.PropTypes.bool,
	
	    /**
	     * This is the IconButton to render. This button will open the menu.
	     */
	    iconButtonElement: _react2.default.PropTypes.element.isRequired,
	
	    /**
	     * The style object to use to override underlying icon style.
	     */
	    iconStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The style object to use to override underlying menu style.
	     */
	    menuStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Fired when a menu item is touchTapped.
	     */
	    onItemTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when keyobard focuses on element.
	     */
	    onKeyboardFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when mouse is pressed on element.
	     */
	    onMouseDown: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when mouse enters the element.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when mouse leaves the element.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when mouse is lifted inside the element.
	     */
	    onMouseUp: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the open state
	     * of the menu is requested to be changed. The provided
	     * open argument determines whether the menu is requested
	     * to be opened or closed. Also, the reason argument states
	     * why the menu got closed or opened. It can be 'keyboard',
	     * 'iconTap' for open action and 'enter', 'escape', 'itemTap',
	     * 'clickAway' for close action.
	     */
	    onRequestChange: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when element is touch tapped.
	     */
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Controls whether the IconMenu is opened or not.
	     */
	    open: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * This is the point on the menu which will stick to the menu
	     * origin.
	     * Options:
	     * vertical: [top, middle, bottom]
	     * horizontal: [left, center, right].
	     */
	    targetOrigin: _propTypes2.default.origin,
	
	    /**
	     * Sets the delay in milliseconds before closing the
	     * menu when an item is clicked.
	     */
	    touchTapCloseDelay: _react2.default.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeOnItemTouchTap: true,
	      open: null,
	      onItemTouchTap: function onItemTouchTap() {},
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onMouseDown: function onMouseDown() {},
	      onMouseLeave: function onMouseLeave() {},
	      onMouseEnter: function onMouseEnter() {},
	      onMouseUp: function onMouseUp() {},
	      onTouchTap: function onTouchTap() {},
	      onRequestChange: function onRequestChange() {},
	      anchorOrigin: {
	        vertical: 'top',
	        horizontal: 'left'
	      },
	      targetOrigin: {
	        vertical: 'top',
	        horizontal: 'left'
	      },
	      touchTapCloseDelay: 200
	    };
	  },
	  getInitialState: function getInitialState() {
	    if (false) {
	      this._warningIfNeeded();
	    }
	
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      iconButtonRef: this.props.iconButtonElement.props.ref || 'iconButton',
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    if (false) {
	      this._warningIfNeeded();
	    }
	
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (nextProps.open === true || nextProps.open === false) {
	      this.setState({ open: nextProps.open });
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._timeout) clearTimeout(this._timeout);
	  },
	  _warningIfNeeded: function _warningIfNeeded() {
	    if (this.props.hasOwnProperty('open')) {
	       false ? (0, _warning2.default)(this.props.hasOwnProperty('closeOnItemTouchTap'), 'closeOnItemTouchTap has been deprecated in favor of open, onRequestChange') : undefined;
	    }
	  },
	  isOpen: function isOpen() {
	    return this.state.open;
	  },
	  close: function close(reason, isKeyboard) {
	    var _this = this;
	
	    if (!this.state.open) {
	      return;
	    }
	
	    if (this.props.open !== null) {
	      this.props.onRequestChange(false, reason);
	    }
	
	    this.setState({ open: false }, function () {
	      //Set focus on the icon button when the menu close
	      if (isKeyboard) {
	        var iconButton = _this.refs[_this.state.iconButtonRef];
	        _reactDom2.default.findDOMNode(iconButton).focus();
	        iconButton.setKeyboardFocus();
	      }
	    });
	  },
	  open: function open(reason, event) {
	    if (this.props.open !== null) {
	      this.props.onRequestChange(true, reason);
	
	      return this.setState({
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	    }
	
	    this.setState({
	      open: true,
	      menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	      anchorEl: event.currentTarget
	    });
	
	    event.preventDefault();
	  },
	  _handleItemTouchTap: function _handleItemTouchTap(event, child) {
	    var _this2 = this;
	
	    if (this.props.closeOnItemTouchTap) {
	      (function () {
	        var isKeyboard = _events2.default.isKeyboard(event);
	        _this2._timeout = setTimeout(function () {
	          if (!_this2.isMounted()) {
	            return;
	          }
	
	          _this2.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	        }, _this2.props.touchTapCloseDelay);
	      })();
	    }
	
	    this.props.onItemTouchTap(event, child);
	  },
	  _handleMenuEscKeyDown: function _handleMenuEscKeyDown(event) {
	    this.close('escape', event);
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var _props = this.props;
	    var anchorOrigin = _props.anchorOrigin;
	    var className = _props.className;
	    var closeOnItemTouchTap = _props.closeOnItemTouchTap;
	    var iconButtonElement = _props.iconButtonElement;
	    var iconStyle = _props.iconStyle;
	    var onItemTouchTap = _props.onItemTouchTap;
	    var onKeyboardFocus = _props.onKeyboardFocus;
	    var onMouseDown = _props.onMouseDown;
	    var onMouseLeave = _props.onMouseLeave;
	    var onMouseEnter = _props.onMouseEnter;
	    var onMouseUp = _props.onMouseUp;
	    var onTouchTap = _props.onTouchTap;
	    var menuStyle = _props.menuStyle;
	    var style = _props.style;
	    var targetOrigin = _props.targetOrigin;
	
	    var other = _objectWithoutProperties(_props, ['anchorOrigin', 'className', 'closeOnItemTouchTap', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onTouchTap', 'menuStyle', 'style', 'targetOrigin']);
	
	    var _state = this.state;
	    var open = _state.open;
	    var anchorEl = _state.anchorEl;
	
	    var styles = {
	      root: {
	        display: 'inline-block',
	        position: 'relative'
	      },
	
	      menu: {
	        position: 'relative'
	      }
	    };
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	    var mergedMenuStyles = this.mergeStyles(styles.menu, menuStyle);
	
	    var iconButton = _react2.default.cloneElement(iconButtonElement, {
	      onKeyboardFocus: this.props.onKeyboardFocus,
	      iconStyle: this.mergeStyles(iconStyle, iconButtonElement.props.iconStyle),
	      onTouchTap: function onTouchTap(e) {
	        _this3.open(_events2.default.isKeyboard(e) ? 'keyboard' : 'iconTap', e);
	        if (iconButtonElement.props.onTouchTap) iconButtonElement.props.onTouchTap(e);
	      },
	      ref: this.state.iconButtonRef
	    });
	
	    var menu = _react2.default.createElement(
	      _menu2.default,
	      _extends({}, other, {
	        animateOpen: true,
	        initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	        onEscKeyDown: this._handleMenuEscKeyDown,
	        onItemTouchTap: this._handleItemTouchTap,
	        zDepth: 0,
	        style: mergedMenuStyles
	      }),
	      this.props.children
	    );
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseDown: onMouseDown,
	        onMouseLeave: onMouseLeave,
	        onMouseEnter: onMouseEnter,
	        onMouseUp: onMouseUp,
	        onTouchTap: onTouchTap,
	        style: this.prepareStyles(mergedRootStyles)
	      },
	      iconButton,
	      _react2.default.createElement(
	        _popover2.default,
	        {
	          anchorOrigin: anchorOrigin,
	          targetOrigin: targetOrigin,
	          open: open,
	          anchorEl: anchorEl,
	          childContextTypes: this.constructor.childContextTypes,
	          useLayerForClickAway: false,
	          onRequestClose: this.close,
	          context: this.context
	        },
	        menu
	      )
	    );
	  }
	});
	
	exports.default = IconMenu;
	module.exports = exports['default'];

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleResizable = exports.StylePropable = exports.WindowListenable = exports.ClickAwayable = undefined;
	
	var _clickAwayable = __webpack_require__(48);
	
	var _clickAwayable2 = _interopRequireDefault(_clickAwayable);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _styleResizable = __webpack_require__(145);
	
	var _styleResizable2 = _interopRequireDefault(_styleResizable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ClickAwayable = _clickAwayable2.default;
	exports.WindowListenable = _windowListenable2.default;
	exports.StylePropable = _stylePropable2.default;
	exports.StyleResizable = _styleResizable2.default;
	exports.default = {
	  ClickAwayable: _clickAwayable2.default,
	  WindowListenable: _windowListenable2.default,
	  StylePropable: _stylePropable2.default,
	  StyleResizable: _styleResizable2.default
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = muiThemeable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function muiThemeable(WrappedComponent) {
	  var MuiComponent = function MuiComponent(props, _ref) {
	    var _ref$muiTheme = _ref.muiTheme;
	    var muiTheme = _ref$muiTheme === undefined ? (0, _getMuiTheme2.default)() : _ref$muiTheme;
	
	    return _react2.default.createElement(WrappedComponent, _extends({}, props, { muiTheme: muiTheme }));
	  };
	
	  MuiComponent.displayName = getDisplayName(WrappedComponent);
	  MuiComponent.contextTypes = {
	    muiTheme: _react2.default.PropTypes.object
	  };
	  MuiComponent.childContextTypes = {
	    muiTheme: _react2.default.PropTypes.object
	  };
	
	  return MuiComponent;
	}
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopoverAnimationFromTop = _react2.default.createClass({
	  displayName: 'PopoverAnimationFromTop',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    className: _react2.default.PropTypes.string,
	    open: _react2.default.PropTypes.bool.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    targetOrigin: _propTypes2.default.origin,
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      zDepth: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      open: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.setState({ open: true }); //eslint-disable-line react/no-did-mount-set-state
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    this.setState({
	      open: nextProps.open,
	      muiTheme: newMuiTheme
	    });
	  },
	  getStyles: function getStyles() {
	    var targetOrigin = this.props.targetOrigin;
	
	    var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	    return {
	      base: {
	        opacity: 0,
	        transform: 'scaleY(0)',
	        transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	        position: 'fixed',
	        zIndex: this.state.muiTheme.zIndex.popover,
	        transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	        maxHeight: '100%'
	      }
	
	    };
	  },
	  getOpenStyles: function getOpenStyles() {
	    return {
	      base: {
	        opacity: 1,
	        transform: 'scaleY(1)'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	    var zDepth = _props.zDepth;
	
	    var styles = this.getStyles();
	    var openStyles = {};
	    if (this.state.open) openStyles = this.getOpenStyles();
	
	    return _react2.default.createElement(
	      _paper2.default,
	      {
	        style: this.mergeStyles(styles.base, style, openStyles.base),
	        zDepth: zDepth,
	        className: className
	      },
	      this.props.children
	    );
	  }
	});
	
	exports.default = PopoverAnimationFromTop;
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(25);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopoverDefaultAnimation = _react2.default.createClass({
	  displayName: 'PopoverDefaultAnimation',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	    open: _react2.default.PropTypes.bool.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	    targetOrigin: _propTypes2.default.origin,
	    zDepth: _propTypes2.default.zDepth
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      zDepth: 1
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      open: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.setState({ open: true }); //eslint-disable-line react/no-did-mount-set-state
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    this.setState({
	      open: nextProps.open,
	      muiTheme: newMuiTheme
	    });
	  },
	  getStyles: function getStyles() {
	    var targetOrigin = this.props.targetOrigin;
	
	    var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	    return {
	      base: {
	        opacity: 0,
	        transform: 'scale(0, 0)',
	        transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	        position: 'fixed',
	        zIndex: this.state.muiTheme.zIndex.popover,
	        transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	        maxHeight: '100%'
	
	      },
	      horizontal: {
	        maxHeight: '100%',
	        overflowY: 'auto',
	        transform: 'scaleX(0)',
	        opacity: 0,
	        transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	        transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	      },
	      vertical: {
	        opacity: 0,
	        transform: 'scaleY(0)',
	        transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	        transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	      }
	    };
	  },
	  getOpenStyles: function getOpenStyles() {
	    return {
	      base: {
	        opacity: 1,
	        transform: 'scale(1, 1)'
	      },
	      horizontal: {
	        opacity: 1,
	        transform: 'scaleX(1)'
	      },
	      vertical: {
	        opacity: 1,
	        transform: 'scaleY(1)'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	    var zDepth = _props.zDepth;
	
	    var styles = this.getStyles();
	    var openStyles = {};
	    if (this.state.open) openStyles = this.getOpenStyles();
	
	    return _react2.default.createElement(
	      _paper2.default,
	      {
	        style: this.mergeStyles(styles.base, style, openStyles.base),
	        zDepth: zDepth,
	        className: className
	      },
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.horizontal, openStyles.horizontal) },
	        _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(styles.vertical, openStyles.vertical) },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports.default = PopoverDefaultAnimation;
	module.exports = exports['default'];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radioButton = __webpack_require__(146);
	
	var _radioButton2 = _interopRequireDefault(_radioButton);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RadioButtonGroup = _react2.default.createClass({
	  displayName: 'RadioButtonGroup',
	
	  propTypes: {
	    /**
	     * Should be used to pass `RadioButton` components.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Sets the default radio button to be the one whose
	     * value matches defaultSelected (case-sensitive).
	     * This will override any individual radio button with
	     * the defaultChecked or checked property stated.
	     */
	    defaultSelected: _react2.default.PropTypes.string,
	
	    /**
	     * Where the label will be placed for all radio buttons.
	     * This will override any labelPosition properties defined
	     * for an individual radio button.
	     */
	    labelPosition: _react2.default.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * The name that will be applied to all radio buttons inside it.
	     */
	    name: _react2.default.PropTypes.string.isRequired,
	
	    /**
	     * Callback function that is fired when a radio button has
	     * been clicked. Returns the event and the value of the radio
	     * button that has been selected.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of the currently selected radio button.
	     */
	    valueSelected: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      numberCheckedRadioButtons: 0,
	      selected: this.props.valueSelected || this.props.defaultSelected || '',
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var cnt = 0;
	
	    _react2.default.Children.forEach(this.props.children, function (option) {
	      if (_this._hasCheckAttribute(option)) cnt++;
	    }, this);
	
	    this.setState({ numberCheckedRadioButtons: cnt });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    var newState = { muiTheme: newMuiTheme };
	
	    if (nextProps.hasOwnProperty('valueSelected')) {
	      newState.selected = nextProps.valueSelected;
	    }
	
	    this.setState(newState);
	  },
	  _hasCheckAttribute: function _hasCheckAttribute(radioButton) {
	    return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	  },
	  _updateRadioButtons: function _updateRadioButtons(newSelection) {
	    if (this.state.numberCheckedRadioButtons === 0) {
	      this.setState({ selected: newSelection });
	    } else {
	       false ? (0, _warning2.default)(false, 'Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : undefined;
	    }
	  },
	  _onChange: function _onChange(e, newSelection) {
	    this._updateRadioButtons(newSelection);
	
	    // Successful update
	    if (this.state.numberCheckedRadioButtons === 0) {
	      if (this.props.onChange) this.props.onChange(e, newSelection);
	    }
	  },
	  getSelectedValue: function getSelectedValue() {
	    return this.state.selected;
	  },
	  setSelectedValue: function setSelectedValue(newSelectionValue) {
	    this._updateRadioButtons(newSelectionValue);
	  },
	  clearValue: function clearValue() {
	    this.setSelectedValue('');
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var options = _react2.default.Children.map(this.props.children, function (option) {
	      var _option$props = option.props;
	      var name = _option$props.name;
	      var value = _option$props.value;
	      var label = _option$props.label;
	      var onCheck = _option$props.onCheck;
	
	      var other = _objectWithoutProperties(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	      return _react2.default.createElement(_radioButton2.default, _extends({}, other, {
	        ref: option.props.value,
	        name: _this2.props.name,
	        key: option.props.value,
	        value: option.props.value,
	        label: option.props.label,
	        labelPosition: _this2.props.labelPosition,
	        onCheck: _this2._onChange,
	        checked: option.props.value === _this2.state.selected
	      }));
	    }, this);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: this.prepareStyles(this.props.style),
	        className: this.props.className
	      },
	      options
	    );
	  }
	});
	
	exports.default = RadioButtonGroup;
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _children = __webpack_require__(59);
	
	var _children2 = _interopRequireDefault(_children);
	
	var _typography = __webpack_require__(35);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function validateLabel(props, propName, componentName) {
	  if (!props.children && !props.label) {
	    return new Error('Required prop label or children was not ' + 'specified in ' + componentName + '.');
	  }
	}
	
	var RaisedButton = _react2.default.createClass({
	  displayName: 'RaisedButton',
	
	  propTypes: {
	    /**
	     * Override the background color. Always takes precedence unless the button is disabled.
	     */
	    backgroundColor: _react2.default.PropTypes.string,
	
	    /**
	     * This is what will be displayed inside the button.
	     * If a label is specified, the text within the label prop will
	     * be displayed. Otherwise, the component will expect children
	     * which will then be displayed. (In our example,
	     * we are nesting an `<input type="file" />` and a `span`
	     * that acts as our label to be displayed.) This only
	     * applies to flat and raised buttons.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Disables the button if set to true.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the background color if the button is disabled.
	     */
	    disabledBackgroundColor: _react2.default.PropTypes.string,
	
	    /**
	     * Color of the label if disabled is true.
	     */
	    disabledLabelColor: _react2.default.PropTypes.string,
	
	    /**
	     * If true, then the button will take up the full
	     * width of its container.
	     */
	    fullWidth: _react2.default.PropTypes.bool,
	
	    /**
	     * URL to link to when button clicked if `linkButton` is set to true.
	     */
	    href: _react2.default.PropTypes.string,
	
	    /**
	     * Use this property to display an icon.
	     */
	    icon: _react2.default.PropTypes.node,
	
	    /**
	     * The label for the button.
	     */
	    label: validateLabel,
	
	    /**
	     * The color of the label for the button.
	     */
	    labelColor: _react2.default.PropTypes.string,
	
	    /**
	     * Place label before or after the passed children.
	     */
	    labelPosition: _react2.default.PropTypes.oneOf(['before', 'after']),
	
	    /**
	     * Override the inline-styles of the button's label element.
	     */
	    labelStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Enables use of `href` property to provide a URL to link to if set to true.
	     */
	    linkButton: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback function for when the mouse is pressed down inside this element.
	     */
	    onMouseDown: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the mouse enters this element.
	     */
	    onMouseEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the mouse leaves this element.
	     */
	    onMouseLeave: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when the mouse is realeased
	     * above this element.
	     */
	    onMouseUp: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when a touchTap event ends.
	     */
	    onTouchEnd: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function for when a touchTap event starts.
	     */
	    onTouchStart: _react2.default.PropTypes.func,
	
	    /**
	     * If true, colors button according to
	     * primaryTextColor from the Theme.
	     */
	    primary: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, colors button according to secondaryTextColor from the theme.
	     * The primary prop has precendent if set to true.
	     */
	    secondary: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      labelPosition: 'after',
	      fullWidth: false,
	      primary: false,
	      secondary: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var zDepth = this.props.disabled ? 0 : 1;
	    return {
	      hovered: false,
	      touched: false,
	      initialZDepth: zDepth,
	      zDepth: zDepth,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var zDepth = nextProps.disabled ? 0 : 1;
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      zDepth: zDepth,
	      initialZDepth: zDepth,
	      muiTheme: newMuiTheme
	    });
	  },
	  _getBackgroundColor: function _getBackgroundColor() {
	    var disabledColor = this.props.disabledBackgroundColor ? this.props.disabledBackgroundColor : this.getTheme().disabledColor;
	
	    return this.props.disabled ? disabledColor : this.props.backgroundColor ? this.props.backgroundColor : this.props.primary ? this.getTheme().primaryColor : this.props.secondary ? this.getTheme().secondaryColor : this.getTheme().color;
	  },
	  _getLabelColor: function _getLabelColor() {
	    var disabledColor = this.props.disabledLabelColor ? this.props.disabledLabelColor : this.getTheme().disabledTextColor;
	
	    return this.props.disabled ? disabledColor : this.props.labelColor ? this.props.labelColor : this.props.primary ? this.getTheme().primaryTextColor : this.props.secondary ? this.getTheme().secondaryTextColor : this.getTheme().textColor;
	  },
	  getThemeButton: function getThemeButton() {
	    return this.state.muiTheme.button;
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.raisedButton;
	  },
	  getStyles: function getStyles() {
	    var _props = this.props;
	    var icon = _props.icon;
	    var labelPosition = _props.labelPosition;
	    var primary = _props.primary;
	    var secondary = _props.secondary;
	
	    var amount = primary || secondary ? 0.4 : 0.08;
	    var styles = {
	      root: {
	        display: 'inline-block',
	        minWidth: this.props.fullWidth ? '100%' : this.getThemeButton().minWidth,
	        height: this.getThemeButton().height,
	        transition: _transitions2.default.easeOut()
	      },
	      container: {
	        position: 'relative',
	        height: '100%',
	        width: '100%',
	        padding: 0,
	        overflow: 'hidden',
	        borderRadius: 2,
	        transition: _transitions2.default.easeOut(),
	        backgroundColor: this._getBackgroundColor()
	      },
	      label: {
	        position: 'relative',
	        opacity: 1,
	        fontSize: '14px',
	        letterSpacing: 0,
	        textTransform: this.getTheme().textTransform ? this.getTheme().textTransform : this.getThemeButton().textTransform ? this.getThemeButton().textTransform : 'uppercase',
	        fontWeight: _typography2.default.fontWeightMedium,
	        margin: 0,
	        userSelect: 'none',
	        paddingLeft: this.state.muiTheme.rawTheme.spacing.desktopGutterLess,
	        paddingRight: this.state.muiTheme.rawTheme.spacing.desktopGutterLess,
	        lineHeight: this.props.style && this.props.style.height ? this.props.style.height : this.getThemeButton().height + 'px',
	        color: this._getLabelColor()
	      },
	      overlay: {
	        transition: _transitions2.default.easeOut(),
	        top: 0
	      },
	      overlayWhenHovered: {
	        backgroundColor: _colorManipulator2.default.fade(this._getLabelColor(), amount)
	      }
	    };
	
	    if (icon) {
	      if (labelPosition === 'before') {
	        styles.label.paddingRight = 8;
	      } else {
	        styles.label.paddingLeft = 8;
	      }
	    }
	
	    return styles;
	  },
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	    }
	    if (this.props.onMouseDown) this.props.onMouseDown(e);
	  },
	  _handleMouseUp: function _handleMouseUp(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onMouseUp) this.props.onMouseUp(e);
	  },
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.refs.container.isKeyboardFocused()) this.setState({ zDepth: this.state.initialZDepth, hovered: false });
	    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.refs.container.isKeyboardFocused() && !this.state.touch) {
	      this.setState({ hovered: true });
	    }
	    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({
	      touch: true,
	      zDepth: this.state.initialZDepth + 1
	    });
	    if (this.props.onTouchStart) this.props.onTouchStart(e);
	  },
	  _handleTouchEnd: function _handleTouchEnd(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onTouchEnd) this.props.onTouchEnd(e);
	  },
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (keyboardFocused && !this.props.disabled) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	      var amount = this.props.primary || this.props.secondary ? 0.4 : 0.08;
	      _reactDom2.default.findDOMNode(this.refs.overlay).style.backgroundColor = _colorManipulator2.default.fade(this.prepareStyles(this.getStyles().label, this.props.labelStyle).color, amount);
	    } else if (!this.state.hovered) {
	      this.setState({ zDepth: this.state.initialZDepth });
	      _reactDom2.default.findDOMNode(this.refs.overlay).style.backgroundColor = 'transparent';
	    }
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var children = _props2.children;
	    var disabled = _props2.disabled;
	    var icon = _props2.icon;
	    var label = _props2.label;
	    var labelPosition = _props2.labelPosition;
	    var labelStyle = _props2.labelStyle;
	    var primary = _props2.primary;
	    var secondary = _props2.secondary;
	
	    var other = _objectWithoutProperties(_props2, ['children', 'disabled', 'icon', 'label', 'labelPosition', 'labelStyle', 'primary', 'secondary']);
	
	    var styles = this.getStyles();
	
	    var labelElement = undefined;
	    if (label) {
	      labelElement = _react2.default.createElement(
	        'span',
	        { style: this.prepareStyles(styles.label, labelStyle) },
	        label
	      );
	    }
	
	    var rippleColor = styles.label.color;
	    var rippleOpacity = !(primary || secondary) ? 0.1 : 0.16;
	
	    var buttonEventHandlers = disabled ? null : {
	      onMouseDown: this._handleMouseDown,
	      onMouseUp: this._handleMouseUp,
	      onMouseLeave: this._handleMouseLeave,
	      onMouseEnter: this._handleMouseEnter,
	      onTouchStart: this._handleTouchStart,
	      onTouchEnd: this._handleTouchEnd,
	      onKeyboardFocus: this._handleKeyboardFocus
	    };
	
	    var iconCloned = undefined;
	
	    if (icon) {
	      iconCloned = _react2.default.cloneElement(icon, {
	        color: styles.label.color,
	        style: {
	          verticalAlign: 'middle',
	          marginLeft: labelPosition === 'before' ? 0 : 12,
	          marginRight: labelPosition === 'before' ? 12 : 0
	        }
	      });
	    }
	
	    // Place label before or after children.
	    var childrenFragment = labelPosition === 'before' ? {
	      labelElement: labelElement,
	      iconCloned: iconCloned,
	      children: children
	    } : {
	      children: children,
	      iconCloned: iconCloned,
	      labelElement: labelElement
	    };
	    var enhancedButtonChildren = _children2.default.create(childrenFragment);
	
	    return _react2.default.createElement(
	      _paper2.default,
	      {
	        style: this.mergeStyles(styles.root, this.props.style),
	        zDepth: this.state.zDepth
	      },
	      _react2.default.createElement(
	        _enhancedButton2.default,
	        _extends({}, other, buttonEventHandlers, {
	          ref: 'container',
	          disabled: disabled,
	          style: this.mergeStyles(styles.container),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: 'overlay',
	            style: this.prepareStyles(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered)
	          },
	          enhancedButtonChildren
	        )
	      )
	    );
	  }
	});
	
	exports.default = RaisedButton;
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _paper = __webpack_require__(11);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	var RefreshIndicator = _react2.default.createClass({
	  displayName: 'RefreshIndicator',
	
	  propTypes: {
	    /**
	     * Override the theme's color of the indicator while it's status is
	     * "ready" and it's percentage is less than 100.
	     */
	    color: _react2.default.PropTypes.string,
	
	    /**
	     * The absolute left position of the indicator in pixels.
	     */
	    left: _react2.default.PropTypes.number.isRequired,
	
	    /**
	     * Override the theme's color of the indicator while
	     * it's status is "loading" or when it's percentage is 100.
	     */
	    loadingColor: _react2.default.PropTypes.string,
	
	    /**
	     * The confirmation progress to fetch data. Max value is 100.
	     */
	    percentage: _react2.default.PropTypes.number,
	
	    /**
	     * Size in pixels.
	     */
	    size: _react2.default.PropTypes.number,
	
	    /**
	     * The display status of the indicator. If the status is
	     * "ready", the indicator will display the ready state
	     * arrow. If the status is "loading", it will display
	     * the loading progress indicator. If the status is "hide",
	     * the indicator will be hidden.
	     */
	    status: _react2.default.PropTypes.oneOf(['ready', 'loading', 'hide']),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The absolute top position of the indicator in pixels.
	     */
	    top: _react2.default.PropTypes.number.isRequired
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      percentage: 0,
	      size: 40,
	      status: 'hide'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate();
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._scalePath(_reactDom2.default.findDOMNode(this.refs.path), 0);
	    this._rotateWrapper(_reactDom2.default.findDOMNode(this.refs.wrapper));
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.scalePathTimer);
	    clearTimeout(this.rotateWrapperTimer);
	    clearTimeout(this.rotateWrapperSecondTimer);
	  },
	
	  scalePathTimer: undefined,
	  rotateWrapperTimer: undefined,
	  rotateWrapperSecondTimer: undefined,
	
	  _renderChildren: function _renderChildren() {
	    var paperSize = this._getPaperSize();
	    var childrenCmp = null;
	    if (this.props.status !== 'ready') {
	      var circleStyle = this._getCircleStyle(paperSize);
	      childrenCmp = _react2.default.createElement(
	        'div',
	        { ref: 'wrapper', style: this.prepareStyles({
	            transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	            width: '100%',
	            height: '100%'
	          })
	        },
	        _react2.default.createElement(
	          'svg',
	          { style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', _extends({ ref: 'path',
	            style: this.prepareStyles(circleStyle.style, {
	              transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	            })
	          }, circleStyle.attr))
	        )
	      );
	    } else {
	      var circleStyle = this._getCircleStyle(paperSize);
	      var polygonStyle = this._getPolygonStyle(paperSize);
	      childrenCmp = _react2.default.createElement(
	        'svg',
	        { style: {
	            width: paperSize,
	            height: paperSize
	          },
	          viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	        },
	        _react2.default.createElement('circle', _extends({
	          style: this.prepareStyles(circleStyle.style)
	        }, circleStyle.attr)),
	        _react2.default.createElement('polygon', _extends({
	          style: this.prepareStyles(polygonStyle.style)
	        }, polygonStyle.attr))
	      );
	    }
	
	    return childrenCmp;
	  },
	  _getTheme: function _getTheme() {
	    return this.state.muiTheme.refreshIndicator;
	  },
	  _getPaddingSize: function _getPaddingSize() {
	    var padding = this.props.size * 0.1;
	    return padding;
	  },
	  _getPaperSize: function _getPaperSize() {
	    return this.props.size - this._getPaddingSize() * 2;
	  },
	  _getCircleAttr: function _getCircleAttr() {
	    return {
	      radiu: VIEWBOX_SIZE / 2 - 5,
	      originX: VIEWBOX_SIZE / 2,
	      originY: VIEWBOX_SIZE / 2,
	      strokeWidth: 3
	    };
	  },
	  _getArcDeg: function _getArcDeg() {
	    var p = this.props.percentage / 100;
	
	    var beginDeg = p * 120;
	    var endDeg = p * 410;
	    return [beginDeg, endDeg];
	  },
	  _getFactor: function _getFactor() {
	    var p = this.props.percentage / 100;
	    var p1 = Math.min(1, p / 0.4);
	
	    return p1;
	  },
	  _getRootStyle: function _getRootStyle() {
	    var padding = this._getPaddingSize();
	    return {
	      position: 'absolute',
	      zIndex: 2,
	      width: this.props.size,
	      height: this.props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate3d(' + (10000 + this.props.left) + 'px, ' + (10000 + this.props.top) + 'px, 0)',
	      opacity: this.props.status === 'hide' ? 0 : 1,
	      transition: this.props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    };
	  },
	  _getCircleStyle: function _getCircleStyle() {
	    var isLoading = this.props.status === 'loading';
	    var p1 = isLoading ? 1 : this._getFactor();
	    var circle = this._getCircleAttr();
	    var perimeter = Math.PI * 2 * circle.radiu;
	
	    var _getArcDeg2 = this._getArcDeg();
	
	    var _getArcDeg3 = _slicedToArray(_getArcDeg2, 2);
	
	    var beginDeg = _getArcDeg3[0];
	    var endDeg = _getArcDeg3[1];
	
	    var arcLen = (endDeg - beginDeg) * perimeter / 360;
	    var dashOffset = -beginDeg * perimeter / 360;
	
	    var theme = this._getTheme();
	    return {
	      style: {
	        strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	        strokeDashoffset: dashOffset,
	        stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	        strokeLinecap: 'round',
	        opacity: p1,
	        strokeWidth: circle.strokeWidth * p1,
	        fill: 'none'
	      },
	      attr: {
	        cx: circle.originX,
	        cy: circle.originY,
	        r: circle.radiu
	      }
	    };
	  },
	  _getPolygonStyle: function _getPolygonStyle() {
	    var p1 = this._getFactor();
	    var circle = this._getCircleAttr();
	
	    var triangleCx = circle.originX + circle.radiu;
	    var triangleCy = circle.originY;
	    var dx = circle.strokeWidth * 7 / 4 * p1;
	    var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	    var _getArcDeg4 = this._getArcDeg();
	
	    var _getArcDeg5 = _slicedToArray(_getArcDeg4, 2);
	
	    var endDeg = _getArcDeg5[1];
	
	    var theme = this._getTheme();
	    return {
	      style: {
	        fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	        transform: 'rotate(' + endDeg + 'deg)',
	        transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	        opacity: p1
	      },
	      attr: {
	        points: trianglePath
	      }
	    };
	  },
	  _scalePath: function _scalePath(path, step) {
	    var _this = this;
	
	    if (this.props.status !== 'loading') return;
	
	    var currStep = (step || 0) % 3;
	
	    var circle = this._getCircleAttr();
	    var perimeter = Math.PI * 2 * circle.radiu;
	    var arcLen = perimeter * 0.64;
	
	    var strokeDasharray = undefined;
	    var strokeDashoffset = undefined;
	    var transitionDuration = undefined;
	
	    if (currStep === 0) {
	      strokeDasharray = '1, 200';
	      strokeDashoffset = 0;
	      transitionDuration = '0ms';
	    } else if (currStep === 1) {
	      strokeDasharray = arcLen + ', 200';
	      strokeDashoffset = -15;
	      transitionDuration = '750ms';
	    } else {
	      strokeDasharray = arcLen + ',200';
	      strokeDashoffset = -(perimeter - 1);
	      transitionDuration = '850ms';
	    }
	
	    _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray, this.state.muiTheme);
	    _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset, this.state.muiTheme);
	    _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration, this.state.muiTheme);
	
	    this.scalePathTimer = setTimeout(function () {
	      return _this._scalePath(path, currStep + 1);
	    }, currStep ? 750 : 250);
	  },
	  _rotateWrapper: function _rotateWrapper(wrapper) {
	    var _this2 = this;
	
	    if (this.props.status !== 'loading') return;
	
	    _autoPrefix2.default.set(wrapper.style, 'transform', null, this.state.muiTheme);
	    _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)', this.state.muiTheme);
	    _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms', this.state.muiTheme);
	
	    this.rotateWrapperSecondTimer = setTimeout(function () {
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)', _this2.state.muiTheme);
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s', _this2.state.muiTheme);
	      _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear', _this2.state.muiTheme);
	    }, 50);
	
	    this.rotateWrapperTimer = setTimeout(function () {
	      return _this2._rotateWrapper(wrapper);
	    }, 10050);
	  },
	  render: function render() {
	    var rootStyle = this._getRootStyle();
	    return _react2.default.createElement(
	      _paper2.default,
	      {
	        circle: true,
	        style: this.mergeStyles(rootStyle, this.props.style),
	        ref: 'indicatorCt'
	      },
	      this._renderChildren()
	    );
	  }
	});
	
	exports.default = RefreshIndicator;
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TouchRipple = exports.FocusRipple = exports.CircleRipple = undefined;
	
	var _circleRipple = __webpack_require__(148);
	
	var _circleRipple2 = _interopRequireDefault(_circleRipple);
	
	var _focusRipple = __webpack_require__(69);
	
	var _focusRipple2 = _interopRequireDefault(_focusRipple);
	
	var _touchRipple = __webpack_require__(99);
	
	var _touchRipple2 = _interopRequireDefault(_touchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CircleRipple = _circleRipple2.default;
	exports.FocusRipple = _focusRipple2.default;
	exports.TouchRipple = _touchRipple2.default;
	exports.default = {
	  CircleRipple: _circleRipple2.default,
	  FocusRipple: _focusRipple2.default,
	  TouchRipple: _touchRipple2.default
	};

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectField = __webpack_require__(234);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _focusRipple = __webpack_require__(69);
	
	var _focusRipple2 = _interopRequireDefault(_focusRipple);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	  * Verifies min/max range.
	  * @param   {Object} props         Properties of the React component.
	  * @param   {String} propName      Name of the property to validate.
	  * @param   {String} componentName Name of the component whose property is being validated.
	  * @returns {Object} Returns an Error if min >= max otherwise null.
	  */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  var error = _react2.default.PropTypes.number(props, propName, componentName);
	  if (error !== null) return error;
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	  * Verifies value is within the min/max range.
	  * @param   {Object} props         Properties of the React component.
	  * @param   {String} propName      Name of the property to validate.
	  * @param   {String} componentName Name of the component whose property is being validated.
	  * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	  */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  var error = _react2.default.PropTypes.number(props, propName, componentName);
	  if (error !== null) return error;
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var Slider = _react2.default.createClass({
	  displayName: 'Slider',
	
	  propTypes: {
	    /**
	     * The default value of the slider.
	     */
	    defaultValue: valueInRangePropType,
	
	    /**
	     * Describe the slider.
	     */
	    description: _react2.default.PropTypes.string,
	
	    /**
	     * Disables focus ripple if set to true.
	     */
	    disableFocusRipple: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the slider will not be interactable.
	     */
	    disabled: _react2.default.PropTypes.bool,
	
	    /**
	     * An error message for the slider.
	     */
	    error: _react2.default.PropTypes.string,
	
	    /**
	     * The maximum value the slider can slide to on
	     * a scale from 0 to 1 inclusive. Cannot be equal to min.
	     */
	    max: minMaxPropType,
	
	    /**
	     * The minimum value the slider can slide to on a scale
	     * from 0 to 1 inclusive. Cannot be equal to max.
	     */
	    min: minMaxPropType,
	
	    /**
	     * The name of the slider. Behaves like the name attribute
	     * of an input element.
	     */
	    name: _react2.default.PropTypes.string,
	
	    /**
	     * Callback function that is fired when the focus has left the slider.
	     */
	    onBlur: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the user changes the slider's value.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the slider has begun to move.
	     */
	    onDragStart: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fried when the slide has stopped moving.
	     */
	    onDragStop: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired when the user has focused on the slider.
	     */
	    onFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Whether or not the slider is required in a form.
	     */
	    required: _react2.default.PropTypes.bool,
	
	    /**
	     * The granularity the slider can step through values.
	     */
	    step: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The value of the slider.
	     */
	    value: valueInRangePropType
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      disableFocusRipple: false,
	      max: 1,
	      min: 0,
	      required: true,
	      step: 0.01,
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    var value = this.props.value;
	    if (value === undefined) {
	      value = this.props.defaultValue !== undefined ? this.props.defaultValue : this.props.min;
	    }
	    var percent = (value - this.props.min) / (this.props.max - this.props.min);
	    if (isNaN(percent)) percent = 0;
	
	    return {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      percent: percent,
	      value: value,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (nextProps.value !== undefined && !this.state.dragging) {
	      this.setValue(nextProps.value);
	    }
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.slider;
	  },
	  getStyles: function getStyles() {
	    var fillGutter = this.getTheme().handleSize / 2;
	    var disabledGutter = this.getTheme().trackSize + this.getTheme().handleSizeDisabled / 2;
	    var calcDisabledSpacing = this.props.disabled ? ' - ' + disabledGutter + 'px' : '';
	    var styles = {
	      root: {
	        touchCallout: 'none',
	        userSelect: 'none',
	        cursor: 'default',
	        height: this.getTheme().handleSizeActive,
	        position: 'relative',
	        marginTop: 24,
	        marginBottom: 48
	      },
	      track: {
	        position: 'absolute',
	        top: (this.getTheme().handleSizeActive - this.getTheme().trackSize) / 2,
	        left: 0,
	        width: '100%',
	        height: this.getTheme().trackSize
	      },
	      filledAndRemaining: {
	        position: 'absolute',
	        top: 0,
	        height: '100%',
	        transition: _transitions2.default.easeOut(null, 'margin')
	      },
	      handle: {
	        boxSizing: 'border-box',
	        position: 'absolute',
	        cursor: 'pointer',
	        pointerEvents: 'inherit',
	        top: 0,
	        left: '0%',
	        zIndex: 1,
	        margin: this.getTheme().trackSize / 2 + 'px 0 0 0',
	        width: this.getTheme().handleSize,
	        height: this.getTheme().handleSize,
	        backgroundColor: this.getTheme().selectionColor,
	        backgroundClip: 'padding-box',
	        border: '0px solid transparent',
	        borderRadius: '50%',
	        transform: 'translate(-50%, -50%)',
	        transition: _transitions2.default.easeOut('450ms', 'background') + ',' + _transitions2.default.easeOut('450ms', 'border-color') + ',' + _transitions2.default.easeOut('450ms', 'width') + ',' + _transitions2.default.easeOut('450ms', 'height'),
	        overflow: 'visible'
	      },
	      handleWhenDisabled: {
	        boxSizing: 'content-box',
	        cursor: 'not-allowed',
	        backgroundColor: this.getTheme().trackColor,
	        width: this.getTheme().handleSizeDisabled,
	        height: this.getTheme().handleSizeDisabled,
	        border: 'none'
	      },
	      handleWhenPercentZero: {
	        border: this.getTheme().trackSize + 'px solid ' + this.getTheme().handleColorZero,
	        backgroundColor: this.getTheme().handleFillColor,
	        boxShadow: 'none'
	      },
	      handleWhenPercentZeroAndDisabled: {
	        cursor: 'not-allowed',
	        width: this.getTheme().handleSizeDisabled,
	        height: this.getTheme().handleSizeDisabled
	      },
	      handleWhenPercentZeroAndFocused: {
	        border: this.getTheme().trackSize + 'px solid ' + this.getTheme().trackColorSelected
	      },
	      handleWhenActive: {
	        width: this.getTheme().handleSizeActive,
	        height: this.getTheme().handleSizeActive
	      },
	      ripple: {
	        height: this.getTheme().handleSize,
	        width: this.getTheme().handleSize,
	        overflow: 'visible'
	      },
	      rippleWhenPercentZero: {
	        top: -this.getTheme().trackSize,
	        left: -this.getTheme().trackSize
	      },
	      rippleInner: {
	        height: '300%',
	        width: '300%',
	        top: -this.getTheme().handleSize,
	        left: -this.getTheme().handleSize
	      }
	    };
	    styles.filled = this.mergeStyles(styles.filledAndRemaining, {
	      left: 0,
	      backgroundColor: this.props.disabled ? this.getTheme().trackColor : this.getTheme().selectionColor,
	      marginRight: fillGutter,
	      width: 'calc(' + this.state.percent * 100 + '%' + calcDisabledSpacing + ')'
	    });
	    styles.remaining = this.mergeStyles(styles.filledAndRemaining, {
	      right: 0,
	      backgroundColor: this.getTheme().trackColor,
	      marginLeft: fillGutter,
	      width: 'calc(' + (1 - this.state.percent) * 100 + '%' + calcDisabledSpacing + ')'
	    });
	
	    return styles;
	  },
	
	  // Needed to prevent text selection when dragging the slider handler.
	  // In the future, we should consider use <input type="range"> to avoid
	  // similar issues.
	  _toggleSelection: function _toggleSelection(value) {
	    var body = document.getElementsByTagName('body')[0];
	    _autoPrefix2.default.set(body.style, 'userSelect', value, this.state.muiTheme);
	  },
	  _onHandleTouchStart: function _onHandleTouchStart(e) {
	    if (document) {
	      document.addEventListener('touchmove', this._dragTouchHandler, false);
	      document.addEventListener('touchup', this._dragTouchEndHandler, false);
	      document.addEventListener('touchend', this._dragTouchEndHandler, false);
	      document.addEventListener('touchcancel', this._dragTouchEndHandler, false);
	    }
	    this._onDragStart(e);
	  },
	  _onHandleMouseDown: function _onHandleMouseDown(e) {
	    if (document) {
	      document.addEventListener('mousemove', this._dragHandler, false);
	      document.addEventListener('mouseup', this._dragEndHandler, false);
	      this._toggleSelection('none');
	    }
	    this._onDragStart(e);
	  },
	  _dragHandler: function _dragHandler(e) {
	    var _this = this;
	
	    if (this._dragRunning) {
	      return;
	    }
	    this._dragRunning = true;
	    requestAnimationFrame(function () {
	      _this._onDragUpdate(e, e.clientX - _this._getTrackLeft());
	      _this._dragRunning = false;
	    });
	  },
	  _dragTouchHandler: function _dragTouchHandler(e) {
	    var _this2 = this;
	
	    if (this._dragRunning) {
	      return;
	    }
	    this._dragRunning = true;
	    requestAnimationFrame(function () {
	      _this2._onDragUpdate(e, e.touches[0].clientX - _this2._getTrackLeft());
	      _this2._dragRunning = false;
	    });
	  },
	  _dragEndHandler: function _dragEndHandler(e) {
	    if (document) {
	      document.removeEventListener('mousemove', this._dragHandler, false);
	      document.removeEventListener('mouseup', this._dragEndHandler, false);
	      this._toggleSelection('');
	    }
	
	    this._onDragStop(e);
	  },
	  _dragTouchEndHandler: function _dragTouchEndHandler(e) {
	    if (document) {
	      document.removeEventListener('touchmove', this._dragTouchHandler, false);
	      document.removeEventListener('touchup', this._dragTouchEndHandler, false);
	      document.removeEventListener('touchend', this._dragTouchEndHandler, false);
	      document.removeEventListener('touchcancel', this._dragTouchEndHandler, false);
	    }
	
	    this._onDragStop(e);
	  },
	  getValue: function getValue() {
	    return this.state.value;
	  },
	  setValue: function setValue(i) {
	    // calculate percentage
	    var percent = (i - this.props.min) / (this.props.max - this.props.min);
	    if (isNaN(percent)) percent = 0;
	    // update state
	    this.setState({
	      value: i,
	      percent: percent
	    });
	  },
	  getPercent: function getPercent() {
	    return this.state.percent;
	  },
	  setPercent: function setPercent(percent, callback) {
	    var value = this._alignValue(this._percentToValue(percent));
	    var _props = this.props;
	    var min = _props.min;
	    var max = _props.max;
	
	    var alignedPercent = (value - min) / (max - min);
	    if (this.state.value !== value) {
	      this.setState({ value: value, percent: alignedPercent }, callback);
	    }
	  },
	  clearValue: function clearValue() {
	    this.setValue(this.props.min);
	  },
	  _alignValue: function _alignValue(val) {
	    var _props2 = this.props;
	    var step = _props2.step;
	    var min = _props2.min;
	
	    var alignValue = Math.round((val - min) / step) * step + min;
	    return parseFloat(alignValue.toFixed(5));
	  },
	  _onFocus: function _onFocus(e) {
	    this.setState({ focused: true });
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	  _onBlur: function _onBlur(e) {
	    this.setState({ focused: false, active: false });
	    if (this.props.onBlur) this.props.onBlur(e);
	  },
	  _onMouseDown: function _onMouseDown(e) {
	    if (!this.props.disabled) this._pos = e.clientX;
	  },
	  _onMouseEnter: function _onMouseEnter() {
	    this.setState({ hovered: true });
	  },
	  _onMouseLeave: function _onMouseLeave() {
	    this.setState({ hovered: false });
	  },
	  _getTrackLeft: function _getTrackLeft() {
	    return _reactDom2.default.findDOMNode(this.refs.track).getBoundingClientRect().left;
	  },
	  _onMouseUp: function _onMouseUp(e) {
	    if (!this.props.disabled) this.setState({ active: false });
	    if (!this.state.dragging && Math.abs(this._pos - e.clientX) < 5) {
	      var pos = e.clientX - this._getTrackLeft();
	      this._dragX(e, pos);
	    }
	
	    this._pos = undefined;
	  },
	  _onDragStart: function _onDragStart(e) {
	    this.setState({
	      dragging: true,
	      active: true
	    });
	    if (this.props.onDragStart) this.props.onDragStart(e);
	  },
	  _onDragStop: function _onDragStop(e) {
	    this.setState({
	      dragging: false,
	      active: false
	    });
	    if (this.props.onDragStop) this.props.onDragStop(e);
	  },
	  _onDragUpdate: function _onDragUpdate(e, pos) {
	    if (!this.state.dragging) return;
	    if (!this.props.disabled) this._dragX(e, pos);
	  },
	  _dragX: function _dragX(e, pos) {
	    var max = _reactDom2.default.findDOMNode(this.refs.track).clientWidth;
	    if (pos < 0) pos = 0;else if (pos > max) pos = max;
	    this._updateWithChangeEvent(e, pos / max);
	  },
	  _updateWithChangeEvent: function _updateWithChangeEvent(e, percent) {
	    var _this3 = this;
	
	    this.setPercent(percent, function () {
	      if (_this3.props.onChange) _this3.props.onChange(e, _this3.state.value);
	    });
	  },
	  _percentToValue: function _percentToValue(percent) {
	    return percent * (this.props.max - this.props.min) + this.props.min;
	  },
	  render: function render() {
	    var others = _objectWithoutProperties(this.props, []);
	
	    var percent = this.state.percent;
	    if (percent > 1) percent = 1;else if (percent < 0) percent = 0;
	
	    var styles = this.getStyles();
	    var sliderStyles = this.mergeStyles(styles.root, this.props.style);
	    var handleStyles = percent === 0 ? this.mergeStyles(styles.handle, styles.handleWhenPercentZero, this.state.active && styles.handleWhenActive, this.state.focused && { outline: 'none' }, (this.state.hovered || this.state.focused) && !this.props.disabled && styles.handleWhenPercentZeroAndFocused, this.props.disabled && styles.handleWhenPercentZeroAndDisabled) : this.mergeStyles(styles.handle, this.state.active && styles.handleWhenActive, this.state.focused && { outline: 'none' }, this.props.disabled && styles.handleWhenDisabled, {
	      left: percent * 100 + '%'
	    });
	    var rippleStyle = this.mergeStyles(styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	    var remainingStyles = styles.remaining;
	    if ((this.state.hovered || this.state.focused) && !this.props.disabled) {
	      remainingStyles.backgroundColor = this.getTheme().trackColorSelected;
	    }
	
	    var rippleShowCondition = (this.state.hovered || this.state.focused) && !this.state.active;
	    var rippleColor = this.state.percent === 0 ? this.getTheme().handleColorZero : this.getTheme().rippleColor;
	    var focusRipple = undefined;
	    if (!this.props.disabled && !this.props.disableFocusRipple) {
	      focusRipple = _react2.default.createElement(_focusRipple2.default, {
	        ref: 'focusRipple',
	        key: 'focusRipple',
	        style: this.mergeStyles(rippleStyle),
	        innerStyle: styles.rippleInner,
	        show: rippleShowCondition,
	        muiTheme: this.state.muiTheme,
	        color: rippleColor
	      });
	    }
	
	    var handleDragProps = {};
	
	    if (!this.props.disabled) {
	      handleDragProps = {
	        onTouchStart: this._onHandleTouchStart,
	        onMouseDown: this._onHandleMouseDown
	      };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, others, { style: this.prepareStyles(this.props.style) }),
	      _react2.default.createElement(
	        'span',
	        null,
	        this.props.description
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        this.props.error
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: this.prepareStyles(sliderStyles),
	          onFocus: this._onFocus,
	          onBlur: this._onBlur,
	          onMouseDown: this._onMouseDown,
	          onMouseEnter: this._onMouseEnter,
	          onMouseLeave: this._onMouseLeave,
	          onMouseUp: this._onMouseUp
	        },
	        _react2.default.createElement(
	          'div',
	          { ref: 'track', style: this.prepareStyles(styles.track) },
	          _react2.default.createElement('div', { style: this.prepareStyles(styles.filled) }),
	          _react2.default.createElement('div', { style: this.prepareStyles(remainingStyles) }),
	          _react2.default.createElement(
	            'div',
	            _extends({ style: this.prepareStyles(handleStyles), tabIndex: 0 }, handleDragProps),
	            focusRipple
	          )
	        )
	      ),
	      _react2.default.createElement('input', { ref: 'input', type: 'hidden',
	        name: this.props.name,
	        value: this.state.value,
	        required: this.props.required,
	        min: this.props.min,
	        max: this.props.max,
	        step: this.props.step
	      })
	    );
	  }
	});
	
	exports.default = Slider;
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _clickAwayable = __webpack_require__(48);
	
	var _clickAwayable2 = _interopRequireDefault(_clickAwayable);
	
	var _flatButton = __webpack_require__(54);
	
	var _flatButton2 = _interopRequireDefault(_flatButton);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _contextPure = __webpack_require__(34);
	
	var _contextPure2 = _interopRequireDefault(_contextPure);
	
	var _styleResizable = __webpack_require__(145);
	
	var _styleResizable2 = _interopRequireDefault(_styleResizable);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deprecatedPropType = __webpack_require__(42);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Snackbar = _react2.default.createClass({
	  displayName: 'Snackbar',
	
	  propTypes: {
	    /**
	     * The label for the action on the snackbar.
	     */
	    action: _react2.default.PropTypes.string,
	
	    /**
	     * The number of milliseconds to wait before automatically dismissing.
	     * If no value is specified the snackbar will dismiss normally.
	     * If a value is provided the snackbar can still be dismissed normally.
	     * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	     */
	    autoHideDuration: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the body element.
	     */
	    bodyStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * The message to be displayed.
	     */
	    message: _react2.default.PropTypes.node.isRequired,
	
	    /**
	     * Fired when the action button is touchtapped.
	     *
	     * @param {object} event Action button event.
	     */
	    onActionTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when the `Snackbar` is dismissed.
	     */
	    onDismiss: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.func, 'Instead, use the open property to control the component.'),
	
	    /**
	     * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	     * `autoHideDuration` timer expires.
	     *
	     * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	     * `open` prop.
	     *
	     * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	     * for example ignoring `clickaway`.
	     *
	     * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	     */
	    onRequestClose: _react2.default.PropTypes.func.isRequired,
	
	    /**
	     * Fired when the `Snackbar` is shown.
	     */
	    onShow: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.func, 'Instead, use the open property to control the component.'),
	
	    /**
	     * Controls whether the `Snackbar` is opened or not.
	     */
	    open: _react2.default.PropTypes.bool.isRequired,
	
	    /**
	     * If true, the `Snackbar` will open once mounted.
	     */
	    openOnMount: (0, _deprecatedPropType2.default)(_react2.default.PropTypes.bool, 'Instead, use the open property to control the component.'),
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _styleResizable2.default, _clickAwayable2.default, _contextPure2.default],
	
	  statics: {
	    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
	      var theme = muiTheme.snackbar;
	      var spacing = muiTheme.rawTheme.spacing;
	
	      return {
	        textColor: theme.textColor,
	        backgroundColor: theme.backgroundColor,
	        desktopGutter: spacing.desktopGutter,
	        desktopSubheaderHeight: spacing.desktopSubheaderHeight,
	        actionColor: theme.actionColor
	      };
	    },
	    getChildrenClasses: function getChildrenClasses() {
	      return [_flatButton2.default];
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    var open = this.props.open;
	
	    if (open === null) {
	      open = this.props.openOnMount;
	    }
	
	    return {
	      open: open,
	      message: this.props.message,
	      action: this.props.action,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (this.state.open) {
	      this._setAutoHideTimer();
	
	      //Only Bind clickaway after transition finishes
	      this.timerTransitionId = setTimeout(function () {
	        _this._bindClickAway();
	      }, 400);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var _this2 = this;
	
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      muiTheme: newMuiTheme
	    });
	
	    if (this.state.open && nextProps.open === this.props.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	      this.setState({
	        open: false
	      });
	
	      clearTimeout(this.timerOneAtTheTimeId);
	      this.timerOneAtTheTimeId = setTimeout(function () {
	        _this2.setState({
	          message: nextProps.message,
	          action: nextProps.action,
	          open: true
	        });
	      }, 400);
	    } else {
	      var open = nextProps.open;
	
	      this.setState({
	        open: open !== null ? open : this.state.open,
	        message: nextProps.message,
	        action: nextProps.action
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var _this3 = this;
	
	    if (prevState.open !== this.state.open) {
	      if (this.state.open) {
	        this._setAutoHideTimer();
	
	        //Only Bind clickaway after transition finishes
	        this.timerTransitionId = setTimeout(function () {
	          _this3._bindClickAway();
	        }, 400);
	      } else {
	        clearTimeout(this.timerAutoHideId);
	        this._unbindClickAway();
	      }
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timerAutoHideId);
	    clearTimeout(this.timerTransitionId);
	    clearTimeout(this.timerOneAtTheTimeId);
	    this._unbindClickAway();
	  },
	
	  manuallyBindClickAway: true,
	
	  timerAutoHideId: undefined,
	  timerTransitionId: undefined,
	  timerOneAtTheTimeId: undefined,
	
	  componentClickAway: function componentClickAway() {
	    if (this.props.open !== null && this.props.onRequestClose) {
	      this.props.onRequestClose('clickaway');
	    } else {
	      this.setState({ open: false });
	    }
	  },
	  getStyles: function getStyles() {
	    var _constructor$getRelev = this.constructor.getRelevantContextKeys(this.state.muiTheme);
	
	    var textColor = _constructor$getRelev.textColor;
	    var backgroundColor = _constructor$getRelev.backgroundColor;
	    var desktopGutter = _constructor$getRelev.desktopGutter;
	    var desktopSubheaderHeight = _constructor$getRelev.desktopSubheaderHeight;
	    var actionColor = _constructor$getRelev.actionColor;
	
	    var isSmall = this.state.deviceSize === this.constructor.Sizes.SMALL;
	
	    var styles = {
	      root: {
	        position: 'fixed',
	        left: 0,
	        display: 'flex',
	        right: 0,
	        bottom: 0,
	        zIndex: this.state.muiTheme.zIndex.snackbar,
	        visibility: 'hidden',
	        transform: 'translate3d(0, ' + desktopSubheaderHeight + 'px, 0)',
	        transition: _transitions2.default.easeOut('400ms', 'transform') + ',' + _transitions2.default.easeOut('400ms', 'visibility')
	      },
	      rootWhenOpen: {
	        visibility: 'visible',
	        transform: 'translate3d(0, 0, 0)'
	      },
	      body: {
	        backgroundColor: backgroundColor,
	        padding: '0 ' + desktopGutter + 'px',
	        height: desktopSubheaderHeight,
	        lineHeight: desktopSubheaderHeight + 'px',
	        borderRadius: isSmall ? 0 : 2,
	        maxWidth: isSmall ? 'inherit' : 568,
	        minWidth: isSmall ? 'inherit' : 288,
	        flexGrow: isSmall ? 1 : 0,
	        margin: 'auto'
	      },
	      content: {
	        fontSize: 14,
	        color: textColor,
	        opacity: 0,
	        transition: _transitions2.default.easeOut('400ms', 'opacity')
	      },
	      contentWhenOpen: {
	        opacity: 1,
	        transition: _transitions2.default.easeOut('500ms', 'opacity', '100ms')
	      },
	      action: {
	        color: actionColor,
	        float: 'right',
	        marginTop: 6,
	        marginRight: -16,
	        marginLeft: desktopGutter,
	        backgroundColor: 'transparent'
	      }
	    };
	
	    return styles;
	  },
	  show: function show() {
	     false ? (0, _warning2.default)(false, 'show has been deprecated in favor of explicitly setting the open property.') : undefined;
	
	    this.setState({
	      open: true
	    });
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  _onDismiss: function _onDismiss() {
	    if (this.props.onDismiss) {
	      this.props.onDismiss();
	    }
	  },
	  dismiss: function dismiss() {
	     false ? (0, _warning2.default)(false, 'dismiss has been deprecated in favor of explicitly setting the open property.') : undefined;
	
	    this.setState({
	      open: false
	    }, this._onDismiss);
	  },
	  _setAutoHideTimer: function _setAutoHideTimer() {
	    var _this4 = this;
	
	    var autoHideDuration = this.props.autoHideDuration;
	
	    if (autoHideDuration > 0) {
	      clearTimeout(this.timerAutoHideId);
	      this.timerAutoHideId = setTimeout(function () {
	        if (_this4.props.open !== null && _this4.props.onRequestClose) {
	          _this4.props.onRequestClose('timeout');
	        } else {
	          _this4.setState({ open: false });
	        }
	      }, autoHideDuration);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var onActionTouchTap = _props.onActionTouchTap;
	    var style = _props.style;
	    var bodyStyle = _props.bodyStyle;
	
	    var others = _objectWithoutProperties(_props, ['onActionTouchTap', 'style', 'bodyStyle']);
	
	    var styles = this.getStyles();
	
	    var _state = this.state;
	    var open = _state.open;
	    var action = _state.action;
	    var message = _state.message;
	
	    var rootStyles = open ? this.mergeStyles(styles.root, styles.rootWhenOpen, style) : this.mergeStyles(styles.root, style);
	
	    var actionButton = undefined;
	    if (action) {
	      actionButton = _react2.default.createElement(_flatButton2.default, {
	        style: styles.action,
	        label: action,
	        onTouchTap: onActionTouchTap
	      });
	    }
	
	    var mergedBodyStyle = this.mergeStyles(styles.body, bodyStyle);
	
	    var contentStyle = open ? this.mergeStyles(styles.content, styles.contentWhenOpen) : styles.content;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, others, { style: rootStyles }),
	      _react2.default.createElement(
	        'div',
	        { style: mergedBodyStyle },
	        _react2.default.createElement(
	          'div',
	          { style: contentStyle },
	          _react2.default.createElement(
	            'span',
	            null,
	            message
	          ),
	          actionButton
	        )
	      )
	    );
	  }
	});
	
	exports.default = Snackbar;
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _darkBaseTheme = __webpack_require__(149);
	
	var _darkBaseTheme2 = _interopRequireDefault(_darkBaseTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _darkBaseTheme2.default;
	
	// import deprecatedExport from '../../utils/deprecatedExport';
	
	// export default deprecatedExport(
	//   darkBaseTheme,
	//   'material-ui/lib/styles/raw-themes/dark-raw-theme',
	//   'material-ui/lib/styles/baseThemes/darkBaseTheme'
	// );
	
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lightBaseTheme = __webpack_require__(100);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _lightBaseTheme2.default;
	
	// import deprecatedExport from '../../utils/deprecatedExport';
	
	// export default deprecatedExport(
	//   lightBaseTheme,
	//   'material-ui/lib/styles/raw-themes/light-raw-theme',
	//   'material-ui/lib/styles/baseThemes/lightBaseTheme'
	// );
	
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (customTheme) {
	
	  return function (Component) {
	
	    return _react2.default.createClass({
	
	      childContextTypes: {
	        muiTheme: _react2.default.PropTypes.object
	      },
	
	      getChildContext: function getChildContext() {
	        return {
	          muiTheme: customTheme
	        };
	      },
	      render: function render() {
	        return _react2.default.createElement(Component, this.props);
	      }
	    });
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactAddonsUpdate = __webpack_require__(75);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	var _lodash = __webpack_require__(164);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import deprecatedExport from '../utils/deprecatedExport';
	
	exports.default = // deprecatedExport(
	{
	  getMuiTheme: _getMuiTheme2.default,
	  modifyRawThemeSpacing: function modifyRawThemeSpacing(muiTheme, spacing) {
	    return (0, _getMuiTheme2.default)((0, _reactAddonsUpdate2.default)(muiTheme.baseTheme, { spacing: { $set: spacing } }));
	  },
	  modifyRawThemePalette: function modifyRawThemePalette(muiTheme, palette) {
	    var newPalette = (0, _lodash2.default)(muiTheme.baseTheme.palette, palette);
	    return (0, _getMuiTheme2.default)((0, _reactAddonsUpdate2.default)(muiTheme.baseTheme, { palette: { $set: newPalette } }));
	  },
	  modifyRawThemeFontFamily: function modifyRawThemeFontFamily(muiTheme, fontFamily) {
	    return (0, _getMuiTheme2.default)((0, _reactAddonsUpdate2.default)(muiTheme.baseTheme, { fontFamily: { $set: fontFamily } }));
	  }
	}; // ,
	//  'material-ui/lib/styles/theme-manager',
	//  'material-ui/lib/styles/themeManager'
	//);
	
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  if (muiTheme.userAgent !== false) {
	    return function (style) {
	      return muiTheme.prefix(style);
	    };
	  }
	};
	
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'You cannot call prepareStyles() on the same style object more than once.') : undefined;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rtl = exports.callOnce = exports.autoprefixer = undefined;
	
	var _autoprefixer = __webpack_require__(291);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(292);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(294);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.autoprefixer = _autoprefixer2.default;
	exports.callOnce = _callOnce2.default;
	exports.rtl = _rtl2.default;

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtl;
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      Object.keys(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            var matches = undefined;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ',' + -parseFloat(matches[7]) + matches[8] : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = _react2.default.createClass({
	  displayName: 'HardwareKeyboardArrowDown',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	    );
	  }
	});
	
	exports.default = HardwareKeyboardArrowDown;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = _react2.default.createClass({
	  displayName: 'HardwareKeyboardArrowUp',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	    );
	  }
	});
	
	exports.default = HardwareKeyboardArrowUp;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropUp = _react2.default.createClass({
	  displayName: 'NavigationArrowDropUp',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' })
	    );
	  }
	});
	
	exports.default = NavigationArrowDropUp;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = _react2.default.createClass({
	  displayName: 'NavigationCheck',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	    );
	  }
	});
	
	exports.default = NavigationCheck;
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = _react2.default.createClass({
	  displayName: 'ToggleCheckBoxOutlineBlank',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	    );
	  }
	});
	
	exports.default = ToggleCheckBoxOutlineBlank;
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = _react2.default.createClass({
	  displayName: 'ToggleCheckBox',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	    );
	  }
	});
	
	exports.default = ToggleCheckBox;
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = _react2.default.createClass({
	  displayName: 'ToggleRadioButtonChecked',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	    );
	  }
	});
	
	exports.default = ToggleRadioButtonChecked;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _svgIcon = __webpack_require__(16);
	
	var _svgIcon2 = _interopRequireDefault(_svgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = _react2.default.createClass({
	  displayName: 'ToggleRadioButtonUnchecked',
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  render: function render() {
	    return _react2.default.createElement(
	      _svgIcon2.default,
	      this.props,
	      _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	    );
	  }
	});
	
	exports.default = ToggleRadioButtonUnchecked;
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkbox = __webpack_require__(91);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _tableRowColumn = __webpack_require__(102);
	
	var _tableRowColumn2 = _interopRequireDefault(_tableRowColumn);
	
	var _clickAwayable = __webpack_require__(48);
	
	var _clickAwayable2 = _interopRequireDefault(_clickAwayable);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TableBody = _react2.default.createClass({
	  displayName: 'TableBody',
	
	  propTypes: {
	    /**
	     * Set to true to indicate that all rows should be selected.
	     */
	    allRowsSelected: _react2.default.PropTypes.bool,
	
	    /**
	     * Children passed to table body.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Controls whether or not to deselect all selected
	     * rows after clicking outside the table.
	     */
	    deselectOnClickaway: _react2.default.PropTypes.bool,
	
	    /**
	     * Controls the display of the row checkbox. The default value is true.
	     */
	    displayRowCheckbox: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, multiple table rows can be selected.
	     * CTRL/CMD+Click and SHIFT+Click are valid actions.
	     * The default value is false.
	     */
	    multiSelectable: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback function for when a cell is clicked.
	     */
	    onCellClick: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table cell is hovered. rowNumber
	     * is the row number of the hovered row and columnId
	     * is the column number or the column key of the cell.
	     */
	    onCellHover: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table cell is no longer hovered.
	     * rowNumber is the row number of the row and columnId
	     * is the column number or the column key of the cell.
	     */
	    onCellHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table row is hovered.
	     * rowNumber is the row number of the hovered row.
	     */
	    onRowHover: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table row is no longer
	     * hovered. rowNumber is the row number of the row
	     * that is no longer hovered.
	     */
	    onRowHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a row is selected. selectedRows is an
	     * array of all row selections. IF all rows have been selected,
	     * the string "all" will be returned instead to indicate that
	     * all rows have been selected.
	     */
	    onRowSelection: _react2.default.PropTypes.func,
	
	    /**
	     * Controls whether or not the rows are pre-scanned to determine
	     * initial state. If your table has a large number of rows and
	     * you are experiencing a delay in rendering, turn off this property.
	     */
	    preScanRows: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, table rows can be selected. If multiple
	     * row selection is desired, enable multiSelectable.
	     * The default value is true.
	     */
	    selectable: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, table rows will be highlighted when
	     * the cursor is hovering over the row. The default
	     * value is false.
	     */
	    showRowHover: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, every other table row starting
	     * with the first row will be striped. The default value is false.
	     */
	    stripedRows: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_clickAwayable2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      allRowsSelected: false,
	      deselectOnClickaway: true,
	      displayRowCheckbox: true,
	      multiSelectable: false,
	      preScanRows: true,
	      selectable: true,
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      selectedRows: this._calculatePreselectedRows(this.props)
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    var newState = {};
	
	    if (this.props.allRowsSelected && !nextProps.allRowsSelected) {
	      newState.selectedRows = this.state.selectedRows.length > 0 ? [this.state.selectedRows[this.state.selectedRows.length - 1]] : [];
	    } else {
	      newState.selectedRows = this._calculatePreselectedRows(nextProps);
	    }
	
	    this.setState(newState);
	  },
	  componentClickAway: function componentClickAway() {
	    if (this.props.deselectOnClickaway && this.state.selectedRows.length) {
	      this.setState({ selectedRows: [] });
	      if (this.props.onRowSelection) this.props.onRowSelection([]);
	    }
	  },
	  _createRows: function _createRows() {
	    var _this = this;
	
	    var numChildren = _react2.default.Children.count(this.props.children);
	    var rowNumber = 0;
	    var handlers = {
	      onCellClick: this._onCellClick,
	      onCellHover: this._onCellHover,
	      onCellHoverExit: this._onCellHoverExit,
	      onRowHover: this._onRowHover,
	      onRowHoverExit: this._onRowHoverExit,
	      onRowClick: this._onRowClick
	    };
	
	    return _react2.default.Children.map(this.props.children, function (child) {
	      if (_react2.default.isValidElement(child)) {
	        var _ret = function () {
	          var props = {
	            displayRowCheckbox: _this.props.displayRowCheckbox,
	            hoverable: _this.props.showRowHover,
	            selected: _this._isRowSelected(rowNumber),
	            striped: _this.props.stripedRows && rowNumber % 2 === 0,
	            rowNumber: rowNumber++
	          };
	          var checkboxColumn = _this._createRowCheckboxColumn(props);
	
	          if (rowNumber === numChildren) {
	            props.displayBorder = false;
	          }
	
	          var children = [checkboxColumn];
	          _react2.default.Children.forEach(child.props.children, function (child) {
	            children.push(child);
	          });
	
	          return {
	            v: _react2.default.cloneElement(child, _extends({}, props, handlers), children)
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	    });
	  },
	  _createRowCheckboxColumn: function _createRowCheckboxColumn(rowProps) {
	    if (!this.props.displayRowCheckbox) return null;
	
	    var key = rowProps.rowNumber + '-cb';
	    var checkbox = _react2.default.createElement(_checkbox2.default, {
	      ref: 'rowSelectCB',
	      name: key,
	      value: 'selected',
	      disabled: !this.props.selectable,
	      checked: rowProps.selected
	    });
	
	    return _react2.default.createElement(
	      _tableRowColumn2.default,
	      {
	        key: key,
	        columnNumber: 0,
	        style: { width: 24 }
	      },
	      checkbox
	    );
	  },
	  _calculatePreselectedRows: function _calculatePreselectedRows(props) {
	    // Determine what rows are 'pre-selected'.
	    var preSelectedRows = [];
	
	    if (props.selectable && props.preScanRows) {
	      (function () {
	        var index = 0;
	        _react2.default.Children.forEach(props.children, function (child) {
	          if (_react2.default.isValidElement(child)) {
	            if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	              preSelectedRows.push(index);
	            }
	
	            index++;
	          }
	        });
	      })();
	    }
	
	    return preSelectedRows;
	  },
	  _isRowSelected: function _isRowSelected(rowNumber) {
	    if (this.props.allRowsSelected) {
	      return true;
	    }
	
	    for (var i = 0; i < this.state.selectedRows.length; i++) {
	      var selection = this.state.selectedRows[i];
	
	      if ((typeof selection === 'undefined' ? 'undefined' : _typeof(selection)) === 'object') {
	        if (this._isValueInRange(rowNumber, selection)) return true;
	      } else {
	        if (selection === rowNumber) return true;
	      }
	    }
	
	    return false;
	  },
	  _isValueInRange: function _isValueInRange(value, range) {
	    if (!range) return false;
	
	    if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	      return true;
	    }
	
	    return false;
	  },
	  _onRowClick: function _onRowClick(e, rowNumber) {
	    e.stopPropagation();
	
	    if (this.props.selectable) {
	      // Prevent text selection while selecting rows.
	      window.getSelection().removeAllRanges();
	      this._processRowSelection(e, rowNumber);
	    }
	  },
	  _processRowSelection: function _processRowSelection(e, rowNumber) {
	    var selectedRows = this.state.selectedRows;
	
	    if (e.shiftKey && this.props.multiSelectable && selectedRows.length) {
	      var lastIndex = selectedRows.length - 1;
	      var lastSelection = selectedRows[lastIndex];
	
	      if ((typeof lastSelection === 'undefined' ? 'undefined' : _typeof(lastSelection)) === 'object') {
	        lastSelection.end = rowNumber;
	      } else {
	        selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	      }
	    } else if ((e.ctrlKey && !e.metaKey || e.metaKey && !e.ctrlKey) && this.props.multiSelectable) {
	      var idx = selectedRows.indexOf(rowNumber);
	      if (idx < 0) {
	        var foundRange = false;
	        for (var i = 0; i < selectedRows.length; i++) {
	          var range = selectedRows[i];
	          if ((typeof range === 'undefined' ? 'undefined' : _typeof(range)) !== 'object') continue;
	
	          if (this._isValueInRange(rowNumber, range)) {
	            var _selectedRows;
	
	            foundRange = true;
	            var values = this._splitRange(range, rowNumber);
	            (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat(_toConsumableArray(values)));
	          }
	        }
	
	        if (!foundRange) selectedRows.push(rowNumber);
	      } else {
	        selectedRows.splice(idx, 1);
	      }
	    } else {
	      if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	        selectedRows = [];
	      } else {
	        selectedRows = [rowNumber];
	      }
	    }
	
	    this.setState({ selectedRows: selectedRows });
	    if (this.props.onRowSelection) this.props.onRowSelection(this._flattenRanges(selectedRows));
	  },
	  _splitRange: function _splitRange(range, splitPoint) {
	    var splitValues = [];
	    var startOffset = range.start - splitPoint;
	    var endOffset = range.end - splitPoint;
	
	    // Process start half
	    splitValues.push.apply(splitValues, _toConsumableArray(this._genRangeOfValues(splitPoint, startOffset)));
	
	    // Process end half
	    splitValues.push.apply(splitValues, _toConsumableArray(this._genRangeOfValues(splitPoint, endOffset)));
	
	    return splitValues;
	  },
	  _genRangeOfValues: function _genRangeOfValues(start, offset) {
	    var values = [];
	    var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	    while (offset !== 0) {
	      values.push(start + offset);
	      offset += dir;
	    }
	
	    return values;
	  },
	  _flattenRanges: function _flattenRanges(selectedRows) {
	    var rows = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = selectedRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var selection = _step.value;
	
	        if ((typeof selection === 'undefined' ? 'undefined' : _typeof(selection)) === 'object') {
	          var values = this._genRangeOfValues(selection.end, selection.start - selection.end);
	          rows.push.apply(rows, [selection.end].concat(_toConsumableArray(values)));
	        } else {
	          rows.push(selection);
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return rows.sort();
	  },
	  _onCellClick: function _onCellClick(e, rowNumber, columnNumber) {
	    e.stopPropagation();
	    if (this.props.onCellClick) this.props.onCellClick(rowNumber, this._getColumnId(columnNumber));
	  },
	  _onCellHover: function _onCellHover(e, rowNumber, columnNumber) {
	    if (this.props.onCellHover) this.props.onCellHover(rowNumber, this._getColumnId(columnNumber));
	    this._onRowHover(e, rowNumber);
	  },
	  _onCellHoverExit: function _onCellHoverExit(e, rowNumber, columnNumber) {
	    if (this.props.onCellHoverExit) this.props.onCellHoverExit(rowNumber, this._getColumnId(columnNumber));
	    this._onRowHoverExit(e, rowNumber);
	  },
	  _onRowHover: function _onRowHover(e, rowNumber) {
	    if (this.props.onRowHover) this.props.onRowHover(rowNumber);
	  },
	  _onRowHoverExit: function _onRowHoverExit(e, rowNumber) {
	    if (this.props.onRowHoverExit) this.props.onRowHoverExit(rowNumber);
	  },
	  _getColumnId: function _getColumnId(columnNumber) {
	    var columnId = columnNumber;
	    if (this.props.displayRowCheckbox) columnId--;
	
	    return columnId;
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	    var rows = this._createRows();
	
	    return _react2.default.createElement(
	      'tbody',
	      { className: className, style: this.prepareStyles(style) },
	      rows
	    );
	  }
	});
	
	exports.default = TableBody;
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tableRowColumn = __webpack_require__(102);
	
	var _tableRowColumn2 = _interopRequireDefault(_tableRowColumn);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TableFooter = _react2.default.createClass({
	  displayName: 'TableFooter',
	
	  propTypes: {
	    /**
	     * Controls whether or not header rows should be adjusted
	     * for a checkbox column. If the select all checkbox is true,
	     * this property will not influence the number of columns.
	     * This is mainly useful for "super header" rows so that
	     * the checkbox column does not create an offset that needs
	     * to be accounted for manually.
	     */
	    adjustForCheckbox: _react2.default.PropTypes.bool,
	    /**
	     * Children passed to table footer.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      adjustForCheckbox: true,
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.tableFooter;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      cell: {
	        borderTop: '1px solid ' + this.getTheme().borderColor,
	        verticalAlign: 'bottom',
	        padding: 20,
	        textAlign: 'left',
	        whiteSpace: 'nowrap'
	      }
	    };
	
	    return styles;
	  },
	  _createRows: function _createRows() {
	    var _this = this;
	
	    var rowNumber = 0;
	    return _react2.default.Children.map(this.props.children, function (child) {
	      return _this._createRow(child, rowNumber++);
	    });
	  },
	  _createRow: function _createRow(child, rowNumber) {
	    var styles = this.getStyles();
	    var props = {
	      displayBorder: false,
	      key: 'f-' + rowNumber,
	      rowNumber: rowNumber,
	      style: this.mergeStyles(styles.cell, child.props.style)
	    };
	
	    var children = [this._getCheckboxPlaceholder(props)];
	    _react2.default.Children.forEach(child.props.children, function (child) {
	      children.push(child);
	    });
	
	    return _react2.default.cloneElement(child, props, children);
	  },
	  _getCheckboxPlaceholder: function _getCheckboxPlaceholder(props) {
	    if (!this.props.adjustForCheckbox) return null;
	
	    var key = 'fpcb' + props.rowNumber;
	    return _react2.default.createElement(_tableRowColumn2.default, { key: key, style: { width: 24 } });
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	    var footerRows = this._createRows();
	
	    return _react2.default.createElement(
	      'tfoot',
	      _extends({ className: className, style: this.prepareStyles(style) }, other),
	      footerRows
	    );
	  }
	});
	
	exports.default = TableFooter;
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkbox = __webpack_require__(91);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _tableHeaderColumn = __webpack_require__(155);
	
	var _tableHeaderColumn2 = _interopRequireDefault(_tableHeaderColumn);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TableHeader = _react2.default.createClass({
	  displayName: 'TableHeader',
	
	  propTypes: {
	    /**
	     * Controls whether or not header rows should be
	     * adjusted for a checkbox column. If the select all
	     * checkbox is true, this property will not influence
	     * the number of columns. This is mainly useful for
	     * "super header" rows so that the checkbox column
	     * does not create an offset that needs to be accounted
	     * for manually.
	     */
	    adjustForCheckbox: _react2.default.PropTypes.bool,
	
	    /**
	     * Children passed to table header.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Controls whether or not the select all checkbox is displayed.
	     */
	    displaySelectAll: _react2.default.PropTypes.bool,
	
	    /**
	     * If set to true, the select all button will be interactable.
	     * If set to false, the button will not be interactable.
	     * To hide the checkbox, set displaySelectAll to false.
	     */
	    enableSelectAll: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback when select all has been checked.
	     */
	    onSelectAll: _react2.default.PropTypes.func,
	
	    /**
	     * True when select all has been checked.
	     */
	    selectAllSelected: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      adjustForCheckbox: true,
	      displaySelectAll: true,
	      enableSelectAll: true,
	      selectAllSelected: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.tableHeader;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        borderBottom: '1px solid ' + this.getTheme().borderColor
	      }
	    };
	
	    return styles;
	  },
	  _createSuperHeaderRows: function _createSuperHeaderRows() {
	    var numChildren = _react2.default.Children.count(this.props.children);
	    if (numChildren === 1) return undefined;
	
	    var superHeaders = [];
	    for (var index = 0; index < numChildren - 1; index++) {
	      var child = this.props.children[index];
	
	      if (!_react2.default.isValidElement(child)) continue;
	
	      var props = {
	        key: 'sh' + index,
	        rowNumber: index
	      };
	      superHeaders.push(this._createSuperHeaderRow(child, props));
	    }
	
	    if (superHeaders.length) return superHeaders;
	  },
	  _createSuperHeaderRow: function _createSuperHeaderRow(child, props) {
	    var children = [];
	    if (this.props.adjustForCheckbox) {
	      children.push(this._getCheckboxPlaceholder(props));
	    }
	    _react2.default.Children.forEach(child.props.children, function (child) {
	      children.push(child);
	    });
	
	    return _react2.default.cloneElement(child, props, children);
	  },
	  _createBaseHeaderRow: function _createBaseHeaderRow() {
	    var numChildren = _react2.default.Children.count(this.props.children);
	    var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	    var props = {
	      key: 'h' + numChildren,
	      rowNumber: numChildren
	    };
	
	    var children = [this._getSelectAllCheckboxColumn(props)];
	    _react2.default.Children.forEach(child.props.children, function (child) {
	      children.push(child);
	    });
	
	    return _react2.default.cloneElement(child, props, children);
	  },
	  _getCheckboxPlaceholder: function _getCheckboxPlaceholder(props) {
	    if (!this.props.adjustForCheckbox) return null;
	
	    var key = 'hpcb' + props.rowNumber;
	    return _react2.default.createElement(_tableHeaderColumn2.default, { key: key, style: { width: 24 } });
	  },
	  _getSelectAllCheckboxColumn: function _getSelectAllCheckboxColumn(props) {
	    if (!this.props.displaySelectAll) return this._getCheckboxPlaceholder(props);
	
	    var checkbox = _react2.default.createElement(_checkbox2.default, {
	      key: 'selectallcb',
	      name: 'selectallcb',
	      value: 'selected',
	      disabled: !this.props.enableSelectAll,
	      checked: this.props.selectAllSelected,
	      onCheck: this._onSelectAll
	    });
	
	    var key = 'hpcb' + props.rowNumber;
	    return _react2.default.createElement(
	      _tableHeaderColumn2.default,
	      { key: key, style: { width: 24 } },
	      checkbox
	    );
	  },
	  _onSelectAll: function _onSelectAll(e, checked) {
	    if (this.props.onSelectAll) this.props.onSelectAll(checked);
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	    var superHeaderRows = this._createSuperHeaderRows();
	    var baseHeaderRow = this._createBaseHeaderRow();
	
	    return _react2.default.createElement(
	      'thead',
	      { className: className, style: this.prepareStyles(this.getStyles().root, style) },
	      superHeaderRows,
	      baseHeaderRow
	    );
	  }
	});
	
	exports.default = TableHeader;
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TableRow = _react2.default.createClass({
	  displayName: 'TableRow',
	
	  propTypes: {
	    /**
	     * Children passed to table row.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * If true, row border will be displayed for the row.
	     * If false, no border will be drawn.
	     */
	    displayBorder: _react2.default.PropTypes.bool,
	
	    /**
	     * Controls whether or not the row reponseds to hover events.
	     */
	    hoverable: _react2.default.PropTypes.bool,
	
	    /**
	     * Controls whether or not the row should be rendered as being
	     * hovered. This property is evaluated in addition to this.state.hovered
	     * and can be used to synchronize the hovered state with some other
	     * external events.
	     */
	    hovered: _react2.default.PropTypes.bool,
	
	    /**
	     * Called when a row cell is clicked.
	     * rowNumber is the row number and columnId is
	     * the column number or the column key.
	     */
	    onCellClick: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table cell is hovered.
	     * rowNumber is the row number of the hovered row
	     * and columnId is the column number or the column key of the cell.
	     */
	    onCellHover: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table cell is no longer hovered.
	     * rowNumber is the row number of the row and columnId
	     * is the column number or the column key of the cell.
	     */
	    onCellHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Called when row is clicked.
	     */
	    onRowClick: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table row is hovered.
	     * rowNumber is the row number of the hovered row.
	     */
	    onRowHover: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table row is no longer hovered.
	     * rowNumber is the row number of the row that is no longer hovered.
	     */
	    onRowHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Number to identify the row. This property is
	     * automatically populated when used with the TableBody component.
	     */
	    rowNumber: _react2.default.PropTypes.number,
	
	    /**
	     * If true, table rows can be selected. If multiple row
	     * selection is desired, enable multiSelectable.
	     * The default value is true.
	     */
	    selectable: _react2.default.PropTypes.bool,
	
	    /**
	     * Indicates that a particular row is selected.
	     * This property can be used to programmatically select rows.
	     */
	    selected: _react2.default.PropTypes.bool,
	
	    /**
	     * Indicates whether or not the row is striped.
	     */
	    striped: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      displayBorder: true,
	      hoverable: false,
	      hovered: false,
	      selectable: true,
	      selected: false,
	      striped: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      hovered: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.tableRow;
	  },
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var cellBgColor = 'inherit';
	    if (this.props.hovered || this.state.hovered) {
	      cellBgColor = theme.hoverColor;
	    } else if (this.props.selected) {
	      cellBgColor = theme.selectedColor;
	    } else if (this.props.striped) {
	      cellBgColor = theme.stripeColor;
	    }
	
	    var styles = {
	      root: {
	        borderBottom: '1px solid ' + theme.borderColor,
	        color: theme.textColor,
	        height: theme.height
	      },
	      cell: {
	        backgroundColor: cellBgColor
	      }
	    };
	
	    if (!this.props.displayBorder) {
	      styles.root.borderBottom = '';
	    }
	
	    return styles;
	  },
	  _createColumns: function _createColumns() {
	    var _this = this;
	
	    var columnNumber = 1;
	    return _react2.default.Children.map(this.props.children, function (child) {
	      if (_react2.default.isValidElement(child)) {
	        return _this._createColumn(child, columnNumber++);
	      }
	    });
	  },
	  _createColumn: function _createColumn(child, columnNumber) {
	    var key = this.props.rowNumber + '-' + columnNumber;
	    var styles = this.getStyles();
	    var handlers = {
	      onClick: this._onCellClick,
	      onHover: this._onCellHover,
	      onHoverExit: this._onCellHoverExit
	    };
	
	    return _react2.default.cloneElement(child, _extends({
	      columnNumber: columnNumber,
	      hoverable: this.props.hoverable,
	      key: child.props.key || key,
	      style: this.mergeStyles(styles.cell, child.props.style)
	    }, handlers));
	  },
	  _onRowClick: function _onRowClick(e) {
	    if (this.props.selectable && this.props.onRowClick) this.props.onRowClick(e, this.props.rowNumber);
	  },
	  _onRowHover: function _onRowHover(e) {
	    if (this.props.onRowHover) this.props.onRowHover(e, this.props.rowNumber);
	  },
	  _onRowHoverExit: function _onRowHoverExit(e) {
	    if (this.props.onRowHoverExit) this.props.onRowHoverExit(e, this.props.rowNumber);
	  },
	  _onCellClick: function _onCellClick(e, columnIndex) {
	    if (this.props.selectable && this.props.onCellClick) this.props.onCellClick(e, this.props.rowNumber, columnIndex);
	    e.ctrlKey = true;
	    this._onRowClick(e);
	  },
	  _onCellHover: function _onCellHover(e, columnIndex) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: true });
	      if (this.props.onCellHover) this.props.onCellHover(e, this.props.rowNumber, columnIndex);
	      this._onRowHover(e);
	    }
	  },
	  _onCellHoverExit: function _onCellHoverExit(e, columnIndex) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: false });
	      if (this.props.onCellHoverExit) this.props.onCellHoverExit(e, this.props.rowNumber, columnIndex);
	      this._onRowHoverExit(e);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var displayBorder = _props.displayBorder;
	    var hoverable = _props.hoverable;
	    var onCellClick = _props.onCellClick;
	    var onCellHover = _props.onCellHover;
	    var onCellHoverExit = _props.onCellHoverExit;
	    var onRowClick = _props.onRowClick;
	    var onRowHover = _props.onRowHover;
	    var onRowHoverExit = _props.onRowHoverExit;
	    var rowNumber = _props.rowNumber;
	    var selectable = _props.selectable;
	    var selected = _props.selected;
	    var striped = _props.striped;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'displayBorder', 'hoverable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	
	    var rowColumns = this._createColumns();
	
	    return _react2.default.createElement(
	      'tr',
	      _extends({
	        className: className,
	        style: this.prepareStyles(this.getStyles().root, style)
	      }, other),
	      rowColumns
	    );
	  }
	});
	
	exports.default = TableRow;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Table = _react2.default.createClass({
	  displayName: 'Table',
	
	  propTypes: {
	    /**
	     * Set to true to indicate that all rows should be selected.
	     */
	    allRowsSelected: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the body's table element.
	     */
	    bodyStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Children passed to table.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * If true, the footer will appear fixed below the table.
	     * The default value is true.
	     */
	    fixedFooter: _react2.default.PropTypes.bool,
	
	    /**
	     * If true, the header will appear fixed above the table.
	     * The default value is true.
	     */
	    fixedHeader: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the footer's table element.
	     */
	    footerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the header's table element.
	     */
	    headerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * The height of the table.
	     */
	    height: _react2.default.PropTypes.string,
	
	    /**
	     * If true, multiple table rows can be selected.
	     * CTRL/CMD+Click and SHIFT+Click are valid actions.
	     * The default value is false.
	     */
	    multiSelectable: _react2.default.PropTypes.bool,
	
	    /**
	     * Called when a row cell is clicked.
	     * rowNumber is the row number and columnId is
	     * the column number or the column key.
	     */
	    onCellClick: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table cell is hovered.
	     * rowNumber is the row number of the hovered row
	     * and columnId is the column number or the column key of the cell.
	     */
	    onCellHover: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table cell is no longer hovered.
	     * rowNumber is the row number of the row and columnId
	     * is the column number or the column key of the cell.
	     */
	    onCellHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table row is hovered.
	     * rowNumber is the row number of the hovered row.
	     */
	    onRowHover: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a table row is no longer hovered.
	     * rowNumber is the row number of the row that is no longer hovered.
	     */
	    onRowHoverExit: _react2.default.PropTypes.func,
	
	    /**
	     * Called when a row is selected.
	     * selectedRows is an array of all row selections.
	     * IF all rows have been selected, the string "all"
	     * will be returned instead to indicate that all rows have been selected.
	     */
	    onRowSelection: _react2.default.PropTypes.func,
	
	    /**
	     * If true, table rows can be selected.
	     * If multiple row selection is desired, enable multiSelectable.
	     * The default value is true.
	     */
	    selectable: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the table's wrapper element.
	     */
	    wrapperStyle: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      allRowsSelected: false,
	      fixedFooter: true,
	      fixedHeader: true,
	      height: 'inherit',
	      multiSelectable: false,
	      selectable: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      allRowsSelected: this.props.allRowsSelected
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.table;
	  },
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        backgroundColor: this.getTheme().backgroundColor,
	        padding: '0 ' + this.state.muiTheme.rawTheme.spacing.desktopGutter + 'px',
	        width: '100%',
	        borderCollapse: 'collapse',
	        borderSpacing: 0,
	        tableLayout: 'fixed',
	        fontFamily: this.state.muiTheme.rawTheme.fontFamily
	      },
	      bodyTable: {
	        height: this.props.fixedHeader || this.props.fixedFooter ? this.props.height : 'auto',
	        overflowX: 'hidden',
	        overflowY: 'auto'
	      },
	      tableWrapper: {
	        height: this.props.fixedHeader || this.props.fixedFooter ? 'auto' : this.props.height,
	        overflow: 'auto'
	      }
	    };
	
	    return styles;
	  },
	  isScrollbarVisible: function isScrollbarVisible() {
	    var tableDivHeight = _reactDom2.default.findDOMNode(this.refs.tableDiv).clientHeight;
	    var tableBodyHeight = _reactDom2.default.findDOMNode(this.refs.tableBody).clientHeight;
	
	    return tableBodyHeight > tableDivHeight;
	  },
	  _createTableHeader: function _createTableHeader(base) {
	    return _react2.default.cloneElement(base, {
	      enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	      onSelectAll: this._onSelectAll,
	      selectAllSelected: this.state.allRowsSelected
	    });
	  },
	  _createTableBody: function _createTableBody(base) {
	    return _react2.default.cloneElement(base, {
	      allRowsSelected: this.state.allRowsSelected,
	      multiSelectable: this.props.multiSelectable,
	      onCellClick: this._onCellClick,
	      onCellHover: this._onCellHover,
	      onCellHoverExit: this._onCellHoverExit,
	      onRowHover: this._onRowHover,
	      onRowHoverExit: this._onRowHoverExit,
	      onRowSelection: this._onRowSelection,
	      selectable: this.props.selectable,
	      style: this.mergeStyles({ height: this.props.height }, base.props.style)
	    });
	  },
	  _createTableFooter: function _createTableFooter(base) {
	    return base;
	  },
	  _onCellClick: function _onCellClick(rowNumber, columnNumber) {
	    if (this.props.onCellClick) this.props.onCellClick(rowNumber, columnNumber);
	  },
	  _onCellHover: function _onCellHover(rowNumber, columnNumber) {
	    if (this.props.onCellHover) this.props.onCellHover(rowNumber, columnNumber);
	  },
	  _onCellHoverExit: function _onCellHoverExit(rowNumber, columnNumber) {
	    if (this.props.onCellHoverExit) this.props.onCellHoverExit(rowNumber, columnNumber);
	  },
	  _onRowHover: function _onRowHover(rowNumber) {
	    if (this.props.onRowHover) this.props.onRowHover(rowNumber);
	  },
	  _onRowHoverExit: function _onRowHoverExit(rowNumber) {
	    if (this.props.onRowHoverExit) this.props.onRowHoverExit(rowNumber);
	  },
	  _onRowSelection: function _onRowSelection(selectedRows) {
	    if (this.state.allRowsSelected) this.setState({ allRowsSelected: false });
	    if (this.props.onRowSelection) this.props.onRowSelection(selectedRows);
	  },
	  _onSelectAll: function _onSelectAll() {
	    if (this.props.onRowSelection) {
	      if (!this.state.allRowsSelected) {
	        this.props.onRowSelection('all');
	      } else {
	        this.props.onRowSelection('none');
	      }
	    }
	
	    this.setState({ allRowsSelected: !this.state.allRowsSelected });
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	    var fixedFooter = _props.fixedFooter;
	    var fixedHeader = _props.fixedHeader;
	    var style = _props.style;
	    var wrapperStyle = _props.wrapperStyle;
	    var headerStyle = _props.headerStyle;
	    var bodyStyle = _props.bodyStyle;
	    var footerStyle = _props.footerStyle;
	
	    var other = _objectWithoutProperties(_props, ['children', 'className', 'fixedFooter', 'fixedHeader', 'style', 'wrapperStyle', 'headerStyle', 'bodyStyle', 'footerStyle']);
	
	    var styles = this.getStyles();
	
	    var tHead = undefined;
	    var tFoot = undefined;
	    var tBody = undefined;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (!_react2.default.isValidElement(child)) return;
	
	      var displayName = child.type.displayName;
	      if (displayName === 'TableBody') {
	        tBody = _this._createTableBody(child);
	      } else if (displayName === 'TableHeader') {
	        tHead = _this._createTableHeader(child);
	      } else if (displayName === 'TableFooter') {
	        tFoot = _this._createTableFooter(child);
	      }
	    });
	
	    // If we could not find a table-header and a table-body, do not attempt to display anything.
	    if (!tBody && !tHead) return null;
	
	    var mergedTableStyle = this.mergeStyles(styles.root, style);
	    var headerTable = undefined;
	    var footerTable = undefined;
	    var inlineHeader = undefined;
	    var inlineFooter = undefined;
	
	    if (fixedHeader) {
	      headerTable = _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(headerStyle) },
	        _react2.default.createElement(
	          'table',
	          { className: className, style: mergedTableStyle },
	          tHead
	        )
	      );
	    } else {
	      inlineHeader = tHead;
	    }
	
	    if (tFoot !== undefined) {
	      if (fixedFooter) {
	        footerTable = _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(footerStyle) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: this.prepareStyles(mergedTableStyle) },
	            tFoot
	          )
	        );
	      } else {
	        inlineFooter = tFoot;
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(styles.tableWrapper, wrapperStyle) },
	      headerTable,
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.bodyTable, bodyStyle), ref: 'tableDiv' },
	        _react2.default.createElement(
	          'table',
	          { className: className, style: mergedTableStyle, ref: 'tableBody' },
	          inlineHeader,
	          inlineFooter,
	          tBody
	        )
	      ),
	      footerTable
	    );
	  }
	});
	
	exports.default = Table;
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _enhancedButton = __webpack_require__(29);
	
	var _enhancedButton2 = _interopRequireDefault(_enhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tab = _react2.default.createClass({
	  displayName: 'Tab',
	
	  propTypes: {
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	     */
	    icon: _react2.default.PropTypes.node,
	
	    /**
	     * Sets the text value of the tab item to the string specified.
	     */
	    label: _react2.default.PropTypes.node,
	
	    /**
	     * Fired when the active tab changes by touch or tap.
	     * Use this event to specify any functionality when an active tab changes.
	     * For example - we are using this to route to home when the third tab becomes active.
	     * This function will always recieve the active tab as it\'s first argument.
	     */
	    onActive: _react2.default.PropTypes.func,
	
	    /**
	     * This property is overriden by the Tabs component.
	     */
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * Defines if the current tab is selected or not.
	     * The Tabs component is responsible for setting this property.
	     */
	    selected: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * If value prop passed to Tabs component, this value prop is also required.
	     * It assigns a value to the tab so that it can be selected by the Tabs.
	     */
	    value: _react2.default.PropTypes.any,
	
	    /**
	     * This property is overriden by the Tabs component.
	     */
	    width: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  _handleTouchTap: function _handleTouchTap(event) {
	    if (this.props.onTouchTap) {
	      this.props.onTouchTap(this.props.value, event, this);
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	    var onActive = _props.onActive;
	    var onTouchTap = _props.onTouchTap;
	    var selected = _props.selected;
	    var style = _props.style;
	    var value = _props.value;
	    var width = _props.width;
	    var icon = _props.icon;
	
	    var other = _objectWithoutProperties(_props, ['label', 'onActive', 'onTouchTap', 'selected', 'style', 'value', 'width', 'icon']);
	
	    var textColor = selected ? this.state.muiTheme.tabs.selectedTextColor : this.state.muiTheme.tabs.textColor;
	
	    var styles = this.mergeStyles({
	      padding: '0px 12px',
	      height: label && icon ? 72 : 48,
	      color: textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: width,
	      textTransform: 'uppercase'
	    }, style);
	
	    var iconElement = undefined;
	    if (icon && _react2.default.isValidElement(icon)) {
	      var params = {
	        style: {
	          fontSize: 24,
	          marginBottom: label ? 5 : 0,
	          display: label ? 'block' : 'inline-block',
	          color: textColor
	        }
	      };
	      // If it's svg icon set color via props
	      if (icon.type.displayName !== 'FontIcon') {
	        params.color = textColor;
	      }
	      iconElement = _react2.default.cloneElement(icon, params);
	    }
	
	    var rippleColor = styles.color;
	    var rippleOpacity = 0.3;
	
	    return _react2.default.createElement(
	      _enhancedButton2.default,
	      _extends({}, other, {
	        style: styles,
	        focusRippleColor: rippleColor,
	        touchRippleColor: rippleColor,
	        focusRippleOpacity: rippleOpacity,
	        touchRippleOpacity: rippleOpacity,
	        onTouchTap: this._handleTouchTap
	      }),
	      iconElement,
	      label
	    );
	  }
	});
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabTemplate = function (_React$Component) {
	  _inherits(TabTemplate, _React$Component);
	
	  function TabTemplate() {
	    _classCallCheck(this, TabTemplate);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(TabTemplate).apply(this, arguments));
	  }
	
	  _createClass(TabTemplate, [{
	    key: 'render',
	    value: function render() {
	      var styles = {
	        height: 0,
	        overflow: 'hidden',
	        width: '100%',
	        position: 'relative',
	        textAlign: 'initial'
	      };
	
	      if (this.props.selected) {
	        delete styles.height;
	        delete styles.overflow;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TabTemplate;
	}(_react2.default.Component);
	
	TabTemplate.propTypes = {
	  children: _react2.default.PropTypes.node,
	  selected: _react2.default.PropTypes.bool
	};
	exports.default = TabTemplate;
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _tabTemplate = __webpack_require__(309);
	
	var _tabTemplate2 = _interopRequireDefault(_tabTemplate);
	
	var _inkBar = __webpack_require__(267);
	
	var _inkBar2 = _interopRequireDefault(_inkBar);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _warning = __webpack_require__(10);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tabs = _react2.default.createClass({
	  displayName: 'Tabs',
	
	  propTypes: {
	    /**
	     * Should be used to pass `Tab` components.
	     */
	    children: _react2.default.PropTypes.node,
	
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * The css class name of the content's container.
	     */
	    contentContainerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the content's container.
	     */
	    contentContainerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Specify initial visible tab index.
	     * Initial selected index is set by default to 0.
	     * If initialSelectedIndex is set but larger than the total amount of specified tabs,
	     * initialSelectedIndex will revert back to default.
	     */
	    initialSelectedIndex: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the InkBar.
	     */
	    inkBarStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Called when the selected value change.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of the tab-labels container.
	     */
	    tabItemContainerStyle: _react2.default.PropTypes.object,
	
	    /**
	     * Override the default tab template used to wrap the content of each tab element.
	     */
	    tabTemplate: _react2.default.PropTypes.func,
	
	    /**
	     * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	     */
	    value: _react2.default.PropTypes.any
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialSelectedIndex: 0,
	      onChange: function onChange() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    var valueLink = this.getValueLink(this.props);
	    var initialIndex = this.props.initialSelectedIndex;
	
	    return {
	      selectedIndex: valueLink.value !== undefined ? this._getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps, nextContext) {
	    var valueLink = this.getValueLink(newProps);
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	
	    if (valueLink.value !== undefined) {
	      this.setState({ selectedIndex: this._getSelectedIndex(newProps) });
	    }
	
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getEvenWidth: function getEvenWidth() {
	    return parseInt(window.getComputedStyle(_reactDom2.default.findDOMNode(this)).getPropertyValue('width'), 10);
	  },
	  getTabCount: function getTabCount() {
	    return _react2.default.Children.count(this.props.children);
	  },
	
	  // Do not use outside of this component, it will be removed once valueLink is deprecated
	  getValueLink: function getValueLink(props) {
	    return props.valueLink || {
	      value: props.value,
	      requestChange: props.onChange
	    };
	  },
	  _getSelectedIndex: function _getSelectedIndex(props) {
	    var valueLink = this.getValueLink(props);
	    var selectedIndex = -1;
	
	    _react2.default.Children.forEach(props.children, function (tab, index) {
	      if (valueLink.value === tab.props.value) {
	        selectedIndex = index;
	      }
	    });
	
	    return selectedIndex;
	  },
	  _handleTabTouchTap: function _handleTabTouchTap(value, e, tab) {
	    var valueLink = this.getValueLink(this.props);
	    var tabIndex = tab.props.tabIndex;
	
	    if (valueLink.value && valueLink.value !== value || this.state.selectedIndex !== tabIndex) {
	      valueLink.requestChange(value, e, tab);
	    }
	
	    this.setState({ selectedIndex: tabIndex });
	
	    if (tab.props.onActive) {
	      tab.props.onActive(tab);
	    }
	  },
	  _getSelected: function _getSelected(tab, index) {
	    var valueLink = this.getValueLink(this.props);
	    return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var contentContainerClassName = _props.contentContainerClassName;
	    var contentContainerStyle = _props.contentContainerStyle;
	    var initialSelectedIndex = _props.initialSelectedIndex;
	    var inkBarStyle = _props.inkBarStyle;
	    var style = _props.style;
	    var tabItemContainerStyle = _props.tabItemContainerStyle;
	    var tabTemplate = _props.tabTemplate;
	
	    var other = _objectWithoutProperties(_props, ['children', 'contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'style', 'tabItemContainerStyle', 'tabTemplate']);
	
	    var themeVariables = this.state.muiTheme.tabs;
	    var styles = {
	      tabItemContainer: {
	        margin: 0,
	        padding: 0,
	        width: '100%',
	        backgroundColor: themeVariables.backgroundColor,
	        whiteSpace: 'nowrap'
	      }
	    };
	
	    var valueLink = this.getValueLink(this.props);
	    var tabValue = valueLink.value;
	    var tabContent = [];
	
	    var width = 100 / this.getTabCount();
	
	    var tabs = _react2.default.Children.map(children, function (tab, index) {
	       false ? (0, _warning2.default)(tab.type && tab.type.displayName === 'Tab', 'Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.displayName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : undefined;
	
	       false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : undefined;
	
	      tabContent.push(tab.props.children ? _react2.default.createElement(tabTemplate || _tabTemplate2.default, {
	        key: index,
	        selected: _this._getSelected(tab, index)
	      }, tab.props.children) : undefined);
	
	      return _react2.default.cloneElement(tab, {
	        key: index,
	        selected: _this._getSelected(tab, index),
	        tabIndex: index,
	        width: width + '%',
	        onTouchTap: _this._handleTabTouchTap
	      });
	    });
	
	    var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_inkBar2.default, {
	      left: width * this.state.selectedIndex + '%',
	      width: width + '%',
	      style: inkBarStyle
	    }) : null;
	
	    var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, {
	        style: this.prepareStyles(style)
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.tabItemContainer, tabItemContainerStyle) },
	        tabs
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { width: inkBarContainerWidth } },
	        inkBar
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: this.prepareStyles(contentContainerStyle),
	          className: contentContainerClassName
	        },
	        tabContent
	      )
	    );
	  }
	});
	
	exports.default = Tabs;
	module.exports = exports['default'];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'theme-wrapper',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    theme: _react2.default.PropTypes.object.isRequired
	  },
	
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.props.theme
	    };
	  },
	  render: function render() {
	    return this.props.children;
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _clockNumber = __webpack_require__(156);
	
	var _clockNumber2 = _interopRequireDefault(_clockNumber);
	
	var _clockPointer = __webpack_require__(157);
	
	var _clockPointer2 = _interopRequireDefault(_clockPointer);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(e) {
	  var el = e.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  var offset = {
	    offsetX: e.clientX - boundingRect.left,
	    offsetY: e.clientY - boundingRect.top
	  };
	
	  return offset;
	}
	
	var ClockHours = _react2.default.createClass({
	  displayName: 'ClockHours',
	
	  propTypes: {
	    format: _react2.default.PropTypes.oneOf(['ampm', '24hr']),
	    initialHours: _react2.default.PropTypes.number,
	    onChange: _react2.default.PropTypes.func
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialHours: new Date().getHours(),
	      onChange: function onChange() {},
	      format: 'ampm'
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	    this.center = {
	      x: clockElement.offsetWidth / 2,
	      y: clockElement.offsetHeight / 2
	    };
	
	    this.basePoint = {
	      x: this.center.x,
	      y: 0
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	
	  center: { x: 0, y: 0 },
	  basePoint: { x: 0, y: 0 },
	
	  isMousePressed: function isMousePressed(e) {
	    if (typeof e.buttons === 'undefined') {
	      return e.nativeEvent.which;
	    }
	
	    return e.buttons;
	  },
	  handleUp: function handleUp(e) {
	    e.preventDefault();
	    this.setClock(e.nativeEvent, true);
	  },
	  handleMove: function handleMove(e) {
	    e.preventDefault();
	    if (this.isMousePressed(e) !== 1) return;
	    this.setClock(e.nativeEvent, false);
	  },
	  handleTouchMove: function handleTouchMove(e) {
	    e.preventDefault();
	    this.setClock(e.changedTouches[0], false);
	  },
	  handleTouchEnd: function handleTouchEnd(e) {
	    e.preventDefault();
	    this.setClock(e.changedTouches[0], true);
	  },
	  setClock: function setClock(e, finish) {
	    if (typeof e.offsetX === 'undefined') {
	      var offset = getTouchEventOffsetValues(e);
	
	      e.offsetX = offset.offsetX;
	      e.offsetY = offset.offsetY;
	    }
	
	    var hours = this.getHours(e.offsetX, e.offsetY);
	
	    this.props.onChange(hours, finish);
	  },
	  getHours: function getHours(offsetX, offsetY) {
	    var step = 30;
	    var x = offsetX - this.center.x;
	    var y = offsetY - this.center.y;
	    var cx = this.basePoint.x - this.center.x;
	    var cy = this.basePoint.y - this.center.y;
	
	    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	    var deg = rad2deg(atan);
	    deg = Math.round(deg / step) * step;
	    deg %= 360;
	
	    var value = Math.floor(deg / step) || 0;
	
	    var delta = Math.pow(x, 2) + Math.pow(y, 2);
	    var distance = Math.sqrt(delta);
	
	    value = value || 12;
	    if (this.props.format === '24hr') {
	      if (distance < 90) {
	        value += 12;
	        value %= 24;
	      }
	    } else {
	      value %= 12;
	    }
	
	    return value;
	  },
	  _getSelected: function _getSelected() {
	    var hour = this.props.initialHours;
	
	    if (this.props.format === 'ampm') {
	      hour %= 12;
	      hour = hour || 12;
	    }
	
	    return hour;
	  },
	  _getHourNumbers: function _getHourNumbers() {
	    var _this = this;
	
	    var style = {
	      pointerEvents: 'none'
	    };
	    var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	    var hours = [];
	    for (var i = 1; i <= hourSize; i++) {
	      hours.push(i % 24);
	    }
	
	    return hours.map(function (hour) {
	      var isSelected = _this._getSelected() === hour;
	      return _react2.default.createElement(_clockNumber2.default, {
	        key: hour,
	        style: style,
	        isSelected: isSelected,
	        type: 'hour',
	        value: hour
	      });
	    });
	  },
	  render: function render() {
	    var styles = {
	      root: {
	        height: '100%',
	        width: '100%',
	        borderRadius: '100%',
	        position: 'relative',
	        pointerEvents: 'none',
	        boxSizing: 'border-box'
	      },
	
	      hitMask: {
	        height: '100%',
	        width: '100%',
	        pointerEvents: 'auto'
	      }
	    };
	
	    var hours = this._getSelected();
	    var numbers = this._getHourNumbers();
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'clock', style: this.prepareStyles(styles.root) },
	      _react2.default.createElement(_clockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	      numbers,
	      _react2.default.createElement('div', {
	        ref: 'mask', style: this.prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	        onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	      })
	    );
	  }
	});
	
	exports.default = ClockHours;
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _clockNumber = __webpack_require__(156);
	
	var _clockNumber2 = _interopRequireDefault(_clockNumber);
	
	var _clockPointer = __webpack_require__(157);
	
	var _clockPointer2 = _interopRequireDefault(_clockPointer);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(e) {
	  var el = e.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  var offset = {
	    offsetX: e.clientX - boundingRect.left,
	    offsetY: e.clientY - boundingRect.top
	  };
	
	  return offset;
	}
	
	var ClockMinutes = _react2.default.createClass({
	  displayName: 'ClockMinutes',
	
	  propTypes: {
	    initialMinutes: _react2.default.PropTypes.number,
	    onChange: _react2.default.PropTypes.func
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialMinutes: new Date().getMinutes(),
	      onChange: function onChange() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	    this.center = {
	      x: clockElement.offsetWidth / 2,
	      y: clockElement.offsetHeight / 2
	    };
	
	    this.basePoint = {
	      x: this.center.x,
	      y: 0
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	
	  center: { x: 0, y: 0 },
	  basePoint: { x: 0, y: 0 },
	
	  isMousePressed: function isMousePressed(e) {
	    if (typeof e.buttons === 'undefined') {
	      return e.nativeEvent.which;
	    }
	    return e.buttons;
	  },
	  handleUp: function handleUp(e) {
	    e.preventDefault();
	    this.setClock(e.nativeEvent, true);
	  },
	  handleMove: function handleMove(e) {
	    e.preventDefault();
	    if (this.isMousePressed(e) !== 1) return;
	    this.setClock(e.nativeEvent, false);
	  },
	  handleTouch: function handleTouch(e) {
	    e.preventDefault();
	    this.setClock(e.changedTouches[0], false);
	  },
	  setClock: function setClock(e, finish) {
	    if (typeof e.offsetX === 'undefined') {
	      var offset = getTouchEventOffsetValues(e);
	
	      e.offsetX = offset.offsetX;
	      e.offsetY = offset.offsetY;
	    }
	
	    var minutes = this.getMinutes(e.offsetX, e.offsetY);
	
	    this.props.onChange(minutes, finish);
	  },
	  getMinutes: function getMinutes(offsetX, offsetY) {
	    var step = 6;
	    var x = offsetX - this.center.x;
	    var y = offsetY - this.center.y;
	    var cx = this.basePoint.x - this.center.x;
	    var cy = this.basePoint.y - this.center.y;
	
	    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	    var deg = rad2deg(atan);
	    deg = Math.round(deg / step) * step;
	    deg %= 360;
	
	    var value = Math.floor(deg / step) || 0;
	
	    return value;
	  },
	  _getMinuteNumbers: function _getMinuteNumbers() {
	    var minutes = [];
	    for (var i = 0; i < 12; i++) {
	      minutes.push(i * 5);
	    }
	    var selectedMinutes = this.props.initialMinutes;
	    var hasSelected = false;
	
	    var numbers = minutes.map(function (minute) {
	      var isSelected = selectedMinutes === minute;
	      if (isSelected) hasSelected = true;
	      return _react2.default.createElement(_clockNumber2.default, {
	        key: minute, isSelected: isSelected, type: 'minute',
	        value: minute
	      });
	    });
	
	    return {
	      numbers: numbers,
	      hasSelected: hasSelected,
	      selected: selectedMinutes
	    };
	  },
	  render: function render() {
	    var styles = {
	      root: {
	        height: '100%',
	        width: '100%',
	        borderRadius: '100%',
	        position: 'relative',
	        pointerEvents: 'none',
	        boxSizing: 'border-box'
	      },
	
	      hitMask: {
	        height: '100%',
	        width: '100%',
	        pointerEvents: 'auto'
	      }
	    };
	
	    var minutes = this._getMinuteNumbers();
	
	    return _react2.default.createElement(
	      'div',
	      { ref: 'clock', style: this.prepareStyles(styles.root) },
	      _react2.default.createElement(_clockPointer2.default, { value: minutes.selected, type: 'minute' }),
	      minutes.numbers,
	      _react2.default.createElement('div', { ref: 'mask', style: this.prepareStyles(styles.hitMask), hasSelected: minutes.hasSelected,
	        onTouchMove: this.handleTouch, onTouchEnd: this.handleTouch,
	        onMouseUp: this.handleUp, onMouseMove: this.handleMove
	      })
	    );
	  }
	});
	
	exports.default = ClockMinutes;
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _timeDisplay = __webpack_require__(316);
	
	var _timeDisplay2 = _interopRequireDefault(_timeDisplay);
	
	var _clockHours = __webpack_require__(312);
	
	var _clockHours2 = _interopRequireDefault(_clockHours);
	
	var _clockMinutes = __webpack_require__(313);
	
	var _clockMinutes2 = _interopRequireDefault(_clockMinutes);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = _react2.default.createClass({
	  displayName: 'Clock',
	
	  propTypes: {
	    format: _react2.default.PropTypes.oneOf(['ampm', '24hr']),
	    initialTime: _react2.default.PropTypes.object,
	    isActive: _react2.default.PropTypes.bool,
	    mode: _react2.default.PropTypes.oneOf(['hour', 'minute']),
	    onChangeHours: _react2.default.PropTypes.func,
	    onChangeMinutes: _react2.default.PropTypes.func
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialTime: new Date()
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)(),
	      selectedTime: this.props.initialTime,
	      mode: 'hour'
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({
	      muiTheme: newMuiTheme,
	      selectedTime: nextProps.initialTime
	    });
	  },
	  _setMode: function _setMode(mode) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.setState({
	        mode: mode
	      });
	    }, 100);
	  },
	  _setAffix: function _setAffix(affix) {
	    if (affix === this._getAffix()) return;
	
	    var hours = this.state.selectedTime.getHours();
	
	    if (affix === 'am') {
	      this.handleChangeHours(hours - 12, affix);
	      return;
	    }
	
	    this.handleChangeHours(hours + 12, affix);
	  },
	  _getAffix: function _getAffix() {
	    if (this.props.format !== 'ampm') return '';
	
	    var hours = this.state.selectedTime.getHours();
	    if (hours < 12) {
	      return 'am';
	    }
	
	    return 'pm';
	  },
	  handleChangeHours: function handleChangeHours(hours, finished) {
	    var _this2 = this;
	
	    var time = new Date(this.state.selectedTime);
	    var affix = undefined;
	
	    if (typeof finished === 'string') {
	      affix = finished;
	      finished = undefined;
	    }
	    if (!affix) {
	      affix = this._getAffix();
	    }
	    if (affix === 'pm' && hours < 12) {
	      hours += 12;
	    }
	
	    time.setHours(hours);
	    this.setState({
	      selectedTime: time
	    });
	
	    var onChangeHours = this.props.onChangeHours;
	
	    if (finished) {
	      setTimeout(function () {
	        _this2.setState({
	          mode: 'minute'
	        });
	        if (typeof onChangeHours === 'function') {
	          onChangeHours(time);
	        }
	      }, 100);
	    }
	  },
	  handleChangeMinutes: function handleChangeMinutes(minutes) {
	    var time = new Date(this.state.selectedTime);
	    time.setMinutes(minutes);
	    this.setState({
	      selectedTime: time
	    });
	
	    var onChangeMinutes = this.props.onChangeMinutes;
	
	    if (typeof onChangeMinutes === 'function') {
	      setTimeout(function () {
	        onChangeMinutes(time);
	      }, 0);
	    }
	  },
	  getSelectedTime: function getSelectedTime() {
	    return this.state.selectedTime;
	  },
	  render: function render() {
	    var clock = null;
	
	    var styles = {
	      root: {},
	
	      container: {
	        height: 280,
	        padding: 10,
	        position: 'relative'
	      },
	
	      circle: {
	        position: 'absolute',
	        top: 20,
	        width: 260,
	        height: 260,
	        borderRadius: '100%',
	        backgroundColor: this.state.muiTheme.timePicker.clockCircleColor
	      }
	    };
	
	    if (this.state.mode === 'hour') {
	      clock = _react2.default.createElement(_clockHours2.default, { key: 'hours',
	        format: this.props.format,
	        onChange: this.handleChangeHours,
	        initialHours: this.state.selectedTime.getHours()
	      });
	    } else {
	      clock = _react2.default.createElement(_clockMinutes2.default, { key: 'minutes',
	        onChange: this.handleChangeMinutes,
	        initialMinutes: this.state.selectedTime.getMinutes()
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(styles.root) },
	      _react2.default.createElement(_timeDisplay2.default, {
	        selectedTime: this.state.selectedTime,
	        mode: this.state.mode,
	        format: this.props.format,
	        affix: this._getAffix(),
	        onSelectAffix: this._setAffix,
	        onSelectHour: this._setMode.bind(this, 'hour'),
	        onSelectMin: this._setMode.bind(this, 'minute')
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.container) },
	        _react2.default.createElement('div', { style: this.prepareStyles(styles.circle) }),
	        clock
	      )
	    );
	  }
	});
	
	exports.default = Clock;
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _timePicker = __webpack_require__(318);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _timePicker2.default;
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TimeDisplay = _react2.default.createClass({
	  displayName: 'TimeDisplay',
	
	  propTypes: {
	    affix: _react2.default.PropTypes.oneOf(['', 'pm', 'am']),
	    format: _react2.default.PropTypes.oneOf(['ampm', '24hr']),
	    mode: _react2.default.PropTypes.oneOf(['hour', 'minute']),
	    onSelectAffix: _react2.default.PropTypes.func,
	    onSelectHour: _react2.default.PropTypes.func,
	    onSelectMin: _react2.default.PropTypes.func,
	    selectedTime: _react2.default.PropTypes.object.isRequired
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      mode: 'hour',
	      affix: ''
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      transitionDirection: 'up',
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var direction = undefined;
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	
	    if (nextProps.selectedTime !== this.props.selectedTime) {
	      direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	      this.setState({
	        transitionDirection: direction
	      });
	    }
	  },
	  sanitizeTime: function sanitizeTime() {
	    var hour = this.props.selectedTime.getHours();
	    var min = this.props.selectedTime.getMinutes().toString();
	
	    if (this.props.format === 'ampm') {
	      hour %= 12;
	      hour = hour || 12;
	    }
	
	    hour = hour.toString();
	    if (hour.length < 2) hour = '0' + hour;
	    if (min.length < 2) min = '0' + min;
	
	    return [hour, min];
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.timePicker;
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var selectedTime = _props.selectedTime;
	    var mode = _props.mode;
	    var affix = _props.affix;
	
	    var other = _objectWithoutProperties(_props, ['selectedTime', 'mode', 'affix']);
	
	    var styles = {
	      root: {
	        position: 'relative',
	        width: 280,
	        height: '100%'
	      },
	
	      box: {
	        padding: '14px 0',
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        backgroundColor: this.getTheme().headerColor,
	        color: 'white'
	      },
	
	      text: {
	        margin: '6px 0',
	        lineHeight: '58px',
	        height: 58,
	        fontSize: 58,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'baseline'
	      },
	
	      time: {
	        margin: '0 10px'
	      },
	
	      affix: {
	        flex: 1,
	        position: 'relative',
	        lineHeight: '17px',
	        height: 17,
	        fontSize: 17
	      },
	
	      affixTop: {
	        position: 'absolute',
	        top: -20,
	        left: 0
	      },
	
	      clickable: {
	        cursor: 'pointer'
	      },
	
	      inactive: {
	        opacity: 0.7
	      }
	    };
	
	    var _sanitizeTime = this.sanitizeTime();
	
	    var _sanitizeTime2 = _slicedToArray(_sanitizeTime, 2);
	
	    var hour = _sanitizeTime2[0];
	    var min = _sanitizeTime2[1];
	
	    var buttons = [];
	    if (this.props.format === 'ampm') {
	      buttons = [_react2.default.createElement(
	        'div',
	        {
	          key: 'pm',
	          style: this.prepareStyles(styles.clickable, affix === 'pm' ? {} : styles.inactive),
	          onTouchTap: function onTouchTap() {
	            return _this.props.onSelectAffix('pm');
	          }
	        },
	        "PM"
	      ), _react2.default.createElement(
	        'div',
	        {
	          key: 'am',
	          style: this.prepareStyles(styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive),
	          onTouchTap: function onTouchTap() {
	            return _this.props.onSelectAffix('am');
	          }
	        },
	        "AM"
	      )];
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(styles.root) }),
	      _react2.default.createElement(
	        'div',
	        { style: this.prepareStyles(styles.box) },
	        _react2.default.createElement(
	          'div',
	          { style: this.prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: this.prepareStyles(styles.affix) }),
	          _react2.default.createElement(
	            'div',
	            { style: this.prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: this.prepareStyles(styles.clickable, mode === 'hour' ? {} : styles.inactive),
	                onTouchTap: this.props.onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: this.prepareStyles(styles.clickable, mode === 'minute' ? {} : styles.inactive),
	                onTouchTap: this.props.onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: this.prepareStyles(styles.affix) },
	            buttons
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = TimeDisplay;
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _clock = __webpack_require__(314);
	
	var _clock2 = _interopRequireDefault(_clock);
	
	var _dialog = __webpack_require__(92);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _flatButton = __webpack_require__(54);
	
	var _flatButton2 = _interopRequireDefault(_flatButton);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TimePickerDialog = _react2.default.createClass({
	  displayName: 'TimePickerDialog',
	
	  propTypes: {
	    autoOk: _react2.default.PropTypes.bool,
	    format: _react2.default.PropTypes.oneOf(['ampm', '24hr']),
	    initialTime: _react2.default.PropTypes.object,
	    onAccept: _react2.default.PropTypes.func,
	    onDismiss: _react2.default.PropTypes.func,
	    onShow: _react2.default.PropTypes.func
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      open: false,
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp'
	  },
	
	  getTheme: function getTheme() {
	    return this.state.muiTheme.timePicker;
	  },
	  show: function show() {
	    if (this.props.onShow && !this.state.open) this.props.onShow();
	    this.setState({
	      open: true
	    });
	  },
	  dismiss: function dismiss() {
	    if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	    this.setState({
	      open: false
	    });
	  },
	  _handleOKTouchTap: function _handleOKTouchTap() {
	    this.dismiss();
	    if (this.props.onAccept) {
	      this.props.onAccept(this.refs.clock.getSelectedTime());
	    }
	  },
	  _handleWindowKeyUp: function _handleWindowKeyUp(event) {
	    if (this.state.open) {
	      switch (event.keyCode) {
	        case _keyCode2.default.ENTER:
	          this._handleOKTouchTap();
	          break;
	      }
	    }
	  },
	  render: function render() {
	    var _props = this.props;
	    var initialTime = _props.initialTime;
	    var onAccept = _props.onAccept;
	    var format = _props.format;
	    var autoOk = _props.autoOk;
	
	    var other = _objectWithoutProperties(_props, ['initialTime', 'onAccept', 'format', 'autoOk']);
	
	    var styles = {
	      root: {
	        fontSize: 14,
	        color: this.getTheme().clockColor
	      },
	      dialogContent: {
	        width: 280
	      },
	      body: {
	        padding: 0
	      }
	    };
	
	    var actions = [_react2.default.createElement(_flatButton2.default, {
	      key: 0,
	      label: 'Cancel',
	      secondary: true,
	      onTouchTap: this.dismiss
	    }), _react2.default.createElement(_flatButton2.default, {
	      key: 1,
	      label: 'OK',
	      secondary: true,
	      onTouchTap: this._handleOKTouchTap
	    })];
	
	    var onClockChangeMinutes = autoOk === true ? this._handleOKTouchTap : undefined;
	
	    return _react2.default.createElement(
	      _dialog2.default,
	      _extends({}, other, {
	        ref: 'dialogWindow',
	        style: this.mergeStyles(styles.root),
	        bodyStyle: styles.body,
	        actions: actions,
	        contentStyle: styles.dialogContent,
	        repositionOnUpdate: false,
	        open: this.state.open,
	        onRequestClose: this.dismiss
	      }),
	      _react2.default.createElement(_clock2.default, {
	        ref: 'clock',
	        format: format,
	        initialTime: initialTime,
	        onChangeMinutes: onClockChangeMinutes
	      })
	    );
	  }
	});
	
	exports.default = TimePickerDialog;
	module.exports = exports['default'];

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _windowListenable = __webpack_require__(23);
	
	var _windowListenable2 = _interopRequireDefault(_windowListenable);
	
	var _timePickerDialog = __webpack_require__(317);
	
	var _timePickerDialog2 = _interopRequireDefault(_timePickerDialog);
	
	var _textField = __webpack_require__(71);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = _react2.default.createClass({
	  displayName: 'TimePicker',
	
	  propTypes: {
	    /**
	     * If true, automatically accept and close the picker on set minutes.
	     */
	    autoOk: _react2.default.PropTypes.bool,
	
	    /**
	     * This is the initial time value of the component.
	     */
	    defaultTime: _react2.default.PropTypes.object,
	
	    /**
	     * Tells the component to display the picker in
	     * ampm (12hr) format or 24hr format.
	     */
	    format: _react2.default.PropTypes.oneOf(['ampm', '24hr']),
	
	    /**
	     * Callback function that is fired when the time
	     * value changes. The time value is passed in a Date
	     * Object.Since there is no particular event associated
	     * with the change the first argument will always be null
	     * and the second argument will be the new Date instance.
	     */
	    onChange: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when the timepicker dialog is dismissed.
	     */
	    onDismiss: _react2.default.PropTypes.func,
	
	    /**
	     * Callback function that is fired when the timepicker field gains focus.
	     */
	    onFocus: _react2.default.PropTypes.func,
	
	    /**
	     * Fired when the timepicker dialog is shown.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * Callback for touch tap event.
	     */
	    onTouchTap: _react2.default.PropTypes.func,
	
	    /**
	     * It's technically more correct to refer to
	     * "12 noon" and "12 midnight" rather than
	     * "12 a.m." and "12 p.m." and it avoids real
	     * confusion between different locales. By default
	     * (for compatibility reasons) TimePicker uses
	     * (12 a.m./12 p.m.) To use (noon/midnight) set pedantic={true}.
	     */
	    pedantic: _react2.default.PropTypes.bool,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * Override the inline-styles of TimePicker's TextField element.
	     */
	    textFieldStyle: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default, _windowListenable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultTime: null,
	      format: 'ampm',
	      pedantic: false,
	      autoOk: false,
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      time: this.props.defaultTime || emptyTime,
	      dialogTime: new Date(),
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	
	  windowListeners: {
	    'keyup': '_handleWindowKeyUp'
	  },
	
	  formatTime: function formatTime(date) {
	    var hours = date.getHours();
	    var mins = date.getMinutes().toString();
	
	    if (this.props.format === 'ampm') {
	      var isAM = hours < 12;
	      hours = hours % 12;
	      var additional = isAM ? ' am' : ' pm';
	      hours = (hours || 12).toString();
	
	      if (mins.length < 2) mins = '0' + mins;
	
	      if (this.props.pedantic) {
	        // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	        if (hours === '12' && mins === '00') {
	          return additional === ' pm' ? '12 noon' : '12 midnight';
	        }
	      }
	
	      return hours + (mins === '00' ? '' : ':' + mins) + additional;
	    }
	
	    hours = hours.toString();
	
	    if (hours.length < 2) hours = '0' + hours;
	    if (mins.length < 2) mins = '0' + mins;
	
	    return hours + ':' + mins;
	  },
	  getTime: function getTime() {
	    return this.state.time;
	  },
	  setTime: function setTime(time) {
	    this.setState({ time: time ? time : emptyTime });
	  },
	
	  /**
	   * Alias for `openDialog()` for an api consistent with TextField.
	   */
	  focus: function focus() {
	    this.openDialog();
	  },
	  openDialog: function openDialog() {
	    this.setState({
	      dialogTime: this.getTime()
	    });
	
	    this.refs.dialogWindow.show();
	  },
	  _handleDialogAccept: function _handleDialogAccept(t) {
	    this.setTime(t);
	    if (this.props.onChange) this.props.onChange(null, t);
	  },
	  _handleInputFocus: function _handleInputFocus(e) {
	    e.target.blur();
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	  _handleInputTouchTap: function _handleInputTouchTap(e) {
	    e.preventDefault();
	
	    this.openDialog();
	
	    if (this.props.onTouchTap) this.props.onTouchTap(e);
	  },
	  render: function render() {
	    var _props = this.props;
	    var autoOk = _props.autoOk;
	    var format = _props.format;
	    var onFocus = _props.onFocus;
	    var onTouchTap = _props.onTouchTap;
	    var onShow = _props.onShow;
	    var onDismiss = _props.onDismiss;
	    var style = _props.style;
	    var textFieldStyle = _props.textFieldStyle;
	
	    var other = _objectWithoutProperties(_props, ['autoOk', 'format', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss', 'style', 'textFieldStyle']);
	
	    var time = this.state.time;
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.prepareStyles(style) },
	      _react2.default.createElement(_textField2.default, _extends({}, other, {
	        style: textFieldStyle,
	        ref: 'input',
	        value: time === emptyTime ? null : this.formatTime(time),
	        onFocus: this._handleInputFocus,
	        onTouchTap: this._handleInputTouchTap
	      })),
	      _react2.default.createElement(_timePickerDialog2.default, {
	        ref: 'dialogWindow',
	        initialTime: this.state.dialogTime,
	        onAccept: this._handleDialogAccept,
	        onShow: onShow,
	        onDismiss: onDismiss,
	        format: format,
	        autoOk: autoOk
	      })
	    );
	  }
	});
	
	exports.default = TimePicker;
	module.exports = exports['default'];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ToolbarSeparator = _react2.default.createClass({
	  displayName: 'ToolbarSeparator',
	
	  propTypes: {
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.toolbar;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        backgroundColor: this.getTheme().separatorColor,
	        display: 'inline-block',
	        height: this.getSpacing().desktopGutterMore,
	        marginLeft: this.getSpacing().desktopGutter,
	        position: 'relative',
	        top: (this.getTheme().height - this.getSpacing().desktopGutterMore) / 2,
	        width: 1
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement('span', _extends({}, other, { className: className, style: this.prepareStyles(styles.root, style) }));
	  }
	});
	
	exports.default = ToolbarSeparator;
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ToolbarTitle = _react2.default.createClass({
	  displayName: 'ToolbarTitle',
	
	  propTypes: {
	    /**
	     * The css class name of the root element.
	     */
	    className: _react2.default.PropTypes.string,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object,
	
	    /**
	     * The text to be displayed.
	     */
	    text: _react2.default.PropTypes.string
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  getTheme: function getTheme() {
	    return this.state.muiTheme.toolbar;
	  },
	  getSpacing: function getSpacing() {
	    return this.state.muiTheme.rawTheme.spacing;
	  },
	  getStyles: function getStyles() {
	    return {
	      root: {
	        paddingRight: this.getSpacing().desktopGutterLess,
	        lineHeight: this.getTheme().height + 'px',
	        fontSize: this.getTheme().titleFontSize + 'px',
	        display: 'inline-block',
	        position: 'relative'
	      }
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	    var text = _props.text;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style', 'text']);
	
	    var styles = this.getStyles();
	
	    return _react2.default.createElement(
	      'span',
	      _extends({}, other, { className: className, style: this.prepareStyles(styles.root, style) }),
	      text
	    );
	  }
	});
	
	exports.default = ToolbarTitle;
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ScaleInChild = _react2.default.createClass({
	  displayName: 'ScaleInChild',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    enterDelay: _react2.default.PropTypes.number,
	    maxScale: _react2.default.PropTypes.number,
	    minScale: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0,
	      maxScale: 1,
	      minScale: 0
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentWillAppear: function componentWillAppear(callback) {
	    this._initializeAnimation(callback);
	  },
	  componentWillEnter: function componentWillEnter(callback) {
	    this._initializeAnimation(callback);
	  },
	  componentDidAppear: function componentDidAppear() {
	    this._animate();
	  },
	  componentDidEnter: function componentDidEnter() {
	    this._animate();
	  },
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    var style = _reactDom2.default.findDOMNode(this).style;
	
	    style.opacity = '0';
	    _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')', this.state.muiTheme);
	
	    setTimeout(function () {
	      if (_this.isMounted()) callback();
	    }, 450);
	  },
	  _animate: function _animate() {
	    var style = _reactDom2.default.findDOMNode(this).style;
	
	    style.opacity = '1';
	    _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')', this.state.muiTheme);
	  },
	  _initializeAnimation: function _initializeAnimation(callback) {
	    var _this2 = this;
	
	    var style = _reactDom2.default.findDOMNode(this).style;
	
	    style.opacity = '0';
	    _autoPrefix2.default.set(style, 'transform', 'scale(0)', this.state.muiTheme);
	
	    setTimeout(function () {
	      if (_this2.isMounted()) callback();
	    }, this.props.enterDelay);
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var enterDelay = _props.enterDelay;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'style']);
	
	    var mergedRootStyles = this.mergeStyles({
	      position: 'absolute',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: 0,
	      transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	    }, style);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(mergedRootStyles) }),
	      children
	    );
	  }
	});
	
	exports.default = ScaleInChild;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(9);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _reactAddonsTransitionGroup = __webpack_require__(74);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _scaleInChild = __webpack_require__(321);
	
	var _scaleInChild2 = _interopRequireDefault(_scaleInChild);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ScaleIn = _react2.default.createClass({
	  displayName: 'ScaleIn',
	
	  propTypes: {
	    childStyle: _react2.default.PropTypes.object,
	    children: _react2.default.PropTypes.node,
	    enterDelay: _react2.default.PropTypes.number,
	    maxScale: _react2.default.PropTypes.number,
	    minScale: _react2.default.PropTypes.number,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2.default, _stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var childStyle = _props.childStyle;
	    var enterDelay = _props.enterDelay;
	    var maxScale = _props.maxScale;
	    var minScale = _props.minScale;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	
	    var mergedRootStyles = this.mergeStyles({
	      position: 'relative',
	      overflow: 'hidden',
	      height: '100%'
	    }, style);
	
	    var newChildren = _react2.default.Children.map(children, function (child) {
	      return _react2.default.createElement(
	        _scaleInChild2.default,
	        {
	          key: child.key,
	          enterDelay: enterDelay,
	          maxScale: maxScale,
	          minScale: minScale,
	          style: childStyle
	        },
	        child
	      );
	    });
	
	    return _react2.default.createElement(
	      _reactAddonsTransitionGroup2.default,
	      _extends({}, other, {
	        style: this.prepareStyles(mergedRootStyles),
	        component: 'div'
	      }),
	      newChildren
	    );
	  }
	});
	
	exports.default = ScaleIn;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _stylePropable = __webpack_require__(2);
	
	var _stylePropable2 = _interopRequireDefault(_stylePropable);
	
	var _autoPrefix = __webpack_require__(17);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(4);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _getMuiTheme = __webpack_require__(3);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SlideInChild = _react2.default.createClass({
	  displayName: 'SlideInChild',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node,
	    direction: _react2.default.PropTypes.string,
	    enterDelay: _react2.default.PropTypes.number,
	    //This callback is needed bacause
	    //the direction could change when leaving the dom
	    getLeaveDirection: _react2.default.PropTypes.func.isRequired,
	
	    /**
	     * Override the inline-styles of the root element.
	     */
	    style: _react2.default.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  //for passing default theme context to children
	  childContextTypes: {
	    muiTheme: _react2.default.PropTypes.object
	  },
	
	  mixins: [_stylePropable2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      muiTheme: this.context.muiTheme || (0, _getMuiTheme2.default)()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.state.muiTheme
	    };
	  },
	
	  //to update theme inside state whenever a new theme is passed down
	  //from the parent / owner using context
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
	    this.setState({ muiTheme: newMuiTheme });
	  },
	  componentWillEnter: function componentWillEnter(callback) {
	    var _this = this;
	
	    var style = _reactDom2.default.findDOMNode(this).style;
	    var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	    var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	    style.opacity = '0';
	    _autoPrefix2.default.set(style, 'transform', 'translate3d(' + x + ',' + y + ',0)', this.state.muiTheme);
	
	    setTimeout(function () {
	      if (_this.isMounted()) callback();
	    }, this.props.enterDelay);
	  },
	  componentDidEnter: function componentDidEnter() {
	    var style = _reactDom2.default.findDOMNode(this).style;
	    style.opacity = '1';
	    _autoPrefix2.default.set(style, 'transform', 'translate3d(0,0,0)', this.state.muiTheme);
	  },
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this2 = this;
	
	    var style = _reactDom2.default.findDOMNode(this).style;
	    var direction = this.props.getLeaveDirection();
	    var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	    var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	    style.opacity = '0';
	    _autoPrefix2.default.set(style, 'transform', 'translate3d(' + x + ',' + y + ',0)', this.state.muiTheme);
	
	    setTimeout(function () {
	      if (_this2.isMounted()) callback();
	    }, 450);
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var enterDelay = _props.enterDelay;
	    var getLeaveDirection = _props.getLeaveDirection;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	
	    var mergedRootStyles = this.mergeStyles({
	      position: 'absolute',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: 0,
	      transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	    }, style);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, other, { style: this.prepareStyles(mergedRootStyles) }),
	      children
	    );
	  }
	});
	
	exports.default = SlideInChild;
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Styles = exports.UniqueId = exports.KeyLine = exports.KeyCode = exports.Events = exports.Dom = exports.CssEvent = exports.ColorManipulator = undefined;
	
	var _colorManipulator = __webpack_require__(24);
	
	var _colorManipulator2 = _interopRequireDefault(_colorManipulator);
	
	var _cssEvent = __webpack_require__(161);
	
	var _cssEvent2 = _interopRequireDefault(_cssEvent);
	
	var _dom = __webpack_require__(72);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _events = __webpack_require__(43);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keyCode = __webpack_require__(19);
	
	var _keyCode2 = _interopRequireDefault(_keyCode);
	
	var _keyLine = __webpack_require__(162);
	
	var _keyLine2 = _interopRequireDefault(_keyLine);
	
	var _uniqueId = __webpack_require__(105);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _styles = __webpack_require__(30);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ColorManipulator = _colorManipulator2.default;
	exports.CssEvent = _cssEvent2.default;
	exports.Dom = _dom2.default;
	exports.Events = _events2.default;
	exports.KeyCode = _keyCode2.default;
	exports.KeyLine = _keyLine2.default;
	exports.UniqueId = _uniqueId2.default;
	exports.Styles = _styles2.default;
	exports.default = {
	  ColorManipulator: _colorManipulator2.default,
	  CssEvent: _cssEvent2.default,
	  Dom: _dom2.default,
	  Events: _events2.default,
	  KeyCode: _keyCode2.default,
	  KeyLine: _keyLine2.default,
	  UniqueId: _uniqueId2.default,
	  Styles: _styles2.default
	};

/***/ },
/* 325 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _pluginsCalc = __webpack_require__(329);
	
	var _pluginsCalc2 = _interopRequireDefault(_pluginsCalc);
	
	var _pluginsCursor = __webpack_require__(330);
	
	var _pluginsCursor2 = _interopRequireDefault(_pluginsCursor);
	
	var _pluginsFlex = __webpack_require__(331);
	
	var _pluginsFlex2 = _interopRequireDefault(_pluginsFlex);
	
	var _pluginsSizing = __webpack_require__(335);
	
	var _pluginsSizing2 = _interopRequireDefault(_pluginsSizing);
	
	var _pluginsGradient = __webpack_require__(334);
	
	var _pluginsGradient2 = _interopRequireDefault(_pluginsGradient);
	
	var _pluginsTransition = __webpack_require__(336);
	
	var _pluginsTransition2 = _interopRequireDefault(_pluginsTransition);
	
	// special flexbox specifications
	
	var _pluginsFlexboxIE = __webpack_require__(332);
	
	var _pluginsFlexboxIE2 = _interopRequireDefault(_pluginsFlexboxIE);
	
	var _pluginsFlexboxOld = __webpack_require__(333);
	
	var _pluginsFlexboxOld2 = _interopRequireDefault(_pluginsFlexboxOld);
	
	exports['default'] = [_pluginsCalc2['default'], _pluginsCursor2['default'], _pluginsSizing2['default'], _pluginsGradient2['default'], _pluginsTransition2['default'], _pluginsFlexboxIE2['default'], _pluginsFlexboxOld2['default'],
	// this must be run AFTER the flexbox specs
	_pluginsFlex2['default']];
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utilsGetBrowserInformation = __webpack_require__(339);
	
	var _utilsGetBrowserInformation2 = _interopRequireDefault(_utilsGetBrowserInformation);
	
	var _utilsGetPrefixedKeyframes = __webpack_require__(340);
	
	var _utilsGetPrefixedKeyframes2 = _interopRequireDefault(_utilsGetPrefixedKeyframes);
	
	var _utilsCapitalizeString = __webpack_require__(163);
	
	var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);
	
	var _utilsAssign = __webpack_require__(337);
	
	var _utilsAssign2 = _interopRequireDefault(_utilsAssign);
	
	var _utilsWarn = __webpack_require__(341);
	
	var _utilsWarn2 = _interopRequireDefault(_utilsWarn);
	
	var _caniuseData = __webpack_require__(328);
	
	var _caniuseData2 = _interopRequireDefault(_caniuseData);
	
	var _Plugins = __webpack_require__(326);
	
	var _Plugins2 = _interopRequireDefault(_Plugins);
	
	var browserWhitelist = ['phantom'];
	
	var Prefixer = (function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _utilsGetBrowserInformation2['default'])(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _utilsGetPrefixedKeyframes2['default'])(this._browserInfo);
	    } else {
	      this._hasPropsRequiringPrefix = false;
	      (0, _utilsWarn2['default'])('Either the global navigator was undefined or an invalid userAgent was provided.', 'Using a valid userAgent? Please let us know and create an issue at https://github.com/rofrischmann/inline-style-prefixer/issues');
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _caniuseData2['default'][this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        return _extends({}, result, _defineProperty({}, name, true));
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      // check for whitelisted browsers
	      browserWhitelist.forEach(function (browser) {
	        if (_this._browserInfo[browser]) {
	          _this._isWhitelisted = true;
	        }
	      });
	      this._hasPropsRequiringPrefix = false;
	
	      // Do not throw a warning if whitelisted
	      if (this._isWhitelisted) {
	        return true;
	      }
	      (0, _utilsWarn2['default'])('Your userAgent seems to be not supported by inline-style-prefixer. Feel free to open an issue.');
	      return false;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      styles = (0, _utilsAssign2['default'])({}, styles);
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _utilsCapitalizeString2['default'])(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	
	          // resolve plugins
	          _Plugins2['default'].forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            var resolvedStyles = plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix,
	              forceRun: false
	            });
	            (0, _utilsAssign2['default'])(styles, resolvedStyles);
	          });
	        }
	      });
	
	      return styles;
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      var prefixes = {};
	      var browserInfo = (0, _utilsGetBrowserInformation2['default'])('*');
	
	      browserInfo.browsers.forEach(function (browser) {
	        var data = _caniuseData2['default'][browser];
	        if (data) {
	          (0, _utilsAssign2['default'])(prefixes, data);
	        }
	      });
	
	      // there should always be at least one prefixed style, but just incase
	      if (!Object.keys(prefixes).length > 0) {
	        return styles;
	      }
	
	      styles = (0, _utilsAssign2['default'])({}, styles);
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object) {
	          // recurse through nested style objects
	          styles[property] = Prefixer.prefixAll(value);
	        } else {
	          var browsers = Object.keys(browserInfo.prefixes);
	          browsers.forEach(function (browser) {
	            var style = browserInfo.prefixes[browser];
	            // add prefixes if needed
	            if (prefixes[property]) {
	              styles[style.inline + (0, _utilsCapitalizeString2['default'])(property)] = value;
	            }
	
	            // resolve plugins for each browser
	            _Plugins2['default'].forEach(function (plugin) {
	              var resolvedStyles = plugin({
	                property: property,
	                value: value,
	                styles: styles,
	                browserInfo: {
	                  name: browser,
	                  prefix: style,
	                  version: 0 // assume lowest
	                },
	                prefix: {},
	                keepUnprefixed: true,
	                requiresPrefix: prefixes,
	                forceRun: true
	              });
	              (0, _utilsAssign2['default'])(styles, resolvedStyles);
	            });
	          });
	        }
	      });
	
	      return styles;
	    }
	  }]);
	
	  return Prefixer;
	})();
	
	exports['default'] = Prefixer;
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports) {

	var caniuseData = {"chrome":{"transform":35,"transformOrigin":35,"transformOriginX":35,"transformOriginY":35,"backfaceVisibility":35,"perspective":35,"perspectiveOrigin":35,"transformStyle":35,"transformOriginZ":35,"animation":42,"animationDelay":42,"animationDirection":42,"animationFillMode":42,"animationDuration":42,"animationIterationCount":42,"animationName":42,"animationPlayState":42,"animationTimingFunction":42,"appearance":50,"userSelect":50,"fontKerning":32,"textEmphasisPosition":50,"textEmphasis":50,"textEmphasisStyle":50,"textEmphasisColor":50,"boxDecorationBreak":50,"clipPath":50,"maskImage":50,"maskMode":50,"maskRepeat":50,"maskPosition":50,"maskClip":50,"maskOrigin":50,"maskSize":50,"maskComposite":50,"mask":50,"maskBorderSource":50,"maskBorderMode":50,"maskBorderSlice":50,"maskBorderWidth":50,"maskBorderOutset":50,"maskBorderRepeat":50,"maskBorder":50,"maskType":50,"textDecorationStyle":50,"textDecorationSkip":50,"textDecorationLine":50,"textDecorationColor":50,"filter":50,"fontFeatureSettings":47,"breakAfter":50,"breakBefore":50,"breakInside":50,"columnCount":50,"columnFill":50,"columnGap":50,"columnRule":50,"columnRuleColor":50,"columnRuleStyle":50,"columnRuleWidth":50,"columns":50,"columnSpan":50,"columnWidth":50},"safari":{"flex":8,"flexBasis":8,"flexDirection":8,"flexGrow":8,"flexFlow":8,"flexShrink":8,"flexWrap":8,"alignContent":8,"alignItems":8,"alignSelf":8,"justifyContent":8,"order":8,"transition":6,"transitionDelay":6,"transitionDuration":6,"transitionProperty":6,"transitionTimingFunction":6,"transform":8,"transformOrigin":8,"transformOriginX":8,"transformOriginY":8,"backfaceVisibility":8,"perspective":8,"perspectiveOrigin":8,"transformStyle":8,"transformOriginZ":8,"animation":8,"animationDelay":8,"animationDirection":8,"animationFillMode":8,"animationDuration":8,"animationIterationCount":8,"animationName":8,"animationPlayState":8,"animationTimingFunction":8,"appearance":9.1,"userSelect":9.1,"backdropFilter":9.1,"fontKerning":9.1,"scrollSnapType":9.1,"scrollSnapPointsX":9.1,"scrollSnapPointsY":9.1,"scrollSnapDestination":9.1,"scrollSnapCoordinate":9.1,"textEmphasisPosition":7,"textEmphasis":7,"textEmphasisStyle":7,"textEmphasisColor":7,"boxDecorationBreak":9.1,"clipPath":9.1,"maskImage":9.1,"maskMode":9.1,"maskRepeat":9.1,"maskPosition":9.1,"maskClip":9.1,"maskOrigin":9.1,"maskSize":9.1,"maskComposite":9.1,"mask":9.1,"maskBorderSource":9.1,"maskBorderMode":9.1,"maskBorderSlice":9.1,"maskBorderWidth":9.1,"maskBorderOutset":9.1,"maskBorderRepeat":9.1,"maskBorder":9.1,"maskType":9.1,"textDecorationStyle":9.1,"textDecorationSkip":9.1,"textDecorationLine":9.1,"textDecorationColor":9.1,"shapeImageThreshold":9.1,"shapeImageMargin":9.1,"shapeImageOutside":9.1,"filter":9,"hyphens":9.1,"flowInto":9.1,"flowFrom":9.1,"breakBefore":8,"breakAfter":8,"breakInside":8,"regionFragment":9.1,"columnCount":8,"columnFill":8,"columnGap":8,"columnRule":8,"columnRuleColor":8,"columnRuleStyle":8,"columnRuleWidth":8,"columns":8,"columnSpan":8,"columnWidth":8},"firefox":{"appearance":46,"userSelect":46,"boxSizing":28,"textAlignLast":46,"textDecorationStyle":35,"textDecorationSkip":35,"textDecorationLine":35,"textDecorationColor":35,"tabSize":46,"hyphens":42,"fontFeatureSettings":33,"breakAfter":46,"breakBefore":46,"breakInside":46,"columnCount":46,"columnFill":46,"columnGap":46,"columnRule":46,"columnRuleColor":46,"columnRuleStyle":46,"columnRuleWidth":46,"columns":46,"columnSpan":46,"columnWidth":46},"opera":{"flex":16,"flexBasis":16,"flexDirection":16,"flexGrow":16,"flexFlow":16,"flexShrink":16,"flexWrap":16,"alignContent":16,"alignItems":16,"alignSelf":16,"justifyContent":16,"order":16,"transform":22,"transformOrigin":22,"transformOriginX":22,"transformOriginY":22,"backfaceVisibility":22,"perspective":22,"perspectiveOrigin":22,"transformStyle":22,"transformOriginZ":22,"animation":29,"animationDelay":29,"animationDirection":29,"animationFillMode":29,"animationDuration":29,"animationIterationCount":29,"animationName":29,"animationPlayState":29,"animationTimingFunction":29,"appearance":36,"userSelect":36,"fontKerning":19,"textEmphasisPosition":36,"textEmphasis":36,"textEmphasisStyle":36,"textEmphasisColor":36,"boxDecorationBreak":36,"clipPath":36,"maskImage":36,"maskMode":36,"maskRepeat":36,"maskPosition":36,"maskClip":36,"maskOrigin":36,"maskSize":36,"maskComposite":36,"mask":36,"maskBorderSource":36,"maskBorderMode":36,"maskBorderSlice":36,"maskBorderWidth":36,"maskBorderOutset":36,"maskBorderRepeat":36,"maskBorder":36,"maskType":36,"filter":36,"fontFeatureSettings":36,"breakAfter":36,"breakBefore":36,"breakInside":36,"columnCount":36,"columnFill":36,"columnGap":36,"columnRule":36,"columnRuleColor":36,"columnRuleStyle":36,"columnRuleWidth":36,"columns":36,"columnSpan":36,"columnWidth":36},"ie":{"gridArea":11,"gridGap":11,"gridColumnStart":11,"userSelect":11,"grid":11,"breakInside":11,"hyphens":11,"gridTemplateAreas":11,"breakAfter":11,"scrollSnapCoordinate":11,"gridRowStart":11,"gridAutoFlow":11,"scrollSnapDestination":11,"gridTemplate":11,"gridTemplateColumns":11,"transformOrigin":9,"gridAutoRows":11,"gridColumnEnd":11,"transformOriginY":9,"scrollSnapPointsY":11,"breakBefore":11,"gridRowGap":11,"scrollSnapPointsX":11,"regionFragment":11,"flexWrap":10,"wrapFlow":11,"gridRowEnd":11,"flex":10,"flexDirection":10,"flowInto":11,"touchAction":10,"gridColumn":11,"transform":9,"gridTemplateRows":11,"flexFlow":10,"transformOriginX":9,"flowFrom":11,"scrollSnapType":11,"wrapMargin":11,"gridColumnGap":11,"gridRow":11,"wrapThrough":11,"gridAutoColumns":11,"textSizeAdjust":11},"edge":{"userSelect":14,"wrapFlow":14,"wrapThrough":14,"wrapMargin":14,"scrollSnapType":14,"scrollSnapPointsX":14,"scrollSnapPointsY":14,"scrollSnapDestination":14,"scrollSnapCoordinate":14,"hyphens":14,"flowInto":14,"flowFrom":14,"breakBefore":14,"breakAfter":14,"breakInside":14,"regionFragment":14,"gridTemplateColumns":14,"gridTemplateRows":14,"gridTemplateAreas":14,"gridTemplate":14,"gridAutoColumns":14,"gridAutoRows":14,"gridAutoFlow":14,"grid":14,"gridRowStart":14,"gridColumnStart":14,"gridRowEnd":14,"gridRow":14,"gridColumn":14,"gridColumnEnd":14,"gridColumnGap":14,"gridRowGap":14,"gridArea":14,"gridGap":14},"ios_saf":{"flex":8.1,"flexBasis":8.1,"flexDirection":8.1,"flexGrow":8.1,"flexFlow":8.1,"flexShrink":8.1,"flexWrap":8.1,"alignContent":8.1,"alignItems":8.1,"alignSelf":8.1,"justifyContent":8.1,"order":8.1,"transition":6,"transitionDelay":6,"transitionDuration":6,"transitionProperty":6,"transitionTimingFunction":6,"transform":8.1,"transformOrigin":8.1,"transformOriginX":8.1,"transformOriginY":8.1,"backfaceVisibility":8.1,"perspective":8.1,"perspectiveOrigin":8.1,"transformStyle":8.1,"transformOriginZ":8.1,"animation":8.1,"animationDelay":8.1,"animationDirection":8.1,"animationFillMode":8.1,"animationDuration":8.1,"animationIterationCount":8.1,"animationName":8.1,"animationPlayState":8.1,"animationTimingFunction":8.1,"appearance":9.3,"userSelect":9.3,"backdropFilter":9.3,"fontKerning":9.3,"scrollSnapType":9.3,"scrollSnapPointsX":9.3,"scrollSnapPointsY":9.3,"scrollSnapDestination":9.3,"scrollSnapCoordinate":9.3,"boxDecorationBreak":9.3,"clipPath":9.3,"maskImage":9.3,"maskMode":9.3,"maskRepeat":9.3,"maskPosition":9.3,"maskClip":9.3,"maskOrigin":9.3,"maskSize":9.3,"maskComposite":9.3,"mask":9.3,"maskBorderSource":9.3,"maskBorderMode":9.3,"maskBorderSlice":9.3,"maskBorderWidth":9.3,"maskBorderOutset":9.3,"maskBorderRepeat":9.3,"maskBorder":9.3,"maskType":9.3,"textSizeAdjust":9.3,"textDecorationStyle":9.3,"textDecorationSkip":9.3,"textDecorationLine":9.3,"textDecorationColor":9.3,"shapeImageThreshold":9.3,"shapeImageMargin":9.3,"shapeImageOutside":9.3,"filter":9,"hyphens":9.3,"flowInto":9.3,"flowFrom":9.3,"breakBefore":8.1,"breakAfter":8.1,"breakInside":8.1,"regionFragment":9.3,"columnCount":8.1,"columnFill":8.1,"columnGap":8.1,"columnRule":8.1,"columnRuleColor":8.1,"columnRuleStyle":8.1,"columnRuleWidth":8.1,"columns":8.1,"columnSpan":8.1,"columnWidth":8.1},"android":{"borderImage":4.2,"borderImageOutset":4.2,"borderImageRepeat":4.2,"borderImageSlice":4.2,"borderImageSource":4.2,"borderImageWidth":4.2,"flex":4.2,"flexBasis":4.2,"flexDirection":4.2,"flexGrow":4.2,"flexFlow":4.2,"flexShrink":4.2,"flexWrap":4.2,"alignContent":4.2,"alignItems":4.2,"alignSelf":4.2,"justifyContent":4.2,"order":4.2,"transition":4.2,"transitionDelay":4.2,"transitionDuration":4.2,"transitionProperty":4.2,"transitionTimingFunction":4.2,"transform":4.4,"transformOrigin":4.4,"transformOriginX":4.4,"transformOriginY":4.4,"backfaceVisibility":4.4,"perspective":4.4,"perspectiveOrigin":4.4,"transformStyle":4.4,"transformOriginZ":4.4,"animation":4.4,"animationDelay":4.4,"animationDirection":4.4,"animationFillMode":4.4,"animationDuration":4.4,"animationIterationCount":4.4,"animationName":4.4,"animationPlayState":4.4,"animationTimingFunction":4.4,"appearance":46,"userSelect":46,"fontKerning":4.4,"textEmphasisPosition":46,"textEmphasis":46,"textEmphasisStyle":46,"textEmphasisColor":46,"boxDecorationBreak":46,"clipPath":46,"maskImage":46,"maskMode":46,"maskRepeat":46,"maskPosition":46,"maskClip":46,"maskOrigin":46,"maskSize":46,"maskComposite":46,"mask":46,"maskBorderSource":46,"maskBorderMode":46,"maskBorderSlice":46,"maskBorderWidth":46,"maskBorderOutset":46,"maskBorderRepeat":46,"maskBorder":46,"maskType":46,"filter":46,"fontFeatureSettings":46,"breakAfter":46,"breakBefore":46,"breakInside":46,"columnCount":46,"columnFill":46,"columnGap":46,"columnRule":46,"columnRuleColor":46,"columnRuleStyle":46,"columnRuleWidth":46,"columns":46,"columnSpan":46,"columnWidth":46},"and_chr":{"appearance":47,"userSelect":47,"textEmphasisPosition":47,"textEmphasis":47,"textEmphasisStyle":47,"textEmphasisColor":47,"boxDecorationBreak":47,"clipPath":47,"maskImage":47,"maskMode":47,"maskRepeat":47,"maskPosition":47,"maskClip":47,"maskOrigin":47,"maskSize":47,"maskComposite":47,"mask":47,"maskBorderSource":47,"maskBorderMode":47,"maskBorderSlice":47,"maskBorderWidth":47,"maskBorderOutset":47,"maskBorderRepeat":47,"maskBorder":47,"maskType":47,"textDecorationStyle":47,"textDecorationSkip":47,"textDecorationLine":47,"textDecorationColor":47,"filter":47,"fontFeatureSettings":47,"breakAfter":47,"breakBefore":47,"breakInside":47,"columnCount":47,"columnFill":47,"columnGap":47,"columnRule":47,"columnRuleColor":47,"columnRuleStyle":47,"columnRuleWidth":47,"columns":47,"columnSpan":47,"columnWidth":47},"and_uc":{"flex":9.9,"flexBasis":9.9,"flexDirection":9.9,"flexGrow":9.9,"flexFlow":9.9,"flexShrink":9.9,"flexWrap":9.9,"alignContent":9.9,"alignItems":9.9,"alignSelf":9.9,"justifyContent":9.9,"order":9.9,"transition":9.9,"transitionDelay":9.9,"transitionDuration":9.9,"transitionProperty":9.9,"transitionTimingFunction":9.9,"transform":9.9,"transformOrigin":9.9,"transformOriginX":9.9,"transformOriginY":9.9,"backfaceVisibility":9.9,"perspective":9.9,"perspectiveOrigin":9.9,"transformStyle":9.9,"transformOriginZ":9.9,"animation":9.9,"animationDelay":9.9,"animationDirection":9.9,"animationFillMode":9.9,"animationDuration":9.9,"animationIterationCount":9.9,"animationName":9.9,"animationPlayState":9.9,"animationTimingFunction":9.9,"appearance":9.9,"userSelect":9.9,"fontKerning":9.9,"textEmphasisPosition":9.9,"textEmphasis":9.9,"textEmphasisStyle":9.9,"textEmphasisColor":9.9,"maskImage":9.9,"maskMode":9.9,"maskRepeat":9.9,"maskPosition":9.9,"maskClip":9.9,"maskOrigin":9.9,"maskSize":9.9,"maskComposite":9.9,"mask":9.9,"maskBorderSource":9.9,"maskBorderMode":9.9,"maskBorderSlice":9.9,"maskBorderWidth":9.9,"maskBorderOutset":9.9,"maskBorderRepeat":9.9,"maskBorder":9.9,"maskType":9.9,"textSizeAdjust":9.9,"filter":9.9,"hyphens":9.9,"flowInto":9.9,"flowFrom":9.9,"breakBefore":9.9,"breakAfter":9.9,"breakInside":9.9,"regionFragment":9.9,"fontFeatureSettings":9.9,"columnCount":9.9,"columnFill":9.9,"columnGap":9.9,"columnRule":9.9,"columnRuleColor":9.9,"columnRuleStyle":9.9,"columnRuleWidth":9.9,"columns":9.9,"columnSpan":9.9,"columnWidth":9.9},"op_mini":{"borderImage":5,"borderImageOutset":5,"borderImageRepeat":5,"borderImageSlice":5,"borderImageSource":5,"borderImageWidth":5,"tabSize":5,"objectFit":5,"objectPosition":5}}; module.exports = caniuseData

/***/ },
/* 329 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = calc;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (forceRun || browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    var newValue = forceRun ?
	    // prefix all
	    ['-webkit-', '-moz-'].map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    }).join(';' + property + ':') :
	    // default
	    value.replace(/calc\(/g, prefix.css + 'calc(');
	    return _defineProperty({}, property, newValue + (keepUnprefixed ? ';' + property + ':' + value : ''));
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = cursor;
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (property === 'cursor' && values[value] && (forceRun || browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    var newValue = forceRun ?
	    // prefix all
	    ['-webkit-', '-moz-'].map(function (prefix) {
	      return prefix + value;
	    }).join(';' + property + ':') :
	    // default
	    prefix.css + value;
	    return {
	      cursor: newValue + (keepUnprefixed ? ';' + property + ':' + value : '')
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (property === 'display' && values[value] && (forceRun || browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    var newValue = forceRun ?
	    // prefix all
	    ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value].join(';' + property + ':') :
	    // default
	    '-webkit-' + value;
	    return {
	      display: newValue + (keepUnprefixed ? ';' + property + ':' + value : '')
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: '-ms-flexbox',
	  'inline-flex': '-ms-inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	var properties = Object.keys(alternativeProps).concat('display').reduce(function (result, prop) {
	  return _extends({}, result, _defineProperty({}, prop, true));
	}, {});
	
	function flexboxIE(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var styles = pluginInterface.styles;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (properties[property] && (forceRun || (browser === 'ie_mob' || browser === 'ie') && version == 10)) {
	    if (!keepUnprefixed) {
	      delete styles[property];
	    }
	
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	    if (alternativeValues[value]) {
	      return _defineProperty({}, property, alternativeValues[value] + (keepUnprefixed ? ';' + property + ':' + value : ''));
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var properties = Object.keys(alternativeProps).concat(['alignContent', 'alignSelf', 'display', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection']).reduce(function (result, prop) {
	  return _extends({}, result, _defineProperty({}, prop, true));
	}, {});
	
	function flexboxOld(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var styles = pluginInterface.styles;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (properties[property] && (forceRun || browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: prefix.css + alternativeValues[value] + (keepUnprefixed ? ';' + property + ':' + value : '')
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	    if (alternativeValues[value]) {
	      return _defineProperty({}, property, alternativeValues[value] + (keepUnprefixed ? ';' + property + ':' + value : ''));
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = gradient;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (typeof value === 'string' && value.match(values) !== null && (forceRun || browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    var newValue = forceRun ?
	    // prefix all
	    ['-webkit-', '-moz-'].map(function (prefix) {
	      return prefix + value;
	    }).join(';' + property + ':') :
	    // default
	    prefix.css + value;
	    return _defineProperty({}, property, newValue + (keepUnprefixed ? ';' + property + ':' + value : ''));
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = sizing;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    var newValue = forceRun ?
	    // prefix all
	    ['-webkit-', '-moz-'].map(function (prefix) {
	      return prefix + value;
	    }).join(';' + property + ':') :
	    // default
	    prefix.css + value;
	    return _defineProperty({}, property, newValue + (keepUnprefixed ? ';' + property + ':' + value : ''));
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = calc;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _utilsCamelToDashCase = __webpack_require__(338);
	
	var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);
	
	var _utilsCapitalizeString = __webpack_require__(163);
	
	var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);
	
	function calc(pluginInterface) {
	  var property = pluginInterface.property;
	  var value = pluginInterface.value;
	  var browserInfo = pluginInterface.browserInfo;
	  var prefix = pluginInterface.prefix;
	  var keepUnprefixed = pluginInterface.keepUnprefixed;
	  var forceRun = pluginInterface.forceRun;
	  var requiresPrefix = pluginInterface.requiresPrefix;
	  var browser = browserInfo.browser;
	  var version = browserInfo.version;
	
	  if (
	  // also check for already prefixed transitions
	  typeof value === 'string' && (property.toLowerCase().indexOf('transition') > -1 || property.toLowerCase().indexOf('transitionproperty') > -1)) {
	    var _ref;
	
	    var _ret = (function () {
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (property) {
	        return (0, _utilsCamelToDashCase2['default'])(property);
	      });
	      var newValue = value;
	
	      // only split multi values, not cubic beziers
	      var multipleValues = newValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (property) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(property) > -1) {
	            var newVal = forceRun ?
	            // prefix all
	            ['-webkit-', '-moz-', '-ms-'].map(function (prefix) {
	              return val.replace(property, prefix + property);
	            }).join(',') :
	            // default
	            val.replace(property, prefix.css + property);
	            multipleValues[index] = newVal + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	      var outputValue = multipleValues.join(',');
	      if (forceRun) {
	        return {
	          v: (_ref = {}, _defineProperty(_ref, 'Webkit' + (0, _utilsCapitalizeString2['default'])(property), outputValue), _defineProperty(_ref, 'Moz' + (0, _utilsCapitalizeString2['default'])(property), outputValue), _defineProperty(_ref, 'ms' + (0, _utilsCapitalizeString2['default'])(property), outputValue), _defineProperty(_ref, property, outputValue), _ref)
	        };
	      }
	      return {
	        v: _defineProperty({}, property, outputValue)
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports) {

	// leight polyfill for Object.assign
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports["default"] = function (base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (key) {
	    return base[key] = extend[key];
	  });
	  return base;
	};
	
	module.exports = exports["default"];

/***/ },
/* 338 */
/***/ function(module, exports) {

	/**
	 * Converts a camel-case string to a dash-case string
	 * @param {string} str - str that gets converted to dash-case
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (str) {
	  return str.replace(/([a-z]|^)([A-Z])/g, function (match, p1, p2) {
	    return p1 + '-' + p2.toLowerCase();
	  }).replace('ms-', '-ms-');
	};
	
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bowser = __webpack_require__(342);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	
	var browsers = {
	  chrome: [['chrome']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  ie: [['msie']],
	  edge: [['msedge']],
	  opera: [['opera']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie_mob: [['windowsphone', 'mobile', 'msie'], ['windowsphone', 'tablet', 'msie'], ['windowsphone', 'mobile', 'msedge'], ['windowsphone', 'tablet', 'msedge']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	/**
	 * Returns an object containing prefix data associated with a browser
	 * @param {string} browser - browser to find a prefix for
	 */
	var getPrefixes = function getPrefixes(browser) {
	  var prefixKeys = undefined;
	  var prefix = undefined;
	  var vendors = undefined;
	  var conditions = undefined;
	  var prefixVendor = undefined;
	  var browserVendors = undefined;
	
	  // Find the prefix for this browser (if any)
	  prefixKeys = Object.keys(vendorPrefixes);
	  for (var i = 0; i < prefixKeys.length; i++) {
	    prefix = prefixKeys[i];
	
	    // Find a matching vendor
	    vendors = vendorPrefixes[prefix];
	    conditions = browsers[browser];
	
	    for (var j = 0; j < vendors.length; j++) {
	      prefixVendor = vendors[j];
	
	      for (var k = 0; k < conditions.length; k++) {
	        browserVendors = conditions[k];
	
	        if (browserVendors.indexOf(prefixVendor) !== -1) {
	          return {
	            inline: prefix,
	            css: '-' + prefix.toLowerCase() + '-'
	          };
	        }
	      }
	    }
	  }
	
	  // No prefix found for this browser
	  return { inline: '', css: '' };
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports['default'] = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	
	  var info = {};
	
	  // Special user agent, return all supported prefixes
	  // instead of returning a string browser name and a prefix object
	  // we return an array of browser names and map of prefixes for each browser
	  if (userAgent === '*') {
	    // Return an array of supported browsers
	    info.browsers = Object.keys(browsers);
	
	    // Return prefixes associated by browser
	    info.prefixes = {};
	
	    // Iterate browser list, assign prefix to each
	    info.browsers.forEach(function (browser) {
	      info.prefixes[browser] = getPrefixes(browser);
	    });
	
	    return info;
	  }
	
	  // Normal user agent, detect browser
	  info = _bowser2['default']._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  var name = '';
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  info.browser = name;
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	  info.version = parseFloat(info.version);
	  info.osversion = parseFloat(info.osversion);
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	// only throw warnings if devmode is enabled
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function () {
	  if (false) {
	    console.warn.apply(console, arguments);
	  }
	};
	
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * Bowser - a browser detector
	  * https://github.com/ded/bowser
	  * MIT License | (c) Dustin Diaz 2015
	  */
	
	!function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	}('bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , chromeBook = /CrOS/.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , result
	
	    if (/opera|opr/i.test(ua)) {
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/windows phone/i.test(ua)) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeBook) {
	      result = {
	        name: 'Chrome'
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (/sailfish/i.test(ua)) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	      }
	    }
	    else if (/silk/i.test(ua)) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	      , version: versionIdentifier
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/(web|hpw)os/i.test(ua)) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (/tizen/i.test(ua)) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/safari/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      , version: versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      result.name = result.name || "Webkit"
	      result.webkit = t
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.msedge && (android || result.silk)) {
	      result.android = t
	    } else if (iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = osVersion.split('.')[0];
	    if (tablet || iosdevice == 'ipad' || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile))) || result.silk) {
	      result.tablet = t
	    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || result.blackberry || result.webos || result.bada) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
	        (result.chrome && result.version >= 20) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ },
/* 343 */
/***/ function(module, exports) {

	/**
	 * lodash 3.2.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return function() {
	    var length = arguments.length,
	        index = fromRight ? length : -1,
	        leftIndex = 0,
	        funcs = Array(length);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var func = funcs[leftIndex++] = arguments[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	    }
	    return function() {
	      var index = 0,
	          result = length ? funcs[index].apply(this, arguments) : arguments[0];
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  };
	}
	
	/**
	 * This method is like `_.flow` except that it creates a function that
	 * invokes the provided functions from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @alias backflow, compose
	 * @category Function
	 * @param {...Function} [funcs] Functions to invoke.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flowRight(square, _.add);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flowRight = createFlow(true);
	
	module.exports = flowRight;


/***/ },
/* 344 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(347),
	    isIterateeCall = __webpack_require__(348),
	    restParam = __webpack_require__(349);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 348 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 349 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 350 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(352),
	    isArguments = __webpack_require__(73),
	    keysIn = __webpack_require__(165);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 353 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(350),
	    isArguments = __webpack_require__(73),
	    isArray = __webpack_require__(106);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(356),
	    keysIn = __webpack_require__(165);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return baseCopy(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var debounce = __webpack_require__(358);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed invocations. Provide an options object to indicate
	 * that `func` should be invoked on the leading and/or trailing edge of the
	 * `wait` timeout. Subsequent calls to the throttled function return the
	 * result of the last `func` call.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the throttled function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=true] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // avoid excessively updating the position while scrolling
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	 * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	 *   'trailing': false
	 * }));
	 *
	 * // cancel a trailing throttled call
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (options === false) {
	    leading = false;
	  } else if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = throttle;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(359);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed invocations. Provide an options object to indicate that `func`
	 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	 * Subsequent calls to the debounced function return the result of the last
	 * `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it is invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = debounce;


/***/ },
/* 359 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(396).create;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/*! p5.js v0.4.21 January 22, 2016 */
	(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.p5 = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	
	},{}],2:[function(_dereq_,module,exports){
	// Run-time checking of preconditions.
	
	'use strict';
	
	// Precondition function that checks if the given predicate is true.
	// If not, it will throw an error.
	exports.argument = function(predicate, message) {
	    if (!predicate) {
	        throw new Error(message);
	    }
	};
	
	// Precondition function that checks if the given assertion is true.
	// If not, it will throw an error.
	exports.assert = exports.argument;
	
	},{}],3:[function(_dereq_,module,exports){
	// Drawing utility functions.
	
	'use strict';
	
	// Draw a line on the given context from point `x1,y1` to point `x2,y2`.
	function line(ctx, x1, y1, x2, y2) {
	    ctx.beginPath();
	    ctx.moveTo(x1, y1);
	    ctx.lineTo(x2, y2);
	    ctx.stroke();
	}
	
	exports.line = line;
	
	},{}],4:[function(_dereq_,module,exports){
	// Glyph encoding
	
	'use strict';
	
	var cffStandardStrings = [
	    '.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
	    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
	    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
	    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
	    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
	    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
	    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling',
	    'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft',
	    'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph',
	    'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand',
	    'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring',
	    'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE',
	    'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu',
	    'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn',
	    'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright',
	    'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex',
	    'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex',
	    'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute',
	    'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute',
	    'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute',
	    'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave',
	    'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior',
	    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', '266 ff', 'onedotenleader',
	    'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle',
	    'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior',
	    'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior',
	    'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl',
	    'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
	    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
	    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
	    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall',
	    'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall',
	    'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall',
	    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds',
	    'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior',
	    'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior',
	    'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior',
	    'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall',
	    'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall',
	    'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall',
	    'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall',
	    'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000',
	    '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];
	
	var cffStandardEncoding = [
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
	    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
	    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
	    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
	    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
	    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
	    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '',
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle',
	    'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger',
	    'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright',
	    'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde',
	    'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron',
	    'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '',
	    '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '',
	    'lslash', 'oslash', 'oe', 'germandbls'];
	
	var cffExpertEncoding = [
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior',
	    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader',
	    'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle',
	    'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon',
	    'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior',
	    'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior',
	    'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl',
	    'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
	    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
	    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
	    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '',
	    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
	    'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall',
	    'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior',
	    '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters',
	    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '',
	    '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior',
	    'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior',
	    'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior',
	    'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall',
	    'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall',
	    'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall',
	    'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall',
	    'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall',
	    'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
	
	var standardNames = [
	    '.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent',
	    'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash',
	    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less',
	    'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
	    'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright',
	    'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
	    'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde',
	    'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave',
	    'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis',
	    'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis',
	    'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section',
	    'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal',
	    'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation',
	    'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown',
	    'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright',
	    'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft',
	    'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction',
	    'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase',
	    'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute',
	    'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex',
	    'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut',
	    'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth',
	    'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior',
	    'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla',
	    'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];
	
	// This is the encoding used for fonts created from scratch.
	// It loops through all glyphs and finds the appropriate unicode value.
	// Since it's linear time, other encodings will be faster.
	function DefaultEncoding(font) {
	    this.font = font;
	}
	
	DefaultEncoding.prototype.charToGlyphIndex = function(c) {
	    var code = c.charCodeAt(0);
	    var glyphs = this.font.glyphs;
	    if (glyphs) {
	        for (var i = 0; i < glyphs.length; i += 1) {
	            var glyph = glyphs.get(i);
	            for (var j = 0; j < glyph.unicodes.length; j += 1) {
	                if (glyph.unicodes[j] === code) {
	                    return i;
	                }
	            }
	        }
	    } else {
	        return null;
	    }
	};
	
	function CmapEncoding(cmap) {
	    this.cmap = cmap;
	}
	
	CmapEncoding.prototype.charToGlyphIndex = function(c) {
	    return this.cmap.glyphIndexMap[c.charCodeAt(0)] || 0;
	};
	
	function CffEncoding(encoding, charset) {
	    this.encoding = encoding;
	    this.charset = charset;
	}
	
	CffEncoding.prototype.charToGlyphIndex = function(s) {
	    var code = s.charCodeAt(0);
	    var charName = this.encoding[code];
	    return this.charset.indexOf(charName);
	};
	
	function GlyphNames(post) {
	    var i;
	    switch (post.version) {
	    case 1:
	        this.names = exports.standardNames.slice();
	        break;
	    case 2:
	        this.names = new Array(post.numberOfGlyphs);
	        for (i = 0; i < post.numberOfGlyphs; i++) {
	            if (post.glyphNameIndex[i] < exports.standardNames.length) {
	                this.names[i] = exports.standardNames[post.glyphNameIndex[i]];
	            } else {
	                this.names[i] = post.names[post.glyphNameIndex[i] - exports.standardNames.length];
	            }
	        }
	
	        break;
	    case 2.5:
	        this.names = new Array(post.numberOfGlyphs);
	        for (i = 0; i < post.numberOfGlyphs; i++) {
	            this.names[i] = exports.standardNames[i + post.glyphNameIndex[i]];
	        }
	
	        break;
	    case 3:
	        this.names = [];
	        break;
	    }
	}
	
	GlyphNames.prototype.nameToGlyphIndex = function(name) {
	    return this.names.indexOf(name);
	};
	
	GlyphNames.prototype.glyphIndexToName = function(gid) {
	    return this.names[gid];
	};
	
	function addGlyphNames(font) {
	    var glyph;
	    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
	    var charCodes = Object.keys(glyphIndexMap);
	
	    for (var i = 0; i < charCodes.length; i += 1) {
	        var c = charCodes[i];
	        var glyphIndex = glyphIndexMap[c];
	        glyph = font.glyphs.get(glyphIndex);
	        glyph.addUnicode(parseInt(c));
	    }
	
	    for (i = 0; i < font.glyphs.length; i += 1) {
	        glyph = font.glyphs.get(i);
	        if (font.cffEncoding) {
	            glyph.name = font.cffEncoding.charset[i];
	        } else {
	            glyph.name = font.glyphNames.glyphIndexToName(i);
	        }
	    }
	}
	
	exports.cffStandardStrings = cffStandardStrings;
	exports.cffStandardEncoding = cffStandardEncoding;
	exports.cffExpertEncoding = cffExpertEncoding;
	exports.standardNames = standardNames;
	exports.DefaultEncoding = DefaultEncoding;
	exports.CmapEncoding = CmapEncoding;
	exports.CffEncoding = CffEncoding;
	exports.GlyphNames = GlyphNames;
	exports.addGlyphNames = addGlyphNames;
	
	},{}],5:[function(_dereq_,module,exports){
	// The Font object
	
	'use strict';
	
	var path = _dereq_('./path');
	var sfnt = _dereq_('./tables/sfnt');
	var encoding = _dereq_('./encoding');
	var glyphset = _dereq_('./glyphset');
	
	// A Font represents a loaded OpenType font file.
	// It contains a set of glyphs and methods to draw text on a drawing context,
	// or to get a path representing the text.
	function Font(options) {
	    options = options || {};
	
	    // OS X will complain if the names are empty, so we put a single space everywhere by default.
	    this.familyName = options.familyName || ' ';
	    this.styleName = options.styleName || ' ';
	    this.designer = options.designer || ' ';
	    this.designerURL = options.designerURL || ' ';
	    this.manufacturer = options.manufacturer || ' ';
	    this.manufacturerURL = options.manufacturerURL || ' ';
	    this.license = options.license || ' ';
	    this.licenseURL = options.licenseURL || ' ';
	    this.version = options.version || 'Version 0.1';
	    this.description = options.description || ' ';
	    this.copyright = options.copyright || ' ';
	    this.trademark = options.trademark || ' ';
	    this.unitsPerEm = options.unitsPerEm || 1000;
	    this.ascender = options.ascender;
	    this.descender = options.descender;
	    this.supported = true;
	    this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
	    this.encoding = new encoding.DefaultEncoding(this);
	    this.tables = {};
	}
	
	// Check if the font has a glyph for the given character.
	Font.prototype.hasChar = function(c) {
	    return this.encoding.charToGlyphIndex(c) !== null;
	};
	
	// Convert the given character to a single glyph index.
	// Note that this function assumes that there is a one-to-one mapping between
	// the given character and a glyph; for complex scripts this might not be the case.
	Font.prototype.charToGlyphIndex = function(s) {
	    return this.encoding.charToGlyphIndex(s);
	};
	
	// Convert the given character to a single Glyph object.
	// Note that this function assumes that there is a one-to-one mapping between
	// the given character and a glyph; for complex scripts this might not be the case.
	Font.prototype.charToGlyph = function(c) {
	    var glyphIndex = this.charToGlyphIndex(c);
	    var glyph = this.glyphs.get(glyphIndex);
	    if (!glyph) {
	        // .notdef
	        glyph = this.glyphs.get(0);
	    }
	
	    return glyph;
	};
	
	// Convert the given text to a list of Glyph objects.
	// Note that there is no strict one-to-one mapping between characters and
	// glyphs, so the list of returned glyphs can be larger or smaller than the
	// length of the given string.
	Font.prototype.stringToGlyphs = function(s) {
	    var glyphs = [];
	    for (var i = 0; i < s.length; i += 1) {
	        var c = s[i];
	        glyphs.push(this.charToGlyph(c));
	    }
	
	    return glyphs;
	};
	
	Font.prototype.nameToGlyphIndex = function(name) {
	    return this.glyphNames.nameToGlyphIndex(name);
	};
	
	Font.prototype.nameToGlyph = function(name) {
	    var glyphIndex = this.nametoGlyphIndex(name);
	    var glyph = this.glyphs.get(glyphIndex);
	    if (!glyph) {
	        // .notdef
	        glyph = this.glyphs.get(0);
	    }
	
	    return glyph;
	};
	
	Font.prototype.glyphIndexToName = function(gid) {
	    if (!this.glyphNames.glyphIndexToName) {
	        return '';
	    }
	
	    return this.glyphNames.glyphIndexToName(gid);
	};
	
	// Retrieve the value of the kerning pair between the left glyph (or its index)
	// and the right glyph (or its index). If no kerning pair is found, return 0.
	// The kerning value gets added to the advance width when calculating the spacing
	// between glyphs.
	Font.prototype.getKerningValue = function(leftGlyph, rightGlyph) {
	    leftGlyph = leftGlyph.index || leftGlyph;
	    rightGlyph = rightGlyph.index || rightGlyph;
	    var gposKerning = this.getGposKerningValue;
	    return gposKerning ? gposKerning(leftGlyph, rightGlyph) :
	        (this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0);
	};
	
	// Helper function that invokes the given callback for each glyph in the given text.
	// The callback gets `(glyph, x, y, fontSize, options)`.
	Font.prototype.forEachGlyph = function(text, x, y, fontSize, options, callback) {
	    if (!this.supported) {
	        return;
	    }
	
	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 72;
	    options = options || {};
	    var kerning = options.kerning === undefined ? true : options.kerning;
	    var fontScale = 1 / this.unitsPerEm * fontSize;
	    var glyphs = this.stringToGlyphs(text);
	    for (var i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs[i];
	        callback(glyph, x, y, fontSize, options);
	        if (glyph.advanceWidth) {
	            x += glyph.advanceWidth * fontScale;
	        }
	
	        if (kerning && i < glyphs.length - 1) {
	            var kerningValue = this.getKerningValue(glyph, glyphs[i + 1]);
	            x += kerningValue * fontScale;
	        }
	    }
	};
	
	// Create a Path object that represents the given text.
	//
	// text - The text to create.
	// x - Horizontal position of the beginning of the text. (default: 0)
	// y - Vertical position of the *baseline* of the text. (default: 0)
	// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
	// Options is an optional object that contains:
	// - kerning - Whether to take kerning information into account. (default: true)
	//
	// Returns a Path object.
	Font.prototype.getPath = function(text, x, y, fontSize, options) {
	    var fullPath = new path.Path();
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        var glyphPath = glyph.getPath(gX, gY, gFontSize);
	        fullPath.extend(glyphPath);
	    });
	
	    return fullPath;
	};
	
	// Draw the text on the given drawing context.
	//
	// ctx - A 2D drawing context, like Canvas.
	// text - The text to create.
	// x - Horizontal position of the beginning of the text. (default: 0)
	// y - Vertical position of the *baseline* of the text. (default: 0)
	// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
	// Options is an optional object that contains:
	// - kerning - Whether to take kerning information into account. (default: true)
	Font.prototype.draw = function(ctx, text, x, y, fontSize, options) {
	    this.getPath(text, x, y, fontSize, options).draw(ctx);
	};
	
	// Draw the points of all glyphs in the text.
	// On-curve points will be drawn in blue, off-curve points will be drawn in red.
	//
	// ctx - A 2D drawing context, like Canvas.
	// text - The text to create.
	// x - Horizontal position of the beginning of the text. (default: 0)
	// y - Vertical position of the *baseline* of the text. (default: 0)
	// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
	// Options is an optional object that contains:
	// - kerning - Whether to take kerning information into account. (default: true)
	Font.prototype.drawPoints = function(ctx, text, x, y, fontSize, options) {
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        glyph.drawPoints(ctx, gX, gY, gFontSize);
	    });
	};
	
	// Draw lines indicating important font measurements for all glyphs in the text.
	// Black lines indicate the origin of the coordinate system (point 0,0).
	// Blue lines indicate the glyph bounding box.
	// Green line indicates the advance width of the glyph.
	//
	// ctx - A 2D drawing context, like Canvas.
	// text - The text to create.
	// x - Horizontal position of the beginning of the text. (default: 0)
	// y - Vertical position of the *baseline* of the text. (default: 0)
	// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
	// Options is an optional object that contains:
	// - kerning - Whether to take kerning information into account. (default: true)
	Font.prototype.drawMetrics = function(ctx, text, x, y, fontSize, options) {
	    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
	        glyph.drawMetrics(ctx, gX, gY, gFontSize);
	    });
	};
	
	// Validate
	Font.prototype.validate = function() {
	    var warnings = [];
	    var _this = this;
	
	    function assert(predicate, message) {
	        if (!predicate) {
	            warnings.push(message);
	        }
	    }
	
	    function assertStringAttribute(attrName) {
	        assert(_this[attrName] && _this[attrName].trim().length > 0, 'No ' + attrName + ' specified.');
	    }
	
	    // Identification information
	    assertStringAttribute('familyName');
	    assertStringAttribute('weightName');
	    assertStringAttribute('manufacturer');
	    assertStringAttribute('copyright');
	    assertStringAttribute('version');
	
	    // Dimension information
	    assert(this.unitsPerEm > 0, 'No unitsPerEm specified.');
	};
	
	// Convert the font object to a SFNT data structure.
	// This structure contains all the necessary tables and metadata to create a binary OTF file.
	Font.prototype.toTables = function() {
	    return sfnt.fontToTable(this);
	};
	
	Font.prototype.toBuffer = function() {
	    var sfntTable = this.toTables();
	    var bytes = sfntTable.encode();
	    var buffer = new ArrayBuffer(bytes.length);
	    var intArray = new Uint8Array(buffer);
	    for (var i = 0; i < bytes.length; i++) {
	        intArray[i] = bytes[i];
	    }
	
	    return buffer;
	};
	
	// Initiate a download of the OpenType font.
	Font.prototype.download = function() {
	    var fileName = this.familyName.replace(/\s/g, '') + '-' + this.styleName + '.otf';
	    var buffer = this.toBuffer();
	
	    window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;
	    window.requestFileSystem(window.TEMPORARY, buffer.byteLength, function(fs) {
	        fs.root.getFile(fileName, {create: true}, function(fileEntry) {
	            fileEntry.createWriter(function(writer) {
	                var dataView = new DataView(buffer);
	                var blob = new Blob([dataView], {type: 'font/opentype'});
	                writer.write(blob);
	
	                writer.addEventListener('writeend', function() {
	                    // Navigating to the file will download it.
	                    location.href = fileEntry.toURL();
	                }, false);
	            });
	        });
	    },
	
	    function(err) {
	        throw err;
	    });
	};
	
	exports.Font = Font;
	
	},{"./encoding":4,"./glyphset":7,"./path":10,"./tables/sfnt":25}],6:[function(_dereq_,module,exports){
	// The Glyph object
	
	'use strict';
	
	var check = _dereq_('./check');
	var draw = _dereq_('./draw');
	var path = _dereq_('./path');
	
	function getPathDefinition(glyph, path) {
	    var _path = path || { commands: [] };
	    return {
	        configurable: true,
	
	        get: function() {
	            if (typeof _path === 'function') {
	                _path = _path();
	            }
	
	            return _path;
	        },
	
	        set: function(p) {
	            _path = p;
	        }
	    };
	}
	
	// A Glyph is an individual mark that often corresponds to a character.
	// Some glyphs, such as ligatures, are a combination of many characters.
	// Glyphs are the basic building blocks of a font.
	//
	// The `Glyph` class contains utility methods for drawing the path and its points.
	function Glyph(options) {
	    // By putting all the code on a prototype function (which is only declared once)
	    // we reduce the memory requirements for larger fonts by some 2%
	    this.bindConstructorValues(options);
	}
	
	Glyph.prototype.bindConstructorValues = function(options) {
	    this.index = options.index || 0;
	
	    // These three values cannnot be deferred for memory optimization:
	    this.name = options.name || null;
	    this.unicode = options.unicode || undefined;
	    this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];
	
	    // But by binding these values only when necessary, we reduce can
	    // the memory requirements by almost 3% for larger fonts.
	    if (options.xMin) {
	        this.xMin = options.xMin;
	    }
	
	    if (options.yMin) {
	        this.yMin = options.yMin;
	    }
	
	    if (options.xMax) {
	        this.xMax = options.xMax;
	    }
	
	    if (options.yMax) {
	        this.yMax = options.yMax;
	    }
	
	    if (options.advanceWidth) {
	        this.advanceWidth = options.advanceWidth;
	    }
	
	    // The path for a glyph is the most memory intensive, and is bound as a value
	    // with a getter/setter to ensure we actually do path parsing only once the
	    // path is actually needed by anything.
	    Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
	};
	
	Glyph.prototype.addUnicode = function(unicode) {
	    if (this.unicodes.length === 0) {
	        this.unicode = unicode;
	    }
	
	    this.unicodes.push(unicode);
	};
	
	// Convert the glyph to a Path we can draw on a drawing context.
	//
	// x - Horizontal position of the glyph. (default: 0)
	// y - Vertical position of the *baseline* of the glyph. (default: 0)
	// fontSize - Font size, in pixels (default: 72).
	Glyph.prototype.getPath = function(x, y, fontSize) {
	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 72;
	    var scale = 1 / this.path.unitsPerEm * fontSize;
	    var p = new path.Path();
	    var commands = this.path.commands;
	    for (var i = 0; i < commands.length; i += 1) {
	        var cmd = commands[i];
	        if (cmd.type === 'M') {
	            p.moveTo(x + (cmd.x * scale), y + (-cmd.y * scale));
	        } else if (cmd.type === 'L') {
	            p.lineTo(x + (cmd.x * scale), y + (-cmd.y * scale));
	        } else if (cmd.type === 'Q') {
	            p.quadraticCurveTo(x + (cmd.x1 * scale), y + (-cmd.y1 * scale),
	                               x + (cmd.x * scale), y + (-cmd.y * scale));
	        } else if (cmd.type === 'C') {
	            p.curveTo(x + (cmd.x1 * scale), y + (-cmd.y1 * scale),
	                      x + (cmd.x2 * scale), y + (-cmd.y2 * scale),
	                      x + (cmd.x * scale), y + (-cmd.y * scale));
	        } else if (cmd.type === 'Z') {
	            p.closePath();
	        }
	    }
	
	    return p;
	};
	
	// Split the glyph into contours.
	// This function is here for backwards compatibility, and to
	// provide raw access to the TrueType glyph outlines.
	Glyph.prototype.getContours = function() {
	    if (this.points === undefined) {
	        return [];
	    }
	
	    var contours = [];
	    var currentContour = [];
	    for (var i = 0; i < this.points.length; i += 1) {
	        var pt = this.points[i];
	        currentContour.push(pt);
	        if (pt.lastPointOfContour) {
	            contours.push(currentContour);
	            currentContour = [];
	        }
	    }
	
	    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
	    return contours;
	};
	
	// Calculate the xMin/yMin/xMax/yMax/lsb/rsb for a Glyph.
	Glyph.prototype.getMetrics = function() {
	    var commands = this.path.commands;
	    var xCoords = [];
	    var yCoords = [];
	    for (var i = 0; i < commands.length; i += 1) {
	        var cmd = commands[i];
	        if (cmd.type !== 'Z') {
	            xCoords.push(cmd.x);
	            yCoords.push(cmd.y);
	        }
	
	        if (cmd.type === 'Q' || cmd.type === 'C') {
	            xCoords.push(cmd.x1);
	            yCoords.push(cmd.y1);
	        }
	
	        if (cmd.type === 'C') {
	            xCoords.push(cmd.x2);
	            yCoords.push(cmd.y2);
	        }
	    }
	
	    var metrics = {
	        xMin: Math.min.apply(null, xCoords),
	        yMin: Math.min.apply(null, yCoords),
	        xMax: Math.max.apply(null, xCoords),
	        yMax: Math.max.apply(null, yCoords),
	        leftSideBearing: 0
	    };
	    metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
	    return metrics;
	};
	
	// Draw the glyph on the given context.
	//
	// ctx - The drawing context.
	// x - Horizontal position of the glyph. (default: 0)
	// y - Vertical position of the *baseline* of the glyph. (default: 0)
	// fontSize - Font size, in pixels (default: 72).
	Glyph.prototype.draw = function(ctx, x, y, fontSize) {
	    this.getPath(x, y, fontSize).draw(ctx);
	};
	
	// Draw the points of the glyph.
	// On-curve points will be drawn in blue, off-curve points will be drawn in red.
	//
	// ctx - The drawing context.
	// x - Horizontal position of the glyph. (default: 0)
	// y - Vertical position of the *baseline* of the glyph. (default: 0)
	// fontSize - Font size, in pixels (default: 72).
	Glyph.prototype.drawPoints = function(ctx, x, y, fontSize) {
	
	    function drawCircles(l, x, y, scale) {
	        var PI_SQ = Math.PI * 2;
	        ctx.beginPath();
	        for (var j = 0; j < l.length; j += 1) {
	            ctx.moveTo(x + (l[j].x * scale), y + (l[j].y * scale));
	            ctx.arc(x + (l[j].x * scale), y + (l[j].y * scale), 2, 0, PI_SQ, false);
	        }
	
	        ctx.closePath();
	        ctx.fill();
	    }
	
	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 24;
	    var scale = 1 / this.path.unitsPerEm * fontSize;
	
	    var blueCircles = [];
	    var redCircles = [];
	    var path = this.path;
	    for (var i = 0; i < path.commands.length; i += 1) {
	        var cmd = path.commands[i];
	        if (cmd.x !== undefined) {
	            blueCircles.push({x: cmd.x, y: -cmd.y});
	        }
	
	        if (cmd.x1 !== undefined) {
	            redCircles.push({x: cmd.x1, y: -cmd.y1});
	        }
	
	        if (cmd.x2 !== undefined) {
	            redCircles.push({x: cmd.x2, y: -cmd.y2});
	        }
	    }
	
	    ctx.fillStyle = 'blue';
	    drawCircles(blueCircles, x, y, scale);
	    ctx.fillStyle = 'red';
	    drawCircles(redCircles, x, y, scale);
	};
	
	// Draw lines indicating important font measurements.
	// Black lines indicate the origin of the coordinate system (point 0,0).
	// Blue lines indicate the glyph bounding box.
	// Green line indicates the advance width of the glyph.
	//
	// ctx - The drawing context.
	// x - Horizontal position of the glyph. (default: 0)
	// y - Vertical position of the *baseline* of the glyph. (default: 0)
	// fontSize - Font size, in pixels (default: 72).
	Glyph.prototype.drawMetrics = function(ctx, x, y, fontSize) {
	    var scale;
	    x = x !== undefined ? x : 0;
	    y = y !== undefined ? y : 0;
	    fontSize = fontSize !== undefined ? fontSize : 24;
	    scale = 1 / this.path.unitsPerEm * fontSize;
	    ctx.lineWidth = 1;
	
	    // Draw the origin
	    ctx.strokeStyle = 'black';
	    draw.line(ctx, x, -10000, x, 10000);
	    draw.line(ctx, -10000, y, 10000, y);
	
	    // This code is here due to memory optimization: by not using
	    // defaults in the constructor, we save a notable amount of memory.
	    var xMin = this.xMin || 0;
	    var yMin = this.yMin || 0;
	    var xMax = this.xMax || 0;
	    var yMax = this.yMax || 0;
	    var advanceWidth = this.advanceWidth || 0;
	
	    // Draw the glyph box
	    ctx.strokeStyle = 'blue';
	    draw.line(ctx, x + (xMin * scale), -10000, x + (xMin * scale), 10000);
	    draw.line(ctx, x + (xMax * scale), -10000, x + (xMax * scale), 10000);
	    draw.line(ctx, -10000, y + (-yMin * scale), 10000, y + (-yMin * scale));
	    draw.line(ctx, -10000, y + (-yMax * scale), 10000, y + (-yMax * scale));
	
	    // Draw the advance width
	    ctx.strokeStyle = 'green';
	    draw.line(ctx, x + (advanceWidth * scale), -10000, x + (advanceWidth * scale), 10000);
	};
	
	exports.Glyph = Glyph;
	
	},{"./check":2,"./draw":3,"./path":10}],7:[function(_dereq_,module,exports){
	// The GlyphSet object
	
	'use strict';
	
	var _glyph = _dereq_('./glyph');
	
	// A GlyphSet represents all glyphs available in the font, but modelled using
	// a deferred glyph loader, for retrieving glyphs only once they are absolutely
	// necessary, to keep the memory footprint down.
	function GlyphSet(font, glyphs) {
	    this.font = font;
	    this.glyphs = {};
	    if (Array.isArray(glyphs)) {
	        for (var i = 0; i < glyphs.length; i++) {
	            this.glyphs[i] = glyphs[i];
	        }
	    }
	
	    this.length = (glyphs && glyphs.length) || 0;
	}
	
	GlyphSet.prototype.get = function(index) {
	    if (typeof this.glyphs[index] === 'function') {
	        this.glyphs[index] = this.glyphs[index]();
	    }
	
	    return this.glyphs[index];
	};
	
	GlyphSet.prototype.push = function(index, loader) {
	    this.glyphs[index] = loader;
	    this.length++;
	};
	
	function glyphLoader(font, index) {
	    return new _glyph.Glyph({index: index, font: font});
	}
	
	/**
	 * Generate a stub glyph that can be filled with all metadata *except*
	 * the "points" and "path" properties, which must be loaded only once
	 * the glyph's path is actually requested for text shaping.
	 */
	
	function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
	    return function() {
	        var glyph = new _glyph.Glyph({index: index, font: font});
	
	        glyph.path = function() {
	            parseGlyph(glyph, data, position);
	            var path = buildPath(font.glyphs, glyph);
	            path.unitsPerEm = font.unitsPerEm;
	            return path;
	        };
	
	        return glyph;
	    };
	}
	
	function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
	    return function() {
	        var glyph = new _glyph.Glyph({index: index, font: font});
	
	        glyph.path = function() {
	            var path = parseCFFCharstring(font, glyph, charstring);
	            path.unitsPerEm = font.unitsPerEm;
	            return path;
	        };
	
	        return glyph;
	    };
	}
	
	exports.GlyphSet = GlyphSet;
	exports.glyphLoader = glyphLoader;
	exports.ttfGlyphLoader = ttfGlyphLoader;
	exports.cffGlyphLoader = cffGlyphLoader;
	
	},{"./glyph":6}],8:[function(_dereq_,module,exports){
	// opentype.js
	// https://github.com/nodebox/opentype.js
	// (c) 2015 Frederik De Bleser
	// opentype.js may be freely distributed under the MIT license.
	
	/* global ArrayBuffer, DataView, Uint8Array, XMLHttpRequest  */
	
	'use strict';
	
	var encoding = _dereq_('./encoding');
	var _font = _dereq_('./font');
	var glyph = _dereq_('./glyph');
	var parse = _dereq_('./parse');
	var path = _dereq_('./path');
	
	var cmap = _dereq_('./tables/cmap');
	var cff = _dereq_('./tables/cff');
	var glyf = _dereq_('./tables/glyf');
	var gpos = _dereq_('./tables/gpos');
	var head = _dereq_('./tables/head');
	var hhea = _dereq_('./tables/hhea');
	var hmtx = _dereq_('./tables/hmtx');
	var kern = _dereq_('./tables/kern');
	var loca = _dereq_('./tables/loca');
	var maxp = _dereq_('./tables/maxp');
	var _name = _dereq_('./tables/name');
	var os2 = _dereq_('./tables/os2');
	var post = _dereq_('./tables/post');
	
	// File loaders /////////////////////////////////////////////////////////
	
	// Convert a Node.js Buffer to an ArrayBuffer
	function toArrayBuffer(buffer) {
	    var arrayBuffer = new ArrayBuffer(buffer.length);
	    var data = new Uint8Array(arrayBuffer);
	    for (var i = 0; i < buffer.length; i += 1) {
	        data[i] = buffer[i];
	    }
	
	    return arrayBuffer;
	}
	
	function loadFromFile(path, callback) {
	    var fs = _dereq_('fs');
	    fs.readFile(path, function(err, buffer) {
	        if (err) {
	            return callback(err.message);
	        }
	
	        callback(null, toArrayBuffer(buffer));
	    });
	}
	
	function loadFromUrl(url, callback) {
	    var request = new XMLHttpRequest();
	    request.open('get', url, true);
	    request.responseType = 'arraybuffer';
	    request.onload = function() {
	        if (request.status !== 200) {
	            return callback('Font could not be loaded: ' + request.statusText);
	        }
	
	        return callback(null, request.response);
	    };
	
	    request.send();
	}
	
	// Public API ///////////////////////////////////////////////////////////
	
	// Parse the OpenType file data (as an ArrayBuffer) and return a Font object.
	// If the file could not be parsed (most likely because it contains Postscript outlines)
	// we return an empty Font object with the `supported` flag set to `false`.
	function parseBuffer(buffer) {
	    var indexToLocFormat;
	    var hmtxOffset;
	    var glyfOffset;
	    var locaOffset;
	    var cffOffset;
	    var kernOffset;
	    var gposOffset;
	
	    // OpenType fonts use big endian byte ordering.
	    // We can't rely on typed array view types, because they operate with the endianness of the host computer.
	    // Instead we use DataViews where we can specify endianness.
	
	    var font = new _font.Font();
	    var data = new DataView(buffer, 0);
	
	    var version = parse.getFixed(data, 0);
	    if (version === 1.0) {
	        font.outlinesFormat = 'truetype';
	    } else {
	        version = parse.getTag(data, 0);
	        if (version === 'OTTO') {
	            font.outlinesFormat = 'cff';
	        } else {
	            throw new Error('Unsupported OpenType version ' + version);
	        }
	    }
	
	    var numTables = parse.getUShort(data, 4);
	
	    // Offset into the table records.
	    var p = 12;
	    for (var i = 0; i < numTables; i += 1) {
	        var tag = parse.getTag(data, p);
	        var offset = parse.getULong(data, p + 8);
	        switch (tag) {
	        case 'cmap':
	            font.tables.cmap = cmap.parse(data, offset);
	            font.encoding = new encoding.CmapEncoding(font.tables.cmap);
	            if (!font.encoding) {
	                font.supported = false;
	            }
	
	            break;
	        case 'head':
	            font.tables.head = head.parse(data, offset);
	            font.unitsPerEm = font.tables.head.unitsPerEm;
	            indexToLocFormat = font.tables.head.indexToLocFormat;
	            break;
	        case 'hhea':
	            font.tables.hhea = hhea.parse(data, offset);
	            font.ascender = font.tables.hhea.ascender;
	            font.descender = font.tables.hhea.descender;
	            font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
	            break;
	        case 'hmtx':
	            hmtxOffset = offset;
	            break;
	        case 'maxp':
	            font.tables.maxp = maxp.parse(data, offset);
	            font.numGlyphs = font.tables.maxp.numGlyphs;
	            break;
	        case 'name':
	            font.tables.name = _name.parse(data, offset);
	            font.familyName = font.tables.name.fontFamily;
	            font.styleName = font.tables.name.fontSubfamily;
	            break;
	        case 'OS/2':
	            font.tables.os2 = os2.parse(data, offset);
	            break;
	        case 'post':
	            font.tables.post = post.parse(data, offset);
	            font.glyphNames = new encoding.GlyphNames(font.tables.post);
	            break;
	        case 'glyf':
	            glyfOffset = offset;
	            break;
	        case 'loca':
	            locaOffset = offset;
	            break;
	        case 'CFF ':
	            cffOffset = offset;
	            break;
	        case 'kern':
	            kernOffset = offset;
	            break;
	        case 'GPOS':
	            gposOffset = offset;
	            break;
	        }
	        p += 16;
	    }
	
	    if (glyfOffset && locaOffset) {
	        var shortVersion = indexToLocFormat === 0;
	        var locaTable = loca.parse(data, locaOffset, font.numGlyphs, shortVersion);
	        font.glyphs = glyf.parse(data, glyfOffset, locaTable, font);
	        hmtx.parse(data, hmtxOffset, font.numberOfHMetrics, font.numGlyphs, font.glyphs);
	        encoding.addGlyphNames(font);
	    } else if (cffOffset) {
	        cff.parse(data, cffOffset, font);
	        encoding.addGlyphNames(font);
	    } else {
	        font.supported = false;
	    }
	
	    if (font.supported) {
	        if (kernOffset) {
	            font.kerningPairs = kern.parse(data, kernOffset);
	        } else {
	            font.kerningPairs = {};
	        }
	
	        if (gposOffset) {
	            gpos.parse(data, gposOffset, font);
	        }
	    }
	
	    return font;
	}
	
	// Asynchronously load the font from a URL or a filesystem. When done, call the callback
	// with two arguments `(err, font)`. The `err` will be null on success,
	// the `font` is a Font object.
	//
	// We use the node.js callback convention so that
	// opentype.js can integrate with frameworks like async.js.
	function load(url, callback) {
	    var isNode = typeof window === 'undefined';
	    var loadFn = isNode ? loadFromFile : loadFromUrl;
	    loadFn(url, function(err, arrayBuffer) {
	        if (err) {
	            return callback(err);
	        }
	
	        var font = parseBuffer(arrayBuffer);
	        if (!font.supported) {
	            return callback('Font is not supported (is this a Postscript font?)');
	        }
	
	        return callback(null, font);
	    });
	}
	
	exports._parse = parse;
	exports.Font = _font.Font;
	exports.Glyph = glyph.Glyph;
	exports.Path = path.Path;
	exports.parse = parseBuffer;
	exports.load = load;
	
	},{"./encoding":4,"./font":5,"./glyph":6,"./parse":9,"./path":10,"./tables/cff":12,"./tables/cmap":13,"./tables/glyf":14,"./tables/gpos":15,"./tables/head":16,"./tables/hhea":17,"./tables/hmtx":18,"./tables/kern":19,"./tables/loca":20,"./tables/maxp":21,"./tables/name":22,"./tables/os2":23,"./tables/post":24,"fs":1}],9:[function(_dereq_,module,exports){
	// Parsing utility functions
	
	'use strict';
	
	// Retrieve an unsigned byte from the DataView.
	exports.getByte = function getByte(dataView, offset) {
	    return dataView.getUint8(offset);
	};
	
	exports.getCard8 = exports.getByte;
	
	// Retrieve an unsigned 16-bit short from the DataView.
	// The value is stored in big endian.
	exports.getUShort = function(dataView, offset) {
	    return dataView.getUint16(offset, false);
	};
	
	exports.getCard16 = exports.getUShort;
	
	// Retrieve a signed 16-bit short from the DataView.
	// The value is stored in big endian.
	exports.getShort = function(dataView, offset) {
	    return dataView.getInt16(offset, false);
	};
	
	// Retrieve an unsigned 32-bit long from the DataView.
	// The value is stored in big endian.
	exports.getULong = function(dataView, offset) {
	    return dataView.getUint32(offset, false);
	};
	
	// Retrieve a 32-bit signed fixed-point number (16.16) from the DataView.
	// The value is stored in big endian.
	exports.getFixed = function(dataView, offset) {
	    var decimal = dataView.getInt16(offset, false);
	    var fraction = dataView.getUint16(offset + 2, false);
	    return decimal + fraction / 65535;
	};
	
	// Retrieve a 4-character tag from the DataView.
	// Tags are used to identify tables.
	exports.getTag = function(dataView, offset) {
	    var tag = '';
	    for (var i = offset; i < offset + 4; i += 1) {
	        tag += String.fromCharCode(dataView.getInt8(i));
	    }
	
	    return tag;
	};
	
	// Retrieve an offset from the DataView.
	// Offsets are 1 to 4 bytes in length, depending on the offSize argument.
	exports.getOffset = function(dataView, offset, offSize) {
	    var v = 0;
	    for (var i = 0; i < offSize; i += 1) {
	        v <<= 8;
	        v += dataView.getUint8(offset + i);
	    }
	
	    return v;
	};
	
	// Retrieve a number of bytes from start offset to the end offset from the DataView.
	exports.getBytes = function(dataView, startOffset, endOffset) {
	    var bytes = [];
	    for (var i = startOffset; i < endOffset; i += 1) {
	        bytes.push(dataView.getUint8(i));
	    }
	
	    return bytes;
	};
	
	// Convert the list of bytes to a string.
	exports.bytesToString = function(bytes) {
	    var s = '';
	    for (var i = 0; i < bytes.length; i += 1) {
	        s += String.fromCharCode(bytes[i]);
	    }
	
	    return s;
	};
	
	var typeOffsets = {
	    byte: 1,
	    uShort: 2,
	    short: 2,
	    uLong: 4,
	    fixed: 4,
	    longDateTime: 8,
	    tag: 4
	};
	
	// A stateful parser that changes the offset whenever a value is retrieved.
	// The data is a DataView.
	function Parser(data, offset) {
	    this.data = data;
	    this.offset = offset;
	    this.relativeOffset = 0;
	}
	
	Parser.prototype.parseByte = function() {
	    var v = this.data.getUint8(this.offset + this.relativeOffset);
	    this.relativeOffset += 1;
	    return v;
	};
	
	Parser.prototype.parseChar = function() {
	    var v = this.data.getInt8(this.offset + this.relativeOffset);
	    this.relativeOffset += 1;
	    return v;
	};
	
	Parser.prototype.parseCard8 = Parser.prototype.parseByte;
	
	Parser.prototype.parseUShort = function() {
	    var v = this.data.getUint16(this.offset + this.relativeOffset);
	    this.relativeOffset += 2;
	    return v;
	};
	
	Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
	Parser.prototype.parseSID = Parser.prototype.parseUShort;
	Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;
	
	Parser.prototype.parseShort = function() {
	    var v = this.data.getInt16(this.offset + this.relativeOffset);
	    this.relativeOffset += 2;
	    return v;
	};
	
	Parser.prototype.parseF2Dot14 = function() {
	    var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
	    this.relativeOffset += 2;
	    return v;
	};
	
	Parser.prototype.parseULong = function() {
	    var v = exports.getULong(this.data, this.offset + this.relativeOffset);
	    this.relativeOffset += 4;
	    return v;
	};
	
	Parser.prototype.parseFixed = function() {
	    var v = exports.getFixed(this.data, this.offset + this.relativeOffset);
	    this.relativeOffset += 4;
	    return v;
	};
	
	Parser.prototype.parseOffset16List =
	Parser.prototype.parseUShortList = function(count) {
	    var offsets = new Array(count);
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    for (var i = 0; i < count; i++) {
	        offsets[i] = exports.getUShort(dataView, offset);
	        offset += 2;
	    }
	
	    this.relativeOffset += count * 2;
	    return offsets;
	};
	
	Parser.prototype.parseString = function(length) {
	    var dataView = this.data;
	    var offset = this.offset + this.relativeOffset;
	    var string = '';
	    this.relativeOffset += length;
	    for (var i = 0; i < length; i++) {
	        string += String.fromCharCode(dataView.getUint8(offset + i));
	    }
	
	    return string;
	};
	
	Parser.prototype.parseTag = function() {
	    return this.parseString(4);
	};
	
	// LONGDATETIME is a 64-bit integer.
	// JavaScript and unix timestamps traditionally use 32 bits, so we
	// only take the last 32 bits.
	Parser.prototype.parseLongDateTime = function() {
	    var v = exports.getULong(this.data, this.offset + this.relativeOffset + 4);
	    this.relativeOffset += 8;
	    return v;
	};
	
	Parser.prototype.parseFixed = function() {
	    var v = exports.getULong(this.data, this.offset + this.relativeOffset);
	    this.relativeOffset += 4;
	    return v / 65536;
	};
	
	Parser.prototype.parseVersion = function() {
	    var major = exports.getUShort(this.data, this.offset + this.relativeOffset);
	
	    // How to interpret the minor version is very vague in the spec. 0x5000 is 5, 0x1000 is 1
	    // This returns the correct number if minor = 0xN000 where N is 0-9
	    var minor = exports.getUShort(this.data, this.offset + this.relativeOffset + 2);
	    this.relativeOffset += 4;
	    return major + minor / 0x1000 / 10;
	};
	
	Parser.prototype.skip = function(type, amount) {
	    if (amount === undefined) {
	        amount = 1;
	    }
	
	    this.relativeOffset += typeOffsets[type] * amount;
	};
	
	exports.Parser = Parser;
	
	},{}],10:[function(_dereq_,module,exports){
	// Geometric objects
	
	'use strict';
	
	// A bézier path containing a set of path commands similar to a SVG path.
	// Paths can be drawn on a context using `draw`.
	function Path() {
	    this.commands = [];
	    this.fill = 'black';
	    this.stroke = null;
	    this.strokeWidth = 1;
	}
	
	Path.prototype.moveTo = function(x, y) {
	    this.commands.push({
	        type: 'M',
	        x: x,
	        y: y
	    });
	};
	
	Path.prototype.lineTo = function(x, y) {
	    this.commands.push({
	        type: 'L',
	        x: x,
	        y: y
	    });
	};
	
	Path.prototype.curveTo = Path.prototype.bezierCurveTo = function(x1, y1, x2, y2, x, y) {
	    this.commands.push({
	        type: 'C',
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        x: x,
	        y: y
	    });
	};
	
	Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function(x1, y1, x, y) {
	    this.commands.push({
	        type: 'Q',
	        x1: x1,
	        y1: y1,
	        x: x,
	        y: y
	    });
	};
	
	Path.prototype.close = Path.prototype.closePath = function() {
	    this.commands.push({
	        type: 'Z'
	    });
	};
	
	// Add the given path or list of commands to the commands of this path.
	Path.prototype.extend = function(pathOrCommands) {
	    if (pathOrCommands.commands) {
	        pathOrCommands = pathOrCommands.commands;
	    }
	
	    Array.prototype.push.apply(this.commands, pathOrCommands);
	};
	
	// Draw the path to a 2D context.
	Path.prototype.draw = function(ctx) {
	    ctx.beginPath();
	    for (var i = 0; i < this.commands.length; i += 1) {
	        var cmd = this.commands[i];
	        if (cmd.type === 'M') {
	            ctx.moveTo(cmd.x, cmd.y);
	        } else if (cmd.type === 'L') {
	            ctx.lineTo(cmd.x, cmd.y);
	        } else if (cmd.type === 'C') {
	            ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	        } else if (cmd.type === 'Q') {
	            ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
	        } else if (cmd.type === 'Z') {
	            ctx.closePath();
	        }
	    }
	
	    if (this.fill) {
	        ctx.fillStyle = this.fill;
	        ctx.fill();
	    }
	
	    if (this.stroke) {
	        ctx.strokeStyle = this.stroke;
	        ctx.lineWidth = this.strokeWidth;
	        ctx.stroke();
	    }
	};
	
	// Convert the Path to a string of path data instructions
	// See http://www.w3.org/TR/SVG/paths.html#PathData
	// Parameters:
	// - decimalPlaces: The amount of decimal places for floating-point values (default: 2)
	Path.prototype.toPathData = function(decimalPlaces) {
	    decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;
	
	    function floatToString(v) {
	        if (Math.round(v) === v) {
	            return '' + Math.round(v);
	        } else {
	            return v.toFixed(decimalPlaces);
	        }
	    }
	
	    function packValues() {
	        var s = '';
	        for (var i = 0; i < arguments.length; i += 1) {
	            var v = arguments[i];
	            if (v >= 0 && i > 0) {
	                s += ' ';
	            }
	
	            s += floatToString(v);
	        }
	
	        return s;
	    }
	
	    var d = '';
	    for (var i = 0; i < this.commands.length; i += 1) {
	        var cmd = this.commands[i];
	        if (cmd.type === 'M') {
	            d += 'M' + packValues(cmd.x, cmd.y);
	        } else if (cmd.type === 'L') {
	            d += 'L' + packValues(cmd.x, cmd.y);
	        } else if (cmd.type === 'C') {
	            d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	        } else if (cmd.type === 'Q') {
	            d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
	        } else if (cmd.type === 'Z') {
	            d += 'Z';
	        }
	    }
	
	    return d;
	};
	
	// Convert the path to a SVG <path> element, as a string.
	// Parameters:
	// - decimalPlaces: The amount of decimal places for floating-point values (default: 2)
	Path.prototype.toSVG = function(decimalPlaces) {
	    var svg = '<path d="';
	    svg += this.toPathData(decimalPlaces);
	    svg += '"';
	    if (this.fill & this.fill !== 'black') {
	        if (this.fill === null) {
	            svg += ' fill="none"';
	        } else {
	            svg += ' fill="' + this.fill + '"';
	        }
	    }
	
	    if (this.stroke) {
	        svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
	    }
	
	    svg += '/>';
	    return svg;
	};
	
	exports.Path = Path;
	
	},{}],11:[function(_dereq_,module,exports){
	// Table metadata
	
	'use strict';
	
	var check = _dereq_('./check');
	var encode = _dereq_('./types').encode;
	var sizeOf = _dereq_('./types').sizeOf;
	
	function Table(tableName, fields, options) {
	    var i;
	    for (i = 0; i < fields.length; i += 1) {
	        var field = fields[i];
	        this[field.name] = field.value;
	    }
	
	    this.tableName = tableName;
	    this.fields = fields;
	    if (options) {
	        var optionKeys = Object.keys(options);
	        for (i = 0; i < optionKeys.length; i += 1) {
	            var k = optionKeys[i];
	            var v = options[k];
	            if (this[k] !== undefined) {
	                this[k] = v;
	            }
	        }
	    }
	}
	
	Table.prototype.sizeOf = function() {
	    var v = 0;
	    for (var i = 0; i < this.fields.length; i += 1) {
	        var field = this.fields[i];
	        var value = this[field.name];
	        if (value === undefined) {
	            value = field.value;
	        }
	
	        if (typeof value.sizeOf === 'function') {
	            v += value.sizeOf();
	        } else {
	            var sizeOfFunction = sizeOf[field.type];
	            check.assert(typeof sizeOfFunction === 'function', 'Could not find sizeOf function for field' + field.name);
	            v += sizeOfFunction(value);
	        }
	    }
	
	    return v;
	};
	
	Table.prototype.encode = function() {
	    return encode.TABLE(this);
	};
	
	exports.Table = Table;
	
	},{"./check":2,"./types":26}],12:[function(_dereq_,module,exports){
	// The `CFF` table contains the glyph outlines in PostScript format.
	// https://www.microsoft.com/typography/OTSPEC/cff.htm
	// http://download.microsoft.com/download/8/0/1/801a191c-029d-4af3-9642-555f6fe514ee/cff.pdf
	// http://download.microsoft.com/download/8/0/1/801a191c-029d-4af3-9642-555f6fe514ee/type2.pdf
	
	'use strict';
	
	var encoding = _dereq_('../encoding');
	var glyphset = _dereq_('../glyphset');
	var parse = _dereq_('../parse');
	var path = _dereq_('../path');
	var table = _dereq_('../table');
	
	// Custom equals function that can also check lists.
	function equals(a, b) {
	    if (a === b) {
	        return true;
	    } else if (Array.isArray(a) && Array.isArray(b)) {
	        if (a.length !== b.length) {
	            return false;
	        }
	
	        for (var i = 0; i < a.length; i += 1) {
	            if (!equals(a[i], b[i])) {
	                return false;
	            }
	        }
	
	        return true;
	    } else {
	        return false;
	    }
	}
	
	// Parse a `CFF` INDEX array.
	// An index array consists of a list of offsets, then a list of objects at those offsets.
	function parseCFFIndex(data, start, conversionFn) {
	    //var i, objectOffset, endOffset;
	    var offsets = [];
	    var objects = [];
	    var count = parse.getCard16(data, start);
	    var i;
	    var objectOffset;
	    var endOffset;
	    if (count !== 0) {
	        var offsetSize = parse.getByte(data, start + 2);
	        objectOffset = start + ((count + 1) * offsetSize) + 2;
	        var pos = start + 3;
	        for (i = 0; i < count + 1; i += 1) {
	            offsets.push(parse.getOffset(data, pos, offsetSize));
	            pos += offsetSize;
	        }
	
	        // The total size of the index array is 4 header bytes + the value of the last offset.
	        endOffset = objectOffset + offsets[count];
	    } else {
	        endOffset = start + 2;
	    }
	
	    for (i = 0; i < offsets.length - 1; i += 1) {
	        var value = parse.getBytes(data, objectOffset + offsets[i], objectOffset + offsets[i + 1]);
	        if (conversionFn) {
	            value = conversionFn(value);
	        }
	
	        objects.push(value);
	    }
	
	    return {objects: objects, startOffset: start, endOffset: endOffset};
	}
	
	// Parse a `CFF` DICT real value.
	function parseFloatOperand(parser) {
	    var s = '';
	    var eof = 15;
	    var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
	    while (true) {
	        var b = parser.parseByte();
	        var n1 = b >> 4;
	        var n2 = b & 15;
	
	        if (n1 === eof) {
	            break;
	        }
	
	        s += lookup[n1];
	
	        if (n2 === eof) {
	            break;
	        }
	
	        s += lookup[n2];
	    }
	
	    return parseFloat(s);
	}
	
	// Parse a `CFF` DICT operand.
	function parseOperand(parser, b0) {
	    var b1;
	    var b2;
	    var b3;
	    var b4;
	    if (b0 === 28) {
	        b1 = parser.parseByte();
	        b2 = parser.parseByte();
	        return b1 << 8 | b2;
	    }
	
	    if (b0 === 29) {
	        b1 = parser.parseByte();
	        b2 = parser.parseByte();
	        b3 = parser.parseByte();
	        b4 = parser.parseByte();
	        return b1 << 24 | b2 << 16 | b3 << 8 | b4;
	    }
	
	    if (b0 === 30) {
	        return parseFloatOperand(parser);
	    }
	
	    if (b0 >= 32 && b0 <= 246) {
	        return b0 - 139;
	    }
	
	    if (b0 >= 247 && b0 <= 250) {
	        b1 = parser.parseByte();
	        return (b0 - 247) * 256 + b1 + 108;
	    }
	
	    if (b0 >= 251 && b0 <= 254) {
	        b1 = parser.parseByte();
	        return -(b0 - 251) * 256 - b1 - 108;
	    }
	
	    throw new Error('Invalid b0 ' + b0);
	}
	
	// Convert the entries returned by `parseDict` to a proper dictionary.
	// If a value is a list of one, it is unpacked.
	function entriesToObject(entries) {
	    var o = {};
	    for (var i = 0; i < entries.length; i += 1) {
	        var key = entries[i][0];
	        var values = entries[i][1];
	        var value;
	        if (values.length === 1) {
	            value = values[0];
	        } else {
	            value = values;
	        }
	
	        if (o.hasOwnProperty(key)) {
	            throw new Error('Object ' + o + ' already has key ' + key);
	        }
	
	        o[key] = value;
	    }
	
	    return o;
	}
	
	// Parse a `CFF` DICT object.
	// A dictionary contains key-value pairs in a compact tokenized format.
	function parseCFFDict(data, start, size) {
	    start = start !== undefined ? start : 0;
	    var parser = new parse.Parser(data, start);
	    var entries = [];
	    var operands = [];
	    size = size !== undefined ? size : data.length;
	
	    while (parser.relativeOffset < size) {
	        var op = parser.parseByte();
	
	        // The first byte for each dict item distinguishes between operator (key) and operand (value).
	        // Values <= 21 are operators.
	        if (op <= 21) {
	            // Two-byte operators have an initial escape byte of 12.
	            if (op === 12) {
	                op = 1200 + parser.parseByte();
	            }
	
	            entries.push([op, operands]);
	            operands = [];
	        } else {
	            // Since the operands (values) come before the operators (keys), we store all operands in a list
	            // until we encounter an operator.
	            operands.push(parseOperand(parser, op));
	        }
	    }
	
	    return entriesToObject(entries);
	}
	
	// Given a String Index (SID), return the value of the string.
	// Strings below index 392 are standard CFF strings and are not encoded in the font.
	function getCFFString(strings, index) {
	    if (index <= 390) {
	        index = encoding.cffStandardStrings[index];
	    } else {
	        index = strings[index - 391];
	    }
	
	    return index;
	}
	
	// Interpret a dictionary and return a new dictionary with readable keys and values for missing entries.
	// This function takes `meta` which is a list of objects containing `operand`, `name` and `default`.
	function interpretDict(dict, meta, strings) {
	    var newDict = {};
	
	    // Because we also want to include missing values, we start out from the meta list
	    // and lookup values in the dict.
	    for (var i = 0; i < meta.length; i += 1) {
	        var m = meta[i];
	        var value = dict[m.op];
	        if (value === undefined) {
	            value = m.value !== undefined ? m.value : null;
	        }
	
	        if (m.type === 'SID') {
	            value = getCFFString(strings, value);
	        }
	
	        newDict[m.name] = value;
	    }
	
	    return newDict;
	}
	
	// Parse the CFF header.
	function parseCFFHeader(data, start) {
	    var header = {};
	    header.formatMajor = parse.getCard8(data, start);
	    header.formatMinor = parse.getCard8(data, start + 1);
	    header.size = parse.getCard8(data, start + 2);
	    header.offsetSize = parse.getCard8(data, start + 3);
	    header.startOffset = start;
	    header.endOffset = start + 4;
	    return header;
	}
	
	var TOP_DICT_META = [
	    {name: 'version', op: 0, type: 'SID'},
	    {name: 'notice', op: 1, type: 'SID'},
	    {name: 'copyright', op: 1200, type: 'SID'},
	    {name: 'fullName', op: 2, type: 'SID'},
	    {name: 'familyName', op: 3, type: 'SID'},
	    {name: 'weight', op: 4, type: 'SID'},
	    {name: 'isFixedPitch', op: 1201, type: 'number', value: 0},
	    {name: 'italicAngle', op: 1202, type: 'number', value: 0},
	    {name: 'underlinePosition', op: 1203, type: 'number', value: -100},
	    {name: 'underlineThickness', op: 1204, type: 'number', value: 50},
	    {name: 'paintType', op: 1205, type: 'number', value: 0},
	    {name: 'charstringType', op: 1206, type: 'number', value: 2},
	    {name: 'fontMatrix', op: 1207, type: ['real', 'real', 'real', 'real', 'real', 'real'], value: [0.001, 0, 0, 0.001, 0, 0]},
	    {name: 'uniqueId', op: 13, type: 'number'},
	    {name: 'fontBBox', op: 5, type: ['number', 'number', 'number', 'number'], value: [0, 0, 0, 0]},
	    {name: 'strokeWidth', op: 1208, type: 'number', value: 0},
	    {name: 'xuid', op: 14, type: [], value: null},
	    {name: 'charset', op: 15, type: 'offset', value: 0},
	    {name: 'encoding', op: 16, type: 'offset', value: 0},
	    {name: 'charStrings', op: 17, type: 'offset', value: 0},
	    {name: 'private', op: 18, type: ['number', 'offset'], value: [0, 0]}
	];
	
	var PRIVATE_DICT_META = [
	    {name: 'subrs', op: 19, type: 'offset', value: 0},
	    {name: 'defaultWidthX', op: 20, type: 'number', value: 0},
	    {name: 'nominalWidthX', op: 21, type: 'number', value: 0}
	];
	
	// Parse the CFF top dictionary. A CFF table can contain multiple fonts, each with their own top dictionary.
	// The top dictionary contains the essential metadata for the font, together with the private dictionary.
	function parseCFFTopDict(data, strings) {
	    var dict = parseCFFDict(data, 0, data.byteLength);
	    return interpretDict(dict, TOP_DICT_META, strings);
	}
	
	// Parse the CFF private dictionary. We don't fully parse out all the values, only the ones we need.
	function parseCFFPrivateDict(data, start, size, strings) {
	    var dict = parseCFFDict(data, start, size);
	    return interpretDict(dict, PRIVATE_DICT_META, strings);
	}
	
	// Parse the CFF charset table, which contains internal names for all the glyphs.
	// This function will return a list of glyph names.
	// See Adobe TN #5176 chapter 13, "Charsets".
	function parseCFFCharset(data, start, nGlyphs, strings) {
	    var i;
	    var sid;
	    var count;
	    var parser = new parse.Parser(data, start);
	
	    // The .notdef glyph is not included, so subtract 1.
	    nGlyphs -= 1;
	    var charset = ['.notdef'];
	
	    var format = parser.parseCard8();
	    if (format === 0) {
	        for (i = 0; i < nGlyphs; i += 1) {
	            sid = parser.parseSID();
	            charset.push(getCFFString(strings, sid));
	        }
	    } else if (format === 1) {
	        while (charset.length <= nGlyphs) {
	            sid = parser.parseSID();
	            count = parser.parseCard8();
	            for (i = 0; i <= count; i += 1) {
	                charset.push(getCFFString(strings, sid));
	                sid += 1;
	            }
	        }
	    } else if (format === 2) {
	        while (charset.length <= nGlyphs) {
	            sid = parser.parseSID();
	            count = parser.parseCard16();
	            for (i = 0; i <= count; i += 1) {
	                charset.push(getCFFString(strings, sid));
	                sid += 1;
	            }
	        }
	    } else {
	        throw new Error('Unknown charset format ' + format);
	    }
	
	    return charset;
	}
	
	// Parse the CFF encoding data. Only one encoding can be specified per font.
	// See Adobe TN #5176 chapter 12, "Encodings".
	function parseCFFEncoding(data, start, charset) {
	    var i;
	    var code;
	    var enc = {};
	    var parser = new parse.Parser(data, start);
	    var format = parser.parseCard8();
	    if (format === 0) {
	        var nCodes = parser.parseCard8();
	        for (i = 0; i < nCodes; i += 1) {
	            code = parser.parseCard8();
	            enc[code] = i;
	        }
	    } else if (format === 1) {
	        var nRanges = parser.parseCard8();
	        code = 1;
	        for (i = 0; i < nRanges; i += 1) {
	            var first = parser.parseCard8();
	            var nLeft = parser.parseCard8();
	            for (var j = first; j <= first + nLeft; j += 1) {
	                enc[j] = code;
	                code += 1;
	            }
	        }
	    } else {
	        throw new Error('Unknown encoding format ' + format);
	    }
	
	    return new encoding.CffEncoding(enc, charset);
	}
	
	// Take in charstring code and return a Glyph object.
	// The encoding is described in the Type 2 Charstring Format
	// https://www.microsoft.com/typography/OTSPEC/charstr2.htm
	function parseCFFCharstring(font, glyph, code) {
	    var c1x;
	    var c1y;
	    var c2x;
	    var c2y;
	    var p = new path.Path();
	    var stack = [];
	    var nStems = 0;
	    var haveWidth = false;
	    var width = font.defaultWidthX;
	    var open = false;
	    var x = 0;
	    var y = 0;
	
	    function newContour(x, y) {
	        if (open) {
	            p.closePath();
	        }
	
	        p.moveTo(x, y);
	        open = true;
	    }
	
	    function parseStems() {
	        var hasWidthArg;
	
	        // The number of stem operators on the stack is always even.
	        // If the value is uneven, that means a width is specified.
	        hasWidthArg = stack.length % 2 !== 0;
	        if (hasWidthArg && !haveWidth) {
	            width = stack.shift() + font.nominalWidthX;
	        }
	
	        nStems += stack.length >> 1;
	        stack.length = 0;
	        haveWidth = true;
	    }
	
	    function parse(code) {
	        var b1;
	        var b2;
	        var b3;
	        var b4;
	        var codeIndex;
	        var subrCode;
	        var jpx;
	        var jpy;
	        var c3x;
	        var c3y;
	        var c4x;
	        var c4y;
	
	        var i = 0;
	        while (i < code.length) {
	            var v = code[i];
	            i += 1;
	            switch (v) {
	            case 1: // hstem
	                parseStems();
	                break;
	            case 3: // vstem
	                parseStems();
	                break;
	            case 4: // vmoveto
	                if (stack.length > 1 && !haveWidth) {
	                    width = stack.shift() + font.nominalWidthX;
	                    haveWidth = true;
	                }
	
	                y += stack.pop();
	                newContour(x, y);
	                break;
	            case 5: // rlineto
	                while (stack.length > 0) {
	                    x += stack.shift();
	                    y += stack.shift();
	                    p.lineTo(x, y);
	                }
	
	                break;
	            case 6: // hlineto
	                while (stack.length > 0) {
	                    x += stack.shift();
	                    p.lineTo(x, y);
	                    if (stack.length === 0) {
	                        break;
	                    }
	
	                    y += stack.shift();
	                    p.lineTo(x, y);
	                }
	
	                break;
	            case 7: // vlineto
	                while (stack.length > 0) {
	                    y += stack.shift();
	                    p.lineTo(x, y);
	                    if (stack.length === 0) {
	                        break;
	                    }
	
	                    x += stack.shift();
	                    p.lineTo(x, y);
	                }
	
	                break;
	            case 8: // rrcurveto
	                while (stack.length > 0) {
	                    c1x = x + stack.shift();
	                    c1y = y + stack.shift();
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x + stack.shift();
	                    y = c2y + stack.shift();
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                }
	
	                break;
	            case 10: // callsubr
	                codeIndex = stack.pop() + font.subrsBias;
	                subrCode = font.subrs[codeIndex];
	                if (subrCode) {
	                    parse(subrCode);
	                }
	
	                break;
	            case 11: // return
	                return;
	            case 12: // flex operators
	                v = code[i];
	                i += 1;
	                switch (v) {
	                case 35: // flex
	                    // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 dx6 dy6 fd flex (12 35) |-
	                    c1x = x   + stack.shift();    // dx1
	                    c1y = y   + stack.shift();    // dy1
	                    c2x = c1x + stack.shift();    // dx2
	                    c2y = c1y + stack.shift();    // dy2
	                    jpx = c2x + stack.shift();    // dx3
	                    jpy = c2y + stack.shift();    // dy3
	                    c3x = jpx + stack.shift();    // dx4
	                    c3y = jpy + stack.shift();    // dy4
	                    c4x = c3x + stack.shift();    // dx5
	                    c4y = c3y + stack.shift();    // dy5
	                    x = c4x + stack.shift();      // dx6
	                    y = c4y + stack.shift();      // dy6
	                    stack.shift();                // flex depth
	                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                    break;
	                case 34: // hflex
	                    // |- dx1 dx2 dy2 dx3 dx4 dx5 dx6 hflex (12 34) |-
	                    c1x = x   + stack.shift();    // dx1
	                    c1y = y;                      // dy1
	                    c2x = c1x + stack.shift();    // dx2
	                    c2y = c1y + stack.shift();    // dy2
	                    jpx = c2x + stack.shift();    // dx3
	                    jpy = c2y;                    // dy3
	                    c3x = jpx + stack.shift();    // dx4
	                    c3y = c2y;                    // dy4
	                    c4x = c3x + stack.shift();    // dx5
	                    c4y = y;                      // dy5
	                    x = c4x + stack.shift();      // dx6
	                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                    break;
	                case 36: // hflex1
	                    // |- dx1 dy1 dx2 dy2 dx3 dx4 dx5 dy5 dx6 hflex1 (12 36) |-
	                    c1x = x   + stack.shift();    // dx1
	                    c1y = y   + stack.shift();    // dy1
	                    c2x = c1x + stack.shift();    // dx2
	                    c2y = c1y + stack.shift();    // dy2
	                    jpx = c2x + stack.shift();    // dx3
	                    jpy = c2y;                    // dy3
	                    c3x = jpx + stack.shift();    // dx4
	                    c3y = c2y;                    // dy4
	                    c4x = c3x + stack.shift();    // dx5
	                    c4y = c3y + stack.shift();    // dy5
	                    x = c4x + stack.shift();      // dx6
	                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                    break;
	                case 37: // flex1
	                    // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 d6 flex1 (12 37) |-
	                    c1x = x   + stack.shift();    // dx1
	                    c1y = y   + stack.shift();    // dy1
	                    c2x = c1x + stack.shift();    // dx2
	                    c2y = c1y + stack.shift();    // dy2
	                    jpx = c2x + stack.shift();    // dx3
	                    jpy = c2y + stack.shift();    // dy3
	                    c3x = jpx + stack.shift();    // dx4
	                    c3y = jpy + stack.shift();    // dy4
	                    c4x = c3x + stack.shift();    // dx5
	                    c4y = c3y + stack.shift();    // dy5
	                    if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
	                        x = c4x + stack.shift();
	                    } else {
	                        y = c4y + stack.shift();
	                    }
	
	                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
	                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
	                    break;
	                default:
	                    console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
	                    stack.length = 0;
	                }
	                break;
	            case 14: // endchar
	                if (stack.length > 0 && !haveWidth) {
	                    width = stack.shift() + font.nominalWidthX;
	                    haveWidth = true;
	                }
	
	                if (open) {
	                    p.closePath();
	                    open = false;
	                }
	
	                break;
	            case 18: // hstemhm
	                parseStems();
	                break;
	            case 19: // hintmask
	            case 20: // cntrmask
	                parseStems();
	                i += (nStems + 7) >> 3;
	                break;
	            case 21: // rmoveto
	                if (stack.length > 2 && !haveWidth) {
	                    width = stack.shift() + font.nominalWidthX;
	                    haveWidth = true;
	                }
	
	                y += stack.pop();
	                x += stack.pop();
	                newContour(x, y);
	                break;
	            case 22: // hmoveto
	                if (stack.length > 1 && !haveWidth) {
	                    width = stack.shift() + font.nominalWidthX;
	                    haveWidth = true;
	                }
	
	                x += stack.pop();
	                newContour(x, y);
	                break;
	            case 23: // vstemhm
	                parseStems();
	                break;
	            case 24: // rcurveline
	                while (stack.length > 2) {
	                    c1x = x + stack.shift();
	                    c1y = y + stack.shift();
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x + stack.shift();
	                    y = c2y + stack.shift();
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                }
	
	                x += stack.shift();
	                y += stack.shift();
	                p.lineTo(x, y);
	                break;
	            case 25: // rlinecurve
	                while (stack.length > 6) {
	                    x += stack.shift();
	                    y += stack.shift();
	                    p.lineTo(x, y);
	                }
	
	                c1x = x + stack.shift();
	                c1y = y + stack.shift();
	                c2x = c1x + stack.shift();
	                c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y + stack.shift();
	                p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                break;
	            case 26: // vvcurveto
	                if (stack.length % 2) {
	                    x += stack.shift();
	                }
	
	                while (stack.length > 0) {
	                    c1x = x;
	                    c1y = y + stack.shift();
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x;
	                    y = c2y + stack.shift();
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                }
	
	                break;
	            case 27: // hhcurveto
	                if (stack.length % 2) {
	                    y += stack.shift();
	                }
	
	                while (stack.length > 0) {
	                    c1x = x + stack.shift();
	                    c1y = y;
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x + stack.shift();
	                    y = c2y;
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                }
	
	                break;
	            case 28: // shortint
	                b1 = code[i];
	                b2 = code[i + 1];
	                stack.push(((b1 << 24) | (b2 << 16)) >> 16);
	                i += 2;
	                break;
	            case 29: // callgsubr
	                codeIndex = stack.pop() + font.gsubrsBias;
	                subrCode = font.gsubrs[codeIndex];
	                if (subrCode) {
	                    parse(subrCode);
	                }
	
	                break;
	            case 30: // vhcurveto
	                while (stack.length > 0) {
	                    c1x = x;
	                    c1y = y + stack.shift();
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x + stack.shift();
	                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    if (stack.length === 0) {
	                        break;
	                    }
	
	                    c1x = x + stack.shift();
	                    c1y = y;
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    y = c2y + stack.shift();
	                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                }
	
	                break;
	            case 31: // hvcurveto
	                while (stack.length > 0) {
	                    c1x = x + stack.shift();
	                    c1y = y;
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    y = c2y + stack.shift();
	                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                    if (stack.length === 0) {
	                        break;
	                    }
	
	                    c1x = x;
	                    c1y = y + stack.shift();
	                    c2x = c1x + stack.shift();
	                    c2y = c1y + stack.shift();
	                    x = c2x + stack.shift();
	                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
	                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
	                }
	
	                break;
	            default:
	                if (v < 32) {
	                    console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
	                } else if (v < 247) {
	                    stack.push(v - 139);
	                } else if (v < 251) {
	                    b1 = code[i];
	                    i += 1;
	                    stack.push((v - 247) * 256 + b1 + 108);
	                } else if (v < 255) {
	                    b1 = code[i];
	                    i += 1;
	                    stack.push(-(v - 251) * 256 - b1 - 108);
	                } else {
	                    b1 = code[i];
	                    b2 = code[i + 1];
	                    b3 = code[i + 2];
	                    b4 = code[i + 3];
	                    i += 4;
	                    stack.push(((b1 << 24) | (b2 << 16) | (b3 << 8) | b4) / 65536);
	                }
	            }
	        }
	    }
	
	    parse(code);
	
	    glyph.advanceWidth = width;
	    return p;
	}
	
	// Subroutines are encoded using the negative half of the number space.
	// See type 2 chapter 4.7 "Subroutine operators".
	function calcCFFSubroutineBias(subrs) {
	    var bias;
	    if (subrs.length < 1240) {
	        bias = 107;
	    } else if (subrs.length < 33900) {
	        bias = 1131;
	    } else {
	        bias = 32768;
	    }
	
	    return bias;
	}
	
	// Parse the `CFF` table, which contains the glyph outlines in PostScript format.
	function parseCFFTable(data, start, font) {
	    font.tables.cff = {};
	    var header = parseCFFHeader(data, start);
	    var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
	    var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
	    var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
	    var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
	    font.gsubrs = globalSubrIndex.objects;
	    font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);
	
	    var topDictData = new DataView(new Uint8Array(topDictIndex.objects[0]).buffer);
	    var topDict = parseCFFTopDict(topDictData, stringIndex.objects);
	    font.tables.cff.topDict = topDict;
	
	    var privateDictOffset = start + topDict['private'][1];
	    var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict['private'][0], stringIndex.objects);
	    font.defaultWidthX = privateDict.defaultWidthX;
	    font.nominalWidthX = privateDict.nominalWidthX;
	
	    if (privateDict.subrs !== 0) {
	        var subrOffset = privateDictOffset + privateDict.subrs;
	        var subrIndex = parseCFFIndex(data, subrOffset);
	        font.subrs = subrIndex.objects;
	        font.subrsBias = calcCFFSubroutineBias(font.subrs);
	    } else {
	        font.subrs = [];
	        font.subrsBias = 0;
	    }
	
	    // Offsets in the top dict are relative to the beginning of the CFF data, so add the CFF start offset.
	    var charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
	    font.nGlyphs = charStringsIndex.objects.length;
	
	    var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
	    if (topDict.encoding === 0) { // Standard encoding
	        font.cffEncoding = new encoding.CffEncoding(encoding.cffStandardEncoding, charset);
	    } else if (topDict.encoding === 1) { // Expert encoding
	        font.cffEncoding = new encoding.CffEncoding(encoding.cffExpertEncoding, charset);
	    } else {
	        font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
	    }
	
	    // Prefer the CMAP encoding to the CFF encoding.
	    font.encoding = font.encoding || font.cffEncoding;
	
	    font.glyphs = new glyphset.GlyphSet(font);
	    for (var i = 0; i < font.nGlyphs; i += 1) {
	        var charString = charStringsIndex.objects[i];
	        font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
	    }
	}
	
	// Convert a string to a String ID (SID).
	// The list of strings is modified in place.
	function encodeString(s, strings) {
	    var sid;
	
	    // Is the string in the CFF standard strings?
	    var i = encoding.cffStandardStrings.indexOf(s);
	    if (i >= 0) {
	        sid = i;
	    }
	
	    // Is the string already in the string index?
	    i = strings.indexOf(s);
	    if (i >= 0) {
	        sid = i + encoding.cffStandardStrings.length;
	    } else {
	        sid = encoding.cffStandardStrings.length + strings.length;
	        strings.push(s);
	    }
	
	    return sid;
	}
	
	function makeHeader() {
	    return new table.Table('Header', [
	        {name: 'major', type: 'Card8', value: 1},
	        {name: 'minor', type: 'Card8', value: 0},
	        {name: 'hdrSize', type: 'Card8', value: 4},
	        {name: 'major', type: 'Card8', value: 1}
	    ]);
	}
	
	function makeNameIndex(fontNames) {
	    var t = new table.Table('Name INDEX', [
	        {name: 'names', type: 'INDEX', value: []}
	    ]);
	    t.names = [];
	    for (var i = 0; i < fontNames.length; i += 1) {
	        t.names.push({name: 'name_' + i, type: 'NAME', value: fontNames[i]});
	    }
	
	    return t;
	}
	
	// Given a dictionary's metadata, create a DICT structure.
	function makeDict(meta, attrs, strings) {
	    var m = {};
	    for (var i = 0; i < meta.length; i += 1) {
	        var entry = meta[i];
	        var value = attrs[entry.name];
	        if (value !== undefined && !equals(value, entry.value)) {
	            if (entry.type === 'SID') {
	                value = encodeString(value, strings);
	            }
	
	            m[entry.op] = {name: entry.name, type: entry.type, value: value};
	        }
	    }
	
	    return m;
	}
	
	// The Top DICT houses the global font attributes.
	function makeTopDict(attrs, strings) {
	    var t = new table.Table('Top DICT', [
	        {name: 'dict', type: 'DICT', value: {}}
	    ]);
	    t.dict = makeDict(TOP_DICT_META, attrs, strings);
	    return t;
	}
	
	function makeTopDictIndex(topDict) {
	    var t = new table.Table('Top DICT INDEX', [
	        {name: 'topDicts', type: 'INDEX', value: []}
	    ]);
	    t.topDicts = [{name: 'topDict_0', type: 'TABLE', value: topDict}];
	    return t;
	}
	
	function makeStringIndex(strings) {
	    var t = new table.Table('String INDEX', [
	        {name: 'strings', type: 'INDEX', value: []}
	    ]);
	    t.strings = [];
	    for (var i = 0; i < strings.length; i += 1) {
	        t.strings.push({name: 'string_' + i, type: 'STRING', value: strings[i]});
	    }
	
	    return t;
	}
	
	function makeGlobalSubrIndex() {
	    // Currently we don't use subroutines.
	    return new table.Table('Global Subr INDEX', [
	        {name: 'subrs', type: 'INDEX', value: []}
	    ]);
	}
	
	function makeCharsets(glyphNames, strings) {
	    var t = new table.Table('Charsets', [
	        {name: 'format', type: 'Card8', value: 0}
	    ]);
	    for (var i = 0; i < glyphNames.length; i += 1) {
	        var glyphName = glyphNames[i];
	        var glyphSID = encodeString(glyphName, strings);
	        t.fields.push({name: 'glyph_' + i, type: 'SID', value: glyphSID});
	    }
	
	    return t;
	}
	
	function glyphToOps(glyph) {
	    var ops = [];
	    var path = glyph.path;
	    ops.push({name: 'width', type: 'NUMBER', value: glyph.advanceWidth});
	    var x = 0;
	    var y = 0;
	    for (var i = 0; i < path.commands.length; i += 1) {
	        var dx;
	        var dy;
	        var cmd = path.commands[i];
	        if (cmd.type === 'Q') {
	            // CFF only supports bézier curves, so convert the quad to a bézier.
	            var _13 = 1 / 3;
	            var _23 = 2 / 3;
	
	            // We're going to create a new command so we don't change the original path.
	            cmd = {
	                type: 'C',
	                x: cmd.x,
	                y: cmd.y,
	                x1: _13 * x + _23 * cmd.x1,
	                y1: _13 * y + _23 * cmd.y1,
	                x2: _13 * cmd.x + _23 * cmd.x1,
	                y2: _13 * cmd.y + _23 * cmd.y1
	            };
	        }
	
	        if (cmd.type === 'M') {
	            dx = Math.round(cmd.x - x);
	            dy = Math.round(cmd.y - y);
	            ops.push({name: 'dx', type: 'NUMBER', value: dx});
	            ops.push({name: 'dy', type: 'NUMBER', value: dy});
	            ops.push({name: 'rmoveto', type: 'OP', value: 21});
	            x = Math.round(cmd.x);
	            y = Math.round(cmd.y);
	        } else if (cmd.type === 'L') {
	            dx = Math.round(cmd.x - x);
	            dy = Math.round(cmd.y - y);
	            ops.push({name: 'dx', type: 'NUMBER', value: dx});
	            ops.push({name: 'dy', type: 'NUMBER', value: dy});
	            ops.push({name: 'rlineto', type: 'OP', value: 5});
	            x = Math.round(cmd.x);
	            y = Math.round(cmd.y);
	        } else if (cmd.type === 'C') {
	            var dx1 = Math.round(cmd.x1 - x);
	            var dy1 = Math.round(cmd.y1 - y);
	            var dx2 = Math.round(cmd.x2 - cmd.x1);
	            var dy2 = Math.round(cmd.y2 - cmd.y1);
	            dx = Math.round(cmd.x - cmd.x2);
	            dy = Math.round(cmd.y - cmd.y2);
	            ops.push({name: 'dx1', type: 'NUMBER', value: dx1});
	            ops.push({name: 'dy1', type: 'NUMBER', value: dy1});
	            ops.push({name: 'dx2', type: 'NUMBER', value: dx2});
	            ops.push({name: 'dy2', type: 'NUMBER', value: dy2});
	            ops.push({name: 'dx', type: 'NUMBER', value: dx});
	            ops.push({name: 'dy', type: 'NUMBER', value: dy});
	            ops.push({name: 'rrcurveto', type: 'OP', value: 8});
	            x = Math.round(cmd.x);
	            y = Math.round(cmd.y);
	        }
	
	        // Contours are closed automatically.
	
	    }
	
	    ops.push({name: 'endchar', type: 'OP', value: 14});
	    return ops;
	}
	
	function makeCharStringsIndex(glyphs) {
	    var t = new table.Table('CharStrings INDEX', [
	        {name: 'charStrings', type: 'INDEX', value: []}
	    ]);
	
	    for (var i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs.get(i);
	        var ops = glyphToOps(glyph);
	        t.charStrings.push({name: glyph.name, type: 'CHARSTRING', value: ops});
	    }
	
	    return t;
	}
	
	function makePrivateDict(attrs, strings) {
	    var t = new table.Table('Private DICT', [
	        {name: 'dict', type: 'DICT', value: {}}
	    ]);
	    t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
	    return t;
	}
	
	function makePrivateDictIndex(privateDict) {
	    var t = new table.Table('Private DICT INDEX', [
	        {name: 'privateDicts', type: 'INDEX', value: []}
	    ]);
	    t.privateDicts = [{name: 'privateDict_0', type: 'TABLE', value: privateDict}];
	    return t;
	}
	
	function makeCFFTable(glyphs, options) {
	    var t = new table.Table('CFF ', [
	        {name: 'header', type: 'TABLE'},
	        {name: 'nameIndex', type: 'TABLE'},
	        {name: 'topDictIndex', type: 'TABLE'},
	        {name: 'stringIndex', type: 'TABLE'},
	        {name: 'globalSubrIndex', type: 'TABLE'},
	        {name: 'charsets', type: 'TABLE'},
	        {name: 'charStringsIndex', type: 'TABLE'},
	        {name: 'privateDictIndex', type: 'TABLE'}
	    ]);
	
	    var fontScale = 1 / options.unitsPerEm;
	    // We use non-zero values for the offsets so that the DICT encodes them.
	    // This is important because the size of the Top DICT plays a role in offset calculation,
	    // and the size shouldn't change after we've written correct offsets.
	    var attrs = {
	        version: options.version,
	        fullName: options.fullName,
	        familyName: options.familyName,
	        weight: options.weightName,
	        fontMatrix: [fontScale, 0, 0, fontScale, 0, 0],
	        charset: 999,
	        encoding: 0,
	        charStrings: 999,
	        private: [0, 999]
	    };
	
	    var privateAttrs = {};
	
	    var glyphNames = [];
	    var glyph;
	
	    // Skip first glyph (.notdef)
	    for (var i = 1; i < glyphs.length; i += 1) {
	        glyph = glyphs.get(i);
	        glyphNames.push(glyph.name);
	    }
	
	    var strings = [];
	
	    t.header = makeHeader();
	    t.nameIndex = makeNameIndex([options.postScriptName]);
	    var topDict = makeTopDict(attrs, strings);
	    t.topDictIndex = makeTopDictIndex(topDict);
	    t.globalSubrIndex = makeGlobalSubrIndex();
	    t.charsets = makeCharsets(glyphNames, strings);
	    t.charStringsIndex = makeCharStringsIndex(glyphs);
	    var privateDict = makePrivateDict(privateAttrs, strings);
	    t.privateDictIndex = makePrivateDictIndex(privateDict);
	
	    // Needs to come at the end, to encode all custom strings used in the font.
	    t.stringIndex = makeStringIndex(strings);
	
	    var startOffset = t.header.sizeOf() +
	        t.nameIndex.sizeOf() +
	        t.topDictIndex.sizeOf() +
	        t.stringIndex.sizeOf() +
	        t.globalSubrIndex.sizeOf();
	    attrs.charset = startOffset;
	
	    // We use the CFF standard encoding; proper encoding will be handled in cmap.
	    attrs.encoding = 0;
	    attrs.charStrings = attrs.charset + t.charsets.sizeOf();
	    attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();
	
	    // Recreate the Top DICT INDEX with the correct offsets.
	    topDict = makeTopDict(attrs, strings);
	    t.topDictIndex = makeTopDictIndex(topDict);
	
	    return t;
	}
	
	exports.parse = parseCFFTable;
	exports.make = makeCFFTable;
	
	},{"../encoding":4,"../glyphset":7,"../parse":9,"../path":10,"../table":11}],13:[function(_dereq_,module,exports){
	// The `cmap` table stores the mappings from characters to glyphs.
	// https://www.microsoft.com/typography/OTSPEC/cmap.htm
	
	'use strict';
	
	var check = _dereq_('../check');
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// Parse the `cmap` table. This table stores the mappings from characters to glyphs.
	// There are many available formats, but we only support the Windows format 4.
	// This function returns a `CmapEncoding` object or null if no supported format could be found.
	function parseCmapTable(data, start) {
	    var i;
	    var cmap = {};
	    cmap.version = parse.getUShort(data, start);
	    check.argument(cmap.version === 0, 'cmap table version should be 0.');
	
	    // The cmap table can contain many sub-tables, each with their own format.
	    // We're only interested in a "platform 3" table. This is a Windows format.
	    cmap.numTables = parse.getUShort(data, start + 2);
	    var offset = -1;
	    for (i = 0; i < cmap.numTables; i += 1) {
	        var platformId = parse.getUShort(data, start + 4 + (i * 8));
	        var encodingId = parse.getUShort(data, start + 4 + (i * 8) + 2);
	        if (platformId === 3 && (encodingId === 1 || encodingId === 0)) {
	            offset = parse.getULong(data, start + 4 + (i * 8) + 4);
	            break;
	        }
	    }
	
	    if (offset === -1) {
	        // There is no cmap table in the font that we support, so return null.
	        // This font will be marked as unsupported.
	        return null;
	    }
	
	    var p = new parse.Parser(data, start + offset);
	    cmap.format = p.parseUShort();
	    check.argument(cmap.format === 4, 'Only format 4 cmap tables are supported.');
	
	    // Length in bytes of the sub-tables.
	    cmap.length = p.parseUShort();
	    cmap.language = p.parseUShort();
	
	    // segCount is stored x 2.
	    var segCount;
	    cmap.segCount = segCount = p.parseUShort() >> 1;
	
	    // Skip searchRange, entrySelector, rangeShift.
	    p.skip('uShort', 3);
	
	    // The "unrolled" mapping from character codes to glyph indices.
	    cmap.glyphIndexMap = {};
	
	    var endCountParser = new parse.Parser(data, start + offset + 14);
	    var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
	    var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
	    var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
	    var glyphIndexOffset = start + offset + 16 + segCount * 8;
	    for (i = 0; i < segCount - 1; i += 1) {
	        var glyphIndex;
	        var endCount = endCountParser.parseUShort();
	        var startCount = startCountParser.parseUShort();
	        var idDelta = idDeltaParser.parseShort();
	        var idRangeOffset = idRangeOffsetParser.parseUShort();
	        for (var c = startCount; c <= endCount; c += 1) {
	            if (idRangeOffset !== 0) {
	                // The idRangeOffset is relative to the current position in the idRangeOffset array.
	                // Take the current offset in the idRangeOffset array.
	                glyphIndexOffset = (idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2);
	
	                // Add the value of the idRangeOffset, which will move us into the glyphIndex array.
	                glyphIndexOffset += idRangeOffset;
	
	                // Then add the character index of the current segment, multiplied by 2 for USHORTs.
	                glyphIndexOffset += (c - startCount) * 2;
	                glyphIndex = parse.getUShort(data, glyphIndexOffset);
	                if (glyphIndex !== 0) {
	                    glyphIndex = (glyphIndex + idDelta) & 0xFFFF;
	                }
	            } else {
	                glyphIndex = (c + idDelta) & 0xFFFF;
	            }
	
	            cmap.glyphIndexMap[c] = glyphIndex;
	        }
	    }
	
	    return cmap;
	}
	
	function addSegment(t, code, glyphIndex) {
	    t.segments.push({
	        end: code,
	        start: code,
	        delta: -(code - glyphIndex),
	        offset: 0
	    });
	}
	
	function addTerminatorSegment(t) {
	    t.segments.push({
	        end: 0xFFFF,
	        start: 0xFFFF,
	        delta: 1,
	        offset: 0
	    });
	}
	
	function makeCmapTable(glyphs) {
	    var i;
	    var t = new table.Table('cmap', [
	        {name: 'version', type: 'USHORT', value: 0},
	        {name: 'numTables', type: 'USHORT', value: 1},
	        {name: 'platformID', type: 'USHORT', value: 3},
	        {name: 'encodingID', type: 'USHORT', value: 1},
	        {name: 'offset', type: 'ULONG', value: 12},
	        {name: 'format', type: 'USHORT', value: 4},
	        {name: 'length', type: 'USHORT', value: 0},
	        {name: 'language', type: 'USHORT', value: 0},
	        {name: 'segCountX2', type: 'USHORT', value: 0},
	        {name: 'searchRange', type: 'USHORT', value: 0},
	        {name: 'entrySelector', type: 'USHORT', value: 0},
	        {name: 'rangeShift', type: 'USHORT', value: 0}
	    ]);
	
	    t.segments = [];
	    for (i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs.get(i);
	        for (var j = 0; j < glyph.unicodes.length; j += 1) {
	            addSegment(t, glyph.unicodes[j], i);
	        }
	
	        t.segments = t.segments.sort(function(a, b) {
	            return a.start - b.start;
	        });
	    }
	
	    addTerminatorSegment(t);
	
	    var segCount;
	    segCount = t.segments.length;
	    t.segCountX2 = segCount * 2;
	    t.searchRange = Math.pow(2, Math.floor(Math.log(segCount) / Math.log(2))) * 2;
	    t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
	    t.rangeShift = t.segCountX2 - t.searchRange;
	
	    // Set up parallel segment arrays.
	    var endCounts = [];
	    var startCounts = [];
	    var idDeltas = [];
	    var idRangeOffsets = [];
	    var glyphIds = [];
	
	    for (i = 0; i < segCount; i += 1) {
	        var segment = t.segments[i];
	        endCounts = endCounts.concat({name: 'end_' + i, type: 'USHORT', value: segment.end});
	        startCounts = startCounts.concat({name: 'start_' + i, type: 'USHORT', value: segment.start});
	        idDeltas = idDeltas.concat({name: 'idDelta_' + i, type: 'SHORT', value: segment.delta});
	        idRangeOffsets = idRangeOffsets.concat({name: 'idRangeOffset_' + i, type: 'USHORT', value: segment.offset});
	        if (segment.glyphId !== undefined) {
	            glyphIds = glyphIds.concat({name: 'glyph_' + i, type: 'USHORT', value: segment.glyphId});
	        }
	    }
	
	    t.fields = t.fields.concat(endCounts);
	    t.fields.push({name: 'reservedPad', type: 'USHORT', value: 0});
	    t.fields = t.fields.concat(startCounts);
	    t.fields = t.fields.concat(idDeltas);
	    t.fields = t.fields.concat(idRangeOffsets);
	    t.fields = t.fields.concat(glyphIds);
	
	    t.length = 14 + // Subtable header
	        endCounts.length * 2 +
	        2 + // reservedPad
	        startCounts.length * 2 +
	        idDeltas.length * 2 +
	        idRangeOffsets.length * 2 +
	        glyphIds.length * 2;
	
	    return t;
	}
	
	exports.parse = parseCmapTable;
	exports.make = makeCmapTable;
	
	},{"../check":2,"../parse":9,"../table":11}],14:[function(_dereq_,module,exports){
	// The `glyf` table describes the glyphs in TrueType outline format.
	// http://www.microsoft.com/typography/otspec/glyf.htm
	
	'use strict';
	
	var check = _dereq_('../check');
	var glyphset = _dereq_('../glyphset');
	var parse = _dereq_('../parse');
	var path = _dereq_('../path');
	
	// Parse the coordinate data for a glyph.
	function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
	    var v;
	    if ((flag & shortVectorBitMask) > 0) {
	        // The coordinate is 1 byte long.
	        v = p.parseByte();
	        // The `same` bit is re-used for short values to signify the sign of the value.
	        if ((flag & sameBitMask) === 0) {
	            v = -v;
	        }
	
	        v = previousValue + v;
	    } else {
	        //  The coordinate is 2 bytes long.
	        // If the `same` bit is set, the coordinate is the same as the previous coordinate.
	        if ((flag & sameBitMask) > 0) {
	            v = previousValue;
	        } else {
	            // Parse the coordinate as a signed 16-bit delta value.
	            v = previousValue + p.parseShort();
	        }
	    }
	
	    return v;
	}
	
	// Parse a TrueType glyph.
	function parseGlyph(glyph, data, start) {
	    var p = new parse.Parser(data, start);
	    glyph.numberOfContours = p.parseShort();
	    glyph.xMin = p.parseShort();
	    glyph.yMin = p.parseShort();
	    glyph.xMax = p.parseShort();
	    glyph.yMax = p.parseShort();
	    var flags;
	    var flag;
	    if (glyph.numberOfContours > 0) {
	        var i;
	        // This glyph is not a composite.
	        var endPointIndices = glyph.endPointIndices = [];
	        for (i = 0; i < glyph.numberOfContours; i += 1) {
	            endPointIndices.push(p.parseUShort());
	        }
	
	        glyph.instructionLength = p.parseUShort();
	        glyph.instructions = [];
	        for (i = 0; i < glyph.instructionLength; i += 1) {
	            glyph.instructions.push(p.parseByte());
	        }
	
	        var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
	        flags = [];
	        for (i = 0; i < numberOfCoordinates; i += 1) {
	            flag = p.parseByte();
	            flags.push(flag);
	            // If bit 3 is set, we repeat this flag n times, where n is the next byte.
	            if ((flag & 8) > 0) {
	                var repeatCount = p.parseByte();
	                for (var j = 0; j < repeatCount; j += 1) {
	                    flags.push(flag);
	                    i += 1;
	                }
	            }
	        }
	
	        check.argument(flags.length === numberOfCoordinates, 'Bad flags.');
	
	        if (endPointIndices.length > 0) {
	            var points = [];
	            var point;
	            // X/Y coordinates are relative to the previous point, except for the first point which is relative to 0,0.
	            if (numberOfCoordinates > 0) {
	                for (i = 0; i < numberOfCoordinates; i += 1) {
	                    flag = flags[i];
	                    point = {};
	                    point.onCurve = !!(flag & 1);
	                    point.lastPointOfContour = endPointIndices.indexOf(i) >= 0;
	                    points.push(point);
	                }
	
	                var px = 0;
	                for (i = 0; i < numberOfCoordinates; i += 1) {
	                    flag = flags[i];
	                    point = points[i];
	                    point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
	                    px = point.x;
	                }
	
	                var py = 0;
	                for (i = 0; i < numberOfCoordinates; i += 1) {
	                    flag = flags[i];
	                    point = points[i];
	                    point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
	                    py = point.y;
	                }
	            }
	
	            glyph.points = points;
	        } else {
	            glyph.points = [];
	        }
	    } else if (glyph.numberOfContours === 0) {
	        glyph.points = [];
	    } else {
	        glyph.isComposite = true;
	        glyph.points = [];
	        glyph.components = [];
	        var moreComponents = true;
	        while (moreComponents) {
	            flags = p.parseUShort();
	            var component = {
	                glyphIndex: p.parseUShort(),
	                xScale: 1,
	                scale01: 0,
	                scale10: 0,
	                yScale: 1,
	                dx: 0,
	                dy: 0
	            };
	            if ((flags & 1) > 0) {
	                // The arguments are words
	                component.dx = p.parseShort();
	                component.dy = p.parseShort();
	            } else {
	                // The arguments are bytes
	                component.dx = p.parseChar();
	                component.dy = p.parseChar();
	            }
	
	            if ((flags & 8) > 0) {
	                // We have a scale
	                component.xScale = component.yScale = p.parseF2Dot14();
	            } else if ((flags & 64) > 0) {
	                // We have an X / Y scale
	                component.xScale = p.parseF2Dot14();
	                component.yScale = p.parseF2Dot14();
	            } else if ((flags & 128) > 0) {
	                // We have a 2x2 transformation
	                component.xScale = p.parseF2Dot14();
	                component.scale01 = p.parseF2Dot14();
	                component.scale10 = p.parseF2Dot14();
	                component.yScale = p.parseF2Dot14();
	            }
	
	            glyph.components.push(component);
	            moreComponents = !!(flags & 32);
	        }
	    }
	}
	
	// Transform an array of points and return a new array.
	function transformPoints(points, transform) {
	    var newPoints = [];
	    for (var i = 0; i < points.length; i += 1) {
	        var pt = points[i];
	        var newPt = {
	            x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
	            y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
	            onCurve: pt.onCurve,
	            lastPointOfContour: pt.lastPointOfContour
	        };
	        newPoints.push(newPt);
	    }
	
	    return newPoints;
	}
	
	function getContours(points) {
	    var contours = [];
	    var currentContour = [];
	    for (var i = 0; i < points.length; i += 1) {
	        var pt = points[i];
	        currentContour.push(pt);
	        if (pt.lastPointOfContour) {
	            contours.push(currentContour);
	            currentContour = [];
	        }
	    }
	
	    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
	    return contours;
	}
	
	// Convert the TrueType glyph outline to a Path.
	function getPath(points) {
	    var p = new path.Path();
	    if (!points) {
	        return p;
	    }
	
	    var contours = getContours(points);
	    for (var i = 0; i < contours.length; i += 1) {
	        var contour = contours[i];
	        var firstPt = contour[0];
	        var lastPt = contour[contour.length - 1];
	        var curvePt;
	        var realFirstPoint;
	        if (firstPt.onCurve) {
	            curvePt = null;
	            // The first point will be consumed by the moveTo command,
	            // so skip it in the loop.
	            realFirstPoint = true;
	        } else {
	            if (lastPt.onCurve) {
	                // If the first point is off-curve and the last point is on-curve,
	                // start at the last point.
	                firstPt = lastPt;
	            } else {
	                // If both first and last points are off-curve, start at their middle.
	                firstPt = { x: (firstPt.x + lastPt.x) / 2, y: (firstPt.y + lastPt.y) / 2 };
	            }
	
	            curvePt = firstPt;
	            // The first point is synthesized, so don't skip the real first point.
	            realFirstPoint = false;
	        }
	
	        p.moveTo(firstPt.x, firstPt.y);
	
	        for (var j = realFirstPoint ? 1 : 0; j < contour.length; j += 1) {
	            var pt = contour[j];
	            var prevPt = j === 0 ? firstPt : contour[j - 1];
	            if (prevPt.onCurve && pt.onCurve) {
	                // This is a straight line.
	                p.lineTo(pt.x, pt.y);
	            } else if (prevPt.onCurve && !pt.onCurve) {
	                curvePt = pt;
	            } else if (!prevPt.onCurve && !pt.onCurve) {
	                var midPt = { x: (prevPt.x + pt.x) / 2, y: (prevPt.y + pt.y) / 2 };
	                p.quadraticCurveTo(prevPt.x, prevPt.y, midPt.x, midPt.y);
	                curvePt = pt;
	            } else if (!prevPt.onCurve && pt.onCurve) {
	                // Previous point off-curve, this point on-curve.
	                p.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
	                curvePt = null;
	            } else {
	                throw new Error('Invalid state.');
	            }
	        }
	
	        if (firstPt !== lastPt) {
	            // Connect the last and first points
	            if (curvePt) {
	                p.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
	            } else {
	                p.lineTo(firstPt.x, firstPt.y);
	            }
	        }
	    }
	
	    p.closePath();
	    return p;
	}
	
	function buildPath(glyphs, glyph) {
	    if (glyph.isComposite) {
	        for (var j = 0; j < glyph.components.length; j += 1) {
	            var component = glyph.components[j];
	            var componentGlyph = glyphs.get(component.glyphIndex);
	            if (componentGlyph.points) {
	                var transformedPoints = transformPoints(componentGlyph.points, component);
	                glyph.points = glyph.points.concat(transformedPoints);
	            }
	        }
	    }
	
	    return getPath(glyph.points);
	}
	
	// Parse all the glyphs according to the offsets from the `loca` table.
	function parseGlyfTable(data, start, loca, font) {
	    var glyphs = new glyphset.GlyphSet(font);
	    var i;
	
	    // The last element of the loca table is invalid.
	    for (i = 0; i < loca.length - 1; i += 1) {
	        var offset = loca[i];
	        var nextOffset = loca[i + 1];
	        if (offset !== nextOffset) {
	            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
	        } else {
	            glyphs.push(i, glyphset.glyphLoader(font, i));
	        }
	    }
	
	    return glyphs;
	}
	
	exports.parse = parseGlyfTable;
	
	},{"../check":2,"../glyphset":7,"../parse":9,"../path":10}],15:[function(_dereq_,module,exports){
	// The `GPOS` table contains kerning pairs, among other things.
	// https://www.microsoft.com/typography/OTSPEC/gpos.htm
	
	'use strict';
	
	var check = _dereq_('../check');
	var parse = _dereq_('../parse');
	
	// Parse ScriptList and FeatureList tables of GPOS, GSUB, GDEF, BASE, JSTF tables.
	// These lists are unused by now, this function is just the basis for a real parsing.
	function parseTaggedListTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var n = p.parseUShort();
	    var list = [];
	    for (var i = 0; i < n; i++) {
	        list[p.parseTag()] = { offset: p.parseUShort() };
	    }
	
	    return list;
	}
	
	// Parse a coverage table in a GSUB, GPOS or GDEF table.
	// Format 1 is a simple list of glyph ids,
	// Format 2 is a list of ranges. It is expanded in a list of glyphs, maybe not the best idea.
	function parseCoverageTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var format = p.parseUShort();
	    var count =  p.parseUShort();
	    if (format === 1) {
	        return p.parseUShortList(count);
	    }
	    else if (format === 2) {
	        var coverage = [];
	        for (; count--;) {
	            var begin = p.parseUShort();
	            var end = p.parseUShort();
	            var index = p.parseUShort();
	            for (var i = begin; i <= end; i++) {
	                coverage[index++] = i;
	            }
	        }
	
	        return coverage;
	    }
	}
	
	// Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
	// Returns a function that gets a class value from a glyph ID.
	function parseClassDefTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var format = p.parseUShort();
	    if (format === 1) {
	        // Format 1 specifies a range of consecutive glyph indices, one class per glyph ID.
	        var startGlyph = p.parseUShort();
	        var glyphCount = p.parseUShort();
	        var classes = p.parseUShortList(glyphCount);
	        return function(glyphID) {
	            return classes[glyphID - startGlyph] || 0;
	        };
	    }
	    else if (format === 2) {
	        // Format 2 defines multiple groups of glyph indices that belong to the same class.
	        var rangeCount = p.parseUShort();
	        var startGlyphs = [];
	        var endGlyphs = [];
	        var classValues = [];
	        for (var i = 0; i < rangeCount; i++) {
	            startGlyphs[i] = p.parseUShort();
	            endGlyphs[i] = p.parseUShort();
	            classValues[i] = p.parseUShort();
	        }
	
	        return function(glyphID) {
	            var l = 0;
	            var r = startGlyphs.length - 1;
	            while (l < r) {
	                var c = (l + r + 1) >> 1;
	                if (glyphID < startGlyphs[c]) {
	                    r = c - 1;
	                } else {
	                    l = c;
	                }
	            }
	
	            if (startGlyphs[l] <= glyphID && glyphID <= endGlyphs[l]) {
	                return classValues[l] || 0;
	            }
	
	            return 0;
	        };
	    }
	}
	
	// Parse a pair adjustment positioning subtable, format 1 or format 2
	// The subtable is returned in the form of a lookup function.
	function parsePairPosSubTable(data, start) {
	    var p = new parse.Parser(data, start);
	    // This part is common to format 1 and format 2 subtables
	    var format = p.parseUShort();
	    var coverageOffset = p.parseUShort();
	    var coverage = parseCoverageTable(data, start + coverageOffset);
	    // valueFormat 4: XAdvance only, 1: XPlacement only, 0: no ValueRecord for second glyph
	    // Only valueFormat1=4 and valueFormat2=0 is supported.
	    var valueFormat1 = p.parseUShort();
	    var valueFormat2 = p.parseUShort();
	    var value1;
	    var value2;
	    if (valueFormat1 !== 4 || valueFormat2 !== 0) return;
	    var sharedPairSets = {};
	    if (format === 1) {
	        // Pair Positioning Adjustment: Format 1
	        var pairSetCount = p.parseUShort();
	        var pairSet = [];
	        // Array of offsets to PairSet tables-from beginning of PairPos subtable-ordered by Coverage Index
	        var pairSetOffsets = p.parseOffset16List(pairSetCount);
	        for (var firstGlyph = 0; firstGlyph < pairSetCount; firstGlyph++) {
	            var pairSetOffset = pairSetOffsets[firstGlyph];
	            var sharedPairSet = sharedPairSets[pairSetOffset];
	            if (!sharedPairSet) {
	                // Parse a pairset table in a pair adjustment subtable format 1
	                sharedPairSet = {};
	                p.relativeOffset = pairSetOffset;
	                var pairValueCount = p.parseUShort();
	                for (; pairValueCount--;) {
	                    var secondGlyph = p.parseUShort();
	                    if (valueFormat1) value1 = p.parseShort();
	                    if (valueFormat2) value2 = p.parseShort();
	                    // We only support valueFormat1 = 4 and valueFormat2 = 0,
	                    // so value1 is the XAdvance and value2 is empty.
	                    sharedPairSet[secondGlyph] = value1;
	                }
	            }
	
	            pairSet[coverage[firstGlyph]] = sharedPairSet;
	        }
	
	        return function(leftGlyph, rightGlyph) {
	            var pairs = pairSet[leftGlyph];
	            if (pairs) return pairs[rightGlyph];
	        };
	    }
	    else if (format === 2) {
	        // Pair Positioning Adjustment: Format 2
	        var classDef1Offset = p.parseUShort();
	        var classDef2Offset = p.parseUShort();
	        var class1Count = p.parseUShort();
	        var class2Count = p.parseUShort();
	        var getClass1 = parseClassDefTable(data, start + classDef1Offset);
	        var getClass2 = parseClassDefTable(data, start + classDef2Offset);
	
	        // Parse kerning values by class pair.
	        var kerningMatrix = [];
	        for (var i = 0; i < class1Count; i++) {
	            var kerningRow = kerningMatrix[i] = [];
	            for (var j = 0; j < class2Count; j++) {
	                if (valueFormat1) value1 = p.parseShort();
	                if (valueFormat2) value2 = p.parseShort();
	                // We only support valueFormat1 = 4 and valueFormat2 = 0,
	                // so value1 is the XAdvance and value2 is empty.
	                kerningRow[j] = value1;
	            }
	        }
	
	        // Convert coverage list to a hash
	        var covered = {};
	        for (i = 0; i < coverage.length; i++) covered[coverage[i]] = 1;
	
	        // Get the kerning value for a specific glyph pair.
	        return function(leftGlyph, rightGlyph) {
	            if (!covered[leftGlyph]) return;
	            var class1 = getClass1(leftGlyph);
	            var class2 = getClass2(rightGlyph);
	            var kerningRow = kerningMatrix[class1];
	
	            if (kerningRow) {
	                return kerningRow[class2];
	            }
	        };
	    }
	}
	
	// Parse a LookupTable (present in of GPOS, GSUB, GDEF, BASE, JSTF tables).
	function parseLookupTable(data, start) {
	    var p = new parse.Parser(data, start);
	    var lookupType = p.parseUShort();
	    var lookupFlag = p.parseUShort();
	    var useMarkFilteringSet = lookupFlag & 0x10;
	    var subTableCount = p.parseUShort();
	    var subTableOffsets = p.parseOffset16List(subTableCount);
	    var table = {
	        lookupType: lookupType,
	        lookupFlag: lookupFlag,
	        markFilteringSet: useMarkFilteringSet ? p.parseUShort() : -1
	    };
	    // LookupType 2, Pair adjustment
	    if (lookupType === 2) {
	        var subtables = [];
	        for (var i = 0; i < subTableCount; i++) {
	            subtables.push(parsePairPosSubTable(data, start + subTableOffsets[i]));
	        }
	        // Return a function which finds the kerning values in the subtables.
	        table.getKerningValue = function(leftGlyph, rightGlyph) {
	            for (var i = subtables.length; i--;) {
	                var value = subtables[i](leftGlyph, rightGlyph);
	                if (value !== undefined) return value;
	            }
	
	            return 0;
	        };
	    }
	
	    return table;
	}
	
	// Parse the `GPOS` table which contains, among other things, kerning pairs.
	// https://www.microsoft.com/typography/OTSPEC/gpos.htm
	function parseGposTable(data, start, font) {
	    var p = new parse.Parser(data, start);
	    var tableVersion = p.parseFixed();
	    check.argument(tableVersion === 1, 'Unsupported GPOS table version.');
	
	    // ScriptList and FeatureList - ignored for now
	    parseTaggedListTable(data, start + p.parseUShort());
	    // 'kern' is the feature we are looking for.
	    parseTaggedListTable(data, start + p.parseUShort());
	
	    // LookupList
	    var lookupListOffset = p.parseUShort();
	    p.relativeOffset = lookupListOffset;
	    var lookupCount = p.parseUShort();
	    var lookupTableOffsets = p.parseOffset16List(lookupCount);
	    var lookupListAbsoluteOffset = start + lookupListOffset;
	    for (var i = 0; i < lookupCount; i++) {
	        var table = parseLookupTable(data, lookupListAbsoluteOffset + lookupTableOffsets[i]);
	        if (table.lookupType === 2 && !font.getGposKerningValue) font.getGposKerningValue = table.getKerningValue;
	    }
	}
	
	exports.parse = parseGposTable;
	
	},{"../check":2,"../parse":9}],16:[function(_dereq_,module,exports){
	// The `head` table contains global information about the font.
	// https://www.microsoft.com/typography/OTSPEC/head.htm
	
	'use strict';
	
	var check = _dereq_('../check');
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// Parse the header `head` table
	function parseHeadTable(data, start) {
	    var head = {};
	    var p = new parse.Parser(data, start);
	    head.version = p.parseVersion();
	    head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
	    head.checkSumAdjustment = p.parseULong();
	    head.magicNumber = p.parseULong();
	    check.argument(head.magicNumber === 0x5F0F3CF5, 'Font header has wrong magic number.');
	    head.flags = p.parseUShort();
	    head.unitsPerEm = p.parseUShort();
	    head.created = p.parseLongDateTime();
	    head.modified = p.parseLongDateTime();
	    head.xMin = p.parseShort();
	    head.yMin = p.parseShort();
	    head.xMax = p.parseShort();
	    head.yMax = p.parseShort();
	    head.macStyle = p.parseUShort();
	    head.lowestRecPPEM = p.parseUShort();
	    head.fontDirectionHint = p.parseShort();
	    head.indexToLocFormat = p.parseShort();     // 50
	    head.glyphDataFormat = p.parseShort();
	    return head;
	}
	
	function makeHeadTable(options) {
	    return new table.Table('head', [
	        {name: 'version', type: 'FIXED', value: 0x00010000},
	        {name: 'fontRevision', type: 'FIXED', value: 0x00010000},
	        {name: 'checkSumAdjustment', type: 'ULONG', value: 0},
	        {name: 'magicNumber', type: 'ULONG', value: 0x5F0F3CF5},
	        {name: 'flags', type: 'USHORT', value: 0},
	        {name: 'unitsPerEm', type: 'USHORT', value: 1000},
	        {name: 'created', type: 'LONGDATETIME', value: 0},
	        {name: 'modified', type: 'LONGDATETIME', value: 0},
	        {name: 'xMin', type: 'SHORT', value: 0},
	        {name: 'yMin', type: 'SHORT', value: 0},
	        {name: 'xMax', type: 'SHORT', value: 0},
	        {name: 'yMax', type: 'SHORT', value: 0},
	        {name: 'macStyle', type: 'USHORT', value: 0},
	        {name: 'lowestRecPPEM', type: 'USHORT', value: 0},
	        {name: 'fontDirectionHint', type: 'SHORT', value: 2},
	        {name: 'indexToLocFormat', type: 'SHORT', value: 0},
	        {name: 'glyphDataFormat', type: 'SHORT', value: 0}
	    ], options);
	}
	
	exports.parse = parseHeadTable;
	exports.make = makeHeadTable;
	
	},{"../check":2,"../parse":9,"../table":11}],17:[function(_dereq_,module,exports){
	// The `hhea` table contains information for horizontal layout.
	// https://www.microsoft.com/typography/OTSPEC/hhea.htm
	
	'use strict';
	
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// Parse the horizontal header `hhea` table
	function parseHheaTable(data, start) {
	    var hhea = {};
	    var p = new parse.Parser(data, start);
	    hhea.version = p.parseVersion();
	    hhea.ascender = p.parseShort();
	    hhea.descender = p.parseShort();
	    hhea.lineGap = p.parseShort();
	    hhea.advanceWidthMax = p.parseUShort();
	    hhea.minLeftSideBearing = p.parseShort();
	    hhea.minRightSideBearing = p.parseShort();
	    hhea.xMaxExtent = p.parseShort();
	    hhea.caretSlopeRise = p.parseShort();
	    hhea.caretSlopeRun = p.parseShort();
	    hhea.caretOffset = p.parseShort();
	    p.relativeOffset += 8;
	    hhea.metricDataFormat = p.parseShort();
	    hhea.numberOfHMetrics = p.parseUShort();
	    return hhea;
	}
	
	function makeHheaTable(options) {
	    return new table.Table('hhea', [
	        {name: 'version', type: 'FIXED', value: 0x00010000},
	        {name: 'ascender', type: 'FWORD', value: 0},
	        {name: 'descender', type: 'FWORD', value: 0},
	        {name: 'lineGap', type: 'FWORD', value: 0},
	        {name: 'advanceWidthMax', type: 'UFWORD', value: 0},
	        {name: 'minLeftSideBearing', type: 'FWORD', value: 0},
	        {name: 'minRightSideBearing', type: 'FWORD', value: 0},
	        {name: 'xMaxExtent', type: 'FWORD', value: 0},
	        {name: 'caretSlopeRise', type: 'SHORT', value: 1},
	        {name: 'caretSlopeRun', type: 'SHORT', value: 0},
	        {name: 'caretOffset', type: 'SHORT', value: 0},
	        {name: 'reserved1', type: 'SHORT', value: 0},
	        {name: 'reserved2', type: 'SHORT', value: 0},
	        {name: 'reserved3', type: 'SHORT', value: 0},
	        {name: 'reserved4', type: 'SHORT', value: 0},
	        {name: 'metricDataFormat', type: 'SHORT', value: 0},
	        {name: 'numberOfHMetrics', type: 'USHORT', value: 0}
	    ], options);
	}
	
	exports.parse = parseHheaTable;
	exports.make = makeHheaTable;
	
	},{"../parse":9,"../table":11}],18:[function(_dereq_,module,exports){
	// The `hmtx` table contains the horizontal metrics for all glyphs.
	// https://www.microsoft.com/typography/OTSPEC/hmtx.htm
	
	'use strict';
	
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// Parse the `hmtx` table, which contains the horizontal metrics for all glyphs.
	// This function augments the glyph array, adding the advanceWidth and leftSideBearing to each glyph.
	function parseHmtxTable(data, start, numMetrics, numGlyphs, glyphs) {
	    var advanceWidth;
	    var leftSideBearing;
	    var p = new parse.Parser(data, start);
	    for (var i = 0; i < numGlyphs; i += 1) {
	        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
	        if (i < numMetrics) {
	            advanceWidth = p.parseUShort();
	            leftSideBearing = p.parseShort();
	        }
	
	        var glyph = glyphs.get(i);
	        glyph.advanceWidth = advanceWidth;
	        glyph.leftSideBearing = leftSideBearing;
	    }
	}
	
	function makeHmtxTable(glyphs) {
	    var t = new table.Table('hmtx', []);
	    for (var i = 0; i < glyphs.length; i += 1) {
	        var glyph = glyphs.get(i);
	        var advanceWidth = glyph.advanceWidth || 0;
	        var leftSideBearing = glyph.leftSideBearing || 0;
	        t.fields.push({name: 'advanceWidth_' + i, type: 'USHORT', value: advanceWidth});
	        t.fields.push({name: 'leftSideBearing_' + i, type: 'SHORT', value: leftSideBearing});
	    }
	
	    return t;
	}
	
	exports.parse = parseHmtxTable;
	exports.make = makeHmtxTable;
	
	},{"../parse":9,"../table":11}],19:[function(_dereq_,module,exports){
	// The `kern` table contains kerning pairs.
	// Note that some fonts use the GPOS OpenType layout table to specify kerning.
	// https://www.microsoft.com/typography/OTSPEC/kern.htm
	
	'use strict';
	
	var check = _dereq_('../check');
	var parse = _dereq_('../parse');
	
	// Parse the `kern` table which contains kerning pairs.
	function parseKernTable(data, start) {
	    var pairs = {};
	    var p = new parse.Parser(data, start);
	    var tableVersion = p.parseUShort();
	    check.argument(tableVersion === 0, 'Unsupported kern table version.');
	    // Skip nTables.
	    p.skip('uShort', 1);
	    var subTableVersion = p.parseUShort();
	    check.argument(subTableVersion === 0, 'Unsupported kern sub-table version.');
	    // Skip subTableLength, subTableCoverage
	    p.skip('uShort', 2);
	    var nPairs = p.parseUShort();
	    // Skip searchRange, entrySelector, rangeShift.
	    p.skip('uShort', 3);
	    for (var i = 0; i < nPairs; i += 1) {
	        var leftIndex = p.parseUShort();
	        var rightIndex = p.parseUShort();
	        var value = p.parseShort();
	        pairs[leftIndex + ',' + rightIndex] = value;
	    }
	
	    return pairs;
	}
	
	exports.parse = parseKernTable;
	
	},{"../check":2,"../parse":9}],20:[function(_dereq_,module,exports){
	// The `loca` table stores the offsets to the locations of the glyphs in the font.
	// https://www.microsoft.com/typography/OTSPEC/loca.htm
	
	'use strict';
	
	var parse = _dereq_('../parse');
	
	// Parse the `loca` table. This table stores the offsets to the locations of the glyphs in the font,
	// relative to the beginning of the glyphData table.
	// The number of glyphs stored in the `loca` table is specified in the `maxp` table (under numGlyphs)
	// The loca table has two versions: a short version where offsets are stored as uShorts, and a long
	// version where offsets are stored as uLongs. The `head` table specifies which version to use
	// (under indexToLocFormat).
	function parseLocaTable(data, start, numGlyphs, shortVersion) {
	    var p = new parse.Parser(data, start);
	    var parseFn = shortVersion ? p.parseUShort : p.parseULong;
	    // There is an extra entry after the last index element to compute the length of the last glyph.
	    // That's why we use numGlyphs + 1.
	    var glyphOffsets = [];
	    for (var i = 0; i < numGlyphs + 1; i += 1) {
	        var glyphOffset = parseFn.call(p);
	        if (shortVersion) {
	            // The short table version stores the actual offset divided by 2.
	            glyphOffset *= 2;
	        }
	
	        glyphOffsets.push(glyphOffset);
	    }
	
	    return glyphOffsets;
	}
	
	exports.parse = parseLocaTable;
	
	},{"../parse":9}],21:[function(_dereq_,module,exports){
	// The `maxp` table establishes the memory requirements for the font.
	// We need it just to get the number of glyphs in the font.
	// https://www.microsoft.com/typography/OTSPEC/maxp.htm
	
	'use strict';
	
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// Parse the maximum profile `maxp` table.
	function parseMaxpTable(data, start) {
	    var maxp = {};
	    var p = new parse.Parser(data, start);
	    maxp.version = p.parseVersion();
	    maxp.numGlyphs = p.parseUShort();
	    if (maxp.version === 1.0) {
	        maxp.maxPoints = p.parseUShort();
	        maxp.maxContours = p.parseUShort();
	        maxp.maxCompositePoints = p.parseUShort();
	        maxp.maxCompositeContours = p.parseUShort();
	        maxp.maxZones = p.parseUShort();
	        maxp.maxTwilightPoints = p.parseUShort();
	        maxp.maxStorage = p.parseUShort();
	        maxp.maxFunctionDefs = p.parseUShort();
	        maxp.maxInstructionDefs = p.parseUShort();
	        maxp.maxStackElements = p.parseUShort();
	        maxp.maxSizeOfInstructions = p.parseUShort();
	        maxp.maxComponentElements = p.parseUShort();
	        maxp.maxComponentDepth = p.parseUShort();
	    }
	
	    return maxp;
	}
	
	function makeMaxpTable(numGlyphs) {
	    return new table.Table('maxp', [
	        {name: 'version', type: 'FIXED', value: 0x00005000},
	        {name: 'numGlyphs', type: 'USHORT', value: numGlyphs}
	    ]);
	}
	
	exports.parse = parseMaxpTable;
	exports.make = makeMaxpTable;
	
	},{"../parse":9,"../table":11}],22:[function(_dereq_,module,exports){
	// The `name` naming table.
	// https://www.microsoft.com/typography/OTSPEC/name.htm
	
	'use strict';
	
	var encode = _dereq_('../types').encode;
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// NameIDs for the name table.
	var nameTableNames = [
	    'copyright',              // 0
	    'fontFamily',             // 1
	    'fontSubfamily',          // 2
	    'uniqueID',               // 3
	    'fullName',               // 4
	    'version',                // 5
	    'postScriptName',         // 6
	    'trademark',              // 7
	    'manufacturer',           // 8
	    'designer',               // 9
	    'description',            // 10
	    'manufacturerURL',        // 11
	    'designerURL',            // 12
	    'licence',                // 13
	    'licenceURL',             // 14
	    'reserved',               // 15
	    'preferredFamily',        // 16
	    'preferredSubfamily',     // 17
	    'compatibleFullName',     // 18
	    'sampleText',             // 19
	    'postScriptFindFontName', // 20
	    'wwsFamily',              // 21
	    'wwsSubfamily'            // 22
	];
	
	// Parse the naming `name` table
	// Only Windows Unicode English names are supported.
	// Format 1 additional fields are not supported
	function parseNameTable(data, start) {
	    var name = {};
	    var p = new parse.Parser(data, start);
	    name.format = p.parseUShort();
	    var count = p.parseUShort();
	    var stringOffset = p.offset + p.parseUShort();
	    var unknownCount = 0;
	    for (var i = 0; i < count; i++) {
	        var platformID = p.parseUShort();
	        var encodingID = p.parseUShort();
	        var languageID = p.parseUShort();
	        var nameID = p.parseUShort();
	        var property = nameTableNames[nameID];
	        var byteLength = p.parseUShort();
	        var offset = p.parseUShort();
	        // platformID - encodingID - languageID standard combinations :
	        // 1 - 0 - 0 : Macintosh, Roman, English
	        // 3 - 1 - 0x409 : Windows, Unicode BMP (UCS-2), en-US
	        if (platformID === 3 && encodingID === 1 && languageID === 0x409) {
	            var codePoints = [];
	            var length = byteLength / 2;
	            for (var j = 0; j < length; j++, offset += 2) {
	                codePoints[j] = parse.getShort(data, stringOffset + offset);
	            }
	
	            var str = String.fromCharCode.apply(null, codePoints);
	            if (property) {
	                name[property] = str;
	            }
	            else {
	                unknownCount++;
	                name['unknown' + unknownCount] = str;
	            }
	        }
	
	    }
	
	    if (name.format === 1) {
	        name.langTagCount = p.parseUShort();
	    }
	
	    return name;
	}
	
	function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
	    return new table.Table('NameRecord', [
	        {name: 'platformID', type: 'USHORT', value: platformID},
	        {name: 'encodingID', type: 'USHORT', value: encodingID},
	        {name: 'languageID', type: 'USHORT', value: languageID},
	        {name: 'nameID', type: 'USHORT', value: nameID},
	        {name: 'length', type: 'USHORT', value: length},
	        {name: 'offset', type: 'USHORT', value: offset}
	    ]);
	}
	
	function addMacintoshNameRecord(t, recordID, s, offset) {
	    // Macintosh, Roman, English
	    var stringBytes = encode.STRING(s);
	    t.records.push(makeNameRecord(1, 0, 0, recordID, stringBytes.length, offset));
	    t.strings.push(stringBytes);
	    offset += stringBytes.length;
	    return offset;
	}
	
	function addWindowsNameRecord(t, recordID, s, offset) {
	    // Windows, Unicode BMP (UCS-2), US English
	    var utf16Bytes = encode.UTF16(s);
	    t.records.push(makeNameRecord(3, 1, 0x0409, recordID, utf16Bytes.length, offset));
	    t.strings.push(utf16Bytes);
	    offset += utf16Bytes.length;
	    return offset;
	}
	
	function makeNameTable(options) {
	    var t = new table.Table('name', [
	        {name: 'format', type: 'USHORT', value: 0},
	        {name: 'count', type: 'USHORT', value: 0},
	        {name: 'stringOffset', type: 'USHORT', value: 0}
	    ]);
	    t.records = [];
	    t.strings = [];
	    var offset = 0;
	    var i;
	    var s;
	    // Add Macintosh records first
	    for (i = 0; i < nameTableNames.length; i += 1) {
	        if (options[nameTableNames[i]] !== undefined) {
	            s = options[nameTableNames[i]];
	            offset = addMacintoshNameRecord(t, i, s, offset);
	        }
	    }
	    // Then add Windows records
	    for (i = 0; i < nameTableNames.length; i += 1) {
	        if (options[nameTableNames[i]] !== undefined) {
	            s = options[nameTableNames[i]];
	            offset = addWindowsNameRecord(t, i, s, offset);
	        }
	    }
	
	    t.count = t.records.length;
	    t.stringOffset = 6 + t.count * 12;
	    for (i = 0; i < t.records.length; i += 1) {
	        t.fields.push({name: 'record_' + i, type: 'TABLE', value: t.records[i]});
	    }
	
	    for (i = 0; i < t.strings.length; i += 1) {
	        t.fields.push({name: 'string_' + i, type: 'LITERAL', value: t.strings[i]});
	    }
	
	    return t;
	}
	
	exports.parse = parseNameTable;
	exports.make = makeNameTable;
	
	},{"../parse":9,"../table":11,"../types":26}],23:[function(_dereq_,module,exports){
	// The `OS/2` table contains metrics required in OpenType fonts.
	// https://www.microsoft.com/typography/OTSPEC/os2.htm
	
	'use strict';
	
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	var unicodeRanges = [
	    {begin: 0x0000, end: 0x007F}, // Basic Latin
	    {begin: 0x0080, end: 0x00FF}, // Latin-1 Supplement
	    {begin: 0x0100, end: 0x017F}, // Latin Extended-A
	    {begin: 0x0180, end: 0x024F}, // Latin Extended-B
	    {begin: 0x0250, end: 0x02AF}, // IPA Extensions
	    {begin: 0x02B0, end: 0x02FF}, // Spacing Modifier Letters
	    {begin: 0x0300, end: 0x036F}, // Combining Diacritical Marks
	    {begin: 0x0370, end: 0x03FF}, // Greek and Coptic
	    {begin: 0x2C80, end: 0x2CFF}, // Coptic
	    {begin: 0x0400, end: 0x04FF}, // Cyrillic
	    {begin: 0x0530, end: 0x058F}, // Armenian
	    {begin: 0x0590, end: 0x05FF}, // Hebrew
	    {begin: 0xA500, end: 0xA63F}, // Vai
	    {begin: 0x0600, end: 0x06FF}, // Arabic
	    {begin: 0x07C0, end: 0x07FF}, // NKo
	    {begin: 0x0900, end: 0x097F}, // Devanagari
	    {begin: 0x0980, end: 0x09FF}, // Bengali
	    {begin: 0x0A00, end: 0x0A7F}, // Gurmukhi
	    {begin: 0x0A80, end: 0x0AFF}, // Gujarati
	    {begin: 0x0B00, end: 0x0B7F}, // Oriya
	    {begin: 0x0B80, end: 0x0BFF}, // Tamil
	    {begin: 0x0C00, end: 0x0C7F}, // Telugu
	    {begin: 0x0C80, end: 0x0CFF}, // Kannada
	    {begin: 0x0D00, end: 0x0D7F}, // Malayalam
	    {begin: 0x0E00, end: 0x0E7F}, // Thai
	    {begin: 0x0E80, end: 0x0EFF}, // Lao
	    {begin: 0x10A0, end: 0x10FF}, // Georgian
	    {begin: 0x1B00, end: 0x1B7F}, // Balinese
	    {begin: 0x1100, end: 0x11FF}, // Hangul Jamo
	    {begin: 0x1E00, end: 0x1EFF}, // Latin Extended Additional
	    {begin: 0x1F00, end: 0x1FFF}, // Greek Extended
	    {begin: 0x2000, end: 0x206F}, // General Punctuation
	    {begin: 0x2070, end: 0x209F}, // Superscripts And Subscripts
	    {begin: 0x20A0, end: 0x20CF}, // Currency Symbol
	    {begin: 0x20D0, end: 0x20FF}, // Combining Diacritical Marks For Symbols
	    {begin: 0x2100, end: 0x214F}, // Letterlike Symbols
	    {begin: 0x2150, end: 0x218F}, // Number Forms
	    {begin: 0x2190, end: 0x21FF}, // Arrows
	    {begin: 0x2200, end: 0x22FF}, // Mathematical Operators
	    {begin: 0x2300, end: 0x23FF}, // Miscellaneous Technical
	    {begin: 0x2400, end: 0x243F}, // Control Pictures
	    {begin: 0x2440, end: 0x245F}, // Optical Character Recognition
	    {begin: 0x2460, end: 0x24FF}, // Enclosed Alphanumerics
	    {begin: 0x2500, end: 0x257F}, // Box Drawing
	    {begin: 0x2580, end: 0x259F}, // Block Elements
	    {begin: 0x25A0, end: 0x25FF}, // Geometric Shapes
	    {begin: 0x2600, end: 0x26FF}, // Miscellaneous Symbols
	    {begin: 0x2700, end: 0x27BF}, // Dingbats
	    {begin: 0x3000, end: 0x303F}, // CJK Symbols And Punctuation
	    {begin: 0x3040, end: 0x309F}, // Hiragana
	    {begin: 0x30A0, end: 0x30FF}, // Katakana
	    {begin: 0x3100, end: 0x312F}, // Bopomofo
	    {begin: 0x3130, end: 0x318F}, // Hangul Compatibility Jamo
	    {begin: 0xA840, end: 0xA87F}, // Phags-pa
	    {begin: 0x3200, end: 0x32FF}, // Enclosed CJK Letters And Months
	    {begin: 0x3300, end: 0x33FF}, // CJK Compatibility
	    {begin: 0xAC00, end: 0xD7AF}, // Hangul Syllables
	    {begin: 0xD800, end: 0xDFFF}, // Non-Plane 0 *
	    {begin: 0x10900, end: 0x1091F}, // Phoenicia
	    {begin: 0x4E00, end: 0x9FFF}, // CJK Unified Ideographs
	    {begin: 0xE000, end: 0xF8FF}, // Private Use Area (plane 0)
	    {begin: 0x31C0, end: 0x31EF}, // CJK Strokes
	    {begin: 0xFB00, end: 0xFB4F}, // Alphabetic Presentation Forms
	    {begin: 0xFB50, end: 0xFDFF}, // Arabic Presentation Forms-A
	    {begin: 0xFE20, end: 0xFE2F}, // Combining Half Marks
	    {begin: 0xFE10, end: 0xFE1F}, // Vertical Forms
	    {begin: 0xFE50, end: 0xFE6F}, // Small Form Variants
	    {begin: 0xFE70, end: 0xFEFF}, // Arabic Presentation Forms-B
	    {begin: 0xFF00, end: 0xFFEF}, // Halfwidth And Fullwidth Forms
	    {begin: 0xFFF0, end: 0xFFFF}, // Specials
	    {begin: 0x0F00, end: 0x0FFF}, // Tibetan
	    {begin: 0x0700, end: 0x074F}, // Syriac
	    {begin: 0x0780, end: 0x07BF}, // Thaana
	    {begin: 0x0D80, end: 0x0DFF}, // Sinhala
	    {begin: 0x1000, end: 0x109F}, // Myanmar
	    {begin: 0x1200, end: 0x137F}, // Ethiopic
	    {begin: 0x13A0, end: 0x13FF}, // Cherokee
	    {begin: 0x1400, end: 0x167F}, // Unified Canadian Aboriginal Syllabics
	    {begin: 0x1680, end: 0x169F}, // Ogham
	    {begin: 0x16A0, end: 0x16FF}, // Runic
	    {begin: 0x1780, end: 0x17FF}, // Khmer
	    {begin: 0x1800, end: 0x18AF}, // Mongolian
	    {begin: 0x2800, end: 0x28FF}, // Braille Patterns
	    {begin: 0xA000, end: 0xA48F}, // Yi Syllables
	    {begin: 0x1700, end: 0x171F}, // Tagalog
	    {begin: 0x10300, end: 0x1032F}, // Old Italic
	    {begin: 0x10330, end: 0x1034F}, // Gothic
	    {begin: 0x10400, end: 0x1044F}, // Deseret
	    {begin: 0x1D000, end: 0x1D0FF}, // Byzantine Musical Symbols
	    {begin: 0x1D400, end: 0x1D7FF}, // Mathematical Alphanumeric Symbols
	    {begin: 0xFF000, end: 0xFFFFD}, // Private Use (plane 15)
	    {begin: 0xFE00, end: 0xFE0F}, // Variation Selectors
	    {begin: 0xE0000, end: 0xE007F}, // Tags
	    {begin: 0x1900, end: 0x194F}, // Limbu
	    {begin: 0x1950, end: 0x197F}, // Tai Le
	    {begin: 0x1980, end: 0x19DF}, // New Tai Lue
	    {begin: 0x1A00, end: 0x1A1F}, // Buginese
	    {begin: 0x2C00, end: 0x2C5F}, // Glagolitic
	    {begin: 0x2D30, end: 0x2D7F}, // Tifinagh
	    {begin: 0x4DC0, end: 0x4DFF}, // Yijing Hexagram Symbols
	    {begin: 0xA800, end: 0xA82F}, // Syloti Nagri
	    {begin: 0x10000, end: 0x1007F}, // Linear B Syllabary
	    {begin: 0x10140, end: 0x1018F}, // Ancient Greek Numbers
	    {begin: 0x10380, end: 0x1039F}, // Ugaritic
	    {begin: 0x103A0, end: 0x103DF}, // Old Persian
	    {begin: 0x10450, end: 0x1047F}, // Shavian
	    {begin: 0x10480, end: 0x104AF}, // Osmanya
	    {begin: 0x10800, end: 0x1083F}, // Cypriot Syllabary
	    {begin: 0x10A00, end: 0x10A5F}, // Kharoshthi
	    {begin: 0x1D300, end: 0x1D35F}, // Tai Xuan Jing Symbols
	    {begin: 0x12000, end: 0x123FF}, // Cuneiform
	    {begin: 0x1D360, end: 0x1D37F}, // Counting Rod Numerals
	    {begin: 0x1B80, end: 0x1BBF}, // Sundanese
	    {begin: 0x1C00, end: 0x1C4F}, // Lepcha
	    {begin: 0x1C50, end: 0x1C7F}, // Ol Chiki
	    {begin: 0xA880, end: 0xA8DF}, // Saurashtra
	    {begin: 0xA900, end: 0xA92F}, // Kayah Li
	    {begin: 0xA930, end: 0xA95F}, // Rejang
	    {begin: 0xAA00, end: 0xAA5F}, // Cham
	    {begin: 0x10190, end: 0x101CF}, // Ancient Symbols
	    {begin: 0x101D0, end: 0x101FF}, // Phaistos Disc
	    {begin: 0x102A0, end: 0x102DF}, // Carian
	    {begin: 0x1F030, end: 0x1F09F}  // Domino Tiles
	];
	
	function getUnicodeRange(unicode) {
	    for (var i = 0; i < unicodeRanges.length; i += 1) {
	        var range = unicodeRanges[i];
	        if (unicode >= range.begin && unicode < range.end) {
	            return i;
	        }
	    }
	
	    return -1;
	}
	
	// Parse the OS/2 and Windows metrics `OS/2` table
	function parseOS2Table(data, start) {
	    var os2 = {};
	    var p = new parse.Parser(data, start);
	    os2.version = p.parseUShort();
	    os2.xAvgCharWidth = p.parseShort();
	    os2.usWeightClass = p.parseUShort();
	    os2.usWidthClass = p.parseUShort();
	    os2.fsType = p.parseUShort();
	    os2.ySubscriptXSize = p.parseShort();
	    os2.ySubscriptYSize = p.parseShort();
	    os2.ySubscriptXOffset = p.parseShort();
	    os2.ySubscriptYOffset = p.parseShort();
	    os2.ySuperscriptXSize = p.parseShort();
	    os2.ySuperscriptYSize = p.parseShort();
	    os2.ySuperscriptXOffset = p.parseShort();
	    os2.ySuperscriptYOffset = p.parseShort();
	    os2.yStrikeoutSize = p.parseShort();
	    os2.yStrikeoutPosition = p.parseShort();
	    os2.sFamilyClass = p.parseShort();
	    os2.panose = [];
	    for (var i = 0; i < 10; i++) {
	        os2.panose[i] = p.parseByte();
	    }
	
	    os2.ulUnicodeRange1 = p.parseULong();
	    os2.ulUnicodeRange2 = p.parseULong();
	    os2.ulUnicodeRange3 = p.parseULong();
	    os2.ulUnicodeRange4 = p.parseULong();
	    os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
	    os2.fsSelection = p.parseUShort();
	    os2.usFirstCharIndex = p.parseUShort();
	    os2.usLastCharIndex = p.parseUShort();
	    os2.sTypoAscender = p.parseShort();
	    os2.sTypoDescender = p.parseShort();
	    os2.sTypoLineGap = p.parseShort();
	    os2.usWinAscent = p.parseUShort();
	    os2.usWinDescent = p.parseUShort();
	    if (os2.version >= 1) {
	        os2.ulCodePageRange1 = p.parseULong();
	        os2.ulCodePageRange2 = p.parseULong();
	    }
	
	    if (os2.version >= 2) {
	        os2.sxHeight = p.parseShort();
	        os2.sCapHeight = p.parseShort();
	        os2.usDefaultChar = p.parseUShort();
	        os2.usBreakChar = p.parseUShort();
	        os2.usMaxContent = p.parseUShort();
	    }
	
	    return os2;
	}
	
	function makeOS2Table(options) {
	    return new table.Table('OS/2', [
	        {name: 'version', type: 'USHORT', value: 0x0003},
	        {name: 'xAvgCharWidth', type: 'SHORT', value: 0},
	        {name: 'usWeightClass', type: 'USHORT', value: 0},
	        {name: 'usWidthClass', type: 'USHORT', value: 0},
	        {name: 'fsType', type: 'USHORT', value: 0},
	        {name: 'ySubscriptXSize', type: 'SHORT', value: 650},
	        {name: 'ySubscriptYSize', type: 'SHORT', value: 699},
	        {name: 'ySubscriptXOffset', type: 'SHORT', value: 0},
	        {name: 'ySubscriptYOffset', type: 'SHORT', value: 140},
	        {name: 'ySuperscriptXSize', type: 'SHORT', value: 650},
	        {name: 'ySuperscriptYSize', type: 'SHORT', value: 699},
	        {name: 'ySuperscriptXOffset', type: 'SHORT', value: 0},
	        {name: 'ySuperscriptYOffset', type: 'SHORT', value: 479},
	        {name: 'yStrikeoutSize', type: 'SHORT', value: 49},
	        {name: 'yStrikeoutPosition', type: 'SHORT', value: 258},
	        {name: 'sFamilyClass', type: 'SHORT', value: 0},
	        {name: 'bFamilyType', type: 'BYTE', value: 0},
	        {name: 'bSerifStyle', type: 'BYTE', value: 0},
	        {name: 'bWeight', type: 'BYTE', value: 0},
	        {name: 'bProportion', type: 'BYTE', value: 0},
	        {name: 'bContrast', type: 'BYTE', value: 0},
	        {name: 'bStrokeVariation', type: 'BYTE', value: 0},
	        {name: 'bArmStyle', type: 'BYTE', value: 0},
	        {name: 'bLetterform', type: 'BYTE', value: 0},
	        {name: 'bMidline', type: 'BYTE', value: 0},
	        {name: 'bXHeight', type: 'BYTE', value: 0},
	        {name: 'ulUnicodeRange1', type: 'ULONG', value: 0},
	        {name: 'ulUnicodeRange2', type: 'ULONG', value: 0},
	        {name: 'ulUnicodeRange3', type: 'ULONG', value: 0},
	        {name: 'ulUnicodeRange4', type: 'ULONG', value: 0},
	        {name: 'achVendID', type: 'CHARARRAY', value: 'XXXX'},
	        {name: 'fsSelection', type: 'USHORT', value: 0},
	        {name: 'usFirstCharIndex', type: 'USHORT', value: 0},
	        {name: 'usLastCharIndex', type: 'USHORT', value: 0},
	        {name: 'sTypoAscender', type: 'SHORT', value: 0},
	        {name: 'sTypoDescender', type: 'SHORT', value: 0},
	        {name: 'sTypoLineGap', type: 'SHORT', value: 0},
	        {name: 'usWinAscent', type: 'USHORT', value: 0},
	        {name: 'usWinDescent', type: 'USHORT', value: 0},
	        {name: 'ulCodePageRange1', type: 'ULONG', value: 0},
	        {name: 'ulCodePageRange2', type: 'ULONG', value: 0},
	        {name: 'sxHeight', type: 'SHORT', value: 0},
	        {name: 'sCapHeight', type: 'SHORT', value: 0},
	        {name: 'usDefaultChar', type: 'USHORT', value: 0},
	        {name: 'usBreakChar', type: 'USHORT', value: 0},
	        {name: 'usMaxContext', type: 'USHORT', value: 0}
	    ], options);
	}
	
	exports.unicodeRanges = unicodeRanges;
	exports.getUnicodeRange = getUnicodeRange;
	exports.parse = parseOS2Table;
	exports.make = makeOS2Table;
	
	},{"../parse":9,"../table":11}],24:[function(_dereq_,module,exports){
	// The `post` table stores additional PostScript information, such as glyph names.
	// https://www.microsoft.com/typography/OTSPEC/post.htm
	
	'use strict';
	
	var encoding = _dereq_('../encoding');
	var parse = _dereq_('../parse');
	var table = _dereq_('../table');
	
	// Parse the PostScript `post` table
	function parsePostTable(data, start) {
	    var post = {};
	    var p = new parse.Parser(data, start);
	    var i;
	    post.version = p.parseVersion();
	    post.italicAngle = p.parseFixed();
	    post.underlinePosition = p.parseShort();
	    post.underlineThickness = p.parseShort();
	    post.isFixedPitch = p.parseULong();
	    post.minMemType42 = p.parseULong();
	    post.maxMemType42 = p.parseULong();
	    post.minMemType1 = p.parseULong();
	    post.maxMemType1 = p.parseULong();
	    switch (post.version) {
	    case 1:
	        post.names = encoding.standardNames.slice();
	        break;
	    case 2:
	        post.numberOfGlyphs = p.parseUShort();
	        post.glyphNameIndex = new Array(post.numberOfGlyphs);
	        for (i = 0; i < post.numberOfGlyphs; i++) {
	            post.glyphNameIndex[i] = p.parseUShort();
	        }
	
	        post.names = [];
	        for (i = 0; i < post.numberOfGlyphs; i++) {
	            if (post.glyphNameIndex[i] >= encoding.standardNames.length) {
	                var nameLength = p.parseChar();
	                post.names.push(p.parseString(nameLength));
	            }
	        }
	
	        break;
	    case 2.5:
	        post.numberOfGlyphs = p.parseUShort();
	        post.offset = new Array(post.numberOfGlyphs);
	        for (i = 0; i < post.numberOfGlyphs; i++) {
	            post.offset[i] = p.parseChar();
	        }
	
	        break;
	    }
	    return post;
	}
	
	function makePostTable() {
	    return new table.Table('post', [
	        {name: 'version', type: 'FIXED', value: 0x00030000},
	        {name: 'italicAngle', type: 'FIXED', value: 0},
	        {name: 'underlinePosition', type: 'FWORD', value: 0},
	        {name: 'underlineThickness', type: 'FWORD', value: 0},
	        {name: 'isFixedPitch', type: 'ULONG', value: 0},
	        {name: 'minMemType42', type: 'ULONG', value: 0},
	        {name: 'maxMemType42', type: 'ULONG', value: 0},
	        {name: 'minMemType1', type: 'ULONG', value: 0},
	        {name: 'maxMemType1', type: 'ULONG', value: 0}
	    ]);
	}
	
	exports.parse = parsePostTable;
	exports.make = makePostTable;
	
	},{"../encoding":4,"../parse":9,"../table":11}],25:[function(_dereq_,module,exports){
	// The `sfnt` wrapper provides organization for the tables in the font.
	// It is the top-level data structure in a font.
	// https://www.microsoft.com/typography/OTSPEC/otff.htm
	// Recommendations for creating OpenType Fonts:
	// http://www.microsoft.com/typography/otspec140/recom.htm
	
	'use strict';
	
	var check = _dereq_('../check');
	var table = _dereq_('../table');
	
	var cmap = _dereq_('./cmap');
	var cff = _dereq_('./cff');
	var head = _dereq_('./head');
	var hhea = _dereq_('./hhea');
	var hmtx = _dereq_('./hmtx');
	var maxp = _dereq_('./maxp');
	var _name = _dereq_('./name');
	var os2 = _dereq_('./os2');
	var post = _dereq_('./post');
	
	function log2(v) {
	    return Math.log(v) / Math.log(2) | 0;
	}
	
	function computeCheckSum(bytes) {
	    while (bytes.length % 4 !== 0) {
	        bytes.push(0);
	    }
	
	    var sum = 0;
	    for (var i = 0; i < bytes.length; i += 4) {
	        sum += (bytes[i] << 24) +
	            (bytes[i + 1] << 16) +
	            (bytes[i + 2] << 8) +
	            (bytes[i + 3]);
	    }
	
	    sum %= Math.pow(2, 32);
	    return sum;
	}
	
	function makeTableRecord(tag, checkSum, offset, length) {
	    return new table.Table('Table Record', [
	        {name: 'tag', type: 'TAG', value: tag !== undefined ? tag : ''},
	        {name: 'checkSum', type: 'ULONG', value: checkSum !== undefined ? checkSum : 0},
	        {name: 'offset', type: 'ULONG', value: offset !== undefined ? offset : 0},
	        {name: 'length', type: 'ULONG', value: length !== undefined ? length : 0}
	    ]);
	}
	
	function makeSfntTable(tables) {
	    var sfnt = new table.Table('sfnt', [
	        {name: 'version', type: 'TAG', value: 'OTTO'},
	        {name: 'numTables', type: 'USHORT', value: 0},
	        {name: 'searchRange', type: 'USHORT', value: 0},
	        {name: 'entrySelector', type: 'USHORT', value: 0},
	        {name: 'rangeShift', type: 'USHORT', value: 0}
	    ]);
	    sfnt.tables = tables;
	    sfnt.numTables = tables.length;
	    var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
	    sfnt.searchRange = 16 * highestPowerOf2;
	    sfnt.entrySelector = log2(highestPowerOf2);
	    sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;
	
	    var recordFields = [];
	    var tableFields = [];
	
	    var offset = sfnt.sizeOf() + (makeTableRecord().sizeOf() * sfnt.numTables);
	    while (offset % 4 !== 0) {
	        offset += 1;
	        tableFields.push({name: 'padding', type: 'BYTE', value: 0});
	    }
	
	    for (var i = 0; i < tables.length; i += 1) {
	        var t = tables[i];
	        check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
	        var tableLength = t.sizeOf();
	        var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
	        recordFields.push({name: tableRecord.tag + ' Table Record', type: 'TABLE', value: tableRecord});
	        tableFields.push({name: t.tableName + ' table', type: 'TABLE', value: t});
	        offset += tableLength;
	        check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
	        while (offset % 4 !== 0) {
	            offset += 1;
	            tableFields.push({name: 'padding', type: 'BYTE', value: 0});
	        }
	    }
	
	    // Table records need to be sorted alphabetically.
	    recordFields.sort(function(r1, r2) {
	        if (r1.value.tag > r2.value.tag) {
	            return 1;
	        } else {
	            return -1;
	        }
	    });
	
	    sfnt.fields = sfnt.fields.concat(recordFields);
	    sfnt.fields = sfnt.fields.concat(tableFields);
	    return sfnt;
	}
	
	// Get the metrics for a character. If the string has more than one character
	// this function returns metrics for the first available character.
	// You can provide optional fallback metrics if no characters are available.
	function metricsForChar(font, chars, notFoundMetrics) {
	    for (var i = 0; i < chars.length; i += 1) {
	        var glyphIndex = font.charToGlyphIndex(chars[i]);
	        if (glyphIndex > 0) {
	            var glyph = font.glyphs.get(glyphIndex);
	            return glyph.getMetrics();
	        }
	    }
	
	    return notFoundMetrics;
	}
	
	function average(vs) {
	    var sum = 0;
	    for (var i = 0; i < vs.length; i += 1) {
	        sum += vs[i];
	    }
	
	    return sum / vs.length;
	}
	
	// Convert the font object to a SFNT data structure.
	// This structure contains all the necessary tables and metadata to create a binary OTF file.
	function fontToSfntTable(font) {
	    var xMins = [];
	    var yMins = [];
	    var xMaxs = [];
	    var yMaxs = [];
	    var advanceWidths = [];
	    var leftSideBearings = [];
	    var rightSideBearings = [];
	    var firstCharIndex;
	    var lastCharIndex = 0;
	    var ulUnicodeRange1 = 0;
	    var ulUnicodeRange2 = 0;
	    var ulUnicodeRange3 = 0;
	    var ulUnicodeRange4 = 0;
	
	    for (var i = 0; i < font.glyphs.length; i += 1) {
	        var glyph = font.glyphs.get(i);
	        var unicode = glyph.unicode | 0;
	        if (firstCharIndex > unicode || firstCharIndex === null) {
	            firstCharIndex = unicode;
	        }
	
	        if (lastCharIndex < unicode) {
	            lastCharIndex = unicode;
	        }
	
	        var position = os2.getUnicodeRange(unicode);
	        if (position < 32) {
	            ulUnicodeRange1 |= 1 << position;
	        } else if (position < 64) {
	            ulUnicodeRange2 |= 1 << position - 32;
	        } else if (position < 96) {
	            ulUnicodeRange3 |= 1 << position - 64;
	        } else if (position < 123) {
	            ulUnicodeRange4 |= 1 << position - 96;
	        } else {
	            throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
	        }
	        // Skip non-important characters.
	        if (glyph.name === '.notdef') continue;
	        var metrics = glyph.getMetrics();
	        xMins.push(metrics.xMin);
	        yMins.push(metrics.yMin);
	        xMaxs.push(metrics.xMax);
	        yMaxs.push(metrics.yMax);
	        leftSideBearings.push(metrics.leftSideBearing);
	        rightSideBearings.push(metrics.rightSideBearing);
	        advanceWidths.push(glyph.advanceWidth);
	    }
	
	    var globals = {
	        xMin: Math.min.apply(null, xMins),
	        yMin: Math.min.apply(null, yMins),
	        xMax: Math.max.apply(null, xMaxs),
	        yMax: Math.max.apply(null, yMaxs),
	        advanceWidthMax: Math.max.apply(null, advanceWidths),
	        advanceWidthAvg: average(advanceWidths),
	        minLeftSideBearing: Math.min.apply(null, leftSideBearings),
	        maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
	        minRightSideBearing: Math.min.apply(null, rightSideBearings)
	    };
	    globals.ascender = font.ascender !== undefined ? font.ascender : globals.yMax;
	    globals.descender = font.descender !== undefined ? font.descender : globals.yMin;
	
	    var headTable = head.make({
	        unitsPerEm: font.unitsPerEm,
	        xMin: globals.xMin,
	        yMin: globals.yMin,
	        xMax: globals.xMax,
	        yMax: globals.yMax
	    });
	
	    var hheaTable = hhea.make({
	        ascender: globals.ascender,
	        descender: globals.descender,
	        advanceWidthMax: globals.advanceWidthMax,
	        minLeftSideBearing: globals.minLeftSideBearing,
	        minRightSideBearing: globals.minRightSideBearing,
	        xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
	        numberOfHMetrics: font.glyphs.length
	    });
	
	    var maxpTable = maxp.make(font.glyphs.length);
	
	    var os2Table = os2.make({
	        xAvgCharWidth: Math.round(globals.advanceWidthAvg),
	        usWeightClass: 500, // Medium FIXME Make this configurable
	        usWidthClass: 5, // Medium (normal) FIXME Make this configurable
	        usFirstCharIndex: firstCharIndex,
	        usLastCharIndex: lastCharIndex,
	        ulUnicodeRange1: ulUnicodeRange1,
	        ulUnicodeRange2: ulUnicodeRange2,
	        ulUnicodeRange3: ulUnicodeRange3,
	        ulUnicodeRange4: ulUnicodeRange4,
	        // See http://typophile.com/node/13081 for more info on vertical metrics.
	        // We get metrics for typical characters (such as "x" for xHeight).
	        // We provide some fallback characters if characters are unavailable: their
	        // ordering was chosen experimentally.
	        sTypoAscender: globals.ascender,
	        sTypoDescender: globals.descender,
	        sTypoLineGap: 0,
	        usWinAscent: globals.ascender,
	        usWinDescent: -globals.descender,
	        sxHeight: metricsForChar(font, 'xyvw', {yMax: 0}).yMax,
	        sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
	        usBreakChar: font.hasChar(' ') ? 32 : 0 // Use space as the break character, if available.
	    });
	
	    var hmtxTable = hmtx.make(font.glyphs);
	    var cmapTable = cmap.make(font.glyphs);
	
	    var fullName = font.familyName + ' ' + font.styleName;
	    var postScriptName = font.familyName.replace(/\s/g, '') + '-' + font.styleName;
	    var nameTable = _name.make({
	        copyright: font.copyright,
	        fontFamily: font.familyName,
	        fontSubfamily: font.styleName,
	        uniqueID: font.manufacturer + ':' + fullName,
	        fullName: fullName,
	        version: font.version,
	        postScriptName: postScriptName,
	        trademark: font.trademark,
	        manufacturer: font.manufacturer,
	        designer: font.designer,
	        description: font.description,
	        manufacturerURL: font.manufacturerURL,
	        designerURL: font.designerURL,
	        license: font.license,
	        licenseURL: font.licenseURL,
	        preferredFamily: font.familyName,
	        preferredSubfamily: font.styleName
	    });
	    var postTable = post.make();
	    var cffTable = cff.make(font.glyphs, {
	        version: font.version,
	        fullName: fullName,
	        familyName: font.familyName,
	        weightName: font.styleName,
	        postScriptName: postScriptName,
	        unitsPerEm: font.unitsPerEm
	    });
	    // Order the tables according to the the OpenType specification 1.4.
	    var tables = [headTable, hheaTable, maxpTable, os2Table, nameTable, cmapTable, postTable, cffTable, hmtxTable];
	
	    var sfntTable = makeSfntTable(tables);
	
	    // Compute the font's checkSum and store it in head.checkSumAdjustment.
	    var bytes = sfntTable.encode();
	    var checkSum = computeCheckSum(bytes);
	    var tableFields = sfntTable.fields;
	    var checkSumAdjusted = false;
	    for (i = 0; i < tableFields.length; i += 1) {
	        if (tableFields[i].name === 'head table') {
	            tableFields[i].value.checkSumAdjustment = 0xB1B0AFBA - checkSum;
	            checkSumAdjusted = true;
	            break;
	        }
	    }
	
	    if (!checkSumAdjusted) {
	        throw new Error('Could not find head table with checkSum to adjust.');
	    }
	
	    return sfntTable;
	}
	
	exports.computeCheckSum = computeCheckSum;
	exports.make = makeSfntTable;
	exports.fontToTable = fontToSfntTable;
	
	},{"../check":2,"../table":11,"./cff":12,"./cmap":13,"./head":16,"./hhea":17,"./hmtx":18,"./maxp":21,"./name":22,"./os2":23,"./post":24}],26:[function(_dereq_,module,exports){
	// Data types used in the OpenType font file.
	// All OpenType fonts use Motorola-style byte ordering (Big Endian)
	
	/* global WeakMap */
	
	'use strict';
	
	var check = _dereq_('./check');
	
	var LIMIT16 = 32768; // The limit at which a 16-bit number switches signs == 2^15
	var LIMIT32 = 2147483648; // The limit at which a 32-bit number switches signs == 2 ^ 31
	
	var decode = {};
	var encode = {};
	var sizeOf = {};
	
	// Return a function that always returns the same value.
	function constant(v) {
	    return function() {
	        return v;
	    };
	}
	
	// OpenType data types //////////////////////////////////////////////////////
	
	// Convert an 8-bit unsigned integer to a list of 1 byte.
	encode.BYTE = function(v) {
	    check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
	    return [v];
	};
	
	sizeOf.BYTE = constant(1);
	
	// Convert a 8-bit signed integer to a list of 1 byte.
	encode.CHAR = function(v) {
	    return [v.charCodeAt(0)];
	};
	
	sizeOf.BYTE = constant(1);
	
	// Convert an ASCII string to a list of bytes.
	encode.CHARARRAY = function(v) {
	    var b = [];
	    for (var i = 0; i < v.length; i += 1) {
	        b.push(v.charCodeAt(i));
	    }
	
	    return b;
	};
	
	sizeOf.CHARARRAY = function(v) {
	    return v.length;
	};
	
	// Convert a 16-bit unsigned integer to a list of 2 bytes.
	encode.USHORT = function(v) {
	    return [(v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.USHORT = constant(2);
	
	// Convert a 16-bit signed integer to a list of 2 bytes.
	encode.SHORT = function(v) {
	    // Two's complement
	    if (v >= LIMIT16) {
	        v = -(2 * LIMIT16 - v);
	    }
	
	    return [(v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.SHORT = constant(2);
	
	// Convert a 24-bit unsigned integer to a list of 3 bytes.
	encode.UINT24 = function(v) {
	    return [(v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.UINT24 = constant(3);
	
	// Convert a 32-bit unsigned integer to a list of 4 bytes.
	encode.ULONG = function(v) {
	    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.ULONG = constant(4);
	
	// Convert a 32-bit unsigned integer to a list of 4 bytes.
	encode.LONG = function(v) {
	    // Two's complement
	    if (v >= LIMIT32) {
	        v = -(2 * LIMIT32 - v);
	    }
	
	    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.LONG = constant(4);
	
	encode.FIXED = encode.ULONG;
	sizeOf.FIXED = sizeOf.ULONG;
	
	encode.FWORD = encode.SHORT;
	sizeOf.FWORD = sizeOf.SHORT;
	
	encode.UFWORD = encode.USHORT;
	sizeOf.UFWORD = sizeOf.USHORT;
	
	// FIXME Implement LONGDATETIME
	encode.LONGDATETIME = function() {
	    return [0, 0, 0, 0, 0, 0, 0, 0];
	};
	
	sizeOf.LONGDATETIME = constant(8);
	
	// Convert a 4-char tag to a list of 4 bytes.
	encode.TAG = function(v) {
	    check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
	    return [v.charCodeAt(0),
	            v.charCodeAt(1),
	            v.charCodeAt(2),
	            v.charCodeAt(3)];
	};
	
	sizeOf.TAG = constant(4);
	
	// CFF data types ///////////////////////////////////////////////////////////
	
	encode.Card8 = encode.BYTE;
	sizeOf.Card8 = sizeOf.BYTE;
	
	encode.Card16 = encode.USHORT;
	sizeOf.Card16 = sizeOf.USHORT;
	
	encode.OffSize = encode.BYTE;
	sizeOf.OffSize = sizeOf.BYTE;
	
	encode.SID = encode.USHORT;
	sizeOf.SID = sizeOf.USHORT;
	
	// Convert a numeric operand or charstring number to a variable-size list of bytes.
	encode.NUMBER = function(v) {
	    if (v >= -107 && v <= 107) {
	        return [v + 139];
	    } else if (v >= 108 && v <= 1131) {
	        v = v - 108;
	        return [(v >> 8) + 247, v & 0xFF];
	    } else if (v >= -1131 && v <= -108) {
	        v = -v - 108;
	        return [(v >> 8) + 251, v & 0xFF];
	    } else if (v >= -32768 && v <= 32767) {
	        return encode.NUMBER16(v);
	    } else {
	        return encode.NUMBER32(v);
	    }
	};
	
	sizeOf.NUMBER = function(v) {
	    return encode.NUMBER(v).length;
	};
	
	// Convert a signed number between -32768 and +32767 to a three-byte value.
	// This ensures we always use three bytes, but is not the most compact format.
	encode.NUMBER16 = function(v) {
	    return [28, (v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.NUMBER16 = constant(2);
	
	// Convert a signed number between -(2^31) and +(2^31-1) to a four-byte value.
	// This is useful if you want to be sure you always use four bytes,
	// at the expense of wasting a few bytes for smaller numbers.
	encode.NUMBER32 = function(v) {
	    return [29, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
	};
	
	sizeOf.NUMBER32 = constant(4);
	
	encode.REAL = function(v) {
	    var value = v.toString();
	
	    // Some numbers use an epsilon to encode the value. (e.g. JavaScript will store 0.0000001 as 1e-7)
	    // This code converts it back to a number without the epsilon.
	    var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
	    if (m) {
	        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
	        value = (Math.round(v * epsilon) / epsilon).toString();
	    }
	
	    var nibbles = '';
	    var i;
	    var ii;
	    for (i = 0, ii = value.length; i < ii; i += 1) {
	        var c = value[i];
	        if (c === 'e') {
	            nibbles += value[++i] === '-' ? 'c' : 'b';
	        } else if (c === '.') {
	            nibbles += 'a';
	        } else if (c === '-') {
	            nibbles += 'e';
	        } else {
	            nibbles += c;
	        }
	    }
	
	    nibbles += (nibbles.length & 1) ? 'f' : 'ff';
	    var out = [30];
	    for (i = 0, ii = nibbles.length; i < ii; i += 2) {
	        out.push(parseInt(nibbles.substr(i, 2), 16));
	    }
	
	    return out;
	};
	
	sizeOf.REAL = function(v) {
	    return encode.REAL(v).length;
	};
	
	encode.NAME = encode.CHARARRAY;
	sizeOf.NAME = sizeOf.CHARARRAY;
	
	encode.STRING = encode.CHARARRAY;
	sizeOf.STRING = sizeOf.CHARARRAY;
	
	// Convert a ASCII string to a list of UTF16 bytes.
	encode.UTF16 = function(v) {
	    var b = [];
	    for (var i = 0; i < v.length; i += 1) {
	        b.push(0);
	        b.push(v.charCodeAt(i));
	    }
	
	    return b;
	};
	
	sizeOf.UTF16 = function(v) {
	    return v.length * 2;
	};
	
	// Convert a list of values to a CFF INDEX structure.
	// The values should be objects containing name / type / value.
	encode.INDEX = function(l) {
	    var i;
	    //var offset, offsets, offsetEncoder, encodedOffsets, encodedOffset, data,
	    //    dataSize, i, v;
	    // Because we have to know which data type to use to encode the offsets,
	    // we have to go through the values twice: once to encode the data and
	    // calculate the offets, then again to encode the offsets using the fitting data type.
	    var offset = 1; // First offset is always 1.
	    var offsets = [offset];
	    var data = [];
	    var dataSize = 0;
	    for (i = 0; i < l.length; i += 1) {
	        var v = encode.OBJECT(l[i]);
	        Array.prototype.push.apply(data, v);
	        dataSize += v.length;
	        offset += v.length;
	        offsets.push(offset);
	    }
	
	    if (data.length === 0) {
	        return [0, 0];
	    }
	
	    var encodedOffsets = [];
	    var offSize = (1 + Math.floor(Math.log(dataSize) / Math.log(2)) / 8) | 0;
	    var offsetEncoder = [undefined, encode.BYTE, encode.USHORT, encode.UINT24, encode.ULONG][offSize];
	    for (i = 0; i < offsets.length; i += 1) {
	        var encodedOffset = offsetEncoder(offsets[i]);
	        Array.prototype.push.apply(encodedOffsets, encodedOffset);
	    }
	
	    return Array.prototype.concat(encode.Card16(l.length),
	                           encode.OffSize(offSize),
	                           encodedOffsets,
	                           data);
	};
	
	sizeOf.INDEX = function(v) {
	    return encode.INDEX(v).length;
	};
	
	// Convert an object to a CFF DICT structure.
	// The keys should be numeric.
	// The values should be objects containing name / type / value.
	encode.DICT = function(m) {
	    var d = [];
	    var keys = Object.keys(m);
	    var length = keys.length;
	
	    for (var i = 0; i < length; i += 1) {
	        // Object.keys() return string keys, but our keys are always numeric.
	        var k = parseInt(keys[i], 0);
	        var v = m[k];
	        // Value comes before the key.
	        d = d.concat(encode.OPERAND(v.value, v.type));
	        d = d.concat(encode.OPERATOR(k));
	    }
	
	    return d;
	};
	
	sizeOf.DICT = function(m) {
	    return encode.DICT(m).length;
	};
	
	encode.OPERATOR = function(v) {
	    if (v < 1200) {
	        return [v];
	    } else {
	        return [12, v - 1200];
	    }
	};
	
	encode.OPERAND = function(v, type) {
	    var d = [];
	    if (Array.isArray(type)) {
	        for (var i = 0; i < type.length; i += 1) {
	            check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
	            d = d.concat(encode.OPERAND(v[i], type[i]));
	        }
	    } else {
	        if (type === 'SID') {
	            d = d.concat(encode.NUMBER(v));
	        } else if (type === 'offset') {
	            // We make it easy for ourselves and always encode offsets as
	            // 4 bytes. This makes offset calculation for the top dict easier.
	            d = d.concat(encode.NUMBER32(v));
	        } else if (type === 'number') {
	            d = d.concat(encode.NUMBER(v));
	        } else if (type === 'real') {
	            d = d.concat(encode.REAL(v));
	        } else {
	            throw new Error('Unknown operand type ' + type);
	            // FIXME Add support for booleans
	        }
	    }
	
	    return d;
	};
	
	encode.OP = encode.BYTE;
	sizeOf.OP = sizeOf.BYTE;
	
	// memoize charstring encoding using WeakMap if available
	var wmm = typeof WeakMap === 'function' && new WeakMap();
	// Convert a list of CharString operations to bytes.
	encode.CHARSTRING = function(ops) {
	    if (wmm && wmm.has(ops)) {
	        return wmm.get(ops);
	    }
	
	    var d = [];
	    var length = ops.length;
	
	    for (var i = 0; i < length; i += 1) {
	        var op = ops[i];
	        d = d.concat(encode[op.type](op.value));
	    }
	
	    if (wmm) {
	        wmm.set(ops, d);
	    }
	
	    return d;
	};
	
	sizeOf.CHARSTRING = function(ops) {
	    return encode.CHARSTRING(ops).length;
	};
	
	// Utility functions ////////////////////////////////////////////////////////
	
	// Convert an object containing name / type / value to bytes.
	encode.OBJECT = function(v) {
	    var encodingFunction = encode[v.type];
	    check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
	    return encodingFunction(v.value);
	};
	
	// Convert a table object to bytes.
	// A table contains a list of fields containing the metadata (name, type and default value).
	// The table itself has the field values set as attributes.
	encode.TABLE = function(table) {
	    var d = [];
	    var length = table.fields.length;
	
	    for (var i = 0; i < length; i += 1) {
	        var field = table.fields[i];
	        var encodingFunction = encode[field.type];
	        check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type);
	        var value = table[field.name];
	        if (value === undefined) {
	            value = field.value;
	        }
	
	        var bytes = encodingFunction(value);
	        d = d.concat(bytes);
	    }
	
	    return d;
	};
	
	// Merge in a list of bytes.
	encode.LITERAL = function(v) {
	    return v;
	};
	
	sizeOf.LITERAL = function(v) {
	    return v.length;
	};
	
	exports.decode = decode;
	exports.encode = encode;
	exports.sizeOf = sizeOf;
	
	},{"./check":2}],27:[function(_dereq_,module,exports){
	/*!
	  * Reqwest! A general purpose XHR connection manager
	  * license MIT (c) Dustin Diaz 2014
	  * https://github.com/ded/reqwest
	  */
	
	!function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (typeof define == 'function' && define.amd) define(definition)
	  else context[name] = definition()
	}('reqwest', this, function () {
	
	  var win = window
	    , doc = document
	    , httpsRe = /^http/
	    , protocolRe = /(^\w+):\/\//
	    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	    , byTag = 'getElementsByTagName'
	    , readyState = 'readyState'
	    , contentType = 'Content-Type'
	    , requestedWith = 'X-Requested-With'
	    , head = doc[byTag]('head')[0]
	    , uniqid = 0
	    , callbackPrefix = 'reqwest_' + (+new Date())
	    , lastValue // data stored by the most recent JSONP callback
	    , xmlHttpRequest = 'XMLHttpRequest'
	    , xDomainRequest = 'XDomainRequest'
	    , noop = function () {}
	
	    , isArray = typeof Array.isArray == 'function'
	        ? Array.isArray
	        : function (a) {
	            return a instanceof Array
	          }
	
	    , defaultHeaders = {
	          'contentType': 'application/x-www-form-urlencoded'
	        , 'requestedWith': xmlHttpRequest
	        , 'accept': {
	              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
	            , 'xml':  'application/xml, text/xml'
	            , 'html': 'text/html'
	            , 'text': 'text/plain'
	            , 'json': 'application/json, text/javascript'
	            , 'js':   'application/javascript, text/javascript'
	          }
	      }
	
	    , xhr = function(o) {
	        // is it x-domain
	        if (o['crossOrigin'] === true) {
	          var xhr = win[xmlHttpRequest] ? new XMLHttpRequest() : null
	          if (xhr && 'withCredentials' in xhr) {
	            return xhr
	          } else if (win[xDomainRequest]) {
	            return new XDomainRequest()
	          } else {
	            throw new Error('Browser does not support cross-origin requests')
	          }
	        } else if (win[xmlHttpRequest]) {
	          return new XMLHttpRequest()
	        } else {
	          return new ActiveXObject('Microsoft.XMLHTTP')
	        }
	      }
	    , globalSetupOptions = {
	        dataFilter: function (data) {
	          return data
	        }
	      }
	
	  function succeed(r) {
	    var protocol = protocolRe.exec(r.url);
	    protocol = (protocol && protocol[1]) || window.location.protocol;
	    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response;
	  }
	
	  function handleReadyState(r, success, error) {
	    return function () {
	      // use _aborted to mitigate against IE err c00c023f
	      // (can't read props on aborted request objects)
	      if (r._aborted) return error(r.request)
	      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
	      if (r.request && r.request[readyState] == 4) {
	        r.request.onreadystatechange = noop
	        if (succeed(r)) success(r.request)
	        else
	          error(r.request)
	      }
	    }
	  }
	
	  function setHeaders(http, o) {
	    var headers = o['headers'] || {}
	      , h
	
	    headers['Accept'] = headers['Accept']
	      || defaultHeaders['accept'][o['type']]
	      || defaultHeaders['accept']['*']
	
	    var isAFormData = typeof FormData === 'function' && (o['data'] instanceof FormData);
	    // breaks cross-origin requests with legacy browsers
	    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
	    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
	    for (h in headers)
	      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
	  }
	
	  function setCredentials(http, o) {
	    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	      http.withCredentials = !!o['withCredentials']
	    }
	  }
	
	  function generalCallback(data) {
	    lastValue = data
	  }
	
	  function urlappend (url, s) {
	    return url + (/\?/.test(url) ? '&' : '?') + s
	  }
	
	  function handleJsonp(o, fn, err, url) {
	    var reqId = uniqid++
	      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
	      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
	      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
	      , match = url.match(cbreg)
	      , script = doc.createElement('script')
	      , loaded = 0
	      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1
	
	    if (match) {
	      if (match[3] === '?') {
	        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
	      } else {
	        cbval = match[3] // provided callback func name
	      }
	    } else {
	      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
	    }
	
	    win[cbval] = generalCallback
	
	    script.type = 'text/javascript'
	    script.src = url
	    script.async = true
	    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	      // need this for IE due to out-of-order onreadystatechange(), binding script
	      // execution to an event listener gives us control over when the script
	      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	      script.htmlFor = script.id = '_reqwest_' + reqId
	    }
	
	    script.onload = script.onreadystatechange = function () {
	      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
	        return false
	      }
	      script.onload = script.onreadystatechange = null
	      script.onclick && script.onclick()
	      // Call the user callback with the last value stored and clean up values and scripts.
	      fn(lastValue)
	      lastValue = undefined
	      head.removeChild(script)
	      loaded = 1
	    }
	
	    // Add the script to the DOM head
	    head.appendChild(script)
	
	    // Enable JSONP timeout
	    return {
	      abort: function () {
	        script.onload = script.onreadystatechange = null
	        err({}, 'Request is aborted: timeout', {})
	        lastValue = undefined
	        head.removeChild(script)
	        loaded = 1
	      }
	    }
	  }
	
	  function getRequest(fn, err) {
	    var o = this.o
	      , method = (o['method'] || 'GET').toUpperCase()
	      , url = typeof o === 'string' ? o : o['url']
	      // convert non-string objects to query-string form unless o['processData'] is false
	      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
	        ? reqwest.toQueryString(o['data'])
	        : (o['data'] || null)
	      , http
	      , sendWait = false
	
	    // if we're working on a GET request and we have data then we should append
	    // query string to end of URL and not post data
	    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
	      url = urlappend(url, data)
	      data = null
	    }
	
	    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)
	
	    // get the xhr from the factory if passed
	    // if the factory returns null, fall-back to ours
	    http = (o.xhr && o.xhr(o)) || xhr(o)
	
	    http.open(method, url, o['async'] === false ? false : true)
	    setHeaders(http, o)
	    setCredentials(http, o)
	    if (win[xDomainRequest] && http instanceof win[xDomainRequest]) {
	        http.onload = fn
	        http.onerror = err
	        // NOTE: see
	        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	        http.onprogress = function() {}
	        sendWait = true
	    } else {
	      http.onreadystatechange = handleReadyState(this, fn, err)
	    }
	    o['before'] && o['before'](http)
	    if (sendWait) {
	      setTimeout(function () {
	        http.send(data)
	      }, 200)
	    } else {
	      http.send(data)
	    }
	    return http
	  }
	
	  function Reqwest(o, fn) {
	    this.o = o
	    this.fn = fn
	
	    init.apply(this, arguments)
	  }
	
	  function setType(header) {
	    // json, javascript, text/plain, text/html, xml
	    if (header.match('json')) return 'json'
	    if (header.match('javascript')) return 'js'
	    if (header.match('text')) return 'html'
	    if (header.match('xml')) return 'xml'
	  }
	
	  function init(o, fn) {
	
	    this.url = typeof o == 'string' ? o : o['url']
	    this.timeout = null
	
	    // whether request has been fulfilled for purpose
	    // of tracking the Promises
	    this._fulfilled = false
	    // success handlers
	    this._successHandler = function(){}
	    this._fulfillmentHandlers = []
	    // error handlers
	    this._errorHandlers = []
	    // complete (both success and fail) handlers
	    this._completeHandlers = []
	    this._erred = false
	    this._responseArgs = {}
	
	    var self = this
	
	    fn = fn || function () {}
	
	    if (o['timeout']) {
	      this.timeout = setTimeout(function () {
	        timedOut()
	      }, o['timeout'])
	    }
	
	    if (o['success']) {
	      this._successHandler = function () {
	        o['success'].apply(o, arguments)
	      }
	    }
	
	    if (o['error']) {
	      this._errorHandlers.push(function () {
	        o['error'].apply(o, arguments)
	      })
	    }
	
	    if (o['complete']) {
	      this._completeHandlers.push(function () {
	        o['complete'].apply(o, arguments)
	      })
	    }
	
	    function complete (resp) {
	      o['timeout'] && clearTimeout(self.timeout)
	      self.timeout = null
	      while (self._completeHandlers.length > 0) {
	        self._completeHandlers.shift()(resp)
	      }
	    }
	
	    function success (resp) {
	      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
	      resp = (type !== 'jsonp') ? self.request : resp
	      // use global data filter on response text
	      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
	        , r = filteredResponse
	      try {
	        resp.responseText = r
	      } catch (e) {
	        // can't assign this in IE<=8, just ignore
	      }
	      if (r) {
	        switch (type) {
	        case 'json':
	          try {
	            resp = win.JSON ? win.JSON.parse(r) : eval('(' + r + ')')
	          } catch (err) {
	            return error(resp, 'Could not parse JSON in response', err)
	          }
	          break
	        case 'js':
	          resp = eval(r)
	          break
	        case 'html':
	          resp = r
	          break
	        case 'xml':
	          resp = resp.responseXML
	              && resp.responseXML.parseError // IE trololo
	              && resp.responseXML.parseError.errorCode
	              && resp.responseXML.parseError.reason
	            ? null
	            : resp.responseXML
	          break
	        }
	      }
	
	      self._responseArgs.resp = resp
	      self._fulfilled = true
	      fn(resp)
	      self._successHandler(resp)
	      while (self._fulfillmentHandlers.length > 0) {
	        resp = self._fulfillmentHandlers.shift()(resp)
	      }
	
	      complete(resp)
	    }
	
	    function timedOut() {
	      self._timedOut = true
	      self.request.abort()      
	    }
	
	    function error(resp, msg, t) {
	      resp = self.request
	      self._responseArgs.resp = resp
	      self._responseArgs.msg = msg
	      self._responseArgs.t = t
	      self._erred = true
	      while (self._errorHandlers.length > 0) {
	        self._errorHandlers.shift()(resp, msg, t)
	      }
	      complete(resp)
	    }
	
	    this.request = getRequest.call(this, success, error)
	  }
	
	  Reqwest.prototype = {
	    abort: function () {
	      this._aborted = true
	      this.request.abort()
	    }
	
	  , retry: function () {
	      init.call(this, this.o, this.fn)
	    }
	
	    /**
	     * Small deviation from the Promises A CommonJs specification
	     * http://wiki.commonjs.org/wiki/Promises/A
	     */
	
	    /**
	     * `then` will execute upon successful requests
	     */
	  , then: function (success, fail) {
	      success = success || function () {}
	      fail = fail || function () {}
	      if (this._fulfilled) {
	        this._responseArgs.resp = success(this._responseArgs.resp)
	      } else if (this._erred) {
	        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._fulfillmentHandlers.push(success)
	        this._errorHandlers.push(fail)
	      }
	      return this
	    }
	
	    /**
	     * `always` will execute whether the request succeeds or fails
	     */
	  , always: function (fn) {
	      if (this._fulfilled || this._erred) {
	        fn(this._responseArgs.resp)
	      } else {
	        this._completeHandlers.push(fn)
	      }
	      return this
	    }
	
	    /**
	     * `fail` will execute when the request fails
	     */
	  , fail: function (fn) {
	      if (this._erred) {
	        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._errorHandlers.push(fn)
	      }
	      return this
	    }
	  , 'catch': function (fn) {
	      return this.fail(fn)
	    }
	  }
	
	  function reqwest(o, fn) {
	    return new Reqwest(o, fn)
	  }
	
	  // normalize newline variants according to spec -> CRLF
	  function normalize(s) {
	    return s ? s.replace(/\r?\n/g, '\r\n') : ''
	  }
	
	  function serial(el, cb) {
	    var n = el.name
	      , t = el.tagName.toLowerCase()
	      , optCb = function (o) {
	          // IE gives value="" even where there is no value attribute
	          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	          if (o && !o['disabled'])
	            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
	        }
	      , ch, ra, val, i
	
	    // don't serialize elements that are disabled or without a name
	    if (el.disabled || !n) return
	
	    switch (t) {
	    case 'input':
	      if (!/reset|button|image|file/i.test(el.type)) {
	        ch = /checkbox/i.test(el.type)
	        ra = /radio/i.test(el.type)
	        val = el.value
	        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
	      }
	      break
	    case 'textarea':
	      cb(n, normalize(el.value))
	      break
	    case 'select':
	      if (el.type.toLowerCase() === 'select-one') {
	        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
	      } else {
	        for (i = 0; el.length && i < el.length; i++) {
	          el.options[i].selected && optCb(el.options[i])
	        }
	      }
	      break
	    }
	  }
	
	  // collect up all form elements found from the passed argument elements all
	  // the way down to child elements; pass a '<form>' or form fields.
	  // called with 'this'=callback to use for serial() on each element
	  function eachFormElement() {
	    var cb = this
	      , e, i
	      , serializeSubtags = function (e, tags) {
	          var i, j, fa
	          for (i = 0; i < tags.length; i++) {
	            fa = e[byTag](tags[i])
	            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
	          }
	        }
	
	    for (i = 0; i < arguments.length; i++) {
	      e = arguments[i]
	      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
	      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
	    }
	  }
	
	  // standard query string style serialization
	  function serializeQueryString() {
	    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
	  }
	
	  // { 'name': 'value', ... } style serialization
	  function serializeHash() {
	    var hash = {}
	    eachFormElement.apply(function (name, value) {
	      if (name in hash) {
	        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
	        hash[name].push(value)
	      } else hash[name] = value
	    }, arguments)
	    return hash
	  }
	
	  // [ { name: 'name', value: 'value' }, ... ] style serialization
	  reqwest.serializeArray = function () {
	    var arr = []
	    eachFormElement.apply(function (name, value) {
	      arr.push({name: name, value: value})
	    }, arguments)
	    return arr
	  }
	
	  reqwest.serialize = function () {
	    if (arguments.length === 0) return ''
	    var opt, fn
	      , args = Array.prototype.slice.call(arguments, 0)
	
	    opt = args.pop()
	    opt && opt.nodeType && args.push(opt) && (opt = null)
	    opt && (opt = opt.type)
	
	    if (opt == 'map') fn = serializeHash
	    else if (opt == 'array') fn = reqwest.serializeArray
	    else fn = serializeQueryString
	
	    return fn.apply(null, args)
	  }
	
	  reqwest.toQueryString = function (o, trad) {
	    var prefix, i
	      , traditional = trad || false
	      , s = []
	      , enc = encodeURIComponent
	      , add = function (key, value) {
	          // If value is a function, invoke it and return its value
	          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
	          s[s.length] = enc(key) + '=' + enc(value)
	        }
	    // If an array was passed in, assume that it is an array of form elements.
	    if (isArray(o)) {
	      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
	    } else {
	      // If traditional, encode the "old" way (the way 1.3.2 or older
	      // did it), otherwise encode params recursively.
	      for (prefix in o) {
	        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
	      }
	    }
	
	    // spaces should be + according to spec
	    return s.join('&').replace(/%20/g, '+')
	  }
	
	  function buildParams(prefix, obj, traditional, add) {
	    var name, i, v
	      , rbracket = /\[\]$/
	
	    if (isArray(obj)) {
	      // Serialize array item.
	      for (i = 0; obj && i < obj.length; i++) {
	        v = obj[i]
	        if (traditional || rbracket.test(prefix)) {
	          // Treat each array item as a scalar.
	          add(prefix, v)
	        } else {
	          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
	        }
	      }
	    } else if (obj && obj.toString() === '[object Object]') {
	      // Serialize object item.
	      for (name in obj) {
	        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
	      }
	
	    } else {
	      // Serialize scalar item.
	      add(prefix, obj)
	    }
	  }
	
	  reqwest.getcallbackPrefix = function () {
	    return callbackPrefix
	  }
	
	  // jQuery and Zepto compatibility, differences can be remapped here so you can call
	  // .ajax.compat(options, callback)
	  reqwest.compat = function (o, fn) {
	    if (o) {
	      o['type'] && (o['method'] = o['type']) && delete o['type']
	      o['dataType'] && (o['type'] = o['dataType'])
	      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
	      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
	    }
	    return new Reqwest(o, fn)
	  }
	
	  reqwest.ajaxSetup = function (options) {
	    options = options || {}
	    for (var k in options) {
	      globalSetupOptions[k] = options[k]
	    }
	  }
	
	  return reqwest
	});
	
	},{}],28:[function(_dereq_,module,exports){
	/**
	 * @module Shape
	 * @submodule 3D Primitives
	 * @for p5
	 * @requires core
	 * @requires p5.Geometry3D
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	_dereq_('./p5.Geometry3D');
	
	/**
	 * Draw a plane with given a width and height
	 * @method plane
	 * @param  {Number} width      width of the plane
	 * @param  {Number} height     height of the plane
	 * @return {p5}                the p5 object
	 * @example
	 * <div>
	 * <code>
	 * //draw a plane with width 200 and height 200
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   plane(200, 200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.plane = function(width, height){
	
	  width = width || 50;
	  height = height || 50;
	
	  //details for plane are highly optional
	  var detailX = typeof arguments[2] === Number ? arguments[2] : 1;
	  var detailY = typeof arguments[3] === Number ? arguments[3] : 1;
	
	  var gId = 'plane|'+width+'|'+height+'|'+detailX+'|'+detailY;
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createPlane = function(u, v){
	      var x = 2 * width * u - width;
	      var y = 2 * height * v - height;
	      var z = 0;
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(createPlane, detailX, detailY);
	
	    var obj = geometry3d.generateObj();
	
	    this._renderer.initBuffer(gId, [obj]);
	
	  }
	
	  this._renderer.drawBuffer(gId);
	
	};
	
	/**
	 * Draw a sphere with given raduis
	 * @method sphere
	 * @param  {Number} radius            radius of circle
	 * @param  {Number} [detail]          number of segments,
	 *                                    the more segments the smoother geometry
	 *                                    default is 24. Avoid detail number above
	 *                                    150, it may crash the browser.
	 * @example
	 * <div>
	 * <code>
	 * // draw a sphere with radius 200
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.sphere = function(radius, detail){
	
	  radius = radius || 50;
	
	  var detailX = detail || 24;
	  var detailY = detail || 16;
	
	  var gId = 'sphere|'+radius+'|'+detailX+'|'+detailY;
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createSphere = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var phi = Math.PI * v - Math.PI / 2;
	      var x = radius * Math.cos(phi) * Math.sin(theta);
	      var y = radius * Math.sin(phi);
	      var z = radius * Math.cos(phi) * Math.cos(theta);
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(createSphere, detailX, detailY);
	
	    var obj = geometry3d.generateObj(true, true);
	
	    this._renderer.initBuffer(gId, [obj]);
	  }
	
	  this._renderer.drawBuffer(gId);
	
	  return this;
	};
	
	/**
	 * Draw an ellipsoid with given raduis
	 * @method ellipsoid
	 * @param  {Number} radiusx           xradius of circle
	 * @param  {Number} radiusy           yradius of circle
	 * @param  {Number} radiusz           zradius of circle
	 * @param  {Number} [detail]          number of segments,
	 *                                    the more segments the smoother geometry
	 *                                    default is 24. Avoid detail number above
	 *                                    150. It may crash the browser.
	 * @return {p5}                       the p5 object
	 * @example
	 * <div>
	 * <code>
	 * // draw an ellipsoid with radius 200, 300 and 400 .
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   ellipsoid(200,300,400);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.ellipsoid = function(radiusx, radiusy, radiusz, detail){
	
	  radiusx = radiusx || 50;
	  radiusy = radiusy || 50;
	  radiusz = radiusz || 50;
	
	  var detailX = detail || 24;
	  var detailY = detail || 24;
	
	  var gId = 'ellipsoid|'+radiusx+'|'+radiusy+
	  '|'+radiusz+'|'+detailX+'|'+detailY;
	
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createEllipsoid = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var phi = Math.PI * v - Math.PI / 2;
	      var x = radiusx * Math.cos(phi) * Math.sin(theta);
	      var y = radiusy * Math.sin(phi);
	      var z = radiusz * Math.cos(phi) * Math.cos(theta);
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(createEllipsoid, detailX, detailY);
	
	    var obj = geometry3d.generateObj(true, true);
	
	    this._renderer.initBuffer(gId, [obj]);
	  }
	
	  this._renderer.drawBuffer(gId);
	
	  return this;
	};
	
	/**
	 * Draw a cylinder with given radius and height
	 * @method  cylinder
	 * @param  {Number} radius            radius of the surface
	 * @param  {Number} height            height of the cylinder
	 * @param  {Number} [detail]          number of segments,
	 *                                    the more segments the smoother geometry
	 *                                    default is 24. Avoid detail number above
	 *                                    150. It may crash the browser.
	 * @return {p5}                       the p5 object
	 * @example
	 * <div>
	 * <code>
	 * //draw a spining sylinder with radius 200 and height 200
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   rotateX(frameCount * 0.01);
	 *   rotateZ(frameCount * 0.01);
	 *   cylinder(200, 200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.cylinder = function(radius, height, detail){
	
	  radius = radius || 50;
	  height = height || 50;
	
	  var detailX = detail || 24;
	  var detailY = detail || 16;
	
	  var gId = 'cylinder|'+radius+'|'+height+'|'+detailX+'|'+detailY;
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createCylinder = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var x = radius * Math.sin(theta);
	      var y = 2 * height * v - height;
	      var z = radius * Math.cos(theta);
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(createCylinder, detailX, detailY);
	    var obj = geometry3d.generateObj(true);
	
	    var createTop = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var x = radius * Math.sin(-theta);
	      var y = height;
	      var z = radius * Math.cos(theta);
	      if(v === 0){
	        return new p5.Vector(0, height, 0);
	      }
	      else{
	        return new p5.Vector(x, y, z);
	      }
	    };
	
	    var geometry3d1 = new p5.Geometry3D();
	    geometry3d1.parametricGeometry(
	      createTop, detailX, 1);
	    var obj1 = geometry3d1.generateObj();
	
	    var createBottom = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var x = radius * Math.sin(theta);
	      var y = -height;
	      var z = radius * Math.cos(theta);
	      if(v === 0){
	        return new p5.Vector(0, -height, 0);
	      }else{
	        return new p5.Vector(x, y, z);
	      }
	    };
	
	    var geometry3d2 = new p5.Geometry3D();
	    geometry3d2.parametricGeometry(
	      createBottom, detailX, 1);
	    var obj2 = geometry3d2.generateObj();
	
	
	    this._renderer.initBuffer(gId, [obj, obj1, obj2]);
	  }
	
	  this._renderer.drawBuffer(gId);
	
	  return this;
	};
	
	
	/**
	 * Draw a cone with given radius and height
	 * @method cone
	 * @param  {Number} radius            radius of the bottom surface
	 * @param  {Number} height            height of the cone
	 * @param  {Number} [detail]          number of segments,
	 *                                    the more segments the smoother geometry
	 *                                    default is 24. Avoid detail number above
	 *                                    150. It may crash the browser.
	 * @example
	 * <div>
	 * <code>
	 * //draw a spining cone with radius 200 and height 200
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   rotateX(frameCount * 0.01);
	 *   rotateZ(frameCount * 0.01);
	 *   cone(200, 200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.cone = function(radius, height, detail){
	
	  radius = radius || 50;
	  height = height || 50;
	
	  var detailX = detail || 24;
	  var detailY = detail || 16;
	
	  var gId = 'cone|'+radius+'|'+height+'|'+detailX+'|'+detailY;
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createCone = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var x = radius * (1 - v) * Math.sin(theta);
	      var y = 2 * height * v - height;
	      var z = radius * (1 - v) * Math.cos(theta);
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(createCone, detailX, detailY);
	    var obj = geometry3d.generateObj(true);
	
	    var geometry3d1 = new p5.Geometry3D();
	    var createBottom = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var x = radius * (1 - v) * Math.sin(-theta);
	      var y = -height;
	      var z = radius * (1 - v) * Math.cos(theta);
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d1.parametricGeometry(
	      createBottom, detailX, 1);
	    var obj1 = geometry3d1.generateObj();
	
	    this._renderer.initBuffer(gId, [obj, obj1]);
	  }
	
	  this._renderer.drawBuffer(gId);
	
	  return this;
	};
	
	
	/**
	 * Draw a torus with given radius and tube radius
	 * @method torus
	 * @param  {Number} radius            radius of the whole ring
	 * @param  {Number} tubeRadius        radius of the tube
	 * @param  {Number} [detail]          number of segments,
	 *                                    the more segments the smoother geometry
	 *                                    default is 24. Avoid detail number above
	 *                                    150. It may crash the browser.
	 * @example
	 * <div>
	 * <code>
	 * //draw a spining torus with radius 200 and tube radius 60
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   rotateX(frameCount * 0.01);
	 *   rotateY(frameCount * 0.01);
	 *   torus(200, 60);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.torus = function(radius, tubeRadius, detail){
	
	  radius = radius || 50;
	  tubeRadius = tubeRadius || 10;
	
	  var detailX = detail || 24;
	  var detailY = detail || 16;
	
	  var gId = 'torus|'+radius+'|'+tubeRadius+'|'+detailX+'|'+detailY;
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createTorus = function(u, v){
	      var theta = 2 * Math.PI * u;
	      var phi = 2 * Math.PI * v;
	      var x = (radius + tubeRadius * Math.cos(phi)) * Math.cos(theta);
	      var y = (radius + tubeRadius * Math.cos(phi)) * Math.sin(theta);
	      var z = tubeRadius * Math.sin(phi);
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(createTorus, detailX, detailY);
	
	    var obj = geometry3d.generateObj(true);
	
	    this._renderer.initBuffer(gId, [obj]);
	  }
	
	  this._renderer.drawBuffer(gId);
	
	  return this;
	};
	
	/**
	 * Draw a box with given width, height and depth
	 * @method  box
	 * @param  {Number} width  width of the box
	 * @param  {Number} height height of the box
	 * @param  {Number} depth  depth of the box
	 * @return {p5}            the p5 object
	 * @example
	 * <div>
	 * <code>
	 * //draw a spining box with width, height and depth 200
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *   background(200);
	 *   rotateX(frameCount * 0.01);
	 *   rotateY(frameCount * 0.01);
	 *   box(200, 200, 200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.box = function(width, height, depth){
	
	  width = width || 50;
	  height = height || width;
	  depth = depth || width;
	
	  //details for box are highly optional
	  var detailX = typeof arguments[3] === Number ? arguments[3] : 1;
	  var detailY = typeof arguments[4] === Number ? arguments[4] : 1;
	
	  var gId = 'cube|'+width+'|'+height+'|'+depth+'|'+detailX+'|'+detailY;
	
	  if(!this._renderer.geometryInHash(gId)){
	
	    var geometry3d = new p5.Geometry3D();
	
	    var createPlane1 = function(u, v){
	      var x = 2 * width * u - width;
	      var y = 2 * height * v - height;
	      var z = depth;
	      return new p5.Vector(x, y, z);
	    };
	    var createPlane2 = function(u, v){
	      var x = 2 * width * ( 1 - u ) - width;
	      var y = 2 * height * v - height;
	      var z = -depth;
	      return new p5.Vector(x, y, z);
	    };
	    var createPlane3 = function(u, v){
	      var x = 2 * width * ( 1 - u ) - width;
	      var y = height;
	      var z = 2 * depth * v - depth;
	      return new p5.Vector(x, y, z);
	    };
	    var createPlane4 = function(u, v){
	      var x = 2 * width * u - width;
	      var y = -height;
	      var z = 2 * depth * v - depth;
	      return new p5.Vector(x, y, z);
	    };
	    var createPlane5 = function(u, v){
	      var x = width;
	      var y = 2 * height * u - height;
	      var z = 2 * depth * v - depth;
	      return new p5.Vector(x, y, z);
	    };
	    var createPlane6 = function(u, v){
	      var x = -width;
	      var y = 2 * height * ( 1 - u ) - height;
	      var z = 2 * depth * v - depth;
	      return new p5.Vector(x, y, z);
	    };
	
	    geometry3d.parametricGeometry(
	      createPlane1, detailX, detailY, geometry3d.vertices.length);
	    geometry3d.parametricGeometry(
	      createPlane2, detailX, detailY, geometry3d.vertices.length);
	    geometry3d.parametricGeometry(
	      createPlane3, detailX, detailY, geometry3d.vertices.length);
	    geometry3d.parametricGeometry(
	      createPlane4, detailX, detailY, geometry3d.vertices.length);
	    geometry3d.parametricGeometry(
	      createPlane5, detailX, detailY, geometry3d.vertices.length);
	    geometry3d.parametricGeometry(
	      createPlane6, detailX, detailY, geometry3d.vertices.length);
	
	    var obj = geometry3d.generateObj();
	
	    this._renderer.initBuffer(gId, [obj]);
	  }
	
	  this._renderer.drawBuffer(gId);
	
	  return this;
	
	};
	
	module.exports = p5;
	},{"../core/core":48,"./p5.Geometry3D":34}],29:[function(_dereq_,module,exports){
	/**
	 * @module Lights, Camera
	 * @submodule Camera
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Sets camera position
	 * @method camera
	 * @param  {Number} x  camera postion value on x axis
	 * @param  {Number} y  camera postion value on y axis
	 * @param  {Number} z  camera postion value on z axis
	 * @return {p5}        the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 * function draw(){
	 *  //move the camera away from the plane by a sin wave
	 *  camera(0, 0, sin(frameCount * 0.01) * 100);
	 *  plane(120, 120);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.camera = function(x, y, z){
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'camera',
	    args,
	    ['Number', 'Number', 'Number']
	  );
	  //what it manipulates is the model view matrix
	  this._renderer.translate(-x, -y, -z);
	};
	
	/**
	 * Sets perspective camera
	 * @method  perspective
	 * @param  {Number} fovy   camera frustum vertical field of view,
	 *                         from bottom to top of view, in degrees
	 * @param  {Number} aspect camera frustum aspect ratio
	 * @param  {Number} near   frustum near plane length
	 * @param  {Number} far    frustum far plane length
	 * @return {p5}            the p5 object
	 * @example
	 * <div>
	 * <code>
	 * //drag mouse to toggle the world!
	 * //you will see there's a vanish point
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 *   perspective(60 / 180 * PI, width/height, 0.1, 100);
	 * }
	 * function draw(){
	 *  background(200);
	 *  orbitControl();
	 *  for(var i = -1; i < 2; i++){
	 *     for(var j = -2; j < 3; j++){
	 *       push();
	 *       translate(i*160, 0, j*160);
	 *       box(40, 40, 40);
	 *       pop();
	 *     }
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.perspective = function(fovy,aspect,near,far) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'perspective',
	    args,
	    ['Number', 'Number', 'Number', 'Number']
	  );
	  this._renderer.uPMatrix = p5.Matrix.identity();
	  this._renderer.uPMatrix.perspective(fovy,aspect,near,far);
	  this._renderer._setCamera = true;
	};
	
	/**
	 * Setup ortho camera
	 * @method  ortho
	 * @param  {Number} left   camera frustum left plane
	 * @param  {Number} right  camera frustum right plane
	 * @param  {Number} bottom camera frustum bottom plane
	 * @param  {Number} top    camera frustum top plane
	 * @param  {Number} near   camera frustum near plane
	 * @param  {Number} far    camera frustum far plane
	 * @return {p5}            the p5 object
	 * @example
	 * <div>
	 * <code>
	 * //drag mouse to toggle the world!
	 * //there's no vanish point
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 *   ortho(-width/2, width/2, height/2, -height/2, 0.1, 100);
	 * }
	 * function draw(){
	 *  background(200);
	 *  orbitControl();
	 *  for(var i = -1; i < 2; i++){
	 *     for(var j = -2; j < 3; j++){
	 *       push();
	 *       translate(i*160, 0, j*160);
	 *       box(40, 40, 40);
	 *       pop();
	 *     }
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.ortho = function(left,right,bottom,top,near,far) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'ortho',
	    args,
	      ['Number', 'Number', 'Number', 'Number', 'Number', 'Number']
	  );
	  left /= this.width;
	  right /= this.width;
	  top /= this.height;
	  bottom /= this.height;
	  this._renderer.uPMatrix = p5.Matrix.identity();
	  this._renderer.uPMatrix.ortho(left,right,bottom,top,near,far);
	  this._renderer._setCamera = true;
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],30:[function(_dereq_,module,exports){
	//@TODO: documentation of immediate mode
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	//////////////////////////////////////////////
	// _primitives2D in 3D space
	//////////////////////////////////////////////
	
	p5.Renderer3D.prototype._primitives2D = function(arr){
	  this._setDefaultCamera();
	  var gl = this.GL;
	  var shaderProgram = this._getColorVertexShader();
	
	  //create vertice buffer
	  var vertexPositionBuffer = this.verticeBuffer;
	  gl.bindBuffer(gl.ARRAY_BUFFER, vertexPositionBuffer);
	
	  gl.bufferData(
	    gl.ARRAY_BUFFER, new Float32Array(arr), gl.STATIC_DRAW);
	  gl.vertexAttribPointer(shaderProgram.vertexPositionAttribute,
	    3, gl.FLOAT, false, 0, 0);
	
	  //create vertexcolor buffer
	  var vertexColorBuffer = this.colorBuffer;
	  gl.bindBuffer(gl.ARRAY_BUFFER, vertexColorBuffer);
	  var color = this._getCurColor();
	  var colors = [];
	  for(var i = 0; i < arr.length / 3; i++){
	    colors = colors.concat(color);
	  }
	
	  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
	  gl.vertexAttribPointer(shaderProgram.vertexColorAttribute,
	    4, gl.FLOAT, false, 0, 0);
	
	  //matrix
	  var mId = 'vertexColorVert|vertexColorFrag';
	  this.setMatrixUniforms(mId);
	};
	
	p5.Renderer3D.prototype.point = function(x, y, z){
	  var gl = this.GL;
	  this._primitives2D([x, y, z]);
	  gl.drawArrays(gl.POINTS, 0, 1);
	  return this;
	};
	
	p5.Renderer3D.prototype.line = function(x1, y1, z1, x2, y2, z2){
	  var gl = this.GL;
	  this._primitives2D([x1, y1, z1, x2, y2, z2]);
	  gl.drawArrays(gl.LINES, 0, 2);
	  return this;
	};
	
	p5.Renderer3D.prototype.triangle = function
	(x1, y1, z1, x2, y2, z2, x3, y3, z3){
	  var gl = this.GL;
	  this._primitives2D([x1, y1, z1, x2, y2, z2, x3, y3, z3]);
	  this._strokeCheck();
	  gl.drawArrays(gl.TRIANGLES, 0, 3);
	  return this;
	};
	
	//@TODO: how to define the order of 4 points
	p5.Renderer3D.prototype.quad = function
	(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4){
	  var gl = this.GL;
	  this._primitives2D(
	    [x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4]);
	  this._strokeCheck();
	  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
	  return this;
	};
	
	p5.Renderer3D.prototype.beginShape = function(mode){
	  this.shapeMode = mode;
	  this.verticeStack = [];
	  return this;
	};
	
	p5.Renderer3D.prototype.vertex = function(x, y, z){
	  this.verticeStack.push(x, y, z);
	  return this;
	};
	
	p5.Renderer3D.prototype.endShape = function(){
	  var gl = this.GL;
	  this._primitives2D(this.verticeStack);
	  this.verticeStack = [];
	
	  switch(this.shapeMode){
	    case 'POINTS':
	      gl.drawArrays(gl.POINTS, 0, 1);
	      break;
	    case 'LINES':
	      gl.drawArrays(gl.LINES, 0, 2);
	      break;
	    case 'TRIANGLES':
	      this._strokeCheck();
	      gl.drawArrays(gl.TRIANGLES, 0, 3);
	      break;
	    case 'TRIANGLE_STRIP':
	      this._strokeCheck();
	      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
	      break;
	    default:
	      this._strokeCheck();
	      gl.drawArrays(gl.TRIANGLES, 0, 3);
	      break;
	  }
	  return this;
	};
	
	//@TODO: figure out how to actually do stroke on shapes in 3D
	p5.Renderer3D.prototype._strokeCheck = function(){
	  if(this.drawMode === 'stroke'){
	    throw new Error(
	      'stroke for shapes in 3D not yet implemented, use fill for now :('
	    );
	  }
	};
	
	//@TODO
	p5.Renderer3D.prototype.strokeWeight = function() {
	  throw new Error('strokeWeight for 3d not yet implemented');
	};
	
	//////////////////////////////////////////////
	// COLOR
	//////////////////////////////////////////////
	
	p5.Renderer3D.prototype.fill = function(r, g, b, a) {
	  var color = this._pInst.color.apply(this._pInst, arguments);
	  var colorNormalized = color._array;
	  this.curColor = colorNormalized;
	  this.drawMode = 'fill';
	  return this;
	};
	
	p5.Renderer3D.prototype.stroke = function(r, g, b, a) {
	  var color = this._pInst.color.apply(this._pInst, arguments);
	  var colorNormalized = color._array;
	  this.curColor = colorNormalized;
	  this.drawMode = 'stroke';
	  return this;
	};
	
	p5.Renderer3D.prototype._getColorVertexShader = function(){
	  var gl = this.GL;
	  var mId = 'vertexColorVert|vertexColorFrag';
	  var shaderProgram;
	
	  if(!this.materialInHash(mId)){
	    shaderProgram =
	      this.initShaders('vertexColorVert', 'vertexColorFrag', true);
	    this.mHash[mId] = shaderProgram;
	    shaderProgram.vertexColorAttribute =
	    gl.getAttribLocation(shaderProgram, 'aVertexColor');
	    gl.enableVertexAttribArray(shaderProgram.vertexColorAttribute);
	  }else{
	    shaderProgram = this.mHash[mId];
	  }
	  return shaderProgram;
	};
	
	module.exports = p5.Renderer3D;
	
	},{"../core/core":48}],31:[function(_dereq_,module,exports){
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	//@TODO: implement full orbit controls including
	//pan, zoom, quaternion rotation, etc.
	p5.prototype.orbitControl = function(){
	  if(this.mouseIsPressed){
	    this.rotateY((this.mouseX - this.width / 2) / (this.width / 2));
	    this.rotateX((this.mouseY - this.height / 2) / (this.width / 2));
	  }
	  return this;
	};
	
	module.exports = p5;
	},{"../core/core":48}],32:[function(_dereq_,module,exports){
	/**
	 * @module Lights, Camera
	 * @submodule Lights
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Creates an ambient light with a color
	 * @method  ambientLight
	 * @param  {Number|Array|String|p5.Color} v1  gray value,
	 * red or hue value (depending on the current color mode),
	 * or color Array, or CSS color string
	 * @param  {Number}            [v2] optional: green or saturation value
	 * @param  {Number}            [v3] optional: blue or brightness value
	 * @param  {Number}            [a]  optional: opacity
	 * @return {p5}                the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 * function draw(){
	 *   background(0);
	 *   ambientLight(150);
	 *   ambientMaterial(250);
	 *   sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.ambientLight = function(v1, v2, v3, a){
	  var gl = this._renderer.GL;
	  var shaderProgram = this._renderer._getShader(
	    'lightVert', 'lightTextureFrag');
	
	  gl.useProgram(shaderProgram);
	  shaderProgram.uAmbientColor = gl.getUniformLocation(
	    shaderProgram,
	    'uAmbientColor[' + this._renderer.ambientLightCount + ']');
	
	  var color = this._renderer._pInst.color.apply(
	    this._renderer._pInst, arguments);
	  var colors = color._array;
	
	  gl.uniform3f( shaderProgram.uAmbientColor,
	    colors[0], colors[1], colors[2]);
	
	  //in case there's no material color for the geometry
	  shaderProgram.uMaterialColor = gl.getUniformLocation(
	    shaderProgram, 'uMaterialColor' );
	  gl.uniform4f( shaderProgram.uMaterialColor, 1, 1, 1, 1);
	
	  this._renderer.ambientLightCount ++;
	  shaderProgram.uAmbientLightCount =
	    gl.getUniformLocation(shaderProgram, 'uAmbientLightCount');
	  gl.uniform1i(shaderProgram.uAmbientLightCount,
	    this._renderer.ambientLightCount);
	
	  return this;
	};
	
	/**
	 * Creates a directional light with a color and a direction
	 * @method  directionalLight
	 * @param  {Number|Array|String|p5.Color} v1   gray value,
	 * red or hue value (depending on the current color mode),
	 * or color Array, or CSS color string
	 * @param  {Number}          [v2] optional: green or saturation value
	 * @param  {Number}          [v3] optional: blue or brightness value
	 * @param  {Number}          [a]  optional: opacity
	 * @param  {Number|p5.Vector} x   x axis direction or a p5.Vector
	 * @param  {Number}          [y]  optional: y axis direction
	 * @param  {Number}          [z]  optional: z axis direction
	 * @return {p5}              the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 * function draw(){
	 *   background(0);
	 *   //move your mouse to change light direction
	 *   var dirX = (mouseX / width - 0.5) *2;
	 *   var dirY = (mouseY / height - 0.5) *(-2);
	 *   directionalLight(250, 250, 250, dirX, dirY, 0.25);
	 *   ambientMaterial(250);
	 *   sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.directionalLight = function(v1, v2, v3, a, x, y, z) {
	  // TODO(jgessner): Find an example using this and profile it.
	  // var args = new Array(arguments.length);
	  // for (var i = 0; i < args.length; ++i) {
	  //   args[i] = arguments[i];
	  // }
	  // this._validateParameters(
	  //   'directionalLight',
	  //   args,
	  //   [
	  //     //rgbaxyz
	  //     ['Number', 'Number', 'Number', 'Number', 'Number', 'Number', 'Number'],
	  //     //rgbxyz
	  //     ['Number', 'Number', 'Number', 'Number', 'Number', 'Number'],
	  //     //caxyz
	  //     ['Number', 'Number', 'Number', 'Number', 'Number'],
	  //     //cxyz
	  //     ['Number', 'Number', 'Number', 'Number'],
	  //     ['String', 'Number', 'Number', 'Number'],
	  //     ['Array', 'Number', 'Number', 'Number'],
	  //     ['Object', 'Number', 'Number', 'Number'],
	  //     //rgbavector
	  //     ['Number', 'Number', 'Number', 'Number', 'Object'],
	  //     //rgbvector
	  //     ['Number', 'Number', 'Number', 'Object'],
	  //     //cavector
	  //     ['Number', 'Number', 'Object'],
	  //     //cvector
	  //     ['Number', 'Object'],
	  //     ['String', 'Object'],
	  //     ['Array', 'Object'],
	  //     ['Object', 'Object']
	  //   ]
	  // );
	
	  var gl = this._renderer.GL;
	  var shaderProgram = this._renderer._getShader(
	    'lightVert', 'lightTextureFrag');
	
	  gl.useProgram(shaderProgram);
	  shaderProgram.uDirectionalColor = gl.getUniformLocation(
	    shaderProgram,
	    'uDirectionalColor[' + this._renderer.directionalLightCount + ']');
	
	  //@TODO: check parameters number
	  var color = this._renderer._pInst.color.apply(
	    this._renderer._pInst, [v1, v2, v3]);
	  var colors = color._array;
	
	  gl.uniform3f( shaderProgram.uDirectionalColor,
	    colors[0], colors[1], colors[2]);
	
	  var _x, _y, _z;
	
	  if(typeof arguments[arguments.length-1] === 'number'){
	    _x = arguments[arguments.length-3];
	    _y = arguments[arguments.length-2];
	    _z = arguments[arguments.length-1];
	
	  }else{
	    try{
	      _x = arguments[arguments.length-1].x;
	      _y = arguments[arguments.length-1].y;
	      _z = arguments[arguments.length-1].z;
	    }
	    catch(error){
	      throw error;
	    }
	  }
	
	  shaderProgram.uLightingDirection = gl.getUniformLocation(
	    shaderProgram,
	    'uLightingDirection[' + this._renderer.directionalLightCount + ']');
	  gl.uniform3f( shaderProgram.uLightingDirection, _x, _y, _z);
	
	  //in case there's no material color for the geometry
	  shaderProgram.uMaterialColor = gl.getUniformLocation(
	    shaderProgram, 'uMaterialColor' );
	  gl.uniform4f( shaderProgram.uMaterialColor, 1, 1, 1, 1);
	
	  this._renderer.directionalLightCount ++;
	  shaderProgram.uDirectionalLightCount =
	    gl.getUniformLocation(shaderProgram, 'uDirectionalLightCount');
	  gl.uniform1i(shaderProgram.uDirectionalLightCount,
	    this._renderer.directionalLightCount);
	
	  return this;
	};
	
	/**
	 * Creates a point light with a color and a light position
	 * @method  pointLight
	 * @param  {Number|Array|String|p5.Color} v1   gray value,
	 * red or hue value (depending on the current color mode),
	 * or color Array, or CSS color string
	 * @param  {Number}          [v2] optional: green or saturation value
	 * @param  {Number}          [v3] optional: blue or brightness value
	 * @param  {Number}          [a]  optional: opacity
	 * @param  {Number|p5.Vector} x   x axis position or a p5.Vector
	 * @param  {Number}          [y]  optional: y axis position
	 * @param  {Number}          [z]  optional: z axis position
	 * @return {p5}              the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 * function draw(){
	 *   background(0);
	 *   //move your mouse to change light position
	 *   var locY = (mouseY / height - 0.5) *(-2);
	 *   var locX = (mouseX / width - 0.5) *2;
	 *   //to set the light position,
	 *   //think of the world's coordinate as:
	 *   // -1,1 -------- 1,1
	 *   //   |            |
	 *   //   |            |
	 *   //   |            |
	 *   // -1,-1---------1,-1
	 *   pointLight(250, 250, 250, locX, locY, 0);
	 *   ambientMaterial(250);
	 *   sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.pointLight = function(v1, v2, v3, a, x, y, z) {
	  // TODO(jgessner): Find an example using this and profile it.
	  // var args = new Array(arguments.length);
	  // for (var i = 0; i < args.length; ++i) {
	  //   args[i] = arguments[i];
	  // }
	  // this._validateParameters(
	  //   'pointLight',
	  //   arguments,
	  //   [
	  //     //rgbaxyz
	  //     ['Number', 'Number', 'Number', 'Number', 'Number', 'Number', 'Number'],
	  //     //rgbxyz
	  //     ['Number', 'Number', 'Number', 'Number', 'Number', 'Number'],
	  //     //caxyz
	  //     ['Number', 'Number', 'Number', 'Number', 'Number'],
	  //     //cxyz
	  //     ['Number', 'Number', 'Number', 'Number'],
	  //     ['String', 'Number', 'Number', 'Number'],
	  //     ['Array', 'Number', 'Number', 'Number'],
	  //     ['Object', 'Number', 'Number', 'Number'],
	  //     //rgbavector
	  //     ['Number', 'Number', 'Number', 'Number', 'Object'],
	  //     //rgbvector
	  //     ['Number', 'Number', 'Number', 'Object'],
	  //     //cavector
	  //     ['Number', 'Number', 'Object'],
	  //     //cvector
	  //     ['Number', 'Object'],
	  //     ['String', 'Object'],
	  //     ['Array', 'Object'],
	  //     ['Object', 'Object']
	  //   ]
	  // );
	
	  var gl = this._renderer.GL;
	  var shaderProgram = this._renderer._getShader(
	    'lightVert', 'lightTextureFrag');
	
	  gl.useProgram(shaderProgram);
	  shaderProgram.uPointLightColor = gl.getUniformLocation(
	    shaderProgram,
	    'uPointLightColor[' + this._renderer.pointLightCount + ']');
	
	  //@TODO: check parameters number
	  var color = this._renderer._pInst.color.apply(
	    this._renderer._pInst, [v1, v2, v3]);
	  var colors = color._array;
	
	  gl.uniform3f( shaderProgram.uPointLightColor,
	    colors[0], colors[1], colors[2]);
	
	  var _x, _y, _z;
	
	  if(typeof arguments[arguments.length-1] === 'number'){
	    _x = arguments[arguments.length-3];
	    _y = arguments[arguments.length-2];
	    _z = arguments[arguments.length-1];
	
	  }else{
	    try{
	      _x = arguments[arguments.length-1].x;
	      _y = arguments[arguments.length-1].y;
	      _z = arguments[arguments.length-1].z;
	    }
	    catch(error){
	      throw error;
	    }
	  }
	
	  shaderProgram.uPointLightLocation = gl.getUniformLocation(
	    shaderProgram,
	    'uPointLightLocation[' + this._renderer.pointLightCount + ']');
	  gl.uniform3f( shaderProgram.uPointLightLocation, _x, _y, _z);
	
	  //in case there's no material color for the geometry
	  shaderProgram.uMaterialColor = gl.getUniformLocation(
	    shaderProgram, 'uMaterialColor' );
	  gl.uniform4f( shaderProgram.uMaterialColor, 1, 1, 1, 1);
	
	  this._renderer.pointLightCount ++;
	  shaderProgram.uPointLightCount =
	    gl.getUniformLocation(shaderProgram, 'uPointLightCount');
	  gl.uniform1i(shaderProgram.uPointLightCount,
	    this._renderer.pointLightCount);
	
	  return this;
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],33:[function(_dereq_,module,exports){
	/**
	 * @module Lights, Camera
	 * @submodule Material
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	//require('./p5.Texture');
	
	/**
	 * Normal material for geometry
	 * @method normalMaterial
	 * @return {p5}                the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *  background(0);
	 *  normalMaterial();
	 *  sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.normalMaterial = function(){
	  this._renderer._getShader('normalVert', 'normalFrag');
	  return this;
	};
	
	/**
	 * Texture for geometry
	 * @method texture
	 * @return {p5}                the p5 object
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 *   img = loadImage("assets/laDefense.jpg");
	 * }
	 *
	 * function draw(){
	 *   background(0);
	 *   rotateZ(frameCount * 0.01);
	 *   rotateX(frameCount * 0.01);
	 *   rotateY(frameCount * 0.01);
	 *   //pass image as texture
	 *   texture(img);
	 *   box(200, 200, 200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.texture = function(image){
	  var gl = this._renderer.GL;
	  var shaderProgram = this._renderer._getShader('lightVert',
	    'lightTextureFrag');
	  gl.useProgram(shaderProgram);
	  if (image instanceof p5.Image) {
	    //check if image is already used as texture
	    if(!image.isTexture){
	      //createTexture and set isTexture to true
	      var tex = gl.createTexture();
	      image.createTexture(tex);
	      gl.bindTexture(gl.TEXTURE_2D, tex);
	      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
	      image._setProperty('isTexture', true);
	    }
	    //otherwise we're good to bind texture without creating
	    //a new one on the gl
	    else {
	      //TODO
	    }
	    image.loadPixels();
	    var data = new Uint8Array(image.pixels);
	    gl.texImage2D(gl.TEXTURE_2D, 0,
	      gl.RGBA, image.width, image.height,
	      0, gl.RGBA, gl.UNSIGNED_BYTE, data);
	  }
	  //if param is a video
	  else if (image instanceof p5.MediaElement){
	    if(!image.loadedmetadata) {return;}
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA,
	    gl.UNSIGNED_BYTE, image.elt);
	  }
	  else {
	    //@TODO handle following cases:
	    //- 2D canvas (p5 inst)
	  }
	  if (_isPowerOf2(image.width) && _isPowerOf2(image.height)) {
	    gl.generateMipmap(gl.TEXTURE_2D);
	  } else {
	    //@TODO this is problematic
	    //image.width = _nextHighestPOT(image.width);
	    //image.height = _nextHighestPOT(image.height);
	    gl.texParameteri(gl.TEXTURE_2D,
	    gl.TEXTURE_MAG_FILTER, gl.LINEAR);
	    gl.texParameteri(gl.TEXTURE_2D,
	    gl.TEXTURE_MIN_FILTER, gl.LINEAR);
	    gl.texParameteri(gl.TEXTURE_2D,
	    gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D,
	    gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	  }
	  //this is where we'd activate multi textures
	  //eg. gl.activeTexture(gl.TEXTURE0 + (unit || 0));
	  //but for now we just have a single texture.
	  //@TODO need to extend this functionality
	  //gl.activeTexture(gl.TEXTURE0 + 0);
	  //gl.bindTexture(gl.TEXTURE_2D, tex);
	  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'uSampler'), 0);
	  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'isTexture'), true);
	  return this;
	};
	
	/**
	 * Helper functions; Checks whether val is a pot
	 * more info on power of 2 here:
	 * https://www.opengl.org/wiki/NPOT_Texture
	 * @param  {Number}  value
	 * @return {Boolean}
	 */
	function _isPowerOf2 (value){
	  return (value & (value - 1)) === 0;
	}
	
	/**
	 * returns the next highest power of 2 value
	 * @param  {Number} value [description]
	 * @return {Number}       [description]
	 */
	// function _nextHighestPOT (value){
	//   --value;
	//   for (var i = 1; i < 32; i <<= 1) {
	//     value = value | value >> i;
	//   }
	//   return value + 1;
	// }
	
	/**
	 * Basic material for geometry with a given color
	 * @method  basicMaterial
	 * @param  {Number|Array|String|p5.Color} v1  gray value,
	 * red or hue value (depending on the current color mode),
	 * or color Array, or CSS color string
	 * @param  {Number}            [v2] optional: green or saturation value
	 * @param  {Number}            [v3] optional: blue or brightness value
	 * @param  {Number}            [a]  optional: opacity
	 * @return {p5}                the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 *
	 * function draw(){
	 *  background(0);
	 *  basicMaterial(250, 0, 0);
	 *  rotateX(frameCount * 0.01);
	 *  rotateY(frameCount * 0.01);
	 *  rotateZ(frameCount * 0.01);
	 *  box(200, 200, 200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.basicMaterial = function(v1, v2, v3, a){
	  var gl = this._renderer.GL;
	
	  var shaderProgram = this._renderer._getShader('normalVert', 'basicFrag');
	
	  gl.useProgram(shaderProgram);
	  shaderProgram.uMaterialColor = gl.getUniformLocation(
	    shaderProgram, 'uMaterialColor' );
	
	  var color = this._renderer._pInst.color.apply(
	    this._renderer._pInst, arguments);
	  var colors = color._array;
	
	  gl.uniform4f( shaderProgram.uMaterialColor,
	    colors[0], colors[1], colors[2], colors[3]);
	
	  return this;
	
	};
	
	/**
	 * Ambient material for geometry with a given color
	 * @method  ambientMaterial
	 * @param  {Number|Array|String|p5.Color} v1  gray value,
	 * red or hue value (depending on the current color mode),
	 * or color Array, or CSS color string
	 * @param  {Number}            [v2] optional: green or saturation value
	 * @param  {Number}            [v3] optional: blue or brightness value
	 * @param  {Number}            [a]  optional: opacity
	* @return {p5}                 the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 * function draw(){
	 *  background(0);
	 *  ambientLight(100);
	 *  pointLight(250, 250, 250, 100, 100, 0);
	 *  ambientMaterial(250);
	 *  sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.ambientMaterial = function(v1, v2, v3, a) {
	  var gl = this._renderer.GL;
	  var shaderProgram =
	    this._renderer._getShader('lightVert', 'lightTextureFrag');
	
	  gl.useProgram(shaderProgram);
	  shaderProgram.uMaterialColor = gl.getUniformLocation(
	    shaderProgram, 'uMaterialColor' );
	
	  var color = this._renderer._pInst.color.apply(
	    this._renderer._pInst, arguments);
	  var colors = color._array;
	
	  gl.uniform4f(shaderProgram.uMaterialColor,
	    colors[0], colors[1], colors[2], colors[3]);
	
	  shaderProgram.uSpecular = gl.getUniformLocation(
	    shaderProgram, 'uSpecular' );
	  gl.uniform1i(shaderProgram.uSpecular, false);
	
	  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'isTexture'), false);
	
	  return this;
	};
	
	/**
	 * Specular material for geometry with a given color
	 * @method specularMaterial
	 * @param  {Number|Array|String|p5.Color} v1  gray value,
	 * red or hue value (depending on the current color mode),
	 * or color Array, or CSS color string
	 * @param  {Number}            [v2] optional: green or saturation value
	 * @param  {Number}            [v3] optional: blue or brightness value
	 * @param  {Number}            [a]  optional: opacity
	 * @return {p5}                the p5 object
	 * @example
	 * <div>
	 * <code>
	 * function setup(){
	 *   createCanvas(100, 100, WEBGL);
	 * }
	 * function draw(){
	 *  background(0);
	 *  ambientLight(100);
	 *  pointLight(250, 250, 250, 100, 100, 0);
	 *  specularMaterial(250);
	 *  sphere(200);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.specularMaterial = function(v1, v2, v3, a) {
	  var gl = this._renderer.GL;
	  var shaderProgram =
	    this._renderer._getShader('lightVert', 'lightTextureFrag');
	  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'isTexture'), false);
	  gl.useProgram(shaderProgram);
	  shaderProgram.uMaterialColor = gl.getUniformLocation(
	    shaderProgram, 'uMaterialColor' );
	
	  var color = this._renderer._pInst.color.apply(
	    this._renderer._pInst, arguments);
	  var colors = color._array;
	
	  gl.uniform4f(shaderProgram.uMaterialColor,
	    colors[0], colors[1], colors[2], colors[3]);
	
	  shaderProgram.uSpecular = gl.getUniformLocation(
	    shaderProgram, 'uSpecular' );
	  gl.uniform1i(shaderProgram.uSpecular, true);
	
	  return this;
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],34:[function(_dereq_,module,exports){
	//some of the functions are adjusted from Three.js(http://threejs.org)
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * p5 Geometry3D class
	 */
	p5.Geometry3D = function(){
	  //an array holding every vertice
	  //each vertex is a p5.Vector
	  this.vertices = [];
	  //an array holding each normals for each vertice
	  //each normal is a p5.Vector
	  this.vertexNormals = [];
	  //an array holding each three indecies of vertices that form a face
	  //[[0, 1, 2], [1, 2, 3], ...]
	  this.faces = [];
	  //an array holding every noraml for each face
	  //each faceNormal is a p5.Vector
	  //[[p5.Vector, p5.Vector, p5.Vector],[p5.Vector, p5.Vector, p5.Vector],...]
	  this.faceNormals = [];
	  //an array of array holding uvs (group according to faces)
	  //[[[0, 0], [1, 0], [1, 0]],...]
	  this.uvs = [];
	};
	
	/**
	 * generate geometriy with parametric method
	 * @param  {Function} func  callback function for how to generate geometry
	 * @param  {Number} detailX number of vertices on horizontal surface
	 * @param  {Number} detailY number of vertices on horizontal surface
	 * @param  {Number} offset  offset of vertices index
	 */
	p5.Geometry3D.prototype.parametricGeometry = function
	//@TODO: put func as the last parameters
	(func, detailX, detailY, offset){
	
	  var i, j, p;
	  var u, v;
	  offset = offset || 0;
	  this.detailX = detailX;
	  this.detailY = detailY;
	
	  var sliceCount = detailX + 1;
	  for (i = 0; i <= detailY; i++){
	    v = i / detailY;
	    for (j = 0; j <= detailX; j++){
	      u = j / detailX;
	      p = func(u, v);
	      this.vertices.push(p);
	    }
	  }
	
	  var a, b, c, d;
	  var uva, uvb, uvc, uvd;
	
	  for (i = 0; i < detailY; i++){
	    for (j = 0; j < detailX; j++){
	      a = i * sliceCount + j + offset;
	      b = i * sliceCount + j + 1 + offset;
	      c = (i + 1)* sliceCount + j + 1 + offset;
	      d = (i + 1)* sliceCount + j + offset;
	
	      uva = [j/detailX, i/detailY];
	      uvb = [(j + 1)/ detailX, i/detailY];
	      uvc = [(j + 1)/ detailX, (i + 1)/detailY];
	      uvd = [j/detailX, (i + 1)/detailY];
	
	      this.faces.push([a, b, d]);
	      this.uvs.push([uva, uvb, uvd]);
	
	      this.faces.push([b, c, d]);
	      this.uvs.push([uvb, uvc, uvd]);
	    }
	  }
	};
	
	/**
	 * compute faceNormals for a geometry
	 */
	p5.Geometry3D.prototype.computeFaceNormals = function(){
	
	  var cb = new p5.Vector();
	  var ab = new p5.Vector();
	
	  for (var f = 0; f < this.faces.length; f++){
	    var face = this.faces[f];
	    var vA = this.vertices[face[0]];
	    var vB = this.vertices[face[1]];
	    var vC = this.vertices[face[2]];
	
	    p5.Vector.sub(vC, vB, cb);
	    p5.Vector.sub(vA, vB, ab);
	
	    var normal = p5.Vector.cross(ab, cb);
	    normal.normalize();
	    normal.mult(-1);
	    this.faceNormals[f] = normal;
	  }
	
	};
	
	/**
	 * compute vertexNormals for a geometry
	 */
	p5.Geometry3D.prototype.computeVertexNormals = function (){
	
	  var v, f, face, faceNormal, vertices;
	  var vertexNormals = [];
	
	  vertices = new Array(this.vertices.length);
	  for (v = 0; v < this.vertices.length; v++) {
	    vertices[v] = new p5.Vector();
	  }
	
	  for (f = 0; f < this.faces.length; f++) {
	    face = this.faces[f];
	    faceNormal = this.faceNormals[f];
	
	    vertices[face[0]].add(faceNormal);
	    vertices[face[1]].add(faceNormal);
	    vertices[face[2]].add(faceNormal);
	  }
	
	  for (v = 0; v < this.vertices.length; v++) {
	    vertices[v].normalize();
	  }
	
	  for (f = 0; f < this.faces.length; f++) {
	    face = this.faces[f];
	    vertexNormals[f] = [];
	    vertexNormals[f][0]= vertices[face[0]].copy();
	    vertexNormals[f][1]= vertices[face[1]].copy();
	    vertexNormals[f][2]= vertices[face[2]].copy();
	  }
	
	  for (f = 0; f < this.faces.length; f++){
	    face = this.faces[f];
	    faceNormal = this.faceNormals[f];
	    this.vertexNormals[face[0]] = vertexNormals[f][0];
	    this.vertexNormals[face[1]] = vertexNormals[f][1];
	    this.vertexNormals[face[2]] = vertexNormals[f][2];
	  }
	
	};
	
	p5.Geometry3D.prototype.averageNormals = function() {
	
	  for(var i = 0; i <= this.detailY; i++){
	    var offset = this.detailX + 1;
	    var temp = p5.Vector
	      .add(this.vertexNormals[i*offset],
	        this.vertexNormals[i*offset + this.detailX]);
	    temp = p5.Vector.div(temp, 2);
	    this.vertexNormals[i*offset] = temp;
	    this.vertexNormals[i*offset + this.detailX] = temp;
	  }
	};
	
	p5.Geometry3D.prototype.averagePoleNormals = function() {
	
	  //average the north pole
	  var sum = new p5.Vector(0, 0, 0);
	  for(var i = 0; i < this.detailX; i++){
	    sum.add(this.vertexNormals[i]);
	  }
	  sum = p5.Vector.div(sum, this.detailX);
	
	  for(i = 0; i < this.detailX; i++){
	    this.vertexNormals[i] = sum;
	  }
	
	  //average the south pole
	  sum = new p5.Vector(0, 0, 0);
	  for(i = this.vertices.length - 1;
	    i > this.vertices.length - 1 - this.detailX; i--){
	    sum.add(this.vertexNormals[i]);
	  }
	  sum = p5.Vector.div(sum, this.detailX);
	
	  for(i = this.vertices.length - 1;
	    i > this.vertices.length - 1 - this.detailX; i--){
	    this.vertexNormals[i] = sum;
	  }
	};
	
	/**
	 * [generateUV description]
	 * @param  {Array} faces [description]
	 * @param  {Array} uvs   [description]
	 */
	p5.Geometry3D.prototype.generateUV = function(faces, uvs){
	
	  faces = flatten(faces);
	  uvs = flatten(uvs);
	  var arr = [];
	  faces.forEach(function(item, index){
	    arr[item] = uvs[index];
	  });
	  return flatten(arr);
	};
	
	
	/**
	 * generate an object containing information needed to create buffer
	 */
	p5.Geometry3D.prototype.generateObj = function(average, sphere){
	
	  this.computeFaceNormals();
	  this.computeVertexNormals();
	
	  if(average){
	    this.averageNormals();
	  }
	
	  if(sphere){
	    this.averagePoleNormals();
	  }
	
	  var obj = {
	    vertices: turnVectorArrayIntoNumberArray(this.vertices),
	    vertexNormals: turnVectorArrayIntoNumberArray(this.vertexNormals),
	    uvs: this.generateUV(this.faces, this.uvs),
	    faces: flatten(this.faces),
	    len: this.faces.length * 3
	  };
	  return obj;
	};
	
	/**
	 * turn a two dimensional array into one dimensional array
	 * @param  {Array} arr 2-dimensional array
	 * @return {Array}     1-dimensional array
	 * [[1, 2, 3],[4, 5, 6]] -> [1, 2, 3, 4, 5, 6]
	 */
	function flatten(arr){
	  return arr.reduce(function(a, b){
	    return a.concat(b);
	  });
	}
	
	/**
	 * turn an array of Vector into a one dimensional array of numbers
	 * @param  {Array} arr  an array of p5.Vector
	 * @return {Array]}     a one dimensional array of numbers
	 * [p5.Vector(1, 2, 3), p5.Vector(4, 5, 6)] ->
	 * [1, 2, 3, 4, 5, 6]
	 */
	function turnVectorArrayIntoNumberArray(arr){
	  return flatten(arr.map(function(item){
	    return [item.x, item.y, item.z];
	  }));
	}
	
	module.exports = p5.Geometry3D;
	},{"../core/core":48}],35:[function(_dereq_,module,exports){
	/**
	* @requires constants
	* @todo see methods below needing further implementation.
	* future consideration: implement SIMD optimizations
	* when browser compatibility becomes available
	* https://developer.mozilla.org/en-US/docs/Web/JavaScript/
	*   Reference/Global_Objects/SIMD
	*/
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var polarGeometry = _dereq_('../math/polargeometry');
	var constants = _dereq_('../core/constants');
	var GLMAT_ARRAY_TYPE = (
	    typeof Float32Array !== 'undefined') ?
	  Float32Array : Array;
	
	/**
	 * A class to describe a 4x4 matrix
	 * for model and view matrix manipulation in the p5js webgl renderer.
	 * class p5.Matrix
	 * @constructor
	 * @param {Array} [mat4] array literal of our 4x4 matrix
	 */
	p5.Matrix = function() {
	  // This is how it comes in with createMatrix()
	  if(arguments[0] instanceof p5) {
	    // save reference to p5 if passed in
	    this.p5 = arguments[0];
	    this.mat4  = arguments[1] || new GLMAT_ARRAY_TYPE([
	      1, 0, 0, 0,
	      0, 1, 0, 0,
	      0, 0, 1, 0,
	      0, 0, 0, 1
	    ]);
	  // This is what we'll get with new p5.Matrix()
	  // a mat4 identity matrix
	  } else {
	    this.mat4 = arguments[0] || new GLMAT_ARRAY_TYPE([
	      1, 0, 0, 0,
	      0, 1, 0, 0,
	      0, 0, 1, 0,
	      0, 0, 0, 1
	    ]);
	  }
	  return this;
	};
	
	/**
	 * Sets the x, y, and z component of the vector using two or three separate
	 * variables, the data from a p5.Matrix, or the values from a float array.
	 *
	 * @param {p5.Matrix|Array} [inMatrix] the input p5.Matrix or
	 *                                     an Array of length 16
	 */
	p5.Matrix.prototype.set = function (inMatrix) {
	  if (inMatrix instanceof p5.Matrix) {
	    this.mat4 = inMatrix.mat4;
	    return this;
	  }
	  else if (inMatrix instanceof GLMAT_ARRAY_TYPE) {
	    this.mat4 = inMatrix;
	    return this;
	  }
	  return this;
	};
	
	/**
	 * Gets a copy of the vector, returns a p5.Matrix object.
	 *
	 * @return {p5.Matrix} the copy of the p5.Matrix object
	 */
	p5.Matrix.prototype.get = function () {
	  return new p5.Matrix(this.mat4);
	};
	
	/**
	 * return a copy of a matrix
	 * @return {p5.Matrix}   the result matrix
	 */
	p5.Matrix.prototype.copy = function(){
	  var copied = new p5.Matrix();
	  copied.mat4[0] = this.mat4[0];
	  copied.mat4[1] = this.mat4[1];
	  copied.mat4[2] = this.mat4[2];
	  copied.mat4[3] = this.mat4[3];
	  copied.mat4[4] = this.mat4[4];
	  copied.mat4[5] = this.mat4[5];
	  copied.mat4[6] = this.mat4[6];
	  copied.mat4[7] = this.mat4[7];
	  copied.mat4[8] = this.mat4[8];
	  copied.mat4[9] = this.mat4[9];
	  copied.mat4[10] = this.mat4[10];
	  copied.mat4[11] = this.mat4[11];
	  copied.mat4[12] = this.mat4[12];
	  copied.mat4[13] = this.mat4[13];
	  copied.mat4[14] = this.mat4[14];
	  copied.mat4[15] = this.mat4[15];
	  return copied;
	};
	
	/**
	 * return an identity matrix
	 * @return {p5.Matrix}   the result matrix
	 */
	p5.Matrix.identity = function(){
	  return new p5.Matrix();
	};
	
	/**
	 * transpose according to a given matrix
	 * @param  {p5.Matrix | Typed Array} a  the matrix to be based on to transpose
	 * @return {p5.Matrix}                  this
	 */
	p5.Matrix.prototype.transpose = function(a){
	  var a01, a02, a03, a12, a13, a23;
	  if(a instanceof p5.Matrix){
	    a01 = a.mat4[1];
	    a02 = a.mat4[2];
	    a03 = a.mat4[3];
	    a12 = a.mat4[6];
	    a13 = a.mat4[7];
	    a23 = a.mat4[11];
	
	    this.mat4[0] = a.mat4[0];
	    this.mat4[1] = a.mat4[4];
	    this.mat4[2] = a.mat4[8];
	    this.mat4[3] = a.mat4[12];
	    this.mat4[4] = a01;
	    this.mat4[5] = a.mat4[5];
	    this.mat4[6] = a.mat4[9];
	    this.mat4[7] = a.mat4[13];
	    this.mat4[8] = a02;
	    this.mat4[9] = a12;
	    this.mat4[10] = a.mat4[10];
	    this.mat4[11] = a.mat4[14];
	    this.mat4[12] = a03;
	    this.mat4[13] = a13;
	    this.mat4[14] = a23;
	    this.mat4[15] = a.mat4[15];
	
	  }else if(a instanceof GLMAT_ARRAY_TYPE){
	    a01 = a[1];
	    a02 = a[2];
	    a03 = a[3];
	    a12 = a[6];
	    a13 = a[7];
	    a23 = a[11];
	
	    this.mat4[0] = a[0];
	    this.mat4[1] = a[4];
	    this.mat4[2] = a[8];
	    this.mat4[3] = a[12];
	    this.mat4[4] = a01;
	    this.mat4[5] = a[5];
	    this.mat4[6] = a[9];
	    this.mat4[7] = a[13];
	    this.mat4[8] = a02;
	    this.mat4[9] = a12;
	    this.mat4[10] = a[10];
	    this.mat4[11] = a[14];
	    this.mat4[12] = a03;
	    this.mat4[13] = a13;
	    this.mat4[14] = a23;
	    this.mat4[15] = a[15];
	  }
	  return this;
	};
	
	/**
	 * invert  matrix according to a give matrix
	 * @param  {p5.Matrix or Typed Array} a   the matrix to be based on to invert
	 * @return {p5.Matrix}                    this
	 */
	p5.Matrix.prototype.invert = function(a){
	  var a00, a01, a02, a03, a10, a11, a12, a13,
	  a20, a21, a22, a23, a30, a31, a32, a33;
	  if(a instanceof p5.Matrix){
	    a00 = a.mat4[0];
	    a01 = a.mat4[1];
	    a02 = a.mat4[2];
	    a03 = a.mat4[3];
	    a10 = a.mat4[4];
	    a11 = a.mat4[5];
	    a12 = a.mat4[6];
	    a13 = a.mat4[7];
	    a20 = a.mat4[8];
	    a21 = a.mat4[9];
	    a22 = a.mat4[10];
	    a23 = a.mat4[11];
	    a30 = a.mat4[12];
	    a31 = a.mat4[13];
	    a32 = a.mat4[14];
	    a33 = a.mat4[15];
	  }else if(a instanceof GLMAT_ARRAY_TYPE){
	    a00 = a[0];
	    a01 = a[1];
	    a02 = a[2];
	    a03 = a[3];
	    a10 = a[4];
	    a11 = a[5];
	    a12 = a[6];
	    a13 = a[7];
	    a20 = a[8];
	    a21 = a[9];
	    a22 = a[10];
	    a23 = a[11];
	    a30 = a[12];
	    a31 = a[13];
	    a32 = a[14];
	    a33 = a[15];
	  }
	  var b00 = a00 * a11 - a01 * a10,
	  b01 = a00 * a12 - a02 * a10,
	  b02 = a00 * a13 - a03 * a10,
	  b03 = a01 * a12 - a02 * a11,
	  b04 = a01 * a13 - a03 * a11,
	  b05 = a02 * a13 - a03 * a12,
	  b06 = a20 * a31 - a21 * a30,
	  b07 = a20 * a32 - a22 * a30,
	  b08 = a20 * a33 - a23 * a30,
	  b09 = a21 * a32 - a22 * a31,
	  b10 = a21 * a33 - a23 * a31,
	  b11 = a22 * a33 - a23 * a32,
	
	  // Calculate the determinant
	  det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 -
	  b04 * b07 + b05 * b06;
	
	  if (!det) {
	    return null;
	  }
	  det = 1.0 / det;
	
	  this.mat4[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	  this.mat4[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	  this.mat4[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	  this.mat4[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	  this.mat4[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	  this.mat4[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	  this.mat4[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	  this.mat4[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	  this.mat4[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	  this.mat4[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	  this.mat4[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	  this.mat4[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	  this.mat4[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	  this.mat4[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	  this.mat4[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	  this.mat4[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	
	  return this;
	};
	
	/**
	 * inspired by Toji's mat4 determinant
	 * @return {Number} Determinant of our 4x4 matrix
	 */
	p5.Matrix.prototype.determinant = function(){
	  var d00 = (this.mat4[0] * this.mat4[5]) - (this.mat4[1] * this.mat4[4]),
	    d01 = (this.mat4[0] * this.mat4[6]) - (this.mat4[2] * this.mat4[4]),
	    d02 = (this.mat4[0] * this.mat4[7]) - (this.mat4[3] * this.mat4[4]),
	    d03 = (this.mat4[1] * this.mat4[6]) - (this.mat4[2] * this.mat4[5]),
	    d04 = (this.mat4[1] * this.mat4[7]) - (this.mat4[3] * this.mat4[5]),
	    d05 = (this.mat4[2] * this.mat4[7]) - (this.mat4[3] * this.mat4[6]),
	    d06 = (this.mat4[8] * this.mat4[13]) - (this.mat4[9] * this.mat4[12]),
	    d07 = (this.mat4[8] * this.mat4[14]) - (this.mat4[10] * this.mat4[12]),
	    d08 = (this.mat4[8] * this.mat4[15]) - (this.mat4[11] * this.mat4[12]),
	    d09 = (this.mat4[9] * this.mat4[14]) - (this.mat4[10] * this.mat4[13]),
	    d10 = (this.mat4[9] * this.mat4[15]) - (this.mat4[11] * this.mat4[13]),
	    d11 = (this.mat4[10] * this.mat4[15]) - (this.mat4[11] * this.mat4[14]);
	
	  // Calculate the determinant
	  return d00 * d11 - d01 * d10 + d02 * d09 +
	    d03 * d08 - d04 * d07 + d05 * d06;
	};
	
	/**
	 * multiply two mat4s
	 * @param {p5.Matrix | Array}  multMatrix The matrix we want to multiply by
	 * @return {p5.Matrix}         this
	 */
	p5.Matrix.prototype.mult = function(multMatrix){
	  var _dest = new GLMAT_ARRAY_TYPE(16);
	  var _src = new GLMAT_ARRAY_TYPE(16);
	
	  if(multMatrix instanceof p5.Matrix) {
	    _src = multMatrix.mat4;
	  }
	  else if(multMatrix instanceof GLMAT_ARRAY_TYPE){
	    _src = multMatrix;
	  }
	
	  // each row is used for the multiplier
	  var b0  = this.mat4[0], b1 = this.mat4[1],
	    b2 = this.mat4[2], b3 = this.mat4[3];
	  _dest[0] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
	  _dest[1] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
	  _dest[2] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
	  _dest[3] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];
	
	  b0 = this.mat4[4];
	  b1 = this.mat4[5];
	  b2 = this.mat4[6];
	  b3 = this.mat4[7];
	  _dest[4] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
	  _dest[5] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
	  _dest[6] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
	  _dest[7] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];
	
	  b0 = this.mat4[8];
	  b1 = this.mat4[9];
	  b2 = this.mat4[10];
	  b3 = this.mat4[11];
	  _dest[8] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
	  _dest[9] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
	  _dest[10] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
	  _dest[11] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];
	
	  b0 = this.mat4[12];
	  b1 = this.mat4[13];
	  b2 = this.mat4[14];
	  b3 = this.mat4[15];
	  _dest[12] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
	  _dest[13] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
	  _dest[14] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
	  _dest[15] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];
	
	  this.mat4 = _dest;
	
	  return this;
	};
	
	/**
	 * scales a p5.Matrix by scalars or a vector
	 * @param  {p5.Vector | Array }
	 *                      vector to scale by
	 * @return {p5.Matrix}  this
	 */
	p5.Matrix.prototype.scale = function() {
	  var x,y,z;
	  var args = new Array(arguments.length);
	  for(var i = 0; i < args.length; i++) {
	    args[i] = arguments[i];
	  }
	  //if our 1st arg is a type p5.Vector
	  if (args[0] instanceof p5.Vector){
	    x = args[0].x;
	    y = args[0].y;
	    z = args[0].z;
	  }
	  //otherwise if it's an array
	  else if (args[0] instanceof Array){
	    x = args[0][0];
	    y = args[0][1];
	    z = args[0][2];
	  }
	  var _dest = new GLMAT_ARRAY_TYPE(16);
	  _dest[0] = this.mat4[0] * x;
	  _dest[1] = this.mat4[1] * x;
	  _dest[2] = this.mat4[2] * x;
	  _dest[3] = this.mat4[3] * x;
	  _dest[4] = this.mat4[4] * y;
	  _dest[5] = this.mat4[5] * y;
	  _dest[6] = this.mat4[6] * y;
	  _dest[7] = this.mat4[7] * y;
	  _dest[8] = this.mat4[8] * z;
	  _dest[9] = this.mat4[9] * z;
	  _dest[10] = this.mat4[10] * z;
	  _dest[11] = this.mat4[11] * z;
	  _dest[12] = this.mat4[12];
	  _dest[13] = this.mat4[13];
	  _dest[14] = this.mat4[14];
	  _dest[15] = this.mat4[15];
	
	  this.mat4 = _dest;
	  return this;
	};
	
	/**
	 * rotate our Matrix around an axis by the given angle.
	 * @param  {Number} a The angle of rotation in radians
	 * @param  {p5.Vector | Array} axis  the axis(es) to rotate around
	 * @return {p5.Matrix}                    this
	 * inspired by Toji's gl-matrix lib, mat4 rotation
	 */
	p5.Matrix.prototype.rotate = function(a, axis){
	  var x, y, z, _a, len;
	
	  if (this.p5) {
	    if (this.p5._angleMode === constants.DEGREES) {
	      _a = polarGeometry.degreesToRadians(a);
	    }
	  }
	  else {
	    _a = a;
	  }
	  if (axis instanceof p5.Vector) {
	    x = axis.x;
	    y = axis.y;
	    z = axis.z;
	  }
	  else if (axis instanceof Array) {
	    x = axis[0];
	    y = axis[1];
	    z = axis[2];
	  }
	
	  len = Math.sqrt(x * x + y * y + z * z);
	  x *= (1/len);
	  y *= (1/len);
	  z *= (1/len);
	
	  var a00 = this.mat4[0];
	  var a01 = this.mat4[1];
	  var a02 = this.mat4[2];
	  var a03 = this.mat4[3];
	  var a10 = this.mat4[4];
	  var a11 = this.mat4[5];
	  var a12 = this.mat4[6];
	  var a13 = this.mat4[7];
	  var a20 = this.mat4[8];
	  var a21 = this.mat4[9];
	  var a22 = this.mat4[10];
	  var a23 = this.mat4[11];
	
	  //sin,cos, and tan of respective angle
	  var sA = Math.sin(_a);
	  var cA = Math.cos(_a);
	  var tA = 1 - cA;
	  // Construct the elements of the rotation matrix
	  var b00 = x * x * tA + cA;
	  var b01 = y * x * tA + z * sA;
	  var b02 = z * x * tA - y * sA;
	  var b10 = x * y * tA - z * sA;
	  var b11 = y * y * tA + cA;
	  var b12 = z * y * tA + x * sA;
	  var b20 = x * z * tA + y * sA;
	  var b21 = y * z * tA - x * sA;
	  var b22 = z * z * tA + cA;
	
	  // rotation-specific matrix multiplication
	  this.mat4[0] = a00 * b00 + a10 * b01 + a20 * b02;
	  this.mat4[1] = a01 * b00 + a11 * b01 + a21 * b02;
	  this.mat4[2] = a02 * b00 + a12 * b01 + a22 * b02;
	  this.mat4[3] = a03 * b00 + a13 * b01 + a23 * b02;
	  this.mat4[4] = a00 * b10 + a10 * b11 + a20 * b12;
	  this.mat4[5] = a01 * b10 + a11 * b11 + a21 * b12;
	  this.mat4[6] = a02 * b10 + a12 * b11 + a22 * b12;
	  this.mat4[7] = a03 * b10 + a13 * b11 + a23 * b12;
	  this.mat4[8] = a00 * b20 + a10 * b21 + a20 * b22;
	  this.mat4[9] = a01 * b20 + a11 * b21 + a21 * b22;
	  this.mat4[10] = a02 * b20 + a12 * b21 + a22 * b22;
	  this.mat4[11] = a03 * b20 + a13 * b21 + a23 * b22;
	
	  return this;
	};
	
	/**
	 * @todo  finish implementing this method!
	 * translates
	 * @param  {Array} v vector to translate by
	 * @return {p5.Matrix}                    this
	 */
	p5.Matrix.prototype.translate = function(v){
	  var x = v[0],
	    y = v[1],
	    z = v[2] || 0;
	  this.mat4[12] =
	    this.mat4[0] * x +this.mat4[4] * y +this.mat4[8] * z +this.mat4[12];
	  this.mat4[13] =
	    this.mat4[1] * x +this.mat4[5] * y +this.mat4[9] * z +this.mat4[13];
	  this.mat4[14] =
	    this.mat4[2] * x +this.mat4[6] * y +this.mat4[10] * z +this.mat4[14];
	  this.mat4[15] =
	    this.mat4[3] * x +this.mat4[7] * y +this.mat4[11] * z +this.mat4[15];
	};
	
	p5.Matrix.prototype.rotateX = function(a){
	  this.rotate(a, [1,0,0]);
	};
	p5.Matrix.prototype.rotateY = function(a){
	  this.rotate(a, [0,1,0]);
	};
	p5.Matrix.prototype.rotateZ = function(a){
	  this.rotate(a, [0,0,1]);
	};
	
	/**
	 * sets the perspective matrix
	 * @param  {Number} fovy   [description]
	 * @param  {Number} aspect [description]
	 * @param  {Number} near   near clipping plane
	 * @param  {Number} far    far clipping plane
	 * @return {void}
	 */
	p5.Matrix.prototype.perspective = function(fovy,aspect,near,far){
	
	  var f = 1.0 / Math.tan(fovy / 2),
	    nf = 1 / (near - far);
	
	  this.mat4[0] = f / aspect;
	  this.mat4[1] = 0;
	  this.mat4[2] = 0;
	  this.mat4[3] = 0;
	  this.mat4[4] = 0;
	  this.mat4[5] = f;
	  this.mat4[6] = 0;
	  this.mat4[7] = 0;
	  this.mat4[8] = 0;
	  this.mat4[9] = 0;
	  this.mat4[10] = (far + near) * nf;
	  this.mat4[11] = -1;
	  this.mat4[12] = 0;
	  this.mat4[13] = 0;
	  this.mat4[14] = (2 * far * near) * nf;
	  this.mat4[15] = 0;
	
	  return this;
	
	};
	
	/**
	 * sets the ortho matrix
	 * @param  {Number} left   [description]
	 * @param  {Number} right  [description]
	 * @param  {Number} bottom [description]
	 * @param  {Number} top    [description]
	 * @param  {Number} near   near clipping plane
	 * @param  {Number} far    far clipping plane
	 * @return {void}
	 */
	p5.Matrix.prototype.ortho = function(left,right,bottom,top,near,far){
	
	  var lr = 1 / (left - right),
	    bt = 1 / (bottom - top),
	    nf = 1 / (near - far);
	  this.mat4[0] = -2 * lr;
	  this.mat4[1] = 0;
	  this.mat4[2] = 0;
	  this.mat4[3] = 0;
	  this.mat4[4] = 0;
	  this.mat4[5] = -2 * bt;
	  this.mat4[6] = 0;
	  this.mat4[7] = 0;
	  this.mat4[8] = 0;
	  this.mat4[9] = 0;
	  this.mat4[10] = 2 * nf;
	  this.mat4[11] = 0;
	  this.mat4[12] = (left + right) * lr;
	  this.mat4[13] = (top + bottom) * bt;
	  this.mat4[14] = (far + near) * nf;
	  this.mat4[15] = 1;
	
	  return this;
	};
	
	/**
	 * PRIVATE
	 */
	// matrix methods adapted from:
	// https://developer.mozilla.org/en-US/docs/Web/WebGL/
	// gluPerspective
	//
	// function _makePerspective(fovy, aspect, znear, zfar){
	//    var ymax = znear * Math.tan(fovy * Math.PI / 360.0);
	//    var ymin = -ymax;
	//    var xmin = ymin * aspect;
	//    var xmax = ymax * aspect;
	//    return _makeFrustum(xmin, xmax, ymin, ymax, znear, zfar);
	//  }
	
	////
	//// glFrustum
	////
	//function _makeFrustum(left, right, bottom, top, znear, zfar){
	//  var X = 2*znear/(right-left);
	//  var Y = 2*znear/(top-bottom);
	//  var A = (right+left)/(right-left);
	//  var B = (top+bottom)/(top-bottom);
	//  var C = -(zfar+znear)/(zfar-znear);
	//  var D = -2*zfar*znear/(zfar-znear);
	//  var frustrumMatrix =[
	//  X, 0, A, 0,
	//  0, Y, B, 0,
	//  0, 0, C, D,
	//  0, 0, -1, 0
	//];
	//return frustrumMatrix;
	// }
	
	// function _setMVPMatrices(){
	////an identity matrix
	////@TODO use the p5.Matrix class to abstract away our MV matrices and
	///other math
	//var _mvMatrix =
	//[
	//  1.0,0.0,0.0,0.0,
	//  0.0,1.0,0.0,0.0,
	//  0.0,0.0,1.0,0.0,
	//  0.0,0.0,0.0,1.0
	//];
	
	module.exports = p5.Matrix;
	},{"../core/constants":47,"../core/core":48,"../math/polargeometry":77}],36:[function(_dereq_,module,exports){
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var shader = _dereq_('./shader');
	_dereq_('../core/p5.Renderer');
	_dereq_('./p5.Matrix');
	var uMVMatrixStack = [];
	var RESOLUTION = 1000;
	
	//@TODO should probably implement an override for these attributes
	var attributes = {
	  alpha: true,
	  depth: true,
	  stencil: true,
	  antialias: false,
	  premultipliedAlpha: false,
	  preserveDrawingBuffer: false
	};
	
	/**
	 * 3D graphics class.  Can also be used as an off-screen graphics buffer.
	 * A p5.Renderer3D object can be constructed
	 *
	 */
	p5.Renderer3D = function(elt, pInst, isMainCanvas) {
	  p5.Renderer.call(this, elt, pInst, isMainCanvas);
	
	  try {
	    this.drawingContext = this.canvas.getContext('webgl', attributes) ||
	      this.canvas.getContext('experimental-webgl', attributes);
	    if (this.drawingContext === null) {
	      throw new Error('Error creating webgl context');
	    } else {
	      console.log('p5.Renderer3D: enabled webgl context');
	    }
	  } catch (er) {
	    throw new Error(er);
	  }
	
	  this.isP3D = true; //lets us know we're in 3d mode
	  this.GL = this.drawingContext;
	  var gl = this.GL;
	  gl.clearColor(1.0, 1.0, 1.0, 1.0); //background is initialized white
	  gl.clearDepth(1);
	  gl.enable(gl.DEPTH_TEST);
	  gl.depthFunc(gl.LEQUAL);
	  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	  gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	  this._init();
	  return this;
	};
	
	p5.Renderer3D.prototype = Object.create(p5.Renderer.prototype);
	
	p5.Renderer3D.prototype._applyDefaults = function() {
	  return this;
	};
	
	//////////////////////////////////////////////
	// Setting
	//////////////////////////////////////////////
	
	p5.Renderer3D.prototype._init = function(first_argument) {
	  var gl = this.GL;
	  //for our default matrices
	  this.initMatrix();
	  this.initHash();
	  //for immedidate mode
	  this.verticeStack = [];
	  this.verticeBuffer = gl.createBuffer();
	  this.colorBuffer = gl.createBuffer();
	  //for camera
	  this._setCamera = false;
	  //for counting lights
	  this.ambientLightCount = 0;
	  this.directionalLightCount = 0;
	  this.pointLightCount = 0;
	};
	
	p5.Renderer3D.prototype._update = function() {
	  this.resetMatrix();
	  this.translate(0, 0, -800);
	  this.ambientLightCount = 0;
	  this.directionalLightCount = 0;
	  this.pointLightCount = 0;
	  this.verticeStack = [];
	};
	
	/**
	 * [resize description]
	 * @param  {[type]} w [description]
	 * @param  {[tyoe]} h [description]
	 * @return {[type]}   [description]
	 */
	p5.Renderer3D.prototype.resize = function(w,h) {
	  var gl = this.GL;
	  p5.Renderer.prototype.resize.call(this, w, h);
	  gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	};
	
	/**
	 * [background description]
	 * @return {[type]} [description]
	 */
	p5.Renderer3D.prototype.background = function() {
	  var gl = this.GL;
	  var _col = this._pInst.color.apply(this._pInst, arguments);
	  // gl.clearColor(0.0,0.0,0.0,1.0);
	  var _r = (_col.levels[0]) / 255;
	  var _g = (_col.levels[1]) / 255;
	  var _b = (_col.levels[2]) / 255;
	  var _a = (_col.levels[3]) / 255;
	  gl.clearColor(_r, _g, _b, _a);
	  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	};
	
	//@TODO implement this
	// p5.Renderer3D.prototype.clear = function() {
	//@TODO
	// };
	
	//////////////////////////////////////////////
	// SHADER
	//////////////////////////////////////////////
	
	/**
	 * [initShaders description]
	 * @param  {[type]} vertId [description]
	 * @param  {[type]} fragId [description]
	 * @return {[type]}        [description]
	 */
	p5.Renderer3D.prototype.initShaders = function(vertId, fragId, immediateMode) {
	  var gl = this.GL;
	  //set up our default shaders by:
	  // 1. create the shader,
	  // 2. load the shader source,
	  // 3. compile the shader
	  var _vertShader = gl.createShader(gl.VERTEX_SHADER);
	  //load in our default vertex shader
	  gl.shaderSource(_vertShader, shader[vertId]);
	  gl.compileShader(_vertShader);
	  // if our vertex shader failed compilation?
	  if (!gl.getShaderParameter(_vertShader, gl.COMPILE_STATUS)) {
	    alert('Yikes! An error occurred compiling the shaders:' +
	      gl.getShaderInfoLog(_vertShader));
	    return null;
	  }
	
	  var _fragShader = gl.createShader(gl.FRAGMENT_SHADER);
	  //load in our material frag shader
	  gl.shaderSource(_fragShader, shader[fragId]);
	  gl.compileShader(_fragShader);
	  // if our frag shader failed compilation?
	  if (!gl.getShaderParameter(_fragShader, gl.COMPILE_STATUS)) {
	    alert('Darn! An error occurred compiling the shaders:' +
	      gl.getShaderInfoLog(_fragShader));
	    return null;
	  }
	
	  var shaderProgram = gl.createProgram();
	  gl.attachShader(shaderProgram, _vertShader);
	  gl.attachShader(shaderProgram, _fragShader);
	  gl.linkProgram(shaderProgram);
	  if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
	    alert('Snap! Error linking shader program');
	  }
	  //END SHADERS SETUP
	
	  this._getLocation(shaderProgram, immediateMode);
	
	  return shaderProgram;
	};
	
	p5.Renderer3D.prototype._getLocation = function(shaderProgram, immediateMode) {
	  var gl = this.GL;
	  gl.useProgram(shaderProgram);
	  shaderProgram.uResolution =
	    gl.getUniformLocation(shaderProgram, 'uResolution');
	  gl.uniform1f(shaderProgram.uResolution, RESOLUTION);
	
	  //vertex position Attribute
	  shaderProgram.vertexPositionAttribute =
	    gl.getAttribLocation(shaderProgram, 'aPosition');
	  gl.enableVertexAttribArray(shaderProgram.vertexPositionAttribute);
	
	  //projection Matrix uniform
	  shaderProgram.uPMatrixUniform =
	    gl.getUniformLocation(shaderProgram, 'uProjectionMatrix');
	  //model view Matrix uniform
	  shaderProgram.uMVMatrixUniform =
	    gl.getUniformLocation(shaderProgram, 'uModelViewMatrix');
	
	  //@TODO: figure out a better way instead of if statement
	  if(immediateMode === undefined){
	    //vertex normal Attribute
	    shaderProgram.vertexNormalAttribute =
	      gl.getAttribLocation(shaderProgram, 'aNormal');
	    gl.enableVertexAttribArray(shaderProgram.vertexNormalAttribute);
	
	    //normal Matrix uniform
	    shaderProgram.uNMatrixUniform =
	    gl.getUniformLocation(shaderProgram, 'uNormalMatrix');
	
	    //texture coordinate Attribute
	    shaderProgram.textureCoordAttribute =
	      gl.getAttribLocation(shaderProgram, 'aTexCoord');
	    gl.enableVertexAttribArray(shaderProgram.textureCoordAttribute);
	
	    shaderProgram.samplerUniform =
	    gl.getUniformLocation(shaderProgram, 'uSampler');
	  }
	};
	
	p5.Renderer3D.prototype.setMatrixUniforms = function(shaderKey) {
	  var gl = this.GL;
	  var shaderProgram = this.mHash[shaderKey];
	
	  gl.useProgram(shaderProgram);
	
	  gl.uniformMatrix4fv(
	    shaderProgram.uPMatrixUniform,
	    false, this.uPMatrix.mat4);
	
	  gl.uniformMatrix4fv(
	    shaderProgram.uMVMatrixUniform,
	    false, this.uMVMatrix.mat4);
	
	  this.uNMatrix = new p5.Matrix();
	  this.uNMatrix.invert(this.uMVMatrix);
	  this.uNMatrix.transpose(this.uNMatrix);
	
	  gl.uniformMatrix4fv(
	    shaderProgram.uNMatrixUniform,
	    false, this.uNMatrix.mat4);
	};
	//////////////////////////////////////////////
	// GET CURRENT | for shader and color
	//////////////////////////////////////////////
	p5.Renderer3D.prototype._getShader = function(vertId, fragId, immediateMode) {
	  var mId = vertId+ '|' + fragId;
	  //create it and put it into hashTable
	  if(!this.materialInHash(mId)){
	    var shaderProgram = this.initShaders(vertId, fragId, immediateMode);
	    this.mHash[mId] = shaderProgram;
	  }
	  this.curShaderId = mId;
	
	  return this.mHash[this.curShaderId];
	};
	
	p5.Renderer3D.prototype._getCurShaderId = function(){
	  //if it's not defined yet
	  if(this.curShaderId === undefined){
	    //default shader: normalMaterial()
	    var mId = 'normalVert|normalFrag';
	    var shaderProgram = this.initShaders('normalVert', 'normalFrag');
	    this.mHash[mId] = shaderProgram;
	    this.curShaderId = mId;
	  }
	
	  return this.curShaderId;
	};
	
	p5.Renderer3D.prototype._getCurColor = function() {
	  //default color: gray
	  if(this.curColor === undefined) {
	    this.curColor = [0.5, 0.5, 0.5, 1.0];
	  }
	  return this.curColor;
	};
	
	//////////////////////////////////////////////
	// HASH | for material and geometry
	//////////////////////////////////////////////
	
	p5.Renderer3D.prototype.initHash = function(){
	  this.gHash = {};
	  this.mHash = {};
	};
	
	p5.Renderer3D.prototype.geometryInHash = function(gId){
	  return this.gHash[gId] !== undefined;
	};
	
	p5.Renderer3D.prototype.materialInHash = function(mId){
	  return this.mHash[mId] !== undefined;
	};
	
	//////////////////////////////////////////////
	// MATRIX
	//////////////////////////////////////////////
	
	p5.Renderer3D.prototype.initMatrix = function(){
	  this.uMVMatrix = new p5.Matrix();
	  this.uPMatrix  = new p5.Matrix();
	  this.uNMatrix = new p5.Matrix();
	};
	
	p5.Renderer3D.prototype.resetMatrix = function() {
	  this.uMVMatrix = p5.Matrix.identity();
	  //this.uPMatrix = p5.Matrix.identity();
	};
	
	//detect if user didn't set the camera
	//then call this function below
	p5.Renderer3D.prototype._setDefaultCamera = function(){
	  if(!this._setCamera){
	    var _w = this.width;
	    var _h = this.height;
	    this.uPMatrix = p5.Matrix.identity();
	    this.uPMatrix.perspective(60 / 180 * Math.PI, _w / _h, 0.1, 100);
	    this._setCamera = true;
	  }
	};
	
	/**
	 * [translate description]
	 * @param  {[type]} x [description]
	 * @param  {[type]} y [description]
	 * @param  {[type]} z [description]
	 * @return {[type]}   [description]
	 * @todo implement handle for components or vector as args
	 */
	p5.Renderer3D.prototype.translate = function(x, y, z) {
	  //@TODO: figure out how to fit the resolution
	  x = x / RESOLUTION;
	  y = -y / RESOLUTION;
	  z = z / RESOLUTION;
	  this.uMVMatrix.translate([x,y,z]);
	  return this;
	};
	
	/**
	 * Scales the Model View Matrix by a vector
	 * @param  {Number | p5.Vector | Array} x [description]
	 * @param  {Number} [y] y-axis scalar
	 * @param  {Number} [z] z-axis scalar
	 * @return {this}   [description]
	 */
	p5.Renderer3D.prototype.scale = function(x,y,z) {
	  this.uMVMatrix.scale([x,y,z]);
	  return this;
	};
	
	/**
	 * [rotate description]
	 * @param  {Number} rad  angle in radians
	 * @param  {p5.Vector | Array} axis axis to rotate around
	 * @return {p5.Renderer3D}      [description]
	 */
	p5.Renderer3D.prototype.rotate = function(rad, axis){
	  this.uMVMatrix.rotate(rad, axis);
	  return this;
	};
	
	/**
	 * [rotateX description]
	 * @param  {Number} rad radians to rotate
	 * @return {[type]}     [description]
	 */
	p5.Renderer3D.prototype.rotateX = function(rad) {
	  this.uMVMatrix.rotateX(rad);
	  return this;
	};
	
	/**
	 * [rotateY description]
	 * @param  {Number} rad rad radians to rotate
	 * @return {[type]}     [description]
	 */
	p5.Renderer3D.prototype.rotateY = function(rad) {
	  this.uMVMatrix.rotateY(rad);
	  return this;
	};
	
	/**
	 * [rotateZ description]
	 * @param  {Number} rad rad radians to rotate
	 * @return {[type]}     [description]
	 */
	p5.Renderer3D.prototype.rotateZ = function(rad) {
	  this.uMVMatrix.rotateZ(rad);
	  return this;
	};
	
	/**
	 * pushes a copy of the model view matrix onto the
	 * MV Matrix stack.
	 * NOTE to self: could probably make this more readable
	 * @return {[type]} [description]
	 */
	p5.Renderer3D.prototype.push = function() {
	  uMVMatrixStack.push(this.uMVMatrix.copy());
	};
	
	/**
	 * [pop description]
	 * @return {[type]} [description]
	 */
	p5.Renderer3D.prototype.pop = function() {
	  if (uMVMatrixStack.length === 0) {
	    throw new Error('Invalid popMatrix!');
	  }
	  this.uMVMatrix = uMVMatrixStack.pop();
	};
	
	module.exports = p5.Renderer3D;
	
	},{"../core/core":48,"../core/p5.Renderer":54,"./p5.Matrix":35,"./shader":38}],37:[function(_dereq_,module,exports){
	//retained mode is used by rendering 3d_primitives
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var hashCount = 0;
	
	/**
	 * createBuffer
	 * @param  {String} gId  key of the geometry object
	 * @param  {Array}  arr  array holding bject containing geometry information
	 */
	p5.Renderer3D.prototype.createBuffer = function(gId, arr) {
	
	  hashCount ++;
	  if(hashCount > 1000){
	    var key = Object.keys(this.gHash)[0];
	    delete this.gHash[key];
	    hashCount --;
	  }
	
	  var gl = this.GL;
	  this.gHash[gId] = {};
	  this.gHash[gId].len = [];
	  this.gHash[gId].vertexBuffer = [];
	  this.gHash[gId].normalBuffer = [];
	  this.gHash[gId].uvBuffer = [];
	  this.gHash[gId].indexBuffer =[];
	
	  arr.forEach(function(obj){
	    this.gHash[gId].len.push(obj.len);
	    this.gHash[gId].vertexBuffer.push(gl.createBuffer());
	    this.gHash[gId].normalBuffer.push(gl.createBuffer());
	    this.gHash[gId].uvBuffer.push(gl.createBuffer());
	    this.gHash[gId].indexBuffer.push(gl.createBuffer());
	  }.bind(this));
	};
	
	/**
	 * initBuffer description
	 * @param  {String} gId    key of the geometry object
	 * @param  {Array}  arr    array holding bject containing geometry information
	 */
	p5.Renderer3D.prototype.initBuffer = function(gId, arr) {
	  this._setDefaultCamera();
	  var gl = this.GL;
	  this.createBuffer(gId, arr);
	
	  var shaderProgram = this.mHash[this._getCurShaderId()];
	
	  arr.forEach(function(obj, i){
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].vertexBuffer[i]);
	    gl.bufferData(
	      gl.ARRAY_BUFFER, new Float32Array(obj.vertices), gl.STATIC_DRAW);
	    gl.vertexAttribPointer(
	      shaderProgram.vertexPositionAttribute,
	      3, gl.FLOAT, false, 0, 0);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].normalBuffer[i]);
	    gl.bufferData(
	      gl.ARRAY_BUFFER, new Float32Array(obj.vertexNormals), gl.STATIC_DRAW);
	    gl.vertexAttribPointer(
	      shaderProgram.vertexNormalAttribute,
	      3, gl.FLOAT, false, 0, 0);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].uvBuffer[i]);
	    gl.bufferData(
	      gl.ARRAY_BUFFER, new Float32Array(obj.uvs), gl.STATIC_DRAW);
	    gl.vertexAttribPointer(
	      shaderProgram.textureCoordAttribute,
	      2, gl.FLOAT, false, 0, 0);
	
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.gHash[gId].indexBuffer[i]);
	    gl.bufferData
	     (gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(obj.faces), gl.STATIC_DRAW);
	  }.bind(this));
	};
	
	/**
	 * drawBuffer
	 * @param  {String} gId     key of the geometery object
	 */
	p5.Renderer3D.prototype.drawBuffer = function(gId) {
	  this._setDefaultCamera();
	  var gl = this.GL;
	  var shaderKey = this._getCurShaderId();
	  var shaderProgram = this.mHash[shaderKey];
	
	  this.gHash[gId].len.forEach(function(d, i){
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].vertexBuffer[i]);
	    gl.vertexAttribPointer(
	      shaderProgram.vertexPositionAttribute,
	      3, gl.FLOAT, false, 0, 0);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].normalBuffer[i]);
	    gl.vertexAttribPointer(
	      shaderProgram.vertexNormalAttribute,
	      3, gl.FLOAT, false, 0, 0);
	
	    gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].uvBuffer[i]);
	    gl.vertexAttribPointer(
	      shaderProgram.textureCoordAttribute,
	      2, gl.FLOAT, false, 0, 0);
	
	    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.gHash[gId].indexBuffer[i]);
	
	    this.setMatrixUniforms(shaderKey);
	
	    gl.drawElements(
	      gl.TRIANGLES, this.gHash[gId].len[i],
	       gl.UNSIGNED_SHORT, 0);
	  }.bind(this));
	};
	
	module.exports = p5.Renderer3D;
	},{"../core/core":48}],38:[function(_dereq_,module,exports){
	
	
	module.exports = {
	  vertexColorVert:
	    "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uResolution;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition / uResolution * vec3(1.0, -1.0, 1.0), 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n}",
	  vertexColorFrag:
	    "precision mediump float;\nvarying vec4 vColor;\nvoid main(void) {\n  gl_FragColor = vColor;\n}",
	  normalVert:
	    "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat4 uNormalMatrix;\nuniform float uResolution;\n\nvarying vec3 vVertexNormal;\nvarying highp vec2 vVertTexCoord;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition / uResolution, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vVertexNormal = vec3( uNormalMatrix * vec4( aNormal, 1.0 ) );\n  vVertTexCoord = aTexCoord;\n}",
	  normalFrag:
	    "precision mediump float;\nvarying vec3 vVertexNormal;\nvoid main(void) {\n  gl_FragColor = vec4(vVertexNormal, 1.0);\n}",
	  basicFrag:
	    "precision mediump float;\nvarying vec3 vVertexNormal;\nuniform vec4 uMaterialColor;\nvoid main(void) {\n  gl_FragColor = uMaterialColor;\n}",
	  lightVert:
	    "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat4 uNormalMatrix;\nuniform float uResolution;\nuniform int uAmbientLightCount;\nuniform int uDirectionalLightCount;\nuniform int uPointLightCount;\n\nuniform vec3 uAmbientColor[8];\nuniform vec3 uLightingDirection[8];\nuniform vec3 uDirectionalColor[8];\nuniform vec3 uPointLightLocation[8];\nuniform vec3 uPointLightColor[8];\nuniform bool uSpecular;\n\nvarying vec3 vVertexNormal;\nvarying vec2 vVertTexCoord;\nvarying vec3 vLightWeighting;\n\nvec3 ambientLightFactor = vec3(0.0, 0.0, 0.0);\nvec3 directionalLightFactor = vec3(0.0, 0.0, 0.0);\nvec3 pointLightFactor = vec3(0.0, 0.0, 0.0);\nvec3 pointLightFactor2 = vec3(0.0, 0.0, 0.0);\n\nvoid main(void){\n\n  vec4 positionVec4 = vec4(aPosition / uResolution, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n\n  vec3 vertexNormal = vec3( uNormalMatrix * vec4( aNormal, 1.0 ) );\n  vVertexNormal = vertexNormal;\n  vVertTexCoord = aTexCoord;\n\n  vec4 mvPosition = uModelViewMatrix * vec4(aPosition / uResolution, 1.0);\n  vec3 eyeDirection = normalize(-mvPosition.xyz);\n\n  float shininess = 32.0;\n  float specularFactor = 2.0;\n  float diffuseFactor = 0.3;\n\n  for(int i = 0; i < 8; i++){\n    if(uAmbientLightCount == i) break;\n    ambientLightFactor += uAmbientColor[i];\n  }\n\n  for(int j = 0; j < 8; j++){\n    if(uDirectionalLightCount == j) break;\n    vec3 dir = uLightingDirection[j];\n    float directionalLightWeighting = max(dot(vertexNormal, dir), 0.0);\n    directionalLightFactor += uDirectionalColor[j] * directionalLightWeighting;\n  }\n\n  for(int k = 0; k < 8; k++){\n    if(uPointLightCount == k) break;\n    vec3 loc = uPointLightLocation[k];\n    //loc = loc / uResolution;\n    vec3 lightDirection = normalize(loc - mvPosition.xyz);\n\n    float directionalLightWeighting = max(dot(vertexNormal, lightDirection), 0.0);\n    pointLightFactor += uPointLightColor[k] * directionalLightWeighting;\n\n    //factor2 for specular\n    vec3 reflectionDirection = reflect(-lightDirection, vertexNormal);\n    float specularLightWeighting = pow(max(dot(reflectionDirection, eyeDirection), 0.0), shininess);\n\n    pointLightFactor2 += uPointLightColor[k] * (specularFactor * specularLightWeighting\n      +  directionalLightWeighting * diffuseFactor);\n  }\n  \n  if(!uSpecular){\n    vLightWeighting =  ambientLightFactor + directionalLightFactor + pointLightFactor;\n  }else{\n    vLightWeighting = ambientLightFactor + directionalLightFactor + pointLightFactor2;\n  }\n\n}",
	  lightTextureFrag:
	    "precision mediump float;\n\nuniform vec4 uMaterialColor;\nuniform sampler2D uSampler;\nuniform bool isTexture;\n\nvarying vec3 vLightWeighting;\nvarying highp vec2 vVertTexCoord;\n\nvoid main(void) {\n  if(!isTexture){\n    gl_FragColor = vec4(vec3(uMaterialColor.rgb * vLightWeighting), uMaterialColor.a);\n  }else{\n    vec4 textureColor = texture2D(uSampler, vVertTexCoord);\n    if(vLightWeighting == vec3(0., 0., 0.)){\n      gl_FragColor = textureColor;\n    }else{\n      gl_FragColor = vec4(vec3(textureColor.rgb * vLightWeighting), textureColor.a); \n    }\n  }\n}"
	};
	},{}],39:[function(_dereq_,module,exports){
	
	'use strict';
	
	var p5 = _dereq_('./core/core');
	_dereq_('./color/p5.Color');
	_dereq_('./core/p5.Element');
	_dereq_('./typography/p5.Font');
	_dereq_('./core/p5.Graphics');
	_dereq_('./core/p5.Renderer2D');
	
	_dereq_('./image/p5.Image');
	_dereq_('./math/p5.Vector');
	_dereq_('./io/p5.TableRow');
	_dereq_('./io/p5.Table');
	
	_dereq_('./color/creating_reading');
	_dereq_('./color/setting');
	_dereq_('./core/constants');
	_dereq_('./utilities/conversion');
	_dereq_('./utilities/array_functions');
	_dereq_('./utilities/string_functions');
	_dereq_('./core/environment');
	_dereq_('./image/image');
	_dereq_('./image/loading_displaying');
	_dereq_('./image/pixels');
	_dereq_('./io/files');
	_dereq_('./events/keyboard');
	_dereq_('./events/acceleration'); //john
	_dereq_('./events/mouse');
	_dereq_('./utilities/time_date');
	_dereq_('./events/touch');
	_dereq_('./math/math');
	_dereq_('./math/calculation');
	_dereq_('./math/random');
	_dereq_('./math/noise');
	_dereq_('./math/trigonometry');
	_dereq_('./core/rendering');
	_dereq_('./core/2d_primitives');
	
	_dereq_('./core/attributes');
	_dereq_('./core/curves');
	_dereq_('./core/vertex');
	_dereq_('./core/structure');
	_dereq_('./core/transform');
	_dereq_('./typography/attributes');
	_dereq_('./typography/loading_displaying');
	
	_dereq_('./3d/p5.Renderer3D');
	_dereq_('./3d/p5.Geometry3D');
	_dereq_('./3d/retainedMode3D');
	_dereq_('./3d/immediateMode3D');
	_dereq_('./3d/3d_primitives');
	_dereq_('./3d/p5.Matrix');
	_dereq_('./3d/material');
	_dereq_('./3d/light');
	_dereq_('./3d/shader');
	_dereq_('./3d/camera');
	_dereq_('./3d/interaction');
	
	/**
	 * _globalInit
	 *
	 * TODO: ???
	 * if sketch is on window
	 * assume "global" mode
	 * and instantiate p5 automatically
	 * otherwise do nothing
	 *
	 * @return {Undefined}
	 */
	var _globalInit = function() {
	  if (!window.PHANTOMJS && !window.mocha) {
	    // If there is a setup or draw function on the window
	    // then instantiate p5 in "global" mode
	    if((window.setup && typeof window.setup === 'function') ||
	      (window.draw && typeof window.draw === 'function')) {
	      new p5();
	    }
	  }
	};
	
	// TODO: ???
	if (document.readyState === 'complete') {
	  _globalInit();
	} else {
	  window.addEventListener('load', _globalInit , false);
	}
	
	module.exports = p5;
	},{"./3d/3d_primitives":28,"./3d/camera":29,"./3d/immediateMode3D":30,"./3d/interaction":31,"./3d/light":32,"./3d/material":33,"./3d/p5.Geometry3D":34,"./3d/p5.Matrix":35,"./3d/p5.Renderer3D":36,"./3d/retainedMode3D":37,"./3d/shader":38,"./color/creating_reading":41,"./color/p5.Color":42,"./color/setting":43,"./core/2d_primitives":44,"./core/attributes":45,"./core/constants":47,"./core/core":48,"./core/curves":49,"./core/environment":50,"./core/p5.Element":52,"./core/p5.Graphics":53,"./core/p5.Renderer2D":55,"./core/rendering":56,"./core/structure":58,"./core/transform":59,"./core/vertex":60,"./events/acceleration":61,"./events/keyboard":62,"./events/mouse":63,"./events/touch":64,"./image/image":66,"./image/loading_displaying":67,"./image/p5.Image":68,"./image/pixels":69,"./io/files":70,"./io/p5.Table":71,"./io/p5.TableRow":72,"./math/calculation":73,"./math/math":74,"./math/noise":75,"./math/p5.Vector":76,"./math/random":78,"./math/trigonometry":79,"./typography/attributes":80,"./typography/loading_displaying":81,"./typography/p5.Font":82,"./utilities/array_functions":83,"./utilities/conversion":84,"./utilities/string_functions":85,"./utilities/time_date":86}],40:[function(_dereq_,module,exports){
	/**
	 * module Conversion
	 * submodule Color Conversion
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	/**
	 * Conversions adapted from <http://www.easyrgb.com/math.html>.
	 *
	 * In these functions, hue is always in the range [0,1); all other components
	 * are in the range [0,1]. 'Brightness' and 'value' are used interchangeably.
	 */
	
	var p5 = _dereq_('../core/core');
	p5.ColorConversion = {};
	
	/**
	 * Convert an HSBA array to HSLA.
	 */
	p5.ColorConversion._hsbaToHSLA = function(hsba) {
	  var hue = hsba[0];
	  var sat = hsba[1];
	  var val = hsba[2];
	
	  // Calculate lightness.
	  var li = (2 - sat) * val / 2;
	
	  // Convert saturation.
	  if (li !== 0) {
	    if (li === 1) {
	      sat = 0;
	    } else if (li < 0.5) {
	      sat = sat / (2 - sat);
	    } else {
	      sat = sat * val / (2 - li * 2);
	    }
	  }
	
	  // Hue and alpha stay the same.
	  return [hue, sat, li, hsba[3]];
	};
	
	/**
	 * Convert an HSBA array to RGBA.
	 */
	p5.ColorConversion._hsbaToRGBA = function(hsba) {
	  var hue = hsba[0] * 6;  // We will split hue into 6 sectors.
	  var sat = hsba[1];
	  var val = hsba[2];
	
	  var RGBA = [];
	
	  if (sat === 0) {
	    RGBA = [val, val, val, hsba[3]];  // Return early if grayscale.
	  } else {
	    var sector = Math.floor(hue);
	    var tint1 = val * (1 - sat);
	    var tint2 = val * (1 - sat * (hue - sector));
	    var tint3 = val * (1 - sat * (1 + sector - hue));
	    var red, green, blue;
	    if (sector === 0) {  // Red to yellow.
	      red = val;
	      green = tint3;
	      blue = tint1;
	    } else if (sector === 1) {  // Yellow to green.
	      red = tint2;
	      green = val;
	      blue = tint1;
	    } else if (sector === 2) {  // Green to cyan.
	      red = tint1;
	      green = val;
	      blue = tint3;
	    } else if (sector === 3) {  // Cyan to blue.
	      red = tint1;
	      green = tint2;
	      blue = val;
	    } else if (sector === 4) {  // Blue to magenta.
	      red = tint3;
	      green = tint1;
	      blue = val;
	    } else {  // Magenta to red.
	      red = val;
	      green = tint1;
	      blue = tint2;
	    }
	    RGBA = [red, green, blue, hsba[3]];
	  }
	
	  return RGBA;
	};
	
	/**
	 * Convert an HSLA array to HSBA.
	 */
	p5.ColorConversion._hslaToHSBA = function(hsla) {
	  var hue = hsla[0];
	  var sat = hsla[1];
	  var li = hsla[2];
	
	  // Calculate brightness.
	  var val;
	  if (li < 0.5) {
	    val = (1 + sat) * li;
	  } else {
	    val = li + sat - li * sat;
	  }
	
	  // Convert saturation.
	  sat = 2 * (val - li) / val;
	
	  // Hue and alpha stay the same.
	  return [hue, sat, val, hsla[3]];
	};
	
	/**
	 * Convert an HSLA array to RGBA.
	 *
	 * We need to change basis from HSLA to something that can be more easily be
	 * projected onto RGBA. We will choose hue and brightness as our first two
	 * components, and pick a convenient third one ('zest') so that we don't need
	 * to calculate formal HSBA saturation.
	 */
	p5.ColorConversion._hslaToRGBA = function(hsla){
	  var hue = hsla[0] * 6;  // We will split hue into 6 sectors.
	  var sat = hsla[1];
	  var li = hsla[2];
	
	  var RGBA = [];
	
	  if (sat === 0) {
	    RGBA = [li, li, li, hsla[3]]; // Return early if grayscale.
	  } else {
	
	    // Calculate brightness.
	    var val;
	    if (li < 0.5) {
	      val = (1 + sat) * li;
	    } else {
	      val = li + sat - li * sat;
	    }
	
	    // Define zest.
	    var zest = 2 * li - val;
	
	    // Implement projection (project onto green by default).
	    var hzvToRGB = function(hue, zest, val) {
	      if (hue < 0) {  // Hue must wrap to allow projection onto red and blue.
	        hue += 6;
	      } else if (hue >= 6) {
	        hue -= 6;
	      }
	      if (hue < 1) {  // Red to yellow (increasing green).
	        return (zest + (val - zest) * hue);
	      } else if (hue < 3) {  // Yellow to cyan (greatest green).
	        return val;
	      } else if (hue < 4) {  // Cyan to blue (decreasing green).
	        return (zest + (val - zest) * (4 - hue));
	      } else {  // Blue to red (least green).
	        return zest;
	      }
	    };
	
	    // Perform projections, offsetting hue as necessary.
	    RGBA = [hzvToRGB(hue + 2, zest, val),
	            hzvToRGB(hue    , zest, val),
	            hzvToRGB(hue - 2, zest, val),
	            hsla[3]];
	  }
	
	  return RGBA;
	};
	
	/**
	 * Convert an RGBA array to HSBA.
	 */
	p5.ColorConversion._rgbaToHSBA = function(rgba) {
	  var red = rgba[0];
	  var green = rgba[1];
	  var blue = rgba[2];
	
	  var val = Math.max(red, green, blue);
	  var chroma = val - Math.min(red, green, blue);
	
	  var hue, sat;
	  if (chroma === 0) {  // Return early if grayscale.
	    hue = 0;
	    sat = 0;
	  }
	  else {
	    sat = chroma / val;
	    if (red === val) {  // Magenta to yellow.
	      hue = (green - blue) / chroma;
	    } else if (green === val) { // Yellow to cyan.
	      hue = 2 + (blue - red) / chroma;
	    } else if (blue === val) {  // Cyan to magenta.
	      hue = 4 + (red - green) / chroma;
	    }
	    if (hue < 0) {  // Confine hue to the interval [0, 1).
	      hue += 6;
	    } else if (hue >= 6) {
	      hue -= 6;
	    }
	  }
	
	  return [hue / 6, sat, val, rgba[3]];
	};
	
	/**
	 * Convert an RGBA array to HSLA.
	 */
	p5.ColorConversion._rgbaToHSLA = function(rgba) {
	  var red = rgba[0];
	  var green = rgba[1];
	  var blue = rgba[2];
	
	  var val = Math.max(red, green, blue);
	  var min = Math.min(red, green, blue);
	  var li = val + min;  // We will halve this later.
	  var chroma = val - min;
	
	  var hue, sat;
	  if (chroma === 0) {  // Return early if grayscale.
	    hue = 0;
	    sat = 0;
	  } else {
	    if (li < 1) {
	      sat = chroma / li;
	    } else {
	      sat = chroma / (2 - chroma);
	    }
	    if (red === val) {  // Magenta to yellow.
	      hue = (green - blue) / chroma;
	    } else if (green === val) {  // Yellow to cyan.
	      hue = 2 + (blue - red) / chroma;
	    } else if (blue === val) {  // Cyan to magenta.
	      hue = 4 + (red - green) / chroma;
	    }
	    if (hue < 0) {  // Confine hue to the interval [0, 1).
	      hue += 6;
	    } else if (hue >= 6) {
	      hue -= 6;
	    }
	  }
	
	  return [hue / 6, sat, li / 2, rgba[3]];
	};
	
	module.exports = p5.ColorConversion;
	
	},{"../core/core":48}],41:[function(_dereq_,module,exports){
	/**
	 * @module Color
	 * @submodule Creating & Reading
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var constants = _dereq_('../core/constants');
	_dereq_('./p5.Color');
	
	/**
	 * Extracts the alpha value from a color or pixel array.
	 *
	 * @method alpha
	 * @param {Object} obj p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * c = color(0, 126, 255, 102);
	 * fill(c);
	 * rect(15, 15, 35, 70);
	 * value = alpha(c);  // Sets 'value' to 102
	 * fill(value);
	 * rect(50, 15, 35, 70);
	 * </code>
	 * </div>
	 */
	p5.prototype.alpha = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getAlpha();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Extracts the blue value from a color or pixel array.
	 *
	 * @method blue
	 * @param {Object} obj p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * c = color(175, 100, 220);  // Define color 'c'
	 * fill(c);  // Use color variable 'c' as fill color
	 * rect(15, 20, 35, 60);  // Draw left rectangle
	 *
	 * blueValue = blue(c);  // Get blue in 'c'
	 * println(blueValue);  // Prints "220.0"
	 * fill(0, 0, blueValue);  // Use 'blueValue' in new fill
	 * rect(50, 20, 35, 60);  // Draw right rectangle
	 * </code>
	 * </div>
	 */
	p5.prototype.blue = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getBlue();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Extracts the HSB brightness value from a color or pixel array.
	 *
	 * @method brightness
	 * @param {Object} color p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * colorMode(HSB, 255);
	 * c = color(0, 126, 255);
	 * fill(c);
	 * rect(15, 20, 35, 60);
	 * value = brightness(c);  // Sets 'value' to 255
	 * fill(value);
	 * rect(50, 20, 35, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.brightness = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getBrightness();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Creates colors for storing in variables of the color datatype. The
	 * parameters are interpreted as RGB or HSB values depending on the
	 * current colorMode(). The default mode is RGB values from 0 to 255
	 * and, therefore, the function call color(255, 204, 0) will return a
	 * bright yellow color.
	 * <br><br>
	 * Note that if only one value is provided to color(), it will be interpreted
	 * as a grayscale value. Add a second value, and it will be used for alpha
	 * transparency. When three values are specified, they are interpreted as
	 * either RGB or HSB values. Adding a fourth value applies alpha
	 * transparency. If a single string parameter is provided it will be
	 * interpreted as a CSS-compatible color string.
	 *
	 * Colors are stored as Numbers or Arrays.
	 *
	 * @method color
	 * @param  {Number|String} v1      gray value or red or hue value relative to
	 *                                 the current color range, or a color string
	 * @param  {Number}        [v2]    gray value or green or saturation value
	 *                                 relative to the current color range (or
	 *                                 alpha value if first param is gray value)
	 * @param  {Number}        [v3]    gray value or blue or brightness value
	 *                                 relative to the current color range
	 * @param  {Number}        [alpha] alpha value relative to current color range
	 * @return {Array}                 resulting color
	 *
	 * @example
	 * <div>
	 * <code>
	 * var c = color(255, 204, 0);  // Define color 'c'
	 * fill(c);  // Use color variable 'c' as fill color
	 * noStroke();  // Don't draw a stroke around shapes
	 * rect(30, 20, 55, 55);  // Draw rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var c = color(255, 204, 0);  // Define color 'c'
	 * fill(c);  // Use color variable 'c' as fill color
	 * noStroke();  // Don't draw a stroke around shapes
	 * ellipse(25, 25, 80, 80);  // Draw left circle
	 *
	 * // Using only one value with color()
	 * // generates a grayscale value.
	 * var c = color(65);  // Update 'c' with grayscale value
	 * fill(c);  // Use updated 'c' as fill color
	 * ellipse(75, 75, 80, 80);  // Draw right circle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // Named SVG & CSS colors may be used,
	 * var c = color('magenta');
	 * fill(c);  // Use 'c' as fill color
	 * noStroke();  // Don't draw a stroke around shapes
	 * rect(20, 20, 60, 60);  // Draw rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // as can hex color codes:
	 * noStroke();  // Don't draw a stroke around shapes
	 * var c = color('#0f0');
	 * fill(c);  // Use 'c' as fill color
	 * rect(0, 10, 45, 80);  // Draw rectangle
	 *
	 * c = color('#00ff00');
	 * fill(c);  // Use updated 'c' as fill color
	 * rect(55, 10, 45, 80);  // Draw rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // RGB and RGBA color strings are also supported:
	 * // these all set to the same color (solid blue)
	 * var c;
	 * noStroke();  // Don't draw a stroke around shapes
	 * c = color('rgb(0,0,255)');
	 * fill(c); // Use 'c' as fill color
	 * rect(10, 10, 35, 35);  // Draw rectangle
	 *
	 * c = color('rgb(0%, 0%, 100%)');
	 * fill(c); // Use updated 'c' as fill color
	 * rect(55, 10, 35, 35);  // Draw rectangle
	 *
	 * c = color('rgba(0, 0, 255, 1)');
	 * fill(c); // Use updated 'c' as fill color
	 * rect(10, 55, 35, 35);  // Draw rectangle
	 *
	 * c = color('rgba(0%, 0%, 100%, 1)');
	 * fill(c); // Use updated 'c' as fill color
	 * rect(55, 55, 35, 35);  // Draw rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // HSL color is also supported and can be specified
	 * // by value
	 * var c;
	 * noStroke();  // Don't draw a stroke around shapes
	 * c = color('hsl(160, 100%, 50%)');
	 * fill(c);  // Use 'c' as fill color
	 * rect(0, 10, 45, 80);  // Draw rectangle
	 *
	 * c = color('hsla(160, 100%, 50%, 0.5)');
	 * fill(c); // Use updated 'c' as fill color
	 * rect(55, 10, 45, 80);  // Draw rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // HSB color is also supported and can be specified
	 * // by value
	 * var c;
	 * noStroke();  // Don't draw a stroke around shapes
	 * c = color('hsb(160, 100%, 50%)');
	 * fill(c);  // Use 'c' as fill color
	 * rect(0, 10, 45, 80);  // Draw rectangle
	 *
	 * c = color('hsba(160, 100%, 50%, 0.5)');
	 * fill(c); // Use updated 'c' as fill color
	 * rect(55, 10, 45, 80);  // Draw rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var c;  // Declare color 'c'
	 * noStroke();  // Don't draw a stroke around shapes
	 *
	 * // If no colorMode is specified, then the
	 * // default of RGB with scale of 0-255 is used.
	 * c = color(50, 55, 100);  // Create a color for 'c'
	 * fill(c);  // Use color variable 'c' as fill color
	 * rect(0, 10, 45, 80);  // Draw left rect
	 *
	 * colorMode(HSB, 100);  // Use HSB with scale of 0-100
	 * c = color(50, 55, 100);  // Update 'c' with new color
	 * fill(c);  // Use updated 'c' as fill color
	 * rect(55, 10, 45, 80);  // Draw right rect
	 * </code>
	 * </div>
	 */
	p5.prototype.color = function() {
	  if (arguments[0] instanceof p5.Color) {
	    return arguments[0];  // Do nothing if argument is already a color object.
	  } else if (arguments[0] instanceof Array) {
	    return new p5.Color(this, arguments[0]);
	  } else {
	    return new p5.Color(this, arguments);
	  }
	};
	
	/**
	 * Extracts the green value from a color or pixel array.
	 *
	 * @method green
	 * @param {Object} color p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * c = color(20, 75, 200);  // Define color 'c'
	 * fill(c);  // Use color variable 'c' as fill color
	 * rect(15, 20, 35, 60);  // Draw left rectangle
	 *
	 * greenValue = green(c);  // Get green in 'c'
	 * println(greenValue);  // Print "75.0"
	 * fill(0, greenValue, 0);  // Use 'greenValue' in new fill
	 * rect(50, 20, 35, 60);  // Draw right rectangle
	 * </code>
	 * </div>
	 */
	p5.prototype.green = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getGreen();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Extracts the hue value from a color or pixel array.
	 *
	 * Hue exists in both HSB and HSL. This function will return the
	 * HSB-normalized hue when supplied with an HSB color object (or when supplied
	 * with a pixel array while the color mode is HSB), but will default to the
	 * HSL-normalized hue otherwise. (The values will only be different if the
	 * maximum hue setting for each system is different.)
	 *
	 * @method hue
	 * @param {Object} color p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * colorMode(HSB, 255);
	 * c = color(0, 126, 255);
	 * fill(c);
	 * rect(15, 20, 35, 60);
	 * value = hue(c);  // Sets 'value' to "0"
	 * fill(value);
	 * rect(50, 20, 35, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.hue = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getHue();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Blends two colors to find a third color somewhere between them. The amt
	 * parameter is the amount to interpolate between the two values where 0.0
	 * equal to the first color, 0.1 is very near the first color, 0.5 is halfway
	 * in between, etc. An amount below 0 will be treated as 0. Likewise, amounts
	 * above 1 will be capped at 1. This is different from the behavior of lerp(),
	 * but necessary because otherwise numbers outside the range will produce
	 * strange and unexpected colors.
	 * <br><br>
	 * The way that colours are interpolated depends on the current color mode.
	 *
	 * @method lerpColor
	 * @param  {Array/Number} c1  interpolate from this color
	 * @param  {Array/Number} c2  interpolate to this color
	 * @param  {Number}       amt number between 0 and 1
	 * @return {Array/Number}     interpolated color
	 * @example
	 * <div>
	 * <code>
	 * colorMode(RGB);
	 * stroke(255);
	 * background(51);
	 * from = color(218, 165, 32);
	 * to = color(72, 61, 139);
	 * colorMode(RGB);  // Try changing to HSB.
	 * interA = lerpColor(from, to, .33);
	 * interB = lerpColor(from, to, .66);
	 * fill(from);
	 * rect(10, 20, 20, 60);
	 * fill(interA);
	 * rect(30, 20, 20, 60);
	 * fill(interB);
	 * rect(50, 20, 20, 60);
	 * fill(to);
	 * rect(70, 20, 20, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.lerpColor = function(c1, c2, amt) {
	  var mode = this._renderer._colorMode;
	  var maxes = this._renderer._colorMaxes;
	  var l0, l1, l2, l3;
	  var fromArray, toArray;
	
	  if (mode === constants.RGB) {
	    fromArray = c1.levels.map(function(level) {
	      return level / 255;
	    });
	    toArray = c2.levels.map(function(level) {
	      return level / 255;
	    });
	  } else if (mode === constants.HSB) {
	    c1._getBrightness();  // Cache hsba so it definitely exists.
	    c2._getBrightness();
	    fromArray = c1.hsba;
	    toArray = c2.hsba;
	  } else if (mode === constants.HSL) {
	    c1._getLightness();  // Cache hsla so it definitely exists.
	    c2._getLightness();
	    fromArray = c1.hsla;
	    toArray = c2.hsla;
	  } else {
	    throw new Error (mode + 'cannot be used for interpolation.');
	  }
	
	  // Prevent extrapolation.
	  amt = Math.max(Math.min(amt, 1), 0);
	
	  // Perform interpolation.
	  l0 = this.lerp(fromArray[0], toArray[0], amt);
	  l1 = this.lerp(fromArray[1], toArray[1], amt);
	  l2 = this.lerp(fromArray[2], toArray[2], amt);
	  l3 = this.lerp(fromArray[3], toArray[3], amt);
	
	  // Scale components.
	  l0 *= maxes[mode][0];
	  l1 *= maxes[mode][1];
	  l2 *= maxes[mode][2];
	  l3 *= maxes[mode][3];
	
	  return this.color(l0, l1, l2, l3);
	};
	
	/**
	 * Extracts the HSL lightness value from a color or pixel array.
	 *
	 * @method lightness
	 * @param {Object} color p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * colorMode(HSL);
	 * c = color(156, 100, 50, 1);
	 * fill(c);
	 * rect(15, 20, 35, 60);
	 * value = lightness(c);  // Sets 'value' to 50
	 * fill(value);
	 * rect(50, 20, 35, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.lightness = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getLightness();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Extracts the red value from a color or pixel array.
	 *
	 * @method red
	 * @param {Object} obj p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * c = color(255, 204, 0);  // Define color 'c'
	 * fill(c);  // Use color variable 'c' as fill color
	 * rect(15, 20, 35, 60);  // Draw left rectangle
	 *
	 * redValue = red(c);  // Get red in 'c'
	 * println(redValue);  // Print "255.0"
	 * fill(redValue, 0, 0);  // Use 'redValue' in new fill
	 * rect(50, 20, 35, 60);  // Draw right rectangle
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * colorMode(RGB, 255);
	 * var c = color(127, 255, 0);
	 * colorMode(RGB, 1);
	 * var myColor = red(c);
	 * print(myColor);
	 * </code>
	 * </div>
	 */
	p5.prototype.red = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getRed();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	/**
	 * Extracts the saturation value from a color or pixel array.
	 *
	 * Saturation is scaled differently in HSB and HSL. This function will return
	 * the HSB saturation when supplied with an HSB color object (or when supplied
	 * with a pixel array while the color mode is HSB), but will default to the
	 * HSL saturation otherwise.
	 *
	 * @method saturation
	 * @param {Object} color p5.Color object or pixel array
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * colorMode(HSB, 255);
	 * c = color(0, 126, 255);
	 * fill(c);
	 * rect(15, 20, 35, 60);
	 * value = saturation(c);  // Sets 'value' to 126
	 * fill(value);
	 * rect(50, 20, 35, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.saturation = function(c) {
	  if (c instanceof p5.Color || c instanceof Array) {
	    return this.color(c)._getSaturation();
	  } else {
	    throw new Error('Needs p5.Color or pixel array as argument.');
	  }
	};
	
	module.exports = p5;
	
	},{"../core/constants":47,"../core/core":48,"./p5.Color":42}],42:[function(_dereq_,module,exports){
	/**
	 * @module Color
	 * @submodule Creating & Reading
	 * @for p5
	 * @requires core
	 * @requires constants
	 * @requires color_conversion
	 */
	
	var p5 = _dereq_('../core/core');
	var constants = _dereq_('../core/constants');
	var color_conversion = _dereq_('./color_conversion');
	
	/**
	 * We define colors to be immutable objects. Each color stores the color mode
	 * and level maxes that applied at the time of its construction. These are
	 * used to interpret the input arguments and to format the output e.g. when
	 * saturation() is requested.
	 *
	 * Internally we store an array representing the ideal RGBA values in floating
	 * point form, normalized from 0 to 1. From this we calculate the closest
	 * screen color (RGBA levels from 0 to 255) and expose this to the renderer.
	 *
	 * We also cache normalized, floating point components of the color in various
	 * representations as they are calculated. This is done to prevent repeating a
	 * conversion that has already been performed.
	 *
	 * @class p5.Color
	 * @constructor
	 */
	p5.Color = function(pInst, vals) {
	
	  // Record color mode and maxes at time of construction.
	  this.mode = pInst._renderer._colorMode;
	  this.maxes = pInst._renderer._colorMaxes;
	
	  // Calculate normalized RGBA values.
	  if (this.mode !== constants.RGB &&
	      this.mode !== constants.HSL &&
	      this.mode !== constants.HSB) {
	    throw new Error(this.mode + ' is an invalid colorMode.');
	  } else {
	    this._array = p5.Color._parseInputs.apply(pInst, vals);
	  }
	
	  // Expose closest screen color.
	  this.levels = this._array.map(function(level) {
	    return Math.round(level * 255);
	  });
	
	  return this;
	};
	
	p5.Color.prototype.toString = function() {
	  var a = this.levels;
	  a[3] = this._array[3];  // String representation uses normalized alpha.
	  return 'rgba('+a[0]+','+a[1]+','+a[2]+','+ a[3] +')';
	};
	
	p5.Color.prototype._getAlpha = function() {
	  return this._array[3] * this.maxes[this.mode][3];
	};
	
	p5.Color.prototype._getBlue = function() {
	  return this._array[2] * this.maxes[constants.RGB][2];
	};
	
	p5.Color.prototype._getBrightness = function() {
	  if (!this.hsba) {
	    this.hsba = color_conversion._rgbaToHSBA(this._array);
	  }
	  return this.hsba[2] * this.maxes[constants.HSB][2];
	};
	
	p5.Color.prototype._getGreen = function() {
	  return this._array[1] * this.maxes[constants.RGB][1];
	};
	
	/**
	 * Hue is the same in HSB and HSL, but the maximum value may be different.
	 * This function will return the HSB-normalized saturation when supplied with
	 * an HSB color object, but will default to the HSL-normalized saturation
	 * otherwise.
	 */
	p5.Color.prototype._getHue = function() {
	  if (this.mode === constants.HSB) {
	    if (!this.hsba) {
	      this.hsba = color_conversion._rgbaToHSBA(this._array);
	    }
	    return this.hsba[0] * this.maxes[constants.HSB][0];
	  } else {
	    if (!this.hsla) {
	      this.hsla = color_conversion._rgbaToHSLA(this._array);
	    }
	    return this.hsla[0] * this.maxes[constants.HSL][0];
	  }
	};
	
	p5.Color.prototype._getLightness = function() {
	  if (!this.hsla) {
	    this.hsla = color_conversion._rgbaToHSLA(this._array);
	  }
	  return this.hsla[2] * this.maxes[constants.HSL][2];
	};
	
	p5.Color.prototype._getRed = function() {
	  return this._array[0] * this.maxes[constants.RGB][0];
	};
	
	/**
	 * Saturation is scaled differently in HSB and HSL. This function will return
	 * the HSB saturation when supplied with an HSB color object, but will default
	 * to the HSL saturation otherwise.
	 */
	p5.Color.prototype._getSaturation = function() {
	  if (this.mode === constants.HSB) {
	    if (!this.hsba) {
	      this.hsba = color_conversion._rgbaToHSBA(this._array);
	    }
	    return this.hsba[1] * this.maxes[constants.HSB][1];
	  } else {
	    if (!this.hsla) {
	      this.hsla = color_conversion._rgbaToHSLA(this._array);
	    }
	    return this.hsla[1] * this.maxes[constants.HSL][1];
	  }
	};
	
	/**
	 * CSS named colors.
	 */
	var namedColors = {
	  aliceblue:             '#f0f8ff',
	  antiquewhite:          '#faebd7',
	  aqua:                  '#00ffff',
	  aquamarine:            '#7fffd4',
	  azure:                 '#f0ffff',
	  beige:                 '#f5f5dc',
	  bisque:                '#ffe4c4',
	  black:                 '#000000',
	  blanchedalmond:        '#ffebcd',
	  blue:                  '#0000ff',
	  blueviolet:            '#8a2be2',
	  brown:                 '#a52a2a',
	  burlywood:             '#deb887',
	  cadetblue:             '#5f9ea0',
	  chartreuse:            '#7fff00',
	  chocolate:             '#d2691e',
	  coral:                 '#ff7f50',
	  cornflowerblue:        '#6495ed',
	  cornsilk:              '#fff8dc',
	  crimson:               '#dc143c',
	  cyan:                  '#00ffff',
	  darkblue:              '#00008b',
	  darkcyan:              '#008b8b',
	  darkgoldenrod:         '#b8860b',
	  darkgray:              '#a9a9a9',
	  darkgreen:             '#006400',
	  darkgrey:              '#a9a9a9',
	  darkkhaki:             '#bdb76b',
	  darkmagenta:           '#8b008b',
	  darkolivegreen:        '#556b2f',
	  darkorange:            '#ff8c00',
	  darkorchid:            '#9932cc',
	  darkred:               '#8b0000',
	  darksalmon:            '#e9967a',
	  darkseagreen:          '#8fbc8f',
	  darkslateblue:         '#483d8b',
	  darkslategray:         '#2f4f4f',
	  darkslategrey:         '#2f4f4f',
	  darkturquoise:         '#00ced1',
	  darkviolet:            '#9400d3',
	  deeppink:              '#ff1493',
	  deepskyblue:           '#00bfff',
	  dimgray:               '#696969',
	  dimgrey:               '#696969',
	  dodgerblue:            '#1e90ff',
	  firebrick:             '#b22222',
	  floralwhite:           '#fffaf0',
	  forestgreen:           '#228b22',
	  fuchsia:               '#ff00ff',
	  gainsboro:             '#dcdcdc',
	  ghostwhite:            '#f8f8ff',
	  gold:                  '#ffd700',
	  goldenrod:             '#daa520',
	  gray:                  '#808080',
	  green:                 '#008000',
	  greenyellow:           '#adff2f',
	  grey:                  '#808080',
	  honeydew:              '#f0fff0',
	  hotpink:               '#ff69b4',
	  indianred:             '#cd5c5c',
	  indigo:                '#4b0082',
	  ivory:                 '#fffff0',
	  khaki:                 '#f0e68c',
	  lavender:              '#e6e6fa',
	  lavenderblush:         '#fff0f5',
	  lawngreen:             '#7cfc00',
	  lemonchiffon:          '#fffacd',
	  lightblue:             '#add8e6',
	  lightcoral:            '#f08080',
	  lightcyan:             '#e0ffff',
	  lightgoldenrodyellow:  '#fafad2',
	  lightgray:             '#d3d3d3',
	  lightgreen:            '#90ee90',
	  lightgrey:             '#d3d3d3',
	  lightpink:             '#ffb6c1',
	  lightsalmon:           '#ffa07a',
	  lightseagreen:         '#20b2aa',
	  lightskyblue:          '#87cefa',
	  lightslategray:        '#778899',
	  lightslategrey:        '#778899',
	  lightsteelblue:        '#b0c4de',
	  lightyellow:           '#ffffe0',
	  lime:                  '#00ff00',
	  limegreen:             '#32cd32',
	  linen:                 '#faf0e6',
	  magenta:               '#ff00ff',
	  maroon:                '#800000',
	  mediumaquamarine:      '#66cdaa',
	  mediumblue:            '#0000cd',
	  mediumorchid:          '#ba55d3',
	  mediumpurple:          '#9370db',
	  mediumseagreen:        '#3cb371',
	  mediumslateblue:       '#7b68ee',
	  mediumspringgreen:     '#00fa9a',
	  mediumturquoise:       '#48d1cc',
	  mediumvioletred:       '#c71585',
	  midnightblue:          '#191970',
	  mintcream:             '#f5fffa',
	  mistyrose:             '#ffe4e1',
	  moccasin:              '#ffe4b5',
	  navajowhite:           '#ffdead',
	  navy:                  '#000080',
	  oldlace:               '#fdf5e6',
	  olive:                 '#808000',
	  olivedrab:             '#6b8e23',
	  orange:                '#ffa500',
	  orangered:             '#ff4500',
	  orchid:                '#da70d6',
	  palegoldenrod:         '#eee8aa',
	  palegreen:             '#98fb98',
	  paleturquoise:         '#afeeee',
	  palevioletred:         '#db7093',
	  papayawhip:            '#ffefd5',
	  peachpuff:             '#ffdab9',
	  peru:                  '#cd853f',
	  pink:                  '#ffc0cb',
	  plum:                  '#dda0dd',
	  powderblue:            '#b0e0e6',
	  purple:                '#800080',
	  red:                   '#ff0000',
	  rosybrown:             '#bc8f8f',
	  royalblue:             '#4169e1',
	  saddlebrown:           '#8b4513',
	  salmon:                '#fa8072',
	  sandybrown:            '#f4a460',
	  seagreen:              '#2e8b57',
	  seashell:              '#fff5ee',
	  sienna:                '#a0522d',
	  silver:                '#c0c0c0',
	  skyblue:               '#87ceeb',
	  slateblue:             '#6a5acd',
	  slategray:             '#708090',
	  slategrey:             '#708090',
	  snow:                  '#fffafa',
	  springgreen:           '#00ff7f',
	  steelblue:             '#4682b4',
	  tan:                   '#d2b48c',
	  teal:                  '#008080',
	  thistle:               '#d8bfd8',
	  tomato:                '#ff6347',
	  turquoise:             '#40e0d0',
	  violet:                '#ee82ee',
	  wheat:                 '#f5deb3',
	  white:                 '#ffffff',
	  whitesmoke:            '#f5f5f5',
	  yellow:                '#ffff00',
	  yellowgreen:           '#9acd32'
	};
	
	/**
	 * These regular expressions are used to build up the patterns for matching
	 * viable CSS color strings: fragmenting the regexes in this way increases the
	 * legibility and comprehensibility of the code.
	 *
	 * Note that RGB values of .9 are not parsed by IE, but are supported here for
	 * color string consistency.
	 */
	var WHITESPACE = /\s*/;  // Match zero or more whitespace characters.
	var INTEGER = /(\d{1,3})/;  // Match integers: 79, 255, etc.
	var DECIMAL = /((?:\d+(?:\.\d+)?)|(?:\.\d+))/;  // Match 129.6, 79, .9, etc.
	var PERCENT = new RegExp(DECIMAL.source + '%');  // Match 12.9%, 79%, .9%, etc.
	
	/**
	 * Full color string patterns. The capture groups are necessary.
	 */
	var colorPatterns = {
	  // Match colors in format #XXX, e.g. #416.
	  HEX3: /^#([a-f0-9])([a-f0-9])([a-f0-9])$/i,
	
	  // Match colors in format #XXXXXX, e.g. #b4d455.
	  HEX6: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
	
	  // Match colors in format rgb(R, G, B), e.g. rgb(255, 0, 128).
	  RGB: new RegExp([
	    '^rgb\\(',
	    INTEGER.source,
	    ',',
	    INTEGER.source,
	    ',',
	    INTEGER.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format rgb(R%, G%, B%), e.g. rgb(100%, 0%, 28.9%).
	  RGB_PERCENT: new RegExp([
	    '^rgb\\(',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format rgb(R, G, B, A), e.g. rgb(255, 0, 128, 0.25).
	  RGBA: new RegExp([
	    '^rgba\\(',
	    INTEGER.source,
	    ',',
	    INTEGER.source,
	    ',',
	    INTEGER.source,
	    ',',
	    DECIMAL.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format rgb(R%, G%, B%, A), e.g. rgb(100%, 0%, 28.9%, 0.5).
	  RGBA_PERCENT: new RegExp([
	    '^rgba\\(',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    ',',
	    DECIMAL.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format hsla(H, S%, L%), e.g. hsl(100, 40%, 28.9%).
	  HSL: new RegExp([
	    '^hsl\\(',
	    INTEGER.source,
	    ',',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format hsla(H, S%, L%, A), e.g. hsla(100, 40%, 28.9%, 0.5).
	  HSLA: new RegExp([
	    '^hsla\\(',
	    INTEGER.source,
	    ',',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    ',',
	    DECIMAL.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format hsb(H, S%, B%), e.g. hsb(100, 40%, 28.9%).
	  HSB: new RegExp([
	    '^hsb\\(',
	    INTEGER.source,
	    ',',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i'),
	
	  // Match colors in format hsba(H, S%, B%, A), e.g. hsba(100, 40%, 28.9%, 0.5).
	  HSBA: new RegExp([
	    '^hsba\\(',
	    INTEGER.source,
	    ',',
	    PERCENT.source,
	    ',',
	    PERCENT.source,
	    ',',
	    DECIMAL.source,
	    '\\)$'
	  ].join(WHITESPACE.source), 'i')
	};
	
	/**
	 * For a number of different inputs, returns a color formatted as [r, g, b, a]
	 * arrays, with each component normalized between 0 and 1.
	 *
	 * @param {Array-like} args An 'array-like' object that represents a list of
	 *                          arguments
	 * @return {Array}          a color formatted as [r, g, b, a]
	 *                          Example:
	 *                          input        ==> output
	 *                          g            ==> [g, g, g, 255]
	 *                          g,a          ==> [g, g, g, a]
	 *                          r, g, b      ==> [r, g, b, 255]
	 *                          r, g, b, a   ==> [r, g, b, a]
	 *                          [g]          ==> [g, g, g, 255]
	 *                          [g, a]       ==> [g, g, g, a]
	 *                          [r, g, b]    ==> [r, g, b, 255]
	 *                          [r, g, b, a] ==> [r, g, b, a]
	 * @example
	 * <div>
	 * <code>
	 * // todo
	 * </code>
	 * </div>
	 */
	p5.Color._parseInputs = function() {
	  var numArgs = arguments.length;
	  var mode = this._renderer._colorMode;
	  var maxes = this._renderer._colorMaxes;
	  var results = [];
	
	  if (numArgs >= 3) {  // Argument is a list of component values.
	
	    results[0] = arguments[0] / maxes[mode][0];
	    results[1] = arguments[1] / maxes[mode][1];
	    results[2] = arguments[2] / maxes[mode][2];
	
	    // Alpha may be undefined, so default it to 100%.
	    if (typeof arguments[3] === 'number') {
	      results[3] = arguments[3] / maxes[mode][3];
	    } else {
	      results[3] = 1;
	    }
	
	    // Constrain components to the range [0,1].
	    results = results.map(function(value) {
	      return Math.max(Math.min(value, 1), 0);
	    });
	
	    // Convert to RGBA and return.
	    if (mode === constants.HSL) {
	      return color_conversion._hslaToRGBA(results);
	    } else if (mode === constants.HSB) {
	      return color_conversion._hsbaToRGBA(results);
	    } else {
	      return results;
	    }
	
	  } else if (numArgs === 1 && typeof arguments[0] === 'string') {
	
	    var str = arguments[0].trim().toLowerCase();
	
	    // Return if string is a named colour.
	    if (namedColors[str]) {
	      return p5.Color._parseInputs.apply(this, [namedColors[str]]);
	    }
	
	    // Try RGBA pattern matching.
	    if (colorPatterns.HEX3.test(str)) {  // #rgb
	      results = colorPatterns.HEX3.exec(str).slice(1).map(function(color) {
	        return parseInt(color + color, 16) / 255;
	      });
	      results[3] = 1;
	      return results;
	    } else if (colorPatterns.HEX6.test(str)) {  // #rrggbb
	      results = colorPatterns.HEX6.exec(str).slice(1).map(function(color) {
	        return parseInt(color, 16) / 255;
	      });
	      results[3] = 1;
	      return results;
	    } else if (colorPatterns.RGB.test(str)) {  // rgb(R,G,B)
	      results = colorPatterns.RGB.exec(str).slice(1).map(function(color) {
	        return color / 255;
	      });
	      results[3] = 1;
	      return results;
	    } else if (colorPatterns.RGB_PERCENT.test(str)) {  // rgb(R%,G%,B%)
	      results = colorPatterns.RGB_PERCENT.exec(str).slice(1)
	        .map(function(color) {
	          return parseFloat(color) / 100;
	        });
	      results[3] = 1;
	      return results;
	    } else if (colorPatterns.RGBA.test(str)) {  // rgba(R,G,B,A)
	      results = colorPatterns.RGBA.exec(str).slice(1)
	        .map(function(color, idx) {
	          if (idx === 3) {
	            return parseFloat(color);
	          }
	          return color / 255;
	        });
	      return results;
	    } else if (colorPatterns.RGBA_PERCENT.test(str)) {  // rgba(R%,G%,B%,A%)
	      results = colorPatterns.RGBA_PERCENT.exec(str).slice(1)
	        .map(function(color, idx) {
	          if (idx === 3) {
	            return parseFloat(color);
	          }
	          return parseFloat(color) / 100;
	        });
	      return results;
	    }
	
	    // Try HSLA pattern matching.
	    if (colorPatterns.HSL.test(str)) {  // hsl(H,S,L)
	      results = colorPatterns.HSL.exec(str).slice(1)
	        .map(function(color, idx) {
	        if (idx === 0) {
	          return parseInt(color, 10) / 360;
	        }
	        return parseInt(color, 10) / 100;
	      });
	      results[3] = 1;
	    } else if (colorPatterns.HSLA.test(str)) {  // hsla(H,S,L,A)
	      results = colorPatterns.HSLA.exec(str).slice(1)
	        .map(function(color, idx) {
	        if (idx === 0) {
	          return parseInt(color, 10) / 360;
	        }
	        else if (idx === 3) {
	          return parseFloat(color);
	        }
	        return parseInt(color, 10) / 100;
	      });
	    }
	    if (results.length) {
	      return color_conversion._hslaToRGBA(results);
	    }
	
	    // Try HSBA pattern matching.
	    if (colorPatterns.HSB.test(str)) {  // hsb(H,S,B)
	      results = colorPatterns.HSB.exec(str).slice(1)
	        .map(function(color, idx) {
	        if (idx === 0) {
	          return parseInt(color, 10) / 360;
	        }
	        return parseInt(color, 10) / 100;
	      });
	      results[3] = 1;
	    } else if (colorPatterns.HSBA.test(str)) {  // hsba(H,S,B,A)
	      results = colorPatterns.HSBA.exec(str).slice(1)
	        .map(function(color, idx) {
	        if (idx === 0) {
	          return parseInt(color, 10) / 360;
	        }
	        else if (idx === 3) {
	          return parseFloat(color);
	        }
	        return parseInt(color, 10) / 100;
	      });
	    }
	    if (results.length) {
	      return color_conversion._hsbaToRGBA(results);
	    }
	
	    // Input did not match any CSS color pattern: default to white.
	    results = [1, 1, 1, 1];
	
	  } else if ((numArgs === 1 || numArgs === 2) &&
	              typeof arguments[0] === 'number') {  // 'Grayscale' mode.
	
	    /**
	     * For HSB and HSL, interpret the gray level as a brightness/lightness
	     * value (they are equivalent when chroma is zero). For RGB, normalize the
	     * gray level according to the blue maximum.
	     */
	    results[0] = arguments[0] / maxes[mode][2];
	    results[1] = arguments[0] / maxes[mode][2];
	    results[2] = arguments[0] / maxes[mode][2];
	
	    // Alpha may be undefined, so default it to 100%.
	    if (typeof arguments[1] === 'number') {
	      results[3] = arguments[1] / maxes[mode][3];
	    } else {
	      results[3] = 1;
	    }
	
	    // Constrain components to the range [0,1].
	    results = results.map(function(value) {
	      return Math.max(Math.min(value, 1), 0);
	    });
	
	  } else {
	    throw new Error (arguments + 'is not a valid color representation.');
	  }
	
	  return results;
	};
	
	module.exports = p5.Color;
	
	},{"../core/constants":47,"../core/core":48,"./color_conversion":40}],43:[function(_dereq_,module,exports){
	/**
	 * @module Color
	 * @submodule Setting
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var constants = _dereq_('../core/constants');
	_dereq_('./p5.Color');
	
	/**
	 * The background() function sets the color used for the background of the
	 * p5.js canvas. The default background is light gray. This function is
	 * typically used within draw() to clear the display window at the beginning
	 * of each frame, but it can be used inside setup() to set the background on
	 * the first frame of animation or if the background need only be set once.
	 *
	 * @method background
	 * @param {Number|String|p5.Color|p5.Image} v1   gray value, red or hue value
	 *                                               (depending on the current
	 *                                               color mode), color string,
	 *                                               p5.Color, or p5.Image
	 * @param {Number}                          [v2] green or saturation value
	 *                                               (depending on the current
	 *                                               color mode)
	 * @param {Number}                          [v3] blue or brightness value
	 *                                               (depending on the current
	 *                                               color mode)
	 * @param {Number}                          [a]  opacity of the background
	 *
	 * @example
	 * <div>
	 * <code>
	 * // Grayscale integer value
	 * background(51);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // R, G & B integer values
	 * background(255, 204, 0);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // H, S & B integer values
	 * colorMode(HSB);
	 * background(255, 204, 100);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // Named SVG/CSS color string
	 * background('red');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // three-digit hexadecimal RGB notation
	 * background('#fae');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // six-digit hexadecimal RGB notation
	 * background('#222222');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // integer RGB notation
	 * background('rgb(0,255,0)');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // integer RGBA notation
	 * background('rgba(0,255,0, 0.25)');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // percentage RGB notation
	 * background('rgb(100%,0%,10%)');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // percentage RGBA notation
	 * background('rgba(100%,0%,100%,0.5)');
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // p5 Color object
	 * background(color(0, 0, 255));
	 * </code>
	 * </div>
	 */
	p5.prototype.background = function() {
	  if (arguments[0] instanceof p5.Image) {
	    this.image(arguments[0], 0, 0, this.width, this.height);
	  } else {
	    this._renderer.background.apply(this._renderer, arguments);
	  }
	  return this;
	};
	
	/**
	 * Clears the pixels within a buffer. This function only works on p5.Canvas
	 * objects created with the createCanvas() function; it won't work with the
	 * main display window. Unlike the main graphics context, pixels in
	 * additional graphics areas created with createGraphics() can be entirely
	 * or partially transparent. This function clears everything to make all of
	 * the pixels 100% transparent.
	 *
	 * @method clear
	 * @example
	 * <div>
	 * <code>
	 * // Clear the screen on mouse press.
	 * function setup() {
	 *   createCanvas(100, 100);
	 * }
	 *
	 * function draw() {
	 *   ellipse(mouseX, mouseY, 20, 20);
	 * }
	 *
	 * function mousePressed() {
	 *   clear();
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.clear = function() {
	  this._renderer.clear();
	  return this;
	};
	
	/**
	 * colorMode() changes the way p5.js interprets color data. By default, the
	 * parameters for fill(), stroke(), background(), and color() are defined by
	 * values between 0 and 255 using the RGB color model. This is equivalent to
	 * setting colorMode(RGB, 255). Setting colorMode(HSB) lets you use the HSB
	 * system instead. By default, this is colorMode(HSB, 360, 100, 100, 1). You
	 * can also use HSL.
	 * <br><br>
	 * Note: existing color objects remember the mode that they were created in,
	 * so you can change modes as you like without affecting their appearance.
	 *
	 * @method colorMode
	 * @param {Number|Constant} mode   either RGB or HSB, corresponding to
	 *                                 Red/Green/Blue and Hue/Saturation/Brightness
	 *                                 (or Lightness)
	 * @param {Number|Constant} [max1] range for the red or hue depending on the
	 *                                 current color mode, or range for all values
	 * @param {Number|Constant} [max2] range for the green or saturation depending
	 *                                 on the current color mode
	 * @param {Number|Constant} [max3] range for the blue or brightness/lighntess
	 *                                 depending on the current color mode
	 * @param {Number|Constant} [maxA] range for the alpha
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * colorMode(RGB, 100);
	 * for (i = 0; i < 100; i++) {
	 *   for (j = 0; j < 100; j++) {
	 *     stroke(i, j, 0);
	 *     point(i, j);
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noStroke();
	 * colorMode(HSB, 100);
	 * for (i = 0; i < 100; i++) {
	 *   for (j = 0; j < 100; j++) {
	 *     stroke(i, j, 100);
	 *     point(i, j);
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * colorMode(RGB, 255);
	 * var c = color(127, 255, 0);
	 *
	 * colorMode(RGB, 1);
	 * var myColor = c._getRed();
	 * text(myColor, 10, 10, 80, 80);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * colorMode(RGB, 255, 255, 255, 1);
	 * background(255);
	 *
	 * strokeWeight(4);
	 * stroke(255, 0 , 10, 0.3);
	 * ellipse(40, 40, 50, 50);
	 * ellipse(50, 50, 40, 40);
	 * </code>
	 * </div>
	 */
	p5.prototype.colorMode = function() {
	  if (arguments[0] === constants.RGB ||
	      arguments[0] === constants.HSB ||
	      arguments[0] === constants.HSL) {
	
	    // Set color mode.
	    this._renderer._colorMode = arguments[0];
	
	    // Set color maxes.
	    var maxes = this._renderer._colorMaxes[this._renderer._colorMode];
	    if (arguments.length === 2) {
	      maxes[0] = arguments[1];  // Red
	      maxes[1] = arguments[1];  // Green
	      maxes[2] = arguments[1];  // Blue
	      maxes[3] = arguments[1];  // Alpha
	    } else if (arguments.length === 4) {
	      maxes[0] = arguments[1];  // Red
	      maxes[1] = arguments[2];  // Green
	      maxes[2] = arguments[3];  // Blue
	    } else if (arguments.length === 5) {
	      maxes[0] = arguments[1];  // Red
	      maxes[1] = arguments[2];  // Green
	      maxes[2] = arguments[3];  // Blue
	      maxes[3] = arguments[4];  // Alpha
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Sets the color used to fill shapes. For example, if you run
	 * fill(204, 102, 0), all subsequent shapes will be filled with orange. This
	 * color is either specified in terms of the RGB or HSB color depending on
	 * the current colorMode(). (The default color space is RGB, with each value
	 * in the range from 0 to 255).
	 * <br><br>
	 * If a single string argument is provided, RGB, RGBA and Hex CSS color strings
	 * and all named color strings are supported. A p5 Color object can also be
	 * provided to set the fill color.
	 *
	 * @method fill
	 * @param {Number|Array|String|p5.Color} v1   gray value, red or hue value
	 *                                            (depending on the current color
	 *                                            mode), or color Array, or CSS
	 *                                            color string
	 * @param {Number}                       [v2] green or saturation value
	 *                                            (depending on the current
	 *                                            color mode)
	 * @param {Number}                       [v3] blue or brightness value
	 *                                            (depending on the current
	 *                                            color mode)
	 * @param {Number}                       [a]  opacity of the background
	 *
	 * @example
	 * <div>
	 * <code>
	 * // Grayscale integer value
	 * fill(51);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // R, G & B integer values
	 * fill(255, 204, 0);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // H, S & B integer values
	 * colorMode(HSB);
	 * fill(255, 204, 100);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // Named SVG/CSS color string
	 * fill('red');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // three-digit hexadecimal RGB notation
	 * fill('#fae');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // six-digit hexadecimal RGB notation
	 * fill('#222222');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // integer RGB notation
	 * fill('rgb(0,255,0)');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // integer RGBA notation
	 * fill('rgba(0,255,0, 0.25)');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // percentage RGB notation
	 * fill('rgb(100%,0%,10%)');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // percentage RGBA notation
	 * fill('rgba(100%,0%,100%,0.5)');
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // p5 Color object
	 * fill(color(0, 0, 255));
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.fill = function() {
	  this._renderer._setProperty('_fillSet', true);
	  this._renderer._setProperty('_doFill', true);
	  this._renderer.fill.apply(this._renderer, arguments);
	  return this;
	};
	
	/**
	 * Disables filling geometry. If both noStroke() and noFill() are called,
	 * nothing will be drawn to the screen.
	 *
	 * @method noFill
	 * @example
	 * <div>
	 * <code>
	 * rect(15, 10, 55, 55);
	 * noFill();
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.noFill = function() {
	  this._renderer._setProperty('_doFill', false);
	  return this;
	};
	
	/**
	 * Disables drawing the stroke (outline). If both noStroke() and noFill()
	 * are called, nothing will be drawn to the screen.
	 *
	 * @method noStroke
	 * @example
	 * <div>
	 * <code>
	 * noStroke();
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.noStroke = function() {
	  this._renderer._setProperty('_doStroke', false);
	  return this;
	};
	
	/**
	 * Sets the color used to draw lines and borders around shapes. This color
	 * is either specified in terms of the RGB or HSB color depending on the
	 * current colorMode() (the default color space is RGB, with each value in
	 * the range from 0 to 255).
	 * <br><br>
	 * If a single string argument is provided, RGB, RGBA and Hex CSS color
	 * strings and all named color strings are supported. A p5 Color object
	 * can also be provided to set the stroke color.
	 *
	 * @method stroke
	 * @param {Number|Array|String|p5.Color} v1   gray value, red or hue value
	 *                                            (depending on the current color
	 *                                            mode), or color Array, or CSS
	 *                                            color string
	 * @param {Number}                       [v2] green or saturation value
	 *                                            (depending on the current
	 *                                            color mode)
	 * @param {Number}                       [v3] blue or brightness value
	 *                                            (depending on the current
	 *                                            color mode)
	 * @param {Number}                       [a]  opacity of the background
	 *
	 * @example
	 * <div>
	 * <code>
	 * // Grayscale integer value
	 * strokeWeight(4);
	 * stroke(51);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // R, G & B integer values
	 * stroke(255, 204, 0);
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // H, S & B integer values
	 * colorMode(HSB);
	 * strokeWeight(4);
	 * stroke(255, 204, 100);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // Named SVG/CSS color string
	 * stroke('red');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // three-digit hexadecimal RGB notation
	 * stroke('#fae');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // six-digit hexadecimal RGB notation
	 * stroke('#222222');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // integer RGB notation
	 * stroke('rgb(0,255,0)');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // integer RGBA notation
	 * stroke('rgba(0,255,0,0.25)');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // percentage RGB notation
	 * stroke('rgb(100%,0%,10%)');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // percentage RGBA notation
	 * stroke('rgba(100%,0%,100%,0.5)');
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // p5 Color object
	 * stroke(color(0, 0, 255));
	 * strokeWeight(4);
	 * rect(20, 20, 60, 60);
	 * </code>
	 * </div>
	 */
	p5.prototype.stroke = function() {
	  this._renderer._setProperty('_strokeSet', true);
	  this._renderer._setProperty('_doStroke', true);
	  this._renderer.stroke.apply(this._renderer, arguments);
	  return this;
	};
	
	module.exports = p5;
	
	},{"../core/constants":47,"../core/core":48,"./p5.Color":42}],44:[function(_dereq_,module,exports){
	/**
	 * @module Shape
	 * @submodule 2D Primitives
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('./constants');
	
	_dereq_('./error_helpers');
	
	/**
	 * Draw an arc to the screen. If called with only a, b, c, d, start, and
	 * stop, the arc will be drawn as an open pie. If mode is provided, the arc
	 * will be drawn either open, as a chord, or as a pie as specified. The
	 * origin may be changed with the ellipseMode() function.<br><br>
	 * Note that drawing a full circle (ex: 0 to TWO_PI) will appear blank
	 * because 0 and TWO_PI are the same position on the unit circle. The
	 * best way to handle this is by using the ellipse() function instead
	 * to create a closed ellipse, and to use the arc() function
	 * only to draw parts of an ellipse.
	 *
	 * @method arc
	 * @param  {Number} a      x-coordinate of the arc's ellipse
	 * @param  {Number} b      y-coordinate of the arc's ellipse
	 * @param  {Number} c      width of the arc's ellipse by default
	 * @param  {Number} d      height of the arc's ellipse by default
	 * @param  {Number} start  angle to start the arc, specified in radians
	 * @param  {Number} stop   angle to stop the arc, specified in radians
	 * @param  {String} [mode] optional parameter to determine the way of drawing
	 *                         the arc
	 * @return {Object}        the p5 object
	 * @example
	 * <div>
	 * <code>
	 * arc(50, 55, 50, 50, 0, HALF_PI);
	 * noFill();
	 * arc(50, 55, 60, 60, HALF_PI, PI);
	 * arc(50, 55, 70, 70, PI, PI+QUARTER_PI);
	 * arc(50, 55, 80, 80, PI+QUARTER_PI, TWO_PI);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * arc(50, 50, 80, 80, 0, PI+QUARTER_PI, OPEN);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * arc(50, 50, 80, 80, 0, PI+QUARTER_PI, CHORD);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * arc(50, 50, 80, 80, 0, PI+QUARTER_PI, PIE);
	 * </code>
	 * </div>
	 */
	p5.prototype.arc = function(x, y, w, h, start, stop, mode) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'arc',
	    args,
	    [
	      ['Number', 'Number', 'Number', 'Number', 'Number', 'Number'],
	      [ 'Number', 'Number', 'Number', 'Number',
	        'Number', 'Number', 'String' ]
	    ]
	  );
	
	  if (!this._renderer._doStroke && !this._renderer._doFill) {
	    return this;
	  }
	  if (this._angleMode === constants.DEGREES) {
	    start = this.radians(start);
	    stop = this.radians(stop);
	  }
	
	  // Make all angles positive...
	  while (start < 0) {
	    start += constants.TWO_PI;
	  }
	  while (stop < 0) {
	    stop += constants.TWO_PI;
	  }
	  // ...and confine them to the interval [0,TWO_PI).
	  start %= constants.TWO_PI;
	  stop %= constants.TWO_PI;
	
	  // Adjust angles to counter linear scaling.
	  if (start <= constants.HALF_PI) {
	    start = Math.atan(w / h * Math.tan(start));
	  } else  if (start > constants.HALF_PI && start <= 3 * constants.HALF_PI) {
	    start = Math.atan(w / h * Math.tan(start)) + constants.PI;
	  } else {
	    start = Math.atan(w / h * Math.tan(start)) + constants.TWO_PI;
	  }
	  if (stop <= constants.HALF_PI) {
	    stop = Math.atan(w / h * Math.tan(stop));
	  } else  if (stop > constants.HALF_PI && stop <= 3 * constants.HALF_PI) {
	    stop = Math.atan(w / h * Math.tan(stop)) + constants.PI;
	  } else {
	    stop = Math.atan(w / h * Math.tan(stop)) + constants.TWO_PI;
	  }
	
	  // Exceed the interval if necessary in order to preserve the size and
	  // orientation of the arc.
	  if (start > stop) {
	    stop += constants.TWO_PI;
	  }
	  // p5 supports negative width and heights for ellipses
	  w = Math.abs(w);
	  h = Math.abs(h);
	  this._renderer.arc(x, y, w, h, start, stop, mode);
	  return this;
	};
	
	/**
	 * Draws an ellipse (oval) to the screen. An ellipse with equal width and
	 * height is a circle. By default, the first two parameters set the location,
	 * and the third and fourth parameters set the shape's width and height. The
	 * origin may be changed with the ellipseMode() function.
	 *
	 * @method ellipse
	 * @param  {Number} a x-coordinate of the ellipse.
	 * @param  {Number} b y-coordinate of the ellipse.
	 * @param  {Number} c width of the ellipse.
	 * @param  {Number} d height of the ellipse.
	 * @return {p5}       the p5 object
	 * @example
	 * <div>
	 * <code>
	 * ellipse(56, 46, 55, 55);
	 * </code>
	 * </div>
	 */
	p5.prototype.ellipse = function(x, y, w, h) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'ellipse',
	    args,
	    ['Number', 'Number', 'Number', 'Number']
	  );
	
	  if (!this._renderer._doStroke && !this._renderer._doFill) {
	    return this;
	  }
	  // p5 supports negative width and heights for ellipses
	  w = Math.abs(w);
	  h = Math.abs(h);
	  //@TODO add catch block here if this._renderer
	  //doesn't have the method implemented yet
	  this._renderer.ellipse(x, y, w, h);
	  return this;
	};
	/**
	 * Draws a line (a direct path between two points) to the screen. The version
	 * of line() with four parameters draws the line in 2D. To color a line, use
	 * the stroke() function. A line cannot be filled, therefore the fill()
	 * function will not affect the color of a line. 2D lines are drawn with a
	 * width of one pixel by default, but this can be changed with the
	 * strokeWeight() function.
	 *
	 * @method line
	 * @param  {Number} x1 the x-coordinate of the first point
	 * @param  {Number} y1 the y-coordinate of the first point
	 * @param  {Number} x2 the x-coordinate of the second point
	 * @param  {Number} y2 the y-coordinate of the second point
	 * @return {p5}        the p5 object
	 * @example
	 * <div>
	 * <code>
	 * line(30, 20, 85, 75);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * line(30, 20, 85, 20);
	 * stroke(126);
	 * line(85, 20, 85, 75);
	 * stroke(255);
	 * line(85, 75, 30, 75);
	 * </code>
	 * </div>
	 */
	////commented out original
	// p5.prototype.line = function(x1, y1, x2, y2) {
	//   if (!this._renderer._doStroke) {
	//     return this;
	//   }
	//   if(this._renderer.isP3D){
	//   } else {
	//     this._renderer.line(x1, y1, x2, y2);
	//   }
	// };
	p5.prototype.line = function() {
	  if (!this._renderer._doStroke) {
	    return this;
	  }
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  //check whether we should draw a 3d line or 2d
	  if(this._renderer.isP3D){
	    this._validateParameters(
	      'line',
	      args,
	      [
	        ['Number', 'Number', 'Number', 'Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.line(
	      args[0],
	      args[1],
	      args[2],
	      args[3],
	      args[4],
	      args[5]);
	  } else {
	    this._validateParameters(
	      'line',
	      args,
	      [
	        ['Number', 'Number', 'Number', 'Number'],
	      ]
	    );
	    this._renderer.line(
	      args[0],
	      args[1],
	      args[2],
	      args[3]);
	  }
	  return this;
	};
	
	/**
	 * Draws a point, a coordinate in space at the dimension of one pixel.
	 * The first parameter is the horizontal value for the point, the second
	 * value is the vertical value for the point. The color of the point is
	 * determined by the current stroke.
	 *
	 * @method point
	 * @param  {Number} x the x-coordinate
	 * @param  {Number} y the y-coordinate
	 * @return {p5}       the p5 object
	 * @example
	 * <div>
	 * <code>
	 * point(30, 20);
	 * point(85, 20);
	 * point(85, 75);
	 * point(30, 75);
	 * </code>
	 * </div>
	 */
	p5.prototype.point = function() {
	  if (!this._renderer._doStroke) {
	    return this;
	  }
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  //check whether we should draw a 3d line or 2d
	  if(this._renderer.isP3D){
	    this._validateParameters(
	      'point',
	      args,
	      [
	        ['Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.point(
	      args[0],
	      args[1],
	      args[2]
	      );
	  } else {
	    this._validateParameters(
	      'point',
	      args,
	      [
	        ['Number', 'Number']
	      ]
	    );
	    this._renderer.point(
	      args[0],
	      args[1]
	    );
	  }
	  return this;
	};
	
	
	/**
	 * Draw a quad. A quad is a quadrilateral, a four sided polygon. It is
	 * similar to a rectangle, but the angles between its edges are not
	 * constrained to ninety degrees. The first pair of parameters (x1,y1)
	 * sets the first vertex and the subsequent pairs should proceed
	 * clockwise or counter-clockwise around the defined shape.
	 *
	 * @method quad
	 * @param {type} x1 the x-coordinate of the first point
	 * @param {type} y1 the y-coordinate of the first point
	 * @param {type} x2 the x-coordinate of the second point
	 * @param {type} y2 the y-coordinate of the second point
	 * @param {type} x3 the x-coordinate of the third point
	 * @param {type} y3 the y-coordinate of the third point
	 * @param {type} x4 the x-coordinate of the fourth point
	 * @param {type} y4 the y-coordinate of the fourth point
	 * @return {p5}     the p5 object
	 * @example
	 * <div>
	 * <code>
	 * quad(38, 31, 86, 20, 69, 63, 30, 76);
	 * </code>
	 * </div>
	 */
	p5.prototype.quad = function() {
	  if (!this._renderer._doStroke && !this._renderer._doFill) {
	    return this;
	  }
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  if(this._renderer.isP3D){
	    this._validateParameters(
	      'quad',
	      args,
	      [
	        [ 'Number', 'Number', 'Number',
	          'Number', 'Number', 'Number',
	          'Number', 'Number', 'Number',
	          'Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.quad(
	      args[0],
	      args[1],
	      args[2],
	      args[3],
	      args[4],
	      args[5],
	      args[6],
	      args[7],
	      args[8],
	      args[9],
	      args[10],
	      args[11]
	      );
	  } else {
	    this._validateParameters(
	      'quad',
	      args,
	      [
	        [ 'Number', 'Number', 'Number', 'Number',
	          'Number', 'Number', 'Number', 'Number' ]
	      ]
	    );
	    this._renderer.quad(
	     args[0],
	     args[1],
	     args[2],
	     args[3],
	     args[4],
	     args[5],
	     args[6],
	    args[7]
	    );
	  }
	  return this;
	};
	
	/**
	* Draws a rectangle to the screen. A rectangle is a four-sided shape with
	* every angle at ninety degrees. By default, the first two parameters set
	* the location of the upper-left corner, the third sets the width, and the
	* fourth sets the height. The way these parameters are interpreted, however,
	* may be changed with the rectMode() function.
	* <br><br>
	* The fifth, sixth, seventh and eighth parameters, if specified,
	* determine corner radius for the top-right, top-left, lower-right and
	* lower-left corners, respectively. An omitted corner radius parameter is set
	* to the value of the previously specified radius value in the parameter list.
	*
	* @method rect
	* @param  {Number} x  x-coordinate of the rectangle.
	* @param  {Number} y  y-coordinate of the rectangle.
	* @param  {Number} w  width of the rectangle.
	* @param  {Number} h  height of the rectangle.
	* @param  {Number} [tl] optional radius of top-left corner.
	* @param  {Number} [tr] optional radius of top-right corner.
	* @param  {Number} [br] optional radius of bottom-right corner.
	* @param  {Number} [bl] optional radius of bottom-left corner.
	* @return {p5}          the p5 object.
	* @example
	* <div>
	* <code>
	* // Draw a rectangle at location (30, 20) with a width and height of 55.
	* rect(30, 20, 55, 55);
	* </code>
	* </div>
	*
	* <div>
	* <code>
	* // Draw a rectangle with rounded corners, each having a radius of 20.
	* rect(30, 20, 55, 55, 20);
	* </code>
	* </div>
	*
	* <div>
	* <code>
	* // Draw a rectangle with rounded corners having the following radii:
	* // top-left = 20, top-right = 15, bottom-right = 10, bottom-left = 5.
	* rect(30, 20, 55, 55, 20, 15, 10, 5)
	* </code>
	* </div>
	*/
	p5.prototype.rect = function (x, y, w, h, tl, tr, br, bl) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'rect',
	    args,
	    [
	      ['Number', 'Number', 'Number', 'Number'],
	      ['Number', 'Number', 'Number', 'Number', 'Number'],
	      ['Number', 'Number', 'Number', 'Number',
	       'Number', 'Number', 'Number', 'Number']
	    ]
	  );
	
	  if (!this._renderer._doStroke && !this._renderer._doFill) {
	    return;
	  }
	  this._renderer.rect(x, y, w, h, tl, tr, br, bl);
	  return this;
	};
	
	/**
	* A triangle is a plane created by connecting three points. The first two
	* arguments specify the first point, the middle two arguments specify the
	* second point, and the last two arguments specify the third point.
	*
	* @method triangle
	* @param  {Number} x1 x-coordinate of the first point
	* @param  {Number} y1 y-coordinate of the first point
	* @param  {Number} x2 x-coordinate of the second point
	* @param  {Number} y2 y-coordinate of the second point
	* @param  {Number} x3 x-coordinate of the third point
	* @param  {Number} y3 y-coordinate of the third point
	* @return {p5}        the p5 object
	* @example
	* <div>
	* <code>
	* triangle(30, 75, 58, 20, 86, 75);
	* </code>
	* </div>
	*/
	p5.prototype.triangle = function() {
	
	  if (!this._renderer._doStroke && !this._renderer._doFill) {
	    return this;
	  }
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  if(this._renderer.isP3D){
	    this._validateParameters(
	      'triangle',
	      args,
	      [
	        ['Number', 'Number', 'Number', 'Number', 'Number', 'Number',
	         'Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.triangle(
	      args[0],
	      args[1],
	      args[2],
	      args[3],
	      args[4],
	      args[5],
	      args[6],
	      args[7],
	      args[8]
	      );
	  } else {
	    this._validateParameters(
	      'triangle',
	      args,
	      [
	        ['Number', 'Number', 'Number', 'Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.triangle(
	     args[0],
	     args[1],
	     args[2],
	     args[3],
	     args[4],
	     args[5]
	    );
	  }
	  return this;
	};
	
	module.exports = p5;
	
	},{"./constants":47,"./core":48,"./error_helpers":51}],45:[function(_dereq_,module,exports){
	/**
	 * @module Shape
	 * @submodule Attributes
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('./constants');
	
	/**
	 * Modifies the location from which ellipses are drawn by changing the way
	 * in which parameters given to ellipse() are interpreted.
	 * <br><br>
	 * The default mode is ellipseMode(CENTER), which interprets the first two
	 * parameters of ellipse() as the shape's center point, while the third and
	 * fourth parameters are its width and height.
	 * <br><br>
	 * ellipseMode(RADIUS) also uses the first two parameters of ellipse() as
	 * the shape's center point, but uses the third and fourth parameters to
	 * specify half of the shapes's width and height.
	 * <br><br>
	 * ellipseMode(CORNER) interprets the first two parameters of ellipse() as
	 * the upper-left corner of the shape, while the third and fourth parameters
	 * are its width and height.
	 * <br><br>
	 * ellipseMode(CORNERS) interprets the first two parameters of ellipse() as
	 * the location of one corner of the ellipse's bounding box, and the third
	 * and fourth parameters as the location of the opposite corner.
	 * <br><br>
	 * The parameter must be written in ALL CAPS because Javascript is a
	 * case-sensitive language.
	 *
	 * @method ellipseMode
	 * @param  {Number/Constant} mode either CENTER, RADIUS, CORNER, or CORNERS
	 * @return {p5}                   the p5 object
	 * @example
	 * <div>
	 * <code>
	 * ellipseMode(RADIUS);  // Set ellipseMode to RADIUS
	 * fill(255);  // Set fill to white
	 * ellipse(50, 50, 30, 30);  // Draw white ellipse using RADIUS mode
	 *
	 * ellipseMode(CENTER);  // Set ellipseMode to CENTER
	 * fill(100);  // Set fill to gray
	 * ellipse(50, 50, 30, 30);  // Draw gray ellipse using CENTER mode
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * ellipseMode(CORNER);  // Set ellipseMode is CORNER
	 * fill(255);  // Set fill to white
	 * ellipse(25, 25, 50, 50);  // Draw white ellipse using CORNER mode
	 *
	 * ellipseMode(CORNERS);  // Set ellipseMode to CORNERS
	 * fill(100);  // Set fill to gray
	 * ellipse(25, 25, 50, 50);  // Draw gray ellipse using CORNERS mode
	 * </code>
	 * </div>
	 */
	p5.prototype.ellipseMode = function(m) {
	  if (m === constants.CORNER ||
	    m === constants.CORNERS ||
	    m === constants.RADIUS ||
	    m === constants.CENTER) {
	    this._renderer._ellipseMode = m;
	  }
	  return this;
	};
	
	/**
	 * Draws all geometry with jagged (aliased) edges. Note that smooth() is
	 * active by default, so it is necessary to call noSmooth() to disable
	 * smoothing of geometry, images, and fonts.
	 *
	 * @method noSmooth
	 * @return {p5} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * background(0);
	 * noStroke();
	 * smooth();
	 * ellipse(30, 48, 36, 36);
	 * noSmooth();
	 * ellipse(70, 48, 36, 36);
	 * </code>
	 * </div>
	 */
	p5.prototype.noSmooth = function() {
	  this._renderer.noSmooth();
	  return this;
	};
	
	/**
	 * Modifies the location from which rectangles are drawn by changing the way
	 * in which parameters given to rect() are interpreted.
	 * <br><br>
	 * The default mode is rectMode(CORNER), which interprets the first two
	 * parameters of rect() as the upper-left corner of the shape, while the
	 * third and fourth parameters are its width and height.
	 * <br><br>
	 * rectMode(CORNERS) interprets the first two parameters of rect() as the
	 * location of one corner, and the third and fourth parameters as the
	 * location of the opposite corner.
	 * <br><br>
	 * rectMode(CENTER) interprets the first two parameters of rect() as the
	 * shape's center point, while the third and fourth parameters are its
	 * width and height.
	 * <br><br>
	 * rectMode(RADIUS) also uses the first two parameters of rect() as the
	 * shape's center point, but uses the third and fourth parameters to specify
	 * half of the shapes's width and height.
	 * <br><br>
	 * The parameter must be written in ALL CAPS because Javascript is a
	 * case-sensitive language.
	 *
	 * @method rectMode
	 * @param  {Number/Constant} mode either CORNER, CORNERS, CENTER, or RADIUS
	 * @return {p5}                   the p5 object
	 * @example
	 * <div>
	 * <code>
	 * rectMode(CORNER);  // Default rectMode is CORNER
	 * fill(255);  // Set fill to white
	 * rect(25, 25, 50, 50);  // Draw white rect using CORNER mode
	 *
	 * rectMode(CORNERS);  // Set rectMode to CORNERS
	 * fill(100);  // Set fill to gray
	 * rect(25, 25, 50, 50);  // Draw gray rect using CORNERS mode
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * rectMode(RADIUS);  // Set rectMode to RADIUS
	 * fill(255);  // Set fill to white
	 * rect(50, 50, 30, 30);  // Draw white rect using RADIUS mode
	 *
	 * rectMode(CENTER);  // Set rectMode to CENTER
	 * fill(100);  // Set fill to gray
	 * rect(50, 50, 30, 30);  // Draw gray rect using CENTER mode
	 * </code>
	 * </div>
	 */
	p5.prototype.rectMode = function(m) {
	  if (m === constants.CORNER ||
	    m === constants.CORNERS ||
	    m === constants.RADIUS ||
	    m === constants.CENTER) {
	    this._renderer._rectMode = m;
	  }
	  return this;
	};
	
	/**
	 * Draws all geometry with smooth (anti-aliased) edges. smooth() will also
	 * improve image quality of resized images. Note that smooth() is active by
	 * default; noSmooth() can be used to disable smoothing of geometry,
	 * images, and fonts.
	 *
	 * @method smooth
	 * @return {p5} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * background(0);
	 * noStroke();
	 * smooth();
	 * ellipse(30, 48, 36, 36);
	 * noSmooth();
	 * ellipse(70, 48, 36, 36);
	 * </code>
	 * </div>
	 */
	p5.prototype.smooth = function() {
	  this._renderer.smooth();
	  return this;
	};
	
	/**
	 * Sets the style for rendering line endings. These ends are either squared,
	 * extended, or rounded, each of which specified with the corresponding
	 * parameters: SQUARE, PROJECT, and ROUND. The default cap is ROUND.
	 *
	 * @method strokeCap
	 * @param  {Number/Constant} cap either SQUARE, PROJECT, or ROUND
	 * @return {p5}                  the p5 object
	 * @example
	 * <div>
	 * <code>
	 * strokeWeight(12.0);
	 * strokeCap(ROUND);
	 * line(20, 30, 80, 30);
	 * strokeCap(SQUARE);
	 * line(20, 50, 80, 50);
	 * strokeCap(PROJECT);
	 * line(20, 70, 80, 70);
	 * </code>
	 * </div>
	 */
	p5.prototype.strokeCap = function(cap) {
	  if (cap === constants.ROUND ||
	    cap === constants.SQUARE ||
	    cap === constants.PROJECT) {
	    this._renderer.strokeCap(cap);
	  }
	  return this;
	};
	
	/**
	 * Sets the style of the joints which connect line segments. These joints
	 * are either mitered, beveled, or rounded and specified with the
	 * corresponding parameters MITER, BEVEL, and ROUND. The default joint is
	 * MITER.
	 *
	 * @method strokeJoin
	 * @param  {Number/Constant} join either MITER, BEVEL, ROUND
	 * @return {p5}                   the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * strokeWeight(10.0);
	 * strokeJoin(MITER);
	 * beginShape();
	 * vertex(35, 20);
	 * vertex(65, 50);
	 * vertex(35, 80);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * strokeWeight(10.0);
	 * strokeJoin(BEVEL);
	 * beginShape();
	 * vertex(35, 20);
	 * vertex(65, 50);
	 * vertex(35, 80);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * strokeWeight(10.0);
	 * strokeJoin(ROUND);
	 * beginShape();
	 * vertex(35, 20);
	 * vertex(65, 50);
	 * vertex(35, 80);
	 * endShape();
	 * </code>
	 * </div>
	 */
	p5.prototype.strokeJoin = function(join) {
	  if (join === constants.ROUND ||
	    join === constants.BEVEL ||
	    join === constants.MITER) {
	    this._renderer.strokeJoin(join);
	  }
	  return this;
	};
	
	/**
	 * Sets the width of the stroke used for lines, points, and the border
	 * around shapes. All widths are set in units of pixels.
	 *
	 * @method strokeWeight
	 * @param  {Number} weight the weight (in pixels) of the stroke
	 * @return {p5}            the p5 object
	 * @example
	 * <div>
	 * <code>
	 * strokeWeight(1);  // Default
	 * line(20, 20, 80, 20);
	 * strokeWeight(4);  // Thicker
	 * line(20, 40, 80, 40);
	 * strokeWeight(10);  // Beastly
	 * line(20, 70, 80, 70);
	 * </code>
	 * </div>
	 */
	p5.prototype.strokeWeight = function(w) {
	  this._renderer.strokeWeight(w);
	  return this;
	};
	
	module.exports = p5;
	
	},{"./constants":47,"./core":48}],46:[function(_dereq_,module,exports){
	/**
	 * @requires constants
	 */
	
	var constants = _dereq_('./constants');
	
	module.exports = {
	
	  modeAdjust: function(a, b, c, d, mode) {
	    if (mode === constants.CORNER) {
	      return { x: a, y: b, w: c, h: d };
	    } else if (mode === constants.CORNERS) {
	      return { x: a, y: b, w: c-a, h: d-b };
	    } else if (mode === constants.RADIUS) {
	      return { x: a-c, y: b-d, w: 2*c, h: 2*d };
	    } else if (mode === constants.CENTER) {
	      return { x: a-c*0.5, y: b-d*0.5, w: c, h: d };
	    }
	  },
	
	  arcModeAdjust: function(a, b, c, d, mode) {
	    if (mode === constants.CORNER) {
	      return { x: a+c*0.5, y: b+d*0.5, w: c, h: d };
	    } else if (mode === constants.CORNERS) {
	      return { x: a, y: b, w: c+a, h: d+b };
	    } else if (mode === constants.RADIUS) {
	      return { x: a, y: b, w: 2*c, h: 2*d };
	    } else if (mode === constants.CENTER) {
	      return { x: a, y: b, w: c, h: d };
	    }
	  }
	
	};
	
	
	},{"./constants":47}],47:[function(_dereq_,module,exports){
	/**
	 * @module Constants
	 * @submodule Constants
	 * @for p5
	 */
	
	var PI = Math.PI;
	
	module.exports = {
	
	  // GRAPHICS RENDERER
	  P2D: 'p2d',
	  WEBGL: 'webgl',
	
	  // ENVIRONMENT
	  ARROW: 'default',
	  CROSS: 'crosshair',
	  HAND: 'pointer',
	  MOVE: 'move',
	  TEXT: 'text',
	  WAIT: 'wait',
	
	  // TRIGONOMETRY
	
	  /**
	   * HALF_PI is a mathematical constant with the value
	   * 1.57079632679489661923. It is half the ratio of the
	   * circumference of a circle to its diameter. It is useful in
	   * combination with the trigonometric functions sin() and cos().
	   *
	   * @property HALF_PI
	   *
	   * @example
	   * <div><code>
	   * arc(50, 50, 80, 80, 0, HALF_PI);
	   * </code></div>
	   *
	   */
	  HALF_PI: PI / 2,
	  /**
	   * PI is a mathematical constant with the value
	   * 3.14159265358979323846. It is the ratio of the circumference
	   * of a circle to its diameter. It is useful in combination with
	   * the trigonometric functions sin() and cos().
	   *
	   * @property PI
	   *
	   * @example
	   * <div><code>
	   * arc(50, 50, 80, 80, 0, PI);
	   * </code></div>
	   */
	  PI: PI,
	  /**
	   * QUARTER_PI is a mathematical constant with the value 0.7853982.
	   * It is one quarter the ratio of the circumference of a circle to
	   * its diameter. It is useful in combination with the trigonometric
	   * functions sin() and cos().
	   *
	   * @property QUARTER_PI
	   *
	   * @example
	   * <div><code>
	   * arc(50, 50, 80, 80, 0, QUARTER_PI);
	   * </code></div>
	   *
	   */
	  QUARTER_PI: PI / 4,
	  /**
	   * TAU is an alias for TWO_PI, a mathematical constant with the
	   * value 6.28318530717958647693. It is twice the ratio of the
	   * circumference of a circle to its diameter. It is useful in
	   * combination with the trigonometric functions sin() and cos().
	   *
	   * @property TAU
	   *
	   * @example
	   * <div><code>
	   * arc(50, 50, 80, 80, 0, TAU);
	   * </code></div>
	   *
	   */
	  TAU: PI * 2,
	  /**
	   * TWO_PI is a mathematical constant with the value
	   * 6.28318530717958647693. It is twice the ratio of the
	   * circumference of a circle to its diameter. It is useful in
	   * combination with the trigonometric functions sin() and cos().
	   *
	   * @property TWO_PI
	   *
	   * @example
	   * <div><code>
	   * arc(50, 50, 80, 80, 0, TWO_PI);
	   * </code></div>
	   *
	   */
	  TWO_PI: PI * 2,
	  DEGREES: 'degrees',
	  RADIANS: 'radians',
	
	  // SHAPE
	  CORNER: 'corner',
	  CORNERS: 'corners',
	  RADIUS: 'radius',
	  RIGHT: 'right',
	  LEFT: 'left',
	  CENTER: 'center',
	  TOP: 'top',
	  BOTTOM: 'bottom',
	  BASELINE: 'alphabetic',
	  POINTS: 'points',
	  LINES: 'lines',
	  TRIANGLES: 'triangles',
	  TRIANGLE_FAN: 'triangles_fan',
	  TRIANGLE_STRIP: 'triangles_strip',
	  QUADS: 'quads',
	  QUAD_STRIP: 'quad_strip',
	  CLOSE: 'close',
	  OPEN: 'open',
	  CHORD: 'chord',
	  PIE: 'pie',
	  PROJECT: 'square', // PEND: careful this is counterintuitive
	  SQUARE: 'butt',
	  ROUND: 'round',
	  BEVEL: 'bevel',
	  MITER: 'miter',
	
	  // COLOR
	  RGB: 'rgb',
	  HSB: 'hsb',
	  HSL: 'hsl',
	
	  // DOM EXTENSION
	  AUTO: 'auto',
	
	  // INPUT
	  ALT: 18,
	  BACKSPACE: 8,
	  CONTROL: 17,
	  DELETE: 46,
	  DOWN_ARROW: 40,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT_ARROW: 37,
	  OPTION: 18,
	  RETURN: 13,
	  RIGHT_ARROW: 39,
	  SHIFT: 16,
	  TAB: 9,
	  UP_ARROW: 38,
	
	  // RENDERING
	  BLEND: 'normal',
	  ADD: 'lighter',
	  //ADD: 'add', //
	  //SUBTRACT: 'subtract', //
	  DARKEST: 'darken',
	  LIGHTEST: 'lighten',
	  DIFFERENCE: 'difference',
	  EXCLUSION: 'exclusion',
	  MULTIPLY: 'multiply',
	  SCREEN: 'screen',
	  REPLACE: 'source-over',
	  OVERLAY: 'overlay',
	  HARD_LIGHT: 'hard-light',
	  SOFT_LIGHT: 'soft-light',
	  DODGE: 'color-dodge',
	  BURN: 'color-burn',
	
	  // FILTERS
	  THRESHOLD: 'threshold',
	  GRAY: 'gray',
	  OPAQUE: 'opaque',
	  INVERT: 'invert',
	  POSTERIZE: 'posterize',
	  DILATE: 'dilate',
	  ERODE: 'erode',
	  BLUR: 'blur',
	
	  // TYPOGRAPHY
	  NORMAL: 'normal',
	  ITALIC: 'italic',
	  BOLD: 'bold',
	
	  // TYPOGRAPHY-INTERNAL
	  _DEFAULT_TEXT_FILL: '#000000',
	  _DEFAULT_LEADMULT: 1.25,
	  _CTX_MIDDLE: 'middle',
	
	  // VERTICES
	  LINEAR: 'linear',
	  QUADRATIC: 'quadratic',
	  BEZIER: 'bezier',
	  CURVE: 'curve',
	
	  // DEFAULTS
	  _DEFAULT_STROKE: '#000000',
	  _DEFAULT_FILL: '#FFFFFF'
	
	};
	
	},{}],48:[function(_dereq_,module,exports){
	/**
	 * @module Structure
	 * @submodule Structure
	 * @for p5
	 * @requires constants
	 */
	
	'use strict';
	
	_dereq_('./shim');
	
	// Core needs the PVariables object
	var constants = _dereq_('./constants');
	
	/**
	 * This is the p5 instance constructor.
	 *
	 * A p5 instance holds all the properties and methods related to
	 * a p5 sketch.  It expects an incoming sketch closure and it can also
	 * take an optional node parameter for attaching the generated p5 canvas
	 * to a node.  The sketch closure takes the newly created p5 instance as
	 * its sole argument and may optionally set preload(), setup(), and/or
	 * draw() properties on it for running a sketch.
	 *
	 * A p5 sketch can run in "global" or "instance" mode:
	 * "global"   - all properties and methods are attached to the window
	 * "instance" - all properties and methods are bound to this p5 object
	 *
	 * @param  {Function}    sketch a closure that can set optional preload(),
	 *                              setup(), and/or draw() properties on the
	 *                              given p5 instance
	 * @param  {HTMLElement|boolean} node element to attach canvas to, if a
	 *                                    boolean is passed in use it as sync
	 * @param  {boolean}     [sync] start synchronously (optional)
	 * @return {p5}                 a p5 instance
	 */
	var p5 = function(sketch, node, sync) {
	
	  if (arguments.length === 2 && typeof node === 'boolean') {
	    sync = node;
	    node = undefined;
	  }
	
	  //////////////////////////////////////////////
	  // PUBLIC p5 PROPERTIES AND METHODS
	  //////////////////////////////////////////////
	
	
	  /**
	   * Called directly before setup(), the preload() function is used to handle
	   * asynchronous loading of external files. If a preload function is
	   * defined, setup() will wait until any load calls within have finished.
	   * Nothing besides load calls should be inside preload (loadImage,
	   * loadJSON, loadFont, loadStrings, etc).
	   *
	   * @method preload
	   * @example
	   * <div><code>
	   * var img;
	   * var c;
	   * function preload() {  // preload() runs once
	   *   img = loadImage('assets/laDefense.jpg');
	   * }
	   *
	   * function setup() {  // setup() waits until preload() is done
	   *   img.loadPixels();
	   *   // get color of middle pixel
	   *   c = img.get(img.width/2, img.height/2);
	   * }
	   *
	   * function draw() {
	   *   background(c);
	   *   image(img, 25, 25, 50, 50);
	   * }
	   * </code></div>
	   */
	
	  /**
	   * The setup() function is called once when the program starts. It's used to
	   * define initial environment properties such as screen size and background
	   * color and to load media such as images and fonts as the program starts.
	   * There can only be one setup() function for each program and it shouldn't
	   * be called again after its initial execution.
	   * <br><br>
	   * Note: Variables declared within setup() are not accessible within other
	   * functions, including draw().
	   *
	   * @method setup
	   * @example
	   * <div><code>
	   * var a = 0;
	   *
	   * function setup() {
	   *   background(0);
	   *   noStroke();
	   *   fill(102);
	   * }
	   *
	   * function draw() {
	   *   rect(a++%width, 10, 2, 80);
	   * }
	   * </code></div>
	   */
	
	  /**
	   * Called directly after setup(), the draw() function continuously executes
	   * the lines of code contained inside its block until the program is stopped
	   * or noLoop() is called. draw() is called automatically and should never be
	   * called explicitly.
	   * <br><br>
	   * It should always be controlled with noLoop(), redraw() and loop(). After
	   * noLoop() stops the code in draw() from executing, redraw() causes the
	   * code inside draw() to execute once, and loop() will cause the code
	   * inside draw() to resume executing continuously.
	   * <br><br>
	   * The number of times draw() executes in each second may be controlled with
	   * the frameRate() function.
	   * <br><br>
	   * There can only be one draw() function for each sketch, and draw() must
	   * exist if you want the code to run continuously, or to process events such
	   * as mousePressed(). Sometimes, you might have an empty call to draw() in
	   * your program, as shown in the above example.
	   *
	   * @method draw
	   * @example
	   * <div><code>
	   * var yPos = 0;
	   * function setup() {  // setup() runs once
	   *   frameRate(30);
	   * }
	   * function draw() {  // draw() loops forever, until stopped
	   *   background(204);
	   *   yPos = yPos - 1;
	   *   if (yPos < 0) {
	   *     yPos = height;
	   *   }
	   *   line(0, yPos, width, yPos);
	   * }
	   * </code></div>
	   */
	
	
	  //////////////////////////////////////////////
	  // PRIVATE p5 PROPERTIES AND METHODS
	  //////////////////////////////////////////////
	
	  this._setupDone = false;
	  // for handling hidpi
	  this._pixelDensity = Math.ceil(window.devicePixelRatio) || 1;
	  this._userNode = node;
	  this._curElement = null;
	  this._elements = [];
	  this._requestAnimId = 0;
	  this._preloadCount = 0;
	  this._isGlobal = false;
	  this._loop = true;
	  this._styles = [];
	  this._defaultCanvasSize = {
	    width: 100,
	    height: 100
	  };
	  this._events = { // keep track of user-events for unregistering later
	    'mousemove': null,
	    'mousedown': null,
	    'mouseup': null,
	    'dragend': null,
	    'dragover': null,
	    'click': null,
	    'mouseover': null,
	    'mouseout': null,
	    'keydown': null,
	    'keyup': null,
	    'keypress': null,
	    'touchstart': null,
	    'touchmove': null,
	    'touchend': null,
	    'resize': null,
	    'blur': null
	  };
	
	  if (window.DeviceOrientationEvent) {
	    this._events.deviceorientation = null;
	  }
	  if (window.DeviceMotionEvent && !window._isNodeWebkit) {
	    this._events.devicemotion = null;
	  }
	
	  this._events.wheel = null;
	
	
	  this._loadingScreenId = 'p5_loading';
	
	  this._start = function () {
	    // Find node if id given
	    if (this._userNode) {
	      if (typeof this._userNode === 'string') {
	        this._userNode = document.getElementById(this._userNode);
	      }
	    }
	
	    // Always create a default canvas.
	    // Later on if the user calls createCanvas, this default one
	    // will be replaced
	    this.createCanvas(
	      this._defaultCanvasSize.width,
	      this._defaultCanvasSize.height,
	      'p2d',
	      true
	    );
	
	    var userPreload = this.preload || window.preload; // look for "preload"
	    if (userPreload) {
	
	      // Setup loading screen
	      // Set loading scfeen into dom if not present
	      // Otherwise displays and removes user provided loading screen
	      var loadingScreen = document.getElementById(this._loadingScreenId);
	      if(!loadingScreen){
	        loadingScreen = document.createElement('div');
	        loadingScreen.innerHTML = 'Loading...';
	        loadingScreen.style.position = 'absolute';
	        loadingScreen.id = this._loadingScreenId;
	        var node = this._userNode || document.body;
	        node.appendChild(loadingScreen);
	      }
	      // var methods = this._preloadMethods;
	      for (var method in this._preloadMethods){
	        // default to p5 if no object defined
	        this._preloadMethods[method] = this._preloadMethods[method] || p5;
	        var obj = this._preloadMethods[method];
	        //it's p5, check if it's global or instance
	        if (obj === p5.prototype || obj === p5){
	          obj = this._isGlobal ? window : this;
	        }
	        this._registeredPreloadMethods[method] = obj[method];
	        obj[method] = this._wrapPreload(obj, method);
	      }
	
	      userPreload();
	      this._runIfPreloadsAreDone();
	    } else {
	      this._setup();
	      this._runFrames();
	      this._draw();
	    }
	  }.bind(this);
	
	  this._runIfPreloadsAreDone = function(){
	    var context = this._isGlobal ? window : this;
	    if (context._preloadCount === 0) {
	      var loadingScreen = document.getElementById(context._loadingScreenId);
	      if (loadingScreen) {
	        loadingScreen.parentNode.removeChild(loadingScreen);
	      }
	      context._setup();
	      context._runFrames();
	      context._draw();
	    }
	  };
	
	  this._decrementPreload = function(){
	    var context = this._isGlobal ? window : this;
	    context._setProperty('_preloadCount', context._preloadCount - 1);
	    context._runIfPreloadsAreDone();
	  };
	
	  this._wrapPreload = function(obj, fnName){
	    return function(){
	      //increment counter
	      this._incrementPreload();
	      //call original function
	      var args = Array.prototype.slice.call(arguments);
	      args.push(this._decrementPreload.bind(this));
	      return this._registeredPreloadMethods[fnName].apply(obj, args);
	    }.bind(this);
	  };
	
	  this._incrementPreload = function(){
	    var context = this._isGlobal ? window : this;
	    context._setProperty('_preloadCount', context._preloadCount + 1);
	  };
	
	  this._setup = function() {
	
	    // return preload functions to their normal vals if switched by preload
	    var context = this._isGlobal ? window : this;
	    if (typeof context.preload === 'function') {
	      for (var f in this._preloadMethods) {
	        context[f] = this._preloadMethods[f][f];
	        if (context[f] && this) {
	          context[f] = context[f].bind(this);
	        }
	      }
	    }
	
	    // Short-circuit on this, in case someone used the library in "global"
	    // mode earlier
	    if (typeof context.setup === 'function') {
	      context.setup();
	    }
	
	    // // unhide hidden canvas that was created
	    // this.canvas.style.visibility = '';
	    // this.canvas.className = this.canvas.className.replace('p5_hidden', '');
	
	    // unhide any hidden canvases that were created
	    var reg = new RegExp(/(^|\s)p5_hidden(?!\S)/g);
	    var canvases = document.getElementsByClassName('p5_hidden');
	    for (var i = 0; i < canvases.length; i++) {
	      var k = canvases[i];
	      k.style.visibility = '';
	      k.className = k.className.replace(reg, '');
	    }
	    this._setupDone = true;
	
	  }.bind(this);
	
	  this._draw = function () {
	    var now = window.performance.now();
	    var time_since_last = now - this._lastFrameTime;
	    var target_time_between_frames = 1000 / this._targetFrameRate;
	
	    // only draw if we really need to; don't overextend the browser.
	    // draw if we're within 5ms of when our next frame should paint
	    // (this will prevent us from giving up opportunities to draw
	    // again when it's really about time for us to do so). fixes an
	    // issue where the frameRate is too low if our refresh loop isn't
	    // in sync with the browser. note that we have to draw once even
	    // if looping is off, so we bypass the time delay if that
	    // is the case.
	    var epsilon = 5;
	    if (!this._loop ||
	        time_since_last >= target_time_between_frames - epsilon) {
	
	      //mandatory update values(matrixs and stack) for 3d
	      if(this._renderer.isP3D){
	        this._renderer._update();
	      }
	
	      this._setProperty('frameCount', this.frameCount + 1);
	      this._updateMouseCoords();
	      this._updateTouchCoords();
	      this.redraw();
	      this._frameRate = 1000.0/(now - this._lastFrameTime);
	      this._lastFrameTime = now;
	    }
	
	    // get notified the next time the browser gives us
	    // an opportunity to draw.
	    if (this._loop) {
	      this._requestAnimId = window.requestAnimationFrame(this._draw);
	    }
	  }.bind(this);
	
	  this._runFrames = function() {
	    if (this._updateInterval) {
	      clearInterval(this._updateInterval);
	    }
	  }.bind(this);
	
	  this._setProperty = function(prop, value) {
	    this[prop] = value;
	    if (this._isGlobal) {
	      window[prop] = value;
	    }
	  }.bind(this);
	
	  /**
	   * Removes the entire p5 sketch. This will remove the canvas and any
	   * elements created by p5.js. It will also stop the draw loop and unbind
	   * any properties or methods from the window global scope. It will
	   * leave a variable p5 in case you wanted to create a new p5 sketch.
	   * If you like, you can set p5 = null to erase it.
	   * @method remove
	   * @example
	   * <div class='norender'><code>
	   * function draw() {
	   *   ellipse(50, 50, 10, 10);
	   * }
	   *
	   * function mousePressed() {
	   *   remove(); // remove whole sketch on mouse press
	   * }
	   * </code></div>
	   */
	  this.remove = function() {
	    if (this._curElement) {
	
	      // stop draw
	      this._loop = false;
	      if (this._requestAnimId) {
	        window.cancelAnimationFrame(this._requestAnimId);
	      }
	
	      // unregister events sketch-wide
	      for (var ev in this._events) {
	        window.removeEventListener(ev, this._events[ev]);
	      }
	
	      // remove DOM elements created by p5, and listeners
	      for (var i=0; i<this._elements.length; i++) {
	        var e = this._elements[i];
	        if (e.elt.parentNode) {
	          e.elt.parentNode.removeChild(e.elt);
	        }
	        for (var elt_ev in e._events) {
	          e.elt.removeEventListener(elt_ev, e._events[elt_ev]);
	        }
	      }
	
	      // call any registered remove functions
	      var self = this;
	      this._registeredMethods.remove.forEach(function (f) {
	        if (typeof(f) !== 'undefined') {
	          f.call(self);
	        }
	      });
	
	      // remove window bound properties and methods
	      if (this._isGlobal) {
	        for (var p in p5.prototype) {
	          try {
	            delete window[p];
	          } catch (x) {
	            window[p] = undefined;
	          }
	        }
	        for (var p2 in this) {
	          if (this.hasOwnProperty(p2)) {
	            try {
	              delete window[p2];
	            } catch (x) {
	              window[p2] = undefined;
	            }
	          }
	        }
	      }
	    }
	    // window.p5 = undefined;
	  }.bind(this);
	
	
	  // attach constants to p5 instance
	  for (var k in constants) {
	    p5.prototype[k] = constants[k];
	  }
	
	  // If the user has created a global setup or draw function,
	  // assume "global" mode and make everything global (i.e. on the window)
	  if (!sketch) {
	    this._isGlobal = true;
	    // Loop through methods on the prototype and attach them to the window
	    for (var p in p5.prototype) {
	      if(typeof p5.prototype[p] === 'function') {
	        var ev = p.substring(2);
	        if (!this._events.hasOwnProperty(ev)) {
	          window[p] = p5.prototype[p].bind(this);
	        }
	      } else {
	        window[p] = p5.prototype[p];
	      }
	    }
	    // Attach its properties to the window
	    for (var p2 in this) {
	      if (this.hasOwnProperty(p2)) {
	        window[p2] = this[p2];
	      }
	    }
	
	  } else {
	    // Else, the user has passed in a sketch closure that may set
	    // user-provided 'setup', 'draw', etc. properties on this instance of p5
	    sketch(this);
	  }
	
	  // Bind events to window (not using container div bc key events don't work)
	
	  for (var e in this._events) {
	    var f = this['_on'+e];
	    if (f) {
	      var m = f.bind(this);
	      window.addEventListener(e, m);
	      this._events[e] = m;
	    }
	  }
	
	  var focusHandler = function() {
	    this._setProperty('focused', true);
	  }.bind(this);
	  var blurHandler = function() {
	    this._setProperty('focused', false);
	  }.bind(this);
	  window.addEventListener('focus', focusHandler);
	  window.addEventListener('blur', blurHandler);
	  this.registerMethod('remove', function() {
	    window.removeEventListener('focus', focusHandler);
	    window.removeEventListener('blur', blurHandler);
	  });
	
	  // TODO: ???
	
	  if (sync) {
	    this._start();
	  } else {
	    if (document.readyState === 'complete') {
	      this._start();
	    } else {
	      window.addEventListener('load', this._start.bind(this), false);
	    }
	  }
	};
	
	
	// functions that cause preload to wait
	// more can be added by using registerPreloadMethod(func)
	p5.prototype._preloadMethods = {
	  loadJSON: p5.prototype,
	  loadImage: p5.prototype,
	  loadStrings: p5.prototype,
	  loadXML: p5.prototype,
	  loadShape: p5.prototype,
	  loadTable: p5.prototype,
	  loadFont: p5.prototype
	};
	
	p5.prototype._registeredMethods = { pre: [], post: [], remove: [] };
	
	p5.prototype._registeredPreloadMethods = {};
	
	p5.prototype.registerPreloadMethod = function(fnString, obj) {
	  // obj = obj || p5.prototype;
	  if (!p5.prototype._preloadMethods.hasOwnProperty(fnString)) {
	    p5.prototype._preloadMethods[fnString] = obj;
	  }
	};
	
	p5.prototype.registerMethod = function(name, m) {
	  if (!p5.prototype._registeredMethods.hasOwnProperty(name)) {
	    p5.prototype._registeredMethods[name] = [];
	  }
	  p5.prototype._registeredMethods[name].push(m);
	};
	
	module.exports = p5;
	
	},{"./constants":47,"./shim":57}],49:[function(_dereq_,module,exports){
	/**
	 * @module Shape
	 * @submodule Curves
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	
	_dereq_('./error_helpers');
	
	var bezierDetail = 20;
	var curveDetail = 20;
	
	/**
	 * Draws a cubic Bezier curve on the screen. These curves are defined by a
	 * series of anchor and control points. The first two parameters specify
	 * the first anchor point and the last two parameters specify the other
	 * anchor point, which become the first and last points on the curve. The
	 * middle parameters specify the two control points which define the shape
	 * of the curve. Approximately speaking, control points "pull" the curve
	 * towards them.<br /><br />Bezier curves were developed by French
	 * automotive engineer Pierre Bezier, and are commonly used in computer
	 * graphics to define gently sloping curves. See also curve().
	 *
	 * @method bezier
	 * @param  {Number} x1 x-coordinate for the first anchor point
	 * @param  {Number} y1 y-coordinate for the first anchor point
	 * @param  {Number} x2 x-coordinate for the first control point
	 * @param  {Number} y2 y-coordinate for the first control point
	 * @param  {Number} x3 x-coordinate for the second control point
	 * @param  {Number} y3 y-coordinate for the second control point
	 * @param  {Number} x4 x-coordinate for the second anchor point
	 * @param  {Number} y4 y-coordinate for the second anchor point
	 * @return {Object}    the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * stroke(255, 102, 0);
	 * line(85, 20, 10, 10);
	 * line(90, 90, 15, 80);
	 * stroke(0, 0, 0);
	 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
	 * </code>
	 * </div>
	 */
	p5.prototype.bezier = function(x1, y1, x2, y2, x3, y3, x4, y4) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'bezier',
	    args,
	    [ 'Number', 'Number', 'Number', 'Number',
	      'Number', 'Number', 'Number', 'Number' ]
	  );
	
	  if (!this._renderer._doStroke) {
	    return this;
	  }
	  this._renderer.bezier(x1, y1, x2, y2, x3, y3, x4, y4);
	  return this;
	};
	
	/**
	 * Sets the resolution at which Beziers display.
	 *
	 * The default value is 20.
	 *
	 * @param {Number} detail resolution of the curves
	 * @return {Object} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * background(204);
	 * bezierDetail(50);
	 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
	 * </code>
	 * </div>
	 */
	p5.prototype.bezierDetail = function(d) {
	  bezierDetail = d;
	  return this;
	};
	
	/**
	 * Evaluates the Bezier at position t for points a, b, c, d.
	 * The parameters a and d are the first and last points
	 * on the curve, and b and c are the control points.
	 * The final parameter t varies between 0 and 1.
	 * This can be done once with the x coordinates and a second time
	 * with the y coordinates to get the location of a bezier curve at t.
	 *
	 * @method bezierPoint
	 * @param {Number} a coordinate of first point on the curve
	 * @param {Number} b coordinate of first control point
	 * @param {Number} c coordinate of second control point
	 * @param {Number} d coordinate of second point on the curve
	 * @param {Number} t value between 0 and 1
	 * @return {Number} the value of the Bezier at position t
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * x1 = 85, x2 = 10, x3 = 90, x4 = 15;
	 * y1 = 20, y2 = 10, y3 = 90, y4 = 80;
	 * bezier(x1, y1, x2, y2, x3, y3, x4, y4);
	 * fill(255);
	 * steps = 10;
	 * for (i = 0; i <= steps; i++) {
	 *   t = i / steps;
	 *   x = bezierPoint(x1, x2, x3, x4, t);
	 *   y = bezierPoint(y1, y2, y3, y4, t);
	 *   ellipse(x, y, 5, 5);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.bezierPoint = function(a, b, c, d, t) {
	  var adjustedT = 1-t;
	  return Math.pow(adjustedT,3)*a +
	   3*(Math.pow(adjustedT,2))*t*b +
	   3*adjustedT*Math.pow(t,2)*c +
	   Math.pow(t,3)*d;
	};
	
	/**
	 * Evaluates the tangent to the Bezier at position t for points a, b, c, d.
	 * The parameters a and d are the first and last points
	 * on the curve, and b and c are the control points.
	 * The final parameter t varies between 0 and 1.
	 *
	 * @method bezierTangent
	 * @param {Number} a coordinate of first point on the curve
	 * @param {Number} b coordinate of first control point
	 * @param {Number} c coordinate of second control point
	 * @param {Number} d coordinate of second point on the curve
	 * @param {Number} t value between 0 and 1
	 * @return {Number} the tangent at position t
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
	 * steps = 6;
	 * fill(255);
	 * for (i = 0; i <= steps; i++) {
	 *   t = i / steps;
	 *   // Get the location of the point
	 *   x = bezierPoint(85, 10, 90, 15, t);
	 *   y = bezierPoint(20, 10, 90, 80, t);
	 *   // Get the tangent points
	 *   tx = bezierTangent(85, 10, 90, 15, t);
	 *   ty = bezierTangent(20, 10, 90, 80, t);
	 *   // Calculate an angle from the tangent points
	 *   a = atan2(ty, tx);
	 *   a += PI;
	 *   stroke(255, 102, 0);
	 *   line(x, y, cos(a)*30 + x, sin(a)*30 + y);
	 *   // The following line of code makes a line
	 *   // inverse of the above line
	 *   //line(x, y, cos(a)*-30 + x, sin(a)*-30 + y);
	 *   stroke(0);
	 *   ellipse(x, y, 5, 5);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
	 * stroke(255, 102, 0);
	 * steps = 16;
	 * for (i = 0; i <= steps; i++) {
	 *   t = i / steps;
	 *   x = bezierPoint(85, 10, 90, 15, t);
	 *   y = bezierPoint(20, 10, 90, 80, t);
	 *   tx = bezierTangent(85, 10, 90, 15, t);
	 *   ty = bezierTangent(20, 10, 90, 80, t);
	 *   a = atan2(ty, tx);
	 *   a -= HALF_PI;
	 *   line(x, y, cos(a)*8 + x, sin(a)*8 + y);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.bezierTangent = function(a, b, c, d, t) {
	  var adjustedT = 1-t;
	  return 3*d*Math.pow(t,2) -
	   3*c*Math.pow(t,2) +
	   6*c*adjustedT*t -
	   6*b*adjustedT*t +
	   3*b*Math.pow(adjustedT,2) -
	   3*a*Math.pow(adjustedT,2);
	};
	
	/**
	 * Draws a curved line on the screen between two points, given as the
	 * middle four parameters. The first two parameters are a control point, as
	 * if the curve came from this point even though it's not drawn. The last
	 * two parameters similarly describe the other control point. <br /><br />
	 * Longer curves can be created by putting a series of curve() functions
	 * together or using curveVertex(). An additional function called
	 * curveTightness() provides control for the visual quality of the curve.
	 * The curve() function is an implementation of Catmull-Rom splines.
	 *
	 * @method curve
	 * @param  {Number} x1 x-coordinate for the beginning control point
	 * @param  {Number} y1 y-coordinate for the beginning control point
	 * @param  {Number} x2 x-coordinate for the first point
	 * @param  {Number} y2 y-coordinate for the first point
	 * @param  {Number} x3 x-coordinate for the second point
	 * @param  {Number} y3 y-coordinate for the second point
	 * @param  {Number} x4 x-coordinate for the ending control point
	 * @param  {Number} y4 y-coordinate for the ending control point
	 * @return {Object}    the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * stroke(255, 102, 0);
	 * curve(5, 26, 5, 26, 73, 24, 73, 61);
	 * stroke(0);
	 * curve(5, 26, 73, 24, 73, 61, 15, 65);
	 * stroke(255, 102, 0);
	 * curve(73, 24, 73, 61, 15, 65, 15, 65);
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * // Define the curve points as JavaScript objects
	 * p1 = {x: 5, y: 26}, p2 = {x: 73, y: 24}
	 * p3 = {x: 73, y: 61}, p4 = {x: 15, y: 65}
	 * noFill();
	 * stroke(255, 102, 0);
	 * curve(p1.x, p1.y, p1.x, p1.y, p2.x, p2.y, p3.x, p3.y)
	 * stroke(0);
	 * curve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y)
	 * stroke(255, 102, 0);
	 * curve(p2.x, p2.y, p3.x, p3.y, p4.x, p4.y, p4.x, p4.y)
	 * </code>
	 * </div>
	 */
	p5.prototype.curve = function(x1, y1, x2, y2, x3, y3, x4, y4) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'curve',
	    args,
	    [ 'Number', 'Number', 'Number', 'Number',
	      'Number', 'Number', 'Number', 'Number' ]
	  );
	
	  if (!this._renderer._doStroke) {
	    return;
	  }
	  this._renderer.curve(x1, y1, x2, y2, x3, y3, x4, y4);
	  return this;
	};
	
	/**
	 * Sets the resolution at which curves display.
	 *
	 * The default value is 20.
	 *
	 * @param {Number} resolution of the curves
	 * @return {Object} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * background(204);
	 * curveDetail(20);
	 * curve(5, 26, 5, 26, 73, 24, 73, 61);
	 * </code>
	 * </div>
	 */
	p5.prototype.curveDetail = function(d) {
	  curveDetail = d;
	  return this;
	};
	
	/**
	 * Modifies the quality of forms created with curve() and curveVertex().
	 * The parameter tightness determines how the curve fits to the vertex
	 * points. The value 0.0 is the default value for tightness (this value
	 * defines the curves to be Catmull-Rom splines) and the value 1.0 connects
	 * all the points with straight lines. Values within the range -5.0 and 5.0
	 * will deform the curves but will leave them recognizable and as values
	 * increase in magnitude, they will continue to deform.
	 *
	 * @method curveTightness
	 * @param {Number} amount of deformation from the original vertices
	 * @return {Object} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * // Move the mouse left and right to see the curve change
	 *
	 * function setup() {
	 *   createCanvas(100, 100);
	 *   noFill();
	 * }
	 *
	 * function draw() {
	 *   background(204);
	 *   var t = map(mouseX, 0, width, -5, 5);
	 *   curveTightness(t);
	 *   beginShape();
	 *   curveVertex(10, 26);
	 *   curveVertex(10, 26);
	 *   curveVertex(83, 24);
	 *   curveVertex(83, 61);
	 *   curveVertex(25, 65);
	 *   curveVertex(25, 65);
	 *   endShape();
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.curveTightness = function (t) {
	  this._renderer._curveTightness = t;
	};
	
	/**
	 * Evaluates the curve at position t for points a, b, c, d.
	 * The parameter t varies between 0 and 1, a and d are points
	 * on the curve, and b and c are the control points.
	 * This can be done once with the x coordinates and a second time
	 * with the y coordinates to get the location of a curve at t.
	 *
	 * @method curvePoint
	 * @param {Number} a coordinate of first point on the curve
	 * @param {Number} b coordinate of first control point
	 * @param {Number} c coordinate of second control point
	 * @param {Number} d coordinate of second point on the curve
	 * @param {Number} t value between 0 and 1
	 * @return {Number} bezier value at position t
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * curve(5, 26, 5, 26, 73, 24, 73, 61);
	 * curve(5, 26, 73, 24, 73, 61, 15, 65);
	 * fill(255);
	 * ellipseMode(CENTER);
	 * steps = 6;
	 * for (i = 0; i <= steps; i++) {
	 *   t = i / steps;
	 *   x = curvePoint(5, 5, 73, 73, t);
	 *   y = curvePoint(26, 26, 24, 61, t);
	 *   ellipse(x, y, 5, 5);
	 *   x = curvePoint(5, 73, 73, 15, t);
	 *   y = curvePoint(26, 24, 61, 65, t);
	 *   ellipse(x, y, 5, 5);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.curvePoint = function(a, b, c, d, t) {
	  var t3 = t*t*t,
	    t2 = t*t,
	    f1 = -0.5 * t3 + t2 - 0.5 * t,
	    f2 = 1.5 * t3 - 2.5 * t2 + 1.0,
	    f3 = -1.5 * t3 + 2.0 * t2 + 0.5 * t,
	    f4 = 0.5 * t3 - 0.5 * t2;
	  return a*f1 + b*f2 + c*f3 + d*f4;
	};
	
	/**
	 * Evaluates the tangent to the curve at position t for points a, b, c, d.
	 * The parameter t varies between 0 and 1, a and d are points on the curve,
	 * and b and c are the control points
	 *
	 * @method curveTangent
	 * @param {Number} a coordinate of first point on the curve
	 * @param {Number} b coordinate of first control point
	 * @param {Number} c coordinate of second control point
	 * @param {Number} d coordinate of second point on the curve
	 * @param {Number} t value between 0 and 1
	 * @return {Number} the tangent at position t
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * curve(5, 26, 73, 24, 73, 61, 15, 65);
	 * steps = 6;
	 * for (i = 0; i <= steps; i++) {
	 *   t = i / steps;
	 *   x = curvePoint(5, 73, 73, 15, t);
	 *   y = curvePoint(26, 24, 61, 65, t);
	 *   //ellipse(x, y, 5, 5);
	 *   tx = curveTangent(5, 73, 73, 15, t);
	 *   ty = curveTangent(26, 24, 61, 65, t);
	 *   a = atan2(ty, tx);
	 *   a -= PI/2.0;
	 *   line(x, y, cos(a)*8 + x, sin(a)*8 + y);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.curveTangent = function(a, b,c, d, t) {
	  var t2 = t*t,
	    f1 = (-3*t2)/2 + 2*t - 0.5,
	    f2 = (9*t2)/2 - 5*t,
	    f3 = (-9*t2)/2 + 4*t + 0.5,
	    f4 = (3*t2)/2 - t;
	  return a*f1 + b*f2 + c*f3 + d*f4;
	};
	
	module.exports = p5;
	
	},{"./core":48,"./error_helpers":51}],50:[function(_dereq_,module,exports){
	/**
	 * @module Environment
	 * @submodule Environment
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	var C = _dereq_('./constants');
	
	var standardCursors = [C.ARROW, C.CROSS, C.HAND, C.MOVE, C.TEXT, C.WAIT];
	
	p5.prototype._frameRate = 0;
	p5.prototype._lastFrameTime = window.performance.now();
	p5.prototype._targetFrameRate = 60;
	
	
	if (window.console && console.log) {
	  /**
	   * The print() function writes to the console area of your browser.
	   * This function is often helpful for looking at the data a program is
	   * producing. This function creates a new line of text for each call to
	   * the function. Individual elements can be
	   * separated with quotes ("") and joined with the addition operator (+).
	   * <br><br>
	   * While print() is similar to console.log(), it does not directly map to
	   * it in order to simulate easier to understand behavior than
	   * console.log(). Due to this, it is slower. For fastest results, use
	   * console.log().
	   *
	   * @method print
	   * @param {Any} contents any combination of Number, String, Object, Boolean,
	   *                       Array to print
	   * @example
	   * <div><code class='norender'>
	   * var x = 10;
	   * print("The value of x is " + x);
	   * // prints "The value of x is 10"
	   * </code></div>
	   */
	  // Converts passed args into a string and then parses that string to
	  // simulate synchronous behavior. This is a hack and is gross.
	  // Since this will not work on all objects, particularly circular
	  // structures, simply console.log() on error.
	  p5.prototype.print = function(args) {
	    try {
	      var newArgs = JSON.parse(JSON.stringify(args));
	      console.log(newArgs);
	    } catch(err) {
	      console.log(args);
	    }
	  };
	} else {
	  p5.prototype.print = function() {};
	}
	
	p5.prototype.println = p5.prototype.print;
	
	/**
	 * The system variable frameCount contains the number of frames that have
	 * been displayed since the program started. Inside setup() the value is 0,
	 * after the first iteration of draw it is 1, etc.
	 *
	 * @property frameCount
	 * @example
	 *   <div><code>
	 *     function setup() {
	 *       frameRate(30);
	 *       textSize(20);
	 *       textSize(30);
	 *       textAlign(CENTER);
	 *     }
	 *
	 *     function draw() {
	 *       background(200);
	 *       text(frameCount, width/2, height/2);
	 *     }
	 *   </code></div>
	 */
	p5.prototype.frameCount = 0;
	
	/**
	 * Confirms if the window a p5.js program is in is "focused," meaning that
	 * the sketch will accept mouse or keyboard input. This variable is
	 * "true" if the window is focused and "false" if not.
	 *
	 * @property focused
	 * @example
	 * <div><code>
	 * // To demonstrate, put two windows side by side.
	 * // Click on the window that the p5 sketch isn't in!
	 * function draw() {
	 *   if (focused) {  // or "if (focused === true)"
	 *     noStroke();
	 *     fill(0, 200, 0);
	 *     ellipse(25, 25, 50, 50);
	 *   } else {
	 *     stroke(200,0,0);
	 *     line(0, 0, 100, 100);
	 *     line(100, 0, 0, 100);
	 *   }
	 * }
	 *
	 * </code></div>
	 */
	p5.prototype.focused = (document.hasFocus());
	
	/**
	 * Sets the cursor to a predefined symbol or an image, or makes it visible
	 * if already hidden. If you are trying to set an image as the cursor, the
	 * recommended size is 16x16 or 32x32 pixels. It is not possible to load an
	 * image as the cursor if you are exporting your program for the Web, and not
	 * all MODES work with all browsers. The values for parameters x and y must
	 * be less than the dimensions of the image.
	 *
	 * @method cursor
	 * @param {Number/Constant} type either ARROW, CROSS, HAND, MOVE, TEXT, or
	 *                               WAIT, or path for image
	 * @param {Number}          [x]  the horizontal active spot of the cursor
	 * @param {Number}          [y]  the vertical active spot of the cursor
	 * @example
	 * <div><code>
	 * // Move the mouse left and right across the image
	 * // to see the cursor change from a cross to a hand
	 * function draw() {
	 *   line(width/2, 0, width/2, height);
	 *   if (mouseX < 50) {
	 *     cursor(CROSS);
	 *   } else {
	 *     cursor(HAND);
	 *   }
	 * }
	 * </code></div>
	 */
	p5.prototype.cursor = function(type, x, y) {
	  var cursor = 'auto';
	  var canvas = this._curElement.elt;
	  if (standardCursors.indexOf(type) > -1) {
	    // Standard css cursor
	    cursor = type;
	  } else if (typeof type === 'string') {
	    var coords = '';
	    if (x && y && (typeof x === 'number' && typeof y === 'number')) {
	      // Note that x and y values must be unit-less positive integers < 32
	      // https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
	      coords = x + ' ' + y;
	    }
	    if (type.substring(0, 6) !== 'http://') {
	      // Image (absolute url)
	      cursor = 'url(' + type + ') ' + coords + ', auto';
	    } else if (/\.(cur|jpg|jpeg|gif|png|CUR|JPG|JPEG|GIF|PNG)$/.test(type)) {
	      // Image file (relative path) - Separated for performance reasons
	      cursor = 'url(' + type + ') ' + coords + ', auto';
	    } else {
	      // Any valid string for the css cursor property
	      cursor = type;
	    }
	  }
	  canvas.style.cursor = cursor;
	};
	
	/**
	 * Specifies the number of frames to be displayed every second. For example,
	 * the function call frameRate(30) will attempt to refresh 30 times a second.
	 * If the processor is not fast enough to maintain the specified rate, the
	 * frame rate will not be achieved. Setting the frame rate within setup() is
	 * recommended. The default rate is 60 frames per second. This is the same as
	 * setFrameRate(val).
	 * <br><br>
	 * Calling frameRate() with no arguments returns the current framerate. This
	 * is the same as getFrameRate().
	 * <br><br>
	 * Calling frameRate() with arguments that are not of the type numbers
	 * or are non positive also returns current framerate.
	 *
	 * @method frameRate
	 * @param  {Number} [fps] number of frames to be displayed every second
	 * @return {Number}       current frameRate
	 * @example
	 *
	 * <div><code>
	 * var rectX = 0;
	 * var fr = 30; //starting FPS
	 * var clr;
	 *
	 * function setup() {
	 *   background(200);
	 *   frameRate(fr); // Attempt to refresh at starting FPS
	 *   clr = color(255,0,0);
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 *   rectX = rectX += 1; // Move Rectangle
	 *
	 *   if (rectX >= width) { // If you go off screen.
	 *     if (fr == 30) {
	 *       clr = color(0,0,255);
	 *       fr = 10;
	 *       frameRate(fr); // make frameRate 10 FPS
	 *     } else {
	 *       clr = color(255,0,0);
	 *       fr = 30;
	 *       frameRate(fr); // make frameRate 30 FPS
	 *     }
	 *     rectX = 0;
	 *   }
	 *   fill(clr);
	 *   rect(rectX, 40, 20,20);
	 * }
	 * </div></code>
	 *
	 */
	p5.prototype.frameRate = function(fps) {
	  if (typeof fps !== 'number' || fps <= 0) {
	    return this._frameRate;
	  } else {
	    this._setProperty('_targetFrameRate', fps);
	    this._runFrames();
	    return this;
	  }
	};
	/**
	 * Returns the current framerate.
	 *
	 * @return {Number} current frameRate
	 */
	p5.prototype.getFrameRate = function() {
	  return this.frameRate();
	};
	
	/**
	 * Specifies the number of frames to be displayed every second. For example,
	 * the function call frameRate(30) will attempt to refresh 30 times a second.
	 * If the processor is not fast enough to maintain the specified rate, the
	 * frame rate will not be achieved. Setting the frame rate within setup() is
	 * recommended. The default rate is 60 frames per second.
	 *
	 * Calling frameRate() with no arguments returns the current framerate.
	 *
	 * @param {Number} [fps] number of frames to be displayed every second
	 */
	p5.prototype.setFrameRate = function(fps) {
	  return this.frameRate(fps);
	};
	
	/**
	 * Hides the cursor from view.
	 *
	 * @method noCursor
	 * @example
	 * <div><code>
	 * function setup() {
	 *   noCursor();
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 *   ellipse(mouseX, mouseY, 10, 10);
	 * }
	 * </code></div>
	 */
	p5.prototype.noCursor = function() {
	  this._curElement.elt.style.cursor = 'none';
	};
	
	
	/**
	 * System variable that stores the width of the entire screen display. This
	 * is used to run a full-screen program on any display size.
	 *
	 * @property displayWidth
	 * @example
	 * <div class="norender"><code>
	 * createCanvas(displayWidth, displayHeight);
	 * </code></div>
	 */
	p5.prototype.displayWidth = screen.width;
	
	/**
	 * System variable that stores the height of the entire screen display. This
	 * is used to run a full-screen program on any display size.
	 *
	 * @property displayHeight
	 * @example
	 * <div class="norender"><code>
	 * createCanvas(displayWidth, displayHeight);
	 * </code></div>
	 */
	p5.prototype.displayHeight = screen.height;
	
	/**
	 * System variable that stores the width of the inner window, it maps to
	 * window.innerWidth.
	 *
	 * @property windowWidth
	 * @example
	 * <div class="norender"><code>
	 * createCanvas(windowWidth, windowHeight);
	 * </code></div>
	 */
	p5.prototype.windowWidth = window.innerWidth;
	/**
	 * System variable that stores the height of the inner window, it maps to
	 * window.innerHeight.
	 *
	 * @property windowHeight
	 * @example
	 * <div class="norender"><code>
	 * createCanvas(windowWidth, windowHeight);
	 * </code></div>
	 */
	p5.prototype.windowHeight = window.innerHeight;
	
	/**
	 * The windowResized() function is called once every time the browser window
	 * is resized. This is a good place to resize the canvas or do any other
	 * adjustements to accomodate the new window size.
	 *
	 * @method windowResized
	 * @example
	 * <div class="norender"><code>
	 * function setup() {
	 *   createCanvas(windowWidth, windowHeight);
	 * }
	 *
	 * function draw() {
	 *  background(0, 100, 200);
	 * }
	 *
	 * function windowResized() {
	 *   resizeCanvas(windowWidth, windowHeight);
	 * }
	 * </code></div>
	 */
	p5.prototype._onresize = function(e){
	  this._setProperty('windowWidth', window.innerWidth);
	  this._setProperty('windowHeight', window.innerHeight);
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  if (typeof context.windowResized === 'function') {
	    executeDefault = context.windowResized(e);
	    if (executeDefault !== undefined && !executeDefault) {
	      e.preventDefault();
	    }
	  }
	};
	
	/**
	 * System variable that stores the width of the drawing canvas. This value
	 * is set by the first parameter of the createCanvas() function.
	 * For example, the function call createCanvas(320, 240) sets the width
	 * variable to the value 320. The value of width defaults to 100 if
	 * createCanvas() is not used in a program.
	 *
	 * @property width
	 */
	p5.prototype.width = 0;
	
	/**
	 * System variable that stores the height of the drawing canvas. This value
	 * is set by the second parameter of the createCanvas() function. For
	 * example, the function call createCanvas(320, 240) sets the height
	 * variable to the value 240. The value of height defaults to 100 if
	 * createCanvas() is not used in a program.
	 *
	 * @property height
	 */
	p5.prototype.height = 0;
	
	/**
	 * If argument is given, sets the sketch to fullscreen or not based on the
	 * value of the argument. If no argument is given, returns the current
	 * fullscreen state. Note that due to browser restrictions this can only
	 * be called on user input, for example, on mouse press like the example
	 * below.
	 *
	 * @method fullScreen
	 * @param  {Boolean} [val] whether the sketch should be fullscreened or not
	 * @return {Boolean} current fullscreen state
	 * @example
	 * <div>
	 * <code>
	 * // Clicking in the box toggles fullscreen on and off.
	 * function setup() {
	 *   background(200);
	 * }
	 * function mousePressed() {
	 *   if (mouseX > 0 && mouseX < 100 && mouseY > 0 && mouseY < 100) {
	 *     var fs = fullScreen();
	 *     fullScreen(!fs);
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.fullScreen = function(val) {
	  // no arguments, return fullscreen or not
	  if (typeof val === 'undefined') {
	    return document.fullscreenElement ||
	           document.webkitFullscreenElement ||
	           document.mozFullScreenElement ||
	           document.msFullscreenElement;
	  } else { // otherwise set to fullscreen or not
	    if (val) {
	      launchFullscreen(document.documentElement);
	    } else {
	      exitFullscreen();
	    }
	  }
	};
	
	/**
	 * Sets the pixel scaling for high pixel density displays. By default
	 * pixel density is set to match display density, call pixelDensity(1)
	 * to turn this off. Calling pixelDensity() with no arguments returns
	 * the current pixel density of the sketch.
	 *
	 *
	 * @method pixelDensity
	 * @param  {Number} [val] whether or how much the sketch should scale
	 * @returns {Number} current pixel density of the sketch
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   pixelDensity(1);
	 *   createCanvas(100, 100);
	 *   background(200);
	 *   ellipse(width/2, height/2, 50, 50);
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * function setup() {
	 *   pixelDensity(3.0);
	 *   createCanvas(100, 100);
	 *   background(200);
	 *   ellipse(width/2, height/2, 50, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.pixelDensity = function(val) {
	  if (typeof val === 'number') {
	    this._pixelDensity = val;
	  } else {
	    return this._pixelDensity;
	  }
	  this.resizeCanvas(this.width, this.height, true);
	};
	
	/**
	 * Returns the pixel density of the current display the sketch is running on.
	 *
	 * @method displayDensity
	 * @returns {Number} current pixel density of the display
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   var density = displayDensity();
	 *   pixelDensity(density);
	 *   createCanvas(100, 100);
	 *   background(200);
	 *   ellipse(width/2, height/2, 50, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.displayDensity = function() {
	  return window.devicePixelRatio;
	};
	
	function launchFullscreen(element) {
	  var enabled = document.fullscreenEnabled ||
	                document.webkitFullscreenEnabled ||
	                document.mozFullScreenEnabled ||
	                document.msFullscreenEnabled;
	  if (!enabled) {
	    throw new Error('Fullscreen not enabled in this browser.');
	  }
	  if(element.requestFullscreen) {
	    element.requestFullscreen();
	  } else if(element.mozRequestFullScreen) {
	    element.mozRequestFullScreen();
	  } else if(element.webkitRequestFullscreen) {
	    element.webkitRequestFullscreen();
	  } else if(element.msRequestFullscreen) {
	    element.msRequestFullscreen();
	  }
	}
	
	function exitFullscreen() {
	  if(document.exitFullscreen) {
	    document.exitFullscreen();
	  } else if(document.mozCancelFullScreen) {
	    document.mozCancelFullScreen();
	  } else if(document.webkitExitFullscreen) {
	    document.webkitExitFullscreen();
	  } else if (document.msExitFullscreen) {
	    document.msExitFullscreen();
	  }
	}
	
	
	/**
	 * Gets the current URL.
	 * @method getURL
	 * @return {String} url
	 * @example
	 * <div>
	 * <code>
	 * var url;
	 * var x = 100;
	 *
	 * function setup() {
	 *   fill(0);
	 *   noStroke();
	 *   url = getURL();
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 *   text(url, x, height/2);
	 *   x--;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.getURL = function() {
	  return location.href;
	};
	/**
	 * Gets the current URL path as an array.
	 * @method getURLPath
	 * @return {Array} path components
	 * @example
	 * <div class='norender'><code>
	 * function setup() {
	 *   var urlPath = getURLPath();
	 *   for (var i=0; i&lt;urlPath.length; i++) {
	 *     text(urlPath[i], 10, i*20+20);
	 *   }
	 * }
	 * </code></div>
	 */
	p5.prototype.getURLPath = function() {
	  return location.pathname.split('/').filter(function(v){return v!=='';});
	};
	/**
	 * Gets the current URL params as an Object.
	 * @method getURLParams
	 * @return {Object} URL params
	 * @example
	 * <div class='norender'>
	 * <code>
	 * // Example: http://p5js.org?year=2014&month=May&day=15
	 *
	 * function setup() {
	 *   var params = getURLParams();
	 *   text(params.day, 10, 20);
	 *   text(params.month, 10, 40);
	 *   text(params.year, 10, 60);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.getURLParams = function() {
	  var re = /[?&]([^&=]+)(?:[&=])([^&=]+)/gim;
	  var m;
	  var v={};
	  while ((m = re.exec(location.search)) != null) {
	    if (m.index === re.lastIndex) {
	      re.lastIndex++;
	    }
	    v[m[1]]=m[2];
	  }
	  return v;
	};
	
	module.exports = p5;
	
	},{"./constants":47,"./core":48}],51:[function(_dereq_,module,exports){
	/**
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	var doFriendlyWelcome = false; // TEMP until we get it all working LM
	
	// -- Borrowed from jQuery 1.11.3 --
	var class2type = {};
	var toString = class2type.toString;
	var names = ['Boolean', 'Number', 'String', 'Function',
	             'Array', 'Date', 'RegExp', 'Object', 'Error'];
	for (var n=0; n<names.length; n++) {
	  class2type[ '[object ' + names[n] + ']' ] = names[n].toLowerCase();
	}
	var getType = function( obj ) {
	  if ( obj == null ) {
	    return obj + '';
	  }
	  return typeof obj === 'object' || typeof obj === 'function' ?
	    class2type[ toString.call(obj) ] || 'object' :
	    typeof obj;
	};
	var isArray = Array.isArray || function( obj ) {
	  return getType(obj) === 'array';
	};
	var isNumeric =function( obj ) {
	  // parseFloat NaNs numeric-cast false positives (null|true|false|"")
	  // ...but misinterprets leading-number strings, particularly hex literals
	  // subtraction forces infinities to NaN
	  // adding 1 corrects loss of precision from parseFloat (#15100)
	  return !isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	};
	// -- End borrow --
	
	/**
	 * Checks the definition type against the argument type
	 * If any of these passes (in order), it matches:
	 *
	 * - p5.* definitions are checked with instanceof
	 * - Booleans are let through (everything is truthy or falsey)
	 * - Lowercase of the definition is checked against the js type
	 * - Number types are checked to see if they are numerically castable
	 */
	var numberTypes = ['Number', 'Integer', 'Number/Constant'];
	function typeMatches(defType, argType, arg) {
	  if(defType.match(/^p5\./)) {
	    var parts = defType.split('.');
	    return arg instanceof p5[parts[1]];
	  }
	  return defType === 'Boolean' || // Anything is truthy, cover in Debug Guide
	    (defType.toLowerCase() === argType) ||
	    (numberTypes.indexOf(defType) > -1 && isNumeric(arg));
	}
	
	/**
	 * Prints out a fancy, colorful message to the console log
	 *
	 * @param  {String}               message the words to be said
	 * @param  {String}               func    the name of the function to link
	 * @param  {Integer/Color String} color   CSS color string or error type
	 *
	 * @return console logs
	 */
	// Wrong number of params, undefined param, wrong type
	var PARAM_COUNT = 0;
	var EMPTY_VAR = 1;
	var WRONG_TYPE = 2;
	var FILE_LOAD = 3;
	// p5.js blue, p5.js orange, auto dark green; fallback p5.js darkened magenta
	// See testColors below for all the color codes and names
	var typeColors = ['#2D7BB6', '#EE9900', '#4DB200', '#C83C00'];
	function report(message, func, color) {
	  if(doFriendlyWelcome){
	    friendlyWelcome();
	    doFriendlyWelcome =false;
	  }
	  if ('undefined' === getType(color)) {
	    color   = '#B40033'; // dark magenta
	  } else if (getType(color) === 'number') { // Type to color
	    color = typeColors[color];
	  }
	  // LM TEMP commenting this out until we get the whole system working
	  // if (func.substring(0,4) === 'load'){
	  //   console.log(
	  //     '%c> p5.js says: '+message+'%c'+
	  //     '[https://github.com/processing/p5.js/wiki/Local-server]',
	  //     'background-color:' + color + ';color:#FFF;',
	  //     'background-color:transparent;color:' + color +';',
	  //     'background-color:' + color + ';color:#FFF;',
	  //     'background-color:transparent;color:' + color +';'
	  //   );
	  // }
	  // else{
	  //   console.log(
	  //     '%c> p5.js says: '+message+'%c [http://p5js.org/reference/#p5/'+func+
	  //     ']', 'background-color:' + color + ';color:#FFF;',
	  //     'background-color:transparent;color:' + color +';'
	  //   );
	  // }
	}
	
	/**
	 * Validate all the parameters of a function for number and type
	 * NOTE THIS FUNCTION IS TEMPORARILY DISABLED UNTIL FURTHER WORK
	 * AND UPDATES ARE IMPLEMENTED. -LMCCART
	 *
	 * @param  {String} func  name of function we're checking
	 * @param  {Array}  args  pass of the JS default arguments array
	 * @param  {Array}  types List of types accepted ['Number', 'String, ...] OR
	 *                        a list of lists for each format: [
	 *                          ['String', 'Number', 'Number'],
	 *                          ['String', 'Number', 'Number', 'Number', 'Number'
	 *                        ]
	 *
	 * @return console logs
	 */
	p5.prototype._validateParameters = function(func, args, types) {
	  if (!isArray(types[0])) {
	    types = [types];
	  }
	  // Check number of parameters
	  // Example: "You wrote ellipse(X,X,X). ellipse was expecting 4
	  //          parameters. Try ellipse(X,X,X,X)."
	  var diff = Math.abs(args.length-types[0].length);
	  var message, tindex = 0;
	  for (var i=1, len=types.length; i<len; i++) {
	    var d = Math.abs(args.length-types[i].length);
	    if (d <= diff) {
	      tindex = i;
	      diff = d;
	    }
	  }
	  var symbol = 'X'; // Parameter placeholder
	  if(diff > 0) {
	    message = 'You wrote ' + func + '(';
	    // Concat an appropriate number of placeholders for call
	    if (args.length > 0) {
	      message += symbol + Array(args.length).join(',' + symbol);
	    }
	    message += '). ' + func + ' was expecting ' + types[tindex].length +
	      ' parameters. Try ' + func + '(';
	    // Concat an appropriate number of placeholders for definition
	    if (types[tindex].length > 0) {
	      message += symbol + Array(types[tindex].length).join(',' + symbol);
	    }
	    message += ').';
	    // If multiple definitions
	    if (types.length > 1) {
	      message += ' ' + func + ' takes different numbers of parameters ' +
	        'depending on what you want to do. Click this link to learn more: ';
	    }
	    report(message, func, PARAM_COUNT);
	  }
	  // Type checking
	  // Example: "It looks like ellipse received an empty variable in spot #2."
	  // Example: "ellipse was expecting a number for parameter #1,
	  //           received "foo" instead."
	  for (var format=0; format<types.length; format++) {
	    for (var p=0; p < types[format].length && p < args.length; p++) {
	      var defType = types[format][p];
	      var argType = getType(args[p]);
	      if ('undefined' === argType || null === argType) {
	        report('It looks like ' + func +
	          ' received an empty variable in spot #' + (p+1) +
	          '. If not intentional, this is often a problem with scope: ' +
	          '[link to scope].', func, EMPTY_VAR);
	      } else if (defType !== '*' && !typeMatches(defType, argType, args[p])) {
	        message = func + ' was expecting a ' + defType.toLowerCase() +
	          ' for parameter #' + (p+1) + ', received ';
	        // Wrap strings in quotes
	        message += 'string' === argType ? '"' + args[p] + '"' : args[p];
	        message += ' instead.';
	        // If multiple definitions
	        if (types.length > 1) {
	          message += ' ' + func + ' takes different numbers of parameters ' +
	            'depending on what you want to do. ' +
	            'Click this link to learn more:';
	        }
	        report(message, func, WRONG_TYPE);
	      }
	    }
	  }
	};
	/*
	 * NOTE THIS FUNCTION IS TEMPORARILY DISABLED UNTIL FURTHER WORK
	 * AND UPDATES ARE IMPLEMENTED. -LMCCART
	 */
	p5.prototype._validateParameters = function() {
	  return true;
	};
	
	var errorCases = {
	  '0': {
	    fileType: 'image',
	    method: 'loadImage',
	    message: ' hosting the image online,'
	  },
	  '1': {
	    fileType: 'XML file',
	    method: 'loadXML'
	  },
	  '2': {
	    fileType: 'table file',
	    method: 'loadTable'
	  },
	  '3': {
	    fileType: 'text file',
	    method: 'loadStrings'
	  }
	};
	p5._friendlyFileLoadError = function (errorType, filePath) {
	  var errorInfo = errorCases[ errorType ];
	  var message = 'It looks like there was a problem' +
	  ' loading your ' + errorInfo.fileType + '.' +
	  ' Try checking if the file path%c [' + filePath + '] %cis correct,' +
	  (errorInfo.message || '') + ' or running a local server.';
	  report(message, errorInfo.method, FILE_LOAD);
	};
	
	function friendlyWelcome() {
	  // p5.js brand - magenta: #ED225D
	  var astrixBgColor = 'transparent';
	  var astrixTxtColor = '#ED225D';
	  var welcomeBgColor = '#ED225D';
	  var welcomeTextColor = 'white';
	  console.log(
	  '%c    _ \n'+
	  ' /\\| |/\\ \n'+
	  ' \\ ` \' /  \n'+
	  ' / , . \\  \n'+
	  ' \\/|_|\\/ '+
	  '\n\n%c> p5.js says: Welcome! '+
	  'This is your friendly debugger. ' +
	  'To turn me off switch to using “p5.min.js”.',
	  'background-color:'+astrixBgColor+';color:' + astrixTxtColor +';',
	  'background-color:'+welcomeBgColor+';color:' + welcomeTextColor +';'
	  );
	}
	
	/**
	 * Prints out all the colors in the color pallete with white text.
	 * For color blindness testing.
	 */
	/* function testColors() {
	  var str = 'A box of biscuits, a box of mixed biscuits and a biscuit mixer';
	  report(str, 'println', '#ED225D'); // p5.js magenta
	  report(str, 'println', '#2D7BB6'); // p5.js blue
	  report(str, 'println', '#EE9900'); // p5.js orange
	  report(str, 'println', '#A67F59'); // p5.js light brown
	  report(str, 'println', '#704F21'); // p5.js gold
	  report(str, 'println', '#1CC581'); // auto cyan
	  report(str, 'println', '#FF6625'); // auto orange
	  report(str, 'println', '#79EB22'); // auto green
	  report(str, 'println', '#B40033'); // p5.js darkened magenta
	  report(str, 'println', '#084B7F'); // p5.js darkened blue
	  report(str, 'println', '#945F00'); // p5.js darkened orange
	  report(str, 'println', '#6B441D'); // p5.js darkened brown
	  report(str, 'println', '#2E1B00'); // p5.js darkened gold
	  report(str, 'println', '#008851'); // auto dark cyan
	  report(str, 'println', '#C83C00'); // auto dark orange
	  report(str, 'println', '#4DB200'); // auto dark green
	} */
	
	// This is a list of p5 functions/variables that are commonly misused
	// by beginners at top-level code, outside of setup/draw. We'd like to
	// detect these errors and help the user by suggesting they move them
	// into setup/draw.
	//
	// For more details, see https://github.com/processing/p5.js/issues/1121.
	var misusedAtTopLevelCode = [
	  'color',
	  'random'
	];
	
	function helpForMisusedAtTopLevelCode(e) {
	  misusedAtTopLevelCode.forEach(function(name) {
	    if (e.message && e.message.indexOf(name) !== -1) {
	      console.log('%c Did you just try to use p5.js\'s \'' + name + '\' ' +
	                  'function or variable? If so, you may want to ' +
	                  'move it into your sketch\'s setup() function.',
	                  'color: #B40033' /* Dark magenta */);
	    }
	  });
	}
	
	if (document.readyState !== 'complete') {
	  window.addEventListener('error', helpForMisusedAtTopLevelCode, false);
	
	  // Our job is only to catch ReferenceErrors that are thrown when
	  // global (non-instance mode) p5 APIs are used at the top-level
	  // scope of a file, so we'll unbind our error listener now to make
	  // sure we don't log false positives later.
	  window.addEventListener('load', function() {
	    window.removeEventListener('error', helpForMisusedAtTopLevelCode, false);
	  });
	}
	
	module.exports = p5;
	
	},{"./core":48}],52:[function(_dereq_,module,exports){
	/**
	 * @module DOM
	 * @submodule DOM
	 * @for p5.Element
	 */
	
	var p5 = _dereq_('./core');
	
	/**
	 * Base class for all elements added to a sketch, including canvas,
	 * graphics buffers, and other HTML elements. Methods in blue are
	 * included in the core functionality, methods in brown are added
	 * with the <a href="http://p5js.org/libraries/">p5.dom library</a>.
	 * It is not called directly, but p5.Element
	 * objects are created by calling createCanvas, createGraphics,
	 * or in the p5.dom library, createDiv, createImg, createInput, etc.
	 *
	 * @class p5.Element
	 * @constructor
	 * @param {String} elt DOM node that is wrapped
	 * @param {Object} [pInst] pointer to p5 instance
	 */
	p5.Element = function(elt, pInst) {
	  /**
	   * Underlying HTML element. All normal HTML methods can be called on this.
	   *
	   * @property elt
	   */
	  this.elt = elt;
	  this._pInst = pInst;
	  this._events = {};
	  this.width = this.elt.offsetWidth;
	  this.height = this.elt.offsetHeight;
	};
	
	/**
	 *
	 * Attaches the element to the parent specified. A way of setting
	 * the container for the element. Accepts either a string ID, DOM
	 * node, or p5.Element. If no arguments given, parent node is returned.
	 *
	 * @method parent
	 * @param  {String|Object} parent the ID, DOM node, or p5.Element
	 *                         of desired parent element
	 * @return {p5.Element}
	 * @example
	 * <div class="norender"><code>
	 * // in the html file:
	 * &lt;div id="myContainer">&lt;/div>
	 * // in the js file:
	 * var cnv = createCanvas(100, 100);
	 * cnv.parent("myContainer");
	 * </code></div>
	 * <div class='norender'><code>
	 * var div0 = createDiv('this is the parent');
	 * var div1 = createDiv('this is the child');
	 * div1.parent(div0); // use p5.Element
	 * </code></div>
	 * <div class='norender'><code>
	 * var div0 = createDiv('this is the parent');
	 * div0.id('apples');
	 * var div1 = createDiv('this is the child');
	 * div1.parent('apples'); // use id
	 * </code></div>
	 * <div class='norender'><code>
	 * var elt = document.getElementById('myParentDiv');
	 * var div1 = createDiv('this is the child');
	 * div1.parent(elt); // use element from page
	 * </code></div>
	 */
	p5.Element.prototype.parent = function(p) {
	  if (arguments.length === 0){
	    return this.elt.parentNode;
	  } else {
	    if (typeof p === 'string') {
	      if (p[0] === '#') {
	        p = p.substring(1);
	      }
	      p = document.getElementById(p);
	    } else if (p instanceof p5.Element) {
	      p = p.elt;
	    }
	    p.appendChild(this.elt);
	    return this;
	  }
	};
	
	/**
	 *
	 * Sets the ID of the element
	 *
	 * @method id
	 * @param  {String} id ID of the element
	 * @return {p5.Element}
	 */
	p5.Element.prototype.id = function(id) {
	  if (arguments.length === 0) {
	    return this.elt.id;
	  } else {
	    this.elt.id = id;
	    this.width = this.elt.offsetWidth;
	    this.height = this.elt.offsetHeight;
	    return this;
	  }
	};
	
	/**
	 *
	 * Adds given class to the element
	 *
	 * @method class
	 * @param  {String} class class to add
	 * @return {p5.Element}
	 */
	p5.Element.prototype.class = function(c) {
	  if (arguments.length === 0) {
	    return this.elt.className;
	  } else {
	    this.elt.className = c;
	    this.width = this.elt.offsetWidth;
	    this.height = this.elt.offsetHeight;
	    return this;
	  }
	};
	
	/**
	 * The .mousePressed() function is called once after every time a
	 * mouse button is pressed over the element. This can be used to
	 * attach element specific event listeners.
	 *
	 * @method mousePressed
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    pressed over the element.
	 * @return {p5.Element}
	 * @example
	 * <div class='norender'><code>
	 * var cnv;
	 * var d;
	 * var g;
	 * function setup() {
	 *   cnv = createCanvas(100, 100);
	 *   cnv.mousePressed(changeGray); // attach listener for
	 *                                 // canvas click only
	 *   d = 10;
	 *   g = 100;
	 * }
	 *
	 * function draw() {
	 *   background(g);
	 *   ellipse(width/2, height/2, d, d);
	 * }
	 *
	 * // this function fires with any click anywhere
	 * function mousePressed() {
	 *   d = d + 10;
	 * }
	 *
	 * // this function fires only when cnv is clicked
	 * function changeGray() {
	 *   g = random(0, 255);
	 * }
	 * </code></div>
	 *
	 */
	p5.Element.prototype.mousePressed = function (fxn) {
	  attachListener('mousedown', fxn, this);
	  attachListener('touchstart', fxn, this);
	  return this;
	};
	
	/**
	 * The .mouseWheel() function is called once after every time a
	 * mouse wheel is scrolled over the element. This can be used to
	 * attach element specific event listeners.<br><br>
	 * The event.wheelDelta or event.detail property returns negative values if
	 * the mouse wheel if rotated up or away from the user and positive in the
	 * other direction. On OS X with "natural" scrolling enabled, the values are
	 * opposite.
	 *
	 * @method mouseWheel
	 * @param  {Function} fxn function to be fired when mouse wheel is
	 *                    scrolled over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.mouseWheel = function (fxn) {
	  attachListener('wheel', fxn, this);
	  return this;
	};
	
	/**
	 * The .mouseReleased() function is called once after every time a
	 * mouse button is released over the element. This can be used to
	 * attach element specific event listeners.
	 *
	 * @method mouseReleased
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    released over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.mouseReleased = function (fxn) {
	  attachListener('mouseup', fxn, this);
	  attachListener('touchend', fxn, this);
	  return this;
	};
	
	
	/**
	 * The .mouseClicked() function is called once after a mouse button is
	 * pressed and released over the element. This can be used to
	 * attach element specific event listeners.
	 *
	 * @method mouseClicked
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    clicked over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.mouseClicked = function (fxn) {
	  attachListener('click', fxn, this);
	  return this;
	};
	
	/**
	 * The .mouseMoved() function is called once every time a
	 * mouse moves over the element. This can be used to attach an
	 * element specific event listener.
	 *
	 * @method mouseMoved
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    moved over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.mouseMoved = function (fxn) {
	  attachListener('mousemove', fxn, this);
	  attachListener('touchmove', fxn, this);
	  return this;
	};
	
	/**
	 * The .mouseOver() function is called once after every time a
	 * mouse moves onto the element. This can be used to attach an
	 * element specific event listener.
	 *
	 * @method mouseOver
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    moved over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.mouseOver = function (fxn) {
	  attachListener('mouseover', fxn, this);
	  return this;
	};
	
	
	/**
	 * The .changed() function is called when the value of an
	 * element is changed.
	 * This can be used to attach an element specific event listener.
	 *
	 * @method changed
	 * @param  {Function} fxn function to be fired when the value of an
	 * element changes.
	 * @return {p5.Element}
	 * @example
	 * <div><code>
	 * var sel;
	 *
	 * function setup() {
	 *   textAlign(CENTER);
	 *   background(200);
	 *   sel = createSelect();
	 *   sel.position(10, 10);
	 *   sel.option('pear');
	 *   sel.option('kiwi');
	 *   sel.option('grape');
	 *   sel.changed(mySelectEvent);
	 * }
	 *
	 * function mySelectEvent() {
	 *   var item = sel.value();
	 *   background(200);
	 *   text("it's a "+item+"!", 50, 50);
	 * }
	 * </code></div>
	 * <div><code>
	 * var checkbox;
	 * var cnv;
	 *
	 * function setup() {
	 *   checkbox = createCheckbox(" fill");
	 *   checkbox.changed(changeFill);
	 *   cnv = createCanvas(100, 100);
	 *   cnv.position(0, 30);
	 *   noFill();
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 *   ellipse(50, 50, 50, 50);
	 * }
	 *
	 * function changeFill() {
	 *   if (checkbox.checked()) {
	 *     fill(0);
	 *   } else {
	 *     noFill();
	 *   }
	 * }
	 * </code></div>
	 */
	p5.Element.prototype.changed = function (fxn) {
	  attachListener('change', fxn, this);
	  return this;
	};
	
	/**
	 * The .input() function is called when any user input is
	 * detected with an element. The input event is often used
	 * to detect keystrokes in a input element, or changes on a
	 * slider element. This can be used to attach an element specific
	 * event listener.
	 *
	 * @method input
	 * @param  {Function} fxn function to be fired on user input.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.input = function (fxn) {
	  attachListener('input', fxn, this);
	  return this;
	};
	
	/**
	 * The .mouseOut() function is called once after every time a
	 * mouse moves off the element. This can be used to attach an
	 * element specific event listener.
	 *
	 * @method mouseOut
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    moved off the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.mouseOut = function (fxn) {
	  attachListener('mouseout', fxn, this);
	  return this;
	};
	
	/**
	 * The .touchStarted() function is called once after every time a touch is
	 * registered. This can be used to attach element specific event listeners.
	 *
	 * @method touchStarted
	 * @param  {Function} fxn function to be fired when touch is
	 *                    started over the element.
	 * @return {p5.Element}
	 * @example
	 * <div class='norender'><code>
	 * var cnv;
	 * var d;
	 * var g;
	 * function setup() {
	 *   cnv = createCanvas(100, 100);
	 *   cnv.touchStarted(changeGray); // attach listener for
	 *                                 // canvas click only
	 *   d = 10;
	 *   g = 100;
	 * }
	 *
	 * function draw() {
	 *   background(g);
	 *   ellipse(width/2, height/2, d, d);
	 * }
	 *
	 * // this function fires with any touch anywhere
	 * function touchStarted() {
	 *   d = d + 10;
	 * }
	 *
	 * // this function fires only when cnv is clicked
	 * function changeGray() {
	 *   g = random(0, 255);
	 * }
	 * </code></div>
	 *
	 */
	p5.Element.prototype.touchStarted = function (fxn) {
	  attachListener('touchstart', fxn, this);
	  attachListener('mousedown', fxn, this);
	  return this;
	};
	
	/**
	 * The .touchMoved() function is called once after every time a touch move is
	 * registered. This can be used to attach element specific event listeners.
	 *
	 * @method touchMoved
	 * @param  {Function} fxn function to be fired when touch is moved
	 *                    over the element.
	 * @return {p5.Element}
	 * @example
	 * <div class='norender'><code>
	 * var cnv;
	 * var g;
	 * function setup() {
	 *   cnv = createCanvas(100, 100);
	 *   cnv.touchMoved(changeGray); // attach listener for
	 *                               // canvas click only
	 *   g = 100;
	 * }
	 *
	 * function draw() {
	 *   background(g);
	 * }
	 *
	 * // this function fires only when cnv is clicked
	 * function changeGray() {
	 *   g = random(0, 255);
	 * }
	 * </code></div>
	 *
	 */
	p5.Element.prototype.touchMoved = function (fxn) {
	  attachListener('touchmove', fxn, this);
	  attachListener('mousemove', fxn, this);
	  return this;
	};
	
	/**
	 * The .touchEnded() function is called once after every time a touch is
	 * registered. This can be used to attach element specific event listeners.
	 *
	 * @method touchEnded
	 * @param  {Function} fxn function to be fired when touch is
	 *                    ended over the element.
	 * @return {p5.Element}
	 * @example
	 * <div class='norender'><code>
	 * var cnv;
	 * var d;
	 * var g;
	 * function setup() {
	 *   cnv = createCanvas(100, 100);
	 *   cnv.touchEnded(changeGray);   // attach listener for
	 *                                 // canvas click only
	 *   d = 10;
	 *   g = 100;
	 * }
	 *
	 * function draw() {
	 *   background(g);
	 *   ellipse(width/2, height/2, d, d);
	 * }
	 *
	 * // this function fires with any touch anywhere
	 * function touchEnded() {
	 *   d = d + 10;
	 * }
	 *
	 * // this function fires only when cnv is clicked
	 * function changeGray() {
	 *   g = random(0, 255);
	 * }
	 * </code></div>
	 *
	 */
	p5.Element.prototype.touchEnded = function (fxn) {
	  attachListener('touchend', fxn, this);
	  attachListener('mouseup', fxn, this);
	  return this;
	};
	
	
	
	/**
	 * The .dragOver() function is called once after every time a
	 * file is dragged over the element. This can be used to attach an
	 * element specific event listener.
	 *
	 * @method dragOver
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    dragged over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.dragOver = function (fxn) {
	  attachListener('dragover', fxn, this);
	  return this;
	};
	
	/**
	 * The .dragLeave() function is called once after every time a
	 * dragged file leaves the element area. This can be used to attach an
	 * element specific event listener.
	 *
	 * @method dragLeave
	 * @param  {Function} fxn function to be fired when mouse is
	 *                    dragged over the element.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.dragLeave = function (fxn) {
	  attachListener('dragleave', fxn, this);
	  return this;
	};
	
	/**
	 * The .drop() function is called for each file dropped on the element.
	 * It requires a callback that is passed a p5.File object.  You can
	 * optionally pass two callbacks, the first one (required) is triggered
	 * for each file dropped when the file is loaded.  The second (optional)
	 * is triggered just once when a file (or files) are dropped.
	 *
	 * @method drop
	 * @param  {Function} callback triggered when files are dropped.
	 * @param  {Function} callback to receive loaded file.
	 * @return {p5.Element}
	 */
	p5.Element.prototype.drop = function (callback, fxn) {
	  // Make a file loader callback and trigger user's callback
	  function makeLoader(theFile) {
	    // Making a p5.File object
	    var p5file = new p5.File(theFile);
	    return function(e) {
	      p5file.data = e.target.result;
	      callback(p5file);
	    };
	  }
	
	  // Is the file stuff supported?
	  if (window.File && window.FileReader && window.FileList && window.Blob) {
	
	    // If you want to be able to drop you've got to turn off
	    // a lot of default behavior
	    attachListener('dragover',function(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	    },this);
	
	    // If this is a drag area we need to turn off the default behavior
	    attachListener('dragleave',function(evt) {
	      evt.stopPropagation();
	      evt.preventDefault();
	    },this);
	
	    // If just one argument it's the callback for the files
	    if (arguments.length > 1) {
	      attachListener('drop', fxn, this);
	    }
	
	    // Deal with the files
	    attachListener('drop', function(evt) {
	
	      evt.stopPropagation();
	      evt.preventDefault();
	
	      // A FileList
	      var files = evt.dataTransfer.files;
	
	      // Load each one and trigger the callback
	      for (var i = 0; i < files.length; i++) {
	        var f = files[i];
	        var reader = new FileReader();
	        reader.onload = makeLoader(f);
	
	
	        // Text or data?
	        // This should likely be improved
	        if (f.type.indexOf('text') > -1) {
	          reader.readAsText(f);
	        } else {
	          reader.readAsDataURL(f);
	        }
	      }
	    }, this);
	  } else {
	    console.log('The File APIs are not fully supported in this browser.');
	  }
	
	  return this;
	};
	
	
	
	
	function attachListener(ev, fxn, ctx) {
	  // LM removing, not sure why we had this?
	  // var _this = ctx;
	  // var f = function (e) { fxn(e, _this); };
	  var f = fxn.bind(ctx);
	  ctx.elt.addEventListener(ev, f, false);
	  ctx._events[ev] = f;
	}
	
	/**
	 * Helper fxn for sharing pixel methods
	 *
	 */
	p5.Element.prototype._setProperty = function (prop, value) {
	  this[prop] = value;
	};
	
	
	module.exports = p5.Element;
	
	},{"./core":48}],53:[function(_dereq_,module,exports){
	/**
	 * @module Rendering
	 * @submodule Rendering
	 * @for p5
	 */
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('./constants');
	
	/**
	 * Thin wrapper around a renderer, to be used for creating a
	 * graphics buffer object. Use this class if you need
	 * to draw into an off-screen graphics buffer. The two parameters define the
	 * width and height in pixels. The fields and methods for this class are
	 * extensive, but mirror the normal drawing API for p5.
	 *
	 * @class p5.Graphics
	 * @constructor
	 * @extends p5.Element
	 * @param {String} elt DOM node that is wrapped
	 * @param {Object} [pInst] pointer to p5 instance
	 * @param {Boolean} whether we're using it as main canvas
	 */
	p5.Graphics = function(w, h, renderer, pInst) {
	
	  var r = renderer || constants.P2D;
	
	  var c = document.createElement('canvas');
	  var node = this._userNode || document.body;
	  node.appendChild(c);
	
	  p5.Element.call(this, c, pInst, false);
	  this._styles = [];
	  this.width = w;
	  this.height = h;
	  this._pixelDensity = pInst._pixelDensity;
	
	  if (r === constants.WEBGL) {
	    this._renderer = new p5.Renderer3D(c, pInst, false);
	  } else {
	    this._renderer = new p5.Renderer2D(c, pInst, false);
	  }
	
	  this._renderer.resize(w, h);
	  this._renderer._applyDefaults();
	
	  pInst._elements.push(this);
	
	  // bind methods and props of p5 to the new object
	  for (var p in p5.prototype) {
	    if (!this[p]) {
	      if (typeof p5.prototype[p] === 'function') {
	        this[p] = p5.prototype[p].bind(this);
	      } else {
	        this[p] = p5.prototype[p];
	      }
	    }
	  }
	
	  return this;
	};
	
	p5.Graphics.prototype = Object.create(p5.Element.prototype);
	
	module.exports = p5.Graphics;
	
	},{"./constants":47,"./core":48}],54:[function(_dereq_,module,exports){
	/**
	 * @module Rendering
	 * @submodule Rendering
	 * @for p5
	 */
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('../core/constants');
	
	/**
	 * Main graphics and rendering context, as well as the base API
	 * implementation for p5.js "core". To be used as the superclass for
	 * Renderer2D and Renderer3D classes, respecitvely.
	 *
	 * @class p5.Renderer
	 * @constructor
	 * @extends p5.Element
	 * @param {String} elt DOM node that is wrapped
	 * @param {Object} [pInst] pointer to p5 instance
	 * @param {Boolean} whether we're using it as main canvas
	 */
	p5.Renderer = function(elt, pInst, isMainCanvas) {
	  p5.Element.call(this, elt, pInst);
	  this.canvas = elt;
	  this._pInst = pInst;
	  if (isMainCanvas) {
	    this._isMainCanvas = true;
	    // for pixel method sharing with pimage
	    this._pInst._setProperty('_curElement', this);
	    this._pInst._setProperty('canvas', this.canvas);
	    this._pInst._setProperty('width', this.width);
	    this._pInst._setProperty('height', this.height);
	  } else { // hide if offscreen buffer by default
	    this.canvas.style.display = 'none';
	    this._styles = []; // non-main elt styles stored in p5.Renderer
	  }
	
	
	  this._textSize = 12;
	  this._textLeading = 15;
	  this._textFont = 'sans-serif';
	  this._textStyle = constants.NORMAL;
	  this._textAscent = null;
	  this._textDescent = null;
	
	
	  this._rectMode = constants.CORNER;
	  this._ellipseMode = constants.CENTER;
	  this._curveTightness = 0;
	  this._imageMode = constants.CORNER;
	
	  this._tint = null;
	  this._doStroke = true;
	  this._doFill = true;
	  this._strokeSet = false;
	  this._fillSet = false;
	  this._colorMode = constants.RGB;
	  this._colorMaxes = {
	    rgb: [255, 255, 255, 255],
	    hsb: [360, 100, 100, 1],
	    hsl: [360, 100, 100, 1]
	  };
	
	};
	
	p5.Renderer.prototype = Object.create(p5.Element.prototype);
	
	
	
	
	/**
	 * Resize our canvas element.
	 */
	p5.Renderer.prototype.resize = function(w, h) {
	  this.width = w;
	  this.height = h;
	  this.elt.width = w * this._pInst._pixelDensity;
	  this.elt.height = h * this._pInst._pixelDensity;
	  this.elt.style.width = w +'px';
	  this.elt.style.height = h + 'px';
	  if (this._isMainCanvas) {
	    this._pInst._setProperty('width', this.width);
	    this._pInst._setProperty('height', this.height);
	  }
	};
	
	p5.Renderer.prototype.textLeading = function(l) {
	
	  if (arguments.length && arguments[0]) {
	
	    this._setProperty('_textLeading', l);
	    return this;
	  }
	
	  return this._textLeading;
	};
	
	p5.Renderer.prototype.textSize = function(s) {
	
	  if (arguments.length && arguments[0]) {
	
	    this._setProperty('_textSize', s);
	    this._setProperty('_textLeading', s * constants._DEFAULT_LEADMULT);
	    return this._applyTextProperties();
	  }
	
	  return this._textSize;
	};
	
	p5.Renderer.prototype.textStyle = function(s) {
	
	  if (arguments.length && arguments[0]) {
	
	    if (s === constants.NORMAL ||
	      s === constants.ITALIC ||
	      s === constants.BOLD) {
	      this._setProperty('_textStyle', s);
	    }
	
	    return this._applyTextProperties();
	  }
	
	  return this._textStyle;
	};
	
	p5.Renderer.prototype.textAscent = function() {
	  if (this._textAscent === null) {
	    this._updateTextMetrics();
	  }
	  return this._textAscent;
	};
	
	p5.Renderer.prototype.textDescent = function() {
	
	  if (this._textDescent === null) {
	    this._updateTextMetrics();
	  }
	  return this._textDescent;
	};
	
	/**
	 * Helper fxn to check font type (system or otf)
	 */
	p5.Renderer.prototype._isOpenType = function(f) {
	
	  f = f || this._textFont;
	  return (typeof f === 'object' && f.font && f.font.supported);
	};
	
	p5.Renderer.prototype._updateTextMetrics = function() {
	
	  if (this._isOpenType()) {
	
	    this._setProperty('_textAscent', this._textFont._textAscent());
	    this._setProperty('_textDescent', this._textFont._textDescent());
	    return this;
	  }
	
	  // Adapted from http://stackoverflow.com/a/25355178
	  var text = document.createElement('span');
	  text.style.fontFamily = this._textFont;
	  text.style.fontSize = this._textSize + 'px';
	  text.innerHTML = 'ABCjgq|';
	
	  var block = document.createElement('div');
	  block.style.display = 'inline-block';
	  block.style.width = '1px';
	  block.style.height = '0px';
	
	  var container = document.createElement('div');
	  container.appendChild(text);
	  container.appendChild(block);
	
	  container.style.height = '0px';
	  container.style.overflow = 'hidden';
	  document.body.appendChild(container);
	
	  block.style.verticalAlign = 'baseline';
	  var blockOffset = calculateOffset(block);
	  var textOffset = calculateOffset(text);
	  var ascent = blockOffset[1] - textOffset[1];
	
	  block.style.verticalAlign = 'bottom';
	  blockOffset = calculateOffset(block);
	  textOffset = calculateOffset(text);
	  var height = blockOffset[1] - textOffset[1];
	  var descent = height - ascent;
	
	  document.body.removeChild(container);
	
	  this._setProperty('_textAscent', ascent);
	  this._setProperty('_textDescent', descent);
	
	  return this;
	};
	
	/**
	 * Helper fxn to measure ascent and descent.
	 * Adapted from http://stackoverflow.com/a/25355178
	 */
	function calculateOffset(object) {
	  var currentLeft = 0,
	    currentTop = 0;
	  if (object.offsetParent) {
	    do {
	      currentLeft += object.offsetLeft;
	      currentTop += object.offsetTop;
	    } while (object = object.offsetParent);
	  } else {
	    currentLeft += object.offsetLeft;
	    currentTop += object.offsetTop;
	  }
	  return [currentLeft, currentTop];
	}
	
	module.exports = p5.Renderer;
	
	},{"../core/constants":47,"./core":48}],55:[function(_dereq_,module,exports){
	
	var p5 = _dereq_('./core');
	var canvas = _dereq_('./canvas');
	var constants = _dereq_('./constants');
	var filters = _dereq_('../image/filters');
	
	_dereq_('./p5.Renderer');
	
	/**
	 * p5.Renderer2D
	 * The 2D graphics canvas renderer class.
	 * extends p5.Renderer
	 */
	var styleEmpty = 'rgba(0,0,0,0)';
	// var alphaThreshold = 0.00125; // minimum visible
	
	p5.Renderer2D = function(elt, pInst, isMainCanvas){
	  p5.Renderer.call(this, elt, pInst, isMainCanvas);
	  this.drawingContext = this.canvas.getContext('2d');
	  this._pInst._setProperty('drawingContext', this.drawingContext);
	  return this;
	};
	
	p5.Renderer2D.prototype = Object.create(p5.Renderer.prototype);
	
	p5.Renderer2D.prototype._applyDefaults = function() {
	  this.drawingContext.fillStyle = constants._DEFAULT_FILL;
	  this.drawingContext.strokeStyle = constants._DEFAULT_STROKE;
	  this.drawingContext.lineCap = constants.ROUND;
	  this.drawingContext.font = 'normal 12px sans-serif';
	};
	
	p5.Renderer2D.prototype.resize = function(w,h) {
	  p5.Renderer.prototype.resize.call(this, w,h);
	  this.drawingContext.scale(this._pInst._pixelDensity,
	                            this._pInst._pixelDensity);
	};
	
	//////////////////////////////////////////////
	// COLOR | Setting
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.background = function() {
	  this.drawingContext.save();
	  this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
	  this.drawingContext.scale(this._pInst._pixelDensity,
	                            this._pInst._pixelDensity);
	
	  if (arguments[0] instanceof p5.Image) {
	    this._pInst.image(arguments[0], 0, 0, this.width, this.height);
	  } else {
	    var curFill = this.drawingContext.fillStyle;
	    // create background rect
	    var color = this._pInst.color.apply(this._pInst, arguments);
	    var newFill = color.toString();
	    this.drawingContext.fillStyle = newFill;
	    this.drawingContext.fillRect(0, 0, this.width, this.height);
	    // reset fill
	    this.drawingContext.fillStyle = curFill;
	  }
	  this.drawingContext.restore();
	};
	
	p5.Renderer2D.prototype.clear = function() {
	  this.drawingContext.clearRect(0, 0, this.width, this.height);
	};
	
	p5.Renderer2D.prototype.fill = function() {
	
	  var ctx = this.drawingContext;
	  var color = this._pInst.color.apply(this._pInst, arguments);
	  ctx.fillStyle = color.toString();
	};
	
	p5.Renderer2D.prototype.stroke = function() {
	  var ctx = this.drawingContext;
	  var color = this._pInst.color.apply(this._pInst, arguments);
	  ctx.strokeStyle = color.toString();
	};
	
	//////////////////////////////////////////////
	// IMAGE | Loading & Displaying
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.image =
	  function (img, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
	  var cnv;
	  try {
	    if (this._tint) {
	      if (p5.MediaElement && img instanceof p5.MediaElement) {
	        img.loadPixels();
	      }
	      if (img.canvas) {
	        cnv = this._getTintedImageCanvas(img);
	      }
	    }
	    if (!cnv) {
	      cnv = img.canvas || img.elt;
	    }
	    this.drawingContext.drawImage(cnv, sx, sy, sWidth, sHeight, dx, dy,
	      dWidth, dHeight);
	  } catch (e) {
	    if (e.name !== 'NS_ERROR_NOT_AVAILABLE') {
	      throw e;
	    }
	  }
	};
	
	p5.Renderer2D.prototype._getTintedImageCanvas = function (img) {
	  if (!img.canvas) {
	    return img;
	  }
	  var pixels = filters._toPixels(img.canvas);
	  var tmpCanvas = document.createElement('canvas');
	  tmpCanvas.width = img.canvas.width;
	  tmpCanvas.height = img.canvas.height;
	  var tmpCtx = tmpCanvas.getContext('2d');
	  var id = tmpCtx.createImageData(img.canvas.width, img.canvas.height);
	  var newPixels = id.data;
	  for (var i = 0; i < pixels.length; i += 4) {
	    var r = pixels[i];
	    var g = pixels[i + 1];
	    var b = pixels[i + 2];
	    var a = pixels[i + 3];
	    newPixels[i] = r * this._tint[0] / 255;
	    newPixels[i + 1] = g * this._tint[1] / 255;
	    newPixels[i + 2] = b * this._tint[2] / 255;
	    newPixels[i + 3] = a * this._tint[3] / 255;
	  }
	  tmpCtx.putImageData(id, 0, 0);
	  return tmpCanvas;
	};
	
	
	//////////////////////////////////////////////
	// IMAGE | Pixels
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.blendMode = function(mode) {
	  this.drawingContext.globalCompositeOperation = mode;
	};
	p5.Renderer2D.prototype.blend = function() {
	  var currBlend = this.drawingContext.globalCompositeOperation;
	  var blendMode = arguments[arguments.length - 1];
	
	  var copyArgs = Array.prototype.slice.call(
	    arguments,
	    0,
	    arguments.length - 1
	  );
	
	  this.drawingContext.globalCompositeOperation = blendMode;
	  this._pInst.copy.apply(this._pInst, copyArgs);
	  this.drawingContext.globalCompositeOperation = currBlend;
	};
	
	p5.Renderer2D.prototype.copy = function () {
	  var srcImage, sx, sy, sw, sh, dx, dy, dw, dh;
	  if (arguments.length === 9) {
	    srcImage = arguments[0];
	    sx = arguments[1];
	    sy = arguments[2];
	    sw = arguments[3];
	    sh = arguments[4];
	    dx = arguments[5];
	    dy = arguments[6];
	    dw = arguments[7];
	    dh = arguments[8];
	  } else if (arguments.length === 8) {
	    srcImage = this._pInst;
	    sx = arguments[0];
	    sy = arguments[1];
	    sw = arguments[2];
	    sh = arguments[3];
	    dx = arguments[4];
	    dy = arguments[5];
	    dw = arguments[6];
	    dh = arguments[7];
	  } else {
	    throw new Error('Signature not supported');
	  }
	  p5.Renderer2D._copyHelper(srcImage, sx, sy, sw, sh, dx, dy, dw, dh);
	};
	
	p5.Renderer2D._copyHelper =
	function (srcImage, sx, sy, sw, sh, dx, dy, dw, dh) {
	  var s = srcImage.canvas.width / srcImage.width;
	  this.drawingContext.drawImage(srcImage.canvas,
	    s * sx, s * sy, s * sw, s * sh, dx, dy, dw, dh);
	};
	
	p5.Renderer2D.prototype.get = function(x, y, w, h) {
	  if (x === undefined && y === undefined &&
	      w === undefined && h === undefined){
	    x = 0;
	    y = 0;
	    w = this.width;
	    h = this.height;
	  } else if (w === undefined && h === undefined) {
	    w = 1;
	    h = 1;
	  }
	
	  // if the section does not overlap the canvas
	  if(x + w < 0 || y + h < 0 || x > this.width || y > this.height){
	    return [0, 0, 0, 255];
	  }
	
	  var ctx = this._pInst || this;
	
	  var pd = ctx._pixelDensity;
	
	  this.loadPixels.call(ctx);
	
	  // round down to get integer numbers
	  x = Math.floor(x);
	  y = Math.floor(y);
	
	  if (w === 1 && h === 1){
	
	    return [
	      ctx.pixels[pd*4*(y*this.width+x)],
	      ctx.pixels[pd*(4*(y*this.width+x)+1)],
	      ctx.pixels[pd*(4*(y*this.width+x)+2)],
	      ctx.pixels[pd*(4*(y*this.width+x)+3)]
	    ];
	  } else {
	    var sx = x * pd;
	    var sy = y * pd;
	    //auto constrain the width and height to
	    //dimensions of the source image
	    var dw = Math.min(w, ctx.width);
	    var dh = Math.min(h, ctx.height);
	    var sw = dw * pd;
	    var sh = dh * pd;
	
	    var region = new p5.Image(dw, dh);
	    region.canvas.getContext('2d').drawImage(this.canvas, sx, sy, sw, sh,
	      0, 0, dw, dh);
	
	    return region;
	  }
	};
	
	p5.Renderer2D.prototype.loadPixels = function () {
	  var pd = this._pixelDensity || this._pInst._pixelDensity;
	  var w = this.width * pd;
	  var h = this.height * pd;
	  var imageData = this.drawingContext.getImageData(0, 0, w, h);
	  // @todo this should actually set pixels per object, so diff buffers can
	  // have diff pixel arrays.
	  if (this._pInst) {
	    this._pInst._setProperty('imageData', imageData);
	    this._pInst._setProperty('pixels', imageData.data);
	  } else { // if called by p5.Image
	    this._setProperty('imageData', imageData);
	    this._setProperty('pixels', imageData.data);
	  }
	};
	
	p5.Renderer2D.prototype.set = function (x, y, imgOrCol) {
	  // round down to get integer numbers
	  x = Math.floor(x);
	  y = Math.floor(y);
	  if (imgOrCol instanceof p5.Image) {
	    this.drawingContext.save();
	    this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
	    this.drawingContext.scale(this._pInst._pixelDensity,
	      this._pInst._pixelDensity);
	    this.drawingContext.drawImage(imgOrCol.canvas, x, y);
	    this.loadPixels.call(this._pInst);
	    this.drawingContext.restore();
	  } else {
	    var ctx = this._pInst || this;
	    var r = 0, g = 0, b = 0, a = 0;
	    var idx = 4*((y * ctx._pixelDensity) *
	      (this.width * ctx._pixelDensity) + (x * ctx._pixelDensity));
	    if (!ctx.imageData) {
	      ctx.loadPixels.call(ctx);
	    }
	    if (typeof imgOrCol === 'number') {
	      if (idx < ctx.pixels.length) {
	        r = imgOrCol;
	        g = imgOrCol;
	        b = imgOrCol;
	        a = 255;
	        //this.updatePixels.call(this);
	      }
	    }
	    else if (imgOrCol instanceof Array) {
	      if (imgOrCol.length < 4) {
	        throw new Error('pixel array must be of the form [R, G, B, A]');
	      }
	      if (idx < ctx.pixels.length) {
	        r = imgOrCol[0];
	        g = imgOrCol[1];
	        b = imgOrCol[2];
	        a = imgOrCol[3];
	        //this.updatePixels.call(this);
	      }
	    } else if (imgOrCol instanceof p5.Color) {
	      if (idx < ctx.pixels.length) {
	        r = imgOrCol.levels[0];
	        g = imgOrCol.levels[1];
	        b = imgOrCol.levels[2];
	        a = imgOrCol.levels[3];
	        //this.updatePixels.call(this);
	      }
	    }
	    // loop over pixelDensity * pixelDensity
	    for (var i = 0; i < ctx._pixelDensity; i++) {
	      for (var j = 0; j < ctx._pixelDensity; j++) {
	        // loop over
	        idx = 4*((y * ctx._pixelDensity + j) * this.width *
	          ctx._pixelDensity + (x * ctx._pixelDensity + i));
	        ctx.pixels[idx] = r;
	        ctx.pixels[idx+1] = g;
	        ctx.pixels[idx+2] = b;
	        ctx.pixels[idx+3] = a;
	      }
	    }
	  }
	};
	
	p5.Renderer2D.prototype.updatePixels = function (x, y, w, h) {
	  var pd = this._pixelDensity || this._pInst._pixelDensity;
	  if (x === undefined &&
	      y === undefined &&
	      w === undefined &&
	      h === undefined) {
	    x = 0;
	    y = 0;
	    w = this.width;
	    h = this.height;
	  }
	  w *= pd;
	  h *= pd;
	
	  if (this._pInst) {
	    this.drawingContext.putImageData(this._pInst.imageData, x, y, 0, 0, w, h);
	  } else {
	    this.drawingContext.putImageData(this.imageData, x, y, 0, 0, w, h);
	  }
	};
	
	//////////////////////////////////////////////
	// SHAPE | 2D Primitives
	//////////////////////////////////////////////
	
	/**
	 * Generate a cubic Bezier representing an arc on the unit circle of total
	 * angle `size` radians, beginning `start` radians above the x-axis. Up to
	 * four of these curves are combined to make a full arc.
	 *
	 * See www.joecridge.me/bezier.pdf for an explanation of the method.
	 */
	p5.Renderer2D.prototype._acuteArcToBezier =
	  function _acuteArcToBezier(start, size) {
	  // Evauate constants.
	  var alpha = size / 2.0,
	    cos_alpha = Math.cos(alpha),
	    sin_alpha = Math.sin(alpha),
	    cot_alpha = 1.0 / Math.tan(alpha),
	    phi = start + alpha,  // This is how far the arc needs to be rotated.
	    cos_phi = Math.cos(phi),
	    sin_phi = Math.sin(phi),
	    lambda = (4.0 - cos_alpha) / 3.0,
	    mu = sin_alpha + (cos_alpha - lambda) * cot_alpha;
	
	  // Return rotated waypoints.
	  return {
	    ax: Math.cos(start),
	    ay: Math.sin(start),
	    bx: lambda * cos_phi + mu * sin_phi,
	    by: lambda * sin_phi - mu * cos_phi,
	    cx: lambda * cos_phi - mu * sin_phi,
	    cy: lambda * sin_phi + mu * cos_phi,
	    dx: Math.cos(start + size),
	    dy: Math.sin(start + size)
	  };
	};
	
	p5.Renderer2D.prototype.arc =
	  function(x, y, w, h, start, stop, mode) {
	  var ctx = this.drawingContext;
	  var vals = canvas.arcModeAdjust(x, y, w, h, this._ellipseMode);
	  var rx = vals.w / 2.0;
	  var ry = vals.h / 2.0;
	  var epsilon = 0.00001;  // Smallest visible angle on displays up to 4K.
	  var arcToDraw = 0;
	  var curves = [];
	
	  // Create curves
	  while(stop - start > epsilon) {
	    arcToDraw = Math.min(stop - start, constants.HALF_PI);
	    curves.push(this._acuteArcToBezier(start, arcToDraw));
	    start += arcToDraw;
	  }
	
	  // Fill curves
	  if (this._doFill) {
	    ctx.beginPath();
	    curves.forEach(function (curve, index) {
	      if (index === 0) {
	        ctx.moveTo(vals.x + curve.ax * rx, vals.y + curve.ay * ry);
	      }
	      ctx.bezierCurveTo(vals.x + curve.bx * rx, vals.y + curve.by * ry,
	                        vals.x + curve.cx * rx, vals.y + curve.cy * ry,
	                        vals.x + curve.dx * rx, vals.y + curve.dy * ry);
	    });
	    if (mode === constants.PIE || mode == null) {
	      ctx.lineTo(vals.x, vals.y);
	    }
	    ctx.closePath();
	    ctx.fill();
	  }
	
	  // Stroke curves
	  if (this._doStroke) {
	    ctx.beginPath();
	    curves.forEach(function (curve, index) {
	      if (index === 0) {
	        ctx.moveTo(vals.x + curve.ax * rx, vals.y + curve.ay * ry);
	      }
	      ctx.bezierCurveTo(vals.x + curve.bx * rx, vals.y + curve.by * ry,
	                        vals.x + curve.cx * rx, vals.y + curve.cy * ry,
	                        vals.x + curve.dx * rx, vals.y + curve.dy * ry);
	    });
	    if (mode === constants.PIE) {
	      ctx.lineTo(vals.x, vals.y);
	      ctx.closePath();
	    } else if (mode === constants.CHORD) {
	      ctx.closePath();
	    }
	    ctx.stroke();
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.ellipse = function(x, y, w, h) {
	  var ctx = this.drawingContext;
	  var doFill = this._doFill, doStroke = this._doStroke;
	  if (doFill && !doStroke) {
	    if(ctx.fillStyle === styleEmpty) {
	      return this;
	    }
	  } else if (!doFill && doStroke) {
	    if(ctx.strokeStyle === styleEmpty) {
	      return this;
	    }
	  }
	  var vals = canvas.modeAdjust(x, y, w, h, this._ellipseMode);
	  var kappa = 0.5522847498,
	    ox = (vals.w / 2) * kappa, // control point offset horizontal
	    oy = (vals.h / 2) * kappa, // control point offset vertical
	    xe = vals.x + vals.w,      // x-end
	    ye = vals.y + vals.h,      // y-end
	    xm = vals.x + vals.w / 2,  // x-middle
	    ym = vals.y + vals.h / 2;  // y-middle
	  ctx.beginPath();
	  ctx.moveTo(vals.x, ym);
	  ctx.bezierCurveTo(vals.x, ym - oy, xm - ox, vals.y, xm, vals.y);
	  ctx.bezierCurveTo(xm + ox, vals.y, xe, ym - oy, xe, ym);
	  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	  ctx.bezierCurveTo(xm - ox, ye, vals.x, ym + oy, vals.x, ym);
	  ctx.closePath();
	  if (doFill) {
	    ctx.fill();
	  }
	  if (doStroke) {
	    ctx.stroke();
	  }
	};
	
	p5.Renderer2D.prototype.line = function(x1, y1, x2, y2) {
	  var ctx = this.drawingContext;
	  if (!this._doStroke) {
	    return this;
	  } else if(ctx.strokeStyle === styleEmpty){
	    return this;
	  }
	  // Translate the line by (0.5, 0.5) to draw it crisp
	  if (ctx.lineWidth % 2 === 1) {
	    ctx.translate(0.5, 0.5);
	  }
	  ctx.beginPath();
	  ctx.moveTo(x1, y1);
	  ctx.lineTo(x2, y2);
	  ctx.stroke();
	  if (ctx.lineWidth % 2 === 1) {
	    ctx.translate(-0.5, -0.5);
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.point = function(x, y) {
	  var ctx = this.drawingContext;
	  var s = ctx.strokeStyle;
	  var f = ctx.fillStyle;
	  if (!this._doStroke) {
	    return this;
	  } else if(ctx.strokeStyle === styleEmpty){
	    return this;
	  }
	  x = Math.round(x);
	  y = Math.round(y);
	  ctx.fillStyle = s;
	  if (ctx.lineWidth > 1) {
	    ctx.beginPath();
	    ctx.arc(
	      x,
	      y,
	      ctx.lineWidth / 2,
	      0,
	      constants.TWO_PI,
	      false
	    );
	    ctx.fill();
	  } else {
	    ctx.fillRect(x, y, 1, 1);
	  }
	  ctx.fillStyle = f;
	};
	
	p5.Renderer2D.prototype.quad =
	  function(x1, y1, x2, y2, x3, y3, x4, y4) {
	  var ctx = this.drawingContext;
	  var doFill = this._doFill, doStroke = this._doStroke;
	  if (doFill && !doStroke) {
	    if(ctx.fillStyle === styleEmpty) {
	      return this;
	    }
	  } else if (!doFill && doStroke) {
	    if(ctx.strokeStyle === styleEmpty) {
	      return this;
	    }
	  }
	  ctx.beginPath();
	  ctx.moveTo(x1, y1);
	  ctx.lineTo(x2, y2);
	  ctx.lineTo(x3, y3);
	  ctx.lineTo(x4, y4);
	  ctx.closePath();
	  if (doFill) {
	    ctx.fill();
	  }
	  if (doStroke) {
	    ctx.stroke();
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.rect = function(x, y, w, h, tl, tr, br, bl) {
	  var ctx = this.drawingContext;
	  var doFill = this._doFill, doStroke = this._doStroke;
	  if (doFill && !doStroke) {
	    if(ctx.fillStyle === styleEmpty) {
	      return this;
	    }
	  } else if (!doFill && doStroke) {
	    if(ctx.strokeStyle === styleEmpty) {
	      return this;
	    }
	  }
	  var vals = canvas.modeAdjust(x, y, w, h, this._rectMode);
	  // Translate the line by (0.5, 0.5) to draw a crisp rectangle border
	  if (this._doStroke && ctx.lineWidth % 2 === 1) {
	    ctx.translate(0.5, 0.5);
	  }
	  ctx.beginPath();
	
	  if (typeof tl === 'undefined') {
	    // No rounded corners
	    ctx.rect(vals.x, vals.y, vals.w, vals.h);
	  } else {
	    // At least one rounded corner
	    // Set defaults when not specified
	    if (typeof tr === 'undefined') { tr = tl; }
	    if (typeof br === 'undefined') { br = tr; }
	    if (typeof bl === 'undefined') { bl = br; }
	
	    // Cache and compute several values
	    var _x = vals.x;
	    var _y = vals.y;
	    var _w = vals.w;
	    var _h = vals.h;
	    var hw = _w / 2;
	    var hh = _h / 2;
	
	    // Clip radii
	    if (_w < 2 * tl) { tl = hw; }
	    if (_h < 2 * tl) { tl = hh; }
	    if (_w < 2 * tr) { tr = hw; }
	    if (_h < 2 * tr) { tr = hh; }
	    if (_w < 2 * br) { br = hw; }
	    if (_h < 2 * br) { br = hh; }
	    if (_w < 2 * bl) { bl = hw; }
	    if (_h < 2 * bl) { bl = hh; }
	
	    // Draw shape
	    ctx.beginPath();
	    ctx.moveTo(_x + tl, _y);
	    ctx.arcTo(_x + _w, _y, _x + _w, _y + _h, tr);
	    ctx.arcTo(_x + _w, _y + _h, _x, _y + _h, br);
	    ctx.arcTo(_x, _y + _h, _x, _y, bl);
	    ctx.arcTo(_x, _y, _x + _w, _y, tl);
	    ctx.closePath();
	  }
	  if (this._doFill) {
	    ctx.fill();
	  }
	  if (this._doStroke) {
	    ctx.stroke();
	  }
	  if (this._doStroke && ctx.lineWidth % 2 === 1) {
	    ctx.translate(-0.5, -0.5);
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.triangle = function(x1, y1, x2, y2, x3, y3) {
	  var ctx = this.drawingContext;
	  var doFill = this._doFill, doStroke = this._doStroke;
	  if (doFill && !doStroke) {
	    if(ctx.fillStyle === styleEmpty) {
	      return this;
	    }
	  } else if (!doFill && doStroke) {
	    if(ctx.strokeStyle === styleEmpty) {
	      return this;
	    }
	  }
	  ctx.beginPath();
	  ctx.moveTo(x1, y1);
	  ctx.lineTo(x2, y2);
	  ctx.lineTo(x3, y3);
	  ctx.closePath();
	  if (doFill) {
	    ctx.fill();
	  }
	  if (doStroke) {
	    ctx.stroke();
	  }
	};
	
	p5.Renderer2D.prototype.endShape =
	function (mode, vertices, isCurve, isBezier,
	    isQuadratic, isContour, shapeKind) {
	  if (vertices.length === 0) {
	    return this;
	  }
	  if (!this._doStroke && !this._doFill) {
	    return this;
	  }
	  var closeShape = mode === constants.CLOSE;
	  var v;
	  if (closeShape && !isContour) {
	    vertices.push(vertices[0]);
	  }
	  var i, j;
	  var numVerts = vertices.length;
	  if (isCurve && (shapeKind === constants.POLYGON || shapeKind === null)) {
	    if (numVerts > 3) {
	      var b = [], s = 1 - this._curveTightness;
	      this.drawingContext.beginPath();
	      this.drawingContext.moveTo(vertices[1][0], vertices[1][1]);
	      for (i = 1; i + 2 < numVerts; i++) {
	        v = vertices[i];
	        b[0] = [
	          v[0],
	          v[1]
	        ];
	        b[1] = [
	          v[0] + (s * vertices[i + 1][0] - s * vertices[i - 1][0]) / 6,
	          v[1] + (s * vertices[i + 1][1] - s * vertices[i - 1][1]) / 6
	        ];
	        b[2] = [
	          vertices[i + 1][0] +
	          (s * vertices[i][0]-s * vertices[i + 2][0]) / 6,
	          vertices[i + 1][1]+(s * vertices[i][1] - s*vertices[i + 2][1]) / 6
	        ];
	        b[3] = [
	          vertices[i + 1][0],
	          vertices[i + 1][1]
	        ];
	        this.drawingContext.bezierCurveTo(b[1][0],b[1][1],
	          b[2][0],b[2][1],b[3][0],b[3][1]);
	      }
	      if (closeShape) {
	        this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
	      }
	      this._doFillStrokeClose();
	    }
	  } else if (isBezier&&(shapeKind===constants.POLYGON ||shapeKind === null)) {
	    this.drawingContext.beginPath();
	    for (i = 0; i < numVerts; i++) {
	      if (vertices[i].isVert) {
	        if (vertices[i].moveTo) {
	          this.drawingContext.moveTo(vertices[i][0], vertices[i][1]);
	        } else {
	          this.drawingContext.lineTo(vertices[i][0], vertices[i][1]);
	        }
	      } else {
	        this.drawingContext.bezierCurveTo(vertices[i][0], vertices[i][1],
	          vertices[i][2], vertices[i][3], vertices[i][4], vertices[i][5]);
	      }
	    }
	    this._doFillStrokeClose();
	  } else if (isQuadratic &&
	    (shapeKind === constants.POLYGON || shapeKind === null)) {
	    this.drawingContext.beginPath();
	    for (i = 0; i < numVerts; i++) {
	      if (vertices[i].isVert) {
	        if (vertices[i].moveTo) {
	          this.drawingContext.moveTo([0], vertices[i][1]);
	        } else {
	          this.drawingContext.lineTo(vertices[i][0], vertices[i][1]);
	        }
	      } else {
	        this.drawingContext.quadraticCurveTo(vertices[i][0], vertices[i][1],
	          vertices[i][2], vertices[i][3]);
	      }
	    }
	    this._doFillStrokeClose();
	  } else {
	    if (shapeKind === constants.POINTS) {
	      for (i = 0; i < numVerts; i++) {
	        v = vertices[i];
	        if (this._doStroke) {
	          this._pInst.stroke(v[6]);
	        }
	        this._pInst.point(v[0], v[1]);
	      }
	    } else if (shapeKind === constants.LINES) {
	      for (i = 0; i + 1 < numVerts; i += 2) {
	        v = vertices[i];
	        if (this._doStroke) {
	          this._pInst.stroke(vertices[i + 1][6]);
	        }
	        this._pInst.line(v[0], v[1], vertices[i + 1][0], vertices[i + 1][1]);
	      }
	    } else if (shapeKind === constants.TRIANGLES) {
	      for (i = 0; i + 2 < numVerts; i += 3) {
	        v = vertices[i];
	        this.drawingContext.beginPath();
	        this.drawingContext.moveTo(v[0], v[1]);
	        this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
	        this.drawingContext.lineTo(vertices[i + 2][0], vertices[i + 2][1]);
	        this.drawingContext.lineTo(v[0], v[1]);
	        if (this._doFill) {
	          this._pInst.fill(vertices[i + 2][5]);
	          this.drawingContext.fill();
	        }
	        if (this._doStroke) {
	          this._pInst.stroke(vertices[i + 2][6]);
	          this.drawingContext.stroke();
	        }
	        this.drawingContext.closePath();
	      }
	    } else if (shapeKind === constants.TRIANGLE_STRIP) {
	      for (i = 0; i + 1 < numVerts; i++) {
	        v = vertices[i];
	        this.drawingContext.beginPath();
	        this.drawingContext.moveTo(vertices[i + 1][0], vertices[i + 1][1]);
	        this.drawingContext.lineTo(v[0], v[1]);
	        if (this._doStroke) {
	          this._pInst.stroke(vertices[i + 1][6]);
	        }
	        if (this._doFill) {
	          this._pInst.fill(vertices[i + 1][5]);
	        }
	        if (i + 2 < numVerts) {
	          this.drawingContext.lineTo(vertices[i + 2][0], vertices[i + 2][1]);
	          if (this._doStroke) {
	            this._pInst.stroke(vertices[i + 2][6]);
	          }
	          if (this._doFill) {
	            this._pInst.fill(vertices[i + 2][5]);
	          }
	        }
	        this._doFillStrokeClose();
	      }
	    } else if (shapeKind === constants.TRIANGLE_FAN) {
	      if (numVerts > 2) {
	        this.drawingContext.beginPath();
	        this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
	        this.drawingContext.lineTo(vertices[1][0], vertices[1][1]);
	        this.drawingContext.lineTo(vertices[2][0], vertices[2][1]);
	        if (this._doFill) {
	          this._pInst.fill(vertices[2][5]);
	        }
	        if (this._doStroke) {
	          this._pInst.stroke(vertices[2][6]);
	        }
	        this._doFillStrokeClose();
	        for (i = 3; i < numVerts; i++) {
	          v = vertices[i];
	          this.drawingContext.beginPath();
	          this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
	          this.drawingContext.lineTo(vertices[i - 1][0], vertices[i - 1][1]);
	          this.drawingContext.lineTo(v[0], v[1]);
	          if (this._doFill) {
	            this._pInst.fill(v[5]);
	          }
	          if (this._doStroke) {
	            this._pInst.stroke(v[6]);
	          }
	          this._doFillStrokeClose();
	        }
	      }
	    } else if (shapeKind === constants.QUADS) {
	      for (i = 0; i + 3 < numVerts; i += 4) {
	        v = vertices[i];
	        this.drawingContext.beginPath();
	        this.drawingContext.moveTo(v[0], v[1]);
	        for (j = 1; j < 4; j++) {
	          this.drawingContext.lineTo(vertices[i + j][0], vertices[i + j][1]);
	        }
	        this.drawingContext.lineTo(v[0], v[1]);
	        if (this._doFill) {
	          this._pInst.fill(vertices[i + 3][5]);
	        }
	        if (this._doStroke) {
	          this._pInst.stroke(vertices[i + 3][6]);
	        }
	        this._doFillStrokeClose();
	      }
	    } else if (shapeKind === constants.QUAD_STRIP) {
	      if (numVerts > 3) {
	        for (i = 0; i + 1 < numVerts; i += 2) {
	          v = vertices[i];
	          this.drawingContext.beginPath();
	          if (i + 3 < numVerts) {
	            this.drawingContext.moveTo(vertices[i + 2][0], vertices[i+2][1]);
	            this.drawingContext.lineTo(v[0], v[1]);
	            this.drawingContext.lineTo(vertices[i + 1][0], vertices[i+1][1]);
	            this.drawingContext.lineTo(vertices[i + 3][0], vertices[i+3][1]);
	            if (this._doFill) {
	              this._pInst.fill(vertices[i + 3][5]);
	            }
	            if (this._doStroke) {
	              this._pInst.stroke(vertices[i + 3][6]);
	            }
	          } else {
	            this.drawingContext.moveTo(v[0], v[1]);
	            this.drawingContext.lineTo(vertices[i + 1][0], vertices[i+1][1]);
	          }
	          this._doFillStrokeClose();
	        }
	      }
	    } else {
	      this.drawingContext.beginPath();
	      this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
	      for (i = 1; i < numVerts; i++) {
	        v = vertices[i];
	        if (v.isVert) {
	          if (v.moveTo) {
	            this.drawingContext.moveTo(v[0], v[1]);
	          } else {
	            this.drawingContext.lineTo(v[0], v[1]);
	          }
	        }
	      }
	      this._doFillStrokeClose();
	    }
	  }
	  isCurve = false;
	  isBezier = false;
	  isQuadratic = false;
	  isContour = false;
	  if (closeShape) {
	    vertices.pop();
	  }
	  return this;
	};
	//////////////////////////////////////////////
	// SHAPE | Attributes
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.noSmooth = function() {
	  if ('imageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.imageSmoothingEnabled = false;
	  }
	  else if ('mozImageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.mozImageSmoothingEnabled = false;
	  }
	  else if ('webkitImageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.webkitImageSmoothingEnabled = false;
	  }
	  else if ('msImageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.msImageSmoothingEnabled = false;
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.smooth = function() {
	  if ('imageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.imageSmoothingEnabled = true;
	  }
	  else if ('mozImageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.mozImageSmoothingEnabled = true;
	  }
	  else if ('webkitImageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.webkitImageSmoothingEnabled = true;
	  }
	  else if ('msImageSmoothingEnabled' in this.drawingContext) {
	    this.drawingContext.msImageSmoothingEnabled = true;
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.strokeCap = function(cap) {
	  if (cap === constants.ROUND ||
	    cap === constants.SQUARE ||
	    cap === constants.PROJECT) {
	    this.drawingContext.lineCap = cap;
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.strokeJoin = function(join) {
	  if (join === constants.ROUND ||
	    join === constants.BEVEL ||
	    join === constants.MITER) {
	    this.drawingContext.lineJoin = join;
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype.strokeWeight = function(w) {
	  if (typeof w === 'undefined' || w === 0) {
	    // hack because lineWidth 0 doesn't work
	    this.drawingContext.lineWidth = 0.0001;
	  } else {
	    this.drawingContext.lineWidth = w;
	  }
	  return this;
	};
	
	p5.Renderer2D.prototype._getFill = function(){
	  return this.drawingContext.fillStyle;
	};
	
	p5.Renderer2D.prototype._getStroke = function(){
	  return this.drawingContext.strokeStyle;
	};
	
	//////////////////////////////////////////////
	// SHAPE | Curves
	//////////////////////////////////////////////
	p5.Renderer2D.prototype.bezier = function (x1, y1, x2, y2, x3, y3, x4, y4) {
	  this._pInst.beginShape();
	  this._pInst.vertex(x1, y1);
	  this._pInst.bezierVertex(x2, y2, x3, y3, x4, y4);
	  this._pInst.endShape();
	  return this;
	};
	
	p5.Renderer2D.prototype.curve = function (x1, y1, x2, y2, x3, y3, x4, y4) {
	  this._pInst.beginShape();
	  this._pInst.curveVertex(x1, y1);
	  this._pInst.curveVertex(x2, y2);
	  this._pInst.curveVertex(x3, y3);
	  this._pInst.curveVertex(x4, y4);
	  this._pInst.endShape();
	  return this;
	};
	
	//////////////////////////////////////////////
	// SHAPE | Vertex
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype._doFillStrokeClose = function () {
	  if (this._doFill) {
	    this.drawingContext.fill();
	  }
	  if (this._doStroke) {
	    this.drawingContext.stroke();
	  }
	  this.drawingContext.closePath();
	};
	
	//////////////////////////////////////////////
	// TRANSFORM
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.applyMatrix =
	function(n00, n01, n02, n10, n11, n12) {
	  this.drawingContext.transform(n00, n01, n02, n10, n11, n12);
	};
	
	p5.Renderer2D.prototype.resetMatrix = function() {
	  this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
	  this.drawingContext.scale(this._pInst._pixelDensity,
	                            this._pInst._pixelDensity);
	  return this;
	};
	
	p5.Renderer2D.prototype.rotate = function(r) {
	  this.drawingContext.rotate(r);
	};
	
	p5.Renderer2D.prototype.scale = function(x,y) {
	  this.drawingContext.scale(x, y);
	  return this;
	};
	
	p5.Renderer2D.prototype.shearX = function(angle) {
	  if (this._pInst._angleMode === constants.DEGREES) {
	    angle = this._pInst.radians(angle);
	  }
	  this.drawingContext.transform(1, 0, this._pInst.tan(angle), 1, 0, 0);
	  return this;
	};
	
	p5.Renderer2D.prototype.shearY = function(angle) {
	  if (this._pInst._angleMode === constants.DEGREES) {
	    angle = this._pInst.radians(angle);
	  }
	  this.drawingContext.transform(1, this._pInst.tan(angle), 0, 1, 0, 0);
	  return this;
	};
	
	p5.Renderer2D.prototype.translate = function(x, y) {
	    console.log(x, y)
	  this.drawingContext.translate(x, y);
	  return this;
	};
	
	//////////////////////////////////////////////
	// TYPOGRAPHY
	//
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.text = function (str, x, y, maxWidth, maxHeight) {
	
	  var p = this._pInst, cars, n, ii, jj, line, testLine,
	    testWidth, words, totalHeight, baselineHacked,
	    finalMaxHeight = Number.MAX_VALUE;
	
	  // baselineHacked: (HACK)
	  // A temporary fix to conform to Processing's implementation
	  // of BASELINE vertical alignment in a bounding box
	
	  if (!(this._doFill || this._doStroke)) {
	    return;
	  }
	
	  if (typeof str !== 'string') {
	    str = str.toString();
	  }
	
	  str = str.replace(/(\t)/g, '  ');
	  cars = str.split('\n');
	
	  if (typeof maxWidth !== 'undefined') {
	
	    totalHeight = 0;
	    for (ii = 0; ii < cars.length; ii++) {
	      line = '';
	      words = cars[ii].split(' ');
	      for (n = 0; n < words.length; n++) {
	        testLine = line + words[n] + ' ';
	        testWidth = this.textWidth(testLine);
	        if (testWidth > maxWidth) {
	          line = words[n] + ' ';
	          totalHeight += p.textLeading();
	        } else {
	          line = testLine;
	        }
	      }
	    }
	
	    if (this._rectMode === constants.CENTER) {
	
	      x -= maxWidth / 2;
	      y -= maxHeight / 2;
	    }
	
	    switch (this.drawingContext.textAlign) {
	
	    case constants.CENTER:
	      x += maxWidth / 2;
	      break;
	    case constants.RIGHT:
	      x += maxWidth;
	      break;
	    }
	
	    if (typeof maxHeight !== 'undefined') {
	
	      switch (this.drawingContext.textBaseline) {
	      case constants.BOTTOM:
	        y += (maxHeight - totalHeight);
	        break;
	      case constants._CTX_MIDDLE:
	        y += (maxHeight - totalHeight) / 2;
	        break;
	      case constants.BASELINE:
	        baselineHacked = true;
	        this.drawingContext.textBaseline = constants.TOP;
	        break;
	      }
	
	      // remember the max-allowed y-position for any line (fix to #928)
	      finalMaxHeight = (y + maxHeight) - p.textAscent();
	    }
	
	    for (ii = 0; ii < cars.length; ii++) {
	
	      line = '';
	      words = cars[ii].split(' ');
	      for (n = 0; n < words.length; n++) {
	        testLine = line + words[n] + ' ';
	        testWidth = this.textWidth(testLine);
	        if (testWidth > maxWidth && line.length > 0) {
	          this._renderText(p, line, x, y, finalMaxHeight);
	          line = words[n] + ' ';
	          y += p.textLeading();
	        } else {
	          line = testLine;
	        }
	      }
	
	      this._renderText(p, line, x, y, finalMaxHeight);
	      y += p.textLeading();
	    }
	  }
	  else {
	    for (jj = 0; jj < cars.length; jj++) {
	
	      this._renderText(p, cars[jj], x, y, finalMaxHeight);
	      y += p.textLeading();
	    }
	  }
	
	  if (baselineHacked) {
	    this.drawingContext.textBaseline = constants.BASELINE;
	  }
	
	  return p;
	};
	
	p5.Renderer2D.prototype._renderText = function(p, line, x, y, maxY) {
	
	  if (y >= maxY) {
	    return; // don't render lines beyond our maxY position
	  }
	
	  p.push(); // fix to #803
	
	  if (!this._isOpenType()) {  // a system/browser font
	
	    // no stroke unless specified by user
	    if (this._doStroke && this._strokeSet) {
	
	      this.drawingContext.strokeText(line, x, y);
	    }
	
	    if (this._doFill) {
	
	      // if fill hasn't been set by user, use default text fill
	      this.drawingContext.fillStyle =  this._fillSet ?
	        this.drawingContext.fillStyle : constants._DEFAULT_TEXT_FILL;
	
	      this.drawingContext.fillText(line, x, y);
	    }
	  }
	  else { // an opentype font, let it handle the rendering
	
	    this._textFont._renderPath(line, x, y, { renderer: this });
	  }
	
	  p.pop();
	
	  return p;
	};
	
	p5.Renderer2D.prototype.textWidth = function(s) {
	
	  if (this._isOpenType()) {
	
	    return this._textFont._textWidth(s);
	  }
	
	  return this.drawingContext.measureText(s).width;
	};
	
	p5.Renderer2D.prototype.textAlign = function(h, v) {
	
	  if (arguments.length) {
	
	    if (h === constants.LEFT ||
	      h === constants.RIGHT ||
	      h === constants.CENTER) {
	
	      this.drawingContext.textAlign = h;
	    }
	
	    if (v === constants.TOP ||
	      v === constants.BOTTOM ||
	      v === constants.CENTER ||
	      v === constants.BASELINE) {
	
	      if (v === constants.CENTER) {
	        this.drawingContext.textBaseline = constants._CTX_MIDDLE;
	      } else {
	        this.drawingContext.textBaseline = v;
	      }
	    }
	
	    return this._pInst;
	
	  } else {
	
	    var valign = this.drawingContext.textBaseline;
	
	    if (valign === constants._CTX_MIDDLE) {
	
	      valign = constants.CENTER;
	    }
	
	    return {
	
	      horizontal: this.drawingContext.textAlign,
	      vertical: valign
	    };
	  }
	};
	
	p5.Renderer2D.prototype._applyTextProperties = function() {
	
	  var font, p = this._pInst;
	
	  this._setProperty('_textAscent', null);
	  this._setProperty('_textDescent', null);
	
	  font = this._textFont;
	
	  if (this._isOpenType()) {
	
	    font = this._textFont.font.familyName;
	    this._setProperty('_textStyle', this._textFont.font.styleName);
	  }
	
	  this.drawingContext.font = this._textStyle + ' ' +
	  this._textSize + 'px ' + font;
	
	  return p;
	};
	
	
	//////////////////////////////////////////////
	// STRUCTURE
	//////////////////////////////////////////////
	
	p5.Renderer2D.prototype.push = function() {
	  this.drawingContext.save();
	};
	
	p5.Renderer2D.prototype.pop = function() {
	  this.drawingContext.restore();
	};
	
	module.exports = p5.Renderer2D;
	
	},{"../image/filters":65,"./canvas":46,"./constants":47,"./core":48,"./p5.Renderer":54}],56:[function(_dereq_,module,exports){
	/**
	 * @module Rendering
	 * @submodule Rendering
	 * @for p5
	 */
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('./constants');
	_dereq_('./p5.Graphics');
	_dereq_('./p5.Renderer2D');
	_dereq_('../3d/p5.Renderer3D');
	var defaultId = 'defaultCanvas0'; // this gets set again in createCanvas
	
	/**
	 * Creates a canvas element in the document, and sets the dimensions of it
	 * in pixels. This method should be called only once at the start of setup.
	 * Calling createCanvas more than once in a sketch will result in very
	 * unpredicable behavior. If you want more than one drawing canvas
	 * you could use createGraphics (hidden by default but it can be shown).
	 * <br><br>
	 * The system variables width and height are set by the parameters passed
	 * to this function. If createCanvas() is not used, the window will be
	 * given a default size of 100x100 pixels.
	 *
	 * @method createCanvas
	 * @param  {Number} w width of the canvas
	 * @param  {Number} h height of the canvas
	 * @param  optional:{String} renderer 'p2d' | 'webgl'
	 * @return {Object} canvas generated
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   createCanvas(100, 50);
	 *   background(153);
	 *   line(0, 0, width, height);
	 * }
	 * </code>
	 * </div>
	 */
	
	p5.prototype.createCanvas = function(w, h, renderer) {
	  //optional: renderer, otherwise defaults to p2d
	  var r = renderer || constants.P2D;
	  var isDefault, c;
	
	  //4th arg (isDefault) used when called onLoad,
	  //otherwise hidden to the public api
	  if(arguments[3]){
	    isDefault =
	    (typeof arguments[3] === 'boolean') ? arguments[3] : false;
	  }
	
	  if(r === constants.WEBGL){
	    c = document.getElementById(defaultId);
	    if(c){ //if defaultCanvas already exists
	      c.parentNode.removeChild(c); //replace the existing defaultCanvas
	    }
	    c = document.createElement('canvas');
	    c.id = defaultId;
	  }
	  else {
	    if (isDefault) {
	      c = document.createElement('canvas');
	      var i = 0;
	      while (document.getElementById('defaultCanvas'+i)) {
	        i++;
	      }
	      defaultId = 'defaultCanvas'+i;
	      c.id = defaultId;
	    } else { // resize the default canvas if new one is created
	      c = this.canvas;
	    }
	  }
	
	  // set to invisible if still in setup (to prevent flashing with manipulate)
	  if (!this._setupDone) {
	    c.className += ' p5_hidden'; // tag to show later
	    c.style.visibility='hidden';
	  }
	
	  if (this._userNode) { // user input node case
	    this._userNode.appendChild(c);
	  } else {
	    document.body.appendChild(c);
	  }
	
	
	
	  // Init our graphics renderer
	  //webgl mode
	  if (r === constants.WEBGL) {
	    this._setProperty('_renderer', new p5.Renderer3D(c, this, true));
	    this._isdefaultGraphics = true;
	  }
	  //P2D mode
	  else {
	    if (!this._isdefaultGraphics) {
	      this._setProperty('_renderer', new p5.Renderer2D(c, this, true));
	      this._isdefaultGraphics = true;
	    }
	  }
	  this._renderer.resize(w, h);
	  this._renderer._applyDefaults();
	  if (isDefault) { // only push once
	    this._elements.push(this._renderer);
	  }
	  return this._renderer;
	};
	
	/**
	 * Resizes the canvas to given width and height. The canvas will be cleared
	 * and draw will be called immediately, allowing the sketch to re-render itself
	 * in the resized canvas.
	 * @method resizeCanvas
	 * @example
	 * <div class="norender"><code>
	 * function setup() {
	 *   createCanvas(windowWidth, windowHeight);
	 * }
	 *
	 * function draw() {
	 *  background(0, 100, 200);
	 * }
	 *
	 * function windowResized() {
	 *   resizeCanvas(windowWidth, windowHeight);
	 * }
	 * </code></div>
	 */
	p5.prototype.resizeCanvas = function (w, h, noRedraw) {
	  if (this._renderer) {
	
	    // save canvas properties
	    var props = {};
	    for (var key in this.drawingContext) {
	      var val = this.drawingContext[key];
	      if (typeof val !== 'object' && typeof val !== 'function') {
	        props[key] = val;
	      }
	    }
	    this._renderer.resize(w, h);
	    // reset canvas properties
	    for (var savedKey in props) {
	      this.drawingContext[savedKey] = props[savedKey];
	    }
	    if (!noRedraw) {
	      this.redraw();
	    }
	  }
	};
	
	
	/**
	 * Removes the default canvas for a p5 sketch that doesn't
	 * require a canvas
	 * @method noCanvas
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   noCanvas();
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.noCanvas = function() {
	  if (this.canvas) {
	    this.canvas.parentNode.removeChild(this.canvas);
	  }
	};
	
	/**
	 * Creates and returns a new p5.Renderer object. Use this class if you need
	 * to draw into an off-screen graphics buffer. The two parameters define the
	 * width and height in pixels.
	 *
	 * @method createGraphics
	 * @param  {Number} w width of the offscreen graphics buffer
	 * @param  {Number} h height of the offscreen graphics buffer
	 * @param {String} renderer either 'p2d' or 'webgl'.
	 * undefined defaults to p2d
	 * @return {Object} offscreen graphics buffer
	 * @example
	 * <div>
	 * <code>
	 * var pg;
	 * function setup() {
	 *   createCanvas(100, 100);
	 *   pg = createGraphics(100, 100);
	 * }
	 * function draw() {
	 *   background(200);
	 *   pg.background(100);
	 *   pg.noStroke();
	 *   pg.ellipse(pg.width/2, pg.height/2, 50, 50);
	 *   image(pg, 50, 50);
	 *   image(pg, 0, 0, 50, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.createGraphics = function(w, h, renderer){
	  return new p5.Graphics(w, h, renderer, this);
	};
	
	/**
	 * Blends the pixels in the display window according to the defined mode.
	 * There is a choice of the following modes to blend the source pixels (A)
	 * with the ones of pixels already in the display window (B):
	 * <ul>
	 * <li><code>BLEND</code> - linear interpolation of colours: C =
	 * A*factor + B. This is the default blending mode.</li>
	 * <li><code>ADD</code> - sum of A and B</li>
	 * <li><code>DARKEST</code> - only the darkest colour succeeds: C =
	 * min(A*factor, B).</li>
	 * <li><code>LIGHTEST</code> - only the lightest colour succeeds: C =
	 * max(A*factor, B).</li>
	 * <li><code>DIFFERENCE</code> - subtract colors from underlying image.</li>
	 * <li><code>EXCLUSION</code> - similar to <code>DIFFERENCE</code>, but less
	 * extreme.</li>
	 * <li><code>MULTIPLY</code> - multiply the colors, result will always be
	 * darker.</li>
	 * <li><code>SCREEN</code> - opposite multiply, uses inverse values of the
	 * colors.</li>
	 * <li><code>REPLACE</code> - the pixels entirely replace the others and
	 * don't utilize alpha (transparency) values.</li>
	 * <li><code>OVERLAY</code> - mix of <code>MULTIPLY</code> and <code>SCREEN
	 * </code>. Multiplies dark values, and screens light values.</li>
	 * <li><code>HARD_LIGHT</code> - <code>SCREEN</code> when greater than 50%
	 * gray, <code>MULTIPLY</code> when lower.</li>
	 * <li><code>SOFT_LIGHT</code> - mix of <code>DARKEST</code> and
	 * <code>LIGHTEST</code>. Works like <code>OVERLAY</code>, but not as harsh.
	 * </li>
	 * <li><code>DODGE</code> - lightens light tones and increases contrast,
	 * ignores darks.</li>
	 * <li><code>BURN</code> - darker areas are applied, increasing contrast,
	 * ignores lights.</li>
	 * </ul>
	 *
	 * @method blendMode
	 * @param  {String/Constant} mode blend mode to set for canvas
	 * @example
	 * <div>
	 * <code>
	 * blendMode(LIGHTEST);
	 * strokeWeight(30);
	 * stroke(80, 150, 255);
	 * line(25, 25, 75, 75);
	 * stroke(255, 50, 50);
	 * line(75, 25, 25, 75);
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * blendMode(MULTIPLY);
	 * strokeWeight(30);
	 * stroke(80, 150, 255);
	 * line(25, 25, 75, 75);
	 * stroke(255, 50, 50);
	 * line(75, 25, 25, 75);
	 * </code>
	 * </div>
	 */
	p5.prototype.blendMode = function(mode) {
	  if (mode === constants.BLEND || mode === constants.DARKEST ||
	    mode === constants.LIGHTEST || mode === constants.DIFFERENCE ||
	    mode === constants.MULTIPLY || mode === constants.EXCLUSION ||
	    mode === constants.SCREEN || mode === constants.REPLACE ||
	    mode === constants.OVERLAY || mode === constants.HARD_LIGHT ||
	    mode === constants.SOFT_LIGHT || mode === constants.DODGE ||
	    mode === constants.BURN || mode === constants.ADD ||
	    mode === constants.NORMAL) {
	    this._renderer.blendMode(mode);
	  } else {
	    throw new Error('Mode '+mode+' not recognized.');
	  }
	};
	
	module.exports = p5;
	
	},{"../3d/p5.Renderer3D":36,"./constants":47,"./core":48,"./p5.Graphics":53,"./p5.Renderer2D":55}],57:[function(_dereq_,module,exports){
	
	// requestAnim shim layer by Paul Irish
	window.requestAnimationFrame = (function(){
	  return window.requestAnimationFrame      ||
	        window.webkitRequestAnimationFrame ||
	        window.mozRequestAnimationFrame    ||
	        window.oRequestAnimationFrame      ||
	        window.msRequestAnimationFrame     ||
	        function(callback, element){
	          // should '60' here be framerate?
	          window.setTimeout(callback, 1000 / 60);
	        };
	})();
	
	// use window.performance() to get max fast and accurate time in milliseconds
	window.performance = window.performance || {};
	window.performance.now = (function(){
	  var load_date = Date.now();
	  return window.performance.now        ||
	        window.performance.mozNow      ||
	        window.performance.msNow       ||
	        window.performance.oNow        ||
	        window.performance.webkitNow   ||
	        function () {
	          return Date.now() - load_date;
	        };
	})();
	
	/*
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/
	// requestanimationframe-for-smart-er-animating
	// requestAnimationFrame polyfill by Erik Möller
	// fixes from Paul Irish and Tino Zijdel
	(function() {
	  var lastTime = 0;
	  var vendors = ['ms', 'moz', 'webkit', 'o'];
	  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame =
	      window[vendors[x]+'RequestAnimationFrame'];
	    window.cancelAnimationFrame =
	      window[vendors[x]+'CancelAnimationFrame'] ||
	      window[vendors[x]+'CancelRequestAnimationFrame'];
	  }
	
	  if (!window.requestAnimationFrame) {
	    window.requestAnimationFrame = function(callback, element) {
	      var currTime = new Date().getTime();
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	      var id = window.setTimeout(function()
	        { callback(currTime + timeToCall); }, timeToCall);
	      lastTime = currTime + timeToCall;
	      return id;
	    };
	  }
	
	  if (!window.cancelAnimationFrame) {
	    window.cancelAnimationFrame = function(id) {
	      clearTimeout(id);
	    };
	  }
	}());
	*/
	
	/**
	 * shim for Uint8ClampedArray.slice
	 * (allows arrayCopy to work with pixels[])
	 * with thanks to http://halfpapstudios.com/blog/tag/html5-canvas/
	 */
	(function () {
	  'use strict';
	
	  if (typeof Uint8ClampedArray !== 'undefined') {
	    //Firefox and Chrome
	    Uint8ClampedArray.prototype.slice = Array.prototype.slice;
	  }
	}());
	
	
	},{}],58:[function(_dereq_,module,exports){
	/**
	 * @module Structure
	 * @submodule Structure
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	
	p5.prototype.exit = function() {
	  throw 'exit() not implemented, see remove()';
	};
	/**
	 * Stops p5.js from continuously executing the code within draw().
	 * If loop() is called, the code in draw() begins to run continuously again.
	 * If using noLoop() in setup(), it should be the last line inside the block.
	 * <br><br>
	 * When noLoop() is used, it's not possible to manipulate or access the
	 * screen inside event handling functions such as mousePressed() or
	 * keyPressed(). Instead, use those functions to call redraw() or loop(),
	 * which will run draw(), which can update the screen properly. This means
	 * that when noLoop() has been called, no drawing can happen, and functions
	 * like saveFrame() or loadPixels() may not be used.
	 * <br><br>
	 * Note that if the sketch is resized, redraw() will be called to update
	 * the sketch, even after noLoop() has been specified. Otherwise, the sketch
	 * would enter an odd state until loop() was called.
	 *
	 * @method noLoop
	 * @example
	 * <div><code>
	 * function setup() {
	 *   createCanvas(100, 100);
	 *   background(200);
	 *   noLoop();
	 * }
	
	 * function draw() {
	 *   line(10, 10, 90, 90);
	 * }
	 * </code></div>
	 *
	 * <div><code>
	 * var x = 0;
	 * function setup() {
	 *   createCanvas(100, 100);
	 * }
	 *
	 * function draw() {
	 *   background(204);
	 *   x = x + 0.1;
	 *   if (x > width) {
	 *     x = 0;
	 *   }
	 *   line(x, 0, x, height);
	 * }
	 *
	 * function mousePressed() {
	 *   noLoop();
	 * }
	 *
	 * function mouseReleased() {
	 *   loop();
	 * }
	 * </code></div>
	 */
	p5.prototype.noLoop = function() {
	  this._loop = false;
	};
	/**
	 * By default, p5.js loops through draw() continuously, executing the code
	 * within it. However, the draw() loop may be stopped by calling noLoop().
	 * In that case, the draw() loop can be resumed with loop().
	 *
	 * @method loop
	 * @example
	 * <div><code>
	 * var x = 0;
	 * function setup() {
	 *   createCanvas(100, 100);
	 *   noLoop();
	 * }
	 *
	 * function draw() {
	 *   background(204);
	 *   x = x + 0.1;
	 *   if (x > width) {
	 *     x = 0;
	 *   }
	 *   line(x, 0, x, height);
	 * }
	 *
	 * function mousePressed() {
	 *   loop();
	 * }
	 *
	 * function mouseReleased() {
	 *   noLoop();
	 * }
	 * </code></div>
	 */
	
	p5.prototype.loop = function() {
	  this._loop = true;
	  this._draw();
	};
	
	/**
	 * The push() function saves the current drawing style settings and
	 * transformations, while pop() restores these settings. Note that these
	 * functions are always used together. They allow you to change the style
	 * and transformation settings and later return to what you had. When a new
	 * state is started with push(), it builds on the current style and transform
	 * information. The push() and pop() functions can be embedded to provide
	 * more control. (See the second example for a demonstration.)
	 * <br><br>
	 * push() stores information related to the current transformation state
	 * and style settings controlled by the following functions: fill(),
	 * stroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),
	 * imageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),
	 * textFont(), textMode(), textSize(), textLeading().
	 *
	 * @method push
	 * @example
	 * <div>
	 * <code>
	 * ellipse(0, 50, 33, 33);  // Left circle
	 *
	 * push();  // Start a new drawing state
	 * strokeWeight(10);
	 * fill(204, 153, 0);
	 * translate(50, 0);
	 * ellipse(0, 50, 33, 33);  // Middle circle
	 * pop();  // Restore original state
	 *
	 * ellipse(100, 50, 33, 33);  // Right circle
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * ellipse(0, 50, 33, 33);  // Left circle
	 *
	 * push();  // Start a new drawing state
	 * strokeWeight(10);
	 * fill(204, 153, 0);
	 * ellipse(33, 50, 33, 33);  // Left-middle circle
	 *
	 * push();  // Start another new drawing state
	 * stroke(0, 102, 153);
	 * ellipse(66, 50, 33, 33);  // Right-middle circle
	 * pop();  // Restore previous state
	 *
	 * pop();  // Restore original state
	 *
	 * ellipse(100, 50, 33, 33);  // Right circle
	 * </code>
	 * </div>
	 */
	p5.prototype.push = function () {
	  this._renderer.push();
	  this._styles.push({
	    _doStroke: this._renderer._doStroke,
	    _doFill: this._renderer._doFill,
	    _tint: this._renderer._tint,
	    _imageMode: this._renderer._imageMode,
	    _rectMode: this._renderer._rectMode,
	    _ellipseMode: this._renderer._ellipseMode,
	    _colorMode: this._renderer._colorMode,
	    _textFont: this._renderer._textFont,
	    _textLeading: this._renderer._textLeading,
	    _textSize: this._renderer._textSize,
	    _textStyle: this._renderer._textStyle
	  });
	};
	
	/**
	 * The push() function saves the current drawing style settings and
	 * transformations, while pop() restores these settings. Note that these
	 * functions are always used together. They allow you to change the style
	 * and transformation settings and later return to what you had. When a new
	 * state is started with push(), it builds on the current style and transform
	 * information. The push() and pop() functions can be embedded to provide
	 * more control. (See the second example for a demonstration.)
	 * <br><br>
	 * push() stores information related to the current transformation state
	 * and style settings controlled by the following functions: fill(),
	 * stroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),
	 * imageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),
	 * textFont(), textMode(), textSize(), textLeading().
	 *
	 * @method pop
	 * @example
	 * <div>
	 * <code>
	 * ellipse(0, 50, 33, 33);  // Left circle
	 *
	 * push();  // Start a new drawing state
	 * translate(50, 0);
	 * strokeWeight(10);
	 * fill(204, 153, 0);
	 * ellipse(0, 50, 33, 33);  // Middle circle
	 * pop();  // Restore original state
	 *
	 * ellipse(100, 50, 33, 33);  // Right circle
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * ellipse(0, 50, 33, 33);  // Left circle
	 *
	 * push();  // Start a new drawing state
	 * strokeWeight(10);
	 * fill(204, 153, 0);
	 * ellipse(33, 50, 33, 33);  // Left-middle circle
	 *
	 * push();  // Start another new drawing state
	 * stroke(0, 102, 153);
	 * ellipse(66, 50, 33, 33);  // Right-middle circle
	 * pop();  // Restore previous state
	 *
	 * pop();  // Restore original state
	 *
	 * ellipse(100, 50, 33, 33);  // Right circle
	 * </code>
	 * </div>
	 */
	p5.prototype.pop = function () {
	  this._renderer.pop();
	  var lastS = this._styles.pop();
	  for(var prop in lastS){
	    this._renderer[prop] = lastS[prop];
	  }
	};
	
	p5.prototype.pushStyle = function() {
	  throw new Error('pushStyle() not used, see push()');
	};
	
	p5.prototype.popStyle = function() {
	  throw new Error('popStyle() not used, see pop()');
	};
	
	/**
	 *
	 * Executes the code within draw() one time. This functions allows the
	 * program to update the display window only when necessary, for example
	 * when an event registered by mousePressed() or keyPressed() occurs.
	 * <br><br>
	 * In structuring a program, it only makes sense to call redraw() within
	 * events such as mousePressed(). This is because redraw() does not run
	 * draw() immediately (it only sets a flag that indicates an update is
	 * needed).
	 * <br><br>
	 * The redraw() function does not work properly when called inside draw().
	 * To enable/disable animations, use loop() and noLoop().
	 *
	 * @method redraw
	 * @example
	 *   <div><code>
	 *     var x = 0;
	 *
	 *     function setup() {
	 *       createCanvas(100, 100);
	 *       noLoop();
	 *     }
	 *
	 *     function draw() {
	 *       background(204);
	 *       line(x, 0, x, height);
	 *     }
	 *
	 *     function mousePressed() {
	 *       x += 1;
	 *       redraw();
	 *     }
	 *   </code></div>
	 */
	p5.prototype.redraw = function () {
	  var userSetup = this.setup || window.setup;
	  var userDraw = this.draw || window.draw;
	  if (typeof userDraw === 'function') {
	    this.push();
	    if (typeof userSetup === 'undefined') {
	      this.scale(this._pixelDensity, this._pixelDensity);
	    }
	    var self = this;
	    this._registeredMethods.pre.forEach(function (f) {
	      f.call(self);
	    });
	    userDraw();
	    this._registeredMethods.post.forEach(function (f) {
	      f.call(self);
	    });
	    this.pop();
	  }
	};
	
	p5.prototype.size = function() {
	  var s = 'size() is not a valid p5 function, to set the size of the ';
	  s += 'drawing canvas, please use createCanvas() instead';
	  throw s;
	};
	
	
	module.exports = p5;
	
	},{"./core":48}],59:[function(_dereq_,module,exports){
	/**
	 * @module Transform
	 * @submodule Transform
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	
	'use strict';
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('./constants');
	
	/**
	 * Multiplies the current matrix by the one specified through the parameters.
	 * This is very slow because it will try to calculate the inverse of the
	 * transform, so avoid it whenever possible.
	 *
	 * @method applyMatrix
	 * @param  {Number} n00 numbers which define the 3x2 matrix to be multiplied
	 * @param  {Number} n01 numbers which define the 3x2 matrix to be multiplied
	 * @param  {Number} n02 numbers which define the 3x2 matrix to be multiplied
	 * @param  {Number} n10 numbers which define the 3x2 matrix to be multiplied
	 * @param  {Number} n11 numbers which define the 3x2 matrix to be multiplied
	 * @param  {Number} n12 numbers which define the 3x2 matrix to be multiplied
	 * @return {p5}         the p5 object
	 * @example
	 * <div>
	 * <code>
	 * // Example in the works.
	 * </code>
	 * </div>
	 */
	p5.prototype.applyMatrix = function(n00, n01, n02, n10, n11, n12) {
	  this._renderer.applyMatrix(n00, n01, n02, n10, n11, n12);
	  return this;
	};
	
	p5.prototype.popMatrix = function() {
	  throw new Error('popMatrix() not used, see pop()');
	};
	
	p5.prototype.printMatrix = function() {
	  throw new Error('printMatrix() not implemented');
	};
	
	p5.prototype.pushMatrix = function() {
	  throw new Error('pushMatrix() not used, see push()');
	};
	
	/**
	 * Replaces the current matrix with the identity matrix.
	 *
	 * @method resetMatrix
	 * @return {p5} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * // Example in the works.
	 * </code>
	 * </div>
	 */
	p5.prototype.resetMatrix = function() {
	  this._renderer.resetMatrix();
	  return this;
	};
	
	/**
	 * Rotates a shape the amount specified by the angle parameter. This
	 * function accounts for angleMode, so angles can be entered in either
	 * RADIANS or DEGREES.
	 * <br><br>
	 * Objects are always rotated around their relative position to the
	 * origin and positive numbers rotate objects in a clockwise direction.
	 * Transformations apply to everything that happens after and subsequent
	 * calls to the function accumulates the effect. For example, calling
	 * rotate(HALF_PI) and then rotate(HALF_PI) is the same as rotate(PI).
	 * All tranformations are reset when draw() begins again.
	 * <br><br>
	 * Technically, rotate() multiplies the current transformation matrix
	 * by a rotation matrix. This function can be further controlled by
	 * the push() and pop().
	 *
	 * @method rotate
	 * @param  {Number} angle the angle of rotation, specified in radians
	 *                        or degrees, depending on current angleMode
	 * @return {p5}           the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(width/2, height/2);
	 * rotate(PI/3.0);
	 * rect(-26, -26, 52, 52);
	 * </code>
	 * </div>
	 */
	p5.prototype.rotate = function() {
	  var r = arguments[0];
	  if (this._angleMode === constants.DEGREES) {
	    r = this.radians(r);
	  }
	  //in webgl mode
	  if(arguments.length > 1){
	    this._renderer.rotate(r, arguments[1]);
	  }
	  else {
	    this._renderer.rotate(r);
	  }
	  return this;
	};
	
	/**
	 * [rotateX description]
	 * @param  {[type]} rad [description]
	 * @return {[type]}     [description]
	 */
	p5.prototype.rotateX = function(rad) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  if (this._renderer.isP3D) {
	    this._validateParameters(
	      'rotateX',
	      args,
	      [
	        ['Number']
	      ]
	    );
	    this._renderer.rotateX(rad);
	  } else {
	    throw 'not supported in p2d. Please use webgl mode';
	  }
	  return this;
	};
	
	/**
	 * [rotateY description]
	 * @param  {[type]} rad [description]
	 * @return {[type]}     [description]
	 */
	p5.prototype.rotateY = function(rad) {
	  if (this._renderer.isP3D) {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; ++i) {
	      args[i] = arguments[i];
	    }
	    this._validateParameters(
	      'rotateY',
	      args,
	      [
	        ['Number']
	      ]
	    );
	    this._renderer.rotateY(rad);
	  } else {
	    throw 'not supported in p2d. Please use webgl mode';
	  }
	  return this;
	};
	
	/**
	 * [rotateZ description]
	 * @param  {[type]} rad [description]
	 * @return {[type]}     [description]
	 */
	p5.prototype.rotateZ = function(rad) {
	  if (this._renderer.isP3D) {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; ++i) {
	      args[i] = arguments[i];
	    }
	    this._validateParameters(
	      'rotateZ',
	      args,
	      [
	        ['Number']
	      ]
	    );
	    this._renderer.rotateZ(rad);
	  } else {
	    throw 'not supported in p2d. Please use webgl mode';
	  }
	  return this;
	};
	
	/**
	 * Increases or decreases the size of a shape by expanding and contracting
	 * vertices. Objects always scale from their relative origin to the
	 * coordinate system. Scale values are specified as decimal percentages.
	 * For example, the function call scale(2.0) increases the dimension of a
	 * shape by 200%.
	 * <br><br>
	 * Transformations apply to everything that happens after and subsequent
	 * calls to the function multiply the effect. For example, calling scale(2.0)
	 * and then scale(1.5) is the same as scale(3.0). If scale() is called
	 * within draw(), the transformation is reset when the loop begins again.
	 * <br><br>
	 * Using this fuction with the z parameter requires using P3D as a
	 * parameter for size(), as shown in the third example above. This function
	 * can be further controlled with push() and pop().
	 *
	 * @method scale
	 * @param  {Number | p5.Vector | Array} s
	 *                      percent to scale the object, or percentage to
	 *                      scale the object in the x-axis if multiple arguments
	 *                      are given
	 * @param  {Number} [y] percent to scale the object in the y-axis
	 * @param  {Number} [z] percent to scale the object in the z-axis (webgl only)
	 * @return {p5}         the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(width/2, height/2);
	 * rotate(PI/3.0);
	 * rect(-26, -26, 52, 52);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * rect(30, 20, 50, 50);
	 * scale(0.5, 1.3);
	 * rect(30, 20, 50, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.scale = function() {
	  var x,y,z;
	  var args = new Array(arguments.length);
	  for(var i = 0; i < args.length; i++) {
	    args[i] = arguments[i];
	  }
	  if(args[0] instanceof p5.Vector){
	    x = args[0].x;
	    y = args[0].y;
	    z = args[0].z;
	  }
	  else if(args[0] instanceof Array){
	    x = args[0][0];
	    y = args[0][1];
	    z = args[0][2] || 1;
	  }
	  else {
	    if(args.length === 1){
	      x = y = z = args[0];
	    }
	    else {
	      x = args[0];
	      y = args[1];
	      z = args[2] || 1;
	    }
	  }
	
	  if(this._renderer.isP3D){
	    this._renderer.scale.call(this._renderer, x,y,z);
	  }
	  else {
	    this._renderer.scale.call(this._renderer, x,y);
	  }
	  return this;
	};
	
	/**
	 * Shears a shape around the x-axis the amount specified by the angle
	 * parameter. Angles should be specified in the current angleMode.
	 * Objects are always sheared around their relative position to the origin
	 * and positive numbers shear objects in a clockwise direction.
	 * <br><br>
	 * Transformations apply to everything that happens after and subsequent
	 * calls to the function accumulates the effect. For example, calling
	 * shearX(PI/2) and then shearX(PI/2) is the same as shearX(PI).
	 * If shearX() is called within the draw(), the transformation is reset when
	 * the loop begins again.
	 * <br><br>
	 * Technically, shearX() multiplies the current transformation matrix by a
	 * rotation matrix. This function can be further controlled by the
	 * push() and pop() functions.
	 *
	 * @method shearX
	 * @param  {Number} angle angle of shear specified in radians or degrees,
	 *                        depending on current angleMode
	 * @return {p5}           the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(width/4, height/4);
	 * shearX(PI/4.0);
	 * rect(0, 0, 30, 30);
	 * </code>
	 * </div>
	 */
	p5.prototype.shearX = function(angle) {
	  if (this._angleMode === constants.DEGREES) {
	    angle = this.radians(angle);
	  }
	  this._renderer.shearX(angle);
	  return this;
	};
	
	/**
	 * Shears a shape around the y-axis the amount specified by the angle
	 * parameter. Angles should be specified in the current angleMode. Objects
	 * are always sheared around their relative position to the origin and
	 * positive numbers shear objects in a clockwise direction.
	 * <br><br>
	 * Transformations apply to everything that happens after and subsequent
	 * calls to the function accumulates the effect. For example, calling
	 * shearY(PI/2) and then shearY(PI/2) is the same as shearY(PI). If
	 * shearY() is called within the draw(), the transformation is reset when
	 * the loop begins again.
	 * <br><br>
	 * Technically, shearY() multiplies the current transformation matrix by a
	 * rotation matrix. This function can be further controlled by the
	 * push() and pop() functions.
	 *
	 * @method shearY
	 * @param  {Number} angle angle of shear specified in radians or degrees,
	 *                        depending on current angleMode
	 * @return {p5}           the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(width/4, height/4);
	 * shearY(PI/4.0);
	 * rect(0, 0, 30, 30);
	 * </code>
	 * </div>
	 */
	p5.prototype.shearY = function(angle) {
	  if (this._angleMode === constants.DEGREES) {
	    angle = this.radians(angle);
	  }
	  this._renderer.shearY(angle);
	  return this;
	};
	
	/**
	 * Specifies an amount to displace objects within the display window.
	 * The x parameter specifies left/right translation, the y parameter
	 * specifies up/down translation.
	 * <br><br>
	 * Transformations are cumulative and apply to everything that happens after
	 * and subsequent calls to the function accumulates the effect. For example,
	 * calling translate(50, 0) and then translate(20, 0) is the same as
	 * translate(70, 0). If translate() is called within draw(), the
	 * transformation is reset when the loop begins again. This function can be
	 * further controlled by using push() and pop().
	 *
	 * @method translate
	 * @param  {Number} x left/right translation
	 * @param  {Number} y up/down translation
	 * @return {p5}       the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(30, 20);
	 * rect(0, 0, 55, 55);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * rect(0, 0, 55, 55);  // Draw rect at original 0,0
	 * translate(30, 20);
	 * rect(0, 0, 55, 55);  // Draw rect at new 0,0
	 * translate(14, 14);
	 * rect(0, 0, 55, 55);  // Draw rect at new 0,0
	 * </code>
	 * </div>
	 */
	p5.prototype.translate = function(x, y, z) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	
	  console.log(x, y)
	  if (this._renderer.isP3D) {
	    this._validateParameters(
	      'translate',
	      args,
	      [
	        //p3d
	        ['Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.translate(x, y, z);
	  } else {
	    this._validateParameters(
	      'translate',
	      args,
	      [
	        //p2d
	        ['Number', 'Number']
	      ]
	    );
	    this._renderer.translate(x, y);
	  }
	  return this;
	};
	
	module.exports = p5;
	
	},{"./constants":47,"./core":48}],60:[function(_dereq_,module,exports){
	/**
	 * @module Shape
	 * @submodule Vertex
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('./core');
	var constants = _dereq_('./constants');
	var shapeKind = null;
	var vertices = [];
	var contourVertices = [];
	var isBezier = false;
	var isCurve = false;
	var isQuadratic = false;
	var isContour = false;
	
	/**
	 * Use the beginContour() and endContour() functions to create negative
	 * shapes within shapes such as the center of the letter 'O'. beginContour()
	 * begins recording vertices for the shape and endContour() stops recording.
	 * The vertices that define a negative shape must "wind" in the opposite
	 * direction from the exterior shape. First draw vertices for the exterior
	 * clockwise order, then for internal shapes, draw vertices
	 * shape in counter-clockwise.
	 * <br><br>
	 * These functions can only be used within a beginShape()/endShape() pair and
	 * transformations such as translate(), rotate(), and scale() do not work
	 * within a beginContour()/endContour() pair. It is also not possible to use
	 * other shapes, such as ellipse() or rect() within.
	 *
	 * @method beginContour
	 * @return {Object} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(50, 50);
	 * stroke(255, 0, 0);
	 * beginShape();
	 * // Exterior part of shape, clockwise winding
	 * vertex(-40, -40);
	 * vertex(40, -40);
	 * vertex(40, 40);
	 * vertex(-40, 40);
	 * // Interior part of shape, counter-clockwise winding
	 * beginContour();
	 * vertex(-20, -20);
	 * vertex(-20, 20);
	 * vertex(20, 20);
	 * vertex(20, -20);
	 * endContour();
	 * endShape(CLOSE);
	 * </code>
	 * </div>
	 */
	p5.prototype.beginContour = function() {
	  contourVertices = [];
	  isContour = true;
	  return this;
	};
	
	/**
	 * Using the beginShape() and endShape() functions allow creating more
	 * complex forms. beginShape() begins recording vertices for a shape and
	 * endShape() stops recording. The value of the kind parameter tells it which
	 * types of shapes to create from the provided vertices. With no mode
	 * specified, the shape can be any irregular polygon.
	 * <br><br>
	 * The parameters available for beginShape() are POINTS, LINES, TRIANGLES,
	 * TRIANGLE_FAN, TRIANGLE_STRIP, QUADS, and QUAD_STRIP. After calling the
	 * beginShape() function, a series of vertex() commands must follow. To stop
	 * drawing the shape, call endShape(). Each shape will be outlined with the
	 * current stroke color and filled with the fill color.
	 * <br><br>
	 * Transformations such as translate(), rotate(), and scale() do not work
	 * within beginShape(). It is also not possible to use other shapes, such as
	 * ellipse() or rect() within beginShape().
	 *
	 * @method beginShape
	 * @param  {Number/Constant} kind either POINTS, LINES, TRIANGLES,
	 *                                TRIANGLE_FAN, TRIANGLE_STRIP, QUADS,
	 *                                or QUAD_STRIP
	 * @return {Object}               the p5 object
	 * @example
	 * <div>
	 * <code>
	 * beginShape();
	 * vertex(30, 20);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * vertex(30, 75);
	 * endShape(CLOSE);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * // currently not working
	 * beginShape(POINTS);
	 * vertex(30, 20);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * vertex(30, 75);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape(LINES);
	 * vertex(30, 20);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * vertex(30, 75);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * beginShape();
	 * vertex(30, 20);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * vertex(30, 75);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * beginShape();
	 * vertex(30, 20);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * vertex(30, 75);
	 * endShape(CLOSE);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape(TRIANGLES);
	 * vertex(30, 75);
	 * vertex(40, 20);
	 * vertex(50, 75);
	 * vertex(60, 20);
	 * vertex(70, 75);
	 * vertex(80, 20);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape(TRIANGLE_STRIP);
	 * vertex(30, 75);
	 * vertex(40, 20);
	 * vertex(50, 75);
	 * vertex(60, 20);
	 * vertex(70, 75);
	 * vertex(80, 20);
	 * vertex(90, 75);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape(TRIANGLE_FAN);
	 * vertex(57.5, 50);
	 * vertex(57.5, 15);
	 * vertex(92, 50);
	 * vertex(57.5, 85);
	 * vertex(22, 50);
	 * vertex(57.5, 15);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape(QUADS);
	 * vertex(30, 20);
	 * vertex(30, 75);
	 * vertex(50, 75);
	 * vertex(50, 20);
	 * vertex(65, 20);
	 * vertex(65, 75);
	 * vertex(85, 75);
	 * vertex(85, 20);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape(QUAD_STRIP);
	 * vertex(30, 20);
	 * vertex(30, 75);
	 * vertex(50, 20);
	 * vertex(50, 75);
	 * vertex(65, 20);
	 * vertex(65, 75);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape();
	 * vertex(20, 20);
	 * vertex(40, 20);
	 * vertex(40, 40);
	 * vertex(60, 40);
	 * vertex(60, 60);
	 * vertex(20, 60);
	 * endShape(CLOSE);
	 * </code>
	 * </div>
	 */
	p5.prototype.beginShape = function(kind) {
	  if (kind === constants.POINTS ||
	    kind === constants.LINES ||
	    kind === constants.TRIANGLES ||
	    kind === constants.TRIANGLE_FAN ||
	    kind === constants.TRIANGLE_STRIP ||
	    kind === constants.QUADS ||
	    kind === constants.QUAD_STRIP) {
	    shapeKind = kind;
	  } else {
	    shapeKind = null;
	  }
	  if(this._renderer.isP3D){
	    this._renderer.beginShape(kind);
	  } else {
	    vertices = [];
	    contourVertices = [];
	  }
	  return this;
	};
	
	/**
	 * Specifies vertex coordinates for Bezier curves. Each call to
	 * bezierVertex() defines the position of two control points and
	 * one anchor point of a Bezier curve, adding a new segment to a
	 * line or shape.
	 * <br><br>
	 * The first time bezierVertex() is used within a
	 * beginShape() call, it must be prefaced with a call to vertex()
	 * to set the first anchor point. This function must be used between
	 * beginShape() and endShape() and only when there is no MODE
	 * parameter specified to beginShape().
	 *
	 * @method bezierVertex
	 * @param  {Number} x2 x-coordinate for the first control point
	 * @param  {Number} y2 y-coordinate for the first control point
	 * @param  {Number} x3 x-coordinate for the second control point
	 * @param  {Number} y3 y-coordinate for the second control point
	 * @param  {Number} x4 x-coordinate for the anchor point
	 * @param  {Number} y4 y-coordinate for the anchor point
	 * @return {Object}    the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * beginShape();
	 * vertex(30, 20);
	 * bezierVertex(80, 0, 80, 75, 30, 75);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * beginShape();
	 * vertex(30, 20);
	 * bezierVertex(80, 0, 80, 75, 30, 75);
	 * bezierVertex(50, 80, 60, 25, 30, 20);
	 * endShape();
	 * </code>
	 * </div>
	 */
	p5.prototype.bezierVertex = function(x2, y2, x3, y3, x4, y4) {
	  if (vertices.length === 0) {
	    throw 'vertex() must be used once before calling bezierVertex()';
	  } else {
	    isBezier = true;
	    var vert = [];
	    for (var i = 0; i < arguments.length; i++) {
	      vert[i] = arguments[i];
	    }
	    vert.isVert = false;
	    if (isContour) {
	      contourVertices.push(vert);
	    } else {
	      vertices.push(vert);
	    }
	  }
	  return this;
	};
	
	/**
	 * Specifies vertex coordinates for curves. This function may only
	 * be used between beginShape() and endShape() and only when there
	 * is no MODE parameter specified to beginShape().
	 * <br><br>
	 * The first and last points in a series of curveVertex() lines will be used to
	 * guide the beginning and end of a the curve. A minimum of four
	 * points is required to draw a tiny curve between the second and
	 * third points. Adding a fifth point with curveVertex() will draw
	 * the curve between the second, third, and fourth points. The
	 * curveVertex() function is an implementation of Catmull-Rom
	 * splines.
	 *
	 * @method curveVertex
	 * @param {Number} x x-coordinate of the vertex
	 * @param {Number} y y-coordinate of the vertex
	 * @return {Object} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * beginShape();
	 * curveVertex(84,  91);
	 * curveVertex(84,  91);
	 * curveVertex(68,  19);
	 * curveVertex(21,  17);
	 * curveVertex(32, 100);
	 * curveVertex(32, 100);
	 * endShape();
	 * </code>
	 * </div>
	 */
	p5.prototype.curveVertex = function(x,y) {
	  isCurve = true;
	  this.vertex(x, y);
	  return this;
	};
	
	/**
	 * Use the beginContour() and endContour() functions to create negative
	 * shapes within shapes such as the center of the letter 'O'. beginContour()
	 * begins recording vertices for the shape and endContour() stops recording.
	 * The vertices that define a negative shape must "wind" in the opposite
	 * direction from the exterior shape. First draw vertices for the exterior
	 * clockwise order, then for internal shapes, draw vertices
	 * shape in counter-clockwise.
	 * <br><br>
	 * These functions can only be used within a beginShape()/endShape() pair and
	 * transformations such as translate(), rotate(), and scale() do not work
	 * within a beginContour()/endContour() pair. It is also not possible to use
	 * other shapes, such as ellipse() or rect() within.
	 *
	 * @method endContour
	 * @return {Object} the p5 object
	 * @example
	 * <div>
	 * <code>
	 * translate(50, 50);
	 * stroke(255, 0, 0);
	 * beginShape();
	 * // Exterior part of shape, clockwise winding
	 * vertex(-40, -40);
	 * vertex(40, -40);
	 * vertex(40, 40);
	 * vertex(-40, 40);
	 * // Interior part of shape, counter-clockwise winding
	 * beginContour();
	 * vertex(-20, -20);
	 * vertex(-20, 20);
	 * vertex(20, 20);
	 * vertex(20, -20);
	 * endContour();
	 * endShape(CLOSE);
	 * </code>
	 * </div>
	 */
	p5.prototype.endContour = function() {
	  var vert = contourVertices[0].slice(); // copy all data
	  vert.isVert = contourVertices[0].isVert;
	  vert.moveTo = false;
	  contourVertices.push(vert);
	
	  vertices.push(vertices[0]);
	  for (var i = 0; i < contourVertices.length; i++) {
	    vertices.push(contourVertices[i]);
	  }
	  return this;
	};
	
	/**
	 * The endShape() function is the companion to beginShape() and may only be
	 * called after beginShape(). When endshape() is called, all of image data
	 * defined since the previous call to beginShape() is written into the image
	 * buffer. The constant CLOSE as the value for the MODE parameter to close
	 * the shape (to connect the beginning and the end).
	 *
	 * @method endShape
	 * @param  {Number/Constant} mode use CLOSE to close the shape
	 * @return {Object}               the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 *
	 * beginShape();
	 * vertex(20, 20);
	 * vertex(45, 20);
	 * vertex(45, 80);
	 * endShape(CLOSE);
	 *
	 * beginShape();
	 * vertex(50, 20);
	 * vertex(75, 20);
	 * vertex(75, 80);
	 * endShape();
	 * </code>
	 * </div>
	 */
	p5.prototype.endShape = function(mode) {
	  if(this._renderer.isP3D){
	    this._renderer.endShape();
	  }else{
	    if (vertices.length === 0) { return this; }
	    if (!this._renderer._doStroke && !this._renderer._doFill) { return this; }
	
	    var closeShape = mode === constants.CLOSE;
	
	    // if the shape is closed, the first element is also the last element
	    if (closeShape && !isContour) {
	      vertices.push(vertices[0]);
	    }
	
	    this._renderer.endShape(mode, vertices, isCurve, isBezier,
	      isQuadratic, isContour, shapeKind);
	
	    // Reset some settings
	    isCurve = false;
	    isBezier = false;
	    isQuadratic = false;
	    isContour = false;
	
	    // If the shape is closed, the first element was added as last element.
	    // We must remove it again to prevent the list of vertices from growing
	    // over successive calls to endShape(CLOSE)
	    if (closeShape) {
	      vertices.pop();
	    }
	  }
	  return this;
	};
	
	/**
	 * Specifies vertex coordinates for quadratic Bezier curves. Each call to
	 * quadraticVertex() defines the position of one control points and one
	 * anchor point of a Bezier curve, adding a new segment to a line or shape.
	 * The first time quadraticVertex() is used within a beginShape() call, it
	 * must be prefaced with a call to vertex() to set the first anchor point.
	 * This function must be used between beginShape() and endShape() and only
	 * when there is no MODE parameter specified to beginShape().
	 *
	 * @method quadraticVertex
	 * @param  {Number} cx x-coordinate for the control point
	 * @param  {Number} cy y-coordinate for the control point
	 * @param  {Number} x3 x-coordinate for the anchor point
	 * @param  {Number} y3 y-coordinate for the anchor point
	 * @return {Object}    the p5 object
	 * @example
	 * <div>
	 * <code>
	 * noFill();
	 * strokeWeight(4);
	 * beginShape();
	 * vertex(20, 20);
	 * quadraticVertex(80, 20, 50, 50);
	 * endShape();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * noFill();
	 * strokeWeight(4);
	 * beginShape();
	 * vertex(20, 20);
	 * quadraticVertex(80, 20, 50, 50);
	 * quadraticVertex(20, 80, 80, 80);
	 * vertex(80, 60);
	 * endShape();
	 * </code>
	 * </div>
	 */
	p5.prototype.quadraticVertex = function(cx, cy, x3, y3) {
	  //if we're drawing a contour, put the points into an
	  // array for inside drawing
	  if(this._contourInited) {
	    var pt = {};
	    pt.x = cx;
	    pt.y = cy;
	    pt.x3 = x3;
	    pt.y3 = y3;
	    pt.type = constants.QUADRATIC;
	    this._contourVertices.push(pt);
	
	    return this;
	  }
	  if (vertices.length > 0) {
	    isQuadratic = true;
	    var vert = [];
	    for (var i = 0; i < arguments.length; i++) {
	      vert[i] = arguments[i];
	    }
	    vert.isVert = false;
	    if (isContour) {
	      contourVertices.push(vert);
	    } else {
	      vertices.push(vert);
	    }
	  } else {
	    throw 'vertex() must be used once before calling quadraticVertex()';
	  }
	  return this;
	};
	
	/**
	 * All shapes are constructed by connecting a series of vertices. vertex()
	 * is used to specify the vertex coordinates for points, lines, triangles,
	 * quads, and polygons. It is used exclusively within the beginShape() and
	 * endShape() functions.
	 *
	 * @method vertex
	 * @param  {Number} x x-coordinate of the vertex
	 * @param  {Number} y y-coordinate of the vertex
	 * @return {Object}   the p5 object
	 * @example
	 * <div>
	 * <code>
	 * beginShape(POINTS);
	 * vertex(30, 20);
	 * vertex(85, 20);
	 * vertex(85, 75);
	 * vertex(30, 75);
	 * endShape();
	 * </code>
	 * </div>
	 */
	p5.prototype.vertex = function(x, y, moveTo) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  if(this._renderer.isP3D){
	    this._validateParameters(
	      'vertex',
	      args,
	      [
	        ['Number', 'Number', 'Number']
	      ]
	    );
	    this._renderer.vertex
	    (arguments[0], arguments[1], arguments[2]);
	  }else{
	    this._validateParameters(
	      'vertex',
	      args,
	      [
	        ['Number', 'Number'],
	        ['Number', 'Number', 'Number']
	      ]
	    );
	    var vert = [];
	    vert.isVert = true;
	    vert[0] = x;
	    vert[1] = y;
	    vert[2] = 0;
	    vert[3] = 0;
	    vert[4] = 0;
	    vert[5] = this._renderer._getFill();
	    vert[6] = this._renderer._getStroke();
	
	    if (moveTo) {
	      vert.moveTo = moveTo;
	    }
	    if (isContour) {
	      if (contourVertices.length === 0) {
	        vert.moveTo = true;
	      }
	      contourVertices.push(vert);
	    } else {
	      vertices.push(vert);
	    }
	  }
	  return this;
	};
	
	module.exports = p5;
	
	},{"./constants":47,"./core":48}],61:[function(_dereq_,module,exports){
	/**
	 * @module Events
	 * @submodule Acceleration
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * The system variable deviceOrientation always contains the orientation of
	 * the device. The value of this variable will either be set 'landscape'
	 * or 'portrait'. If no data is available it will be set to 'undefined'.
	 *
	 * @property deviceOrientation
	 */
	p5.prototype.deviceOrientation = undefined;
	
	/**
	 * The system variable accelerationX always contains the acceleration of the
	 * device along the x axis. Value is represented as meters per second squared.
	 *
	 * @property accelerationX
	 */
	p5.prototype.accelerationX = 0;
	
	/**
	 * The system variable accelerationY always contains the acceleration of the
	 * device along the y axis. Value is represented as meters per second squared.
	 *
	 * @property accelerationY
	 */
	p5.prototype.accelerationY = 0;
	
	/**
	 * The system variable accelerationZ always contains the acceleration of the
	 * device along the z axis. Value is represented as meters per second squared.
	 *
	 * @property accelerationZ
	 */
	p5.prototype.accelerationZ = 0;
	
	/**
	 * The system variable pAccelerationX always contains the acceleration of the
	 * device along the x axis in the frame previous to the current frame. Value
	 * is represented as meters per second squared.
	 *
	 * @property pAccelerationX
	 */
	p5.prototype.pAccelerationX = 0;
	
	/**
	 * The system variable pAccelerationY always contains the acceleration of the
	 * device along the y axis in the frame previous to the current frame. Value
	 * is represented as meters per second squared.
	 *
	 * @property pAccelerationY
	 */
	p5.prototype.pAccelerationY = 0;
	
	/**
	 * The system variable pAccelerationZ always contains the acceleration of the
	 * device along the z axis in the frame previous to the current frame. Value
	 * is represented as meters per second squared.
	 *
	 * @property pAccelerationZ
	 */
	p5.prototype.pAccelerationZ = 0;
	
	/**
	 * _updatePAccelerations updates the pAcceleration values
	 *
	 * @private
	 */
	p5.prototype._updatePAccelerations = function(){
	  this._setProperty('pAccelerationX', this.accelerationX);
	  this._setProperty('pAccelerationY', this.accelerationY);
	  this._setProperty('pAccelerationZ', this.accelerationZ);
	};
	
	/**
	 * The system variable rotationX always contains the rotation of the
	 * device along the x axis. Value is represented as 0 to +/-180 degrees.
	 *
	 * @property rotationX
	 */
	p5.prototype.rotationX = 0;
	
	/**
	 * The system variable rotationY always contains the rotation of the
	 * device along the y axis. Value is represented as 0 to +/-180 degrees.
	 *
	 * @property rotationY
	 */
	p5.prototype.rotationY = 0;
	
	/**
	 * The system variable rotationZ always contains the rotation of the
	 * device along the z axis. Value is represented as 0 to 359 degrees.
	 * <br><br>
	 * Unlike rotationX and rotationY, this variable is available for devices
	 * with a built-in compass only.
	 *
	 * @property rotationZ
	 */
	p5.prototype.rotationZ = 0;
	
	/**
	 * The system variable pRotationX always contains the rotation of the
	 * device along the x axis in the frame previous to the current frame. Value
	 * is represented as 0 to +/-180 degrees.
	 * <br><br>
	 * pRotationX can also be used with rotationX to determine the rotate
	 * direction of the device along the X-axis.
	 * @example
	 * <div class='norender'>
	 * <code>
	 * // A simple if statement looking at whether
	 * // rotationX - pRotationX < 0 is true or not will be
	 * // sufficient for determining the rotate direction
	 * // in most cases.
	 *
	 * // Some extra logic is needed to account for cases where
	 * // the angles wrap around.
	 * var rotateDirection = 'clockwise';
	 *
	 * // Simple range conversion to make things simpler.
	 * // This is not absolutely neccessary but the logic
	 * // will be different in that case.
	 *
	 * var rX = rotationX + 180;
	 * var pRX = pRotationX + 180;
	 *
	 * if ((rX - pRX > 0 && rX - pRX < 270)|| rX - pRX < -270){
	 *   rotateDirection = 'clockwise';
	 * } else if (rX - pRX < 0 || rX - pRX > 270){
	 *   rotateDirection = 'counter-clockwise';
	 * }
	 * </code>
	 * </div>
	 *
	 * @property pRotationX
	 */
	p5.prototype.pRotationX = 0;
	
	/**
	 * The system variable pRotationY always contains the rotation of the
	 * device along the y axis in the frame previous to the current frame. Value
	 * is represented as 0 to +/-180 degrees.
	 * <br><br>
	 * pRotationY can also be used with rotationY to determine the rotate
	 * direction of the device along the Y-axis.
	 * @example
	 * <div class='norender'>
	 * <code>
	 * // A simple if statement looking at whether
	 * // rotationY - pRotationY < 0 is true or not will be
	 * // sufficient for determining the rotate direction
	 * // in most cases.
	 *
	 * // Some extra logic is needed to account for cases where
	 * // the angles wrap around.
	 * var rotateDirection = 'clockwise';
	 *
	 * // Simple range conversion to make things simpler.
	 * // This is not absolutely neccessary but the logic
	 * // will be different in that case.
	 *
	 * var rY = rotationY + 180;
	 * var pRY = pRotationY + 180;
	 *
	 * if ((rY - pRY > 0 && rY - pRY < 270)|| rY - pRY < -270){
	 *   rotateDirection = 'clockwise';
	 * } else if (rY - pRY < 0 || rY - pRY > 270){
	 *   rotateDirection = 'counter-clockwise';
	 * }
	 * </code>
	 * </div>
	 *
	 * @property pRotationY
	 */
	p5.prototype.pRotationY = 0;
	
	/**
	 * The system variable pRotationZ always contains the rotation of the
	 * device along the z axis in the frame previous to the current frame. Value
	 * is represented as 0 to 359 degrees.
	 * <br><br>
	 * pRotationZ can also be used with rotationZ to determine the rotate
	 * direction of the device along the Z-axis.
	 * @example
	 * <div class='norender'>
	 * <code>
	 * // A simple if statement looking at whether
	 * // rotationZ - pRotationZ < 0 is true or not will be
	 * // sufficient for determining the rotate direction
	 * // in most cases.
	 *
	 * // Some extra logic is needed to account for cases where
	 * // the angles wrap around.
	 * var rotateDirection = 'clockwise';
	 *
	 * if ((rotationZ - pRotationZ > 0 &&
	 *   rotationZ - pRotationZ < 270)||
	 *   rotationZ - pRotationZ < -270){
	 *
	 *   rotateDirection = 'clockwise';
	 *
	 * } else if (rotationZ - pRotationZ < 0 ||
	 *   rotationZ - pRotationZ > 270){
	 *
	 *   rotateDirection = 'counter-clockwise';
	 *
	 * }
	 * </code>
	 * </div>
	 *
	 * @property pRotationZ
	 */
	p5.prototype.pRotationZ = 0;
	
	var startAngleX = 0;
	var startAngleY = 0;
	var startAngleZ = 0;
	
	var rotateDirectionX = 'clockwise';
	var rotateDirectionY = 'clockwise';
	var rotateDirectionZ = 'clockwise';
	
	var pRotateDirectionX;
	var pRotateDirectionY;
	var pRotateDirectionZ;
	
	p5.prototype._updatePRotations = function(){
	  this._setProperty('pRotationX', this.rotationX);
	  this._setProperty('pRotationY', this.rotationY);
	  this._setProperty('pRotationZ', this.rotationZ);
	};
	
	p5.prototype.turnAxis = undefined;
	
	var move_threshold = 0.5;
	var shake_threshold = 30;
	
	/**
	 * The setMoveThreshold() function is used to set the movement threshold for
	 * the deviceMoved() function. The default threshold is set to 0.5.
	 *
	 * @method setMoveThreshold
	 * @param {number} value The threshold value
	 */
	p5.prototype.setMoveThreshold = function(val){
	  if(typeof val === 'number'){
	    move_threshold = val;
	  }
	};
	
	/**
	 * The setShakeThreshold() function is used to set the movement threshold for
	 * the deviceShaken() function. The default threshold is set to 30.
	 *
	 * @method setShakeThreshold
	 * @param {number} value The threshold value
	 */
	p5.prototype.setShakeThreshold = function(val){
	  if(typeof val === 'number'){
	    shake_threshold = val;
	  }
	};
	
	/**
	 * The deviceMoved() function is called when the device is moved by more than
	 * the threshold value along X, Y or Z axis. The default threshold is set to
	 * 0.5.
	 * @method deviceMoved
	 * @example
	 * <div>
	 * <code>
	 * // Run this example on a mobile device
	 * // Move the device around
	 * // to change the value.
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function deviceMoved() {
	 *   value = value + 5;
	 *   if (value > 255) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	
	/**
	 * The deviceTurned() function is called when the device rotates by
	 * more than 90 degrees continuously.
	 * <br><br>
	 * The axis that triggers the deviceTurned() method is stored in the turnAxis
	 * variable. The deviceTurned() method can be locked to trigger on any axis:
	 * X, Y or Z by comparing the turnAxis variable to 'X', 'Y' or 'Z'.
	 *
	 * @method deviceTurned
	 * @example
	 * <div>
	 * <code>
	 * // Run this example on a mobile device
	 * // Rotate the device by 90 degrees
	 * // to change the value.
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function deviceTurned() {
	 *   if (value == 0){
	 *     value = 255
	 *   } else if (value == 255) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * // Run this example on a mobile device
	 * // Rotate the device by 90 degrees in the
	 * // X-axis to change the value.
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function deviceTurned() {
	 *   if (turnAxis == 'X'){
	 *     if (value == 0){
	 *       value = 255
	 *     } else if (value == 255) {
	 *       value = 0;
	 *     }
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	
	/**
	 * The deviceShaken() function is called when the device total acceleration
	 * changes of accelerationX and accelerationY values is more than
	 * the threshold value. The default threshold is set to 30.
	 * @method deviceShaken
	 * @example
	 * <div>
	 * <code>
	 * // Run this example on a mobile device
	 * // Shake the device to change the value.
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function deviceShaken() {
	 *   value = value + 5;
	 *   if (value > 255) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	
	p5.prototype._ondeviceorientation = function (e) {
	  this._updatePRotations();
	  this._setProperty('rotationX', e.beta);
	  this._setProperty('rotationY', e.gamma);
	  this._setProperty('rotationZ', e.alpha);
	  this._handleMotion();
	};
	p5.prototype._ondevicemotion = function (e) {
	  this._updatePAccelerations();
	  this._setProperty('accelerationX', e.acceleration.x * 2);
	  this._setProperty('accelerationY', e.acceleration.y * 2);
	  this._setProperty('accelerationZ', e.acceleration.z * 2);
	  this._handleMotion();
	};
	p5.prototype._handleMotion = function() {
	  if (window.orientation === 90 || window.orientation === -90) {
	    this._setProperty('deviceOrientation', 'landscape');
	  } else if (window.orientation === 0) {
	    this._setProperty('deviceOrientation', 'portrait');
	  } else if (window.orientation === undefined) {
	    this._setProperty('deviceOrientation', 'undefined');
	  }
	  var deviceMoved = this.deviceMoved || window.deviceMoved;
	  if (typeof deviceMoved === 'function') {
	    if (Math.abs(this.accelerationX - this.pAccelerationX) > move_threshold ||
	      Math.abs(this.accelerationY - this.pAccelerationY) > move_threshold ||
	      Math.abs(this.accelerationZ - this.pAccelerationZ) > move_threshold) {
	      deviceMoved();
	    }
	  }
	  var deviceTurned = this.deviceTurned || window.deviceTurned;
	  if (typeof deviceTurned === 'function') {
	    // The angles given by rotationX etc is from range -180 to 180.
	    // The following will convert them to 0 to 360 for ease of calculation
	    // of cases when the angles wrapped around.
	    // _startAngleX will be converted back at the end and updated.
	    var wRX = this.rotationX + 180;
	    var wPRX = this.pRotationX + 180;
	    var wSAX = startAngleX + 180;
	    if ((wRX - wPRX > 0 && wRX - wPRX < 270)|| wRX - wPRX < -270){
	      rotateDirectionX = 'clockwise';
	    } else if (wRX - wPRX < 0 || wRX - wPRX > 270){
	      rotateDirectionX = 'counter-clockwise';
	    }
	    if (rotateDirectionX !== pRotateDirectionX){
	      wSAX = wRX;
	    }
	    if (Math.abs(wRX - wSAX) > 90 && Math.abs(wRX - wSAX) < 270){
	      wSAX = wRX;
	      this._setProperty('turnAxis', 'X');
	      deviceTurned();
	    }
	    pRotateDirectionX = rotateDirectionX;
	    startAngleX = wSAX - 180;
	
	    // Y-axis is identical to X-axis except for changing some names.
	    var wRY = this.rotationY + 180;
	    var wPRY = this.pRotationY + 180;
	    var wSAY = startAngleY + 180;
	    if ((wRY - wPRY > 0 && wRY - wPRY < 270)|| wRY - wPRY < -270){
	      rotateDirectionY = 'clockwise';
	    } else if (wRY - wPRY < 0 || wRY - this.pRotationY > 270){
	      rotateDirectionY = 'counter-clockwise';
	    }
	    if (rotateDirectionY !== pRotateDirectionY){
	      wSAY = wRY;
	    }
	    if (Math.abs(wRY - wSAY) > 90 && Math.abs(wRY - wSAY) < 270){
	      wSAY = wRY;
	      this._setProperty('turnAxis', 'Y');
	      deviceTurned();
	    }
	    pRotateDirectionY = rotateDirectionY;
	    startAngleY = wSAY - 180;
	
	    // Z-axis is already in the range 0 to 360
	    // so no conversion is needed.
	    if ((this.rotationZ - this.pRotationZ > 0 &&
	      this.rotationZ - this.pRotationZ < 270)||
	      this.rotationZ - this.pRotationZ < -270){
	      rotateDirectionZ = 'clockwise';
	    } else if (this.rotationZ - this.pRotationZ < 0 ||
	      this.rotationZ - this.pRotationZ > 270){
	      rotateDirectionZ = 'counter-clockwise';
	    }
	    if (rotateDirectionZ !== pRotateDirectionZ){
	      startAngleZ = this.rotationZ;
	    }
	    if (Math.abs(this.rotationZ - startAngleZ) > 90 &&
	      Math.abs(this.rotationZ - startAngleZ) < 270){
	      startAngleZ = this.rotationZ;
	      this._setProperty('turnAxis', 'Z');
	      deviceTurned();
	    }
	    pRotateDirectionZ = rotateDirectionZ;
	    this._setProperty('turnAxis', undefined);
	  }
	  var deviceShaken = this.deviceShaken || window.deviceShaken;
	  if (typeof deviceShaken === 'function') {
	    var accelerationChangeX;
	    var accelerationChangeY;
	    // Add accelerationChangeZ if acceleration change on Z is needed
	    if (this.pAccelerationX !== null) {
	      accelerationChangeX = Math.abs(this.accelerationX - this.pAccelerationX);
	      accelerationChangeY = Math.abs(this.accelerationY - this.pAccelerationY);
	    }
	    if (accelerationChangeX + accelerationChangeY > shake_threshold) {
	      deviceShaken();
	    }
	  }
	};
	
	
	module.exports = p5;
	
	},{"../core/core":48}],62:[function(_dereq_,module,exports){
	/**
	 * @module Events
	 * @submodule Keyboard
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Holds the key codes of currently pressed keys.
	 * @private
	 */
	var downKeys = {};
	
	/**
	 * The boolean system variable keyIsPressed is true if any key is pressed
	 * and false if no keys are pressed.
	 *
	 * @property keyIsPressed
	 * @example
	 * <div>
	 * <code>
	 * var value = 0;
	 * function draw() {
	 *   if (keyIsPressed === true) {
	 *     fill(0);
	 *   } else {
	 *     fill(255);
	 *   }
	 *   rect(25, 25, 50, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.isKeyPressed = false;
	p5.prototype.keyIsPressed = false; // khan
	
	/**
	 * The system variable key always contains the value of the most recent
	 * key on the keyboard that was typed. To get the proper capitalization, it
	 * is best to use it within keyTyped(). For non-ASCII keys, use the keyCode
	 * variable.
	 *
	 * @property key
	 * @example
	 * <div><code>
	 * // Click any key to display it!
	 * // (Not Guaranteed to be Case Sensitive)
	 * function setup() {
	 *   fill(245, 123, 158);
	 *   textSize(50);
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 *   text(key, 33,65); // Display last key pressed.
	 * }
	 * </div></code>
	 */
	p5.prototype.key = '';
	
	/**
	 * The variable keyCode is used to detect special keys such as BACKSPACE,
	 * DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL, OPTION, ALT, UP_ARROW,
	 * DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.
	 *
	 * @property keyCode
	 * @example
	 * <div><code>
	 * var fillVal = 126;
	 * function draw() {
	 *   fill(fillVal);
	 *   rect(25, 25, 50, 50);
	 * }
	 *
	 * function keyPressed() {
	 *   if (keyCode == UP_ARROW) {
	 *     fillVal = 255;
	 *   } else if (keyCode == DOWN_ARROW) {
	 *     fillVal = 0;
	 *   }
	 *   return false; // prevent default
	 * }
	 * </code></div>
	 */
	p5.prototype.keyCode = 0;
	
	/**
	 * The keyPressed() function is called once every time a key is pressed. The
	 * keyCode for the key that was pressed is stored in the keyCode variable.
	 * <br><br>
	 * For non-ASCII keys, use the keyCode variable. You can check if the keyCode
	 * equals BACKSPACE, DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL,
	 * OPTION, ALT, UP_ARROW, DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.
	 * <br><br>
	 * For ASCII keys that was pressed is stored in the key variable. However, it
	 * does not distinguish between uppercase and lowercase. For this reason, it
	 * is recommended to use keyTyped() to read the key variable, in which the
	 * case of the variable will be distinguished.
	 * <br><br>
	 * Because of how operating systems handle key repeats, holding down a key
	 * may cause multiple calls to keyTyped() (and keyReleased() as well). The
	 * rate of repeat is set by the operating system and how each computer is
	 * configured.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various key events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 * @method keyPressed
	 * @example
	 * <div>
	 * <code>
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function keyPressed() {
	 *   if (value === 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function keyPressed() {
	 *   if (keyCode === LEFT_ARROW) {
	 *     value = 255;
	 *   } else if (keyCode === RIGHT_ARROW) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 * <div class="norender">
	 * <code>
	 * function keyPressed(){
	 *   // Do something
	 *   return false; // prevent any default behaviour
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onkeydown = function (e) {
	  if (downKeys[e.which]) { // prevent multiple firings
	    return;
	  }
	  this._setProperty('isKeyPressed', true);
	  this._setProperty('keyIsPressed', true);
	  this._setProperty('keyCode', e.which);
	  downKeys[e.which] = true;
	  var key = String.fromCharCode(e.which);
	  if (!key) {
	    key = e.which;
	  }
	  this._setProperty('key', key);
	  var keyPressed = this.keyPressed || window.keyPressed;
	  if (typeof keyPressed === 'function' && !e.charCode) {
	    var executeDefault = keyPressed(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	/**
	 * The keyReleased() function is called once every time a key is released.
	 * See key and keyCode for more information.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various key events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 * @method keyReleased
	 * @example
	 * <div>
	 * <code>
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function keyReleased() {
	 *   if (value === 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 *   return false; // prevent any default behavior
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onkeyup = function (e) {
	  var keyReleased = this.keyReleased || window.keyReleased;
	  this._setProperty('isKeyPressed', false);
	  this._setProperty('keyIsPressed', false);
	  this._setProperty('_lastKeyCodeTyped', null);
	  downKeys[e.which] = false;
	  //delete this._downKeys[e.which];
	  var key = String.fromCharCode(e.which);
	  if (!key) {
	    key = e.which;
	  }
	  this._setProperty('key', key);
	  this._setProperty('keyCode', e.which);
	  if (typeof keyReleased === 'function') {
	    var executeDefault = keyReleased(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	/**
	 * The keyTyped() function is called once every time a key is pressed, but
	 * action keys such as Ctrl, Shift, and Alt are ignored. The most recent
	 * key pressed will be stored in the key variable.
	 * <br><br>
	 * Because of how operating systems handle key repeats, holding down a key
	 * will cause multiple calls to keyTyped() (and keyReleased() as well). The
	 * rate of repeat is set by the operating system and how each computer is
	 * configured.<br><br>
	 * Browsers may have different default behaviors attached to various key
	 * events. To prevent any default behavior for this event, add "return false"
	 * to the end of the method.
	 *
	 * @method keyTyped
	 * @example
	 * <div>
	 * <code>
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function keyTyped() {
	 *   if (key === 'a') {
	 *     value = 255;
	 *   } else if (key === 'b') {
	 *     value = 0;
	 *   }
	 *   return false; // prevent any default behavior
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onkeypress = function (e) {
	  if (e.which === this._lastKeyCodeTyped) { // prevent multiple firings
	    return;
	  }
	  this._setProperty('keyCode', e.which);
	  this._setProperty('_lastKeyCodeTyped', e.which); // track last keyCode
	  this._setProperty('key', String.fromCharCode(e.which));
	  var keyTyped = this.keyTyped || window.keyTyped;
	  if (typeof keyTyped === 'function') {
	    var executeDefault = keyTyped(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	/**
	 * The onblur function is called when the user is no longer focused
	 * on the p5 element. Because the keyup events will not fire if the user is
	 * not focused on the element we must assume all keys currently down have
	 * been released.
	 */
	p5.prototype._onblur = function (e) {
	  downKeys = {};
	};
	
	/**
	 * The keyIsDown() function checks if the key is currently down, i.e. pressed.
	 * It can be used if you have an object that moves, and you want several keys
	 * to be able to affect its behaviour simultaneously, such as moving a
	 * sprite diagonally. You can put in any number representing the keyCode of
	 * the key, or use any of the variable keyCode names listed
	 * <a href="http://p5js.org/reference/#p5/keyCode">here</a>.
	 *
	 * @method keyIsDown
	 * @param {Number}          code The key to check for.
	 * @return {Boolean}        whether key is down or not
	 * @example
	 * <div><code>
	 * var x = 100;
	 * var y = 100;
	 *
	 * function setup() {
	 *   createCanvas(512, 512);
	 * }
	 *
	 * function draw() {
	 *   if (keyIsDown(LEFT_ARROW))
	 *     x-=5;
	 *
	 *   if (keyIsDown(RIGHT_ARROW))
	 *     x+=5;
	 *
	 *   if (keyIsDown(UP_ARROW))
	 *     y-=5;
	 *
	 *   if (keyIsDown(DOWN_ARROW))
	 *     y+=5;
	 *
	 *   clear();
	 *   fill(255, 0, 0);
	 *   ellipse(x, y, 50, 50);
	 * }
	 * </code></div>
	 */
	p5.prototype.keyIsDown = function(code) {
	  return downKeys[code];
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],63:[function(_dereq_,module,exports){
	/**
	 * @module Events
	 * @submodule Mouse
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var constants = _dereq_('../core/constants');
	
	/*
	 * These are helper vars that store the mouseX and mouseY vals
	 * between the time that a mouse event happens and the next frame
	 * of draw. This is done to deal with the asynchronicity of event
	 * calls interacting with the draw loop. When a mouse event occurs
	 * the _nextMouseX/Y vars are updated, then on each call of draw, mouseX/Y
	 * and pmouseX/Y are updated using the _nextMouseX/Y vals.
	 */
	p5.prototype._nextMouseX = 0;
	p5.prototype._nextMouseY = 0;
	
	/**
	 * The system variable mouseX always contains the current horizontal
	 * position of the mouse, relative to (0, 0) of the canvas.
	 *
	 * @property mouseX
	 *
	 * @example
	 * <div>
	 * <code>
	 * // Move the mouse across the canvas
	 * function draw() {
	 *   background(244, 248, 252);
	 *   line(mouseX, 0, mouseX, 100);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.mouseX = 0;
	
	/**
	 * The system variable mouseY always contains the current vertical position
	 * of the mouse, relative to (0, 0) of the canvas.
	 *
	 * @property mouseY
	 *
	 * @example
	 * <div>
	 * <code>
	 * // Move the mouse across the canvas
	 * function draw() {
	 *   background(244, 248, 252);
	 *   line(0, mouseY, 100, mouseY);
	 *}
	 * </code>
	 * </div>
	 */
	p5.prototype.mouseY = 0;
	
	/**
	 * The system variable pmouseX always contains the horizontal position of
	 * the mouse in the frame previous to the current frame, relative to (0, 0)
	 * of the canvas.
	 *
	 * @property pmouseX
	 *
	 * @example
	 * <div>
	 * <code>
	 * // Move the mouse across the canvas to leave a trail
	 * function setup() {
	 *   //slow down the frameRate to make it more visible
	 *   frameRate(10);
	 * }
	 *
	 * function draw() {
	 *   background(244, 248, 252);
	 *   line(mouseX, mouseY, pmouseX, pmouseY);
	 *   print(pmouseX + " -> " + mouseX);
	 * }
	 *
	 * </code>
	 * </div>
	 */
	p5.prototype.pmouseX = 0;
	
	/**
	 * The system variable pmouseY always contains the vertical position of the
	 * mouse in the frame previous to the current frame, relative to (0, 0) of
	 * the canvas.
	 *
	 * @property pmouseY
	 *
	 * @example
	 * <div>
	 * <code>
	 * function draw() {
	 *   background(237, 34, 93);
	 *   fill(0);
	 *   //draw a square only if the mouse is not moving
	 *   if(mouseY == pmouseY && mouseX == pmouseX)
	 *     rect(20,20,60,60);
	 *
	 *   print(pmouseY + " -> " + mouseY);
	 * }
	 *
	 * </code>
	 * </div>
	 */
	p5.prototype.pmouseY = 0;
	
	/**
	 * The system variable winMouseX always contains the current horizontal
	 * position of the mouse, relative to (0, 0) of the window.
	 *
	 * @property winMouseX
	 *
	 * @example
	 * <div>
	 * <code>
	 * var myCanvas;
	 *
	 * function setup() {
	 *   //use a variable to store a pointer to the canvas
	 *   myCanvas = createCanvas(100, 100);
	 * }
	 *
	 * function draw() {
	 *   background(237, 34, 93);
	 *   fill(0);
	 *
	 *   //move the canvas to the horizontal mouse position
	 *   //relative to the window
	 *   myCanvas.position(winMouseX+1, windowHeight/2);
	 *
	 *  //the y of the square is relative to the canvas
	 *  rect(20,mouseY,60,60);
	 * }
	 *
	 * </code>
	 * </div>
	 */
	p5.prototype.winMouseX = 0;
	
	/**
	 * The system variable winMouseY always contains the current vertical
	 * position of the mouse, relative to (0, 0) of the window.
	 *
	 * @property winMouseY
	 *
	 * @example
	 * <div>
	 * <code>
	 *var myCanvas;
	 *
	 * function setup() {
	 *   //use a variable to store a pointer to the canvas
	 *   myCanvas = createCanvas(100, 100);
	 * }
	 *
	 * function draw() {
	 *   background(237, 34, 93);
	 *   fill(0);
	 *
	 *   //move the canvas to the vertical mouse position
	 *   //relative to the window
	 *   myCanvas.position(windowWidth/2, winMouseY+1);
	 *
	 *  //the x of the square is relative to the canvas
	 *  rect(mouseX,20,60,60);
	 * }
	 *
	 * </code>
	 * </div>
	 */
	p5.prototype.winMouseY = 0;
	
	/**
	 * The system variable pwinMouseX always contains the horizontal position
	 * of the mouse in the frame previous to the current frame, relative to
	 * (0, 0) of the window.
	 *
	 * @property pwinMouseX
	 *
	 * @example
	 * <div>
	 * <code>
	 *
	 * var myCanvas;
	 *
	 * function setup() {
	 *   //use a variable to store a pointer to the canvas
	 *   myCanvas = createCanvas(100, 100);
	 *   noStroke();
	 *   fill(237, 34, 93);
	 *   }
	 *
	 * function draw() {
	 *   clear();
	 *   //the difference between previous and
	 *   //current x position is the horizontal mouse speed
	 *   var speed = abs(winMouseX-pwinMouseX);
	 *   //change the size of the circle
	 *   //according to the horizontal speed
	 *   ellipse(50, 50, 10+speed*5, 10+speed*5);
	 *   //move the canvas to the mouse position
	 *   myCanvas.position( winMouseX+1, winMouseY+1);
	 * }
	 *
	 * </code>
	 * </div>
	 */
	p5.prototype.pwinMouseX = 0;
	
	/**
	 * The system variable pwinMouseY always contains the vertical position of
	 * the mouse in the frame previous to the current frame, relative to (0, 0)
	 * of the window.
	 *
	 * @property pwinMouseY
	 *
	 *
	 * @example
	 * <div>
	 * <code>
	 *
	 * var myCanvas;
	 *
	 * function setup() {
	 *   //use a variable to store a pointer to the canvas
	 *   myCanvas = createCanvas(100, 100);
	 *   noStroke();
	 *   fill(237, 34, 93);
	 *   }
	 *
	 * function draw() {
	 *   clear();
	 *   //the difference between previous and
	 *   //current y position is the vertical mouse speed
	 *   var speed = abs(winMouseY-pwinMouseY);
	 *   //change the size of the circle
	 *   //according to the vertical speed
	 *   ellipse(50, 50, 10+speed*5, 10+speed*5);
	 *   //move the canvas to the mouse position
	 *   myCanvas.position( winMouseX+1, winMouseY+1);
	 * }
	 *
	 * </code>
	 * </div>
	 */
	p5.prototype.pwinMouseY = 0;
	
	/**
	 * Processing automatically tracks if the mouse button is pressed and which
	 * button is pressed. The value of the system variable mouseButton is either
	 * LEFT, RIGHT, or CENTER depending on which button was pressed last.
	 * Warning: different browsers may track mouseButton differently.
	 *
	 * @property mouseButton
	 *
	 * @example
		* <div>
		* <code>
		* function draw() {
		*   background(237, 34, 93);
		*   fill(0);
		*
		*   if (mouseIsPressed) {
		*     if (mouseButton == LEFT)
		*       ellipse(50, 50, 50, 50);
		*     if (mouseButton == RIGHT)
		*       rect(25, 25, 50, 50);
		*     if (mouseButton == CENTER)
		*       triangle(23, 75, 50, 20, 78, 75);
		*   }
		*
		*   print(mouseButton);
		* }
		* </code>
	 * </div>
	 */
	p5.prototype.mouseButton = 0;
	
	/**
	 * The boolean system variable mouseIsPressed is true if the mouse is pressed
	 * and false if not.
	 *
	 * @property mouseIsPressed
	 *
	 * @example
		* <div>
		* <code>
		* function draw() {
		*   background(237, 34, 93);
		*   fill(0);
		*
		*   if (mouseIsPressed)
		*     ellipse(50, 50, 50, 50);
		*   else
		*     rect(25, 25, 50, 50);
		*
		*   print(mouseIsPressed);
		* }
		* </code>
		* </div>
	 */
	p5.prototype.mouseIsPressed = false;
	p5.prototype.isMousePressed = false; // both are supported
	
	p5.prototype._updateNextMouseCoords = function(e) {
	  if(e.type === 'touchstart' ||
	     e.type === 'touchmove' ||
	     e.type === 'touchend') {
	    this._setProperty('_nextMouseX', this._nextTouchX);
	    this._setProperty('_nextMouseY', this._nextTouchY);
	  } else {
	    if(this._curElement !== null) {
	      var mousePos = getMousePos(this._curElement.elt, e);
	      this._setProperty('_nextMouseX', mousePos.x);
	      this._setProperty('_nextMouseY', mousePos.y);
	    }
	  }
	  this._setProperty('winMouseX', e.pageX);
	  this._setProperty('winMouseY', e.pageY);
	};
	
	p5.prototype._updateMouseCoords = function() {
	  this._setProperty('pmouseX', this.mouseX);
	  this._setProperty('pmouseY', this.mouseY);
	  this._setProperty('mouseX', this._nextMouseX);
	  this._setProperty('mouseY', this._nextMouseY);
	  this._setProperty('pwinMouseX', this.winMouseX);
	  this._setProperty('pwinMouseY', this.winMouseY);
	};
	
	function getMousePos(canvas, evt) {
	  var rect = canvas.getBoundingClientRect();
	  return {
	    x: evt.clientX - rect.left,
	    y: evt.clientY - rect.top
	  };
	}
	
	p5.prototype._setMouseButton = function(e) {
	  if (e.button === 1) {
	    this._setProperty('mouseButton', constants.CENTER);
	  } else if (e.button === 2) {
	    this._setProperty('mouseButton', constants.RIGHT);
	  } else {
	    this._setProperty('mouseButton', constants.LEFT);
	  }
	};
	
	/**
	 * The mouseMoved() function is called every time the mouse moves and a mouse
	 * button is not pressed.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various mouse events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 * @method mouseMoved
	 * @example
	 * <div>
	 * <code>
	 * // Move the mouse across the page
	 * // to change its value
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function mouseMoved() {
	 *   value = value + 5;
	 *   if (value > 255) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function mouseMoved() {
	 *   ellipse(mouseX, mouseY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	
	/**
	 * The mouseDragged() function is called once every time the mouse moves and
	 * a mouse button is pressed. If no mouseDragged() function is defined, the
	 * touchMoved() function will be called instead if it is defined.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various mouse events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 * @method mouseDragged
	 * @example
	 * <div>
	 * <code>
	 * // Drag the mouse across the page
	 * // to change its value
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function mouseDragged() {
	 *   value = value + 5;
	 *   if (value > 255) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function mouseDragged() {
	 *   ellipse(mouseX, mouseY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onmousemove = function(e){
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  this._updateNextMouseCoords(e);
	  this._updateNextTouchCoords(e);
	  if (!this.isMousePressed) {
	    if (typeof context.mouseMoved === 'function') {
	      executeDefault = context.mouseMoved(e);
	      if(executeDefault === false) {
	        e.preventDefault();
	      }
	    }
	  }
	  else {
	    if (typeof context.mouseDragged === 'function') {
	      executeDefault = context.mouseDragged(e);
	      if(executeDefault === false) {
	        e.preventDefault();
	      }
	    } else if (typeof context.touchMoved === 'function') {
	      executeDefault = context.touchMoved(e);
	      if(executeDefault === false) {
	        e.preventDefault();
	      }
	    }
	  }
	};
	
	/**
	 * The mousePressed() function is called once after every time a mouse button
	 * is pressed. The mouseButton variable (see the related reference entry)
	 * can be used to determine which button has been pressed. If no
	 * mousePressed() function is defined, the touchStarted() function will be
	 * called instead if it is defined.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various mouse events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 * @method mousePressed
	 * @example
	 * <div>
	 * <code>
	 * // Click within the image to change
	 * // the value of the rectangle
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function mousePressed() {
	 *   if (value == 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function mousePressed() {
	 *   ellipse(mouseX, mouseY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onmousedown = function(e) {
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  this._setProperty('isMousePressed', true);
	  this._setProperty('mouseIsPressed', true);
	  this._setMouseButton(e);
	  this._updateNextMouseCoords(e);
	  this._updateNextTouchCoords(e);
	  if (typeof context.mousePressed === 'function') {
	    executeDefault = context.mousePressed(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  } else if (typeof context.touchStarted === 'function') {
	    executeDefault = context.touchStarted(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	/**
	 * The mouseReleased() function is called every time a mouse button is
	 * released. If no mouseReleased() function is defined, the touchEnded()
	 * function will be called instead if it is defined.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various mouse events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 *
	 * @method mouseReleased
	 * @example
	 * <div>
	 * <code>
	 * // Click within the image to change
	 * // the value of the rectangle
	 * // after the mouse has been clicked
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function mouseReleased() {
	 *   if (value == 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function mouseReleased() {
	 *   ellipse(mouseX, mouseY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onmouseup = function(e) {
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  this._setProperty('isMousePressed', false);
	  this._setProperty('mouseIsPressed', false);
	  if (typeof context.mouseReleased === 'function') {
	    executeDefault = context.mouseReleased(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  } else if (typeof context.touchEnded === 'function') {
	    executeDefault = context.touchEnded(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	p5.prototype._ondragend = p5.prototype._onmouseup;
	p5.prototype._ondragover = p5.prototype._onmousemove;
	
	/**
	 * The mouseClicked() function is called once after a mouse button has been
	 * pressed and then released.<br><br>
	 * Browsers may have different default
	 * behaviors attached to various mouse events. To prevent any default
	 * behavior for this event, add "return false" to the end of the method.
	 *
	 * @method mouseClicked
	 * @example
	 * <div>
	 * <code>
	 * // Click within the image to change
	 * // the value of the rectangle
	 * // after the mouse has been clicked
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function mouseClicked() {
	 *   if (value == 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function mouseClicked() {
	 *   ellipse(mouseX, mouseY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onclick = function(e) {
	  var context = this._isGlobal ? window : this;
	  if (typeof context.mouseClicked === 'function') {
	    var executeDefault = context.mouseClicked(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	/**
	 * The function mouseWheel() is executed every time a vertical mouse wheel
	 * event is detected either triggered by an actual mouse wheel or by a
	 * touchpad.<br><br>
	 * The event.delta property returns the amount the mouse wheel
	 * have scrolled. The values can be positive or negative depending on the
	 * scroll direction (on OS X with "natural" scrolling enabled, the signs
	 * are inverted).<br><br>
	 * Browsers may have different default behaviors attached to various
	 * mouse events. To prevent any default behavior for this event, add
	 * "return false" to the end of the method.<br><br>
	 * Due to the current support of the "wheel" event on Safari, the function
	 * may only work as expected if "return false" is included while using Safari.
	 *
	 * @method mouseWheel
	 *
	 * @example
	 * <div>
	 * <code>
	 * var pos = 25;
	 *
	 * function draw() {
	 *   background(237, 34, 93);
	 *   fill(0);
	 *   rect(25, pos, 50, 50);
	 * }
	 *
	 * function mouseWheel(event) {
	 *   print(event.delta);
	 *   //move the square according to the vertical scroll amount
	 *   pos += event.delta;
	 *   //uncomment to block page scrolling
	 *   //return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._onwheel = function(e) {
	  var context = this._isGlobal ? window : this;
	  if (typeof context.mouseWheel === 'function') {
	    e.delta = e.deltaY;
	    var executeDefault = context.mouseWheel(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	module.exports = p5;
	
	},{"../core/constants":47,"../core/core":48}],64:[function(_dereq_,module,exports){
	/**
	 * @module Events
	 * @submodule Touch
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/*
	 * These are helper vars that store the touchX and touchY vals
	 * between the time that a mouse event happens and the next frame
	 * of draw. This is done to deal with the asynchronicity of event
	 * calls interacting with the draw loop. When a touch event occurs
	 * the _nextTouchX/Y vars are updated, then on each call of draw, touchX/Y
	 * and ptouchX/Y are updated using the _nextMouseX/Y vals.
	 */
	p5.prototype._nextTouchX = 0;
	p5.prototype._nextTouchY = 0;
	
	/**
	 * The system variable touchX always contains the horizontal position of
	 * one finger, relative to (0, 0) of the canvas. This is best used for
	 * single touch interactions. For multi-touch interactions, use the
	 * touches[] array.
	 *
	 * @property touchX
	 */
	p5.prototype.touchX = 0;
	
	/**
	 * The system variable touchY always contains the vertical position of
	 * one finger, relative to (0, 0) of the canvas. This is best used for
	 * single touch interactions. For multi-touch interactions, use the
	 * touches[] array.
	 *
	 * @property touchY
	 */
	p5.prototype.touchY = 0;
	
	/**
	 * The system variable ptouchX always contains the horizontal position of
	 * one finger, relative to (0, 0) of the canvas, in the frame previous to the
	 * current frame.
	 *
	 * @property ptouchX
	 */
	p5.prototype.ptouchX = 0;
	
	/**
	 * The system variable ptouchY always contains the vertical position of
	 * one finger, relative to (0, 0) of the canvas, in the frame previous to the
	 * current frame.
	 *
	 * @property ptouchY
	 */
	p5.prototype.ptouchY = 0;
	
	/**
	 * The system variable touches[] contains an array of the positions of all
	 * current touch points, relative to (0, 0) of the canvas, and IDs identifying a
	 * unique touch as it moves. Each element in the array is an object with x, y,
	 * and id properties.
	 *
	 * @property touches[]
	 */
	p5.prototype.touches = [];
	
	/**
	 * The boolean system variable touchIsDown is true if the screen is
	 * touched and false if not.
	 *
	 * @property touchIsDown
	 */
	p5.prototype.touchIsDown = false;
	
	p5.prototype._updateNextTouchCoords = function(e) {
	  if(e.type === 'mousedown' ||
	     e.type === 'mousemove' ||
	     e.type === 'mouseup'){
	    this._setProperty('_nextTouchX', this._nextMouseX);
	    this._setProperty('_nextTouchY', this._nextMouseY);
	  } else {
	    if(this._curElement !== null) {
	      var touchInfo = getTouchInfo(this._curElement.elt, e, 0);
	      this._setProperty('_nextTouchX', touchInfo.x);
	      this._setProperty('_nextTouchY', touchInfo.y);
	
	      var touches = [];
	      for(var i = 0; i < e.touches.length; i++){
	        touches[i] = getTouchInfo(this._curElement.elt, e, i);
	      }
	      this._setProperty('touches', touches);
	    }
	  }
	};
	
	p5.prototype._updateTouchCoords = function() {
	  this._setProperty('ptouchX', this.touchX);
	  this._setProperty('ptouchY', this.touchY);
	  this._setProperty('touchX', this._nextTouchX);
	  this._setProperty('touchY', this._nextTouchY);
	};
	
	function getTouchInfo(canvas, e, i) {
	  i = i || 0;
	  var rect = canvas.getBoundingClientRect();
	  var touch = e.touches[i] || e.changedTouches[i];
	  return {
	    x: touch.clientX - rect.left,
	    y: touch.clientY - rect.top,
	    id: touch.identifier
	  };
	}
	
	/**
	 * The touchStarted() function is called once after every time a touch is
	 * registered. If no touchStarted() function is defined, the mousePressed()
	 * function will be called instead if it is defined.<br><br>
	 * Browsers may have different default behaviors attached to various touch
	 * events. To prevent any default behavior for this event, add "return false"
	 * to the end of the method.
	 *
	 * @method touchStarted
	 * @example
	 * <div>
	 * <code>
	 * // Touch within the image to change
	 * // the value of the rectangle
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function touchStarted() {
	 *   if (value == 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function touchStarted() {
	 *   ellipse(touchX, touchY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._ontouchstart = function(e) {
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  this._updateNextTouchCoords(e);
	  this._updateNextMouseCoords(e);
	  this._setProperty('touchIsDown', true);
	  if(typeof context.touchStarted === 'function') {
	    executeDefault = context.touchStarted(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  } else if (typeof context.mousePressed === 'function') {
	    executeDefault = context.mousePressed(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	    //this._setMouseButton(e);
	  }
	};
	
	/**
	 * The touchMoved() function is called every time a touch move is registered.
	 * If no touchMoved() function is defined, the mouseDragged() function will
	 * be called instead if it is defined.<br><br>
	 * Browsers may have different default behaviors attached to various touch
	 * events. To prevent any default behavior for this event, add "return false"
	 * to the end of the method.
	 *
	 * @method touchMoved
	 * @example
	 * <div>
	 * <code>
	 * // Move your finger across the page
	 * // to change its value
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function touchMoved() {
	 *   value = value + 5;
	 *   if (value > 255) {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function touchMoved() {
	 *   ellipse(touchX, touchY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._ontouchmove = function(e) {
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  this._updateNextTouchCoords(e);
	  this._updateNextMouseCoords(e);
	  if (typeof context.touchMoved === 'function') {
	    executeDefault = context.touchMoved(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  } else if (typeof context.mouseDragged === 'function') {
	    executeDefault = context.mouseDragged(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	/**
	 * The touchEnded() function is called every time a touch ends. If no
	 * touchEnded() function is defined, the mouseReleased() function will be
	 * called instead if it is defined.<br><br>
	 * Browsers may have different default behaviors attached to various touch
	 * events. To prevent any default behavior for this event, add "return false"
	 * to the end of the method.
	 *
	 * @method touchEnded
	 * @example
	 * <div>
	 * <code>
	 * // Release touch within the image to
	 * // change the value of the rectangle
	 *
	 * var value = 0;
	 * function draw() {
	 *   fill(value);
	 *   rect(25, 25, 50, 50);
	 * }
	 * function touchEnded() {
	 *   if (value == 0) {
	 *     value = 255;
	 *   } else {
	 *     value = 0;
	 *   }
	 * }
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * function touchEnded() {
	 *   ellipse(touchX, touchY, 5, 5);
	 *   // prevent default
	 *   return false;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype._ontouchend = function(e) {
	  this._updateNextTouchCoords(e);
	  this._updateNextMouseCoords(e);
	  if (this.touches.length === 0) {
	    this._setProperty('touchIsDown', false);
	  }
	  var context = this._isGlobal ? window : this;
	  var executeDefault;
	  if (typeof context.touchEnded === 'function') {
	    executeDefault = context.touchEnded(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  } else if (typeof context.mouseReleased === 'function') {
	    executeDefault = context.mouseReleased(e);
	    if(executeDefault === false) {
	      e.preventDefault();
	    }
	  }
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],65:[function(_dereq_,module,exports){
	/*global ImageData:false */
	
	/**
	 * This module defines the filters for use with image buffers.
	 *
	 * This module is basically a collection of functions stored in an object
	 * as opposed to modules. The functions are destructive, modifying
	 * the passed in canvas rather than creating a copy.
	 *
	 * Generally speaking users of this module will use the Filters.apply method
	 * on a canvas to create an effect.
	 *
	 * A number of functions are borrowed/adapted from
	 * http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
	 * or the java processing implementation.
	 */
	
	'use strict';
	
	var Filters = {};
	
	
	/*
	 * Helper functions
	 */
	
	
	/**
	 * Returns the pixel buffer for a canvas
	 *
	 * @private
	 *
	 * @param  {Canvas|ImageData} canvas the canvas to get pixels from
	 * @return {Uint8ClampedArray}       a one-dimensional array containing
	 *                                   the data in thc RGBA order, with integer
	 *                                   values between 0 and 255
	 */
	Filters._toPixels = function (canvas) {
	  if (canvas instanceof ImageData) {
	    return canvas.data;
	  } else {
	    return canvas.getContext('2d').getImageData(
	      0,
	      0,
	      canvas.width,
	      canvas.height
	    ).data;
	  }
	};
	
	/**
	 * Returns a 32 bit number containing ARGB data at ith pixel in the
	 * 1D array containing pixels data.
	 *
	 * @private
	 *
	 * @param  {Uint8ClampedArray} data array returned by _toPixels()
	 * @param  {Integer}           i    index of a 1D Image Array
	 * @return {Integer}                32 bit integer value representing
	 *                                  ARGB value.
	 */
	Filters._getARGB = function (data, i) {
	  var offset = i * 4;
	  return (data[offset+3] << 24) & 0xff000000 |
	    (data[offset] << 16) & 0x00ff0000 |
	    (data[offset+1] << 8) & 0x0000ff00 |
	    data[offset+2] & 0x000000ff;
	};
	
	/**
	 * Modifies pixels RGBA values to values contained in the data object.
	 *
	 * @private
	 *
	 * @param {Uint8ClampedArray} pixels array returned by _toPixels()
	 * @param {Int32Array}        data   source 1D array where each value
	 *                                   represents ARGB values
	 */
	Filters._setPixels = function (pixels, data) {
	  var offset = 0;
	  for( var i = 0, al = pixels.length; i < al; i++) {
	    offset = i*4;
	    pixels[offset + 0] = (data[i] & 0x00ff0000)>>>16;
	    pixels[offset + 1] = (data[i] & 0x0000ff00)>>>8;
	    pixels[offset + 2] = (data[i] & 0x000000ff);
	    pixels[offset + 3] = (data[i] & 0xff000000)>>>24;
	  }
	};
	
	/**
	 * Returns the ImageData object for a canvas
	 * https://developer.mozilla.org/en-US/docs/Web/API/ImageData
	 *
	 * @private
	 *
	 * @param  {Canvas|ImageData} canvas canvas to get image data from
	 * @return {ImageData}               Holder of pixel data (and width and
	 *                                   height) for a canvas
	 */
	Filters._toImageData = function (canvas) {
	  if (canvas instanceof ImageData) {
	    return canvas;
	  } else {
	    return canvas.getContext('2d').getImageData(
	      0,
	      0,
	      canvas.width,
	      canvas.height
	    );
	  }
	};
	
	/**
	 * Returns a blank ImageData object.
	 *
	 * @private
	 *
	 * @param  {Integer} width
	 * @param  {Integer} height
	 * @return {ImageData}
	 */
	Filters._createImageData = function (width, height) {
	  Filters._tmpCanvas = document.createElement('canvas');
	  Filters._tmpCtx = Filters._tmpCanvas.getContext('2d');
	  return this._tmpCtx.createImageData(width, height);
	};
	
	
	/**
	 * Applys a filter function to a canvas.
	 *
	 * The difference between this and the actual filter functions defined below
	 * is that the filter functions generally modify the pixel buffer but do
	 * not actually put that data back to the canvas (where it would actually
	 * update what is visible). By contrast this method does make the changes
	 * actually visible in the canvas.
	 *
	 * The apply method is the method that callers of this module would generally
	 * use. It has been separated from the actual filters to support an advanced
	 * use case of creating a filter chain that executes without actually updating
	 * the canvas in between everystep.
	 *
	 * @param  {[type]} func   [description]
	 * @param  {[type]} canvas [description]
	 * @param  {[type]} level  [description]
	 * @return {[type]}        [description]
	 */
	Filters.apply = function (canvas, func, filterParam) {
	  var ctx = canvas.getContext('2d');
	  var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	
	  //Filters can either return a new ImageData object, or just modify
	  //the one they received.
	  var newImageData = func(imageData, filterParam);
	  if (newImageData instanceof ImageData) {
	    ctx.putImageData(newImageData, 0, 0, 0, 0, canvas.width, canvas.height);
	  } else {
	    ctx.putImageData(imageData, 0, 0, 0, 0, canvas.width, canvas.height);
	  }
	};
	
	
	/*
	 * Filters
	 */
	
	
	/**
	 * Converts the image to black and white pixels depending if they are above or
	 * below the threshold defined by the level parameter. The parameter must be
	 * between 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.
	 *
	 * Borrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
	 *
	 * @param  {Canvas} canvas
	 * @param  {Float} level
	 */
	Filters.threshold = function (canvas, level) {
	  var pixels = Filters._toPixels(canvas);
	
	  if (level === undefined) {
	    level = 0.5;
	  }
	  var thresh = Math.floor(level * 255);
	
	  for (var i = 0; i < pixels.length; i += 4) {
	    var r = pixels[i];
	    var g = pixels[i + 1];
	    var b = pixels[i + 2];
	    var gray = (0.2126 * r + 0.7152 * g + 0.0722 * b);
	    var val;
	    if (gray >= thresh) {
	      val = 255;
	    } else {
	      val = 0;
	    }
	    pixels[i] = pixels[i + 1] = pixels[i + 2] = val;
	  }
	
	};
	
	
	/**
	 * Converts any colors in the image to grayscale equivalents.
	 * No parameter is used.
	 *
	 * Borrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
	 *
	 * @param {Canvas} canvas
	 */
	Filters.gray = function (canvas) {
	  var pixels = Filters._toPixels(canvas);
	
	  for (var i = 0; i < pixels.length; i += 4) {
	    var r = pixels[i];
	    var g = pixels[i + 1];
	    var b = pixels[i + 2];
	
	    // CIE luminance for RGB
	    var gray = (0.2126 * r + 0.7152 * g + 0.0722 * b);
	    pixels[i] = pixels[i + 1] = pixels[i + 2] = gray;
	  }
	};
	
	/**
	 * Sets the alpha channel to entirely opaque. No parameter is used.
	 *
	 * @param {Canvas} canvas
	 */
	Filters.opaque = function (canvas) {
	  var pixels = Filters._toPixels(canvas);
	
	  for (var i = 0; i < pixels.length; i += 4) {
	    pixels[i + 3] = 255;
	  }
	
	  return pixels;
	};
	
	/**
	 * Sets each pixel to its inverse value. No parameter is used.
	 * @param {Invert}
	 */
	Filters.invert = function (canvas) {
	  var pixels = Filters._toPixels(canvas);
	
	  for (var i = 0; i < pixels.length; i += 4) {
	    pixels[i] = 255 - pixels[i];
	    pixels[i + 1] = 255 - pixels[i + 1];
	    pixels[i + 2] = 255 - pixels[i + 2];
	  }
	
	};
	
	
	/**
	 * Limits each channel of the image to the number of colors specified as
	 * the parameter. The parameter can be set to values between 2 and 255, but
	 * results are most noticeable in the lower ranges.
	 *
	 * Adapted from java based processing implementation
	 *
	 * @param  {Canvas} canvas
	 * @param  {Integer} level
	 */
	Filters.posterize = function (canvas, level) {
	  var pixels = Filters._toPixels(canvas);
	
	  if ((level < 2) || (level > 255)) {
	    throw new Error(
	      'Level must be greater than 2 and less than 255 for posterize'
	    );
	  }
	
	  var levels1 = level - 1;
	  for (var i = 0; i < pixels.length; i+=4) {
	    var rlevel = pixels[i];
	    var glevel = pixels[i + 1];
	    var blevel = pixels[i + 2];
	
	    pixels[i] = (((rlevel * level) >> 8) * 255) / levels1;
	    pixels[i + 1] = (((glevel * level) >> 8) * 255) / levels1;
	    pixels[i + 2] = (((blevel * level) >> 8) * 255) / levels1;
	  }
	};
	
	/**
	 * reduces the bright areas in an image
	 * @param  {Canvas} canvas
	 *
	 */
	Filters.dilate = function (canvas) {
	  var pixels = Filters._toPixels(canvas);
	  var currIdx = 0;
	  var maxIdx = pixels.length ? pixels.length/4 : 0;
	  var out = new Int32Array(maxIdx);
	  var currRowIdx, maxRowIdx, colOrig, colOut, currLum;
	  var idxRight, idxLeft, idxUp, idxDown,
	      colRight, colLeft, colUp, colDown,
	      lumRight, lumLeft, lumUp, lumDown;
	
	  while(currIdx < maxIdx) {
	    currRowIdx = currIdx;
	    maxRowIdx = currIdx + canvas.width;
	    while (currIdx < maxRowIdx) {
	      colOrig = colOut = Filters._getARGB(pixels, currIdx);
	      idxLeft = currIdx - 1;
	      idxRight = currIdx + 1;
	      idxUp = currIdx - canvas.width;
	      idxDown = currIdx + canvas.width;
	
	      if (idxLeft < currRowIdx) {
	        idxLeft = currIdx;
	      }
	      if (idxRight >= maxRowIdx) {
	        idxRight = currIdx;
	      }
	      if (idxUp < 0){
	        idxUp = 0;
	      }
	      if (idxDown >= maxIdx) {
	        idxDown = currIdx;
	      }
	      colUp = Filters._getARGB(pixels, idxUp);
	      colLeft = Filters._getARGB(pixels, idxLeft);
	      colDown = Filters._getARGB(pixels, idxDown);
	      colRight = Filters._getARGB(pixels, idxRight);
	
	      //compute luminance
	      currLum = 77*(colOrig>>16&0xff) +
	        151*(colOrig>>8&0xff) +
	        28*(colOrig&0xff);
	      lumLeft = 77*(colLeft>>16&0xff) +
	        151*(colLeft>>8&0xff) +
	        28*(colLeft&0xff);
	      lumRight = 77*(colRight>>16&0xff) +
	        151*(colRight>>8&0xff) +
	        28*(colRight&0xff);
	      lumUp = 77*(colUp>>16&0xff) +
	        151*(colUp>>8&0xff) +
	        28*(colUp&0xff);
	      lumDown = 77*(colDown>>16&0xff) +
	        151*(colDown>>8&0xff) +
	        28*(colDown&0xff);
	
	      if (lumLeft > currLum) {
	        colOut = colLeft;
	        currLum = lumLeft;
	      }
	      if (lumRight > currLum) {
	        colOut = colRight;
	        currLum = lumRight;
	      }
	      if (lumUp > currLum) {
	        colOut = colUp;
	        currLum = lumUp;
	      }
	      if (lumDown > currLum) {
	        colOut = colDown;
	        currLum = lumDown;
	      }
	      out[currIdx++]=colOut;
	    }
	  }
	  Filters._setPixels(pixels, out);
	};
	
	/**
	 * increases the bright areas in an image
	 * @param  {Canvas} canvas
	 *
	 */
	Filters.erode = function(canvas) {
	  var pixels = Filters._toPixels(canvas);
	  var currIdx = 0;
	  var maxIdx = pixels.length ? pixels.length/4 : 0;
	  var out = new Int32Array(maxIdx);
	  var currRowIdx, maxRowIdx, colOrig, colOut, currLum;
	  var idxRight, idxLeft, idxUp, idxDown,
	      colRight, colLeft, colUp, colDown,
	      lumRight, lumLeft, lumUp, lumDown;
	
	  while(currIdx < maxIdx) {
	    currRowIdx = currIdx;
	    maxRowIdx = currIdx + canvas.width;
	    while (currIdx < maxRowIdx) {
	      colOrig = colOut = Filters._getARGB(pixels, currIdx);
	      idxLeft = currIdx - 1;
	      idxRight = currIdx + 1;
	      idxUp = currIdx - canvas.width;
	      idxDown = currIdx + canvas.width;
	
	      if (idxLeft < currRowIdx) {
	        idxLeft = currIdx;
	      }
	      if (idxRight >= maxRowIdx) {
	        idxRight = currIdx;
	      }
	      if (idxUp < 0) {
	        idxUp = 0;
	      }
	      if (idxDown >= maxIdx) {
	        idxDown = currIdx;
	      }
	      colUp = Filters._getARGB(pixels, idxUp);
	      colLeft = Filters._getARGB(pixels, idxLeft);
	      colDown = Filters._getARGB(pixels, idxDown);
	      colRight = Filters._getARGB(pixels, idxRight);
	
	      //compute luminance
	      currLum = 77*(colOrig>>16&0xff) +
	        151*(colOrig>>8&0xff) +
	        28*(colOrig&0xff);
	      lumLeft = 77*(colLeft>>16&0xff) +
	        151*(colLeft>>8&0xff) +
	        28*(colLeft&0xff);
	      lumRight = 77*(colRight>>16&0xff) +
	        151*(colRight>>8&0xff) +
	        28*(colRight&0xff);
	      lumUp = 77*(colUp>>16&0xff) +
	        151*(colUp>>8&0xff) +
	        28*(colUp&0xff);
	      lumDown = 77*(colDown>>16&0xff) +
	        151*(colDown>>8&0xff) +
	        28*(colDown&0xff);
	
	      if (lumLeft < currLum) {
	        colOut = colLeft;
	        currLum = lumLeft;
	      }
	      if (lumRight < currLum) {
	        colOut = colRight;
	        currLum = lumRight;
	      }
	      if (lumUp < currLum) {
	        colOut = colUp;
	        currLum = lumUp;
	      }
	      if (lumDown < currLum) {
	        colOut = colDown;
	        currLum = lumDown;
	      }
	
	      out[currIdx++]=colOut;
	    }
	  }
	  Filters._setPixels(pixels, out);
	};
	
	// BLUR
	
	// internal kernel stuff for the gaussian blur filter
	var blurRadius;
	var blurKernelSize;
	var blurKernel;
	var blurMult;
	
	/*
	 * Port of https://github.com/processing/processing/blob/
	 * master/core/src/processing/core/PImage.java#L1250
	 *
	 * Optimized code for building the blur kernel.
	 * further optimized blur code (approx. 15% for radius=20)
	 * bigger speed gains for larger radii (~30%)
	 * added support for various image types (ALPHA, RGB, ARGB)
	 * [toxi 050728]
	 */
	function buildBlurKernel(r) {
	  var radius = (r * 3.5)|0;
	  radius = (radius < 1) ? 1 : ((radius < 248) ? radius : 248);
	
	  if (blurRadius !== radius) {
	    blurRadius = radius;
	    blurKernelSize = 1 + blurRadius<<1;
	    blurKernel = new Int32Array(blurKernelSize);
	    blurMult = new Array(blurKernelSize);
	    for(var l = 0; l < blurKernelSize; l++){
	      blurMult[l] = new Int32Array(256);
	    }
	
	    var bk,bki;
	    var bm,bmi;
	
	    for (var i = 1, radiusi = radius - 1; i < radius; i++) {
	      blurKernel[radius+i] = blurKernel[radiusi] = bki = radiusi * radiusi;
	      bm = blurMult[radius+i];
	      bmi = blurMult[radiusi--];
	      for (var j = 0; j < 256; j++){
	        bm[j] = bmi[j] = bki * j;
	      }
	    }
	    bk = blurKernel[radius] = radius * radius;
	    bm = blurMult[radius];
	
	    for (var k = 0; k < 256; k++){
	      bm[k] = bk * k;
	    }
	  }
	
	}
	
	// Port of https://github.com/processing/processing/blob/
	// master/core/src/processing/core/PImage.java#L1433
	function blurARGB(canvas, radius) {
	  var pixels = Filters._toPixels(canvas);
	  var width = canvas.width;
	  var height = canvas.height;
	  var numPackedPixels = width * height;
	  var argb = new Int32Array(numPackedPixels);
	  for (var j = 0; j < numPackedPixels; j++) {
	    argb[j] = Filters._getARGB(pixels, j);
	  }
	  var sum, cr, cg, cb, ca;
	  var read, ri, ym, ymi, bk0;
	  var a2 = new Int32Array(numPackedPixels);
	  var r2 = new Int32Array(numPackedPixels);
	  var g2 = new Int32Array(numPackedPixels);
	  var b2 = new Int32Array(numPackedPixels);
	  var yi = 0;
	  buildBlurKernel(radius);
	  var x, y, i;
	  var bm;
	  for (y = 0; y < height; y++) {
	    for (x = 0; x < width; x++) {
	      cb = cg = cr = ca = sum = 0;
	      read = x - blurRadius;
	      if (read < 0) {
	        bk0 = -read;
	        read = 0;
	      } else {
	        if (read >= width) {
	          break;
	        }
	        bk0 = 0;
	      }
	      for (i = bk0; i < blurKernelSize; i++) {
	        if (read >= width) {
	          break;
	        }
	        var c = argb[read + yi];
	        bm = blurMult[i];
	        ca += bm[(c & -16777216) >>> 24];
	        cr += bm[(c & 16711680) >> 16];
	        cg += bm[(c & 65280) >> 8];
	        cb += bm[c & 255];
	        sum += blurKernel[i];
	        read++;
	      }
	      ri = yi + x;
	      a2[ri] = ca / sum;
	      r2[ri] = cr / sum;
	      g2[ri] = cg / sum;
	      b2[ri] = cb / sum;
	    }
	    yi += width;
	  }
	  yi = 0;
	  ym = -blurRadius;
	  ymi = ym * width;
	  for (y = 0; y < height; y++) {
	    for (x = 0; x < width; x++) {
	      cb = cg = cr = ca = sum = 0;
	      if (ym < 0) {
	        bk0 = ri = -ym;
	        read = x;
	      } else {
	        if (ym >= height) {
	          break;
	        }
	        bk0 = 0;
	        ri = ym;
	        read = x + ymi;
	      }
	      for (i = bk0; i < blurKernelSize; i++) {
	        if (ri >= height) {
	          break;
	        }
	        bm = blurMult[i];
	        ca += bm[a2[read]];
	        cr += bm[r2[read]];
	        cg += bm[g2[read]];
	        cb += bm[b2[read]];
	        sum += blurKernel[i];
	        ri++;
	        read += width;
	      }
	      argb[x + yi] = (ca/sum)<<24 | (cr/sum)<<16 | (cg/sum)<<8 | (cb/sum);
	    }
	    yi += width;
	    ymi += width;
	    ym++;
	  }
	  Filters._setPixels(pixels, argb);
	}
	
	Filters.blur = function(canvas, radius){
	  blurARGB(canvas, radius);
	};
	
	
	module.exports = Filters;
	
	},{}],66:[function(_dereq_,module,exports){
	/**
	 * @module Image
	 * @submodule Image
	 * @for p5
	 * @requires core
	 */
	
	/**
	 * This module defines the p5 methods for the p5.Image class
	 * for drawing images to the main display canvas.
	 */
	'use strict';
	
	
	var p5 = _dereq_('../core/core');
	
	/* global frames:true */// This is not global, but JSHint is not aware that
	// this module is implicitly enclosed with Browserify: this overrides the
	// redefined-global error and permits using the name "frames" for the array
	// of saved animation frames.
	var frames = [];
	
	
	/**
	 * Creates a new p5.Image (the datatype for storing images). This provides a
	 * fresh buffer of pixels to play with. Set the size of the buffer with the
	 * width and height parameters.
	 * <br><br>
	 * .pixels gives access to an array containing the values for all the pixels
	 * in the display window.
	 * These values are numbers. This array is the size (including an appropriate
	 * factor for the pixelDensity) of the display window x4,
	 * representing the R, G, B, A values in order for each pixel, moving from
	 * left to right across each row, then down each column. See .pixels for
	 * more info. It may also be simpler to use set() or get().
	 * <br><br>
	 * Before accessing the pixels of an image, the data must loaded with the
	 * loadPixels() function. After the array data has been modified, the
	 * updatePixels() function must be run to update the changes.
	 *
	 * @method createImage
	 * @param  {Integer} width  width in pixels
	 * @param  {Integer} height height in pixels
	 * @return {p5.Image}       the p5.Image object
	 * @example
	 * <div>
	 * <code>
	 * img = createImage(66, 66);
	 * img.loadPixels();
	 * for (i = 0; i < img.width; i++) {
	 *   for (j = 0; j < img.height; j++) {
	 *     img.set(i, j, color(0, 90, 102));
	 *   }
	 * }
	 * img.updatePixels();
	 * image(img, 17, 17);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * img = createImage(66, 66);
	 * img.loadPixels();
	 * for (i = 0; i < img.width; i++) {
	 *   for (j = 0; j < img.height; j++) {
	 *     img.set(i, j, color(0, 90, 102, i % img.width * 2));
	 *   }
	 * }
	 * img.updatePixels();
	 * image(img, 17, 17);
	 * image(img, 34, 34);
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var pink = color(255, 102, 204);
	 * img = createImage(66, 66);
	 * img.loadPixels();
	 * var d = pixelDensity;
	 * var halfImage = 4 * (width * d) * (height/2 * d);
	 * for (var i = 0; i < halfImage; i+=4) {
	 *   img.pixels[i] = red(pink);
	 *   img.pixels[i+1] = green(pink);
	 *   img.pixels[i+2] = blue(pink);
	 *   img.pixels[i+3] = alpha(pink);
	 * }
	 * img.updatePixels();
	 * image(img, 17, 17);
	 * </code>
	 * </div>
	 */
	p5.prototype.createImage = function(width, height) {
	  return new p5.Image(width, height);
	};
	
	/**
	 *  Save the current canvas as an image. In Safari, this will open the
	 *  image in the window and the user must provide their own
	 *  filename on save-as. Other browsers will either save the
	 *  file immediately, or prompt the user with a dialogue window.
	 *
	 *  @method saveCanvas
	 *  @param  {[selectedCanvas]} canvas a variable representing a
	 *                             specific html5 canvas (optional)
	 *  @param  {[String]} filename
	 *  @param  {[String]} extension 'jpg' or 'png'
	 *  @example
	 *  <div class='norender'><code>
	 *  function setup() {
	 *    var c = createCanvas(100, 100);
	 *    background(255, 0, 0);
	 *    saveCanvas(c, 'myCanvas', 'jpg');
	 *  }
	 *  </code></div>
	 *  <div class='norender'><code>
	 *  // note that this example has the same result as above
	 *  // if no canvas is specified, defaults to main canvas
	 *  function setup() {
	 *    createCanvas(100, 100);
	 *    background(255, 0, 0);
	 *    saveCanvas('myCanvas', 'jpg');
	 *  }
	 *  </code></div>
	 *  <div class='norender'><code>
	 *  // all of the following are valid
	 *  saveCanvas(c, 'myCanvas', 'jpg');
	 *  saveCanvas(c, 'myCanvas');
	 *  saveCanvas(c);
	 *  saveCanvas('myCanvas', 'png');
	 *  saveCanvas('myCanvas');
	 *  saveCanvas();
	 *  </code></div>
	 */
	p5.prototype.saveCanvas = function() {
	
	  var cnv, filename, extension;
	  if (arguments.length === 3) {
	    cnv = arguments[0];
	    filename = arguments[1];
	    extension = arguments[2];
	  } else if (arguments.length === 2) {
	    if (typeof arguments[0] === 'object') {
	      cnv = arguments[0];
	      filename = arguments[1];
	    } else {
	      filename = arguments[0];
	      extension = arguments[1];
	    }
	  } else if (arguments.length === 1) {
	    if (typeof arguments[0] === 'object') {
	      cnv = arguments[0];
	    } else {
	      filename = arguments[0];
	    }
	  }
	
	  if (cnv instanceof p5.Element) {
	    cnv = cnv.elt;
	  }
	  if (!(cnv instanceof HTMLCanvasElement)) {
	    cnv = null;
	  }
	
	  if (!extension) {
	    extension = p5.prototype._checkFileExtension(filename, extension)[1];
	    if (extension === '') {
	      extension = 'png';
	    }
	  }
	
	  if (!cnv) {
	    if (this._curElement && this._curElement.elt) {
	      cnv = this._curElement.elt;
	    }
	  }
	
	  if ( p5.prototype._isSafari() ) {
	    var aText = 'Hello, Safari user!\n';
	    aText += 'Now capturing a screenshot...\n';
	    aText += 'To save this image,\n';
	    aText += 'go to File --> Save As.\n';
	    alert(aText);
	    window.location.href = cnv.toDataURL();
	  } else {
	    var mimeType;
	    if (typeof(extension) === 'undefined') {
	      extension = 'png';
	      mimeType = 'image/png';
	    }
	    else {
	      switch(extension){
	      case 'png':
	        mimeType = 'image/png';
	        break;
	      case 'jpeg':
	        mimeType = 'image/jpeg';
	        break;
	      case 'jpg':
	        mimeType = 'image/jpeg';
	        break;
	      default:
	        mimeType = 'image/png';
	        break;
	      }
	    }
	    var downloadMime = 'image/octet-stream';
	    var imageData = cnv.toDataURL(mimeType);
	    imageData = imageData.replace(mimeType, downloadMime);
	
	    p5.prototype.downloadFile(imageData, filename, extension);
	  }
	};
	
	/**
	 *  Capture a sequence of frames that can be used to create a movie.
	 *  Accepts a callback. For example, you may wish to send the frames
	 *  to a server where they can be stored or converted into a movie.
	 *  If no callback is provided, the browser will attempt to download
	 *  all of the images that have just been created.
	 *
	 *  @method saveFrames
	 *  @param  {[type]}   filename  [description]
	 *  @param  {[type]}   extension [description]
	 *  @param  {[type]}   _duration [description]
	 *  @param  {[type]}   _fps      [description]
	 *  @param  {[Function]} callback  [description]
	 *  @return {[type]}             [description]
	 */
	p5.prototype.saveFrames = function(fName, ext, _duration, _fps, callback) {
	  var duration = _duration || 3;
	  duration = p5.prototype.constrain(duration, 0, 15);
	  duration = duration * 1000;
	  var fps = _fps || 15;
	  fps = p5.prototype.constrain(fps, 0, 22);
	  var count = 0;
	
	  var makeFrame = p5.prototype._makeFrame;
	  var cnv = this._curElement.elt;
	  var frameFactory = setInterval(function(){
	    makeFrame(fName + count, ext, cnv);
	    count++;
	  },1000/fps);
	
	  setTimeout(function(){
	    clearInterval(frameFactory);
	    if (callback) {
	      callback(frames);
	    }
	    else {
	      for (var i = 0; i < frames.length; i++) {
	        var f = frames[i];
	        p5.prototype.downloadFile(f.imageData, f.filename, f.ext);
	      }
	    }
	    frames = []; // clear frames
	  }, duration + 0.01);
	};
	
	p5.prototype._makeFrame = function(filename, extension, _cnv) {
	  var cnv;
	  if (this) {
	    cnv = this._curElement.elt;
	  } else {
	    cnv = _cnv;
	  }
	  var mimeType;
	  if (!extension) {
	    extension = 'png';
	    mimeType = 'image/png';
	  }
	  else {
	    switch(extension.toLowerCase()){
	    case 'png':
	      mimeType = 'image/png';
	      break;
	    case 'jpeg':
	      mimeType = 'image/jpeg';
	      break;
	    case 'jpg':
	      mimeType = 'image/jpeg';
	      break;
	    default:
	      mimeType = 'image/png';
	      break;
	    }
	  }
	  var downloadMime = 'image/octet-stream';
	  var imageData = cnv.toDataURL(mimeType);
	  imageData = imageData.replace(mimeType, downloadMime);
	
	  var thisFrame = {};
	  thisFrame.imageData = imageData;
	  thisFrame.filename = filename;
	  thisFrame.ext = extension;
	  frames.push(thisFrame);
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],67:[function(_dereq_,module,exports){
	/**
	 * @module Image
	 * @submodule Loading & Displaying
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var Filters = _dereq_('./filters');
	var canvas = _dereq_('../core/canvas');
	var constants = _dereq_('../core/constants');
	
	_dereq_('../core/error_helpers');
	
	/**
	 * Loads an image from a path and creates a p5.Image from it.
	 * <br><br>
	 * The image may not be immediately available for rendering
	 * If you want to ensure that the image is ready before doing
	 * anything with it, place the loadImage() call in preload().
	 * You may also supply a callback function to handle the image when it's ready.
	 * <br><br>
	 * The path to the image should be relative to the HTML file
	 * that links in your sketch. Loading an from a URL or other
	 * remote location may be blocked due to your browser's built-in
	 * security.
	 *
	 * @method loadImage
	 * @param  {String} path Path of the image to be loaded
	 * @param  {Function(p5.Image)} [successCallback] Function to be called once
	 *                                the image is loaded. Will be passed the
	 *                                p5.Image.
	 * @param  {Function(Event)}    [failureCallback] called with event error if
	 *                                the image fails to load.
	 * @return {p5.Image}             the p5.Image object
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/laDefense.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * function setup() {
	 *   // here we use a callback to display the image after loading
	 *   loadImage("assets/laDefense.jpg", function(img) {
	 *     image(img, 0, 0);
	 *   });
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.loadImage = function(path, successCallback, failureCallback) {
	  var img = new Image();
	  var pImg = new p5.Image(1, 1, this);
	  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
	
	  img.onload = function() {
	    pImg.width = pImg.canvas.width = img.width;
	    pImg.height = pImg.canvas.height = img.height;
	
	    // Draw the image into the backing canvas of the p5.Image
	    pImg.drawingContext.drawImage(img, 0, 0);
	
	    if (typeof successCallback === 'function') {
	      successCallback(pImg);
	    }
	    if (decrementPreload && (successCallback !== decrementPreload)) {
	      decrementPreload();
	    }
	  };
	  img.onerror = function(e) {
	    p5._friendlyFileLoadError(0,img.src);
	    // don't get failure callback mixed up with decrementPreload
	    if ((typeof failureCallback === 'function') &&
	      (failureCallback !== decrementPreload)) {
	      failureCallback(e);
	    }
	  };
	
	  //set crossOrigin in case image is served which CORS headers
	  //this will let us draw to canvas without tainting it.
	  //see https://developer.mozilla.org/en-US/docs/HTML/CORS_Enabled_Image
	  // When using data-uris the file will be loaded locally
	  // so we don't need to worry about crossOrigin with base64 file types
	  if(path.indexOf('data:image/') !== 0) {
	    img.crossOrigin = 'Anonymous';
	  }
	
	  //start loading the image
	  img.src = path;
	
	  return pImg;
	};
	
	/**
	 * Validates clipping params. Per drawImage spec sWidth and sHight cannot be
	 * negative or greater than image intrinsic width and height
	 * @private
	 * @param {Number} sVal
	 * @param {Number} iVal
	 * @returns {Number}
	 * @private
	 */
	function _sAssign(sVal, iVal) {
	  if (sVal > 0 && sVal < iVal) {
	    return sVal;
	  }
	  else {
	    return iVal;
	  }
	}
	
	/**
	 * Draw an image to the main canvas of the p5js sketch
	 *
	 * @method image
	 * @param  {p5.Image} img    the image to display
	 * @param  {Number}   [sx=0]   The X coordinate of the top left corner of the
	 *                             sub-rectangle of the source image to draw into
	 *                             the destination canvas.
	 * @param  {Number}   [sy=0]   The Y coordinate of the top left corner of the
	 *                             sub-rectangle of the source image to draw into
	 *                             the destination canvas.
	 * @param {Number} [sWidth=img.width] The width of the sub-rectangle of the
	 *                                    source image to draw into the destination
	 *                                    canvas.
	 * @param {Number} [sHeight=img.height] The height of the sub-rectangle of the
	 *                                      source image to draw into the
	 *                                      destination context.
	 * @param  {Number}   [dx=0]    The X coordinate in the destination canvas at
	 *                              which to place the top-left corner of the
	 *                              source image.
	 * @param  {Number}   [dy=0]    The Y coordinate in the destination canvas at
	 *                              which to place the top-left corner of the
	 *                              source image.
	 * @param  {Number}   [dWidth]  The width to draw the image in the destination
	 *                              canvas. This allows scaling of the drawn image.
	 * @param  {Number}   [dHeight] The height to draw the image in the destination
	 *                              canvas. This allows scaling of the drawn image.
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/laDefense.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 *   image(img, 0, 0, 100, 100);
	 *   image(img, 0, 0, 100, 100, 0, 0, 100, 100);
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * function setup() {
	 *   // here we use a callback to display the image after loading
	 *   loadImage("assets/laDefense.jpg", function(img) {
	 *     image(img, 0, 0);
	 *   });
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.image =
	  function(img, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
	  // Temporarily disabling until options for p5.Graphics are added.
	  // var args = new Array(arguments.length);
	  // for (var i = 0; i < args.length; ++i) {
	  //   args[i] = arguments[i];
	  // }
	  // this._validateParameters(
	  //   'image',
	  //   args,
	  //   [
	  //     ['p5.Image', 'Number', 'Number'],
	  //     ['p5.Image', 'Number', 'Number', 'Number', 'Number']
	  //   ]
	  // );
	
	  // set defaults per spec: https://goo.gl/3ykfOq
	  if (arguments.length <= 5) {
	    dx = sx || 0;
	    dy = sy || 0;
	    sx = 0;
	    sy = 0;
	    if (img.elt && img.elt.videoWidth && !img.canvas) { // video no canvas
	      var actualW = img.elt.videoWidth;
	      var actualH = img.elt.videoHeight;
	      dWidth = sWidth || img.width;
	      dHeight = sHeight || img.width*actualH/actualW;
	      sWidth = actualW;
	      sHeight = actualH;
	    } else {
	      dWidth = sWidth || img.width;
	      dHeight = sHeight || img.height;
	      sWidth = img.width;
	      sHeight = img.height;
	    }
	  } else if (arguments.length === 9) {
	    sx = sx || 0;
	    sy = sy || 0;
	    sWidth = _sAssign(sWidth, img.width);
	    sHeight = _sAssign(sHeight, img.height);
	
	    dx = dx || 0;
	    dy = dy || 0;
	    dWidth = dWidth || img.width;
	    dHeight = dHeight || img.height;
	  } else {
	    throw 'Wrong number of arguments to image()';
	  }
	
	  var vals = canvas.modeAdjust(dx, dy, dWidth, dHeight,
	    this._renderer._imageMode);
	
	  // tint the image if there is a tint
	  this._renderer.image(img, sx, sy, sWidth, sHeight, vals.x, vals.y, vals.w,
	    vals.h);
	};
	
	/**
	 * Sets the fill value for displaying images. Images can be tinted to
	 * specified colors or made transparent by including an alpha value.
	 * <br><br>
	 * To apply transparency to an image without affecting its color, use
	 * white as the tint color and specify an alpha value. For instance,
	 * tint(255, 128) will make an image 50% transparent (assuming the default
	 * alpha range of 0-255, which can be changed with colorMode()).
	 * <br><br>
	 * The value for the gray parameter must be less than or equal to the current
	 * maximum value as specified by colorMode(). The default maximum value is
	 * 255.
	 *
	 * @method tint
	 * @param {Number|Array} v1   gray value, red or hue value (depending on the
	 *                            current color mode), or color Array
	 * @param {Number|Array} [v2] green or saturation value (depending on the
	 *                            current color mode)
	 * @param {Number|Array} [v3] blue or brightness value (depending on the
	 *                            current color mode)
	 * @param {Number|Array} [a]  opacity of the background
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/laDefense.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 *   tint(0, 153, 204);  // Tint blue
	 *   image(img, 50, 0);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/laDefense.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 *   tint(0, 153, 204, 126);  // Tint blue and set transparency
	 *   image(img, 50, 0);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/laDefense.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 *   tint(255, 126);  // Apply transparency without changing color
	 *   image(img, 50, 0);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.tint = function () {
	  var c = this.color.apply(this, arguments);
	  this._renderer._tint = c.levels;
	};
	
	/**
	 * Removes the current fill value for displaying images and reverts to
	 * displaying images with their original hues.
	 *
	 * @method noTint
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *   tint(0, 153, 204);  // Tint blue
	 *   image(img, 0, 0);
	 *   noTint();  // Disable tint
	 *   image(img, 50, 0);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.noTint = function() {
	  this._renderer._tint = null;
	};
	
	/**
	 * Apply the current tint color to the input image, return the resulting
	 * canvas.
	 *
	 * @param {p5.Image} The image to be tinted
	 * @return {canvas} The resulting tinted canvas
	 *
	 */
	p5.prototype._getTintedImageCanvas = function(img) {
	  if (!img.canvas) {
	    return img;
	  }
	  var pixels = Filters._toPixels(img.canvas);
	  var tmpCanvas = document.createElement('canvas');
	  tmpCanvas.width = img.canvas.width;
	  tmpCanvas.height = img.canvas.height;
	  var tmpCtx = tmpCanvas.getContext('2d');
	  var id = tmpCtx.createImageData(img.canvas.width, img.canvas.height);
	  var newPixels = id.data;
	
	  for(var i = 0; i < pixels.length; i += 4) {
	    var r = pixels[i];
	    var g = pixels[i+1];
	    var b = pixels[i+2];
	    var a = pixels[i+3];
	
	    newPixels[i] = r*this._renderer._tint[0]/255;
	    newPixels[i+1] = g*this._renderer._tint[1]/255;
	    newPixels[i+2] = b*this._renderer._tint[2]/255;
	    newPixels[i+3] = a*this._renderer._tint[3]/255;
	  }
	
	  tmpCtx.putImageData(id, 0, 0);
	  return tmpCanvas;
	};
	
	/**
	 * Set image mode. Modifies the location from which images are drawn by
	 * changing the way in which parameters given to image() are interpreted.
	 * The default mode is imageMode(CORNER), which interprets the second and
	 * third parameters of image() as the upper-left corner of the image. If
	 * two additional parameters are specified, they are used to set the image's
	 * width and height.
	 * <br><br>
	 * imageMode(CORNERS) interprets the second and third parameters of image()
	 * as the location of one corner, and the fourth and fifth parameters as the
	 * opposite corner.
	 * <br><br>
	 * imageMode(CENTER) interprets the second and third parameters of image()
	 * as the image's center point. If two additional parameters are specified,
	 * they are used to set the image's width and height.
	 *
	 * @method imageMode
	 * @param {String} m The mode: either CORNER, CORNERS, or CENTER.
	 * @example
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *   imageMode(CORNER);
	 *   image(img, 10, 10, 50, 50);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *   imageMode(CORNERS);
	 *   image(img, 10, 10, 90, 40);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *   imageMode(CENTER);
	 *   image(img, 50, 50, 80, 80);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.imageMode = function(m) {
	  if (m === constants.CORNER ||
	    m === constants.CORNERS ||
	    m === constants.CENTER) {
	    this._renderer._imageMode = m;
	  }
	};
	
	
	module.exports = p5;
	
	},{"../core/canvas":46,"../core/constants":47,"../core/core":48,"../core/error_helpers":51,"./filters":65}],68:[function(_dereq_,module,exports){
	/**
	 * @module Image
	 * @submodule Image
	 * @requires core
	 * @requires constants
	 * @requires filters
	 */
	
	/**
	 * This module defines the p5.Image class and P5 methods for
	 * drawing images to the main display canvas.
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var Filters = _dereq_('./filters');
	
	/*
	 * Class methods
	 */
	
	/**
	 * Creates a new p5.Image. A p5.Image is a canvas backed representation of an
	 * image.
	 * <br><br>
	 * p5 can display .gif, .jpg and .png images. Images may be displayed
	 * in 2D and 3D space. Before an image is used, it must be loaded with the
	 * loadImage() function. The p5.Image class contains fields for the width and
	 * height of the image, as well as an array called pixels[] that contains the
	 * values for every pixel in the image.
	 * <br><br>
	 * The methods described below allow easy access to the image's pixels and
	 * alpha channel and simplify the process of compositing.
	 * <br><br>
	 * Before using the pixels[] array, be sure to use the loadPixels() method on
	 * the image to make sure that the pixel data is properly loaded.
	 *
	 * @class p5.Image
	 * @constructor
	 * @param {Number} width
	 * @param {Number} height
	 * @param {Object} pInst An instance of a p5 sketch.
	 */
	p5.Image = function(width, height){
	  /**
	   * Image width.
	   * @property width
	   * @example
	   * <div><code>
	   * var img;
	   * function preload() {
	   *   img = loadImage("assets/rockies.jpg");
	   * }
	   *
	   * function setup() {
	   *   createCanvas(100, 100);
	   *   image(img, 0, 0);
	   *   for (var i=0; i < img.width; i++) {
	   *     var c = img.get(i, img.height/2);
	   *     stroke(c);
	   *     line(i, height/2, i, height);
	   *   }
	   * }
	   * </code></div>
	   */
	  this.width = width;
	  /**
	   * Image height.
	   * @property height
	   * @example
	   * <div><code>
	   * var img;
	   * function preload() {
	   *   img = loadImage("assets/rockies.jpg");
	   * }
	   *
	   * function setup() {
	   *   createCanvas(100, 100);
	   *   image(img, 0, 0);
	   *   for (var i=0; i < img.height; i++) {
	   *     var c = img.get(img.width/2, i);
	   *     stroke(c);
	   *     line(0, i, width/2, i);
	   *   }
	   * }
	   * </code></div>
	   */
	  this.height = height;
	  this.canvas = document.createElement('canvas');
	  this.canvas.width = this.width;
	  this.canvas.height = this.height;
	  this.drawingContext = this.canvas.getContext('2d');
	  this._pixelDensity = 1;
	  //used for webgl texturing only
	  this.isTexture = false;
	  /**
	   * Array containing the values for all the pixels in the display window.
	   * These values are numbers. This array is the size (include an appropriate
	   * factor for pixelDensity) of the display window x4,
	   * representing the R, G, B, A values in order for each pixel, moving from
	   * left to right across each row, then down each column. Retina and other
	   * high denisty displays may have more pixels[] (by a factor of
	   * pixelDensity^2).
	   * For example, if the image is 100x100 pixels, there will be 40,000. With
	   * pixelDensity = 2, there will be 160,000. The first four values
	   * (indices 0-3) in the array will be the R, G, B, A values of the pixel at
	   * (0, 0). The second four values (indices 4-7) will contain the R, G, B, A
	   * values of the pixel at (1, 0). More generally, to set values for a pixel
	   * at (x, y):
	   * <code><pre>var d = pixelDensity;
	   * for (var i = 0; i < d; i++) {
	   *   for (var j = 0; j < d; j++) {
	   *     // loop over
	   *     idx = 4*((y * d + j) * width * d + (x * d + i));
	   *     pixels[idx] = r;
	   *     pixels[idx+1] = g;
	   *     pixels[idx+2] = b;
	   *     pixels[idx+3] = a;
	   *   }
	   * }
	   * </pre></code>
	   * <br><br>
	   * Before accessing this array, the data must loaded with the loadPixels()
	   * function. After the array data has been modified, the updatePixels()
	   * function must be run to update the changes.
	   * @property pixels[]
	   * @example
	   * <div>
	   * <code>
	   * img = createImage(66, 66);
	   * img.loadPixels();
	   * for (i = 0; i < img.width; i++) {
	   *   for (j = 0; j < img.height; j++) {
	   *     img.set(i, j, color(0, 90, 102));
	   *   }
	   * }
	   * img.updatePixels();
	   * image(img, 17, 17);
	   * </code>
	   * </div>
	   * <div>
	   * <code>
	   * var pink = color(255, 102, 204);
	   * img = createImage(66, 66);
	   * img.loadPixels();
	   * for (var i = 0; i < 4*(width*height/2); i+=4) {
	   *   img.pixels[i] = red(pink);
	   *   img.pixels[i+1] = green(pink);
	   *   img.pixels[i+2] = blue(pink);
	   *   img.pixels[i+3] = alpha(pink);
	   * }
	   * img.updatePixels();
	   * image(img, 17, 17);
	   * </code>
	   * </div>
	   */
	  this.pixels = [];
	};
	
	/**
	 * Helper fxn for sharing pixel methods
	 *
	 */
	p5.Image.prototype._setProperty = function (prop, value) {
	  this[prop] = value;
	};
	
	/**
	 * Loads the pixels data for this image into the [pixels] attribute.
	 *
	 * @method loadPixels
	 */
	p5.Image.prototype.loadPixels = function(){
	  p5.Renderer2D.prototype.loadPixels.call(this);
	};
	
	/**
	 * Updates the backing canvas for this image with the contents of
	 * the [pixels] array.
	 *
	 * @method updatePixels
	 * @param {Integer|undefined} x x-offset of the target update area for the
	 *                              underlying canvas
	 * @param {Integer|undefined} y y-offset of the target update area for the
	 *                              underlying canvas
	 * @param {Integer|undefined} w height of the target update area for the
	 *                              underlying canvas
	 * @param {Integer|undefined} h height of the target update area for the
	 *                              underlying canvas
	 */
	p5.Image.prototype.updatePixels = function(x, y, w, h){
	  p5.Renderer2D.prototype.updatePixels.call(this, x, y, w, h);
	};
	
	/**
	 * Get a region of pixels from an image.
	 *
	 * If no params are passed, those whole image is returned,
	 * if x and y are the only params passed a single pixel is extracted
	 * if all params are passed a rectangle region is extracted and a p5.Image
	 * is returned.
	 *
	 * Returns undefined if the region is outside the bounds of the image
	 *
	 * @method get
	 * @param  {Number}               [x] x-coordinate of the pixel
	 * @param  {Number}               [y] y-coordinate of the pixel
	 * @param  {Number}               [w] width
	 * @param  {Number}               [h] height
	 * @return {Array/Color | p5.Image}     color of pixel at x,y in array format
	 *                                    [R, G, B, A] or p5.Image
	 */
	p5.Image.prototype.get = function(x, y, w, h){
	  return p5.Renderer2D.prototype.get.call(this, x, y, w, h);
	};
	
	/**
	 * Set the color of a single pixel or write an image into
	 * this p5.Image.
	 *
	 * Note that for a large number of pixels this will
	 * be slower than directly manipulating the pixels array
	 * and then calling updatePixels().
	 *
	 * @method set
	 * @param {Number}              x x-coordinate of the pixel
	 * @param {Number}              y y-coordinate of the pixel
	 * @param {Number|Array|Object}   a grayscale value | pixel array |
	 *                                a p5.Color | image to copy
	 * @example
	 * <div>
	 * <code>
	 * img = createImage(66, 66);
	 * img.loadPixels();
	 * for (i = 0; i < img.width; i++) {
	 *   for (j = 0; j < img.height; j++) {
	 *     img.set(i, j, color(0, 90, 102, i % img.width * 2));
	 *   }
	 * }
	 * img.updatePixels();
	 * image(img, 17, 17);
	 * image(img, 34, 34);
	 * </code>
	 * </div>
	 */
	p5.Image.prototype.set = function(x, y, imgOrCol){
	  p5.Renderer2D.prototype.set.call(this, x, y, imgOrCol);
	};
	
	/**
	 * Resize the image to a new width and height. To make the image scale
	 * proportionally, use 0 as the value for the wide or high parameter.
	 * For instance, to make the width of an image 150 pixels, and change
	 * the height using the same proportion, use resize(150, 0).
	 *
	 * @method resize
	 * @param {Number} width the resized image width
	 * @param {Number} height the resized image height
	 * @example
	 * <div><code>
	 * var img;
	 *
	 * function setup() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	
	 * function draw() {
	 *   image(img, 0, 0);
	 * }
	 *
	 * function mousePressed() {
	 *   img.resize(50, 100);
	 * }
	 * </code></div>
	 */
	p5.Image.prototype.resize = function(width, height){
	
	  // Copy contents to a temporary canvas, resize the original
	  // and then copy back.
	  //
	  // There is a faster approach that involves just one copy and swapping the
	  // this.canvas reference. We could switch to that approach if (as i think
	  // is the case) there an expectation that the user would not hold a
	  // reference to the backing canvas of a p5.Image. But since we do not
	  // enforce that at the moment, I am leaving in the slower, but safer
	  // implementation.
	
	  // auto-resize
	  if (width === 0 && height === 0) {
	    width = this.canvas.width;
	    height = this.canvas.height;
	  } else if (width === 0) {
	    width = this.canvas.width * height / this.canvas.height;
	  } else if (height === 0) {
	    height = this.canvas.height * width / this.canvas.width;
	  }
	
	  var tempCanvas = document.createElement('canvas');
	  tempCanvas.width = width;
	  tempCanvas.height = height;
	  tempCanvas.getContext('2d').drawImage(this.canvas,
	    0, 0, this.canvas.width, this.canvas.height,
	    0, 0, tempCanvas.width, tempCanvas.height
	  );
	
	
	  // Resize the original canvas, which will clear its contents
	  this.canvas.width = this.width = width;
	  this.canvas.height = this.height = height;
	
	  //Copy the image back
	
	  this.drawingContext.drawImage(tempCanvas,
	    0, 0, width, height,
	    0, 0, width, height
	  );
	
	  if(this.pixels.length > 0){
	    this.loadPixels();
	  }
	};
	
	/**
	 * Copies a region of pixels from one image to another. If no
	 * srcImage is specified this is used as the source. If the source
	 * and destination regions aren't the same size, it will
	 * automatically resize source pixels to fit the specified
	 * target region.
	 *
	 * @method copy
	 * @param  {p5.Image|undefined} srcImage source image
	 * @param  {Integer} sx X coordinate of the source's upper left corner
	 * @param  {Integer} sy Y coordinate of the source's upper left corner
	 * @param  {Integer} sw source image width
	 * @param  {Integer} sh source image height
	 * @param  {Integer} dx X coordinate of the destination's upper left corner
	 * @param  {Integer} dy Y coordinate of the destination's upper left corner
	 * @param  {Integer} dw destination image width
	 * @param  {Integer} dh destination image height
	 */
	p5.Image.prototype.copy = function () {
	  p5.prototype.copy.apply(this, arguments);
	};
	
	/**
	 * Masks part of an image from displaying by loading another
	 * image and using it's blue channel as an alpha channel for
	 * this image.
	 *
	 * @method mask
	 * @param {p5.Image} srcImage source image
	 * @example
	 * <div><code>
	 * var photo, maskImage;
	 * function preload() {
	 *   photo = loadImage("assets/rockies.jpg");
	 *   maskImage = loadImage("assets/mask2.png");
	 * }
	 *
	 * function setup() {
	 *   createCanvas(100, 100);
	 *   photo.mask(maskImage);
	 *   image(photo, 0, 0);
	 * }
	 * </code></div>
	 *
	 * http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
	 *
	 */
	// TODO: - Accept an array of alpha values.
	//       - Use other channels of an image. p5 uses the
	//       blue channel (which feels kind of arbitrary). Note: at the
	//       moment this method does not match native processings original
	//       functionality exactly.
	p5.Image.prototype.mask = function(p5Image) {
	  if(p5Image === undefined){
	    p5Image = this;
	  }
	  var currBlend = this.drawingContext.globalCompositeOperation;
	
	  var scaleFactor = 1;
	  if (p5Image instanceof p5.Renderer) {
	    scaleFactor = p5Image._pInst._pixelDensity;
	  }
	
	  var copyArgs = [
	    p5Image,
	    0,
	    0,
	    scaleFactor*p5Image.width,
	    scaleFactor*p5Image.height,
	    0,
	    0,
	    this.width,
	    this.height
	  ];
	
	  this.drawingContext.globalCompositeOperation = 'destination-in';
	  this.copy.apply(this, copyArgs);
	  this.drawingContext.globalCompositeOperation = currBlend;
	};
	
	/**
	 * Applies an image filter to a p5.Image
	 *
	 * @method filter
	 * @param {String} operation one of threshold, gray, invert, posterize and
	 *                           opaque see Filters.js for docs on each available
	 *                           filter
	 * @param {Number|undefined} value
	 */
	p5.Image.prototype.filter = function(operation, value) {
	  Filters.apply(this.canvas, Filters[operation.toLowerCase()], value);
	};
	
	/**
	 * Copies a region of pixels from one image to another, using a specified
	 * blend mode to do the operation.
	 *
	 * @method blend
	 * @param  {p5.Image|undefined} srcImage source image
	 * @param  {Integer} sx X coordinate of the source's upper left corner
	 * @param  {Integer} sy Y coordinate of the source's upper left corner
	 * @param  {Integer} sw source image width
	 * @param  {Integer} sh source image height
	 * @param  {Integer} dx X coordinate of the destination's upper left corner
	 * @param  {Integer} dy Y coordinate of the destination's upper left corner
	 * @param  {Integer} dw destination image width
	 * @param  {Integer} dh destination image height
	 * @param  {Integer} blendMode the blend mode
	 *
	 * Available blend modes are: normal | multiply | screen | overlay |
	 *            darken | lighten | color-dodge | color-burn | hard-light |
	 *            soft-light | difference | exclusion | hue | saturation |
	 *            color | luminosity
	 *
	 *
	 * http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
	 *
	 */
	p5.Image.prototype.blend = function() {
	  p5.prototype.blend.apply(this, arguments);
	};
	
	/**
	 * Saves the image to a file and force the browser to download it.
	 * Accepts two strings for filename and file extension
	 * Supports png (default) and jpg.
	 *
	 * @method save
	 * @param {String} filename give your file a name
	 * @param  {String} extension 'png' or 'jpg'
	 */
	p5.Image.prototype.save = function(filename, extension) {
	  var mimeType;
	  if (!extension) {
	    extension = 'png';
	    mimeType = 'image/png';
	  }
	  else {
	    // en.wikipedia.org/wiki/Comparison_of_web_browsers#Image_format_support
	    switch(extension.toLowerCase()){
	    case 'png':
	      mimeType = 'image/png';
	      break;
	    case 'jpeg':
	      mimeType = 'image/jpeg';
	      break;
	    case 'jpg':
	      mimeType = 'image/jpeg';
	      break;
	    default:
	      mimeType = 'image/png';
	      break;
	    }
	  }
	  var downloadMime = 'image/octet-stream';
	  var imageData = this.canvas.toDataURL(mimeType);
	  imageData = imageData.replace(mimeType, downloadMime);
	
	  //Make the browser download the file
	  p5.prototype.downloadFile(imageData, filename, extension);
	};
	
	/**
	 * creates a gl texture
	 * used in WEBGL mode only
	 * @param  {[type]} tex [description]
	 * @return {[type]}     [description]
	 */
	p5.Image.prototype.createTexture = function(tex){
	  //this.texture = tex;
	  return this;
	};
	
	module.exports = p5.Image;
	
	},{"../core/core":48,"./filters":65}],69:[function(_dereq_,module,exports){
	/**
	 * @module Image
	 * @submodule Pixels
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var Filters = _dereq_('./filters');
	_dereq_('../color/p5.Color');
	
	/**
	 * <a href='https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference
	 * /Global_Objects/Uint8ClampedArray' target='_blank'>Uint8ClampedArray</a>
	 * containing the values for all the pixels in the display window.
	 * These values are numbers. This array is the size (include an appropriate
	 * factor for pixelDensity) of the display window x4,
	 * representing the R, G, B, A values in order for each pixel, moving from
	 * left to right across each row, then down each column. Retina and other
	 * high denisty displays will have more pixels[] (by a factor of
	 * pixelDensity^2).
	 * For example, if the image is 100x100 pixels, there will be 40,000. On a
	 * retina display, there will be 160,000.
	 * <br><br>
	 * The first four values (indices 0-3) in the array will be the R, G, B, A
	 * values of the pixel at (0, 0). The second four values (indices 4-7) will
	 * contain the R, G, B, A values of the pixel at (1, 0). More generally, to
	 * set values for a pixel at (x, y):
	 * <code><pre>
	 * var d = pixelDensity;
	 * for (var i = 0; i < d; i++) {
	 *   for (var j = 0; j < d; j++) {
	 *     // loop over
	 *     idx = 4 * ((y * d + j) * width * d + (x * d + i));
	 *     pixels[idx] = r;
	 *     pixels[idx+1] = g;
	 *     pixels[idx+2] = b;
	 *     pixels[idx+3] = a;
	 *   }
	 * }
	 * </pre></code>
	 *
	 * <p>While the above method is complex, it is flexible enough to work with
	 * any pixelDensity. Note that set() will automatically take care of
	 * setting all the appropriate values in pixels[] for a given (x, y) at
	 * any pixelDensity, but the performance may not be as fast when lots of
	 * modifications are made to the pixel array.
	 * <br><br>
	 * Before accessing this array, the data must loaded with the loadPixels()
	 * function. After the array data has been modified, the updatePixels()
	 * function must be run to update the changes.
	 * <br><br>
	 * Note that this is not a standard javascript array.  This means that
	 * standard javascript functions such as <code>slice()</code> or
	 * <code>arrayCopy()</code> do not
	 * work.</p>
	 *
	 * @property pixels[]
	 * @example
	 * <div>
	 * <code>
	 * var pink = color(255, 102, 204);
	 * loadPixels();
	 * var d = pixelDensity;
	 * var halfImage = 4 * (width * d) * (height/2 * d);
	 * for (var i = 0; i < halfImage; i+=4) {
	 *   pixels[i] = red(pink);
	 *   pixels[i+1] = green(pink);
	 *   pixels[i+2] = blue(pink);
	 *   pixels[i+3] = alpha(pink);
	 * }
	 * updatePixels();
	 * </code>
	 * </div>
	 */
	p5.prototype.pixels = [];
	
	/**
	 * Copies a region of pixels from one image to another, using a specified
	 * blend mode to do the operation.<br><br>
	 * Available blend modes are: BLEND | DARKEST | LIGHTEST | DIFFERENCE |
	 * MULTIPLY| EXCLUSION | SCREEN | REPLACE | OVERLAY | HARD_LIGHT |
	 * SOFT_LIGHT | DODGE | BURN | ADD | NORMAL
	 *
	 *
	 * @method blend
	 * @param  {p5.Image|undefined} srcImage source image
	 * @param  {Integer} sx X coordinate of the source's upper left corner
	 * @param  {Integer} sy Y coordinate of the source's upper left corner
	 * @param  {Integer} sw source image width
	 * @param  {Integer} sh source image height
	 * @param  {Integer} dx X coordinate of the destination's upper left corner
	 * @param  {Integer} dy Y coordinate of the destination's upper left corner
	 * @param  {Integer} dw destination image width
	 * @param  {Integer} dh destination image height
	 * @param  {Integer} blendMode the blend mode
	 *
	 * @example
	 * <div><code>
	 * var img0;
	 * var img1;
	 *
	 * function preload() {
	 *   img0 = loadImage("assets/rockies.jpg");
	 *   img1 = loadImage("assets/bricks_third.jpg");
	 * }
	 *
	 * function setup() {
	 *   background(img0);
	 *   image(img1, 0, 0);
	 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);
	 * }
	 * </code></div>
	 * <div><code>
	 * var img0;
	 * var img1;
	 *
	 * function preload() {
	 *   img0 = loadImage("assets/rockies.jpg");
	 *   img1 = loadImage("assets/bricks_third.jpg");
	 * }
	 *
	 * function setup() {
	 *   background(img0);
	 *   image(img1, 0, 0);
	 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);
	 * }
	 * </code></div>
	 * <div><code>
	 * var img0;
	 * var img1;
	 *
	 * function preload() {
	 *   img0 = loadImage("assets/rockies.jpg");
	 *   img1 = loadImage("assets/bricks_third.jpg");
	 * }
	 *
	 * function setup() {
	 *   background(img0);
	 *   image(img1, 0, 0);
	 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, ADD);
	 * }
	 * </code></div>
	 */
	p5.prototype.blend = function() {
	  this._renderer.blend.apply(this._renderer, arguments);
	};
	
	/**
	 * Copies a region of the canvas to another region of the canvas
	 * and copies a region of pixels from an image used as the srcImg parameter
	 * into the canvas srcImage is specified this is used as the source. If
	 * the source and destination regions aren't the same size, it will
	 * automatically resize source pixels to fit the specified
	 * target region.
	 *
	 * @method copy
	 * @param  {p5.Image|undefined} srcImage source image
	 * @param  {Integer} sx X coordinate of the source's upper left corner
	 * @param  {Integer} sy Y coordinate of the source's upper left corner
	 * @param  {Integer} sw source image width
	 * @param  {Integer} sh source image height
	 * @param  {Integer} dx X coordinate of the destination's upper left corner
	 * @param  {Integer} dy Y coordinate of the destination's upper left corner
	 * @param  {Integer} dw destination image width
	 * @param  {Integer} dh destination image height
	 *
	 * @example
	 * <div><code>
	 * var img;
	 *
	 * function preload() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	 *
	 * function setup() {
	 *   background(img);
	 *   copy(img, 7, 22, 10, 10, 35, 25, 50, 50);
	 *   stroke(255);
	 *   noFill();
	 *   // Rectangle shows area being copied
	 *   rect(7, 22, 10, 10);
	 * }
	 * </code></div>
	 */
	p5.prototype.copy = function () {
	  p5.Renderer2D._copyHelper.apply(this, arguments);
	};
	
	/**
	 * Applies a filter to the canvas.
	 * <br><br>
	 *
	 * The presets options are:
	 * <br><br>
	 *
	 * THRESHOLD
	 * Converts the image to black and white pixels depending if they are above or
	 * below the threshold defined by the level parameter. The parameter must be
	 * between 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.
	 * <br><br>
	 *
	 * GRAY
	 * Converts any colors in the image to grayscale equivalents. No parameter
	 * is used.
	 * <br><br>
	 *
	 * OPAQUE
	 * Sets the alpha channel to entirely opaque. No parameter is used.
	 * <br><br>
	 *
	 * INVERT
	 * Sets each pixel to its inverse value. No parameter is used.
	 * <br><br>
	 *
	 * POSTERIZE
	 * Limits each channel of the image to the number of colors specified as the
	 * parameter. The parameter can be set to values between 2 and 255, but
	 * results are most noticeable in the lower ranges.
	 * <br><br>
	 *
	 * BLUR
	 * Executes a Guassian blur with the level parameter specifying the extent
	 * of the blurring. If no parameter is used, the blur is equivalent to
	 * Guassian blur of radius 1. Larger values increase the blur.
	 * <br><br>
	 *
	 * ERODE
	 * Reduces the light areas. No parameter is used.
	 * <br><br>
	 *
	 * DILATE
	 * Increases the light areas. No parameter is used.
	 *
	 * @method filter
	 * @param  {String} filterType
	 * @param  {Number} filterParam an optional parameter unique
	 *  to each filter, see above
	 *
	 *
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(THRESHOLD);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(GRAY);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(OPAQUE);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(INVERT);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(POSTERIZE,3);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(DILATE);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(BLUR,3);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/bricks.jpg");
	 * }
	 * function setup() {
	 *  image(img, 0, 0);
	 *  filter(ERODE);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.filter = function(operation, value) {
	  Filters.apply(this.canvas, Filters[operation.toLowerCase()], value);
	};
	
	/**
	 * Returns an array of [R,G,B,A] values for any pixel or grabs a section of
	 * an image. If no parameters are specified, the entire image is returned.
	 * Use the x and y parameters to get the value of one pixel. Get a section of
	 * the display window by specifying additional w and h parameters. When
	 * getting an image, the x and y parameters define the coordinates for the
	 * upper-left corner of the image, regardless of the current imageMode().
	 * <br><br>
	 * If the pixel requested is outside of the image window, [0,0,0,255] is
	 * returned. To get the numbers scaled according to the current color ranges
	 * and taking into account colorMode, use getColor instead of get.
	 * <br><br>
	 * Getting the color of a single pixel with get(x, y) is easy, but not as fast
	 * as grabbing the data directly from pixels[]. The equivalent statement to
	 * get(x, y) using pixels[] with pixel density d is
	 * <code>[pixels[(y*width*d+x)*d],
	 * pixels[(y*width*d+x)*d+1],
	 * pixels[(y*width*d+x)*d+2],
	 * pixels[(y*width*d+x)*d+3]]</code>.
	 * <br><br>
	 * See the reference for pixels[] for more information.
	 *
	 * @method get
	 * @param  {Number}         [x] x-coordinate of the pixel
	 * @param  {Number}         [y] y-coordinate of the pixel
	 * @param  {Number}         [w] width
	 * @param  {Number}         [h] height
	 * @return {Array|p5.Image}     values of pixel at x,y in array format
	 *                              [R, G, B, A] or p5.Image
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 *   var c = get();
	 *   image(c, width/2, 0);
	 * }
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	 * function setup() {
	 *   image(img, 0, 0);
	 *   var c = get(50, 90);
	 *   fill(c);
	 *   noStroke();
	 *   rect(25, 25, 50, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.get = function(x, y, w, h){
	  return this._renderer.get(x, y, w, h);
	};
	
	/**
	 * Loads the pixel data for the display window into the pixels[] array. This
	 * function must always be called before reading from or writing to pixels[].
	 *
	 * @method loadPixels
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	 *
	 * function setup() {
	 *   image(img, 0, 0);
	 *   var d = pixelDensity;
	 *   var halfImage = 4 * (img.width * d) *
	       (img.height/2 * d);
	 *   loadPixels();
	 *   for (var i = 0; i < halfImage; i++) {
	 *     pixels[i+halfImage] = pixels[i];
	 *   }
	 *   updatePixels();
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.loadPixels = function() {
	  this._renderer.loadPixels();
	};
	
	/**
	 * <p>Changes the color of any pixel, or writes an image directly to the
	 * display window.</p>
	 * <p>The x and y parameters specify the pixel to change and the c parameter
	 * specifies the color value. This can be a p5.Color object, or [R, G, B, A]
	 * pixel array. It can also be a single grayscale value.
	 * When setting an image, the x and y parameters define the coordinates for
	 * the upper-left corner of the image, regardless of the current imageMode().
	 * </p>
	 * <p>
	 * After using set(), you must call updatePixels() for your changes to
	 * appear.  This should be called once all pixels have been set.
	 * </p>
	 * <p>Setting the color of a single pixel with set(x, y) is easy, but not as
	 * fast as putting the data directly into pixels[]. Setting the pixels[]
	 * values directly may be complicated when working with a retina display,
	 * but will perform better when lots of pixels need to be set directly on
	 * every loop.</p>
	 * <p>See the reference for pixels[] for more information.</p>
	 *
	 * @method set
	 * @param {Number}              x x-coordinate of the pixel
	 * @param {Number}              y y-coordinate of the pixel
	 * @param {Number|Array|Object} c insert a grayscale value | a pixel array |
	 *                                a p5.Color object | a p5.Image to copy
	 * @example
	 * <div>
	 * <code>
	 * var black = color(0);
	 * set(30, 20, black);
	 * set(85, 20, black);
	 * set(85, 75, black);
	 * set(30, 75, black);
	 * updatePixels();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * for (var i = 30; i < width-15; i++) {
	 *   for (var j = 20; j < height-25; j++) {
	 *     var c = color(204-j, 153-i, 0);
	 *     set(i, j, c);
	 *   }
	 * }
	 * updatePixels();
	 * </code>
	 * </div>
	 *
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	 *
	 * function setup() {
	 *   set(0, 0, img);
	 *   updatePixels();
	 *   line(0, 0, width, height);
	 *   line(0, height, width, 0);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.set = function (x, y, imgOrCol) {
	  this._renderer.set(x, y, imgOrCol);
	};
	/**
	 * Updates the display window with the data in the pixels[] array.
	 * Use in conjunction with loadPixels(). If you're only reading pixels from
	 * the array, there's no need to call updatePixels() — updating is only
	 * necessary to apply changes. updatePixels() should be called anytime the
	 * pixels array is manipulated or set() is called.
	 *
	 * @method updatePixels
	 * @param  {Number} [x]    x-coordinate of the upper-left corner of region
	 *                         to update
	 * @param  {Number} [y]    y-coordinate of the upper-left corner of region
	 *                         to update
	 * @param  {Number} [w]    width of region to update
	 * @param  {Number} [w]    height of region to update
	 * @example
	 * <div>
	 * <code>
	 * var img;
	 * function preload() {
	 *   img = loadImage("assets/rockies.jpg");
	 * }
	 *
	 * function setup() {
	 *   image(img, 0, 0);
	 *   var halfImage = 4 * (img.width * pixelDensity) *
	 *     (img.height * pixelDensity/2);
	 *   loadPixels();
	 *   for (var i = 0; i < halfImage; i++) {
	 *     pixels[i+halfImage] = pixels[i];
	 *   }
	 *   updatePixels();
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.updatePixels = function (x, y, w, h) {
	  // graceful fail - if loadPixels() or set() has not been called, pixel
	  // array will be empty, ignore call to updatePixels()
	  if (this.pixels.length === 0) {
	    return;
	  }
	  this._renderer.updatePixels(x, y, w, h);
	};
	
	module.exports = p5;
	
	},{"../color/p5.Color":42,"../core/core":48,"./filters":65}],70:[function(_dereq_,module,exports){
	/**
	 * @module IO
	 * @submodule Input
	 * @for p5
	 * @requires core
	 * @requires reqwest
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var reqwest = _dereq_('reqwest');
	var opentype = _dereq_('opentype.js');
	_dereq_('../core/error_helpers');
	
	/**
	 * Checks if we are in preload and returns the last arg which will be the
	 * _decrementPreload function if called from a loadX() function.  Should
	 * only be used in loadX() functions.
	 * @private
	 */
	p5._getDecrementPreload = function () {
	  var decrementPreload = arguments[arguments.length - 1];
	
	  // when in preload decrementPreload will always be the last arg as it is set
	  // with args.push() before invocation in _wrapPreload
	  if ((window.preload || (this && this.preload)) &&
	    typeof decrementPreload === 'function') {
	    return decrementPreload;
	  } else {
	    return null;
	  }
	};
	
	/**
	 * Loads an opentype font file (.otf, .ttf) from a file or a URL,
	 * and returns a PFont Object. This method is asynchronous,
	 * meaning it may not finish before the next line in your sketch
	 * is executed.
	 * <br><br>
	 * The path to the font should be relative to the HTML file
	 * that links in your sketch. Loading an from a URL or other
	 * remote location may be blocked due to your browser's built-in
	 * security.
	 *
	 * @method loadFont
	 * @param  {String}        path       name of the file or url to load
	 * @param  {Function}      [callback] function to be executed after
	 *                                    loadFont()
	 *                                    completes
	 * @return {Object}                   p5.Font object
	 * @example
	 *
	 * <p>Calling loadFont() inside preload() guarantees that the load
	 * operation will have completed before setup() and draw() are called.</p>
	 *
	 * <div><code>
	 * var myFont;
	 * function preload() {
	 *   myFont = loadFont('assets/AvenirNextLTPro-Demi.otf');
	 * }
	 *
	 * function setup() {
	 *   fill('#ED225D');
	 *   textFont(myFont);
	 *   textSize(36);
	 *   text('p5*js', 10, 50);
	 * }
	 * </code></div>
	 *
	 * <p>Outside of preload(), you may supply a callback function to handle the
	 * object:</p>
	 *
	 * <div><code>
	 * function setup() {
	 *   loadFont('assets/AvenirNextLTPro-Demi.otf', drawText);
	 * }
	 *
	 * function drawText(font) {
	 *   fill('#ED225D');
	 *   textFont(font, 36);
	 *   text('p5*js', 10, 50);
	 * }
	 *
	 * </code></div>
	 *
	 * <p>You can also use the string name of the font to style other HTML
	 * elements.</p>
	 *
	 * <div><code>
	 * var myFont;
	 *
	 * function preload() {
	 *   myFont = loadFont('assets/Avenir.otf');
	 * }
	 *
	 * function setup() {
	 *   var myDiv = createDiv('hello there');
	 *   myDiv.style('font-family', 'Avenir');
	 * }
	 * </code></div>
	 */
	p5.prototype.loadFont = function (path, onSuccess, onError) {
	
	  var p5Font = new p5.Font(this);
	  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
	
	  opentype.load(path, function (err, font) {
	
	    if (err) {
	
	      if ((typeof onError !== 'undefined') && (onError !== decrementPreload)) {
	        return onError(err);
	      }
	      throw err;
	    }
	
	    p5Font.font = font;
	
	    if (typeof onSuccess !== 'undefined') {
	      onSuccess(p5Font);
	    }
	
	    if (decrementPreload && (onSuccess !== decrementPreload)) {
	      decrementPreload();
	    }
	
	    // check that we have an acceptable font type
	    var validFontTypes = [ 'ttf', 'otf', 'woff', 'woff2' ],
	      fileNoPath = path.split('\\').pop().split('/').pop(),
	      lastDotIdx = fileNoPath.lastIndexOf('.'), fontFamily, newStyle,
	      fileExt = lastDotIdx < 1 ? null : fileNoPath.substr(lastDotIdx + 1);
	
	    // if so, add it to the DOM (name-only) for use with p5.dom
	    if (validFontTypes.indexOf(fileExt) > -1) {
	
	      fontFamily = fileNoPath.substr(0, lastDotIdx);
	      newStyle = document.createElement('style');
	      newStyle.appendChild(document.createTextNode('\n@font-face {' +
	        '\nfont-family: ' + fontFamily + ';\nsrc: url(' + path + ');\n}\n'));
	      document.head.appendChild(newStyle);
	    }
	
	  });
	
	  return p5Font;
	};
	
	//BufferedReader
	p5.prototype.createInput = function () {
	  // TODO
	  throw 'not yet implemented';
	};
	
	p5.prototype.createReader = function () {
	  // TODO
	  throw 'not yet implemented';
	};
	
	p5.prototype.loadBytes = function () {
	  // TODO
	  throw 'not yet implemented';
	};
	
	/**
	 * Loads a JSON file from a file or a URL, and returns an Object or Array.
	 * This method is asynchronous, meaning it may not finish before the next
	 * line in your sketch is executed.
	 *
	 * @method loadJSON
	 * @param  {String}        path       name of the file or url to load
	 * @param  {Function}      [callback] function to be executed after
	 *                                    loadJSON() completes, data is passed
	 *                                    in as first argument
	 * @param  {Function}      [errorCallback] function to be executed if
	 *                                    there is an error, response is passed
	 *                                    in as first argument
	 * @param  {String}        [datatype] "json" or "jsonp"
	 * @return {Object|Array}             JSON data
	 * @example
	 *
	 * <p>Calling loadJSON() inside preload() guarantees to complete the
	 * operation before setup() and draw() are called.</p>
	 *
	 * <div><code>
	 * var weather;
	 * function preload() {
	 *   var url = 'http://api.openweathermap.org/data/2.5/weather?q=London,UK'+
	 *    '&APPID=7bbbb47522848e8b9c26ba35c226c734';
	 *   weather = loadJSON(url);
	 * }
	 *
	 * function setup() {
	 *   noLoop();
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 *   // get the humidity value out of the loaded JSON
	 *   var humidity = weather.main.humidity;
	 *   fill(0, humidity); // use the humidity value to set the alpha
	 *   ellipse(width/2, height/2, 50, 50);
	 * }
	 * </code></div>
	 *
	 *
	 * <p>Outside of preload(), you may supply a callback function to handle the
	 * object:</p>
	 * <div><code>
	 * function setup() {
	 *   noLoop();
	 *   var url = 'http://api.openweathermap.org/data/2.5/weather?q=NewYork'+
	 *    '&APPID=7bbbb47522848e8b9c26ba35c226c734';
	 *   loadJSON(url, drawWeather);
	 * }
	 *
	 * function draw() {
	 *   background(200);
	 * }
	 *
	 * function drawWeather(weather) {
	 *   // get the humidity value out of the loaded JSON
	 *   var humidity = weather.main.humidity;
	 *   fill(0, humidity); // use the humidity value to set the alpha
	 *   ellipse(width/2, height/2, 50, 50);
	 * }
	 * </code></div>
	 *
	 */
	p5.prototype.loadJSON = function () {
	  var path = arguments[0];
	  var callback = arguments[1];
	  var errorCallback;
	  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
	
	  var ret = []; // array needed for preload
	  // assume jsonp for URLs
	  var t = 'json'; //= path.indexOf('http') === -1 ? 'json' : 'jsonp';
	
	  // check for explicit data type argument
	  for (var i = 2; i < arguments.length; i++) {
	    var arg = arguments[i];
	    if (typeof arg === 'string') {
	      if (arg === 'jsonp' || arg === 'json') {
	        t = arg;
	      }
	    } else if (typeof arg === 'function') {
	      errorCallback = arg;
	    }
	  }
	
	  reqwest({
	    url: path,
	    type: t,
	    crossOrigin: true,
	    error: function (resp) {
	      // pass to error callback if defined
	      if (errorCallback) {
	        errorCallback(resp);
	      } else { // otherwise log error msg
	        console.log(resp.statusText);
	      }
	    },
	    success: function (resp) {
	      for (var k in resp) {
	        ret[k] = resp[k];
	      }
	      if (typeof callback !== 'undefined') {
	        callback(resp);
	      }
	      if (decrementPreload && (callback !== decrementPreload)) {
	        decrementPreload();
	      }
	    }
	  });
	
	  return ret;
	};
	
	/**
	 * Reads the contents of a file and creates a String array of its individual
	 * lines. If the name of the file is used as the parameter, as in the above
	 * example, the file must be located in the sketch directory/folder.
	 * <br><br>
	 * Alternatively, the file maybe be loaded from anywhere on the local
	 * computer using an absolute path (something that starts with / on Unix and
	 * Linux, or a drive letter on Windows), or the filename parameter can be a
	 * URL for a file found on a network.
	 * <br><br>
	 * This method is asynchronous, meaning it may not finish before the next
	 * line in your sketch is executed.
	 *
	 * @method loadStrings
	 * @param  {String}   filename   name of the file or url to load
	 * @param  {Function} [callback] function to be executed after loadStrings()
	 *                               completes, Array is passed in as first
	 *                               argument
	 * @param  {Function} [errorCallback] function to be executed if
	 *                               there is an error, response is passed
	 *                               in as first argument
	 * @return {Array}               Array of Strings
	 * @example
	 *
	 * <p>Calling loadStrings() inside preload() guarantees to complete the
	 * operation before setup() and draw() are called.</p>
	 *
	 * <div><code>
	 * var result;
	 * function preload() {
	 *   result = loadStrings('assets/test.txt');
	 * }
	
	 * function setup() {
	 *   background(200);
	 *   var ind = floor(random(result.length));
	 *   text(result[ind], 10, 10, 80, 80);
	 * }
	 * </code></div>
	 *
	 * <p>Outside of preload(), you may supply a callback function to handle the
	 * object:</p>
	 *
	 * <div><code>
	 * function setup() {
	 *   loadStrings('assets/test.txt', pickString);
	 * }
	 *
	 * function pickString(result) {
	 *   background(200);
	 *   var ind = floor(random(result.length));
	 *   text(result[ind], 10, 10, 80, 80);
	 * }
	 * </code></div>
	 */
	p5.prototype.loadStrings = function (path, callback, errorCallback) {
	  var ret = [];
	  var req = new XMLHttpRequest();
	  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
	
	  req.addEventListener('error', function (resp) {
	    if (errorCallback) {
	      errorCallback(resp);
	    } else {
	      console.log(resp.responseText);
	    }
	  });
	
	  req.open('GET', path, true);
	  req.onreadystatechange = function () {
	    if (req.readyState === 4) {
	      if (req.status === 200) {
	        var arr = req.responseText.match(/[^\r\n]+/g);
	        for (var k in arr) {
	          ret[k] = arr[k];
	        }
	        if (typeof callback !== 'undefined') {
	          callback(ret);
	        }
	        if (decrementPreload && (callback !== decrementPreload)) {
	          decrementPreload();
	        }
	      } else {
	        if (errorCallback) {
	          errorCallback(req);
	        } else {
	          console.log(req.statusText);
	        }
	        //p5._friendlyFileLoadError(3, path);
	      }
	    }
	  };
	  req.send(null);
	  return ret;
	};
	
	/**
	 * <p>Reads the contents of a file or URL and creates a p5.Table object with
	 * its values. If a file is specified, it must be located in the sketch's
	 * "data" folder. The filename parameter can also be a URL to a file found
	 * online. By default, the file is assumed to be comma-separated (in CSV
	 * format). Table only looks for a header row if the 'header' option is
	 * included.</p>
	 *
	 * <p>Possible options include:
	 * <ul>
	 * <li>csv - parse the table as comma-separated values</li>
	 * <li>tsv - parse the table as tab-separated values</li>
	 * <li>header - this table has a header (title) row</li>
	 * </ul>
	 * </p>
	 *
	 * <p>When passing in multiple options, pass them in as separate parameters,
	 * seperated by commas. For example:
	 * <br><br>
	 * <code>
	 *   loadTable("my_csv_file.csv", "csv", "header")
	 * </code>
	 * </p>
	 *
	 * <p> All files loaded and saved use UTF-8 encoding.</p>
	 *
	 * <p>This method is asynchronous, meaning it may not finish before the next
	 * line in your sketch is executed. Calling loadTable() inside preload()
	 * guarantees to complete the operation before setup() and draw() are called.
	 * <p>Outside of preload(), you may supply a callback function to handle the
	 * object:</p>
	 * </p>
	 *
	 * @method loadTable
	 * @param  {String}         filename   name of the file or URL to load
	 * @param  {String|Strings} [options]  "header" "csv" "tsv"
	 * @param  {Function}       [callback] function to be executed after
	 *                                     loadTable() completes, Table object is
	 *                                     passed in as first argument
	 * @return {Object}                    Table object containing data
	 *
	 * @example
	 * <div class="norender">
	 * <code>
	 * // Given the following CSV file called "mammals.csv"
	 * // located in the project's "assets" folder:
	 * //
	 * // id,species,name
	 * // 0,Capra hircus,Goat
	 * // 1,Panthera pardus,Leopard
	 * // 2,Equus zebra,Zebra
	 *
	 * var table;
	 *
	 * function preload() {
	 *   //my table is comma separated value "csv"
	 *   //and has a header specifying the columns labels
	 *   table = loadTable("assets/mammals.csv", "csv", "header");
	 *   //the file can be remote
	 *   //table = loadTable("http://p5js.org/reference/assets/mammals.csv",
	 *   //                  "csv", "header");
	 * }
	 *
	 * function setup() {
	 *   //count the columns
	 *   print(table.getRowCount() + " total rows in table");
	 *   print(table.getColumnCount() + " total columns in table");
	 *
	 *   print(table.getColumn("name"));
	 *   //["Goat", "Leopard", "Zebra"]
	 *
	 *   //cycle through the table
	 *   for (var r = 0; r < table.getRowCount(); r++)
	 *     for (var c = 0; c < table.getColumnCount(); c++) {
	 *       print(table.getString(r, c));
	 *     }
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.loadTable = function (path) {
	  var callback = null;
	  var options = [];
	  var header = false;
	  var sep = ',';
	  var separatorSet = false;
	  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
	
	  for (var i = 1; i < arguments.length; i++) {
	    if ((typeof (arguments[i]) === 'function') &&
	      (arguments[i] !== decrementPreload)) {
	      callback = arguments[i];
	    } else if (typeof (arguments[i]) === 'string') {
	      options.push(arguments[i]);
	      if (arguments[i] === 'header') {
	        header = true;
	      }
	      if (arguments[i] === 'csv') {
	        if (separatorSet) {
	          throw new Error('Cannot set multiple separator types.');
	        } else {
	          sep = ',';
	          separatorSet = true;
	        }
	      } else if (arguments[i] === 'tsv') {
	        if (separatorSet) {
	          throw new Error('Cannot set multiple separator types.');
	        } else {
	          sep = '\t';
	          separatorSet = true;
	        }
	      }
	    }
	  }
	
	  var t = new p5.Table();
	  reqwest({
	      url: path,
	      crossOrigin: true,
	      type: 'csv'
	    })
	    .then(function (resp) {
	      resp = resp.responseText;
	
	      var state = {};
	
	      // define constants
	      var PRE_TOKEN = 0,
	        MID_TOKEN = 1,
	        POST_TOKEN = 2,
	        POST_RECORD = 4;
	
	      var QUOTE = '\"',
	        CR = '\r',
	        LF = '\n';
	
	      var records = [];
	      var offset = 0;
	      var currentRecord = null;
	      var currentChar;
	
	      var recordBegin = function () {
	        state.escaped = false;
	        currentRecord = [];
	        tokenBegin();
	      };
	
	      var recordEnd = function () {
	        state.currentState = POST_RECORD;
	        records.push(currentRecord);
	        currentRecord = null;
	      };
	
	      var tokenBegin = function () {
	        state.currentState = PRE_TOKEN;
	        state.token = '';
	      };
	
	      var tokenEnd = function () {
	        currentRecord.push(state.token);
	        tokenBegin();
	      };
	
	      while (true) {
	        currentChar = resp[offset++];
	
	        // EOF
	        if (currentChar == null) {
	          if (state.escaped) {
	            throw new Error('Unclosed quote in file.');
	          }
	          if (currentRecord) {
	            tokenEnd();
	            recordEnd();
	            break;
	          }
	        }
	        if (currentRecord === null) {
	          recordBegin();
	        }
	
	        // Handle opening quote
	        if (state.currentState === PRE_TOKEN) {
	          if (currentChar === QUOTE) {
	            state.escaped = true;
	            state.currentState = MID_TOKEN;
	            continue;
	          }
	          state.currentState = MID_TOKEN;
	        }
	
	        // mid-token and escaped, look for sequences and end quote
	        if (state.currentState === MID_TOKEN && state.escaped) {
	          if (currentChar === QUOTE) {
	            if (resp[offset] === QUOTE) {
	              state.token += QUOTE;
	              offset++;
	            } else {
	              state.escaped = false;
	              state.currentState = POST_TOKEN;
	            }
	          } else {
	            state.token += currentChar;
	          }
	          continue;
	        }
	
	        // fall-through: mid-token or post-token, not escaped
	        if (currentChar === CR) {
	          if (resp[offset] === LF) {
	            offset++;
	          }
	          tokenEnd();
	          recordEnd();
	        } else if (currentChar === LF) {
	          tokenEnd();
	          recordEnd();
	        } else if (currentChar === sep) {
	          tokenEnd();
	        } else if (state.currentState === MID_TOKEN) {
	          state.token += currentChar;
	        }
	      }
	
	      // set up column names
	      if (header) {
	        t.columns = records.shift();
	      } else {
	        for (i = 0; i < records.length; i++) {
	          t.columns[i] = i.toString();
	        }
	      }
	      var row;
	      for (i = 0; i < records.length; i++) {
	        //Handles row of 'undefined' at end of some CSVs
	        if (i === records.length - 1 && records[i].length === 1) {
	          if (records[i][0] === 'undefined') {
	            break;
	          }
	        }
	        row = new p5.TableRow();
	        row.arr = records[i];
	        row.obj = makeObject(records[i], t.columns);
	        t.addRow(row);
	      }
	      if (callback !== null) {
	        callback(t);
	      }
	      if (decrementPreload && (callback !== decrementPreload)) {
	        decrementPreload();
	      }
	    })
	    .fail(function (err, msg) {
	      p5._friendlyFileLoadError(2, path);
	      // don't get error callback mixed up with decrementPreload
	      if ((typeof callback !== 'undefined') &&
	        (callback !== decrementPreload)) {
	        callback(false);
	      }
	    });
	
	  return t;
	};
	
	// helper function to turn a row into a JSON object
	function makeObject(row, headers) {
	  var ret = {};
	  headers = headers || [];
	  if (typeof (headers) === 'undefined') {
	    for (var j = 0; j < row.length; j++) {
	      headers[j.toString()] = j;
	    }
	  }
	  for (var i = 0; i < headers.length; i++) {
	    var key = headers[i];
	    var val = row[i];
	    ret[key] = val;
	  }
	  return ret;
	}
	
	/**
	 * Reads the contents of a file and creates an XML object with its values.
	 * If the name of the file is used as the parameter, as in the above example,
	 * the file must be located in the sketch directory/folder.
	 * <br><br>
	 * Alternatively, the file maybe be loaded from anywhere on the local
	 * computer using an absolute path (something that starts with / on Unix and
	 * Linux, or a drive letter on Windows), or the filename parameter can be a
	 * URL for a file found on a network.
	 * <br><br>
	 * This method is asynchronous, meaning it may not finish before the next
	 * line in your sketch is executed. Calling loadXML() inside preload()
	 * guarantees to complete the operation before setup() and draw() are called.
	 * <br><br>
	 * Outside of preload(), you may supply a callback function to handle the
	 * object:
	 *
	 * @method loadXML
	 * @param  {String}   filename   name of the file or URL to load
	 * @param  {Function} [callback] function to be executed after loadXML()
	 *                               completes, XML object is passed in as
	 *                               first argument
	 * @param  {Function} [errorCallback] function to be executed if
	 *                               there is an error, response is passed
	 *                               in as first argument
	 * @return {Object}              XML object containing data
	 */
	p5.prototype.loadXML = function (path, callback, errorCallback) {
	  var ret = document.implementation.createDocument(null, null);
	  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
	
	  reqwest({
	      url: path,
	      type: 'xml',
	      crossOrigin: true,
	      error: function (resp) {
	        // pass to error callback if defined
	        if (errorCallback) {
	          errorCallback(resp);
	        } else { // otherwise log error msg
	          console.log(resp.statusText);
	        }
	        //p5._friendlyFileLoadError(1,path);
	      }
	    })
	    .then(function (resp) {
	      var x = resp.documentElement;
	      ret.appendChild(x);
	      if (typeof callback !== 'undefined') {
	        callback(ret);
	      }
	      if (decrementPreload && (callback !== decrementPreload)) {
	        decrementPreload();
	      }
	    });
	  return ret;
	};
	
	// name clash with window.open
	// p5.prototype.open = function() {
	//   // TODO
	
	// };
	
	p5.prototype.parseXML = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	p5.prototype.selectFolder = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	p5.prototype.selectInput = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	/**
	 * Method for executing an HTTP GET request. If data type is not specified,
	 * p5 will try to guess based on the URL, defaulting to text.
	 *
	 * @method httpGet
	 * @param  {String}        path       name of the file or url to load
	 * @param  {Object}        [data]     param data passed sent with request
	 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
	 * @param  {Function}      [callback] function to be executed after
	 *                                    httpGet() completes, data is passed in
	 *                                    as first argument
	 * @param  {Function}      [errorCallback] function to be executed if
	 *                                    there is an error, response is passed
	 *                                    in as first argument
	 */
	p5.prototype.httpGet = function () {
	  var args = Array.prototype.slice.call(arguments);
	  args.push('GET');
	  p5.prototype.httpDo.apply(this, args);
	};
	
	/**
	 * Method for executing an HTTP POST request. If data type is not specified,
	 * p5 will try to guess based on the URL, defaulting to text.
	 *
	 * @method httpPost
	 * @param  {String}        path       name of the file or url to load
	 * @param  {Object}        [data]     param data passed sent with request
	 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
	 * @param  {Function}      [callback] function to be executed after
	 *                                    httpGet() completes, data is passed in
	 *                                    as first argument
	 * @param  {Function}      [errorCallback] function to be executed if
	 *                                    there is an error, response is passed
	 *                                    in as first argument
	 */
	p5.prototype.httpPost = function () {
	  var args = Array.prototype.slice.call(arguments);
	  args.push('POST');
	  p5.prototype.httpDo.apply(this, args);
	};
	
	/**
	 * Method for executing an HTTP request. If data type is not specified,
	 * p5 will try to guess based on the URL, defaulting to text.<br><br>
	 * You may also pass a single object specifying all parameters for the
	 * request following the examples inside the reqwest() calls here:
	 * <a href='https://github.com/ded/reqwest#api'
	 * >https://github.com/ded/reqwest#api</a>
	 *
	 * @method httpDo
	 * @param  {String}        path       name of the file or url to load
	 * @param  {String}        [method]   either "GET", "POST", or "PUT",
	 *                                    defaults to "GET"
	 * @param  {Object}        [data]     param data passed sent with request
	 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
	 * @param  {Function}      [callback] function to be executed after
	 *                                    httpGet() completes, data is passed in
	 *                                    as first argument
	 * @param  {Function}      [errorCallback] function to be executed if
	 *                                    there is an error, response is passed
	 *                                    in as first argument
	 */
	p5.prototype.httpDo = function () {
	  if (typeof arguments[0] === 'object') {
	    reqwest(arguments[0]);
	  } else {
	    var method = 'GET';
	    var path = arguments[0];
	    var data = {};
	    var type = '';
	    var callback;
	    var errorCallback;
	
	    for (var i = 1; i < arguments.length; i++) {
	      var a = arguments[i];
	      if (typeof a === 'string') {
	        if (a === 'GET' || a === 'POST' || a === 'PUT') {
	          method = a;
	        } else {
	          type = a;
	        }
	      } else if (typeof a === 'object') {
	        data = a;
	      } else if (typeof a === 'function') {
	        if (!callback) {
	          callback = a;
	        } else {
	          errorCallback = a;
	        }
	      }
	    }
	
	    // do some sort of smart type checking
	    if (type === '') {
	      if (path.indexOf('json') !== -1) {
	        type = 'json';
	      } else if (path.indexOf('xml') !== -1) {
	        type = 'xml';
	      } else {
	        type = 'text';
	      }
	    }
	
	    reqwest({
	      url: path,
	      method: method,
	      data: data,
	      type: type,
	      crossOrigin: true,
	      success: function (resp) {
	        if (typeof callback !== 'undefined') {
	          if (type === 'text') {
	            callback(resp.response);
	          } else {
	            callback(resp);
	          }
	        }
	      },
	      error: function (resp) {
	        if (errorCallback) {
	          errorCallback(resp);
	        } else {
	          console.log(resp.statusText);
	        }
	      }
	    });
	  }
	};
	
	/**
	 * @module IO
	 * @submodule Output
	 * @for p5
	 */
	
	window.URL = window.URL || window.webkitURL;
	
	// private array of p5.PrintWriter objects
	p5.prototype._pWriters = [];
	
	p5.prototype.beginRaw = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	p5.prototype.beginRecord = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	p5.prototype.createOutput = function () {
	  // TODO
	
	  throw 'not yet implemented';
	};
	
	p5.prototype.createWriter = function (name, extension) {
	  var newPW;
	  // check that it doesn't already exist
	  for (var i in p5.prototype._pWriters) {
	    if (p5.prototype._pWriters[i].name === name) {
	      // if a p5.PrintWriter w/ this name already exists...
	      // return p5.prototype._pWriters[i]; // return it w/ contents intact.
	      // or, could return a new, empty one with a unique name:
	      newPW = new p5.PrintWriter(name + window.millis(), extension);
	      p5.prototype._pWriters.push(newPW);
	      return newPW;
	    }
	  }
	  newPW = new p5.PrintWriter(name, extension);
	  p5.prototype._pWriters.push(newPW);
	  return newPW;
	};
	
	p5.prototype.endRaw = function () {
	  // TODO
	
	  throw 'not yet implemented';
	};
	
	p5.prototype.endRecord = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	p5.PrintWriter = function (filename, extension) {
	  var self = this;
	  this.name = filename;
	  this.content = '';
	  this.print = function (data) {
	    this.content += data;
	  };
	  this.println = function (data) {
	    this.content += data + '\n';
	  };
	  this.flush = function () {
	    this.content = '';
	  };
	  this.close = function () {
	    // convert String to Array for the writeFile Blob
	    var arr = [];
	    arr.push(this.content);
	    p5.prototype.writeFile(arr, filename, extension);
	    // remove from _pWriters array and delete self
	    for (var i in p5.prototype._pWriters) {
	      if (p5.prototype._pWriters[i].name === this.name) {
	        // remove from _pWriters array
	        p5.prototype._pWriters.splice(i, 1);
	      }
	    }
	    self.flush();
	    self = {};
	  };
	};
	
	p5.prototype.saveBytes = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	// object, filename, options --> saveJSON, saveStrings, saveTable
	// filename, [extension] [canvas] --> saveImage
	
	/**
	 *  <p>Save an image, text, json, csv, wav, or html. Prompts download to
	 *  the client's computer. <b>Note that it is not recommended to call save()
	 *  within draw if it's looping, as the save() function will open a new save
	 *  dialog every frame.</b></p>
	 *  <p>The default behavior is to save the canvas as an image. You can
	 *  optionally specify a filename.
	 *  For example:</p>
	 *  <pre class='language-javascript'><code>
	 *  save();
	 *  save('myCanvas.jpg'); // save a specific canvas with a filename
	 *  </code></pre>
	 *
	 *  <p>Alternately, the first parameter can be a pointer to a canvas
	 *  p5.Element, an Array of Strings,
	 *  an Array of JSON, a JSON object, a p5.Table, a p5.Image, or a
	 *  p5.SoundFile (requires p5.sound). The second parameter is a filename
	 *  (including extension). The third parameter is for options specific
	 *  to this type of object. This method will save a file that fits the
	 *  given paramaters. For example:</p>
	 *
	 *  <pre class='language-javascript'><code>
	 *
	 *  save('myCanvas.jpg');           // Saves canvas as an image
	 *
	 *  var cnv = createCanvas(100, 100);
	 *  save(cnv, 'myCanvas.jpg');      // Saves canvas as an image
	 *
	 *  var gb = createGraphics(100, 100);
	 *  save(gb, 'myGraphics.jpg');      // Saves p5.Renderer object as an image
	 *
	 *  save(myTable, 'myTable.html');  // Saves table as html file
	 *  save(myTable, 'myTable.csv',);  // Comma Separated Values
	 *  save(myTable, 'myTable.tsv');   // Tab Separated Values
	 *
	 *  save(myJSON, 'my.json');        // Saves pretty JSON
	 *  save(myJSON, 'my.json', true);  // Optimizes JSON filesize
	 *
	 *  save(img, 'my.png');            // Saves pImage as a png image
	 *
	 *  save(arrayOfStrings, 'my.txt'); // Saves strings to a text file with line
	 *                                  // breaks after each item in the array
	 *  </code></pre>
	 *
	 *  @method save
	 *  @param  {[Object|String]} objectOrFilename  If filename is provided, will
	 *                                             save canvas as an image with
	 *                                             either png or jpg extension
	 *                                             depending on the filename.
	 *                                             If object is provided, will
	 *                                             save depending on the object
	 *                                             and filename (see examples
	 *                                             above).
	 *  @param  {[String]} filename If an object is provided as the first
	 *                               parameter, then the second parameter
	 *                               indicates the filename,
	 *                               and should include an appropriate
	 *                               file extension (see examples above).
	 *  @param  {[Boolean/String]} options  Additional options depend on
	 *                            filetype. For example, when saving JSON,
	 *                            <code>true</code> indicates that the
	 *                            output will be optimized for filesize,
	 *                            rather than readability.
	 */
	p5.prototype.save = function (object, _filename, _options) {
	  // parse the arguments and figure out which things we are saving
	  var args = arguments;
	  // =================================================
	  // OPTION 1: saveCanvas...
	
	  // if no arguments are provided, save canvas
	  var cnv = this._curElement.elt;
	  if (args.length === 0) {
	    p5.prototype.saveCanvas(cnv);
	    return;
	  }
	  // otherwise, parse the arguments
	
	  // if first param is a p5Graphics, then saveCanvas
	  else if (args[0] instanceof p5.Renderer ||
	    args[0] instanceof p5.Graphics) {
	    p5.prototype.saveCanvas(args[0].elt, args[1], args[2]);
	    return;
	  }
	
	  // if 1st param is String and only one arg, assume it is canvas filename
	  else if (args.length === 1 && typeof (args[0]) === 'string') {
	    p5.prototype.saveCanvas(cnv, args[0]);
	  }
	
	  // =================================================
	  // OPTION 2: extension clarifies saveStrings vs. saveJSON
	  else {
	    var extension = _checkFileExtension(args[1], args[2])[1];
	    switch (extension) {
	    case 'json':
	      p5.prototype.saveJSON(args[0], args[1], args[2]);
	      return;
	    case 'txt':
	      p5.prototype.saveStrings(args[0], args[1], args[2]);
	      return;
	      // =================================================
	      // OPTION 3: decide based on object...
	    default:
	      if (args[0] instanceof Array) {
	        p5.prototype.saveStrings(args[0], args[1], args[2]);
	      } else if (args[0] instanceof p5.Table) {
	        p5.prototype.saveTable(args[0], args[1], args[2], args[3]);
	      } else if (args[0] instanceof p5.Image) {
	        p5.prototype.saveCanvas(args[0].canvas, args[1]);
	      } else if (args[0] instanceof p5.SoundFile) {
	        p5.prototype.saveSound(args[0], args[1], args[2], args[3]);
	      }
	    }
	  }
	};
	
	/**
	 *  Writes the contents of an Array or a JSON object to a .json file.
	 *  The file saving process and location of the saved file will
	 *  vary between web browsers.
	 *
	 *  @method saveJSON
	 *  @param  {Array|Object} json
	 *  @param  {String} filename
	 *  @param  {Boolean} [optimize]   If true, removes line breaks
	 *                                 and spaces from the output
	 *                                 file to optimize filesize
	 *                                 (but not readability).
	 *  @example
	 *  <div><code>
	 *  var json;
	 *
	 *  function setup() {
	 *
	 *    json = {}; // new JSON Object
	 *
	 *    json.id = 0;
	 *    json.species = 'Panthera leo';
	 *    json.name = 'Lion';
	 *
	 *  // To save, un-comment the line below, then click 'run'
	 *  // saveJSONObject(json, 'lion.json');
	 *  }
	 *
	 *  // Saves the following to a file called "lion.json":
	 *  // {
	 *  //   "id": 0,
	 *  //   "species": "Panthera leo",
	 *  //   "name": "Lion"
	 *  // }
	 *  </div></code>
	 */
	p5.prototype.saveJSON = function (json, filename, opt) {
	  var stringify;
	  if (opt) {
	    stringify = JSON.stringify(json);
	  } else {
	    stringify = JSON.stringify(json, undefined, 2);
	  }
	  console.log(stringify);
	  this.saveStrings(stringify.split('\n'), filename, 'json');
	};
	
	p5.prototype.saveJSONObject = p5.prototype.saveJSON;
	p5.prototype.saveJSONArray = p5.prototype.saveJSON;
	
	p5.prototype.saveStream = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	/**
	 *  Writes an array of Strings to a text file, one line per String.
	 *  The file saving process and location of the saved file will
	 *  vary between web browsers.
	 *
	 *  @method saveStrings
	 *  @param  {Array} list      string array to be written
	 *  @param  {String} filename filename for output
	 *  @example
	 *  <div><code>
	 *  var words = 'apple bear cat dog';
	 *
	 *  // .split() outputs an Array
	 *  var list = split(words, ' ');
	 *
	 *  // To save the file, un-comment next line and click 'run'
	 *  // saveStrings(list, 'nouns.txt');
	 *
	 *  // Saves the following to a file called 'nouns.txt':
	 *  //
	 *  // apple
	 *  // bear
	 *  // cat
	 *  // dog
	 *  </code></div>
	 */
	p5.prototype.saveStrings = function (list, filename, extension) {
	  var ext = extension || 'txt';
	  var pWriter = this.createWriter(filename, ext);
	  for (var i = 0; i < list.length; i++) {
	    if (i < list.length - 1) {
	      pWriter.println(list[i]);
	    } else {
	      pWriter.print(list[i]);
	    }
	  }
	  pWriter.close();
	  pWriter.flush();
	};
	
	p5.prototype.saveXML = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	p5.prototype.selectOutput = function () {
	  // TODO
	  throw 'not yet implemented';
	
	};
	
	// =======
	// HELPERS
	// =======
	
	function escapeHelper(content) {
	  return content
	    .replace(/&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#039;');
	}
	
	/**
	 *  Writes the contents of a Table object to a file. Defaults to a
	 *  text file with comma-separated-values ('csv') but can also
	 *  use tab separation ('tsv'), or generate an HTML table ('html').
	 *  The file saving process and location of the saved file will
	 *  vary between web browsers.
	 *
	 *  @method saveTable
	 *  @param  {p5.Table} Table  the Table object to save to a file
	 *  @param  {String} filename the filename to which the Table should be saved
	 *  @param  {[String]} options  can be one of "tsv", "csv", or "html"
	 *  @example
	 *  <div><code>
	 *  var table;
	 *
	 *  function setup() {
	 *    table = new p5.Table();
	 *
	 *    table.addColumn('id');
	 *    table.addColumn('species');
	 *    table.addColumn('name');
	 *
	 *    var newRow = table.addRow();
	 *    newRow.setNum('id', table.getRowCount() - 1);
	 *    newRow.setString('species', 'Panthera leo');
	 *    newRow.setString('name', 'Lion');
	 *
	 *    // To save, un-comment next line then click 'run'
	 *    // saveTable(table, 'new.csv');
	 *    }
	 *
	 *    // Saves the following to a file called 'new.csv':
	 *    // id,species,name
	 *    // 0,Panthera leo,Lion
	 *  </code></div>
	 */
	p5.prototype.saveTable = function (table, filename, options) {
	  var pWriter = this.createWriter(filename, options);
	
	  var header = table.columns;
	
	  var sep = ','; // default to CSV
	  if (options === 'tsv') {
	    sep = '\t';
	  }
	  if (options !== 'html') {
	    // make header if it has values
	    if (header[0] !== '0') {
	      for (var h = 0; h < header.length; h++) {
	        if (h < header.length - 1) {
	          pWriter.print(header[h] + sep);
	        } else {
	          pWriter.println(header[h]);
	        }
	      }
	    }
	
	    // make rows
	    for (var i = 0; i < table.rows.length; i++) {
	      var j;
	      for (j = 0; j < table.rows[i].arr.length; j++) {
	        if (j < table.rows[i].arr.length - 1) {
	          pWriter.print(table.rows[i].arr[j] + sep);
	        } else if (i < table.rows.length - 1) {
	          pWriter.println(table.rows[i].arr[j]);
	        } else {
	          pWriter.print(table.rows[i].arr[j]); // no line break
	        }
	      }
	    }
	  }
	
	  // otherwise, make HTML
	  else {
	    pWriter.println('<html>');
	    pWriter.println('<head>');
	    var str = '  <meta http-equiv=\"content-type\" content';
	    str += '=\"text/html;charset=utf-8\" />';
	    pWriter.println(str);
	    pWriter.println('</head>');
	
	    pWriter.println('<body>');
	    pWriter.println('  <table>');
	
	    // make header if it has values
	    if (header[0] !== '0') {
	      pWriter.println('    <tr>');
	      for (var k = 0; k < header.length; k++) {
	        var e = escapeHelper(header[k]);
	        pWriter.println('      <td>' + e);
	        pWriter.println('      </td>');
	      }
	      pWriter.println('    </tr>');
	    }
	
	    // make rows
	    for (var row = 0; row < table.rows.length; row++) {
	      pWriter.println('    <tr>');
	      for (var col = 0; col < table.columns.length; col++) {
	        var entry = table.rows[row].getString(col);
	        var htmlEntry = escapeHelper(entry);
	        pWriter.println('      <td>' + htmlEntry);
	        pWriter.println('      </td>');
	      }
	      pWriter.println('    </tr>');
	    }
	    pWriter.println('  </table>');
	    pWriter.println('</body>');
	    pWriter.print('</html>');
	  }
	  // close and flush the pWriter
	  pWriter.close();
	  pWriter.flush();
	}; // end saveTable()
	
	/**
	 *  Generate a blob of file data as a url to prepare for download.
	 *  Accepts an array of data, a filename, and an extension (optional).
	 *  This is a private function because it does not do any formatting,
	 *  but it is used by saveStrings, saveJSON, saveTable etc.
	 *
	 *  @param  {Array} dataToDownload
	 *  @param  {String} filename
	 *  @param  {[String]} extension
	 *  @private
	 */
	p5.prototype.writeFile = function (dataToDownload, filename, extension) {
	  var type = 'application\/octet-stream';
	  if (p5.prototype._isSafari()) {
	    type = 'text\/plain';
	  }
	  var blob = new Blob(dataToDownload, {
	    'type': type
	  });
	  var href = window.URL.createObjectURL(blob);
	  p5.prototype.downloadFile(href, filename, extension);
	};
	
	/**
	 *  Forces download. Accepts a url to filedata/blob, a filename,
	 *  and an extension (optional).
	 *  This is a private function because it does not do any formatting,
	 *  but it is used by saveStrings, saveJSON, saveTable etc.
	 *
	 *  @param  {String} href      i.e. an href generated by createObjectURL
	 *  @param  {[String]} filename
	 *  @param  {[String]} extension
	 */
	p5.prototype.downloadFile = function (href, fName, extension) {
	  var fx = _checkFileExtension(fName, extension);
	  var filename = fx[0];
	  var ext = fx[1];
	
	  var a = document.createElement('a');
	  a.href = href;
	  a.download = filename;
	
	  // Firefox requires the link to be added to the DOM before click()
	  a.onclick = destroyClickedElement;
	  a.style.display = 'none';
	  document.body.appendChild(a);
	
	  // Safari will open this file in the same page as a confusing Blob.
	  if (p5.prototype._isSafari()) {
	    var aText = 'Hello, Safari user! To download this file...\n';
	    aText += '1. Go to File --> Save As.\n';
	    aText += '2. Choose "Page Source" as the Format.\n';
	    aText += '3. Name it with this extension: .\"' + ext + '\"';
	    alert(aText);
	  }
	  a.click();
	  href = null;
	};
	
	/**
	 *  Returns a file extension, or another string
	 *  if the provided parameter has no extension.
	 *
	 *  @param   {String} filename
	 *  @return  {Array} [fileName, fileExtension]
	 *
	 *  @private
	 */
	function _checkFileExtension(filename, extension) {
	  if (!extension || extension === true || extension === 'true') {
	    extension = '';
	  }
	  if (!filename) {
	    filename = 'untitled';
	  }
	  var ext = '';
	  // make sure the file will have a name, see if filename needs extension
	  if (filename && filename.indexOf('.') > -1) {
	    ext = filename.split('.').pop();
	  }
	  // append extension if it doesn't exist
	  if (extension) {
	    if (ext !== extension) {
	      ext = extension;
	      filename = filename + '.' + ext;
	    }
	  }
	  return [filename, ext];
	}
	p5.prototype._checkFileExtension = _checkFileExtension;
	
	/**
	 *  Returns true if the browser is Safari, false if not.
	 *  Safari makes trouble for downloading files.
	 *
	 *  @return  {Boolean} [description]
	 *  @private
	 */
	p5.prototype._isSafari = function () {
	  var x = Object.prototype.toString.call(window.HTMLElement);
	  return x.indexOf('Constructor') > 0;
	};
	
	/**
	 *  Helper function, a callback for download that deletes
	 *  an invisible anchor element from the DOM once the file
	 *  has been automatically downloaded.
	 *
	 *  @private
	 */
	function destroyClickedElement(event) {
	  document.body.removeChild(event.target);
	}
	
	module.exports = p5;
	
	},{"../core/core":48,"../core/error_helpers":51,"opentype.js":8,"reqwest":27}],71:[function(_dereq_,module,exports){
	/**
	 * @module IO
	 * @submodule Table
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	
	/**
	 *  Table Options
	 *  <p>Generic class for handling tabular data, typically from a
	 *  CSV, TSV, or other sort of spreadsheet file.</p>
	 *  <p>CSV files are
	 *  <a href="http://en.wikipedia.org/wiki/Comma-separated_values">
	 *  comma separated values</a>, often with the data in quotes. TSV
	 *  files use tabs as separators, and usually don't bother with the
	 *  quotes.</p>
	 *  <p>File names should end with .csv if they're comma separated.</p>
	 *  <p>A rough "spec" for CSV can be found
	 *  <a href="http://tools.ietf.org/html/rfc4180">here</a>.</p>
	 *  <p>To load files, use the loadTable method.</p>
	 *  <p>To save tables to your computer, use the save method
	 *   or the saveTable method.</p>
	 *
	 *  Possible options include:
	 *  <ul>
	 *  <li>csv - parse the table as comma-separated values
	 *  <li>tsv - parse the table as tab-separated values
	 *  <li>header - this table has a header (title) row
	 *  </ul>
	 */
	
	/**
	 *  Table objects store data with multiple rows and columns, much
	 *  like in a traditional spreadsheet. Tables can be generated from
	 *  scratch, dynamically, or using data from an existing file.
	 *
	 *  @class p5.Table
	 *  @constructor
	 *  @param  {Array}     [rows] An array of p5.TableRow objects
	 *  @return {p5.Table}         p5.Table generated
	 */
	p5.Table = function (rows) {
	  /**
	   *  @property columns
	   *  @type {Array}
	   */
	  this.columns = [];
	
	  /**
	   *  @property rows
	   *  @type {Array}
	   */
	  this.rows = [];
	};
	
	/**
	 *  Use addRow() to add a new row of data to a p5.Table object. By default,
	 *  an empty row is created. Typically, you would store a reference to
	 *  the new row in a TableRow object (see newRow in the example above),
	 *  and then set individual values using set().
	 *
	 *  If a p5.TableRow object is included as a parameter, then that row is
	 *  duplicated and added to the table.
	 *
	 *  @method  addRow
	 *  @param   {p5.TableRow} [row] row to be added to the table
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   //add a row
		*   var newRow = table.addRow();
		*   newRow.setString("id", table.getRowCount() - 1);
		*   newRow.setString("species", "Canis Lupus");
		*   newRow.setString("name", "Wolf");
		*
		*   //print the results
		*   for (var r = 0; r < table.getRowCount(); r++)
		*     for (var c = 0; c < table.getColumnCount(); c++)
		*       print(table.getString(r, c));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.addRow = function(row) {
	  // make sure it is a valid TableRow
	  var r = row || new p5.TableRow();
	
	  if (typeof(r.arr) === 'undefined' || typeof(r.obj) === 'undefined') {
	    //r = new p5.prototype.TableRow(r);
	    throw 'invalid TableRow: ' + r;
	  }
	  r.table = this;
	  this.rows.push(r);
	  return r;
	};
	
	/**
	 * Removes a row from the table object.
	 *
	 * @method  removeRow
	 * @param   {Number} id ID number of the row to remove
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   //remove the first row
		*   var r = table.removeRow(0);
		*
		*   //print the results
		*   for (var r = 0; r < table.getRowCount(); r++)
		*     for (var c = 0; c < table.getColumnCount(); c++)
		*       print(table.getString(r, c));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.removeRow = function(id) {
	  this.rows[id].table = null; // remove reference to table
	  var chunk = this.rows.splice(id+1, this.rows.length);
	  this.rows.pop();
	  this.rows = this.rows.concat(chunk);
	};
	
	
	/**
	 * Returns a reference to the specified p5.TableRow. The reference
	 * can then be used to get and set values of the selected row.
	 *
	 * @method  getRow
	 * @param  {Number}   rowID ID number of the row to get
	 * @return {TableRow} p5.TableRow object
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   var row = table.getRow(1);
		*   //print it column by column
		*   //note: a row is an object, not an array
		*   for (var c = 0; c < table.getColumnCount(); c++)
		*     print(row.getString(c));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.getRow = function(r) {
	  return this.rows[r];
	};
	
	/**
	 *  Gets all rows from the table. Returns an array of p5.TableRows.
	 *
	 *  @method  getRows
	 *  @return {Array}   Array of p5.TableRows
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   var rows = table.getRows();
		*
		*   //warning: rows is an array of objects
		*   for (var r = 0; r < rows.length; r++)
		*     rows[r].set("name", "Unicorn");
		*
		*   //print the results
		*   for (var r = 0; r < table.getRowCount(); r++)
		*     for (var c = 0; c < table.getColumnCount(); c++)
		*       print(table.getString(r, c));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.getRows = function() {
	  return this.rows;
	};
	
	/**
	 *  Finds the first row in the Table that contains the value
	 *  provided, and returns a reference to that row. Even if
	 *  multiple rows are possible matches, only the first matching
	 *  row is returned. The column to search may be specified by
	 *  either its ID or title.
	 *
	 *  @method  findRow
	 *  @param  {String} value  The value to match
	 *  @param  {Number|String} column ID number or title of the
	 *                                 column to search
	 *  @return {TableRow}
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   //find the animal named zebra
		*   var row = table.findRow("Zebra", "name");
		*   //find the corresponding species
		*   print(row.getString("species"));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.findRow = function(value, column) {
	  // try the Object
	  if (typeof(column) === 'string') {
	    for (var i = 0; i < this.rows.length; i++){
	      if (this.rows[i].obj[column] === value) {
	        return this.rows[i];
	      }
	    }
	  }
	  // try the Array
	  else {
	    for (var j = 0; j < this.rows.length; j++){
	      if (this.rows[j].arr[column] === value) {
	        return this.rows[j];
	      }
	    }
	  }
	  // otherwise...
	  return null;
	};
	
	/**
	 *  Finds the rows in the Table that contain the value
	 *  provided, and returns references to those rows. Returns an
	 *  Array, so for must be used to iterate through all the rows,
	 *  as shown in the example above. The column to search may be
	 *  specified by either its ID or title.
	 *
	 *  @method  findRows
	 *  @param  {String} value  The value to match
	 *  @param  {Number|String} column ID number or title of the
	 *                                 column to search
	 *  @return {Array}        An Array of TableRow objects
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   //add another goat
		*   var newRow = table.addRow();
		*   newRow.setString("id", table.getRowCount() - 1);
		*   newRow.setString("species", "Scape Goat");
		*   newRow.setString("name", "Goat");
		*
		*   //find the rows containing animals named Goat
		*   var rows = table.findRows("Goat", "name");
		*   print(rows.length + " Goats found");
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.findRows = function(value, column) {
	  var ret = [];
	  if (typeof(column) === 'string') {
	    for (var i = 0; i < this.rows.length; i++){
	      if (this.rows[i].obj[column] === value) {
	        ret.push( this.rows[i] );
	      }
	    }
	  }
	  // try the Array
	  else {
	    for (var j = 0; j < this.rows.length; j++){
	      if (this.rows[j].arr[column] === value) {
	        ret.push( this.rows[j] );
	      }
	    }
	  }
	  return ret;
	};
	
	/**
	 *  Finds the first row in the Table that matches the regular
	 *  expression provided, and returns a reference to that row.
	 *  Even if multiple rows are possible matches, only the first
	 *  matching row is returned. The column to search may be
	 *  specified by either its ID or title.
	 *
	 *  @method  matchRow
	 *  @param  {String} regexp The regular expression to match
	 *  @param  {String|Number} column The column ID (number) or
	 *                                   title (string)
	 *  @return {TableRow}        TableRow object
	 */
	p5.Table.prototype.matchRow = function(regexp, column) {
	  if (typeof(column) === 'number') {
	    for (var j = 0; j < this.rows.length; j++) {
	      if ( this.rows[j].arr[column].match(regexp) ) {
	        return this.rows[j];
	      }
	    }
	  }
	
	  else {
	    for (var i = 0; i < this.rows.length; i++) {
	      if ( this.rows[i].obj[column].match(regexp) ) {
	        return this.rows[i];
	      }
	    }
	  }
	  return null;
	};
	
	/**
	 *  Finds the first row in the Table that matches the regular
	 *  expression provided, and returns a reference to that row.
	 *  Even if multiple rows are possible matches, only the first
	 *  matching row is returned. The column to search may be specified
	 *  by either its ID or title.
	 *
	 *  @method  matchRows
	 *  @param  {String} regexp The regular expression to match
	 *  @param  {String|Number} [column] The column ID (number) or
	 *                                   title (string)
	 *  @return {Array}        An Array of TableRow objects
	 */
	p5.Table.prototype.matchRows = function(regexp, column) {
	  var ret = [];
	  if (typeof(column) === 'number') {
	    for (var j = 0; j < this.rows.length; j++) {
	      if ( this.rows[j].arr[column].match(regexp) ) {
	        ret.push( this.rows[j] );
	      }
	    }
	  }
	
	  else {
	    for (var i = 0; i < this.rows.length; i++) {
	      if ( this.rows[i].obj[column].match(regexp) ) {
	        ret.push( this.rows[i] );
	      }
	    }
	  }
	  return ret;
	};
	
	
	/**
	 *  Retrieves all values in the specified column, and returns them
	 *  as an array. The column may be specified by either its ID or title.
	 *
	 *  @method  getColumn
	 *  @param  {String|Number} column String or Number of the column to return
	 *  @return {Array}       Array of column values
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   //getColumn returns an array that can be printed directly
		*   print(table.getColumn("species"));
		*   //outputs ["Capra hircus", "Panthera pardus", "Equus zebra"]
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.getColumn = function(value) {
	  var ret = [];
	  if (typeof(value) === 'string'){
	    for (var i = 0; i < this.rows.length; i++){
	      ret.push (this.rows[i].obj[value]);
	    }
	  } else {
	    for (var j = 0; j < this.rows.length; j++){
	      ret.push (this.rows[j].arr[value]);
	    }
	  }
	  return ret;
	};
	
	/**
	 *  Removes all rows from a Table. While all rows are removed,
	 *  columns and column titles are maintained.
	 *
	 *  @method  clearRows
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   table.clearRows();
		*   print(table.getRowCount() + " total rows in table");
		*   print(table.getColumnCount() + " total columns in table");
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.clearRows = function() {
	  delete this.rows;
	  this.rows = [];
	};
	
	/**
	 *  Use addColumn() to add a new column to a Table object.
	 *  Typically, you will want to specify a title, so the column
	 *  may be easily referenced later by name. (If no title is
	 *  specified, the new column's title will be null.)
	 *
	 *  @method  addColumn
	 *  @param {String} [title] title of the given column
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   table.addColumn("carnivore");
		*   table.set(0, "carnivore", "no");
		*   table.set(1, "carnivore", "yes");
		*   table.set(2, "carnivore", "no");
		*
		*   //print the results
		*   for (var r = 0; r < table.getRowCount(); r++)
		*     for (var c = 0; c < table.getColumnCount(); c++)
		*       print(table.getString(r, c));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.addColumn = function(title) {
	  var t = title || null;
	  this.columns.push(t);
	};
	
	/**
	 *  Returns the total number of columns in a Table.
	 *
	 *  @return {Number} Number of columns in this table
	 */
	p5.Table.prototype.getColumnCount = function() {
	  return this.columns.length;
	};
	
	/**
	 *  Returns the total number of rows in a Table.
	 *
	 *  @method  getRowCount
	 *  @return {Number} Number of rows in this table
	
	 */
	p5.Table.prototype.getRowCount = function() {
	  return this.rows.length;
	};
	
	/**
	 *  <p>Removes any of the specified characters (or "tokens").</p>
	 *
	 *  <p>If no column is specified, then the values in all columns and
	 *  rows are processed. A specific column may be referenced by
	 *  either its ID or title.</p>
	 *
	 *  @method  removeTokens
	 *  @param  {String} chars  String listing characters to be removed
	 *  @param  {String|Number} [column] Column ID (number)
	 *                                   or name (string)
	 */
	p5.Table.prototype.removeTokens = function(chars, column) {
	  var escape= function(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	  };
	  var charArray = [];
	  for (var i = 0; i < chars.length; i++) {
	    charArray.push( escape( chars.charAt(i) ) );
	  }
	  var regex = new RegExp(charArray.join('|'), 'g');
	
	  if (typeof(column) === 'undefined'){
	    for (var c = 0; c < this.columns.length; c++) {
	      for (var d = 0; d < this.rows.length; d++) {
	        var s = this.rows[d].arr[c];
	        s = s.replace(regex, '');
	        this.rows[d].arr[c] = s;
	        this.rows[d].obj[this.columns[c]] = s;
	      }
	    }
	  }
	  else if (typeof(column) === 'string'){
	    for (var j = 0; j < this.rows.length; j++) {
	      var val = this.rows[j].obj[column];
	      val = val.replace(regex, '');
	      this.rows[j].obj[column] = val;
	      var pos = this.columns.indexOf(column);
	      this.rows[j].arr[pos] = val;
	    }
	  }
	  else {
	    for (var k = 0; k < this.rows.length; k++) {
	      var str = this.rows[k].arr[column];
	      str = str.replace(regex, '');
	      this.rows[k].arr[column] = str;
	      this.rows[k].obj[this.columns[column]] = str;
	    }
	  }
	};
	
	/**
	 *  Trims leading and trailing whitespace, such as spaces and tabs,
	 *  from String table values. If no column is specified, then the
	 *  values in all columns and rows are trimmed. A specific column
	 *  may be referenced by either its ID or title.
	 *
	 *  @method  trim
	 *  @param  {String|Number} column Column ID (number)
	 *                                   or name (string)
	 */
	p5.Table.prototype.trim = function(column) {
	  var regex = new RegExp( (' '), 'g');
	
	  if (typeof(column) === 'undefined'){
	    for (var c = 0; c < this.columns.length; c++) {
	      for (var d = 0; d < this.rows.length; d++) {
	        var s = this.rows[d].arr[c];
	        s = s.replace(regex, '');
	        this.rows[d].arr[c] = s;
	        this.rows[d].obj[this.columns[c]] = s;
	      }
	    }
	  }
	  else if (typeof(column) === 'string'){
	    for (var j = 0; j < this.rows.length; j++) {
	      var val = this.rows[j].obj[column];
	      val = val.replace(regex, '');
	      this.rows[j].obj[column] = val;
	      var pos = this.columns.indexOf(column);
	      this.rows[j].arr[pos] = val;
	    }
	  }
	  else {
	    for (var k = 0; k < this.rows.length; k++) {
	      var str = this.rows[k].arr[column];
	      str = str.replace(regex, '');
	      this.rows[k].arr[column] = str;
	      this.rows[k].obj[this.columns[column]] = str;
	    }
	  }
	};
	
	/**
	 *  Use removeColumn() to remove an existing column from a Table
	 *  object. The column to be removed may be identified by either
	 *  its title (a String) or its index value (an int).
	 *  removeColumn(0) would remove the first column, removeColumn(1)
	 *  would remove the second column, and so on.
	 *
	 *  @method  removeColumn
	 *  @param  {String|Number} column columnName (string) or ID (number)
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   table.removeColumn("id");
		*   print(table.getColumnCount());
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.removeColumn = function(c) {
	  var cString;
	  var cNumber;
	  if (typeof(c) === 'string') {
	    // find the position of c in the columns
	    cString = c;
	    cNumber = this.columns.indexOf(c);
	    console.log('string');
	  }
	  else{
	    cNumber = c;
	    cString = this.columns[c];
	  }
	
	  var chunk = this.columns.splice(cNumber+1, this.columns.length);
	  this.columns.pop();
	  this.columns = this.columns.concat(chunk);
	
	  for (var i = 0; i < this.rows.length; i++){
	    var tempR = this.rows[i].arr;
	    var chip = tempR.splice(cNumber+1, tempR.length);
	    tempR.pop();
	    this.rows[i].arr = tempR.concat(chip);
	    delete this.rows[i].obj[cString];
	  }
	
	};
	
	
	/**
	 * Stores a value in the Table's specified row and column.
	 * The row is specified by its ID, while the column may be specified
	 * by either its ID or title.
	 *
	 * @method  set
	 * @param {String|Number} column column ID (Number)
	 *                               or title (String)
	 * @param {String|Number} value  value to assign
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   table.set(0, "species", "Canis Lupus");
		*   table.set(0, "name", "Wolf");
		*
		*   //print the results
		*   for (var r = 0; r < table.getRowCount(); r++)
		*     for (var c = 0; c < table.getColumnCount(); c++)
		*       print(table.getString(r, c));
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.set = function(row, column, value) {
	  this.rows[row].set(column, value);
	};
	
	/**
	 * Stores a Float value in the Table's specified row and column.
	 * The row is specified by its ID, while the column may be specified
	 * by either its ID or title.
	 *
	 * @method setNum
	 * @param {Number} row row ID
	 * @param {String|Number} column column ID (Number)
	 *                               or title (String)
	 * @param {Number} value  value to assign
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   table.setNum(1, "id", 1);
		*
		*   print(table.getColumn(0));
		*   //["0", 1, "2"]
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.setNum = function(row, column, value){
	  this.rows[row].setNum(column, value);
	};
	
	
	/**
	 * Stores a String value in the Table's specified row and column.
	 * The row is specified by its ID, while the column may be specified
	 * by either its ID or title.
	 *
	 * @method  setString
	 * @param {Number} row row ID
	 * @param {String|Number} column column ID (Number)
	 *                               or title (String)
	 * @param {String} value  value to assign
	 */
	p5.Table.prototype.setString = function(row, column, value){
	  this.rows[row].setString(column, value);
	};
	
	/**
	 * Retrieves a value from the Table's specified row and column.
	 * The row is specified by its ID, while the column may be specified by
	 * either its ID or title.
	 *
	 * @method  get
	 * @param {Number} row row ID
	 * @param  {String|Number} column columnName (string) or
	 *                                   ID (number)
	 * @return {String|Number}
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   print(table.get(0, 1));
		*   //Capra hircus
		*   print(table.get(0, "species"));
		*   //Capra hircus
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.get = function(row, column) {
	  return this.rows[row].get(column);
	};
	
	/**
	 * Retrieves a Float value from the Table's specified row and column.
	 * The row is specified by its ID, while the column may be specified by
	 * either its ID or title.
	 *
	 * @method  getNum
	 * @param {Number} row row ID
	 * @param  {String|Number} column columnName (string) or
	 *                                   ID (number)
	 * @return {Number}
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   print(table.getNum(1, 0) + 100);
		*   //id 1 + 100 = 101
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.getNum = function(row, column) {
	  return this.rows[row].getNum(column);
	};
	
	/**
	 * Retrieves a String value from the Table's specified row and column.
	 * The row is specified by its ID, while the column may be specified by
	 * either its ID or title.
	 *
	 * @method  getString
	 * @param {Number} row row ID
	 * @param  {String|Number} column columnName (string) or
	 *                                   ID (number)
	 * @return {String}
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   var tableArray = table.getArray();
		*
		*   //output each row as array
		*   for (var i = 0; i < tableArray.length; i++)
		*     print(tableArray[i]);
		* }
		* </code>
		* </div>
	 */
	p5.Table.prototype.getString = function(row, column) {
	  return this.rows[row].getString(column);
	};
	
	/**
	 * Retrieves all table data and returns as an object. If a column name is
	 * passed in, each row object will be stored with that attribute as its
	 * title.
	 *
	 * @method  getObject
	 * @param {String} headerColumn Name of the column which should be used to
	 *                              title each row object (optional)
	 * @return {Object}
	 *
	 * @example
		* <div class="norender">
		* <code>
		* // Given the CSV file "mammals.csv"
		* // in the project's "assets" folder:
		* //
		* // id,species,name
		* // 0,Capra hircus,Goat
		* // 1,Panthera pardus,Leopard
		* // 2,Equus zebra,Zebra
		*
		* var table;
		*
		* function preload() {
		*   //my table is comma separated value "csv"
		*   //and has a header specifying the columns labels
		*   table = loadTable("assets/mammals.csv", "csv", "header");
		* }
		*
		* function setup() {
		*   var tableObject = table.getObject();
		*
		*   print(tableObject);
		*   //outputs an object
		* }
		* </code>
		* </div>
	
	 */
	p5.Table.prototype.getObject = function (headerColumn) {
	  var tableObject = {};
	  var obj, cPos, index;
	
	  for(var i = 0; i < this.rows.length; i++) {
	    obj = this.rows[i].obj;
	
	    if (typeof(headerColumn) === 'string'){
	      cPos = this.columns.indexOf(headerColumn); // index of columnID
	      if (cPos >= 0) {
	        index = obj[headerColumn];
	        tableObject[index] = obj;
	      } else {
	        throw 'This table has no column named "' + headerColumn +'"';
	      }
	    } else {
	      tableObject[i] = this.rows[i].obj;
	    }
	  }
	  return tableObject;
	};
	
	/**
	 * Retrieves all table data and returns it as a multidimensional array.
	 *
	 * @method  getArray
	 * @return {Array}
	 */
	p5.Table.prototype.getArray = function () {
	  var tableArray = [];
	  for(var i = 0; i < this.rows.length; i++) {
	    tableArray.push(this.rows[i].arr);
	  }
	  return tableArray;
	};
	
	module.exports = p5.Table;
	
	},{"../core/core":48}],72:[function(_dereq_,module,exports){
	/**
	 * @module IO
	 * @submodule Table
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 *  A TableRow object represents a single row of data values,
	 *  stored in columns, from a table.
	 *
	 *  A Table Row contains both an ordered array, and an unordered
	 *  JSON object.
	 *
	 *  @class p5.TableRow
	 *  @constructor
	 *  @param {String} [str]       optional: populate the row with a
	 *                              string of values, separated by the
	 *                              separator
	 *  @param {String} [separator] comma separated values (csv) by default
	 */
	p5.TableRow = function (str, separator) {
	  var arr = [];
	  var obj = {};
	  if (str){
	    separator = separator || ',';
	    arr = str.split(separator);
	  }
	  for (var i = 0; i < arr.length; i++){
	    var key = i;
	    var val = arr[i];
	    obj[key] = val;
	  }
	  this.arr = arr;
	  this.obj = obj;
	  this.table = null;
	};
	
	/**
	 *  Stores a value in the TableRow's specified column.
	 *  The column may be specified by either its ID or title.
	 *
	 *  @method  set
	 *  @param {String|Number} column Column ID (Number)
	 *                                or Title (String)
	 *  @param {String|Number} value  The value to be stored
	 */
	p5.TableRow.prototype.set = function(column, value) {
	  // if typeof column is string, use .obj
	  if (typeof(column) === 'string'){
	    var cPos = this.table.columns.indexOf(column); // index of columnID
	    if (cPos >= 0) {
	      this.obj[column] = value;
	      this.arr[cPos] = value;
	    }
	    else {
	      throw 'This table has no column named "' + column +'"';
	    }
	  }
	
	  // if typeof column is number, use .arr
	  else {
	    if (column < this.table.columns.length) {
	      this.arr[column] = value;
	      var cTitle = this.table.columns[column];
	      this.obj[cTitle] = value;
	    }
	    else {
	      throw 'Column #' + column + ' is out of the range of this table';
	    }
	  }
	};
	
	
	/**
	 *  Stores a Float value in the TableRow's specified column.
	 *  The column may be specified by either its ID or title.
	 *
	 *  @method  setNum
	 *  @param {String|Number} column Column ID (Number)
	 *                                or Title (String)
	 *  @param {Number} value  The value to be stored
	 *                                as a Float
	 */
	p5.TableRow.prototype.setNum = function(column, value){
	  var floatVal = parseFloat(value, 10);
	  this.set(column, floatVal);
	};
	
	
	/**
	 *  Stores a String value in the TableRow's specified column.
	 *  The column may be specified by either its ID or title.
	 *
	 *  @method  setString
	 *  @param {String|Number} column Column ID (Number)
	 *                                or Title (String)
	 *  @param {String} value  The value to be stored
	 *                                as a String
	 */
	p5.TableRow.prototype.setString = function(column, value){
	  var stringVal = value.toString();
	  this.set(column, stringVal);
	};
	
	/**
	 *  Retrieves a value from the TableRow's specified column.
	 *  The column may be specified by either its ID or title.
	 *
	 *  @method  get
	 *  @param  {String|Number} column columnName (string) or
	 *                                   ID (number)
	 *  @return {String|Number}
	 */
	p5.TableRow.prototype.get = function(column) {
	  if (typeof(column) === 'string'){
	    return this.obj[column];
	  } else {
	    return this.arr[column];
	  }
	};
	
	/**
	 *  Retrieves a Float value from the TableRow's specified
	 *  column. The column may be specified by either its ID or
	 *  title.
	 *
	 *  @method  getNum
	 *  @param  {String|Number} column columnName (string) or
	 *                                   ID (number)
	 *  @return {Number}  Float Floating point number
	 */
	p5.TableRow.prototype.getNum = function(column) {
	  var ret;
	  if (typeof(column) === 'string'){
	    ret = parseFloat(this.obj[column], 10);
	  } else {
	    ret = parseFloat(this.arr[column], 10);
	  }
	
	  if (ret.toString() === 'NaN') {
	    throw 'Error: ' + this.obj[column]+ ' is NaN (Not a Number)';
	  }
	  return ret;
	};
	
	/**
	 *  Retrieves an String value from the TableRow's specified
	 *  column. The column may be specified by either its ID or
	 *  title.
	 *
	 *  @method  getString
	 *  @param  {String|Number} column columnName (string) or
	 *                                   ID (number)
	 *  @return {String}  String
	 */
	p5.TableRow.prototype.getString = function(column) {
	  if (typeof(column) === 'string'){
	    return this.obj[column].toString();
	  } else {
	    return this.arr[column].toString();
	  }
	};
	
	module.exports = p5.TableRow;
	
	},{"../core/core":48}],73:[function(_dereq_,module,exports){
	/**
	 * @module Math
	 * @submodule Calculation
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Calculates the absolute value (magnitude) of a number. Maps to Math.abs().
	 * The absolute value of a number is always positive.
	 *
	 * @method abs
	 * @param  {Number} n number to compute
	 * @return {Number}   absolute value of given number
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var x = -3;
	 *   var y = abs(x);
	 *
	 *   print(x); // -3
	 *   print(y); // 3
	 * }
	 * </code></div>
	 */
	p5.prototype.abs = Math.abs;
	
	/**
	 * Calculates the closest int value that is greater than or equal to the
	 * value of the parameter. Maps to Math.ceil(). For example, ceil(9.03)
	 * returns the value 10.
	 *
	 * @method ceil
	 * @param  {Number} n number to round up
	 * @return {Number}   rounded up number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   // map, mouseX between 0 and 5.
	 *   var ax = map(mouseX, 0, 100, 0, 5);
	 *   var ay = 66;
	 *
	 *   //Get the ceiling of the mapped number.
	 *   var bx = ceil(map(mouseX, 0, 100, 0,5));
	 *   var by = 33;
	 *
	 *   // Multiply the mapped numbers by 20 to more easily
	 *   // see the changes.
	 *   stroke(0);
	 *   fill(0);
	 *   line(0, ay, ax * 20, ay);
	 *   line(0, by, bx * 20, by);
	 *
	 *   // Reformat the float returned by map and draw it.
	 *   noStroke();
	 *   text(nfc(ax, 2,2), ax, ay - 5);
	 *   text(nfc(bx,1,1), bx, by - 5);
	 * }
	 * </code></div>
	 */
	p5.prototype.ceil = Math.ceil;
	
	/**
	 * Constrains a value between a minimum and maximum value.
	 *
	 * @method constrain
	 * @param  {Number} n    number to constrain
	 * @param  {Number} low  minimum limit
	 * @param  {Number} high maximum limit
	 * @return {Number}      constrained number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *
	 *   var leftWall = 25;
	 *   var rightWall = 75;
	 *
	 *   // xm is just the mouseX, while
	 *   // xc is the mouseX, but constrained
	 *   // between the leftWall and rightWall!
	 *   var xm = mouseX;
	 *   var xc = constrain(mouseX, leftWall, rightWall);
	 *
	 *   // Draw the walls.
	 *   stroke(150);
	 *   line(leftWall, 0, leftWall, height);
	 *   line(rightWall, 0, rightWall, height);
	 *
	 *   // Draw xm and xc as circles.
	 *   noStroke();
	 *   fill(150);
	 *   ellipse(xm, 33, 9,9); // Not Constrained
	 *   fill(0);
	 *   ellipse(xc, 66, 9,9); // Constrained
	 * }
	 * </code></div>
	 */
	p5.prototype.constrain = function(n, low, high) {
	  return Math.max(Math.min(n, high), low);
	};
	
	/**
	 * Calculates the distance between two points.
	 *
	 * @method dist
	 * @param  {Number} x1 x-coordinate of the first point
	 * @param  {Number} y1 y-coordinate of the first point
	 * @param  {Number} [z1] z-coordinate of the first point
	 * @param  {Number} x2 x-coordinate of the second point
	 * @param  {Number} y2 y-coordinate of the second point
	 * @param  {Number} [z2] z-coordinate of the second point
	 * @return {Number}    distance between the two points
	 * @example
	 * <div><code>
	 * // Move your mouse inside the canvas to see the
	 * // change in distance between two points!
	 * function draw() {
	 *   background(200);
	 *   fill(0);
	 *
	 *   var x1 = 10;
	 *   var y1 = 90;
	 *   var x2 = mouseX;
	 *   var y2 = mouseY;
	 *
	 *   line(x1, y1, x2, y2);
	 *   ellipse(x1, y1, 7, 7);
	 *   ellipse(x2, y2, 7, 7);
	 *
	 *   // d is the length of the line
	 *   // the distance from point 1 to point 2.
	 *   var d = int(dist(x1, y1, x2, y2));
	 *
	 *   // Let's write d along the line we are drawing!
	 *   push();
	 *   translate( (x1+x2)/2, (y1+y2)/2 );
	 *   rotate( atan2(y2-y1,x2-x1) );
	 *   text(nfc(d,1,1), 0, -5);
	 *   pop();
	 *   // Fancy!
	 * }
	 * </code></div>
	 */
	p5.prototype.dist = function(x1, y1, z1, x2, y2, z2) {
	  if (arguments.length === 4) {
	    // In the case of 2d: z1 means x2 and x2 means y2
	    return Math.sqrt( (z1-x1)*(z1-x1) + (x2-y1)*(x2-y1) );
	  } else if (arguments.length === 6) {
	    return Math.sqrt( (x2-x1)*(x2-x1) + (y2-y1)*(y2-y1) + (z2-z1)*(z2-z1) );
	  }
	};
	
	/**
	 * Returns Euler's number e (2.71828...) raised to the power of the n
	 * parameter. Maps to Math.exp().
	 *
	 * @method exp
	 * @param  {Number} n exponent to raise
	 * @return {Number}   e^n
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *
	 *   // Compute the exp() function with a value between 0 and 2
	 *   var xValue = map(mouseX, 0, width, 0, 2);
	 *   var yValue = exp(xValue);
	 *
	 *   var y = map(yValue, 0, 8, height, 0);
	 *
	 *   var legend = "exp (" + nfc(xValue, 3) +")\n= " + nf(yValue, 1, 4);
	 *   stroke(150);
	 *   line(mouseX, y, mouseX, height);
	 *   fill(0);
	 *   text(legend, 5, 15);
	 *   noStroke();
	 *   ellipse (mouseX,y, 7, 7);
	 *
	 *   // Draw the exp(x) curve,
	 *   // over the domain of x from 0 to 2
	 *   noFill();
	 *   stroke(0);
	 *   beginShape();
	 *   for (var x = 0; x < width; x++) {
	 *     xValue = map(x, 0, width, 0, 2);
	 *     yValue = exp(xValue);
	 *     y = map(yValue, 0, 8, height, 0);
	 *     vertex(x, y);
	 *   }
	 *
	 *   endShape();
	 *   line(0, 0, 0, height);
	 *   line(0, height-1, width, height-1);
	 * }
	 * </code></div>
	 */
	p5.prototype.exp = Math.exp;
	
	/**
	 * Calculates the closest int value that is less than or equal to the
	 * value of the parameter. Maps to Math.floor().
	 *
	 * @method floor
	 * @param  {Number} n number to round down
	 * @return {Number}   rounded down number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   //map, mouseX between 0 and 5.
	 *   var ax = map(mouseX, 0, 100, 0, 5);
	 *   var ay = 66;
	 *
	 *   //Get the floor of the mapped number.
	 *   var bx = floor(map(mouseX, 0, 100, 0,5));
	 *   var by = 33;
	 *
	 *   // Multiply the mapped numbers by 20 to more easily
	 *   // see the changes.
	 *   stroke(0);
	 *   fill(0);
	 *   line(0, ay, ax * 20, ay);
	 *   line(0, by, bx * 20, by);
	 *
	 *   // Reformat the float returned by map and draw it.
	 *   noStroke();
	 *   text(nfc(ax, 2,2), ax, ay - 5);
	 *   text(nfc(bx,1,1), bx, by - 5);
	 * }
	 * </code></div>
	 */
	p5.prototype.floor = Math.floor;
	
	/**
	 * Calculates a number between two numbers at a specific increment. The amt
	 * parameter is the amount to interpolate between the two values where 0.0
	 * equal to the first point, 0.1 is very near the first point, 0.5 is
	 * half-way in between, etc. The lerp function is convenient for creating
	 * motion along a straight path and for drawing dotted lines.
	 *
	 * @method lerp
	 * @param  {Number} start first value
	 * @param  {Number} stop  second value
	 * @param  {Number} amt   number between 0.0 and 1.0
	 * @return {Number}       lerped value
	 * @example
	 * <div><code>
	 * function setup() {
	 *   background(200);
	 *   var a = 20;
	 *   var b = 80;
	 *   var c = lerp(a,b, .2);
	 *   var d = lerp(a,b, .5);
	 *   var e = lerp(a,b, .8);
	 *
	 *   var y = 50
	 *
	 *   strokeWeight(5);
	 *   stroke(0); // Draw the original points in black
	 *   point(a, y);
	 *   point(b, y);
	 *
	 *   stroke(100); // Draw the lerp points in gray
	 *   point(c, y);
	 *   point(d, y);
	 *   point(e, y);
	 * }
	 * </code></div>
	 */
	p5.prototype.lerp = function(start, stop, amt) {
	  return amt*(stop-start)+start;
	};
	
	/**
	 * Calculates the natural logarithm (the base-e logarithm) of a number. This
	 * function expects the n parameter to be a value greater than 0.0. Maps to
	 * Math.log().
	 *
	 * @method log
	 * @param  {Number} n number greater than 0
	 * @return {Number}   natural logarithm of n
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   var maxX = 2.8;
	 *   var maxY = 1.5;
	 *
	 *   // Compute the natural log of a value between 0 and maxX
	 *   var xValue = map(mouseX, 0, width, 0, maxX);
	 *   if (xValue > 0) { // Cannot take the log of a negative number.
	 *     var yValue = log(xValue);
	 *     var y = map(yValue, -maxY, maxY, height, 0);
	 *
	 *     // Display the calculation occurring.
	 *     var legend = "log(" + nf(xValue, 1, 2) + ")\n= " + nf(yValue, 1, 3);
	 *     stroke(150);
	 *     line(mouseX, y, mouseX, height);
	 *     fill(0);
	 *     text (legend, 5, 15);
	 *     noStroke();
	 *     ellipse (mouseX, y, 7, 7);
	 *   }
	 *
	 *   // Draw the log(x) curve,
	 *   // over the domain of x from 0 to maxX
	 *   noFill();
	 *   stroke(0);
	 *   beginShape();
	 *   for(var x=0; x < width; x++) {
	 *     xValue = map(x, 0, width, 0, maxX);
	 *     yValue = log(xValue);
	 *     y = map(yValue, -maxY, maxY, height, 0);
	 *     vertex(x, y);
	 *   }
	 *   endShape();
	 *   line(0,0,0,height);
	 *   line(0,height/2,width, height/2);
	 * }
	 * </code></div>
	 */
	p5.prototype.log = Math.log;
	
	/**
	 * Calculates the magnitude (or length) of a vector. A vector is a direction
	 * in space commonly used in computer graphics and linear algebra. Because it
	 * has no "start" position, the magnitude of a vector can be thought of as
	 * the distance from the coordinate 0,0 to its x,y value. Therefore, mag() is
	 * a shortcut for writing dist(0, 0, x, y).
	 *
	 * @method mag
	 * @param  {Number} a first value
	 * @param  {Number} b second value
	 * @return {Number}   magnitude of vector from (0,0) to (a,b)
	 * @example
	 * <div><code>
	 * function setup() {
	 *   var x1 = 20;
	 *   var x2 = 80;
	 *   var y1 = 30;
	 *   var y2 = 70;
	 *
	 *   line(0, 0, x1, y1);
	 *   print(mag(x1, y1));  // Prints "36.05551"
	 *   line(0, 0, x2, y1);
	 *   print(mag(x2, y1));  // Prints "85.44004"
	 *   line(0, 0, x1, y2);
	 *   print(mag(x1, y2));  // Prints "72.8011"
	 *   line(0, 0, x2, y2);
	 *   print(mag(x2, y2));  // Prints "106.30146"
	 * }
	 * </code></div>
	 */
	p5.prototype.mag = function(x, y) {
	  return Math.sqrt(x*x+y*y);
	};
	
	/**
	 * Re-maps a number from one range to another.
	 * <br><br>
	 * In the first example above, the number 25 is converted from a value in the
	 * range of 0 to 100 into a value that ranges from the left edge of the
	 * window (0) to the right edge (width).
	 *
	 * @method map
	 * @param  {Number} value  the incoming value to be converted
	 * @param  {Number} start1 lower bound of the value's current range
	 * @param  {Number} stop1  upper bound of the value's current range
	 * @param  {Number} start2 lower bound of the value's target range
	 * @param  {Number} stop   upper bound of the value's target range
	 * @return {Number}        remapped number
	 * @example
	 *   <div><code>
	 *     var value = 25;
	 *     var m = map(value, 0, 100, 0, width);
	 *     ellipse(m, 50, 10, 10);
	 *   </code></div>
	 *
	 *   <div><code>
	 *     function setup() {
	 *       noStroke();
	 *     }
	 *
	 *     function draw() {
	 *       background(204);
	 *       var x1 = map(mouseX, 0, width, 25, 75);
	 *       ellipse(x1, 25, 25, 25);
	 *       var x2 = map(mouseX, 0, width, 0, 100);
	 *       ellipse(x2, 75, 25, 25);
	 *     }
	 *   </code></div>
	 */
	p5.prototype.map = function(n, start1, stop1, start2, stop2) {
	  return ((n-start1)/(stop1-start1))*(stop2-start2)+start2;
	};
	
	/**
	 * Determines the largest value in a sequence of numbers, and then returns
	 * that value. max() accepts any number of Number parameters, or an Array
	 * of any length.
	 *
	 * @method max
	 * @param  {Number|Array} n0 Numbers to compare
	 * @return {Number}          maximum Number
	 * @example
	 * <div><code>
	 * function setup() {
	 *   // Change the elements in the array and run the sketch
	 *   // to show how max() works!
	 *   numArray = new Array(2,1,5,4,8,9);
	 *   fill(0);
	 *   noStroke();
	 *   text("Array Elements", 0, 10);
	 *   // Draw all numbers in the array
	 *   var spacing = 15;
	 *   var elemsY = 25;
	 *   for(var i = 0; i < numArray.length; i++) {
	 *     text(numArray[i], i * spacing, elemsY);
	 *   }
	 *   maxX = 33;
	 *   maxY = 80;
	 *   // Draw the Maximum value in the array.
	 *   textSize(32);
	 *   text(max(numArray), maxX, maxY);
	 * }
	 * </code></div>
	 */
	p5.prototype.max = function() {
	  if (arguments[0] instanceof Array) {
	    return Math.max.apply(null,arguments[0]);
	  } else {
	    return Math.max.apply(null,arguments);
	  }
	};
	
	/**
	 * Determines the smallest value in a sequence of numbers, and then returns
	 * that value. min() accepts any number of Number parameters, or an Array
	 * of any length.
	 *
	 * @method min
	 * @param  {Number|Array} n0 Numbers to compare
	 * @return {Number}          minimum Number
	 * @example
	 * <div><code>
	 * function setup() {
	 *   // Change the elements in the array and run the sketch
	 *   // to show how min() works!
	 *   numArray = new Array(2,1,5,4,8,9);
	 *   fill(0);
	 *   noStroke();
	 *   text("Array Elements", 0, 10);
	 *   // Draw all numbers in the array
	 *   var spacing = 15;
	 *   var elemsY = 25;
	 *   for(var i = 0; i < numArray.length; i++) {
	 *     text(numArray[i], i * spacing, elemsY);
	 *   }
	 *   maxX = 33;
	 *   maxY = 80;
	 *   // Draw the Minimum value in the array.
	 *   textSize(32);
	 *   text(min(numArray), maxX, maxY);
	 * }
	 * </code></div>
	 */
	p5.prototype.min = function() {
	  if (arguments[0] instanceof Array) {
	    return Math.min.apply(null,arguments[0]);
	  } else {
	    return Math.min.apply(null,arguments);
	  }
	};
	
	/**
	 * Normalizes a number from another range into a value between 0 and 1.
	 * Identical to map(value, low, high, 0, 1).
	 * Numbers outside of the range are not clamped to 0 and 1, because
	 * out-of-range values are often intentional and useful. (See the second
	 * example above.)
	 *
	 * @method norm
	 * @param  {Number} value incoming value to be normalized
	 * @param  {Number} start lower bound of the value's current range
	 * @param  {Number} stop  upper bound of the value's current range
	 * @return {Number}       normalized number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   currentNum = mouseX;
	 *   lowerBound = 0;
	 *   upperBound = width; //100;
	 *   normalized = norm(currentNum, lowerBound, upperBound);
	 *   lineY = 70
	 *   line(0, lineY, width, lineY);
	 *   //Draw an ellipse mapped to the non-normalized value.
	 *   noStroke();
	 *   fill(50)
	 *   var s = 7; // ellipse size
	 *   ellipse(currentNum, lineY, s, s);
	 *
	 *   // Draw the guide
	 *   guideY = lineY + 15;
	 *   text("0", 0, guideY);
	 *   textAlign(RIGHT);
	 *   text("100", width, guideY);
	 *
	 *   // Draw the normalized value
	 *   textAlign(LEFT);
	 *   fill(0);
	 *   textSize(32);
	 *   normalY = 40;
	 *   normalX = 20;
	 *   text(normalized, normalX, normalY);
	 * }
	 * </code></div>
	 */
	p5.prototype.norm = function(n, start, stop) {
	  return this.map(n, start, stop, 0, 1);
	};
	
	/**
	 * Facilitates exponential expressions. The pow() function is an efficient
	 * way of multiplying numbers by themselves (or their reciprocals) in large
	 * quantities. For example, pow(3, 5) is equivalent to the expression
	 * 3*3*3*3*3 and pow(3, -5) is equivalent to 1 / 3*3*3*3*3. Maps to
	 * Math.pow().
	 *
	 * @method pow
	 * @param  {Number} n base of the exponential expression
	 * @param  {Number} e power by which to raise the base
	 * @return {Number}   n^e
	 * @example
	 * <div><code>
	 * function setup() {
	 *   //Exponentially increase the size of an ellipse.
	 *   eSize = 3; // Original Size
	 *   eLoc = 10; // Original Location
	 *
	 *   ellipse(eLoc, eLoc, eSize, eSize);
	 *
	 *   ellipse(eLoc*2, eLoc*2, pow(eSize, 2), pow(eSize, 2));
	 *
	 *   ellipse(eLoc*4, eLoc*4, pow(eSize, 3), pow(eSize, 3));
	 *
	 *   ellipse(eLoc*8, eLoc*8, pow(eSize, 4), pow(eSize, 4));
	 * }
	 * </code></div>
	 */
	p5.prototype.pow = Math.pow;
	
	/**
	 * Calculates the integer closest to the n parameter. For example,
	 * round(133.8) returns the value 134. Maps to Math.round().
	 *
	 * @method round
	 * @param  {Number} n number to round
	 * @return {Number}   rounded number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   //map, mouseX between 0 and 5.
	 *   var ax = map(mouseX, 0, 100, 0, 5);
	 *   var ay = 66;
	 *
	 *   // Round the mapped number.
	 *   var bx = round(map(mouseX, 0, 100, 0,5));
	 *   var by = 33;
	 *
	 *   // Multiply the mapped numbers by 20 to more easily
	 *   // see the changes.
	 *   stroke(0);
	 *   fill(0);
	 *   line(0, ay, ax * 20, ay);
	 *   line(0, by, bx * 20, by);
	 *
	 *   // Reformat the float returned by map and draw it.
	 *   noStroke();
	 *   text(nfc(ax, 2,2), ax, ay - 5);
	 *   text(nfc(bx,1,1), bx, by - 5);
	 * }
	 * </code></div>
	 */
	p5.prototype.round = Math.round;
	
	/**
	 * Squares a number (multiplies a number by itself). The result is always a
	 * positive number, as multiplying two negative numbers always yields a
	 * positive result. For example, -1 * -1 = 1.
	 *
	 * @method sq
	 * @param  {Number} n number to square
	 * @return {Number}   squared number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   eSize = 7;
	 *   x1 = map(mouseX, 0, width, 0, 10);
	 *   y1 = 80;
	 *   x2 = sq(x1);
	 *   y2 = 20;
	 *
	 *   // Draw the non-squared.
	 *   line(0, y1, width, y1);
	 *   ellipse(x1, y1, eSize, eSize);
	 *
	 *   // Draw the squared.
	 *   line(0, y2, width, y2);
	 *   ellipse(x2, y2, eSize, eSize);
	 *
	 *   // Draw dividing line.
	 *   stroke(100)
	 *   line(0, height/2, width, height/2);
	 *
	 *   // Draw text.
	 *   var spacing = 15;
	 *   noStroke();
	 *   fill(0);
	 *   text("x = " + x1, 0, y1 + spacing);
	 *   text("sq(x) = " + x2, 0, y2 + spacing);
	 * }
	 * </code></div>
	 */
	p5.prototype.sq = function(n) { return n*n; };
	
	/**
	 * Calculates the square root of a number. The square root of a number is
	 * always positive, even though there may be a valid negative root. The
	 * square root s of number a is such that s*s = a. It is the opposite of
	 * squaring. Maps to Math.sqrt().
	 *
	 * @method sqrt
	 * @param  {Number} n non-negative number to square root
	 * @return {Number}   square root of number
	 * @example
	 * <div><code>
	 * function draw() {
	 *   background(200);
	 *   eSize = 7;
	 *   x1 = mouseX;
	 *   y1 = 80;
	 *   x2 = sqrt(x1);
	 *   y2 = 20;
	 *
	 *   // Draw the non-squared.
	 *   line(0, y1, width, y1);
	 *   ellipse(x1, y1, eSize, eSize);
	 *
	 *   // Draw the squared.
	 *   line(0, y2, width, y2);
	 *   ellipse(x2, y2, eSize, eSize);
	 *
	 *   // Draw dividing line.
	 *   stroke(100)
	 *   line(0, height/2, width, height/2);
	 *
	 *   // Draw text.
	 *   noStroke();
	 *   fill(0);
	 *   var spacing = 15;
	 *   text("x = " + x1, 0, y1 + spacing);
	 *   text("sqrt(x) = " + x2, 0, y2 + spacing);
	 * }
	 * </code></div>
	 */
	p5.prototype.sqrt = Math.sqrt;
	
	module.exports = p5;
	
	},{"../core/core":48}],74:[function(_dereq_,module,exports){
	/**
	 * @module Math
	 * @submodule Math
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	
	/**
	 * Creates a new p5.Vector (the datatype for storing vectors). This provides a
	 * two or three dimensional vector, specifically a Euclidean (also known as
	 * geometric) vector. A vector is an entity that has both magnitude and
	 * direction.
	 *
	 * @method createVector
	 * @param {Number} [x] x component of the vector
	 * @param {Number} [y] y component of the vector
	 * @param {Number} [z] z component of the vector
	 */
	p5.prototype.createVector = function (x, y, z) {
	  if (this instanceof p5) {
	    return new p5.Vector(this, arguments);
	  } else {
	    return new p5.Vector(x, y, z);
	  }
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],75:[function(_dereq_,module,exports){
	//////////////////////////////////////////////////////////////
	
	// http://mrl.nyu.edu/~perlin/noise/
	// Adapting from PApplet.java
	// which was adapted from toxi
	// which was adapted from the german demo group farbrausch
	// as used in their demo "art": http://www.farb-rausch.de/fr010src.zip
	
	// someday we might consider using "improved noise"
	// http://mrl.nyu.edu/~perlin/paper445.pdf
	// See: https://github.com/shiffman/The-Nature-of-Code-Examples-p5.js/
	//      blob/master/introduction/Noise1D/noise.js
	
	/**
	 * @module Math
	 * @submodule Noise
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	var PERLIN_YWRAPB = 4;
	var PERLIN_YWRAP = 1<<PERLIN_YWRAPB;
	var PERLIN_ZWRAPB = 8;
	var PERLIN_ZWRAP = 1<<PERLIN_ZWRAPB;
	var PERLIN_SIZE = 4095;
	
	var perlin_octaves = 4; // default to medium smooth
	var perlin_amp_falloff = 0.5; // 50% reduction/octave
	
	var scaled_cosine = function(i) {
	  return 0.5*(1.0-Math.cos(i*Math.PI));
	};
	
	var perlin; // will be initialized lazily by noise() or noiseSeed()
	
	
	/**
	 * Returns the Perlin noise value at specified coordinates. Perlin noise is
	 * a random sequence generator producing a more natural ordered, harmonic
	 * succession of numbers compared to the standard <b>random()</b> function.
	 * It was invented by Ken Perlin in the 1980s and been used since in
	 * graphical applications to produce procedural textures, natural motion,
	 * shapes, terrains etc.<br /><br /> The main difference to the
	 * <b>random()</b> function is that Perlin noise is defined in an infinite
	 * n-dimensional space where each pair of coordinates corresponds to a
	 * fixed semi-random value (fixed only for the lifespan of the program; see
	 * the noiseSeed() function). p5.js can compute 1D, 2D and 3D noise,
	 * depending on the number of coordinates given. The resulting value will
	 * always be between 0.0 and 1.0. The noise value can be animated by moving
	 * through the noise space as demonstrated in the example above. The 2nd
	 * and 3rd dimension can also be interpreted as time.<br /><br />The actual
	 * noise is structured similar to an audio signal, in respect to the
	 * function's use of frequencies. Similar to the concept of harmonics in
	 * physics, perlin noise is computed over several octaves which are added
	 * together for the final result. <br /><br />Another way to adjust the
	 * character of the resulting sequence is the scale of the input
	 * coordinates. As the function works within an infinite space the value of
	 * the coordinates doesn't matter as such, only the distance between
	 * successive coordinates does (eg. when using <b>noise()</b> within a
	 * loop). As a general rule the smaller the difference between coordinates,
	 * the smoother the resulting noise sequence will be. Steps of 0.005-0.03
	 * work best for most applications, but this will differ depending on use.
	 *
	 *
	 * @method noise
	 * @param  {Number} x   x-coordinate in noise space
	 * @param  {Number} y   y-coordinate in noise space
	 * @param  {Number} z   z-coordinate in noise space
	 * @return {Number}     Perlin noise value (between 0 and 1) at specified
	 *                      coordinates
	 * @example
	 * <div>
	 * <code>var xoff = 0.0;
	 *
	 * function draw() {
	 *   background(204);
	 *   xoff = xoff + .01;
	 *   var n = noise(xoff) * width;
	 *   line(n, 0, n, height);
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>var noiseScale=0.02;
	 *
	 * function draw() {
	 *   background(0);
	 *   for (var x=0; x < width; x++) {
	 *     var noiseVal = noise((mouseX+x)*noiseScale, mouseY*noiseScale);
	 *     stroke(noiseVal*255);
	 *     line(x, mouseY+noiseVal*80, x, height);
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.noise = function(x,y,z) {
	  y = y || 0;
	  z = z || 0;
	
	  if (perlin == null) {
	    perlin = new Array(PERLIN_SIZE + 1);
	    for (var i = 0; i < PERLIN_SIZE + 1; i++) {
	      perlin[i] = Math.random();
	    }
	  }
	
	  if (x<0) { x=-x; }
	  if (y<0) { y=-y; }
	  if (z<0) { z=-z; }
	
	  var xi=Math.floor(x), yi=Math.floor(y), zi=Math.floor(z);
	  var xf = x - xi;
	  var yf = y - yi;
	  var zf = z - zi;
	  var rxf, ryf;
	
	  var r=0;
	  var ampl=0.5;
	
	  var n1,n2,n3;
	
	  for (var o=0; o<perlin_octaves; o++) {
	    var of=xi+(yi<<PERLIN_YWRAPB)+(zi<<PERLIN_ZWRAPB);
	
	    rxf = scaled_cosine(xf);
	    ryf = scaled_cosine(yf);
	
	    n1  = perlin[of&PERLIN_SIZE];
	    n1 += rxf*(perlin[(of+1)&PERLIN_SIZE]-n1);
	    n2  = perlin[(of+PERLIN_YWRAP)&PERLIN_SIZE];
	    n2 += rxf*(perlin[(of+PERLIN_YWRAP+1)&PERLIN_SIZE]-n2);
	    n1 += ryf*(n2-n1);
	
	    of += PERLIN_ZWRAP;
	    n2  = perlin[of&PERLIN_SIZE];
	    n2 += rxf*(perlin[(of+1)&PERLIN_SIZE]-n2);
	    n3  = perlin[(of+PERLIN_YWRAP)&PERLIN_SIZE];
	    n3 += rxf*(perlin[(of+PERLIN_YWRAP+1)&PERLIN_SIZE]-n3);
	    n2 += ryf*(n3-n2);
	
	    n1 += scaled_cosine(zf)*(n2-n1);
	
	    r += n1*ampl;
	    ampl *= perlin_amp_falloff;
	    xi<<=1;
	    xf*=2;
	    yi<<=1;
	    yf*=2;
	    zi<<=1;
	    zf*=2;
	
	    if (xf>=1.0) { xi++; xf--; }
	    if (yf>=1.0) { yi++; yf--; }
	    if (zf>=1.0) { zi++; zf--; }
	  }
	  return r;
	};
	
	
	/**
	 *
	 * Adjusts the character and level of detail produced by the Perlin noise
	 * function. Similar to harmonics in physics, noise is computed over
	 * several octaves. Lower octaves contribute more to the output signal and
	 * as such define the overall intensity of the noise, whereas higher octaves
	 * create finer grained details in the noise sequence.
	 * <br><br>
	 * By default, noise is computed over 4 octaves with each octave contributing
	 * exactly half than its predecessor, starting at 50% strength for the 1st
	 * octave. This falloff amount can be changed by adding an additional function
	 * parameter. Eg. a falloff factor of 0.75 means each octave will now have
	 * 75% impact (25% less) of the previous lower octave. Any value between
	 * 0.0 and 1.0 is valid, however note that values greater than 0.5 might
	 * result in greater than 1.0 values returned by <b>noise()</b>.
	 * <br><br>
	 * By changing these parameters, the signal created by the <b>noise()</b>
	 * function can be adapted to fit very specific needs and characteristics.
	 *
	 * @method noiseDetail
	 * @param {Number} lod number of octaves to be used by the noise
	 * @param {Number} falloff falloff factor for each octave
	 * @example
	 * <div>
	 * <code>
	 *
	 * var noiseVal;
	 * var noiseScale=0.02;
	 *
	 * function setup() {
	 *   createCanvas(100,100);
	 * }
	 *
	 * function draw() {
	 *   background(0);
	 *   for (var y = 0; y < height; y++) {
	 *     for (var x = 0; x < width/2; x++) {
	 *       noiseDetail(2,0.2);
	 *       noiseVal = noise((mouseX+x) * noiseScale,
	 *                        (mouseY+y) * noiseScale);
	 *       stroke(noiseVal*255);
	 *       point(x,y);
	 *       noiseDetail(8,0.65);
	 *       noiseVal = noise((mouseX + x + width/2) * noiseScale,
	 *                        (mouseY + y) * noiseScale);
	 *       stroke(noiseVal*255);
	 *       point(x + width/2, y);
	 *     }
	 *   }
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.noiseDetail = function(lod, falloff) {
	  if (lod>0)     { perlin_octaves=lod; }
	  if (falloff>0) { perlin_amp_falloff=falloff; }
	};
	
	/**
	 * Sets the seed value for <b>noise()</b>. By default, <b>noise()</b>
	 * produces different results each time the program is run. Set the
	 * <b>value</b> parameter to a constant to return the same pseudo-random
	 * numbers each time the software is run.
	 *
	 * @method noiseSeed
	 * @param {Number} seed   the seed value
	 * @example
	 * <div>
	 * <code>var xoff = 0.0;
	 *
	 * function setup() {
	 *   noiseSeed(99);
	 *   stroke(0, 10);
	 * }
	 *
	 * function draw() {
	 *   xoff = xoff + .01;
	 *   var n = noise(xoff) * width;
	 *   line(n, 0, n, height);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.noiseSeed = function(seed) {
	  // Linear Congruential Generator
	  // Variant of a Lehman Generator
	  var lcg = (function() {
	    // Set to values from http://en.wikipedia.org/wiki/Numerical_Recipes
	    // m is basically chosen to be large (as it is the max period)
	    // and for its relationships to a and c
	    var m = 4294967296,
	    // a - 1 should be divisible by m's prime factors
	    a = 1664525,
	     // c and m should be co-prime
	    c = 1013904223,
	    seed, z;
	    return {
	      setSeed : function(val) {
	        // pick a random seed if val is undefined or null
	        // the >>> 0 casts the seed to an unsigned 32-bit integer
	        z = seed = (val == null ? Math.random() * m : val) >>> 0;
	      },
	      getSeed : function() {
	        return seed;
	      },
	      rand : function() {
	        // define the recurrence relationship
	        z = (a * z + c) % m;
	        // return a float in [0, 1)
	        // if z = m then z / m = 0 therefore (z % m) / m < 1 always
	        return z / m;
	      }
	    };
	  }());
	
	  lcg.setSeed(seed);
	  perlin = new Array(PERLIN_SIZE + 1);
	  for (var i = 0; i < PERLIN_SIZE + 1; i++) {
	    perlin[i] = lcg.rand();
	  }
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],76:[function(_dereq_,module,exports){
	/**
	 * @module Math
	 * @submodule Math
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var polarGeometry = _dereq_('./polargeometry');
	var constants = _dereq_('../core/constants');
	
	/**
	 * A class to describe a two or three dimensional vector, specifically
	 * a Euclidean (also known as geometric) vector. A vector is an entity
	 * that has both magnitude and direction. The datatype, however, stores
	 * the components of the vector (x, y for 2D, and x, y, z for 3D). The magnitude
	 * and direction can be accessed via the methods mag() and heading().
	 * <br><br>
	 * In many of the p5.js examples, you will see p5.Vector used to describe a
	 * position, velocity, or acceleration. For example, if you consider a rectangle
	 * moving across the screen, at any given instant it has a position (a vector
	 * that points from the origin to its location), a velocity (the rate at which
	 * the object's position changes per time unit, expressed as a vector), and
	 * acceleration (the rate at which the object's velocity changes per time
	 * unit, expressed as a vector).
	 * <br><br>
	 * Since vectors represent groupings of values, we cannot simply use
	 * traditional addition/multiplication/etc. Instead, we'll need to do some
	 * "vector" math, which is made easy by the methods inside the p5.Vector class.
	 *
	 * @class p5.Vector
	 * @constructor
	 * @param {Number} [x] x component of the vector
	 * @param {Number} [y] y component of the vector
	 * @param {Number} [z] z component of the vector
	 * @example
	 * <div>
	 * <code>
	 * var v1 = createVector(40, 50);
	 * var v2 = createVector(40, 50);
	 *
	 * ellipse(v1.x, v1.y, 50, 50);
	 * ellipse(v2.x, v2.y, 50, 50);
	 * v1.add(v2);
	 * ellipse(v1.x, v1.y, 50, 50);
	 * </code>
	 * </div>
	 */
	p5.Vector = function() {
	  var x,y,z;
	  // This is how it comes in with createVector()
	  if(arguments[0] instanceof p5) {
	    // save reference to p5 if passed in
	    this.p5 = arguments[0];
	    x  = arguments[1][0] || 0;
	    y  = arguments[1][1] || 0;
	    z  = arguments[1][2] || 0;
	  // This is what we'll get with new p5.Vector()
	  } else {
	    x = arguments[0] || 0;
	    y = arguments[1] || 0;
	    z = arguments[2] || 0;
	  }
	  /**
	   * The x component of the vector
	   * @property x
	   * @type {Number}
	   */
	  this.x = x;
	  /**
	   * The y component of the vector
	   * @property y
	   * @type {Number}
	   */
	  this.y = y;
	  /**
	   * The z component of the vector
	   * @property z
	   * @type {Number}
	   */
	  this.z = z;
	};
	
	/**
	 * Returns a string representation of a vector v by calling String(v)
	 * or v.toString(). This method is useful for logging vectors in the
	 * console.
	 * @method  toString
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var v = createVector(20,30);
	 *   print(String(v)); // prints "p5.Vector Object : [20, 30, 0]"
	 * }
	 * </div></code>
	 *
	 */
	p5.Vector.prototype.toString = function p5VectorToString() {
	  return 'p5.Vector Object : ['+ this.x +', '+ this.y +', '+ this.z + ']';
	};
	
	/**
	 * Sets the x, y, and z component of the vector using two or three separate
	 * variables, the data from a p5.Vector, or the values from a float array.
	 * @method set
	 *
	 * @param {Number|p5.Vector|Array} [x] the x component of the vector or a
	 *                                     p5.Vector or an Array
	 * @param {Number}                 [y] the y component of the vector
	 * @param {Number}                 [z] the z component of the vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * function setup() {
	 *    var v = createVector(1, 2, 3);
	 *    v.set(4,5,6); // Sets vector to [4, 5, 6]
	 *
	 *    var v1 = createVector(0, 0, 0);
	 *    var arr = [1, 2, 3];
	 *    v1.set(arr); // Sets vector to [1, 2, 3]
	 * }
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.set = function (x, y, z) {
	  if (x instanceof p5.Vector) {
	    this.x = x.x || 0;
	    this.y = x.y || 0;
	    this.z = x.z || 0;
	    return this;
	  }
	  if (x instanceof Array) {
	    this.x = x[0] || 0;
	    this.y = x[1] || 0;
	    this.z = x[2] || 0;
	    return this;
	  }
	  this.x = x || 0;
	  this.y = y || 0;
	  this.z = z || 0;
	  return this;
	};
	
	/**
	 * Gets a copy of the vector, returns a p5.Vector object.
	 *
	 * @method copy
	 * @return {p5.Vector} the copy of the p5.Vector object
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(1, 2, 3);
	 * var v2 = v.copy();
	 * print(v1.x == v2.x && v1.y == v2.y && v1.z == v2.z);
	 * // Prints "true"
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.copy = function () {
	  if (this.p5) {
	    return new p5.Vector(this.p5,[this.x, this.y, this.z]);
	  } else {
	    return new p5.Vector(this.x,this.y,this.z);
	  }
	};
	
	/**
	 * Adds x, y, and z components to a vector, adds one vector to another, or
	 * adds two independent vectors together. The version of the method that adds
	 * two vectors together is a static method and returns a p5.Vector, the others
	 * acts directly on the vector. See the examples for more context.
	 *
	 * @method add
	 * @chainable
	 * @param  {Number|p5.Vector|Array} x   the x component of the vector to be
	 *                                      added or a p5.Vector or an Array
	 * @param  {Number}                 [y] the y component of the vector to be
	 *                                      added
	 * @param  {Number}                 [z] the z component of the vector to be
	 *                                      added
	 * @return {p5.Vector}                  the p5.Vector object.
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(1, 2, 3);
	 * v.add(4,5,6);
	 * // v's compnents are set to [5, 7, 9]
	 * </code>
	 * </div>
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1 = createVector(1, 2, 3);
	 * var v2 = createVector(2, 3, 4);
	 *
	 * var v3 = p5.Vector.add(v1, v2);
	 * // v3 has components [3, 5, 7]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.add = function (x, y, z) {
	  if (x instanceof p5.Vector) {
	    this.x += x.x || 0;
	    this.y += x.y || 0;
	    this.z += x.z || 0;
	    return this;
	  }
	  if (x instanceof Array) {
	    this.x += x[0] || 0;
	    this.y += x[1] || 0;
	    this.z += x[2] || 0;
	    return this;
	  }
	  this.x += x || 0;
	  this.y += y || 0;
	  this.z += z || 0;
	  return this;
	};
	
	/**
	 * Subtracts x, y, and z components from a vector, subtracts one vector from
	 * another, or subtracts two independent vectors. The version of the method
	 * that subtracts two vectors is a static method and returns a p5.Vector, the
	 * other acts directly on the vector. See the examples for more context.
	 *
	 * @method sub
	 * @chainable
	 * @param  {Number|p5.Vector|Array} x   the x component of the vector or a
	 *                                      p5.Vector or an Array
	 * @param  {Number}                 [y] the y component of the vector
	 * @param  {Number}                 [z] the z component of the vector
	 * @return {p5.Vector}                  p5.Vector object.
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(4, 5, 6);
	 * v.sub(1, 1, 1);
	 * // v's compnents are set to [3, 4, 5]
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1 = createVector(2, 3, 4);
	 * var v2 = createVector(1, 2, 3);
	 *
	 * var v3 = p5.Vector.sub(v1, v2);
	 * // v3 has compnents [1, 1, 1]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.sub = function (x, y, z) {
	  if (x instanceof p5.Vector) {
	    this.x -= x.x || 0;
	    this.y -= x.y || 0;
	    this.z -= x.z || 0;
	    return this;
	  }
	  if (x instanceof Array) {
	    this.x -= x[0] || 0;
	    this.y -= x[1] || 0;
	    this.z -= x[2] || 0;
	    return this;
	  }
	  this.x -= x || 0;
	  this.y -= y || 0;
	  this.z -= z || 0;
	  return this;
	};
	
	/**
	 * Multiply the vector by a scalar. The static version of this method
	 * creates a new p5.Vector while the non static version acts on the vector
	 * directly. See the examples for more context.
	 *
	 * @method mult
	 * @chainable
	 * @param  {Number}    n the number to multiply with the vector
	 * @return {p5.Vector} a reference to the p5.Vector object (allow chaining)
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(1, 2, 3);
	 * v.mult(2);
	 * // v's compnents are set to [2, 4, 6]
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1 = createVector(1, 2, 3);
	 * var v2 = p5.Vector.mult(v1, 2);
	 * // v2 has compnents [2, 4, 6]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.mult = function (n) {
	  this.x *= n || 0;
	  this.y *= n || 0;
	  this.z *= n || 0;
	  return this;
	};
	
	/**
	 * Divide the vector by a scalar. The static version of this method creates a
	 * new p5.Vector while the non static version acts on the vector directly.
	 * See the examples for more context.
	 *
	 * @method div
	 * @chainable
	 * @param  {number}    n the number to divide the vector by
	 * @return {p5.Vector} a reference to the p5.Vector object (allow chaining)
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(6, 4, 2);
	 * v.div(2); //v's compnents are set to [3, 2, 1]
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1  = createVector(6, 4, 2);
	 * var v2 = p5.Vector.div(v, 2);
	 * // v2 has compnents [3, 2, 1]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.div = function (n) {
	  this.x /= n;
	  this.y /= n;
	  this.z /= n;
	  return this;
	};
	
	/**
	 * Calculates the magnitude (length) of the vector and returns the result as
	 * a float (this is simply the equation sqrt(x*x + y*y + z*z).)
	 *
	 * @method mag
	 * @return {Number} magnitude of the vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(20.0, 30.0, 40.0);
	 * var m = v.mag(10);
	 * print(m); // Prints "53.85164807134504"
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.mag = function () {
	  return Math.sqrt(this.magSq());
	};
	
	/**
	 * Calculates the squared magnitude of the vector and returns the result
	 * as a float (this is simply the equation <em>(x*x + y*y + z*z)</em>.)
	 * Faster if the real length is not required in the
	 * case of comparing vectors, etc.
	 *
	 * @method magSq
	 * @return {number} squared magnitude of the vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1 = createVector(6, 4, 2);
	 * print(v1.magSq()); // Prints "56"
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.magSq = function () {
	  var x = this.x, y = this.y, z = this.z;
	  return (x * x + y * y + z * z);
	};
	
	/**
	 * Calculates the dot product of two vectors. The version of the method
	 * that computes the dot product of two independent vectors is a static
	 * method. See the examples for more context.
	 *
	 *
	 * @method dot
	 * @param  {Number|p5.Vector} x   x component of the vector or a p5.Vector
	 * @param  {Number}           [y] y component of the vector
	 * @param  {Number}           [z] z component of the vector
	 * @return {Number}                 the dot product
	 *
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(1, 2, 3);
	 * var v2 = createVector(2, 3, 4);
	 *
	 * print(v1.dot(v2)); // Prints "20"
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * //Static method
	 * var v1 = createVector(1, 2, 3);
	 * var v2 = createVector(3, 2, 1);
	 * print (p5.Vector.dot(v1, v2)); // Prints "10"
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.dot = function (x, y, z) {
	  if (x instanceof p5.Vector) {
	    return this.dot(x.x, x.y, x.z);
	  }
	  return this.x * (x || 0) +
	         this.y * (y || 0) +
	         this.z * (z || 0);
	};
	
	/**
	 * Calculates and returns a vector composed of the cross product between
	 * two vectors. Both the static and non static methods return a new p5.Vector.
	 * See the examples for more context.
	 *
	 * @method cross
	 * @param  {p5.Vector} v p5.Vector to be crossed
	 * @return {p5.Vector}   p5.Vector composed of cross product
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(1, 2, 3);
	 * var v2 = createVector(1, 2, 3);
	 *
	 * v1.cross(v2); // v's components are [0, 0, 0]
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1 = createVector(1, 0, 0);
	 * var v2 = createVector(0, 1, 0);
	 *
	 * var crossProduct = p5.Vector.cross(v1, v2);
	 * // crossProduct has components [0, 0, 1]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.cross = function (v) {
	  var x = this.y * v.z - this.z * v.y;
	  var y = this.z * v.x - this.x * v.z;
	  var z = this.x * v.y - this.y * v.x;
	  if (this.p5) {
	    return new p5.Vector(this.p5,[x,y,z]);
	  } else {
	    return new p5.Vector(x,y,z);
	  }
	};
	
	/**
	 * Calculates the Euclidean distance between two points (considering a
	 * point as a vector object).
	 *
	 * @method dist
	 * @param  {p5.Vector} v the x, y, and z coordinates of a p5.Vector
	 * @return {Number}      the distance
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(1, 0, 0);
	 * var v2 = createVector(0, 1, 0);
	 *
	 * var distance = v1.dist(v2); // distance is 1.4142...
	 * </code>
	 * </div>
	 * <div class="norender">
	 * <code>
	 * // Static method
	 * var v1 = createVector(1, 0, 0);
	 * var v2 = createVector(0, 1, 0);
	 *
	 * var distance = p5.Vector.dist(v1,v2);
	 * // distance is 1.4142...
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.dist = function (v) {
	  var d = v.copy().sub(this);
	  return d.mag();
	};
	
	/**
	 * Normalize the vector to length 1 (make it a unit vector).
	 *
	 * @method normalize
	 * @return {p5.Vector} normalized p5.Vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(10, 20, 2);
	 * // v has compnents [10.0, 20.0, 2.0]
	 * v.normalize();
	 * // v's compnents are set to
	 * // [0.4454354, 0.8908708, 0.089087084]
	 * </code>
	 * </div>
	 *
	 */
	p5.Vector.prototype.normalize = function () {
	  return this.div(this.mag());
	};
	
	/**
	 * Limit the magnitude of this vector to the value used for the <b>max</b>
	 * parameter.
	 *
	 * @method limit
	 * @param  {Number}    max the maximum magnitude for the vector
	 * @return {p5.Vector}     the modified p5.Vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(10, 20, 2);
	 * // v has compnents [10.0, 20.0, 2.0]
	 * v.limit(5);
	 * // v's compnents are set to
	 * // [2.2271771, 4.4543543, 0.4454354]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.limit = function (l) {
	  var mSq = this.magSq();
	  if(mSq > l*l) {
	    this.div(Math.sqrt(mSq)); //normalize it
	    this.mult(l);
	  }
	  return this;
	};
	
	/**
	 * Set the magnitude of this vector to the value used for the <b>len</b>
	 * parameter.
	 *
	 * @method setMag
	 * @param  {number}    len the new length for this vector
	 * @return {p5.Vector}     the modified p5.Vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(10, 20, 2);
	 * // v has compnents [10.0, 20.0, 2.0]
	 * v1.setMag(10);
	 * // v's compnents are set to [6.0, 8.0, 0.0]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.setMag = function (n) {
	  return this.normalize().mult(n);
	};
	
	/**
	 * Calculate the angle of rotation for this vector (only 2D vectors)
	 *
	 * @method heading
	 * @return {Number} the angle of rotation
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var v1 = createVector(30,50);
	 *   print(v1.heading()); // 1.0303768265243125
	 *
	 *   var v1 = createVector(40,50);
	 *   print(v1.heading()); // 0.8960553845713439
	 *
	 *   var v1 = createVector(30,70);
	 *   print(v1.heading()); // 1.1659045405098132
	 * }
	 * </div></code>
	 */
	p5.Vector.prototype.heading = function () {
	  var h = Math.atan2(this.y, this.x);
	  if (this.p5) {
	    if (this.p5._angleMode === constants.RADIANS) {
	      return h;
	    } else {
	      return polarGeometry.radiansToDegrees(h);
	    }
	  } else {
	    return h;
	  }
	};
	
	/**
	 * Rotate the vector by an angle (only 2D vectors), magnitude remains the
	 * same
	 *
	 * @method rotate
	 * @param  {number}    angle the angle of rotation
	 * @return {p5.Vector} the modified p5.Vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(10.0, 20.0);
	 * // v has compnents [10.0, 20.0, 0.0]
	 * v.rotate(HALF_PI);
	 * // v's compnents are set to [-20.0, 9.999999, 0.0]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.rotate = function (a) {
	  if (this.p5) {
	    if (this.p5._angleMode === constants.DEGREES) {
	      a = polarGeometry.degreesToRadians(a);
	    }
	  }
	  var newHeading = this.heading() + a;
	  var mag = this.mag();
	  this.x = Math.cos(newHeading) * mag;
	  this.y = Math.sin(newHeading) * mag;
	  return this;
	};
	
	/**
	 * Linear interpolate the vector to another vector
	 *
	 * @method lerp
	 * @param  {p5.Vector} x   the x component or the p5.Vector to lerp to
	 * @param  {p5.Vector} [y] y the y component
	 * @param  {p5.Vector} [z] z the z component
	 * @param  {Number}    amt the amount of interpolation; some value between 0.0
	 *                         (old vector) and 1.0 (new vector). 0.1 is very near
	 *                         the new vector. 0.5 is halfway in between.
	 * @return {p5.Vector}     the modified p5.Vector
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = createVector(1, 1, 0);
	 *
	 * v.lerp(3, 3, 0, 0.5); // v now has components [2,2,0]
	 * </code>
	 * </div>
	 *
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(0, 0, 0);
	 * var v2 = createVector(100, 100, 0);
	 *
	 * var v3 = p5.Vector.lerp(v1, v2, 0.5);
	 * // v3 has components [50,50,0]
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.lerp = function (x, y, z, amt) {
	  if (x instanceof p5.Vector) {
	    return this.lerp(x.x, x.y, x.z, y);
	  }
	  this.x += (x - this.x) * amt || 0;
	  this.y += (y - this.y) * amt || 0;
	  this.z += (z - this.z) * amt || 0;
	  return this;
	};
	
	/**
	 * Return a representation of this vector as a float array. This is only
	 * for temporary use. If used in any other fashion, the contents should be
	 * copied by using the <b>p5.Vector.copy()</b> method to copy into your own
	 * array.
	 *
	 * @method array
	 * @return {Array} an Array with the 3 values
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var v = createVector(20,30);
	 *   print(v.array()); // Prints : Array [20, 30, 0]
	 * }
	 * </div></code>
	 * <div class="norender">
	 * <code>
	 * var v = createVector(10.0, 20.0, 30.0);
	 * var f = v.array();
	 * print(f[0]); // Prints "10.0"
	 * print(f[1]); // Prints "20.0"
	 * print(f[2]); // Prints "30.0"
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.array = function () {
	  return [this.x || 0, this.y || 0, this.z || 0];
	};
	
	/**
	 * Equality check against a p5.Vector
	 *
	 * @method equals
	 * @param {Number|p5.Vector|Array} [x] the x component of the vector or a
	 *                                     p5.Vector or an Array
	 * @param {Number}                 [y] the y component of the vector
	 * @param {Number}                 [z] the z component of the vector
	 * @return {Boolean} whether the vectors are equals
	 * @example
	 * <div class = "norender"><code>
	 * v1 = createVector(5,10,20);
	 * v2 = createVector(5,10,20);
	 * v3 = createVector(13,10,19);
	 *
	 * print(v1.equals(v2.x,v2.y,v2.z)); // true
	 * print(v1.equals(v3.x,v3.y,v3.z)); // false
	 * </div></code>
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(10.0, 20.0, 30.0);
	 * var v2 = createVector(10.0, 20.0, 30.0);
	 * var v3 = createVector(0.0, 0.0, 0.0);
	 * print (v1.equals(v2)) // true
	 * print (v1.equals(v3)) // false
	 * </code>
	 * </div>
	 */
	p5.Vector.prototype.equals = function (x, y, z) {
	  var a, b, c;
	  if (x instanceof p5.Vector) {
	    a = x.x || 0;
	    b = x.y || 0;
	    c = x.z || 0;
	  } else if (x instanceof Array) {
	    a = x[0] || 0;
	    b = x[1] || 0;
	    c = x[2] || 0;
	  } else {
	    a = x || 0;
	    b = y || 0;
	    c = z || 0;
	  }
	  return this.x === a && this.y === b && this.z === c;
	};
	
	
	// Static Methods
	
	
	/**
	 * Make a new 2D unit vector from an angle
	 *
	 * @method fromAngle
	 * @static
	 * @param {Number}     angle the desired angle
	 * @return {p5.Vector}       the new p5.Vector object
	 * @example
	 * <div>
	 * <code>
	 * function draw() {
	 *   background (200);
	 *
	 *   // Create a variable, proportional to the mouseX,
	 *   // varying from 0-360, to represent an angle in degrees.
	 *   angleMode(DEGREES);
	 *   var myDegrees = map(mouseX, 0,width, 0,360);
	 *
	 *   // Display that variable in an onscreen text.
	 *   // (Note the nfc() function to truncate additional decimal places,
	 *   // and the "\xB0" character for the degree symbol.)
	 *   var readout = "angle = " + nfc(myDegrees,1,1) + "\xB0"
	 *   noStroke();
	 *   fill (0);
	 *   text (readout, 5, 15);
	 *
	 *   // Create a p5.Vector using the fromAngle function,
	 *   // and extract its x and y components.
	 *   var v = p5.Vector.fromAngle(radians(myDegrees));
	 *   var vx = v.x;
	 *   var vy = v.y;
	 *
	 *   push();
	 *   translate (width/2, height/2);
	 *   noFill();
	 *   stroke (150);
	 *   line (0,0, 30,0);
	 *   stroke (0);
	 *   line (0,0, 30*vx, 30*vy);
	 *   pop()
	 * }
	 * </code>
	 * </div>
	 */
	p5.Vector.fromAngle = function(angle) {
	  if (this.p5) {
	    if (this.p5._angleMode === constants.DEGREES) {
	      angle = polarGeometry.degreesToRadians(angle);
	    }
	  }
	  if (this.p5) {
	    return new p5.Vector(this.p5,[Math.cos(angle),Math.sin(angle),0]);
	  } else {
	    return new p5.Vector(Math.cos(angle),Math.sin(angle),0);
	  }
	};
	
	/**
	 * Make a new 2D unit vector from a random angle
	 *
	 * @method random2D
	 * @static
	 * @return {p5.Vector} the new p5.Vector object
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = p5.Vector.random2D();
	 * // May make v's attributes something like:
	 * // [0.61554617, -0.51195765, 0.0] or
	 * // [-0.4695841, -0.14366731, 0.0] or
	 * // [0.6091097, -0.22805278, 0.0]
	 * </code>
	 * </div>
	 */
	p5.Vector.random2D = function () {
	  var angle;
	  // A lot of nonsense to determine if we know about a
	  // p5 sketch and whether we should make a random angle in degrees or radians
	  if (this.p5) {
	    if (this.p5._angleMode === constants.DEGREES) {
	      angle = this.p5.random(360);
	    } else {
	      angle = this.p5.random(constants.TWO_PI);
	    }
	  } else {
	    angle = Math.random()*Math.PI*2;
	  }
	  return this.fromAngle(angle);
	};
	
	/**
	 * Make a new random 3D unit vector.
	 *
	 * @method random3D
	 * @static
	 * @return {p5.Vector} the new p5.Vector object
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v = p5.Vector.random3D();
	 * // May make v's attributes something like:
	 * // [0.61554617, -0.51195765, 0.599168] or
	 * // [-0.4695841, -0.14366731, -0.8711202] or
	 * // [0.6091097, -0.22805278, -0.7595902]
	 * </code>
	 * </div>
	 */
	p5.Vector.random3D = function () {
	  var angle,vz;
	  // If we know about p5
	  if (this.p5) {
	    angle = this.p5.random(0,constants.TWO_PI);
	    vz = this.p5.random(-1,1);
	  } else {
	    angle = Math.random()*Math.PI*2;
	    vz = Math.random()*2-1;
	  }
	  var vx = Math.sqrt(1-vz*vz)*Math.cos(angle);
	  var vy = Math.sqrt(1-vz*vz)*Math.sin(angle);
	  if (this.p5) {
	    return new p5.Vector(this.p5,[vx,vy,vz]);
	  } else {
	    return new p5.Vector(vx,vy,vz);
	  }
	};
	
	
	/**
	 * Adds two vectors together and returns a new one.
	 *
	 * @static
	 * @param  {p5.Vector} v1 a p5.Vector to add
	 * @param  {p5.Vector} v2 a p5.Vector to add
	 * @param  {p5.Vector} target if undefined a new vector will be created
	 * @return {p5.Vector} the resulting p5.Vector
	 *
	 */
	
	p5.Vector.add = function (v1, v2, target) {
	  if (!target) {
	    target = v1.copy();
	  } else {
	    target.set(v1);
	  }
	  target.add(v2);
	  return target;
	};
	
	/**
	 * Subtracts one p5.Vector from another and returns a new one.  The second
	 * vector (v2) is subtracted from the first (v1), resulting in v1-v2.
	 *
	 * @static
	 * @param  {p5.Vector} v1 a p5.Vector to subtract from
	 * @param  {p5.Vector} v2 a p5.Vector to subtract
	 * @param  {p5.Vector} target if undefined a new vector will be created
	 * @return {p5.Vector} the resulting p5.Vector
	 */
	
	p5.Vector.sub = function (v1, v2, target) {
	  if (!target) {
	    target = v1.copy();
	  } else {
	    target.set(v1);
	  }
	  target.sub(v2);
	  return target;
	};
	
	
	/**
	 * Multiplies a vector by a scalar and returns a new vector.
	 *
	 * @static
	 * @param  {p5.Vector} v the p5.Vector to multiply
	 * @param  {Number}  n the scalar
	 * @param  {p5.Vector} target if undefined a new vector will be created
	 * @return {p5.Vector}  the resulting new p5.Vector
	 */
	p5.Vector.mult = function (v, n, target) {
	  if (!target) {
	    target = v.copy();
	  } else {
	    target.set(v);
	  }
	  target.mult(n);
	  return target;
	};
	
	/**
	 * Divides a vector by a scalar and returns a new vector.
	 *
	 * @static
	 * @param  {p5.Vector} v the p5.Vector to divide
	 * @param  {Number}  n the scalar
	 * @param  {p5.Vector} target if undefined a new vector will be created
	 * @return {p5.Vector} the resulting new p5.Vector
	 */
	p5.Vector.div = function (v, n, target) {
	  if (!target) {
	    target = v.copy();
	  } else {
	    target.set(v);
	  }
	  target.div(n);
	  return target;
	};
	
	
	/**
	 * Calculates the dot product of two vectors.
	 *
	 * @static
	 * @param  {p5.Vector} v1 the first p5.Vector
	 * @param  {p5.Vector} v2 the second p5.Vector
	 * @return {Number}     the dot product
	 */
	p5.Vector.dot = function (v1, v2) {
	  return v1.dot(v2);
	};
	
	/**
	 * Calculates the cross product of two vectors.
	 *
	 * @static
	 * @param  {p5.Vector} v1 the first p5.Vector
	 * @param  {p5.Vector} v2 the second p5.Vector
	 * @return {Number}     the cross product
	 */
	p5.Vector.cross = function (v1, v2) {
	  return v1.cross(v2);
	};
	
	/**
	 * Calculates the Euclidean distance between two points (considering a
	 * point as a vector object).
	 *
	 * @static
	 * @param  {p5.Vector} v1 the first p5.Vector
	 * @param  {p5.Vector} v2 the second p5.Vector
	 * @return {Number}     the distance
	 */
	p5.Vector.dist = function (v1,v2) {
	  return v1.dist(v2);
	};
	
	/**
	 * Linear interpolate a vector to another vector and return the result as a
	 * new vector.
	 *
	 * @static
	 * @param {p5.Vector} v1 a starting p5.Vector
	 * @param {p5.Vector} v2 the p5.Vector to lerp to
	 * @param {Number}       the amount of interpolation; some value between 0.0
	 *                       (old vector) and 1.0 (new vector). 0.1 is very near
	 *                       the new vector. 0.5 is halfway in between.
	 */
	p5.Vector.lerp = function (v1, v2, amt, target) {
	  if (!target) {
	    target = v1.copy();
	  } else {
	    target.set(v1);
	  }
	  target.lerp(v2, amt);
	  return target;
	};
	
	/**
	 * Calculates and returns the angle (in radians) between two vectors.
	 * @method angleBetween
	 * @static
	 * @param  {p5.Vector} v1 the x, y, and z components of a p5.Vector
	 * @param  {p5.Vector} v2 the x, y, and z components of a p5.Vector
	 * @return {Number}       the angle between (in radians)
	 * @example
	 * <div class="norender">
	 * <code>
	 * var v1 = createVector(1, 0, 0);
	 * var v2 = createVector(0, 1, 0);
	 *
	 * var angle = p5.Vector.angleBetween(v1, v2);
	 * // angle is PI/2
	 * </code>
	 * </div>
	 */
	p5.Vector.angleBetween = function (v1, v2) {
	  var angle = Math.acos(v1.dot(v2) / (v1.mag() * v2.mag()));
	  if (this.p5) {
	    if (this.p5._angleMode === constants.DEGREES) {
	      angle = polarGeometry.radiansToDegrees(angle);
	    }
	  }
	  return angle;
	};
	
	module.exports = p5.Vector;
	
	},{"../core/constants":47,"../core/core":48,"./polargeometry":77}],77:[function(_dereq_,module,exports){
	
	module.exports = {
	
	  degreesToRadians: function(x) {
	    return 2 * Math.PI * x / 360;
	  },
	
	  radiansToDegrees: function(x) {
	    return 360 * x / (2 * Math.PI);
	  }
	
	};
	
	},{}],78:[function(_dereq_,module,exports){
	/**
	 * @module Math
	 * @submodule Random
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	var seeded = false;
	
	// Linear Congruential Generator
	// Variant of a Lehman Generator
	var lcg = (function() {
	  // Set to values from http://en.wikipedia.org/wiki/Numerical_Recipes
	  // m is basically chosen to be large (as it is the max period)
	  // and for its relationships to a and c
	  var m = 4294967296,
	    // a - 1 should be divisible by m's prime factors
	    a = 1664525,
	    // c and m should be co-prime
	    c = 1013904223,
	    seed, z;
	  return {
	    setSeed : function(val) {
	      // pick a random seed if val is undefined or null
	      // the >>> 0 casts the seed to an unsigned 32-bit integer
	      z = seed = (val == null ? Math.random() * m : val) >>> 0;
	    },
	    getSeed : function() {
	      return seed;
	    },
	    rand : function() {
	      // define the recurrence relationship
	      z = (a * z + c) % m;
	      // return a float in [0, 1)
	      // if z = m then z / m = 0 therefore (z % m) / m < 1 always
	      return z / m;
	    }
	  };
	}());
	
	/**
	 * Sets the seed value for random().
	 *
	 * By default, random() produces different results each time the program
	 * is run. Set the seed parameter to a constant to return the same
	 * pseudo-random numbers each time the software is run.
	 *
	 * @method randomSeed
	 * @param {Number} seed   the seed value
	 * @example
	 * <div>
	 * <code>
	 * randomSeed(99);
	 * for (var i=0; i < 100; i++) {
	 *   var r = random(0, 255);
	 *   stroke(r);
	 *   line(i, 0, i, 100);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.randomSeed = function(seed) {
	  lcg.setSeed(seed);
	  seeded = true;
	};
	
	/**
	 * Return a random number.
	 *
	 * Takes either 0, 1 or 2 arguments.
	 * If no argument is given, returns a random number between 0 and 1.
	 * If one argument is given, returns a random number between 0 and the number.
	 * If two arguments are given, returns a random number between them,
	 * inclusive.
	 *
	 * @method random
	 * @param  {Number} min   the lower bound
	 * @param  {Number} max   the upper bound
	 * @return {Number} the random number
	 * @example
	 * <div>
	 * <code>
	 * for (var i = 0; i < 100; i++) {
	 *   var r = random(50);
	 *   stroke(r*5);
	 *   line(50, i, 50+r, i);
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * for (var i = 0; i < 100; i++) {
	 *   var r = random(-50, 50);
	 *   line(50,i,50+r,i);
	 * }
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * // Get a random element from an array
	 * var words = [ "apple", "bear", "cat", "dog" ];
	 * var index = floor(random(words.length));  // Convert to integer
	 * text(words[index],10,50);  // Displays one of the four words
	 * </code>
	 * </div>
	 */
	p5.prototype.random = function (min, max) {
	
	  var rand;
	
	  if (seeded) {
	    rand  = lcg.rand();
	  } else {
	    rand = Math.random();
	  }
	
	  if (arguments.length === 0) {
	    return rand;
	  } else
	  if (arguments.length === 1) {
	    return rand * min;
	  } else {
	    if (min > max) {
	      var tmp = min;
	      min = max;
	      max = tmp;
	    }
	
	    return rand * (max-min) + min;
	  }
	};
	
	
	/**
	 *
	 * Returns a random number fitting a Gaussian, or
	 * normal, distribution. There is theoretically no minimum or maximum
	 * value that randomGaussian() might return. Rather, there is
	 * just a very low probability that values far from the mean will be
	 * returned; and a higher probability that numbers near the mean will
	 * be returned.
	 * <br><br>
	 * Takes either 0, 1 or 2 arguments.<br>
	 * If no args, returns a mean of 0 and standard deviation of 1.<br>
	 * If one arg, that arg is the mean (standard deviation is 1).<br>
	 * If two args, first is mean, second is standard deviation.
	 *
	 * @method randomGaussian
	 * @param  {Number} mean  the mean
	 * @param  {Number} sd    the standard deviation
	 * @return {Number} the random number
	 * @example
	 * <div>
	 * <code>for (var y = 0; y < 100; y++) {
	 *  var x = randomGaussian(50,15);
	 *  line(50, y, x, y);
	 *}
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 *var distribution = new Array(360);
	 *
	 *function setup() {
	 *  createCanvas(100, 100);
	 *  for (var i = 0; i < distribution.length; i++) {
	 *    distribution[i] = floor(randomGaussian(0,15));
	 *  }
	 *}
	 *
	 *function draw() {
	 *  background(204);
	 *
	 *  translate(width/2, width/2);
	 *
	 *  for (var i = 0; i < distribution.length; i++) {
	 *    rotate(TWO_PI/distribution.length);
	 *    stroke(0);
	 *    var dist = abs(distribution[i]);
	 *    line(0, 0, dist, 0);
	 *  }
	 *}
	 * </code>
	 * </div>
	 */
	var y2;
	var previous = false;
	p5.prototype.randomGaussian = function(mean, sd)  {
	  var y1,x1,x2,w;
	  if (previous) {
	    y1 = y2;
	    previous = false;
	  } else {
	    do {
	      x1 = this.random(2) - 1;
	      x2 = this.random(2) - 1;
	      w = x1 * x1 + x2 * x2;
	    } while (w >= 1);
	    w = Math.sqrt((-2 * Math.log(w))/w);
	    y1 = x1 * w;
	    y2 = x2 * w;
	    previous = true;
	  }
	
	  var m = mean || 0;
	  var s = sd || 1;
	  return y1*s + m;
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],79:[function(_dereq_,module,exports){
	/**
	 * @module Math
	 * @submodule Trigonometry
	 * @for p5
	 * @requires core
	 * @requires polargeometry
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var polarGeometry = _dereq_('./polargeometry');
	var constants = _dereq_('../core/constants');
	
	p5.prototype._angleMode = constants.RADIANS;
	
	/**
	 * The inverse of cos(), returns the arc cosine of a value. This function
	 * expects the values in the range of -1 to 1 and values are returned in
	 * the range 0 to PI (3.1415927).
	 *
	 * @method acos
	 * @param  {Number} value the value whose arc cosine is to be returned
	 * @return {Number}       the arc cosine of the given value
	 *
	 * @example
	 * <div class= “norender">
	 * <code>
	 * var a = PI;
	 * var c = cos(a);
	 * var ac = acos(c);
	 * // Prints: "3.1415927 : -1.0 : 3.1415927"
	 * println(a + " : " + c + " : " +  ac);
	 * </code>
	 * </div>
	 *
	 * <div class= “norender">
	 * <code>
	 * var a = PI + PI/4.0;
	 * var c = cos(a);
	 * var ac = acos(c);
	 * // Prints: "3.926991 : -0.70710665 : 2.3561943"
	 * println(a + " : " + c + " : " +  ac);
	 * </code>
	 * </div>
	 */
	p5.prototype.acos = function(ratio) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.acos(ratio);
	  } else {
	    return polarGeometry.radiansToDegrees(Math.acos(ratio));
	  }
	};
	
	/**
	 * The inverse of sin(), returns the arc sine of a value. This function
	 * expects the values in the range of -1 to 1 and values are returned
	 * in the range -PI/2 to PI/2.
	 *
	 * @method asin
	 * @param  {Number} value the value whose arc sine is to be returned
	 * @return {Number}       the arc sine of the given value
	 *
	 * @example
	 * <div class= “norender">
	 * <code>
	 * var a = PI + PI/3;
	 * var s = sin(a);
	 * var as = asin(s);
	 * // Prints: "1.0471976 : 0.86602545 : 1.0471976"
	 * println(a + " : " + s + " : " +  as);
	 * </code>
	 * </div>
	 *
	 * <div class= “norender">
	 * <code>
	 * var a = PI + PI/3.0;
	 * var s = sin(a);
	 * var as = asin(s);
	 * // Prints: "4.1887903 : -0.86602545 : -1.0471976"
	 * println(a + " : " + s + " : " +  as);
	 * </code>
	 * </div>
	 *
	 */
	p5.prototype.asin = function(ratio) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.asin(ratio);
	  } else {
	    return polarGeometry.radiansToDegrees(Math.asin(ratio));
	  }
	};
	
	/**
	 * The inverse of tan(), returns the arc tangent of a value. This function
	 * expects the values in the range of -Infinity to Infinity (exclusive) and
	 * values are returned in the range -PI/2 to PI/2.
	 *
	 * @method atan
	 * @param  {Number} value the value whose arc tangent is to be returned
	 * @return {Number}       the arc tangent of the given value
	 *
	 * @example
	 * <div class= “norender">
	 * <code>
	 * var a = PI + PI/3;
	 * var t = tan(a);
	 * var at = atan(t);
	 * // Prints: "1.0471976 : 1.7320509 : 1.0471976"
	 * println(a + " : " + t + " : " +  at);
	 * </code>
	 * </div>
	 *
	 * <div class= “norender">
	 * <code>
	 * var a = PI + PI/3.0;
	 * var t = tan(a);
	 * var at = atan(t);
	 * // Prints: "4.1887903 : 1.7320513 : 1.0471977"
	 * println(a + " : " + t + " : " +  at);
	 * </code>
	 * </div>
	 *
	 */
	p5.prototype.atan = function(ratio) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.atan(ratio);
	  } else {
	    return polarGeometry.radiansToDegrees(Math.atan(ratio));
	  }
	};
	
	/**
	 * Calculates the angle (in radians) from a specified point to the coordinate
	 * origin as measured from the positive x-axis. Values are returned as a
	 * float in the range from PI to -PI. The atan2() function is most often used
	 * for orienting geometry to the position of the cursor.
	 * <br><br>
	 * Note: The y-coordinate of the point is the first parameter, and the
	 * x-coordinate is the second parameter, due the the structure of calculating
	 * the tangent.
	 *
	 * @method atan2
	 * @param  {Number} y y-coordinate of the point
	 * @param  {Number} x x-coordinate of the point
	 * @return {Number}   the arc tangent of the given point
	 *
	 * @example
	 * <div>
	 * <code>
	 * function draw() {
	 *   background(204);
	 *   translate(width/2, height/2);
	 *   var a = atan2(mouseY-height/2, mouseX-width/2);
	 *   rotate(a);
	 *   rect(-30, -5, 60, 10);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.atan2 = function (y, x) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.atan2(y, x);
	  } else {
	    return polarGeometry.radiansToDegrees(Math.atan2(y, x));
	  }
	};
	
	/**
	 * Calculates the cosine of an angle. This function takes into account the
	 * current angleMode. Values are returned in the range -1 to 1.
	 *
	 * @method cos
	 * @param  {Number} angle the angle
	 * @return {Number}       the cosine of the angle
	 *
	 * @example
	 * <div>
	 * <code>
	 * var a = 0.0;
	 * var inc = TWO_PI/25.0;
	 * for (var i = 0; i < 25; i++) {
	 *   line(i*4, 50, i*4, 50+cos(a)*40.0);
	 *   a = a + inc;
	 * }
	 * </code>
	 * </div>
	 *
	 */
	p5.prototype.cos = function(angle) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.cos(angle);
	  } else {
	    return Math.cos(this.radians(angle));
	  }
	};
	
	/**
	 * Calculates the sine of an angle. This function takes into account the
	 * current angleMode. Values are returned in the range -1 to 1.
	 *
	 * @method sin
	 * @param  {Number} angle the angle
	 * @return {Number}       the sine of the angle
	 *
	 * @example
	 * <div>
	 * <code>
	 * var a = 0.0;
	 * var inc = TWO_PI/25.0;
	 * for (var i = 0; i < 25; i++) {
	 *   line(i*4, 50, i*4, 50+sin(a)*40.0);
	 *   a = a + inc;
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.sin = function(angle) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.sin(angle);
	  } else {
	    return Math.sin(this.radians(angle));
	  }
	};
	
	/**
	 * Calculates the tangent of an angle. This function takes into account
	 * the current angleMode. Values are returned in the range -1 to 1.
	 *
	 * @method tan
	 * @param  {Number} angle the angle
	 * @return {Number}       the tangent of the angle
	 *
	 * @example
	 * <div>
	 * <code>
	 *   var a = 0.0;
	 *   var inc = TWO_PI/50.0;
	 *   for (var i = 0; i < 100; i = i+2) {
	 *     line(i, 50, i, 50+tan(a)*2.0);
	 *     a = a + inc;
	 *   }
	 * </code>
	 * </div>
	 *
	 */
	p5.prototype.tan = function(angle) {
	  if (this._angleMode === constants.RADIANS) {
	    return Math.tan(angle);
	  } else {
	    return Math.tan(this.radians(angle));
	  }
	};
	
	/**
	 * Converts a radian measurement to its corresponding value in degrees.
	 * Radians and degrees are two ways of measuring the same thing. There are
	 * 360 degrees in a circle and 2*PI radians in a circle. For example,
	 * 90° = PI/2 = 1.5707964.
	 *
	 * @method degrees
	 * @param  {Number} radians the radians value to convert to degrees
	 * @return {Number}         the converted angle
	 *
	 *
	 * @example
	 * <div class= “norender">
	 * <code>
	 * var rad = PI/4;
	 * var deg = degrees(rad);
	 * println(rad + " radians is " + deg + " degrees");
	 * // Prints: 45 degrees is 0.7853981633974483 radians
	 * </code>
	 * </div>
	 *
	 */
	p5.prototype.degrees = function(angle) {
	  return polarGeometry.radiansToDegrees(angle);
	};
	
	/**
	 * Converts a degree measurement to its corresponding value in radians.
	 * Radians and degrees are two ways of measuring the same thing. There are
	 * 360 degrees in a circle and 2*PI radians in a circle. For example,
	 * 90° = PI/2 = 1.5707964.
	 *
	 * @method radians
	 * @param  {Number} degrees the degree value to convert to radians
	 * @return {Number}         the converted angle
	 *
	 * @example
	 * <div class= “norender">
	 * <code>
	 * var deg = 45.0;
	 * var rad = radians(deg);
	 * println(deg + " degrees is " + rad + " radians");
	 * // Prints: 45 degrees is 0.7853981633974483 radians
	 * </code>
	 * </div>
	 */
	p5.prototype.radians = function(angle) {
	  return polarGeometry.degreesToRadians(angle);
	};
	
	/**
	 * Sets the current mode of p5 to given mode. Default mode is RADIANS.
	 *
	 * @method angleMode
	 * @param {Number/Constant} mode either RADIANS or DEGREES
	 *
	 * @example
	 * <div>
	 * <code>
	 * function draw(){
	 *   background(204);
	 *   angleMode(DEGREES); // Change the mode to DEGREES
	 *   var a = atan2(mouseY-height/2, mouseX-width/2);
	 *   translate(width/2, height/2);
	 *   push();
	 *   rotate(a);
	 *   rect(-20, -5, 40, 10); // Larger rectangle is rotating in degrees
	 *   pop();
	 *   angleMode(RADIANS); // Change the mode to RADIANS
	 *   rotate(a); // var a stays the same
	 *   rect(-40, -5, 20, 10); // Smaller rectangle is rotating in radians
	 * }
	 * </code>
	 * </div>
	 *
	 */
	p5.prototype.angleMode = function(mode) {
	  if (mode === constants.DEGREES || mode === constants.RADIANS) {
	    this._angleMode = mode;
	  }
	};
	
	module.exports = p5;
	
	},{"../core/constants":47,"../core/core":48,"./polargeometry":77}],80:[function(_dereq_,module,exports){
	/**
	 * @module Typography
	 * @submodule Attributes
	 * @for p5
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Sets the current alignment for drawing text. The parameters LEFT, CENTER,
	 * and RIGHT set the alignment of text in relation to the values for
	 * the x and y parameters of the text() function.
	 *
	 * @method textAlign
	 * @param {Number/Constant} horizAlign horizontal alignment, either LEFT,
	 *                            CENTER, or RIGHT
	 * @param {Number/Constant} vertAlign vertical alignment, either TOP,
	 *                            BOTTOM, CENTER, or BASELINE
	 * @return {Number}
	 * @example
	 * <div>
	 * <code>
	 * textSize(16);
	 * textAlign(RIGHT);
	 * text("ABCD", 50, 30);
	 * textAlign(CENTER);
	 * text("EFGH", 50, 50);
	 * textAlign(LEFT);
	 * text("IJKL", 50, 70);
	 * </code>
	 * </div>
	 */
	p5.prototype.textAlign = function(horizAlign, vertAlign) {
	  return this._renderer.textAlign.apply(this._renderer, arguments);
	};
	
	/**
	 * Sets/gets the spacing, in pixels, between lines of text. This
	 * setting will be used in all subsequent calls to the text() function.
	 *
	 * @method textLeading
	 * @param {Number} leading the size in pixels for spacing between lines
	 * @return {Object|Number}
	 * @example
	 * <div>
	 * <code>
	 * // Text to display. The "\n" is a "new line" character
	 * lines = "L1\nL2\nL3";
	 * textSize(12);
	 *
	 * textLeading(10);  // Set leading to 10
	 * text(lines, 10, 25);
	 *
	 * textLeading(20);  // Set leading to 20
	 * text(lines, 40, 25);
	 *
	 * textLeading(30);  // Set leading to 30
	 * text(lines, 70, 25);
	 * </code>
	 * </div>
	 */
	p5.prototype.textLeading = function(theLeading) {
	  return this._renderer.textLeading.apply(this._renderer, arguments);
	};
	
	/**
	 * Sets/gets the current font size. This size will be used in all subsequent
	 * calls to the text() function. Font size is measured in pixels.
	 *
	 * @method textSize
	 * @param {Number} theSize the size of the letters in units of pixels
	 * @return {Object|Number}
	 * @example
	 * <div>
	 * <code>
	 * textSize(12);
	 * text("Font Size 12", 10, 30);
	 * textSize(14);
	 * text("Font Size 14", 10, 60);
	 * textSize(16);
	 * text("Font Size 16", 10, 90);
	 * </code>
	 * </div>
	 */
	p5.prototype.textSize = function(theSize) {
	  return this._renderer.textSize.apply(this._renderer, arguments);
	};
	
	/**
	 * Sets/gets the style of the text for system fonts to NORMAL, ITALIC, or BOLD.
	 * Note: this may be is overridden by CSS styling. For non-system fonts
	 * (opentype, truetype, etc.) please load styled fonts instead.
	 *
	 * @method textStyle
	 * @param {Number/Constant} theStyle styling for text, either NORMAL,
	 *                            ITALIC, or BOLD
	 * @return {Object|String}
	 * @example
	 * <div>
	 * <code>
	 * strokeWeight(0);
	 * textSize(12);
	 * textStyle(NORMAL);
	 * text("Font Style Normal", 10, 30);
	 * textStyle(ITALIC);
	 * text("Font Style Italic", 10, 60);
	 * textStyle(BOLD);
	 * text("Font Style Bold", 10, 90);
	 * </code>
	 * </div>
	 */
	p5.prototype.textStyle = function(theStyle) {
	  return this._renderer.textStyle.apply(this._renderer, arguments);
	};
	
	/**
	 * Calculates and returns the width of any character or text string.
	 *
	 * @method textWidth
	 * @param {String} theText the String of characters to measure
	 * @return {Number}
	 * @example
	 * <div>
	 * <code>
	 * textSize(28);
	 *
	 * var aChar = 'P';
	 * var cWidth = textWidth(aChar);
	 * text(aChar, 0, 40);
	 * line(cWidth, 0, cWidth, 50);
	 *
	 * var aString = "p5.js";
	 * var sWidth = textWidth(aString);
	 * text(aString, 0, 85);
	 * line(sWidth, 50, sWidth, 100);
	 * </code>
	 * </div>
	 */
	p5.prototype.textWidth = function(theText) {
	  return this._renderer.textWidth.apply(this._renderer, arguments);
	};
	
	/**
	 * Returns the ascent of the current font at its current size. The ascent
	 * represents the distance, in pixels, of the tallest character above
	 * the baseline.
	 *
	 * @return {Number}
	 * @example
	 * <div>
	 * <code>
	 * var base = height * 0.75;
	 * var scalar = 0.8; // Different for each font
	 *
	 * textSize(32);  // Set initial text size
	 * var asc = textAscent() * scalar;  // Calc ascent
	 * line(0, base - asc, width, base - asc);
	 * text("dp", 0, base);  // Draw text on baseline
	 *
	 * textSize(64);  // Increase text size
	 * asc = textAscent() * scalar;  // Recalc ascent
	 * line(40, base - asc, width, base - asc);
	 * text("dp", 40, base);  // Draw text on baseline
	 * </code>
	 * </div>
	 */
	p5.prototype.textAscent = function() {
	  return this._renderer.textAscent();
	};
	
	/**
	 * Returns the descent of the current font at its current size. The descent
	 * represents the distance, in pixels, of the character with the longest
	 * descender below the baseline.
	 *
	 * @return {Number}
	 * @example
	 * <div>
	 * <code>
	 * var base = height * 0.75;
	 * var scalar = 0.8; // Different for each font
	 *
	 * textSize(32);  // Set initial text size
	 * var desc = textDescent() * scalar;  // Calc ascent
	 * line(0, base+desc, width, base+desc);
	 * text("dp", 0, base);  // Draw text on baseline
	 *
	 * textSize(64);  // Increase text size
	 * desc = textDescent() * scalar;  // Recalc ascent
	 * line(40, base + desc, width, base + desc);
	 * text("dp", 40, base);  // Draw text on baseline
	 * </code>
	 * </div>
	 */
	p5.prototype.textDescent = function() {
	  return this._renderer.textDescent();
	};
	
	/**
	 * Helper function to measure ascent and descent.
	 */
	p5.prototype._updateTextMetrics = function() {
	  return this._renderer._updateTextMetrics();
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],81:[function(_dereq_,module,exports){
	/**
	 * @module Typography
	 * @submodule Loading & Displaying
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var constants = _dereq_('../core/constants');
	
	_dereq_('../core/error_helpers');
	
	
	/**
	 * Draws text to the screen. Displays the information specified in the first
	 * parameter on the screen in the position specified by the additional
	 * parameters. A default font will be used unless a font is set with the
	 * textFont() function and a default size will be used unless a font is set
	 * with textSize(). Change the color of the text with the fill() function.
	 * Change the outline of the text with the stroke() and strokeWeight()
	 * functions.
	 * <br><br>
	 * The text displays in relation to the textAlign() function, which gives the
	 * option to draw to the left, right, and center of the coordinates.
	 * <br><br>
	 * The x2 and y2 parameters define a rectangular area to display within and
	 * may only be used with string data. When these parameters are specified,
	 * they are interpreted based on the current rectMode() setting. Text that
	 * does not fit completely within the rectangle specified will not be drawn
	 * to the screen.
	 *
	 * @method text
	 * @param {String} str the alphanumeric symbols to be displayed
	 * @param {Number} x   x-coordinate of text
	 * @param {Number} y   y-coordinate of text
	 * @param {Number} x2  by default, the width of the text box,
	 *                     see rectMode() for more info
	 * @param {Number} y2  by default, the height of the text box,
	 *                     see rectMode() for more info
	 * @return {Object} this
	 * @example
	 * <div>
	 * <code>
	 * textSize(32);
	 * text("word", 10, 30);
	 * fill(0, 102, 153);
	 * text("word", 10, 60);
	 * fill(0, 102, 153, 51);
	 * text("word", 10, 90);
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * s = "The quick brown fox jumped over the lazy dog.";
	 * fill(50);
	 * text(s, 10, 10, 70, 80); // Text wraps within text box
	 * </code>
	 * </div>
	 */
	p5.prototype.text = function(str, x, y, maxWidth, maxHeight) {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  this._validateParameters(
	    'text',
	    args,
	    [
	      ['*', 'Number', 'Number'],
	      ['*', 'Number', 'Number', 'Number', 'Number']
	    ]
	  );
	
	  return (!(this._renderer._doFill || this._renderer._doStroke)) ? this :
	    this._renderer.text.apply(this._renderer, arguments);
	};
	
	/**
	 * Sets the current font that will be drawn with the text() function.
	 *
	 * @method textFont
	 * @param {Object|String} f a font loaded via loadFont(), or a String
	 *  representing a browser-based dfault font.
	 * @return {Object} this
	 * @example
	 * <div>
	 * <code>
	 * fill(0);
	 * textSize(12);
	 * textFont("Georgia");
	 * text("Georgia", 12, 30);
	 * textFont("Helvetica");
	 * text("Helvetica", 12, 60);
	 * </code>
	 * </div>
	 * <div>
	 * <code>
	 * var fontRegular, fontItalic, fontBold;
	 * function preload() {
	 *    fontRegular = loadFont("assets/Regular.otf");
	 *    fontItalic = loadFont("assets/Italic.ttf");
	 *    fontBold = loadFont("assets/Bold.ttf");
	 * }
	 * function setup() {
	 *    background(210);
	 *    fill(0).strokeWeight(0).textSize(10);
	 *    textFont(fontRegular);
	 *    text("Font Style Normal", 10, 30);
	 *    textFont(fontItalic);
	 *    text("Font Style Italic", 10, 50);
	 *    textFont(fontBold);
	 *    text("Font Style Bold", 10, 70);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.textFont = function(theFont, theSize) {
	
	  if (arguments.length) {
	
	    if (!theFont) {
	
	      throw Error('null font passed to textFont');
	    }
	
	    this._renderer._setProperty('_textFont', theFont);
	
	    if (theSize) {
	
	      this._renderer._setProperty('_textSize', theSize);
	      this._renderer._setProperty('_textLeading',
	        theSize * constants._DEFAULT_LEADMULT);
	    }
	
	    return this._renderer._applyTextProperties();
	  }
	
	  return this;
	};
	
	module.exports = p5;
	
	},{"../core/constants":47,"../core/core":48,"../core/error_helpers":51}],82:[function(_dereq_,module,exports){
	/**
	 * This module defines the p5.Font class and functions for
	 * drawing text to the display canvas.
	 * @module Typography
	 * @submodule Font
	 * @requires core
	 * @requires constants
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	var constants = _dereq_('../core/constants');
	
	/*
	 * TODO:
	 *
	 * API:
	 * -- textBounds()
	 * -- getPath()
	 * -- getPoints()
	 *
	 * ===========================================
	 * -- PFont functions:
	 *    PFont.list()
	 *
	 * -- kerning
	 * -- alignment: justified?
	 * -- integrate p5.dom? (later)
	 */
	
	/**
	 * Base class for font handling
	 * @class p5.Font
	 * @constructor
	 * @param {Object} [pInst] pointer to p5 instance
	 */
	p5.Font = function(p) {
	
	  this.parent = p;
	
	  this.cache = {};
	
	  /**
	   * Underlying opentype font implementation
	   * @property font
	   */
	  this.font = undefined;
	};
	
	p5.Font.prototype.list = function() {
	
	  // TODO
	  throw 'not yet implemented';
	};
	
	/**
	 * Returns a tight bounding box for the given text string using this
	 * font (currently only supports single lines)
	 *
	 * @method textBounds
	 * @param  {String} line     a line of text
	 * @param  {Number} x        x-position
	 * @param  {Number} y        y-position
	 * @param  {Number} fontSize font size to use (optional)
	 * @param  {Object} options opentype options (optional)
	 *
	 * @return {Object}          a rectangle object with properties: x, y, w, h
	 *
	 * @example
	 * <div>
	 * <code>
	 * var font;
	 * var textString = 'Lorem ipsum dolor sit amet.';
	 * function preload() {
	 *    font = loadFont('./assets/Regular.otf');
	 * };
	 * function setup() {
	 *    background(210);
	 *
	 *    var bbox = font.textBounds(textString, 10, 30, 12);
	 *    fill(255);
	 *    stroke(0);
	 *    rect(bbox.x, bbox.y, bbox.w, bbox.h);
	 *    fill(0);
	 *    noStroke();
	 *
	 *    textFont(font);
	 *    textSize(12);
	 *    text(textString, 10, 30);
	 * };
	 * </code>
	 * </div>
	 */
	p5.Font.prototype.textBounds = function(str, x, y, fontSize, options) {
	
	  x = x !== undefined ? x : 0;
	  y = y !== undefined ? y : 0;
	  fontSize = fontSize || this.parent._renderer._textSize;
	
	  var result = this.cache[cacheKey('textBounds', str, x, y, fontSize)];
	  if (!result) {
	
	    var xCoords = [], yCoords = [], self = this,
	      scale = this._scale(fontSize), minX, minY, maxX, maxY;
	
	    this.font.forEachGlyph(str, x, y, fontSize, options,
	      function(glyph, gX, gY, gFontSize) {
	
	        xCoords.push(gX);
	        yCoords.push(gY);
	
	        var gm = glyph.getMetrics();
	
	        if (glyph.name !== 'space') {
	
	          xCoords.push(gX + (gm.xMax * scale));
	          yCoords.push(gY + (-gm.yMin * scale));
	          yCoords.push(gY + (-gm.yMax * scale));
	
	        } else { // NOTE: deals with broken metrics for spaces in opentype.js
	
	          xCoords.push(gX + self.font.charToGlyph(' ').advanceWidth *
	            self._scale(fontSize));
	        }
	      });
	
	    minX = Math.max(0, Math.min.apply(null, xCoords));
	    minY = Math.max(0, Math.min.apply(null, yCoords));
	    maxX = Math.max(0, Math.max.apply(null, xCoords));
	    maxY = Math.max(0, Math.max.apply(null, yCoords));
	
	    result = {
	      x: minX,
	      y: minY,
	      h: maxY - minY,
	      w: maxX - minX,
	      advance: minX - x
	    };
	
	    this.cache[cacheKey('textBounds', str, x, y, fontSize)] = result;
	  }
	  //else console.log('cache-hit');
	
	  return result;
	};
	
	
	/**
	 * Computes an array of points following the path for specified text
	 *
	 * @param  {String} txt     a line of text
	 * @param  {Number} x        x-position
	 * @param  {Number} y        y-position
	 * @param  {Number} fontSize font size to use (optional)
	 * @param  {Object} options  an (optional) object that can contain:
	 *
	 * <br>sampleFactor - the ratio of path-length to number of samples
	 * (default=.25); higher values yield more points and are therefore
	 * more precise
	 *
	 * <br>simplifyThreshold - if set to a non-zero value, collinear points will be
	 * be removed from the polygon; the value represents the threshold angle to use
	 * when determining whether two edges are collinear
	 *
	 * @return {Array}  an array of points, each with x, y, alpha (the path angle)
	 */
	p5.Font.prototype.textToPoints = function(txt, x, y, fontSize, options) {
	
	  var xoff = 0, result = [], glyphs = this._getGlyphs(txt);
	
	  fontSize = fontSize || this.parent._renderer._textSize;
	
	  for (var i = 0; i < glyphs.length; i++) {
	
	    var gpath = glyphs[i].getPath(x, y, fontSize),
	      paths = splitPaths(gpath.commands);
	
	    for (var j = 0; j < paths.length; j++) {
	
	      var pts = pathToPoints(paths[j], options);
	
	      for (var k = 0; k < pts.length; k++) {
	        pts[k].x += xoff;
	        result.push(pts[k]);
	      }
	    }
	
	    xoff += glyphs[i].advanceWidth * this._scale(fontSize);
	  }
	
	  return result;
	};
	
	// ----------------------------- End API ------------------------------
	
	/**
	 * Returns the set of opentype glyphs for the supplied string.
	 *
	 * Note that there is not a strict one-to-one mapping between characters
	 * and glyphs, so the list of returned glyphs can be larger or smaller
	 *  than the length of the given string.
	 *
	 * @param  {String} str the string to be converted
	 * @return {array}     the opentype glyphs
	 */
	p5.Font.prototype._getGlyphs = function(str) {
	
	  return this.font.stringToGlyphs(str);
	};
	
	/**
	 * Returns an opentype path for the supplied string and position.
	 *
	 * @param  {String} line     a line of text
	 * @param  {Number} x        x-position
	 * @param  {Number} y        y-position
	 * @param  {Object} options opentype options (optional)
	 * @return {Object}     the opentype path
	 */
	p5.Font.prototype._getPath = function(line, x, y, options) {
	
	  var p = this.parent,
	    ctx = p._renderer.drawingContext,
	    pos = this._handleAlignment(p, ctx, line, x, y);
	
	  return this.font.getPath(line, pos.x, pos.y, p._renderer._textSize, options);
	};
	
	/*
	 * Creates an SVG-formatted path-data string
	 * (See http://www.w3.org/TR/SVG/paths.html#PathData)
	 * from the given opentype path or string/position
	 *
	 * @param  {Object} path    an opentype path, OR the following:
	 *
	 * @param  {String} line     a line of text
	 * @param  {Number} x        x-position
	 * @param  {Number} y        y-position
	 * @param  {Object} options opentype options (optional), set options.decimals
	 * to set the decimal precision of the path-data
	 *
	 * @return {Object}     this p5.Font object
	 */
	p5.Font.prototype._getPathData = function(line, x, y, options) {
	
	  var decimals = 3;
	
	  // create path from string/position
	  if (typeof line === 'string' && arguments.length > 2) {
	
	    line = this._getPath(line, x, y, options);
	  }
	  // handle options specified in 2nd arg
	  else if (typeof x === 'object') {
	
	    options = x;
	  }
	
	  // handle svg arguments
	  if (options && typeof options.decimals === 'number') {
	
	    decimals = options.decimals;
	  }
	
	  return line.toPathData(decimals);
	};
	
	/*
	 * Creates an SVG <path> element, as a string,
	 * from the given opentype path or string/position
	 *
	 * @param  {Object} path    an opentype path, OR the following:
	 *
	 * @param  {String} line     a line of text
	 * @param  {Number} x        x-position
	 * @param  {Number} y        y-position
	 * @param  {Object} options opentype options (optional), set options.decimals
	 * to set the decimal precision of the path-data in the <path> element,
	 *  options.fill to set the fill color for the <path> element,
	 *  options.stroke to set the stroke color for the <path> element,
	 *  options.strokeWidth to set the strokeWidth for the <path> element.
	 *
	 * @return {Object}     this p5.Font object
	 */
	p5.Font.prototype._getSVG = function(line, x, y, options) {
	
	  var decimals = 3;
	
	  // create path from string/position
	  if (typeof line === 'string' && arguments.length > 2) {
	
	    line = this._getPath(line, x, y, options);
	  }
	  // handle options specified in 2nd arg
	  else if (typeof x === 'object') {
	
	    options = x;
	  }
	
	  // handle svg arguments
	  if (options) {
	    if (typeof options.decimals === 'number') {
	      decimals = options.decimals;
	    }
	    if (typeof options.strokeWidth === 'number') {
	      line.strokeWidth = options.strokeWidth;
	    }
	    if (typeof options.fill !== 'undefined') {
	      line.fill = options.fill;
	    }
	    if (typeof options.stroke !== 'undefined') {
	      line.stroke = options.stroke;
	    }
	  }
	
	  return line.toSVG(decimals);
	};
	
	/*
	 * Renders an opentype path or string/position
	 * to the current graphics context
	 *
	 * @param  {Object} path    an opentype path, OR the following:
	 *
	 * @param  {String} line     a line of text
	 * @param  {Number} x        x-position
	 * @param  {Number} y        y-position
	 * @param  {Object} options opentype options (optional)
	 *
	 * @return {Object}     this p5.Font object
	 */
	p5.Font.prototype._renderPath = function(line, x, y, options) {
	
	  var pdata, pg = (options && options.renderer) || this.parent._renderer,
	    ctx = pg.drawingContext;
	
	  if (typeof line === 'object' && line.commands) {
	
	    pdata = line.commands;
	  } else {
	
	    //pos = handleAlignment(p, ctx, line, x, y);
	    pdata = this._getPath(line, x, y, pg._textSize, options).commands;
	  }
	
	  ctx.beginPath();
	  for (var i = 0; i < pdata.length; i += 1) {
	
	    var cmd = pdata[i];
	    if (cmd.type === 'M') {
	      ctx.moveTo(cmd.x, cmd.y);
	    } else if (cmd.type === 'L') {
	      ctx.lineTo(cmd.x, cmd.y);
	    } else if (cmd.type === 'C') {
	      ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	    } else if (cmd.type === 'Q') {
	      ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
	    } else if (cmd.type === 'Z') {
	      ctx.closePath();
	    }
	  }
	
	  // only draw stroke if manually set by user
	  if (pg._doStroke && pg._strokeSet) {
	
	    ctx.stroke();
	  }
	
	  if (pg._doFill) {
	
	    // if fill hasn't been set by user, use default-text-fill
	    ctx.fillStyle = pg._fillSet ? ctx.fillStyle : constants._DEFAULT_TEXT_FILL;
	    ctx.fill();
	  }
	
	  return this;
	};
	
	p5.Font.prototype._textWidth = function(str, fontSize) {
	
	  if (str === ' ') { // special case for now
	
	    return this.font.charToGlyph(' ').advanceWidth * this._scale(fontSize);
	  }
	
	  var bounds = this.textBounds(str, 0, 0, fontSize);
	  return bounds.w + bounds.advance;
	};
	
	p5.Font.prototype._textAscent = function(fontSize) {
	
	  return this.font.ascender * this._scale(fontSize);
	};
	
	p5.Font.prototype._textDescent = function(fontSize) {
	
	  return -this.font.descender * this._scale(fontSize);
	};
	
	p5.Font.prototype._scale = function(fontSize) {
	
	  return (1 / this.font.unitsPerEm) * (fontSize ||
	    this.parent._renderer._textSize);
	};
	
	p5.Font.prototype._handleAlignment = function(p, ctx, line, x, y) {
	
	  var textWidth = this._textWidth(line),
	    textAscent = this._textAscent(),
	    textDescent = this._textDescent(),
	    textHeight = textAscent + textDescent;
	
	  if (ctx.textAlign === constants.CENTER) {
	    x -= textWidth / 2;
	  } else if (ctx.textAlign === constants.RIGHT) {
	    x -= textWidth;
	  }
	
	  if (ctx.textBaseline === constants.TOP) {
	    y += textHeight;
	  } else if (ctx.textBaseline === constants._CTX_MIDDLE) {
	    y += textHeight / 2 - textDescent;
	  } else if (ctx.textBaseline === constants.BOTTOM) {
	    y -= textDescent;
	  }
	
	  return { x: x, y: y };
	};
	
	// path-utils
	
	function pathToPoints(cmds, options) {
	
	  var opts = parseOpts(options, {
	    sampleFactor: 0.1,
	    simplifyThreshold: 0,
	  });
	
	  var len = pointAtLength(cmds,0,1), // total-length
	    t = len / (len * opts.sampleFactor),
	    pts = [];
	
	  for (var i = 0; i < len; i += t) {
	    pts.push(pointAtLength(cmds, i));
	  }
	
	  if (opts.simplifyThreshold) {
	    /*var count = */simplify(pts, opts.simplifyThreshold);
	    //console.log('Simplify: removed ' + count + ' pts');
	  }
	
	  return pts;
	}
	
	function simplify(pts, angle) {
	
	  angle = (typeof angle === 'undefined') ? 0 : angle;
	
	  var num = 0;
	  for (var i = pts.length - 1; pts.length > 3 && i >= 0; --i) {
	
	    if (collinear(at(pts, i - 1), at(pts, i), at(pts, i + 1), angle)) {
	
	      // Remove the middle point
	      pts.splice(i % pts.length, 1);
	      num++;
	    }
	  }
	  return num;
	}
	
	function splitPaths(cmds) {
	
	  var paths = [], current;
	  for (var i = 0; i < cmds.length; i++) {
	    if (cmds[i].type === 'M') {
	      if (current) {
	        paths.push(current);
	      }
	      current = [];
	    }
	    current.push(cmdToArr(cmds[i]));
	  }
	  paths.push(current);
	
	  return paths;
	}
	
	function cmdToArr(cmd) {
	
	  var arr = [ cmd.type ];
	  if (cmd.type === 'M' || cmd.type === 'L') { // moveto or lineto
	    arr.push(cmd.x, cmd.y);
	  } else if (cmd.type === 'C') {
	    arr.push(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
	  } else if (cmd.type === 'Q') {
	    arr.push(cmd.x1, cmd.y1, cmd.x, cmd.y);
	  }
	  // else if (cmd.type === 'Z') { /* no-op */ }
	  return arr;
	}
	
	function parseOpts(options, defaults) {
	
	  if (typeof options !== 'object') {
	    options = defaults;
	  }
	  else {
	    for (var key in defaults) {
	      if (typeof options[key] === 'undefined') {
	        options[key] = defaults[key];
	      }
	    }
	  }
	  return options;
	}
	
	//////////////////////// Helpers ////////////////////////////
	
	function at(v, i) {
	  var s = v.length;
	  return v[i < 0 ? i % s + s : i % s];
	}
	
	function collinear(a, b, c, thresholdAngle) {
	
	  if (!thresholdAngle) {
	    return areaTriangle(a, b, c) === 0;
	  }
	
	  if (typeof collinear.tmpPoint1 === 'undefined') {
	    collinear.tmpPoint1 = [];
	    collinear.tmpPoint2 = [];
	  }
	
	  var ab = collinear.tmpPoint1, bc = collinear.tmpPoint2;
	  ab.x = b.x - a.x;
	  ab.y = b.y - a.y;
	  bc.x = c.x - b.x;
	  bc.y = c.y - b.y;
	
	  var dot = ab.x * bc.x + ab.y * bc.y,
	    magA = Math.sqrt(ab.x * ab.x + ab.y * ab.y),
	    magB = Math.sqrt(bc.x * bc.x + bc.y * bc.y),
	    angle = Math.acos(dot / (magA * magB));
	
	  return angle < thresholdAngle;
	}
	
	function areaTriangle(a, b, c) {
	  return (((b[0] - a[0]) * (c[1] - a[1])) - ((c[0] - a[0]) * (b[1] - a[1])));
	}
	
	// Portions of below code copyright 2008 Dmitry Baranovskiy (via MIT license)
	
	function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	
	  var t1 = 1 - t, t13 = Math.pow(t1, 3), t12 = Math.pow(t1, 2), t2 = t * t,
	    t3 = t2 * t, x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x +
	    t3 * p2x, y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y +
	    t3 * p2y, mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	    my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	    nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	    ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	    ax = t1 * p1x + t * c1x, ay = t1 * p1y + t * c1y,
	    cx = t1 * c2x + t * p2x, cy = t1 * c2y + t * p2y,
	    alpha = (90 - Math.atan2(mx - nx, my - ny) * 180 / Math.PI);
	
	  if (mx > nx || my < ny) { alpha += 180; }
	
	  return { x: x, y: y, m: { x: mx, y: my }, n: { x: nx, y: ny },
	    start: { x: ax, y: ay }, end: { x: cx, y: cy }, alpha: alpha
	  };
	}
	
	function getPointAtSegmentLength(p1x,p1y,c1x,c1y,c2x,c2y,p2x,p2y,length) {
	  return (length == null) ? bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) :
	    findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
	      getTatLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	}
	
	function pointAtLength(path, length, istotal) {
	  path = path2curve(path);
	  var x, y, p, l, sp = '', subpaths = {}, point, len = 0;
	  for (var i = 0, ii = path.length; i < ii; i++) {
	    p = path[i];
	    if (p[0] === 'M') {
	      x = +p[1];
	      y = +p[2];
	    } else {
	      l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	      if (len + l > length) {
	        if (!istotal) {
	          point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5],
	            p[6], length - len);
	          return { x: point.x, y: point.y, alpha: point.alpha };
	        }
	      }
	      len += l;
	      x = +p[5];
	      y = +p[6];
	    }
	    sp += p.shift() + p;
	  }
	  subpaths.end = sp;
	
	  point = istotal ? len : findDotsAtSegment
	    (x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	
	  if (point.alpha) {
	    point = { x: point.x, y: point.y, alpha: point.alpha };
	  }
	
	  return point;
	}
	
	function pathToAbsolute(pathArray) {
	
	  var res = [], x = 0, y = 0, mx = 0, my = 0, start = 0;
	  if (pathArray[0][0] === 'M') {
	    x = +pathArray[0][1];
	    y = +pathArray[0][2];
	    mx = x;
	    my = y;
	    start++;
	    res[0] = ['M', x, y];
	  }
	
	  var dots,crz = pathArray.length===3 && pathArray[0][0]==='M' &&
	    pathArray[1][0].toUpperCase()==='R' && pathArray[2][0].toUpperCase()==='Z';
	
	  for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	    res.push(r = []);
	    pa = pathArray[i];
	    if (pa[0] !== String.prototype.toUpperCase.call(pa[0])) {
	      r[0] = String.prototype.toUpperCase.call(pa[0]);
	      switch (r[0]) {
	        case 'A':
	          r[1] = pa[1];
	          r[2] = pa[2];
	          r[3] = pa[3];
	          r[4] = pa[4];
	          r[5] = pa[5];
	          r[6] = +(pa[6] + x);
	          r[7] = +(pa[7] + y);
	          break;
	        case 'V':
	          r[1] = +pa[1] + y;
	          break;
	        case 'H':
	          r[1] = +pa[1] + x;
	          break;
	        case 'R':
	          dots = [x, y].concat(pa.slice(1));
	          for (var j = 2, jj = dots.length; j < jj; j++) {
	            dots[j] = +dots[j] + x;
	            dots[++j] = +dots[j] + y;
	          }
	          res.pop();
	          res = res.concat(catmullRom2bezier(dots, crz));
	          break;
	        case 'M':
	          mx = +pa[1] + x;
	          my = +pa[2] + y;
	          break;
	        default:
	          for (j = 1, jj = pa.length; j < jj; j++) {
	            r[j] = +pa[j] + ((j % 2) ? x : y);
	          }
	      }
	    } else if (pa[0] === 'R') {
	      dots = [x, y].concat(pa.slice(1));
	      res.pop();
	      res = res.concat(catmullRom2bezier(dots, crz));
	      r = ['R'].concat(pa.slice(-2));
	    } else {
	      for (var k = 0, kk = pa.length; k < kk; k++) {
	        r[k] = pa[k];
	      }
	    }
	    switch (r[0]) {
	      case 'Z':
	        x = mx;
	        y = my;
	        break;
	      case 'H':
	        x = r[1];
	        break;
	      case 'V':
	        y = r[1];
	        break;
	      case 'M':
	        mx = r[r.length - 2];
	        my = r[r.length - 1];
	        break;
	      default:
	        x = r[r.length - 2];
	        y = r[r.length - 1];
	    }
	  }
	  return res;
	}
	
	function path2curve(path, path2) {
	
	  var p = pathToAbsolute(path), p2 = path2 && pathToAbsolute(path2),
	    attrs = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null },
	    attrs2 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null },
	
	    processPath = function(path, d, pcom) {
	      var nx, ny, tq = { T: 1, Q: 1 };
	      if (!path) { return ['C', d.x, d.y, d.x, d.y, d.x, d.y]; }
	      if (!(path[0] in tq)) { d.qx = d.qy = null; }
	      switch (path[0]) {
	        case 'M':
	          d.X = path[1];
	          d.Y = path[2];
	          break;
	        case 'A':
	          path = ['C'].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
	          break;
	        case 'S':
	          if (pcom === 'C' || pcom === 'S') {
	            nx = d.x * 2 - d.bx;
	            ny = d.y * 2 - d.by;
	          } else {
	            nx = d.x;
	            ny = d.y;
	          }
	          path = ['C', nx, ny].concat(path.slice(1));
	          break;
	        case 'T':
	          if (pcom === 'Q' || pcom === 'T') {
	            d.qx = d.x * 2 - d.qx;
	            d.qy = d.y * 2 - d.qy;
	          } else {
	            d.qx = d.x;
	            d.qy = d.y;
	          }
	          path = ['C'].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	          break;
	        case 'Q':
	          d.qx = path[1];
	          d.qy = path[2];
	          path = ['C'].concat(q2c(d.x,d.y,path[1],path[2],path[3],path[4]));
	          break;
	        case 'L':
	          path = ['C'].concat(l2c(d.x, d.y, path[1], path[2]));
	          break;
	        case 'H':
	          path = ['C'].concat(l2c(d.x, d.y, path[1], d.y));
	          break;
	        case 'V':
	          path = ['C'].concat(l2c(d.x, d.y, d.x, path[1]));
	          break;
	        case 'Z':
	          path = ['C'].concat(l2c(d.x, d.y, d.X, d.Y));
	          break;
	      }
	      return path;
	    },
	
	    fixArc = function(pp, i) {
	      if (pp[i].length > 7) {
	        pp[i].shift();
	        var pi = pp[i];
	        while (pi.length) {
	          pcoms1[i] = 'A';
	          if (p2) { pcoms2[i] = 'A'; }
	          pp.splice(i++, 0, ['C'].concat(pi.splice(0, 6)));
	        }
	        pp.splice(i, 1);
	        ii = Math.max(p.length, p2 && p2.length || 0);
	      }
	    },
	
	    fixM = function(path1, path2, a1, a2, i) {
	      if (path1 && path2 && path1[i][0] === 'M' && path2[i][0] !== 'M') {
	        path2.splice(i, 0, ['M', a2.x, a2.y]);
	        a1.bx = 0;
	        a1.by = 0;
	        a1.x = path1[i][1];
	        a1.y = path1[i][2];
	        ii = Math.max(p.length, p2 && p2.length || 0);
	      }
	    },
	
	    pcoms1 = [], // path commands of original path p
	    pcoms2 = [], // path commands of original path p2
	    pfirst = '', // temporary holder for original path command
	    pcom = ''; // holder for previous path command of original path
	
	  for (var i = 0, ii = Math.max(p.length, p2 && p2.length || 0); i < ii; i++) {
	    if (p[i]) { pfirst = p[i][0]; } // save current path command
	
	    if (pfirst !== 'C') {
	      pcoms1[i] = pfirst; // Save current path command
	      if (i) { pcom = pcoms1[i - 1]; } // Get previous path command pcom
	    }
	    p[i] = processPath(p[i], attrs, pcom);
	
	    if (pcoms1[i] !== 'A' && pfirst === 'C') { pcoms1[i] = 'C'; }
	
	    fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	    if (p2) { // the same procedures is done to p2
	      if (p2[i]) { pfirst = p2[i][0]; }
	      if (pfirst !== 'C') {
	        pcoms2[i] = pfirst;
	        if (i) { pcom = pcoms2[i - 1]; }
	      }
	      p2[i] = processPath(p2[i], attrs2, pcom);
	
	      if (pcoms2[i] !== 'A' && pfirst === 'C') { pcoms2[i] = 'C'; }
	
	      fixArc(p2, i);
	    }
	    fixM(p, p2, attrs, attrs2, i);
	    fixM(p2, p, attrs2, attrs, i);
	    var seg = p[i], seg2 = p2 && p2[i], seglen = seg.length,
	      seg2len = p2 && seg2.length;
	    attrs.x = seg[seglen - 2];
	    attrs.y = seg[seglen - 1];
	    attrs.bx = parseFloat(seg[seglen - 4]) || attrs.x;
	    attrs.by = parseFloat(seg[seglen - 3]) || attrs.y;
	    attrs2.bx = p2 && (parseFloat(seg2[seg2len - 4]) || attrs2.x);
	    attrs2.by = p2 && (parseFloat(seg2[seg2len - 3]) || attrs2.y);
	    attrs2.x = p2 && seg2[seg2len - 2];
	    attrs2.y = p2 && seg2[seg2len - 1];
	  }
	
	  return p2 ? [p, p2] : p;
	}
	
	function a2c(x1, y1, rx, ry, angle, lac, sweep_flag, x2, y2, recursive) {
	  // for more information of where this Math came from visit:
	  // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	  var PI = Math.PI, _120 = PI * 120 / 180, f1, f2, cx, cy,
	    rad = PI / 180 * (+angle || 0), res = [], xy,
	    rotate = function (x, y, rad) {
	      var X = x * Math.cos(rad) - y * Math.sin(rad),
	        Y = x * Math.sin(rad) + y * Math.cos(rad);
	      return { x: X, y: Y };
	    };
	  if (!recursive) {
	    xy = rotate(x1, y1, -rad);
	    x1 = xy.x;
	    y1 = xy.y;
	    xy = rotate(x2, y2, -rad);
	    x2 = xy.x;
	    y2 = xy.y;
	    var x = (x1 - x2) / 2, y = (y1 - y2) / 2,
	      h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
	    if (h > 1) {
	      h = Math.sqrt(h);
	      rx = h * rx;
	      ry = h * ry;
	    }
	    var rx2 = rx * rx, ry2 = ry * ry,
	      k = (lac === sweep_flag ? -1 : 1) * Math.sqrt(Math.abs
	        ((rx2 * ry2 - rx2 * y * y - ry2 * x * x)/(rx2 * y * y + ry2 * x * x)));
	
	    cx = k * rx * y / ry + (x1 + x2) / 2;
	    cy = k * -ry * x / rx + (y1 + y2) / 2;
	    f1 = Math.asin(((y1 - cy) / ry).toFixed(9));
	    f2 = Math.asin(((y2 - cy) / ry).toFixed(9));
	
	    f1 = x1 < cx ? PI - f1 : f1;
	    f2 = x2 < cx ? PI - f2 : f2;
	
	    if (f1 < 0) { f1 = PI * 2 + f1; }
	    if (f2 < 0) { f2 = PI * 2 + f2; }
	
	    if (sweep_flag && f1 > f2) {
	      f1 = f1 - PI * 2;
	    }
	    if (!sweep_flag && f2 > f1) {
	      f2 = f2 - PI * 2;
	    }
	  } else {
	    f1 = recursive[0];
	    f2 = recursive[1];
	    cx = recursive[2];
	    cy = recursive[3];
	  }
	  var df = f2 - f1;
	  if (Math.abs(df) > _120) {
	    var f2old = f2, x2old = x2, y2old = y2;
	    f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	    x2 = cx + rx * Math.cos(f2);
	    y2 = cy + ry * Math.sin(f2);
	    res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old,
	      [f2, f2old, cx, cy]);
	  }
	  df = f2 - f1;
	  var c1 = Math.cos(f1),
	    s1 = Math.sin(f1),
	    c2 = Math.cos(f2),
	    s2 = Math.sin(f2),
	    t = Math.tan(df / 4),
	    hx = 4 / 3 * rx * t,
	    hy = 4 / 3 * ry * t,
	    m1 = [x1, y1],
	    m2 = [x1 + hx * s1, y1 - hy * c1],
	    m3 = [x2 + hx * s2, y2 - hy * c2],
	    m4 = [x2, y2];
	  m2[0] = 2 * m1[0] - m2[0];
	  m2[1] = 2 * m1[1] - m2[1];
	  if (recursive) {
	    return [m2, m3, m4].concat(res);
	  } else {
	    res = [m2, m3, m4].concat(res).join().split(',');
	    var newres = [];
	    for (var i = 0, ii = res.length; i < ii; i++) {
	      newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i],
	        res[i + 1], rad).x;
	    }
	    return newres;
	  }
	}
	
	// http://schepers.cc/getting-to-the-point
	function catmullRom2bezier(crp, z) {
	  var d = [];
	  for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	    var p = [{
	      x: +crp[i - 2],
	      y: +crp[i - 1]
	    }, {
	      x: +crp[i],
	      y: +crp[i + 1]
	    }, {
	      x: +crp[i + 2],
	      y: +crp[i + 3]
	    }, {
	      x: +crp[i + 4],
	      y: +crp[i + 5]
	    }];
	    if (z) {
	      if (!i) {
	        p[0] = {
	          x: +crp[iLen - 2],
	          y: +crp[iLen - 1]
	        };
	      } else if (iLen - 4 === i) {
	        p[3] = {
	          x: +crp[0],
	          y: +crp[1]
	        };
	      } else if (iLen - 2 === i) {
	        p[2] = {
	          x: +crp[0],
	          y: +crp[1]
	        };
	        p[3] = {
	          x: +crp[2],
	          y: +crp[3]
	        };
	      }
	    } else {
	      if (iLen - 4 === i) {
	        p[3] = p[2];
	      } else if (!i) {
	        p[0] = {
	          x: +crp[i],
	          y: +crp[i + 1]
	        };
	      }
	    }
	    d.push(['C', (-p[0].x + 6 * p[1].x + p[2].x) / 6, (-p[0].y + 6 * p[1].y +
	      p[2].y) / 6, (p[1].x + 6 * p[2].x - p[3].x) / 6, (p[1].y + 6 * p[2].y -
	      p[3].y) / 6, p[2].x, p[2].y ]);
	  }
	
	  return d;
	}
	
	function l2c(x1, y1, x2, y2) { return [x1, y1, x2, y2, x2, y2]; }
	
	function q2c(x1, y1, ax, ay, x2, y2) {
	  var _13 = 1 / 3, _23 = 2 / 3;
	  return [
	    _13 * x1 + _23 * ax, _13 * y1 + _23 * ay,
	    _13 * x2 + _23 * ax, _13 * y2 + _23 * ay, x2, y2
	  ];
	}
	
	function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	  if (z == null) { z = 1; }
	  z = z > 1 ? 1 : z < 0 ? 0 : z;
	  var z2 = z / 2,
	    n = 12, Tvalues = [-0.1252, 0.1252, -0.3678, 0.3678, -0.5873, 0.5873,
	       -0.7699, 0.7699, -0.9041, 0.9041, -0.9816, 0.9816],
	    sum = 0, Cvalues = [0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032,
	      0.1601, 0.1601, 0.1069, 0.1069, 0.0472, 0.0472 ];
	  for (var i = 0; i < n; i++) {
	    var ct = z2 * Tvalues[i] + z2,
	      xbase = base3(ct, x1, x2, x3, x4),
	      ybase = base3(ct, y1, y2, y3, y4),
	      comb = xbase * xbase + ybase * ybase;
	    sum += Cvalues[i] * Math.sqrt(comb);
	  }
	  return z2 * sum;
	}
	
	function getTatLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	  if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	    return;
	  }
	  var t = 1, step = t / 2, t2 = t - step, l, e = 0.01;
	  l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	  while (Math.abs(l - ll) > e) {
	    step /= 2;
	    t2 += (l < ll ? 1 : -1) * step;
	    l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	  }
	  return t2;
	}
	
	function base3(t, p1, p2, p3, p4) {
	  var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	    t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	  return t * t2 - 3 * p1 + 3 * p2;
	}
	
	function cacheKey() {
	  var args = new Array(arguments.length);
	  for (var i = 0; i < args.length; ++i) {
	    args[i] = arguments[i];
	  }
	  i = args.length;
	  var hash = '';
	  while (i--) {
	    hash += (args[i] === Object(args[i])) ?
	      JSON.stringify(args[i]) : args[i];
	  }
	  return hash;
	}
	
	module.exports = p5.Font;
	
	},{"../core/constants":47,"../core/core":48}],83:[function(_dereq_,module,exports){
	/**
	 * @module Data
	 * @submodule Array Functions
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Adds a value to the end of an array. Extends the length of
	 * the array by one. Maps to Array.push().
	 *
	 * @method append
	 * @param {Array} array Array to append
	 * @param {any} value to be added to the Array
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *
	 * var myArray = new Array("Mango", "Apple", "Papaya")
	 * print(myArray) // ["Mango", "Apple", "Papaya"]
	 *
	 * append(myArray, "Peach")
	 * print(myArray) // ["Mango", "Apple", "Papaya", "Peach"]
	 *
	 * }
	 * </div></code>
	 */
	p5.prototype.append = function(array, value) {
	  array.push(value);
	  return array;
	};
	
	/**
	 * Copies an array (or part of an array) to another array. The src array is
	 * copied to the dst array, beginning at the position specified by
	 * srcPosition and into the position specified by dstPosition. The number of
	 * elements to copy is determined by length. Note that copying values
	 * overwrites existing values in the destination array. To append values
	 * instead of overwriting them, use concat().
	 * <br><br>
	 * The simplified version with only two arguments, arrayCopy(src, dst),
	 * copies an entire array to another of the same size. It is equivalent to
	 * arrayCopy(src, 0, dst, 0, src.length).
	 * <br><br>
	 * Using this function is far more efficient for copying array data than
	 * iterating through a for() loop and copying each element individually.
	 *
	 * @method arrayCopy
	 * @param {Array}  src           the source Array
	 * @param {Number} [srcPosition] starting position in the source Array
	 * @param {Array}  dst           the destination Array
	 * @param {Number} [dstPosition] starting position in the destination Array
	 * @param {Nimber} [length]      number of Array elements to be copied
	 *
	 * @example
	 *  <div class="norender"><code>
	 *  function setup() {
	 *
	 *    var src = new Array("A", "B", "C");
	 *    var dst = new Array( 1 ,  2 ,  3 );
	 *    var srcPosition = 1;
	 *    var dstPosition = 0;
	 *    var length = 2;
	 *
	 *    print(src); // ["A", "B", "C"]
	 *    print(dst); // [ 1 ,  2 ,  3 ]
	 *
	 *    arrayCopy(src, srcPosition, dst, dstPosition, length);
	 *    print(dst); // ["B", "C", 3]
	 *
	 *    }
	 *  </div></code>
	 */
	p5.prototype.arrayCopy = function(
	  src,
	  srcPosition,
	  dst,
	  dstPosition,
	  length) {
	
	  // the index to begin splicing from dst array
	  var start,
	      end;
	
	  if (typeof length !== 'undefined') {
	
	    end = Math.min(length, src.length);
	    start = dstPosition;
	    src = src.slice(srcPosition, end + srcPosition);
	
	  } else {
	
	    if (typeof dst !== 'undefined') { // src, dst, length
	      // rename  so we don't get confused
	      end = dst;
	      end = Math.min(end, src.length);
	    } else { // src, dst
	      end = src.length;
	    }
	
	    start = 0;
	    // rename  so we don't get confused
	    dst = srcPosition;
	    src = src.slice(0, end);
	  }
	
	  // Since we are not returning the array and JavaScript is pass by reference
	  // we must modify the actual values of the array
	  // instead of reassigning arrays
	  Array.prototype.splice.apply(dst, [start, end].concat(src));
	
	};
	
	/**
	 * Concatenates two arrays, maps to Array.concat(). Does not modify the
	 * input arrays.
	 *
	 * @method concat
	 * @param {Array} a first Array to concatenate
	 * @param {Array} b second Array to concatenate
	 * @return {Array} concatenated array
	 *
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var arr1 = new Array("A", "B", "C");
	 *   var arr2 = new Array( 1 ,  2 ,  3 );
	 *
	 *   print(arr1); // ["A","B","C"]
	 *   print(arr2); // [1,2,3]
	 *
	 *   var arr3 = concat(arr1, arr2);
	 *
	 *   print(arr1); // ["A","B","C"]
	 *   print(arr2); // [1,2,3]
	 *   print(arr3); // ["A","B","C",1,2,3]
	 *
	 * }
	 * </div></code>
	 */
	p5.prototype.concat = function(list0, list1) {
	  return list0.concat(list1);
	};
	
	/**
	 * Reverses the order of an array, maps to Array.reverse()
	 *
	 * @method reverse
	 * @param {Array} list Array to reverse
	 * @example
	 * <div class="norender"><code>
	 * function setup() {
	 *   var myArray = new Array("A", "B", "C");
	 *   print(myArray); // ["A","B","C"]
	 *
	 *   reverse(myArray);
	 *   print(myArray); // ["C","B","A"]
	 * }
	 * </div></code>
	 */
	p5.prototype.reverse = function(list) {
	  return list.reverse();
	};
	
	/**
	 * Decreases an array by one element and returns the shortened array,
	 * maps to Array.pop().
	 *
	 * @method shorten
	 * @param  {Array} list Array to shorten
	 * @return {Array} shortened Array
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var myArray = new Array("A", "B", "C");
	 *   print(myArray); // ["A","B","C"]
	 *
	 *   var newArray = shorten(myArray);
	 *   print(myArray); // ["A","B","C"]
	 *   print(newArray); // ["A","B"]
	 * }
	 * </div></code>
	 */
	p5.prototype.shorten = function(list) {
	  list.pop();
	  return list;
	};
	
	/**
	 * Randomizes the order of the elements of an array. Implements
	 * <a href="http://Bost.Ocks.org/mike/shuffle/" target=_blank>
	 * Fisher-Yates Shuffle Algorithm</a>.
	 *
	 * @method shuffle
	 * @param  {Array}   array  Array to shuffle
	 * @param  {Boolean} [bool] modify passed array
	 * @return {Array}   shuffled Array
	 * @example
	 * <div><code>
	 * function setup() {
	 *   var regularArr = ['ABC', 'def', createVector(), TAU, Math.E];
	 *   print(regularArr);
	 *   shuffle(regularArr, true); // force modifications to passed array
	 *   print(regularArr);
	 *
	 *   // By default shuffle() returns a shuffled cloned array:
	 *   var newArr = shuffle(regularArr);
	 *   print(regularArr);
	 *   print(newArr);
	 * }
	 * </code></div>
	 */
	p5.prototype.shuffle = function(arr, bool) {
	  var isView = ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(arr);
	  arr = bool || isView ? arr : arr.slice();
	
	  var rnd, tmp, idx = arr.length;
	  while (idx > 1) {
	    rnd = Math.random()*idx | 0;
	
	    tmp = arr[--idx];
	    arr[idx] = arr[rnd];
	    arr[rnd] = tmp;
	  }
	
	  return arr;
	};
	
	/**
	 * Sorts an array of numbers from smallest to largest, or puts an array of
	 * words in alphabetical order. The original array is not modified; a
	 * re-ordered array is returned. The count parameter states the number of
	 * elements to sort. For example, if there are 12 elements in an array and
	 * count is set to 5, only the first 5 elements in the array will be sorted.
	 *
	 * @method sort
	 * @param {Array} list Array to sort
	 * @param {Number} [count] number of elements to sort, starting from 0
	 *
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var words = new Array("banana", "apple", "pear","lime");
	 *   print(words); // ["banana", "apple", "pear", "lime"]
	 *   var count = 4; // length of array
	 *
	 *   sort(words, count);
	 *   print(words); // ["apple", "banana", "lime", "pear"]
	 * }
	 * </div></code>
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var numbers = new Array(2,6,1,5,14,9,8,12);
	 *   print(numbers); // [2,6,1,5,14,9,8,12]
	 *   var count = 5; // Less than the length of the array
	 *
	 *   sort(numbers, count);
	 *   print(numbers); // [1,2,5,6,14,9,8,12]
	 * }
	 * </div></code>
	 */
	p5.prototype.sort = function(list, count) {
	  var arr = count ? list.slice(0, Math.min(count, list.length)) : list;
	  var rest = count ? list.slice(Math.min(count, list.length)) : [];
	  if (typeof arr[0] === 'string') {
	    arr = arr.sort();
	  } else {
	    arr = arr.sort(function(a,b){return a-b;});
	  }
	  return arr.concat(rest);
	};
	
	/**
	 * Inserts a value or an array of values into an existing array. The first
	 * parameter specifies the initial array to be modified, and the second
	 * parameter defines the data to be inserted. The third parameter is an index
	 * value which specifies the array position from which to insert data.
	 * (Remember that array index numbering starts at zero, so the first position
	 * is 0, the second position is 1, and so on.)
	 *
	 * @method splice
	 * @param {Array}  list Array to splice into
	 * @param {any}    value value to be spliced in
	 * @param {Number} position in the array from which to insert data
	 *
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var myArray = new Array(0,1,2,3,4);
	 *   var insArray = new Array("A","B","C");
	 *   print(myArray); // [0,1,2,3,4]
	 *   print(insArray); // ["A","B","C"]
	 *
	 *   splice(myArray, insArray, 3);
	 *   print(myArray); // [0,1,2,"A","B","C",3,4]
	 * }
	 * </div></code>
	 */
	p5.prototype.splice = function(list, value, index) {
	
	  // note that splice returns spliced elements and not an array
	  Array.prototype.splice.apply(list, [index, 0].concat(value));
	
	  return list;
	};
	
	/**
	 * Extracts an array of elements from an existing array. The list parameter
	 * defines the array from which the elements will be copied, and the start
	 * and count parameters specify which elements to extract. If no count is
	 * given, elements will be extracted from the start to the end of the array.
	 * When specifying the start, remember that the first array element is 0.
	 * This function does not change the source array.
	 *
	 * @method subset
	 * @param  {Array}  list    Array to extract from
	 * @param  {Number} start   position to begin
	 * @param  {Number} [count] number of values to extract
	 * @return {Array}          Array of extracted elements
	 *
	 * @example
	 * <div class = "norender"><code>
	 * function setup() {
	 *   var myArray = new Array(1,2,3,4,5);
	 *   print(myArray); // [1,2,3,4,5]
	 *
	 *   var sub1 = subset(myArray, 0, 3);
	 *   var sub2 = subset(myArray, 2, 2);
	 *   print(sub1); // [1,2,3]
	 *   print(sub2); // [3,4]
	 * }
	 * </div></code>
	 */
	p5.prototype.subset = function(list, start, count) {
	  if (typeof count !== 'undefined') {
	    return list.slice(start, start + count);
	  } else {
	    return list.slice(start, list.length);
	  }
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],84:[function(_dereq_,module,exports){
	/**
	 * @module Data
	 * @submodule Conversion
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * Converts a string to its floating point representation. The contents of a
	 * string must resemble a number, or NaN (not a number) will be returned.
	 * For example, float("1234.56") evaluates to 1234.56, but float("giraffe")
	 * will return NaN.
	 *
	 * @method float
	 * @param {String}  str float string to parse
	 * @return {Number}     floating point representation of string
	 * @example
	 * <div><code>
	 * var str = '20';
	 * var diameter = float(str);
	 * ellipse(width/2, height/2, diameter, diameter);
	 * </code></div>
	 */
	p5.prototype.float = function(str) {
	  return parseFloat(str);
	};
	
	/**
	 * Converts a boolean, string, or float to its integer representation.
	 * When an array of values is passed in, then an int array of the same length
	 * is returned.
	 *
	 * @method int
	 * @param {String|Boolean|Number|Array} n value to parse
	 * @return {Number}                     integer representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(int("10")); // 10
	 * print(int(10.31)); // 10
	 * print(int(-10)); // -10
	 * print(int(true)); // 1
	 * print(int(false)); // 0
	 * print(int([false, true, "10.3", 9.8])); // [0, 1, 10, 9]
	 * </code></div>
	 */
	p5.prototype.int = function(n, radix) {
	  if (typeof n === 'string') {
	    radix = radix || 10;
	    return parseInt(n, radix);
	  } else if (typeof n === 'number') {
	    return n | 0;
	  } else if (typeof n === 'boolean') {
	    return n ? 1 : 0;
	  } else if (n instanceof Array) {
	    return n.map(function(n) { return p5.prototype.int(n, radix); });
	  }
	};
	
	/**
	 * Converts a boolean, string or number to its string representation.
	 * When an array of values is passed in, then an array of strings of the same
	 * length is returned.
	 *
	 * @method str
	 * @param {String|Boolean|Number|Array} n value to parse
	 * @return {String}                     string representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(str("10"));  // "10"
	 * print(str(10.31)); // "10.31"
	 * print(str(-10));   // "-10"
	 * print(str(true));  // "true"
	 * print(str(false)); // "false"
	 * print(str([true, "10.3", 9.8])); // [ "true", "10.3", "9.8" ]
	 * </code></div>
	 */
	p5.prototype.str = function(n) {
	  if (n instanceof Array) {
	    return n.map(p5.prototype.str);
	  } else {
	    return String(n);
	  }
	};
	
	/**
	 * Converts a number or string to its boolean representation.
	 * For a number, any non-zero value (positive or negative) evaluates to true,
	 * while zero evaluates to false. For a string, the value "true" evaluates to
	 * true, while any other value evaluates to false. When an array of number or
	 * string values is passed in, then a array of booleans of the same length is
	 * returned.
	 *
	 * @method boolean
	 * @param {String|Boolean|Number|Array} n value to parse
	 * @return {Boolean}                    boolean representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(boolean(0));               // false
	 * print(boolean(1));               // true
	 * print(boolean("true"));          // true
	 * print(boolean("abcd"));          // false
	 * print(boolean([0, 12, "true"])); // [false, true, false]
	 * </code></div>
	 */
	p5.prototype.boolean = function(n) {
	  if (typeof n === 'number') {
	    return n !== 0;
	  } else if (typeof n === 'string') {
	    return n.toLowerCase() === 'true';
	  } else if (typeof n === 'boolean') {
	    return n;
	  } else if (n instanceof Array) {
	    return n.map(p5.prototype.boolean);
	  }
	};
	
	/**
	 * Converts a number, string or boolean to its byte representation.
	 * A byte can be only a whole number between -128 and 127, so when a value
	 * outside of this range is converted, it wraps around to the corresponding
	 * byte representation. When an array of number, string or boolean values is
	 * passed in, then an array of bytes the same length is returned.
	 *
	 * @method byte
	 * @param {String|Boolean|Number|Array} n value to parse
	 * @return {Number}                     byte representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(byte(127));               // 127
	 * print(byte(128));               // -128
	 * print(byte(23.4));              // 23
	 * print(byte("23.4"));            // 23
	 * print(byte(true));              // 1
	 * print(byte([0, 255, "100"]));   // [0, -1, 100]
	 * </code></div>
	 */
	p5.prototype.byte = function(n) {
	  var nn = p5.prototype.int(n, 10);
	  if (typeof nn === 'number') {
	    return ((nn + 128) % 256) - 128;
	  } else if (nn instanceof Array) {
	    return nn.map(p5.prototype.byte);
	  }
	};
	
	/**
	 * Converts a number or string to its corresponding single-character
	 * string representation. If a string parameter is provided, it is first
	 * parsed as an integer and then translated into a single-character string.
	 * When an array of number or string values is passed in, then an array of
	 * single-character strings of the same length is returned.
	 *
	 * @method char
	 * @param {String|Number|Array} n value to parse
	 * @return {String}             string representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(char(65));                     // "A"
	 * print(char("65"));                   // "A"
	 * print(char([65, 66, 67]));           // [ "A", "B", "C" ]
	 * print(join(char([65, 66, 67]), '')); // "ABC"
	 * </code></div>
	 */
	p5.prototype.char = function(n) {
	  if (typeof n === 'number' && !isNaN(n)) {
	    return String.fromCharCode(n);
	  } else if (n instanceof Array) {
	    return n.map(p5.prototype.char);
	  } else if (typeof n === 'string') {
	    return p5.prototype.char(parseInt(n, 10));
	  }
	};
	
	/**
	 * Converts a single-character string to its corresponding integer
	 * representation. When an array of single-character string values is passed
	 * in, then an array of integers of the same length is returned.
	 *
	 * @method unchar
	 * @param {String|Array} n value to parse
	 * @return {Number}      integer representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(unchar("A"));               // 65
	 * print(unchar(["A", "B", "C"]));   // [ 65, 66, 67 ]
	 * print(unchar(split("ABC", "")));  // [ 65, 66, 67 ]
	 * </code></div>
	 */
	p5.prototype.unchar = function(n) {
	  if (typeof n === 'string' && n.length === 1) {
	    return n.charCodeAt(0);
	  } else if (n instanceof Array) {
	    return n.map(p5.prototype.unchar);
	  }
	};
	
	/**
	 * Converts a number to a string in its equivalent hexadecimal notation. If a
	 * second parameter is passed, it is used to set the number of characters to
	 * generate in the hexadecimal notation. When an array is passed in, an
	 * array of strings in hexadecimal notation of the same length is returned.
	 *
	 * @method hex
	 * @param {Number|Array} n value to parse
	 * @return {String}      hexadecimal string representation of value
	 * @example
	 * <div class='norender'><code>
	 * print(hex(255));               // "000000FF"
	 * print(hex(255, 6));            // "0000FF"
	 * print(hex([0, 127, 255], 6));  // [ "000000", "00007F", "0000FF" ]
	 * </code></div>
	 */
	p5.prototype.hex = function(n, digits) {
	  digits = (digits === undefined || digits === null) ? digits = 8 : digits;
	  if (n instanceof Array) {
	    return n.map(function(n) { return p5.prototype.hex(n, digits); });
	  } else if (typeof n === 'number') {
	    if (n < 0) {
	      n = 0xFFFFFFFF + n + 1;
	    }
	    var hex = Number(n).toString(16).toUpperCase();
	    while (hex.length < digits) {
	      hex = '0' + hex;
	    }
	    if (hex.length >= digits) {
	      hex = hex.substring(hex.length - digits, hex.length);
	    }
	    return hex;
	  }
	};
	
	/**
	 * Converts a string representation of a hexadecimal number to its equivalent
	 * integer value. When an array of strings in hexadecimal notation is passed
	 * in, an array of integers of the same length is returned.
	 *
	 * @method unhex
	 * @param {String|Array} n value to parse
	 * @return {Number}      integer representation of hexadecimal value
	 * @example
	 * <div class='norender'><code>
	 * print(unhex("A"));                // 10
	 * print(unhex("FF"));               // 255
	 * print(unhex(["FF", "AA", "00"])); // [ 255, 170, 0 ]
	 * </code></div>
	 */
	p5.prototype.unhex = function(n) {
	  if (n instanceof Array) {
	    return n.map(p5.prototype.unhex);
	  } else {
	    return parseInt('0x' + n, 16);
	  }
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],85:[function(_dereq_,module,exports){
	/**
	 * @module Data
	 * @submodule String Functions
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	//return p5; //LM is this a mistake?
	
	/**
	 * Combines an array of Strings into one String, each separated by the
	 * character(s) used for the separator parameter. To join arrays of ints or
	 * floats, it's necessary to first convert them to Strings using nf() or
	 * nfs().
	 *
	 * @method join
	 * @param  {Array}  list      array of Strings to be joined
	 * @param  {String} separator String to be placed between each item
	 * @return {String}           joined String
	 * @example
	 * <div>
	 * <code>
	 * var array = ["Hello", "world!"]
	 * var separator = " "
	 * var message = join(array, separator);
	 * text(message, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.join = function(list, separator) {
	  return list.join(separator);
	};
	
	/**
	 * This function is used to apply a regular expression to a piece of text,
	 * and return matching groups (elements found inside parentheses) as a
	 * String array. If there are no matches, a null value will be returned.
	 * If no groups are specified in the regular expression, but the sequence
	 * matches, an array of length 1 (with the matched text as the first element
	 * of the array) will be returned.
	 * <br><br>
	 * To use the function, first check to see if the result is null. If the
	 * result is null, then the sequence did not match at all. If the sequence
	 * did match, an array is returned.
	 * <br><br>
	 * If there are groups (specified by sets of parentheses) in the regular
	 * expression, then the contents of each will be returned in the array.
	 * Element [0] of a regular expression match returns the entire matching
	 * string, and the match groups start at element [1] (the first group is [1],
	 * the second [2], and so on).
	 *
	 * @method match
	 * @param  {String} str    the String to be searched
	 * @param  {String} regexp the regexp to be used for matching
	 * @return {Array}         Array of Strings found
	 * @example
	 * <div>
	 * <code>
	 * var string = "Hello p5js*!"
	 * var regexp = "p5js\\*"
	 * var match = match(string, regexp);
	 * text(match, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.match =  function(str, reg) {
	  return str.match(reg);
	};
	
	/**
	 * This function is used to apply a regular expression to a piece of text,
	 * and return a list of matching groups (elements found inside parentheses)
	 * as a two-dimensional String array. If there are no matches, a null value
	 * will be returned. If no groups are specified in the regular expression,
	 * but the sequence matches, a two dimensional array is still returned, but
	 * the second dimension is only of length one.
	 * <br><br>
	 * To use the function, first check to see if the result is null. If the
	 * result is null, then the sequence did not match at all. If the sequence
	 * did match, a 2D array is returned.
	 * <br><br>
	 * If there are groups (specified by sets of parentheses) in the regular
	 * expression, then the contents of each will be returned in the array.
	 * Assuming a loop with counter variable i, element [i][0] of a regular
	 * expression match returns the entire matching string, and the match groups
	 * start at element [i][1] (the first group is [i][1], the second [i][2],
	 * and so on).
	 *
	 * @method matchAll
	 * @param  {String} str    the String to be searched
	 * @param  {String} regexp the regexp to be used for matching
	 * @return {Array}         2d Array of Strings found
	 * @example
	 * <div class="norender">
	 * <code>
	 * var string = "Hello p5js*! Hello world!"
	 * var regexp = "Hello"
	 * matchAll(string, regexp);
	 * </code>
	 * </div>
	
	 */
	p5.prototype.matchAll = function(str, reg) {
	  var re = new RegExp(reg, 'g');
	  var match = re.exec(str);
	  var matches = [];
	  while (match !== null) {
	    matches.push(match);
	    // matched text: match[0]
	    // match start: match.index
	    // capturing group n: match[n]
	    match = re.exec(str);
	  }
	  return matches;
	};
	
	/**
	 * Utility function for formatting numbers into strings. There are two
	 * versions: one for formatting floats, and one for formatting ints.
	 * The values for the digits, left, and right parameters should always
	 * be positive integers.
	 *
	 * @method nf
	 * @param {Number|Array} num      the Number to format
	 * @param {Number}       [left]   number of digits to the left of the
	 *                                decimal point
	 * @param {Number}       [right]  number of digits to the right of the
	 *                                decimal point
	 * @return {String|Array}         formatted String
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   background(200);
	 *   var num = 112.53106115;
	 *
	 *   noStroke();
	 *   fill(0);
	 *   textSize(14);
	 *   // Draw formatted numbers
	 *   text(nf(num, 5, 2), 10, 20);
	 *
	 *   text(nf(num, 4, 3), 10, 55);
	 *
	 *   text(nf(num, 3, 6), 10, 85);
	 *
	 *   // Draw dividing lines
	 *   stroke(120);
	 *   line(0, 30, width, 30);
	 *   line(0, 65, width, 65);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.nf = function () {
	  if (arguments[0] instanceof Array) {
	    var a = arguments[1];
	    var b = arguments[2];
	    return arguments[0].map(function (x) {
	      return doNf(x, a, b);
	    });
	  }
	  else{
	    var typeOfFirst = Object.prototype.toString.call(arguments[0]);
	    if(typeOfFirst === '[object Arguments]'){
	      if(arguments[0].length===3){
	        return this.nf(arguments[0][0],arguments[0][1],arguments[0][2]);
	      }
	      else if(arguments[0].length===2){
	        return this.nf(arguments[0][0],arguments[0][1]);
	      }
	      else{
	        return this.nf(arguments[0][0]);
	      }
	    }
	    else {
	      return doNf.apply(this, arguments);
	    }
	  }
	};
	
	function doNf() {
	  var num = arguments[0];
	  var neg = num < 0;
	  var n = neg ? num.toString().substring(1) : num.toString();
	  var decimalInd = n.indexOf('.');
	  var intPart = decimalInd !== -1 ? n.substring(0, decimalInd) : n;
	  var decPart = decimalInd !== -1 ? n.substring(decimalInd + 1) : '';
	  var str = neg ? '-' : '';
	  if (arguments.length === 3) {
	    var decimal = '';
	    if(decimalInd !== -1 || arguments[2] - decPart.length > 0){
	      decimal = '.';
	    }
	    if (decPart.length > arguments[2]) {
	      decPart = decPart.substring(0, arguments[2]);
	    }
	    for (var i = 0; i < arguments[1] - intPart.length; i++) {
	      str += '0';
	    }
	    str += intPart;
	    str += decimal;
	    str += decPart;
	    for (var j = 0; j < arguments[2] - decPart.length; j++) {
	      str += '0';
	    }
	    return str;
	  }
	  else {
	    for (var k = 0; k < Math.max(arguments[1] - intPart.length, 0); k++) {
	      str += '0';
	    }
	    str += n;
	    return str;
	  }
	}
	
	/**
	 * Utility function for formatting numbers into strings and placing
	 * appropriate commas to mark units of 1000. There are two versions: one
	 * for formatting ints, and one for formatting an array of ints. The value
	 * for the right parameter should always be a positive integer.
	 *
	 * @method nfc
	 * @param  {Number|Array}   num     the Number to format
	 * @param  {Number}         [right] number of digits to the right of the
	 *                                  decimal point
	 * @return {String|Array}           formatted String
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   background(200);
	 *   var num = 11253106.115;
	 *   var numArr = new Array(1,1,2);
	 *
	 *   noStroke();
	 *   fill(0);
	 *   textSize(12);
	 *
	 *   // Draw formatted numbers
	 *   text(nfc(num, 4, 2), 10, 30);
	 *   text(nfc(numArr, 2, 1), 10, 80);
	 *
	 *   // Draw dividing line
	 *   stroke(120);
	 *   line(0, 50, width, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.nfc = function () {
	  if (arguments[0] instanceof Array) {
	    var a = arguments[1];
	    return arguments[0].map(function (x) {
	      return doNfc(x, a);
	    });
	  } else {
	    return doNfc.apply(this, arguments);
	  }
	};
	function doNfc() {
	  var num = arguments[0].toString();
	  var dec = num.indexOf('.');
	  var rem = dec !== -1 ? num.substring(dec) : '';
	  var n = dec !== -1 ? num.substring(0, dec) : num;
	  n = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	  if (arguments[1] === 0) {
	    rem = '';
	  }
	  else if(arguments[1] !== undefined){
	    if(arguments[1] > rem.length){
	      rem+= dec === -1 ? '.' : '';
	      var len = arguments[1] - rem.length + 1;
	      for(var i =0; i< len; i++){
	        rem += '0';
	      }
	    }
	    else{
	      rem = rem.substring(0, arguments[1] + 1);
	    }
	  }
	  return n + rem;
	}
	
	/**
	 * Utility function for formatting numbers into strings. Similar to nf() but
	 * puts a "+" in front of positive numbers and a "-" in front of negative
	 * numbers. There are two versions: one for formatting floats, and one for
	 * formatting ints. The values for left, and right parameters
	 * should always be positive integers.
	 *
	 * @method nfp
	 * @param {Number|Array} num      the Number to format
	 * @param {Number}       [left]   number of digits to the left of the decimal
	 *                                point
	 * @param {Number}       [right]  number of digits to the right of the
	 *                                decimal point
	 * @return {String|Array}         formatted String
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   background(200);
	 *   var num1 = 11253106.115;
	 *   var num2 = -11253106.115;
	 *
	 *   noStroke();
	 *   fill(0);
	 *   textSize(12);
	 *
	 *   // Draw formatted numbers
	 *   text(nfp(num1, 4, 2), 10, 30);
	 *   text(nfp(num2, 4, 2), 10, 80);
	 *
	 *   // Draw dividing line
	 *   stroke(120);
	 *   line(0, 50, width, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.nfp = function() {
	  var nfRes = this.nf.apply(this, arguments);
	  if (nfRes instanceof Array) {
	    return nfRes.map(addNfp);
	  } else {
	    return addNfp(nfRes);
	  }
	};
	
	function addNfp() {
	  return (
	    parseFloat(arguments[0]) > 0) ?
	    '+'+arguments[0].toString() :
	    arguments[0].toString();
	}
	
	/**
	 * Utility function for formatting numbers into strings. Similar to nf() but
	 * puts a " " (space) in front of positive numbers and a "-" in front of
	 * negative numbers. There are two versions: one for formatting floats, and
	 * one for formatting ints. The values for the digits, left, and right
	 * parameters should always be positive integers.
	 *
	 * @method nfs
	 * @param {Number|Array} num      the Number to format
	 * @param {Number}       [left]   number of digits to the left of the decimal
	 *                                point
	 * @param {Number}       [right]  number of digits to the right of the
	 *                                decimal point
	 * @return {String|Array}         formatted String
	 * @example
	 * <div>
	 * <code>
	 * function setup() {
	 *   background(200);
	 *   var num1 = 11253106.115;
	 *   var num2 = -11253106.115;
	 *
	 *   noStroke();
	 *   fill(0);
	 *   textSize(12);
	 *   // Draw formatted numbers
	 *   text(nfs(num1, 4, 2), 10, 30);
	 *
	 *   text(nfs(num2, 4, 2), 10, 80);
	 *
	 *   // Draw dividing line
	 *   stroke(120);
	 *   line(0, 50, width, 50);
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.nfs = function() {
	  var nfRes = this.nf.apply(this, arguments);
	  if (nfRes instanceof Array) {
	    return nfRes.map(addNfs);
	  } else {
	    return addNfs(nfRes);
	  }
	};
	
	function addNfs() {
	  return (
	    parseFloat(arguments[0]) > 0) ?
	    ' '+arguments[0].toString() :
	    arguments[0].toString();
	}
	
	/**
	 * The split() function maps to String.split(), it breaks a String into
	 * pieces using a character or string as the delimiter. The delim parameter
	 * specifies the character or characters that mark the boundaries between
	 * each piece. A String[] array is returned that contains each of the pieces.
	 *
	 * The splitTokens() function works in a similar fashion, except that it
	 * splits using a range of characters instead of a specific character or
	 * sequence.
	 *
	 * @method split
	 * @param  {String} value the String to be split
	 * @param  {String} delim the String used to separate the data
	 * @return {Array}  Array of Strings
	 * @example
	 * <div>
	 * <code>
	 * var names = "Pat,Xio,Alex"
	 * var splitString = split(names, ",");
	 * text(splitString[0], 5, 30);
	 * text(splitString[1], 5, 50);
	 * text(splitString[2], 5, 70);
	 * </code>
	 * </div>
	 */
	p5.prototype.split = function(str, delim) {
	  return str.split(delim);
	};
	
	/**
	 * The splitTokens() function splits a String at one or many character
	 * delimiters or "tokens." The delim parameter specifies the character or
	 * characters to be used as a boundary.
	 * <br><br>
	 * If no delim characters are specified, any whitespace character is used to
	 * split. Whitespace characters include tab (\t), line feed (\n), carriage
	 * return (\r), form feed (\f), and space.
	 *
	 * @method splitTokens
	 * @param  {String} value   the String to be split
	 * @param  {String} [delim] list of individual Strings that will be used as
	 *                          separators
	 * @return {Array}          Array of Strings
	 * @example
	 * <div class = "norender">
	 * <code>
	 * function setup() {
	 *   var myStr = "Mango, Banana, Lime";
	 *   var myStrArr = splitTokens(myStr, ",");
	 *
	 *   print(myStrArr); // prints : ["Mango"," Banana"," Lime"]
	 * }
	 * </code>
	 * </div>
	 */
	p5.prototype.splitTokens = function() {
	  var d,sqo,sqc,str;
	  str = arguments[1];
	  if (arguments.length > 1) {
	    sqc = /\]/g.exec(str);
	    sqo = /\[/g.exec(str);
	    if ( sqo && sqc ) {
	      str = str.slice(0, sqc.index) + str.slice(sqc.index+1);
	      sqo = /\[/g.exec(str);
	      str = str.slice(0, sqo.index) + str.slice(sqo.index+1);
	      d = new RegExp('[\\['+str+'\\]]','g');
	    } else if ( sqc ) {
	      str = str.slice(0, sqc.index) + str.slice(sqc.index+1);
	      d = new RegExp('[' + str + '\\]]', 'g');
	    } else if(sqo) {
	      str = str.slice(0, sqo.index) + str.slice(sqo.index+1);
	      d = new RegExp('[' + str + '\\[]', 'g');
	    } else {
	      d = new RegExp('[' + str + ']', 'g');
	    }
	  } else {
	    d = /\s/g;
	  }
	  return arguments[0].split(d).filter(function(n){return n;});
	};
	
	/**
	 * Removes whitespace characters from the beginning and end of a String. In
	 * addition to standard whitespace characters such as space, carriage return,
	 * and tab, this function also removes the Unicode "nbsp" character.
	 *
	 * @method trim
	 * @param  {String|Array} [str] a String or Array of Strings to be trimmed
	 * @return {String|Array}       a trimmed String or Array of Strings
	 * @example
	 * <div>
	 * <code>
	 * var string = trim("  No new lines\n   ");
	 * text(string +" here", 2, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.trim = function(str) {
	  if (str instanceof Array) {
	    return str.map(this.trim);
	  } else {
	    return str.trim();
	  }
	};
	
	module.exports = p5;
	
	},{"../core/core":48}],86:[function(_dereq_,module,exports){
	/**
	 * @module Input
	 * @submodule Time & Date
	 * @for p5
	 * @requires core
	 */
	
	'use strict';
	
	var p5 = _dereq_('../core/core');
	
	/**
	 * p5.js communicates with the clock on your computer. The day() function
	 * returns the current day as a value from 1 - 31.
	 *
	 * @method day
	 * @return {Number} the current day
	 * @example
	 * <div>
	 * <code>
	 * var day = day();
	 * text("Current day: \n" + day, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.day = function() {
	  return new Date().getDate();
	};
	
	/**
	 * p5.js communicates with the clock on your computer. The hour() function
	 * returns the current hour as a value from 0 - 23.
	 *
	 * @method hour
	 * @return {Number} the current hour
	 * @example
	 * <div>
	 * <code>
	 * var hour = hour();
	 * text("Current hour:\n" + hour, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.hour = function() {
	  return new Date().getHours();
	};
	
	/**
	 * p5.js communicates with the clock on your computer. The minute() function
	 * returns the current minute as a value from 0 - 59.
	 *
	 * @method minute
	 * @return {Number} the current minute
	 * @example
	 * <div>
	 * <code>
	 * var minute = minute();
	 * text("Current minute: \n" + minute, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.minute = function() {
	  return new Date().getMinutes();
	};
	
	/**
	 * Returns the number of milliseconds (thousandths of a second) since
	 * starting the program. This information is often used for timing events and
	 * animation sequences.
	 *
	 * @method millis
	 * @return {Number} the number of milliseconds since starting the program
	 * @example
	 * <div>
	 * <code>
	 * var millisecond = millis();
	 * text("Milliseconds \nrunning: \n" + millisecond, 5, 40);
	 * </code>
	 * </div>
	 */
	p5.prototype.millis = function() {
	  return window.performance.now();
	};
	
	/**
	 * p5.js communicates with the clock on your computer. The month() function
	 * returns the current month as a value from 1 - 12.
	 *
	 * @method month
	 * @return {Number} the current month
	 * @example
	 * <div>
	 * <code>
	 * var month = month();
	 * text("Current month: \n" + month, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.month = function() {
	  return new Date().getMonth() + 1; //January is 0!
	};
	
	/**
	 * p5.js communicates with the clock on your computer. The second() function
	 * returns the current second as a value from 0 - 59.
	 *
	 * @method second
	 * @return {Number} the current second
	 * @example
	 * <div>
	 * <code>
	 * var second = second();
	 * text("Current second: \n" + second, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.second = function() {
	  return new Date().getSeconds();
	};
	
	/**
	 * p5.js communicates with the clock on your computer. The year() function
	 * returns the current year as an integer (2014, 2015, 2016, etc).
	 *
	 * @method year
	 * @return {Number} the current year
	 * @example
	 * <div>
	 * <code>
	 * var year = year();
	 * text("Current year: \n" + year, 5, 50);
	 * </code>
	 * </div>
	 */
	p5.prototype.year = function() {
	  return new Date().getFullYear();
	};
	
	module.exports = p5;
	
	},{"../core/core":48}]},{},[39])(39)
	});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(166);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/rackt/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	  }
	  /* eslint-disable no-console */
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(166);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(364);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(365);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _isPlainObject = __webpack_require__(370);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(366);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(367);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function checkStateShape(stateProps, dispatch) {
	  (0, _invariant2["default"])((0, _isPlainObject2["default"])(stateProps), '`%sToProps` must return an object. Instead received %s.', dispatch ? 'mapDispatch' : 'mapState', stateProps);
	  return stateProps;
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	  var mapDispatch = (0, _isPlainObject2["default"])(mapDispatchToProps) ? (0, _wrapActionCreators2["default"])(mapDispatchToProps) : mapDispatchToProps || defaultMapDispatchToProps;
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var checkMergedEquals = finalMergeProps !== defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  // Helps track hot reloading.
	
	  var version = nextVersion++;
	
	  function computeMergedProps(stateProps, dispatchProps, parentProps) {
	    var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	    (0, _invariant2["default"])((0, _isPlainObject2["default"])(mergedProps), '`mergeProps` must return an object. Instead received %s.', mergedProps);
	    return mergedProps;
	  }
	
	  return function wrapWithConnect(WrappedComponent) {
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + _this.constructor.displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + _this.constructor.displayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        return checkStateShape(stateProps);
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        return isFactory ? this.computeStateProps(store, props) : checkStateShape(mappedState);
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        return checkStateShape(dispatchProps, true);
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        return isFactory ? this.computeDispatchProps(store, props) : checkStateShape(mappedDispatch, true);
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var prevStoreState = this.state.storeState;
	        var storeState = this.store.getState();
	
	        if (!pure || prevStoreState !== storeState) {
	          this.hasStoreStateChanged = true;
	          this.setState({ storeState: storeState });
	        }
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 364 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(41);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 366 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent) {
	    var keys = Object.getOwnPropertyNames(sourceComponent);
	    for (var i=0; i<keys.length; ++i) {
	        if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]]) {
	            try {
	                targetComponent[keys[i]] = sourceComponent[keys[i]];
	            } catch (error) {
	
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 369 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var isHostObject = __webpack_require__(368),
	    isObjectLike = __webpack_require__(369);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = objectProto;
	  if (typeof value.constructor == 'function') {
	    proto = getPrototypeOf(value);
	  }
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(15);
	
	var findDOMNode = __webpack_require__(116);
	var focusNode = __webpack_require__(198);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(13);
	var FallbackCompositionState = __webpack_require__(380);
	var SyntheticCompositionEvent = __webpack_require__(413);
	var SyntheticInputEvent = __webpack_require__(416);
	
	var keyOf = __webpack_require__(33);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(167);
	var ExecutionEnvironment = __webpack_require__(13);
	var ReactPerf = __webpack_require__(20);
	
	var camelizeStyleName = __webpack_require__(431);
	var dangerousStyleValue = __webpack_require__(421);
	var hyphenateStyleName = __webpack_require__(436);
	var memoizeStringOnly = __webpack_require__(440);
	var warning = __webpack_require__(8);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPluginHub = __webpack_require__(61);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(13);
	var ReactUpdates = __webpack_require__(21);
	var SyntheticEvent = __webpack_require__(45);
	
	var getEventTarget = __webpack_require__(119);
	var isEventSupported = __webpack_require__(122);
	var isTextInputElement = __webpack_require__(195);
	var keyOf = __webpack_require__(33);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var createNodesFromMarkup = __webpack_require__(433);
	var emptyFunction = __webpack_require__(18);
	var getMarkupWrap = __webpack_require__(200);
	var invariant = __webpack_require__(5);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(33);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPropagators = __webpack_require__(62);
	var SyntheticMouseEvent = __webpack_require__(79);
	
	var ReactMount = __webpack_require__(15);
	var keyOf = __webpack_require__(33);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var ReactErrorUtils = __webpack_require__(182);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(36);
	
	var assign = __webpack_require__(7);
	var getTextContentAccessor = __webpack_require__(194);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	var ExecutionEnvironment = __webpack_require__(13);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(63);
	
	var findDOMNode = __webpack_require__(116);
	var warning = __webpack_require__(8);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(44);
	
	var instantiateReactComponent = __webpack_require__(121);
	var shouldUpdateReactComponent = __webpack_require__(124);
	var traverseAllChildren = __webpack_require__(125);
	var warning = __webpack_require__(8);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentWithPureRenderMixin
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(428);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactElement = __webpack_require__(14);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactPerf = __webpack_require__(20);
	var ReactPropTypeLocations = __webpack_require__(78);
	var ReactPropTypeLocationNames = __webpack_require__(77);
	var ReactReconciler = __webpack_require__(44);
	var ReactUpdateQueue = __webpack_require__(114);
	
	var assign = __webpack_require__(7);
	var emptyObject = __webpack_require__(65);
	var invariant = __webpack_require__(5);
	var shouldUpdateReactComponent = __webpack_require__(124);
	var warning = __webpack_require__(8);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(371);
	var CSSPropertyOperations = __webpack_require__(373);
	var DOMProperty = __webpack_require__(50);
	var DOMPropertyOperations = __webpack_require__(108);
	var EventConstants = __webpack_require__(31);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactComponentBrowserEnvironment = __webpack_require__(111);
	var ReactDOMButton = __webpack_require__(386);
	var ReactDOMInput = __webpack_require__(389);
	var ReactDOMOption = __webpack_require__(390);
	var ReactDOMSelect = __webpack_require__(175);
	var ReactDOMTextarea = __webpack_require__(393);
	var ReactMount = __webpack_require__(15);
	var ReactMultiChild = __webpack_require__(399);
	var ReactPerf = __webpack_require__(20);
	var ReactUpdateQueue = __webpack_require__(114);
	
	var assign = __webpack_require__(7);
	var canDefineProperty = __webpack_require__(81);
	var escapeTextContentForBrowser = __webpack_require__(82);
	var invariant = __webpack_require__(5);
	var isEventSupported = __webpack_require__(122);
	var keyOf = __webpack_require__(33);
	var setInnerHTML = __webpack_require__(83);
	var setTextContent = __webpack_require__(123);
	var shallowEqual = __webpack_require__(127);
	var validateDOMNesting = __webpack_require__(126);
	var warning = __webpack_require__(8);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactElementValidator = __webpack_require__(179);
	
	var mapObject = __webpack_require__(439);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(113);
	var LinkedValueUtils = __webpack_require__(109);
	var ReactMount = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(21);
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactDOMSelect = __webpack_require__(175);
	
	var assign = __webpack_require__(7);
	var warning = __webpack_require__(8);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var getNodeForCharacterOffset = __webpack_require__(424);
	var getTextContentAccessor = __webpack_require__(194);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(178);
	var ReactServerRendering = __webpack_require__(404);
	var ReactVersion = __webpack_require__(115);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(109);
	var ReactDOMIDOperations = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(21);
	
	var assign = __webpack_require__(7);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(61);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(196);
	var ExecutionEnvironment = __webpack_require__(13);
	var PooledClass = __webpack_require__(36);
	var ReactInstanceHandles = __webpack_require__(51);
	var ReactMount = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(21);
	
	var assign = __webpack_require__(7);
	var getEventTarget = __webpack_require__(119);
	var getUnboundedScrollPosition = __webpack_require__(434);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFragment
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactElement = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(8);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set a fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is an array.
	 */
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	var ReactFragment = {
	  // Wrap a keyed object in an opaque proxy that warns you if you access any
	  // of its properties.
	  create: function (object) {
	    if (typeof object !== 'object' || !object || Array.isArray(object)) {
	       false ? warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object) : undefined;
	      return object;
	    }
	    if (ReactElement.isValidElement(object)) {
	       false ? warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.') : undefined;
	      return object;
	    }
	
	    !(object.nodeType !== 1) ?  false ? invariant(false, 'React.addons.createFragment(...): Encountered an invalid child; DOM ' + 'elements are not valid children of React components.') : invariant(false) : undefined;
	
	    var result = [];
	
	    for (var key in object) {
	      if (false) {
	        if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.') : undefined;
	          warnedAboutNumeric = true;
	        }
	      }
	      ReactChildren.mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
	    }
	
	    return result;
	  }
	};
	
	module.exports = ReactFragment;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	var EventPluginHub = __webpack_require__(61);
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactClass = __webpack_require__(171);
	var ReactEmptyComponent = __webpack_require__(180);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactNativeComponent = __webpack_require__(186);
	var ReactPerf = __webpack_require__(20);
	var ReactRootIndex = __webpack_require__(189);
	var ReactUpdates = __webpack_require__(21);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactComponent = __webpack_require__(172);
	var ReactClass = __webpack_require__(171);
	var ReactDOMFactories = __webpack_require__(388);
	var ReactElement = __webpack_require__(14);
	var ReactElementValidator = __webpack_require__(179);
	var ReactPropTypes = __webpack_require__(188);
	var ReactVersion = __webpack_require__(115);
	
	var assign = __webpack_require__(7);
	var onlyChild = __webpack_require__(425);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactMultiChildUpdateTypes = __webpack_require__(185);
	
	var ReactCurrentOwner = __webpack_require__(32);
	var ReactReconciler = __webpack_require__(44);
	var ReactChildReconciler = __webpack_require__(383);
	
	var flattenChildren = __webpack_require__(192);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(107);
	var PooledClass = __webpack_require__(36);
	var ReactBrowserEventEmitter = __webpack_require__(76);
	var ReactDOMFeatureFlags = __webpack_require__(174);
	var ReactInputSelection = __webpack_require__(183);
	var Transaction = __webpack_require__(80);
	
	var assign = __webpack_require__(7);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(400);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 403 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(177);
	var ReactElement = __webpack_require__(14);
	var ReactInstanceHandles = __webpack_require__(51);
	var ReactMarkupChecksum = __webpack_require__(184);
	var ReactServerBatchingStrategy = __webpack_require__(403);
	var ReactServerRenderingTransaction = __webpack_require__(405);
	var ReactUpdates = __webpack_require__(21);
	
	var emptyObject = __webpack_require__(65);
	var instantiateReactComponent = __webpack_require__(121);
	var invariant = __webpack_require__(5);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(36);
	var CallbackQueue = __webpack_require__(107);
	var Transaction = __webpack_require__(80);
	
	var assign = __webpack_require__(7);
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(192);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children) {
	    if (!children) {
	      return children;
	    }
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(170);
	var ReactTransitionChildMapping = __webpack_require__(406);
	
	var assign = __webpack_require__(7);
	var emptyFunction = __webpack_require__(18);
	
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	    return React.createElement(this.props.component, this.props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(13);
	var ReactInputSelection = __webpack_require__(183);
	var SyntheticEvent = __webpack_require__(45);
	
	var getActiveElement = __webpack_require__(199);
	var isTextInputElement = __webpack_require__(195);
	var keyOf = __webpack_require__(33);
	var shallowEqual = __webpack_require__(127);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 410 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventListener = __webpack_require__(196);
	var EventPropagators = __webpack_require__(62);
	var ReactMount = __webpack_require__(15);
	var SyntheticClipboardEvent = __webpack_require__(412);
	var SyntheticEvent = __webpack_require__(45);
	var SyntheticFocusEvent = __webpack_require__(415);
	var SyntheticKeyboardEvent = __webpack_require__(417);
	var SyntheticMouseEvent = __webpack_require__(79);
	var SyntheticDragEvent = __webpack_require__(414);
	var SyntheticTouchEvent = __webpack_require__(418);
	var SyntheticUIEvent = __webpack_require__(64);
	var SyntheticWheelEvent = __webpack_require__(419);
	
	var emptyFunction = __webpack_require__(18);
	var getEventCharCode = __webpack_require__(117);
	var invariant = __webpack_require__(5);
	var keyOf = __webpack_require__(33);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(45);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(45);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(79);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(45);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	var getEventCharCode = __webpack_require__(117);
	var getEventKey = __webpack_require__(423);
	var getEventModifierState = __webpack_require__(118);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	var getEventModifierState = __webpack_require__(118);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(79);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 420 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(167);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(7);
	var warning = __webpack_require__(8);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(117);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(82);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(15);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule shallowCompare
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(127);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var assign = __webpack_require__(7);
	var keyOf = __webpack_require__(33);
	var invariant = __webpack_require__(5);
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = keyOf({ $push: null });
	var COMMAND_UNSHIFT = keyOf({ $unshift: null });
	var COMMAND_SPLICE = keyOf({ $splice: null });
	var COMMAND_SET = keyOf({ $set: null });
	var COMMAND_MERGE = keyOf({ $merge: null });
	var COMMAND_APPLY = keyOf({ $apply: null });
	
	var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function (command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : invariant(false) : undefined;
	  var specValue = spec[command];
	  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. ' + 'Did you forget to wrap your parameter in an array?', command, specValue) : invariant(false) : undefined;
	}
	
	function update(value, spec) {
	  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one ' + 'of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : invariant(false) : undefined;
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : invariant(false) : undefined;
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : invariant(false) : undefined;
	    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : invariant(false) : undefined;
	    assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function (item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function (item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : invariant(false) : undefined;
	    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. ' + 'Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : invariant(false) : undefined;
	    spec[COMMAND_SPLICE].forEach(function (args) {
	      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. ' + 'Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : invariant(false) : undefined;
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : invariant(false) : undefined;
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;

/***/ },
/* 430 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(430);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(441);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(13);
	
	var createArrayFromMixed = __webpack_require__(432);
	var getMarkupWrap = __webpack_require__(200);
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 434 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 435 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(435);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 437 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(437);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 439 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 440 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = createDevTools;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactReduxLibComponentsCreateAll = __webpack_require__(547);
	
	var _reactReduxLibComponentsCreateAll2 = _interopRequireDefault(_reactReduxLibComponentsCreateAll);
	
	var _devTools = __webpack_require__(201);
	
	function createDevTools(React) {
	  var PropTypes = React.PropTypes;
	  var Component = React.Component;
	
	  var _createAll = _reactReduxLibComponentsCreateAll2['default'](React);
	
	  var connect = _createAll.connect;
	
	  var DevTools = (function (_Component) {
	    _inherits(DevTools, _Component);
	
	    function DevTools() {
	      _classCallCheck(this, _DevTools);
	
	      _Component.apply(this, arguments);
	    }
	
	    DevTools.prototype.render = function render() {
	      var Monitor = this.props.monitor;
	
	      return React.createElement(Monitor, this.props);
	    };
	
	    var _DevTools = DevTools;
	    DevTools = connect(function (state) {
	      return state;
	    }, _devTools.ActionCreators)(DevTools) || DevTools;
	    return DevTools;
	  })(Component);
	
	  return (function (_Component2) {
	    _inherits(DevToolsWrapper, _Component2);
	
	    _createClass(DevToolsWrapper, null, [{
	      key: 'propTypes',
	      value: {
	        monitor: PropTypes.func.isRequired,
	        store: PropTypes.shape({
	          devToolsStore: PropTypes.shape({
	            dispatch: PropTypes.func.isRequired
	          }).isRequired
	        }).isRequired
	      },
	      enumerable: true
	    }]);
	
	    function DevToolsWrapper(props, context) {
	      _classCallCheck(this, DevToolsWrapper);
	
	      if (props.store && !props.store.devToolsStore) {
	        console.error('Could not find the devTools store inside your store. ' + 'Have you applied devTools() store enhancer?');
	      }
	      _Component2.call(this, props, context);
	    }
	
	    DevToolsWrapper.prototype.render = function render() {
	      return React.createElement(DevTools, _extends({}, this.props, {
	        store: this.props.store.devToolsStore }));
	    };
	
	    return DevToolsWrapper;
	  })(Component);
	}
	
	module.exports = exports['default'];

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _devTools = __webpack_require__(201);
	
	exports.devTools = _interopRequire(_devTools);
	
	var _persistState = __webpack_require__(444);
	
	exports.persistState = _interopRequire(_persistState);

/***/ },
/* 444 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = persistState;
	
	function persistState(sessionId) {
	  var stateDeserializer = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	  var actionDeserializer = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  if (!sessionId) {
	    return function (next) {
	      return function () {
	        return next.apply(undefined, arguments);
	      };
	    };
	  }
	
	  function deserializeState(fullState) {
	    return _extends({}, fullState, {
	      committedState: stateDeserializer(fullState.committedState),
	      computedStates: fullState.computedStates.map(function (computedState) {
	        return _extends({}, computedState, {
	          state: stateDeserializer(computedState.state)
	        });
	      })
	    });
	  }
	
	  function deserializeActions(fullState) {
	    return _extends({}, fullState, {
	      stagedActions: fullState.stagedActions.map(function (action) {
	        return actionDeserializer(action);
	      })
	    });
	  }
	
	  function deserialize(fullState) {
	    if (!fullState) {
	      return fullState;
	    }
	    var deserializedState = fullState;
	    if (typeof stateDeserializer === 'function') {
	      deserializedState = deserializeState(deserializedState);
	    }
	    if (typeof actionDeserializer === 'function') {
	      deserializedState = deserializeActions(deserializedState);
	    }
	    return deserializedState;
	  }
	
	  return function (next) {
	    return function (reducer, initialState) {
	      var key = 'redux-dev-session-' + sessionId;
	
	      var finalInitialState = undefined;
	      try {
	        finalInitialState = deserialize(JSON.parse(localStorage.getItem(key))) || initialState;
	        next(reducer, initialState);
	      } catch (e) {
	        console.warn('Could not read debug session from localStorage:', e);
	        try {
	          localStorage.removeItem(key);
	        } finally {
	          finalInitialState = undefined;
	        }
	      }
	
	      var store = next(reducer, finalInitialState);
	
	      return _extends({}, store, {
	        dispatch: function dispatch(action) {
	          store.dispatch(action);
	
	          try {
	            localStorage.setItem(key, JSON.stringify(store.getState()));
	          } catch (e) {
	            console.warn('Could not write debug session to localStorage:', e);
	          }
	
	          return action;
	        }
	      });
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.getDefaultStyle = getDefaultStyle;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function getDefaultStyle(props) {
	  var left = props.left;
	  var right = props.right;
	  var bottom = props.bottom;
	  var top = props.top;
	
	  if (typeof left === 'undefined' && typeof right === 'undefined') {
	    right = true;
	  }
	  if (typeof top === 'undefined' && typeof bottom === 'undefined') {
	    bottom = true;
	  }
	
	  return {
	    position: 'fixed',
	    zIndex: 10000,
	    fontSize: 17,
	    overflow: 'hidden',
	    opacity: 1,
	    color: 'white',
	    left: left ? 0 : undefined,
	    right: right ? 0 : undefined,
	    top: top ? 0 : undefined,
	    bottom: bottom ? 0 : undefined,
	    maxHeight: bottom && top ? '100%' : '30%',
	    maxWidth: left && right ? '100%' : '30%',
	    wordWrap: 'break-word',
	    boxSizing: 'border-box',
	    boxShadow: '-2px 0 7px 0 rgba(0, 0, 0, 0.5)'
	  };
	}
	
	var DebugPanel = (function (_Component) {
	  _inherits(DebugPanel, _Component);
	
	  function DebugPanel() {
	    _classCallCheck(this, DebugPanel);
	
	    _Component.apply(this, arguments);
	  }
	
	  DebugPanel.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      { style: _extends({}, this.props.getStyle(this.props), this.props.style) },
	      this.props.children
	    );
	  };
	
	  _createClass(DebugPanel, null, [{
	    key: 'propTypes',
	    value: {
	      left: _react.PropTypes.bool,
	      right: _react.PropTypes.bool,
	      bottom: _react.PropTypes.bool,
	      top: _react.PropTypes.bool,
	      getStyle: _react.PropTypes.func.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      getStyle: getDefaultStyle
	    },
	    enumerable: true
	  }]);
	
	  return DebugPanel;
	})(_react.Component);
	
	exports['default'] = DebugPanel;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LogMonitorEntry = __webpack_require__(448);
	
	var _LogMonitorEntry2 = _interopRequireDefault(_LogMonitorEntry);
	
	var _LogMonitorButton = __webpack_require__(447);
	
	var _LogMonitorButton2 = _interopRequireDefault(_LogMonitorButton);
	
	var _themes = __webpack_require__(473);
	
	var themes = _interopRequireWildcard(_themes);
	
	var styles = {
	  container: {
	    fontFamily: 'monaco, Consolas, Lucida Console, monospace',
	    position: 'relative',
	    overflowY: 'hidden',
	    width: '100%',
	    height: '100%',
	    minWidth: 300
	  },
	  buttonBar: {
	    textAlign: 'center',
	    borderBottomWidth: 1,
	    borderBottomStyle: 'solid',
	    borderColor: 'transparent',
	    zIndex: 1,
	    display: 'flex',
	    flexDirection: 'row'
	  },
	  elements: {
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    top: 38,
	    bottom: 0,
	    overflowX: 'hidden',
	    overflowY: 'auto'
	  }
	};
	
	var LogMonitor = (function (_Component) {
	  _inherits(LogMonitor, _Component);
	
	  function LogMonitor(props) {
	    _classCallCheck(this, LogMonitor);
	
	    _Component.call(this, props);
	    if (typeof window !== 'undefined') {
	      window.addEventListener('keydown', this.handleKeyPress.bind(this));
	    }
	  }
	
	  LogMonitor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var node = _react.findDOMNode(this.refs.elements);
	    if (!node) {
	      this.scrollDown = true;
	    } else if (this.props.stagedActions.length < nextProps.stagedActions.length) {
	      var scrollTop = node.scrollTop;
	      var offsetHeight = node.offsetHeight;
	      var scrollHeight = node.scrollHeight;
	
	      this.scrollDown = Math.abs(scrollHeight - (scrollTop + offsetHeight)) < 20;
	    } else {
	      this.scrollDown = false;
	    }
	  };
	
	  LogMonitor.prototype.componentDidUpdate = function componentDidUpdate() {
	    var node = _react.findDOMNode(this.refs.elements);
	    if (!node) {
	      return;
	    }
	    if (this.scrollDown) {
	      var offsetHeight = node.offsetHeight;
	      var scrollHeight = node.scrollHeight;
	
	      node.scrollTop = scrollHeight - offsetHeight;
	      this.scrollDown = false;
	    }
	  };
	
	  LogMonitor.prototype.componentWillMount = function componentWillMount() {
	    var visibleOnLoad = this.props.visibleOnLoad;
	    var monitorState = this.props.monitorState;
	
	    this.props.setMonitorState(_extends({}, monitorState, {
	      isVisible: visibleOnLoad
	    }));
	  };
	
	  LogMonitor.prototype.handleRollback = function handleRollback() {
	    this.props.rollback();
	  };
	
	  LogMonitor.prototype.handleSweep = function handleSweep() {
	    this.props.sweep();
	  };
	
	  LogMonitor.prototype.handleCommit = function handleCommit() {
	    this.props.commit();
	  };
	
	  LogMonitor.prototype.handleToggleAction = function handleToggleAction(index) {
	    this.props.toggleAction(index);
	  };
	
	  LogMonitor.prototype.handleReset = function handleReset() {
	    this.props.reset();
	  };
	
	  LogMonitor.prototype.handleKeyPress = function handleKeyPress(event) {
	    var monitorState = this.props.monitorState;
	
	    if (event.ctrlKey && event.keyCode === 72) {
	      // Ctrl+H
	      event.preventDefault();
	      this.props.setMonitorState(_extends({}, monitorState, {
	        isVisible: !monitorState.isVisible
	      }));
	    }
	  };
	
	  LogMonitor.prototype.render = function render() {
	    var elements = [];
	    var _props = this.props;
	    var monitorState = _props.monitorState;
	    var skippedActions = _props.skippedActions;
	    var stagedActions = _props.stagedActions;
	    var computedStates = _props.computedStates;
	    var select = _props.select;
	
	    var theme = undefined;
	    if (typeof this.props.theme === 'string') {
	      if (typeof themes[this.props.theme] !== 'undefined') {
	        theme = themes[this.props.theme];
	      } else {
	        console.warn('DevTools theme ' + this.props.theme + ' not found, defaulting to nicinabox');
	        theme = themes.nicinabox;
	      }
	    } else {
	      theme = this.props.theme;
	    }
	    if (!monitorState.isVisible) {
	      return null;
	    }
	
	    for (var i = 0; i < stagedActions.length; i++) {
	      var action = stagedActions[i];
	      var _computedStates$i = computedStates[i];
	      var state = _computedStates$i.state;
	      var error = _computedStates$i.error;
	
	      var previousState = undefined;
	      if (i > 0) {
	        previousState = computedStates[i - 1].state;
	      }
	      elements.push(_react2['default'].createElement(_LogMonitorEntry2['default'], { key: i,
	        index: i,
	        theme: theme,
	        select: select,
	        action: action,
	        state: state,
	        previousState: previousState,
	        collapsed: skippedActions[i],
	        error: error,
	        onActionClick: this.handleToggleAction.bind(this) }));
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { style: _extends({}, styles.container, { backgroundColor: theme.base00 }) },
	      _react2['default'].createElement(
	        'div',
	        { style: _extends({}, styles.buttonBar, { borderColor: theme.base02 }) },
	        _react2['default'].createElement(
	          _LogMonitorButton2['default'],
	          { theme: theme, onClick: this.handleReset.bind(this) },
	          'Reset'
	        ),
	        _react2['default'].createElement(
	          _LogMonitorButton2['default'],
	          { theme: theme, onClick: this.handleRollback.bind(this), enabled: computedStates.length },
	          'Revert'
	        ),
	        _react2['default'].createElement(
	          _LogMonitorButton2['default'],
	          { theme: theme, onClick: this.handleSweep.bind(this), enabled: Object.keys(skippedActions).some(function (key) {
	              return skippedActions[key];
	            }) },
	          'Sweep'
	        ),
	        _react2['default'].createElement(
	          _LogMonitorButton2['default'],
	          { theme: theme, onClick: this.handleCommit.bind(this), enabled: computedStates.length > 1 },
	          'Commit'
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: styles.elements, ref: 'elements' },
	        elements
	      )
	    );
	  };
	
	  _createClass(LogMonitor, null, [{
	    key: 'propTypes',
	    value: {
	      computedStates: _react.PropTypes.array.isRequired,
	      currentStateIndex: _react.PropTypes.number.isRequired,
	      monitorState: _react.PropTypes.object.isRequired,
	      stagedActions: _react.PropTypes.array.isRequired,
	      skippedActions: _react.PropTypes.object.isRequired,
	      reset: _react.PropTypes.func.isRequired,
	      commit: _react.PropTypes.func.isRequired,
	      rollback: _react.PropTypes.func.isRequired,
	      sweep: _react.PropTypes.func.isRequired,
	      toggleAction: _react.PropTypes.func.isRequired,
	      jumpToState: _react.PropTypes.func.isRequired,
	      setMonitorState: _react.PropTypes.func.isRequired,
	      select: _react.PropTypes.func.isRequired,
	      visibleOnLoad: _react.PropTypes.bool,
	      theme: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string])
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      select: function select(state) {
	        return state;
	      },
	      monitorState: { isVisible: true },
	      theme: 'nicinabox',
	      visibleOnLoad: true
	    },
	    enumerable: true
	  }]);
	
	  return LogMonitor;
	})(_react.Component);
	
	exports['default'] = LogMonitor;
	module.exports = exports['default'];

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBrighten = __webpack_require__(490);
	
	var _utilsBrighten2 = _interopRequireDefault(_utilsBrighten);
	
	var styles = {
	  base: {
	    cursor: 'pointer',
	    fontWeight: 'bold',
	    borderRadius: 3,
	    padding: 4,
	    marginLeft: 3,
	    marginRight: 3,
	    marginTop: 5,
	    marginBottom: 5,
	    flexGrow: 1,
	    display: 'inline-block',
	    fontSize: '0.8em',
	    color: 'white',
	    textDecoration: 'none'
	  }
	};
	
	var LogMonitorButton = (function (_React$Component) {
	  _inherits(LogMonitorButton, _React$Component);
	
	  function LogMonitorButton(props) {
	    _classCallCheck(this, LogMonitorButton);
	
	    _React$Component.call(this, props);
	    this.state = {
	      hovered: false,
	      active: false
	    };
	  }
	
	  LogMonitorButton.prototype.handleMouseEnter = function handleMouseEnter() {
	    this.setState({ hovered: true });
	  };
	
	  LogMonitorButton.prototype.handleMouseLeave = function handleMouseLeave() {
	    this.setState({ hovered: false });
	  };
	
	  LogMonitorButton.prototype.handleMouseDown = function handleMouseDown() {
	    this.setState({ active: true });
	  };
	
	  LogMonitorButton.prototype.handleMouseUp = function handleMouseUp() {
	    this.setState({ active: false });
	  };
	
	  LogMonitorButton.prototype.onClick = function onClick() {
	    if (!this.props.enabled) {
	      return;
	    }
	    if (this.props.onClick) {
	      this.props.onClick();
	    }
	  };
	
	  LogMonitorButton.prototype.render = function render() {
	    var style = _extends({}, styles.base, {
	      backgroundColor: this.props.theme.base02
	    });
	    if (this.props.enabled && this.state.hovered) {
	      style = _extends({}, style, {
	        backgroundColor: _utilsBrighten2['default'](this.props.theme.base02, 0.2)
	      });
	    }
	    if (!this.props.enabled) {
	      style = _extends({}, style, {
	        opacity: 0.2,
	        cursor: 'text',
	        backgroundColor: 'transparent'
	      });
	    }
	    return _react2['default'].createElement(
	      'a',
	      { onMouseEnter: this.handleMouseEnter.bind(this),
	        onMouseLeave: this.handleMouseLeave.bind(this),
	        onMouseDown: this.handleMouseDown.bind(this),
	        onMouseUp: this.handleMouseUp.bind(this),
	        style: style, onClick: this.onClick.bind(this) },
	      this.props.children
	    );
	  };
	
	  return LogMonitorButton;
	})(_react2['default'].Component);
	
	exports['default'] = LogMonitorButton;
	module.exports = exports['default'];

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJsonTree = __webpack_require__(202);
	
	var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);
	
	var _LogMonitorEntryAction = __webpack_require__(449);
	
	var _LogMonitorEntryAction2 = _interopRequireDefault(_LogMonitorEntryAction);
	
	var styles = {
	  entry: {
	    display: 'block',
	    WebkitUserSelect: 'none'
	  },
	  tree: {
	    paddingLeft: 0
	  }
	};
	
	var LogMonitorEntry = (function (_Component) {
	  _inherits(LogMonitorEntry, _Component);
	
	  function LogMonitorEntry() {
	    _classCallCheck(this, LogMonitorEntry);
	
	    _Component.apply(this, arguments);
	  }
	
	  LogMonitorEntry.prototype.printState = function printState(state, error) {
	    var errorText = error;
	    if (!errorText) {
	      try {
	        return _react2['default'].createElement(_reactJsonTree2['default'], {
	          theme: this.props.theme,
	          keyName: 'state',
	          data: this.props.select(state),
	          previousData: this.props.select(this.props.previousState),
	          style: styles.tree });
	      } catch (err) {
	        errorText = 'Error selecting state.';
	      }
	    }
	    return _react2['default'].createElement(
	      'div',
	      { style: {
	          color: this.props.theme.base08,
	          paddingTop: 20,
	          paddingLeft: 30,
	          paddingRight: 30,
	          paddingBottom: 35
	        } },
	      errorText
	    );
	  };
	
	  LogMonitorEntry.prototype.handleActionClick = function handleActionClick() {
	    var _props = this.props;
	    var index = _props.index;
	    var onActionClick = _props.onActionClick;
	
	    if (index > 0) {
	      onActionClick(index);
	    }
	  };
	
	  LogMonitorEntry.prototype.render = function render() {
	    var _props2 = this.props;
	    var index = _props2.index;
	    var error = _props2.error;
	    var action = _props2.action;
	    var state = _props2.state;
	    var collapsed = _props2.collapsed;
	
	    var styleEntry = {
	      opacity: collapsed ? 0.5 : 1,
	      cursor: index > 0 ? 'pointer' : 'default'
	    };
	    return _react2['default'].createElement(
	      'div',
	      { style: { textDecoration: collapsed ? 'line-through' : 'none' } },
	      _react2['default'].createElement(_LogMonitorEntryAction2['default'], {
	        theme: this.props.theme,
	        collapsed: collapsed,
	        action: action,
	        onClick: this.handleActionClick.bind(this),
	        style: _extends({}, styles.entry, styleEntry) }),
	      !collapsed && _react2['default'].createElement(
	        'div',
	        null,
	        this.printState(state, error)
	      )
	    );
	  };
	
	  _createClass(LogMonitorEntry, null, [{
	    key: 'propTypes',
	    value: {
	      index: _react.PropTypes.number.isRequired,
	      state: _react.PropTypes.object.isRequired,
	      action: _react.PropTypes.object.isRequired,
	      select: _react.PropTypes.func.isRequired,
	      error: _react.PropTypes.string,
	      onActionClick: _react.PropTypes.func.isRequired,
	      collapsed: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  return LogMonitorEntry;
	})(_react.Component);
	
	exports['default'] = LogMonitorEntry;
	module.exports = exports['default'];

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJsonTree = __webpack_require__(202);
	
	var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);
	
	var styles = {
	  actionBar: {
	    paddingTop: 8,
	    paddingBottom: 7,
	    paddingLeft: 16
	  },
	  payload: {
	    margin: 0,
	    overflow: 'auto'
	  }
	};
	
	var LogMonitorAction = (function (_React$Component) {
	  _inherits(LogMonitorAction, _React$Component);
	
	  function LogMonitorAction() {
	    _classCallCheck(this, LogMonitorAction);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  LogMonitorAction.prototype.renderPayload = function renderPayload(payload) {
	    return _react2['default'].createElement(
	      'div',
	      { style: _extends({}, styles.payload, {
	          backgroundColor: this.props.theme.base00
	        }) },
	      Object.keys(payload).length > 0 ? _react2['default'].createElement(_reactJsonTree2['default'], { theme: this.props.theme, keyName: 'action', data: payload }) : ''
	    );
	  };
	
	  LogMonitorAction.prototype.render = function render() {
	    var _props$action = this.props.action;
	    var type = _props$action.type;
	
	    var payload = _objectWithoutProperties(_props$action, ['type']);
	
	    return _react2['default'].createElement(
	      'div',
	      { style: _extends({
	          backgroundColor: this.props.theme.base02,
	          color: this.props.theme.base06
	        }, this.props.style) },
	      _react2['default'].createElement(
	        'div',
	        { style: styles.actionBar,
	          onClick: this.props.onClick },
	        type
	      ),
	      !this.props.collapsed ? this.renderPayload(payload) : ''
	    );
	  };
	
	  return LogMonitorAction;
	})(_react2['default'].Component);
	
	exports['default'] = LogMonitorAction;
	module.exports = exports['default'];

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createDevTools = __webpack_require__(442);
	
	var _createDevTools2 = _interopRequireDefault(_createDevTools);
	
	var DevTools = _createDevTools2['default'](_react2['default']);
	exports.DevTools = DevTools;
	
	var _LogMonitor = __webpack_require__(446);
	
	exports.LogMonitor = _interopRequire(_LogMonitor);
	
	var _DebugPanel = __webpack_require__(445);
	
	exports.DebugPanel = _interopRequire(_DebugPanel);

/***/ },
/* 451 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'apathy',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#031A16',
	  base01: '#0B342D',
	  base02: '#184E45',
	  base03: '#2B685E',
	  base04: '#5F9C92',
	  base05: '#81B5AC',
	  base06: '#A7CEC8',
	  base07: '#D2E7E4',
	  base08: '#3E9688',
	  base09: '#3E7996',
	  base0A: '#3E4C96',
	  base0B: '#883E96',
	  base0C: '#963E4C',
	  base0D: '#96883E',
	  base0E: '#4C963E',
	  base0F: '#3E965B'
	};
	module.exports = exports['default'];

/***/ },
/* 452 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'ashes',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#1C2023',
	  base01: '#393F45',
	  base02: '#565E65',
	  base03: '#747C84',
	  base04: '#ADB3BA',
	  base05: '#C7CCD1',
	  base06: '#DFE2E5',
	  base07: '#F3F4F5',
	  base08: '#C7AE95',
	  base09: '#C7C795',
	  base0A: '#AEC795',
	  base0B: '#95C7AE',
	  base0C: '#95AEC7',
	  base0D: '#AE95C7',
	  base0E: '#C795AE',
	  base0F: '#C79595'
	};
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier dune',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)',
	  base00: '#20201d',
	  base01: '#292824',
	  base02: '#6e6b5e',
	  base03: '#7d7a68',
	  base04: '#999580',
	  base05: '#a6a28c',
	  base06: '#e8e4cf',
	  base07: '#fefbec',
	  base08: '#d73737',
	  base09: '#b65611',
	  base0A: '#cfb017',
	  base0B: '#60ac39',
	  base0C: '#1fad83',
	  base0D: '#6684e1',
	  base0E: '#b854d4',
	  base0F: '#d43552'
	};
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier forest',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)',
	  base00: '#1b1918',
	  base01: '#2c2421',
	  base02: '#68615e',
	  base03: '#766e6b',
	  base04: '#9c9491',
	  base05: '#a8a19f',
	  base06: '#e6e2e0',
	  base07: '#f1efee',
	  base08: '#f22c40',
	  base09: '#df5320',
	  base0A: '#d5911a',
	  base0B: '#5ab738',
	  base0C: '#00ad9c',
	  base0D: '#407ee7',
	  base0E: '#6666ea',
	  base0F: '#c33ff3'
	};
	module.exports = exports['default'];

/***/ },
/* 455 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier heath',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)',
	  base00: '#1b181b',
	  base01: '#292329',
	  base02: '#695d69',
	  base03: '#776977',
	  base04: '#9e8f9e',
	  base05: '#ab9bab',
	  base06: '#d8cad8',
	  base07: '#f7f3f7',
	  base08: '#ca402b',
	  base09: '#a65926',
	  base0A: '#bb8a35',
	  base0B: '#379a37',
	  base0C: '#159393',
	  base0D: '#516aec',
	  base0E: '#7b59c0',
	  base0F: '#cc33cc'
	};
	module.exports = exports['default'];

/***/ },
/* 456 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier lakeside',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)',
	  base00: '#161b1d',
	  base01: '#1f292e',
	  base02: '#516d7b',
	  base03: '#5a7b8c',
	  base04: '#7195a8',
	  base05: '#7ea2b4',
	  base06: '#c1e4f6',
	  base07: '#ebf8ff',
	  base08: '#d22d72',
	  base09: '#935c25',
	  base0A: '#8a8a0f',
	  base0B: '#568c3b',
	  base0C: '#2d8f6f',
	  base0D: '#257fad',
	  base0E: '#5d5db1',
	  base0F: '#b72dd2'
	};
	module.exports = exports['default'];

/***/ },
/* 457 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier seaside',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)',
	  base00: '#131513',
	  base01: '#242924',
	  base02: '#5e6e5e',
	  base03: '#687d68',
	  base04: '#809980',
	  base05: '#8ca68c',
	  base06: '#cfe8cf',
	  base07: '#f0fff0',
	  base08: '#e6193c',
	  base09: '#87711d',
	  base0A: '#c3c322',
	  base0B: '#29a329',
	  base0C: '#1999b3',
	  base0D: '#3d62f5',
	  base0E: '#ad2bee',
	  base0F: '#e619c3'
	};
	module.exports = exports['default'];

/***/ },
/* 458 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'bespin',
	  author: 'jan t. sott',
	  base00: '#28211c',
	  base01: '#36312e',
	  base02: '#5e5d5c',
	  base03: '#666666',
	  base04: '#797977',
	  base05: '#8a8986',
	  base06: '#9d9b97',
	  base07: '#baae9e',
	  base08: '#cf6a4c',
	  base09: '#cf7d34',
	  base0A: '#f9ee98',
	  base0B: '#54be0d',
	  base0C: '#afc4db',
	  base0D: '#5ea6ea',
	  base0E: '#9b859d',
	  base0F: '#937121'
	};
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'brewer',
	  author: 'timothée poisot (http://github.com/tpoisot)',
	  base00: '#0c0d0e',
	  base01: '#2e2f30',
	  base02: '#515253',
	  base03: '#737475',
	  base04: '#959697',
	  base05: '#b7b8b9',
	  base06: '#dadbdc',
	  base07: '#fcfdfe',
	  base08: '#e31a1c',
	  base09: '#e6550d',
	  base0A: '#dca060',
	  base0B: '#31a354',
	  base0C: '#80b1d3',
	  base0D: '#3182bd',
	  base0E: '#756bb1',
	  base0F: '#b15928'
	};
	module.exports = exports['default'];

/***/ },
/* 460 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'bright',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#000000',
	  base01: '#303030',
	  base02: '#505050',
	  base03: '#b0b0b0',
	  base04: '#d0d0d0',
	  base05: '#e0e0e0',
	  base06: '#f5f5f5',
	  base07: '#ffffff',
	  base08: '#fb0120',
	  base09: '#fc6d24',
	  base0A: '#fda331',
	  base0B: '#a1c659',
	  base0C: '#76c7b7',
	  base0D: '#6fb3d2',
	  base0E: '#d381c3',
	  base0F: '#be643c'
	};
	module.exports = exports['default'];

/***/ },
/* 461 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'chalk',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#151515',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#b0b0b0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#f5f5f5',
	  base08: '#fb9fb1',
	  base09: '#eda987',
	  base0A: '#ddb26f',
	  base0B: '#acc267',
	  base0C: '#12cfc0',
	  base0D: '#6fc2ef',
	  base0E: '#e1a3ee',
	  base0F: '#deaf8f'
	};
	module.exports = exports['default'];

/***/ },
/* 462 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'codeschool',
	  author: 'brettof86',
	  base00: '#232c31',
	  base01: '#1c3657',
	  base02: '#2a343a',
	  base03: '#3f4944',
	  base04: '#84898c',
	  base05: '#9ea7a6',
	  base06: '#a7cfa3',
	  base07: '#b5d8f6',
	  base08: '#2a5491',
	  base09: '#43820d',
	  base0A: '#a03b1e',
	  base0B: '#237986',
	  base0C: '#b02f30',
	  base0D: '#484d79',
	  base0E: '#c59820',
	  base0F: '#c98344'
	};
	module.exports = exports['default'];

/***/ },
/* 463 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'colors',
	  author: 'mrmrs (http://clrs.cc)',
	  base00: '#111111',
	  base01: '#333333',
	  base02: '#555555',
	  base03: '#777777',
	  base04: '#999999',
	  base05: '#bbbbbb',
	  base06: '#dddddd',
	  base07: '#ffffff',
	  base08: '#ff4136',
	  base09: '#ff851b',
	  base0A: '#ffdc00',
	  base0B: '#2ecc40',
	  base0C: '#7fdbff',
	  base0D: '#0074d9',
	  base0E: '#b10dc9',
	  base0F: '#85144b'
	};
	module.exports = exports['default'];

/***/ },
/* 464 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'default',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#181818',
	  base01: '#282828',
	  base02: '#383838',
	  base03: '#585858',
	  base04: '#b8b8b8',
	  base05: '#d8d8d8',
	  base06: '#e8e8e8',
	  base07: '#f8f8f8',
	  base08: '#ab4642',
	  base09: '#dc9656',
	  base0A: '#f7ca88',
	  base0B: '#a1b56c',
	  base0C: '#86c1b9',
	  base0D: '#7cafc2',
	  base0E: '#ba8baf',
	  base0F: '#a16946'
	};
	module.exports = exports['default'];

/***/ },
/* 465 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'eighties',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2d2d2d',
	  base01: '#393939',
	  base02: '#515151',
	  base03: '#747369',
	  base04: '#a09f93',
	  base05: '#d3d0c8',
	  base06: '#e8e6df',
	  base07: '#f2f0ec',
	  base08: '#f2777a',
	  base09: '#f99157',
	  base0A: '#ffcc66',
	  base0B: '#99cc99',
	  base0C: '#66cccc',
	  base0D: '#6699cc',
	  base0E: '#cc99cc',
	  base0F: '#d27b53'
	};
	module.exports = exports['default'];

/***/ },
/* 466 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'embers',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#16130F',
	  base01: '#2C2620',
	  base02: '#433B32',
	  base03: '#5A5047',
	  base04: '#8A8075',
	  base05: '#A39A90',
	  base06: '#BEB6AE',
	  base07: '#DBD6D1',
	  base08: '#826D57',
	  base09: '#828257',
	  base0A: '#6D8257',
	  base0B: '#57826D',
	  base0C: '#576D82',
	  base0D: '#6D5782',
	  base0E: '#82576D',
	  base0F: '#825757'
	};
	module.exports = exports['default'];

/***/ },
/* 467 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'flat',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2C3E50',
	  base01: '#34495E',
	  base02: '#7F8C8D',
	  base03: '#95A5A6',
	  base04: '#BDC3C7',
	  base05: '#e0e0e0',
	  base06: '#f5f5f5',
	  base07: '#ECF0F1',
	  base08: '#E74C3C',
	  base09: '#E67E22',
	  base0A: '#F1C40F',
	  base0B: '#2ECC71',
	  base0C: '#1ABC9C',
	  base0D: '#3498DB',
	  base0E: '#9B59B6',
	  base0F: '#be643c'
	};
	module.exports = exports['default'];

/***/ },
/* 468 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'google',
	  author: 'seth wright (http://sethawright.com)',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#CC342B',
	  base09: '#F96A38',
	  base0A: '#FBA922',
	  base0B: '#198844',
	  base0C: '#3971ED',
	  base0D: '#3971ED',
	  base0E: '#A36AC7',
	  base0F: '#3971ED'
	};
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'grayscale',
	  author: 'alexandre gavioli (https://github.com/alexx2/)',
	  base00: '#101010',
	  base01: '#252525',
	  base02: '#464646',
	  base03: '#525252',
	  base04: '#ababab',
	  base05: '#b9b9b9',
	  base06: '#e3e3e3',
	  base07: '#f7f7f7',
	  base08: '#7c7c7c',
	  base09: '#999999',
	  base0A: '#a0a0a0',
	  base0B: '#8e8e8e',
	  base0C: '#868686',
	  base0D: '#686868',
	  base0E: '#747474',
	  base0F: '#5e5e5e'
	};
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'green screen',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#001100',
	  base01: '#003300',
	  base02: '#005500',
	  base03: '#007700',
	  base04: '#009900',
	  base05: '#00bb00',
	  base06: '#00dd00',
	  base07: '#00ff00',
	  base08: '#007700',
	  base09: '#009900',
	  base0A: '#007700',
	  base0B: '#00bb00',
	  base0C: '#005500',
	  base0D: '#009900',
	  base0E: '#00bb00',
	  base0F: '#005500'
	};
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'harmonic16',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#0b1c2c',
	  base01: '#223b54',
	  base02: '#405c79',
	  base03: '#627e99',
	  base04: '#aabcce',
	  base05: '#cbd6e2',
	  base06: '#e5ebf1',
	  base07: '#f7f9fb',
	  base08: '#bf8b56',
	  base09: '#bfbf56',
	  base0A: '#8bbf56',
	  base0B: '#56bf8b',
	  base0C: '#568bbf',
	  base0D: '#8b56bf',
	  base0E: '#bf568b',
	  base0F: '#bf5656'
	};
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'hopscotch',
	  author: 'jan t. sott',
	  base00: '#322931',
	  base01: '#433b42',
	  base02: '#5c545b',
	  base03: '#797379',
	  base04: '#989498',
	  base05: '#b9b5b8',
	  base06: '#d5d3d5',
	  base07: '#ffffff',
	  base08: '#dd464c',
	  base09: '#fd8b19',
	  base0A: '#fdcc59',
	  base0B: '#8fc13e',
	  base0C: '#149b93',
	  base0D: '#1290bf',
	  base0E: '#c85e7c',
	  base0F: '#b33508'
	};
	module.exports = exports['default'];

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _threezerotwofour = __webpack_require__(486);
	
	exports.threezerotwofour = _interopRequire(_threezerotwofour);
	
	var _apathy = __webpack_require__(451);
	
	exports.apathy = _interopRequire(_apathy);
	
	var _ashes = __webpack_require__(452);
	
	exports.ashes = _interopRequire(_ashes);
	
	var _atelierDune = __webpack_require__(453);
	
	exports.atelierDune = _interopRequire(_atelierDune);
	
	var _atelierForest = __webpack_require__(454);
	
	exports.atelierForest = _interopRequire(_atelierForest);
	
	var _atelierHeath = __webpack_require__(455);
	
	exports.atelierHeath = _interopRequire(_atelierHeath);
	
	var _atelierLakeside = __webpack_require__(456);
	
	exports.atelierLakeside = _interopRequire(_atelierLakeside);
	
	var _atelierSeaside = __webpack_require__(457);
	
	exports.atelierSeaside = _interopRequire(_atelierSeaside);
	
	var _bespin = __webpack_require__(458);
	
	exports.bespin = _interopRequire(_bespin);
	
	var _brewer = __webpack_require__(459);
	
	exports.brewer = _interopRequire(_brewer);
	
	var _bright = __webpack_require__(460);
	
	exports.bright = _interopRequire(_bright);
	
	var _chalk = __webpack_require__(461);
	
	exports.chalk = _interopRequire(_chalk);
	
	var _codeschool = __webpack_require__(462);
	
	exports.codeschool = _interopRequire(_codeschool);
	
	var _colors = __webpack_require__(463);
	
	exports.colors = _interopRequire(_colors);
	
	var _default = __webpack_require__(464);
	
	exports['default'] = _interopRequire(_default);
	
	var _eighties = __webpack_require__(465);
	
	exports.eighties = _interopRequire(_eighties);
	
	var _embers = __webpack_require__(466);
	
	exports.embers = _interopRequire(_embers);
	
	var _flat = __webpack_require__(467);
	
	exports.flat = _interopRequire(_flat);
	
	var _google = __webpack_require__(468);
	
	exports.google = _interopRequire(_google);
	
	var _grayscale = __webpack_require__(469);
	
	exports.grayscale = _interopRequire(_grayscale);
	
	var _greenscreen = __webpack_require__(470);
	
	exports.greenscreen = _interopRequire(_greenscreen);
	
	var _harmonic = __webpack_require__(471);
	
	exports.harmonic = _interopRequire(_harmonic);
	
	var _hopscotch = __webpack_require__(472);
	
	exports.hopscotch = _interopRequire(_hopscotch);
	
	var _isotope = __webpack_require__(474);
	
	exports.isotope = _interopRequire(_isotope);
	
	var _marrakesh = __webpack_require__(475);
	
	exports.marrakesh = _interopRequire(_marrakesh);
	
	var _mocha = __webpack_require__(476);
	
	exports.mocha = _interopRequire(_mocha);
	
	var _monokai = __webpack_require__(477);
	
	exports.monokai = _interopRequire(_monokai);
	
	var _ocean = __webpack_require__(479);
	
	exports.ocean = _interopRequire(_ocean);
	
	var _paraiso = __webpack_require__(480);
	
	exports.paraiso = _interopRequire(_paraiso);
	
	var _pop = __webpack_require__(481);
	
	exports.pop = _interopRequire(_pop);
	
	var _railscasts = __webpack_require__(482);
	
	exports.railscasts = _interopRequire(_railscasts);
	
	var _shapeshifter = __webpack_require__(483);
	
	exports.shapeshifter = _interopRequire(_shapeshifter);
	
	var _solarized = __webpack_require__(484);
	
	exports.solarized = _interopRequire(_solarized);
	
	var _summerfruit = __webpack_require__(485);
	
	exports.summerfruit = _interopRequire(_summerfruit);
	
	var _tomorrow = __webpack_require__(487);
	
	exports.tomorrow = _interopRequire(_tomorrow);
	
	var _tube = __webpack_require__(488);
	
	exports.tube = _interopRequire(_tube);
	
	var _twilight = __webpack_require__(489);
	
	exports.twilight = _interopRequire(_twilight);
	
	var _nicinabox = __webpack_require__(478);
	
	exports.nicinabox = _interopRequire(_nicinabox);

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'isotope',
	  author: 'jan t. sott',
	  base00: '#000000',
	  base01: '#404040',
	  base02: '#606060',
	  base03: '#808080',
	  base04: '#c0c0c0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#ff0000',
	  base09: '#ff9900',
	  base0A: '#ff0099',
	  base0B: '#33ff00',
	  base0C: '#00ffff',
	  base0D: '#0066ff',
	  base0E: '#cc00ff',
	  base0F: '#3300ff'
	};
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'marrakesh',
	  author: 'alexandre gavioli (http://github.com/alexx2/)',
	  base00: '#201602',
	  base01: '#302e00',
	  base02: '#5f5b17',
	  base03: '#6c6823',
	  base04: '#86813b',
	  base05: '#948e48',
	  base06: '#ccc37a',
	  base07: '#faf0a5',
	  base08: '#c35359',
	  base09: '#b36144',
	  base0A: '#a88339',
	  base0B: '#18974e',
	  base0C: '#75a738',
	  base0D: '#477ca1',
	  base0E: '#8868b3',
	  base0F: '#b3588e'
	};
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'mocha',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#3B3228',
	  base01: '#534636',
	  base02: '#645240',
	  base03: '#7e705a',
	  base04: '#b8afad',
	  base05: '#d0c8c6',
	  base06: '#e9e1dd',
	  base07: '#f5eeeb',
	  base08: '#cb6077',
	  base09: '#d28b71',
	  base0A: '#f4bc87',
	  base0B: '#beb55b',
	  base0C: '#7bbda4',
	  base0D: '#8ab3b5',
	  base0E: '#a89bb9',
	  base0F: '#bb9584'
	};
	module.exports = exports['default'];

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'monokai',
	  author: 'wimer hazenberg (http://www.monokai.nl)',
	  base00: '#272822',
	  base01: '#383830',
	  base02: '#49483e',
	  base03: '#75715e',
	  base04: '#a59f85',
	  base05: '#f8f8f2',
	  base06: '#f5f4f1',
	  base07: '#f9f8f5',
	  base08: '#f92672',
	  base09: '#fd971f',
	  base0A: '#f4bf75',
	  base0B: '#a6e22e',
	  base0C: '#a1efe4',
	  base0D: '#66d9ef',
	  base0E: '#ae81ff',
	  base0F: '#cc6633'
	};
	module.exports = exports['default'];

/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'nicinabox',
	  author: 'nicinabox (http://github.com/nicinabox)',
	  base00: '#2A2F3A',
	  base01: '#3C444F',
	  base02: '#4F5A65',
	  base03: '#BEBEBE',
	  base04: '#b0b0b0', // unmodified
	  base05: '#d0d0d0', // unmodified
	  base06: '#FFFFFF',
	  base07: '#f5f5f5', // unmodified
	  base08: '#fb9fb1', // unmodified
	  base09: '#FC6D24',
	  base0A: '#ddb26f', // unmodified
	  base0B: '#A1C659',
	  base0C: '#12cfc0', // unmodified
	  base0D: '#6FB3D2',
	  base0E: '#D381C3',
	  base0F: '#deaf8f' // unmodified
	};
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'ocean',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2b303b',
	  base01: '#343d46',
	  base02: '#4f5b66',
	  base03: '#65737e',
	  base04: '#a7adba',
	  base05: '#c0c5ce',
	  base06: '#dfe1e8',
	  base07: '#eff1f5',
	  base08: '#bf616a',
	  base09: '#d08770',
	  base0A: '#ebcb8b',
	  base0B: '#a3be8c',
	  base0C: '#96b5b4',
	  base0D: '#8fa1b3',
	  base0E: '#b48ead',
	  base0F: '#ab7967'
	};
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'paraiso',
	  author: 'jan t. sott',
	  base00: '#2f1e2e',
	  base01: '#41323f',
	  base02: '#4f424c',
	  base03: '#776e71',
	  base04: '#8d8687',
	  base05: '#a39e9b',
	  base06: '#b9b6b0',
	  base07: '#e7e9db',
	  base08: '#ef6155',
	  base09: '#f99b15',
	  base0A: '#fec418',
	  base0B: '#48b685',
	  base0C: '#5bc4bf',
	  base0D: '#06b6ef',
	  base0E: '#815ba4',
	  base0F: '#e96ba8'
	};
	module.exports = exports['default'];

/***/ },
/* 481 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'pop',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#000000',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#b0b0b0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#eb008a',
	  base09: '#f29333',
	  base0A: '#f8ca12',
	  base0B: '#37b349',
	  base0C: '#00aabb',
	  base0D: '#0e5a94',
	  base0E: '#b31e8d',
	  base0F: '#7a2d00'
	};
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'railscasts',
	  author: 'ryan bates (http://railscasts.com)',
	  base00: '#2b2b2b',
	  base01: '#272935',
	  base02: '#3a4055',
	  base03: '#5a647e',
	  base04: '#d4cfc9',
	  base05: '#e6e1dc',
	  base06: '#f4f1ed',
	  base07: '#f9f7f3',
	  base08: '#da4939',
	  base09: '#cc7833',
	  base0A: '#ffc66d',
	  base0B: '#a5c261',
	  base0C: '#519f50',
	  base0D: '#6d9cbe',
	  base0E: '#b6b3eb',
	  base0F: '#bc9458'
	};
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'shapeshifter',
	  author: 'tyler benziger (http://tybenz.com)',
	  base00: '#000000',
	  base01: '#040404',
	  base02: '#102015',
	  base03: '#343434',
	  base04: '#555555',
	  base05: '#ababab',
	  base06: '#e0e0e0',
	  base07: '#f9f9f9',
	  base08: '#e92f2f',
	  base09: '#e09448',
	  base0A: '#dddd13',
	  base0B: '#0ed839',
	  base0C: '#23edda',
	  base0D: '#3b48e3',
	  base0E: '#f996e2',
	  base0F: '#69542d'
	};
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'solarized',
	  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#839496',
	  base05: '#93a1a1',
	  base06: '#eee8d5',
	  base07: '#fdf6e3',
	  base08: '#dc322f',
	  base09: '#cb4b16',
	  base0A: '#b58900',
	  base0B: '#859900',
	  base0C: '#2aa198',
	  base0D: '#268bd2',
	  base0E: '#6c71c4',
	  base0F: '#d33682'
	};
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'summerfruit',
	  author: 'christopher corley (http://cscorley.github.io/)',
	  base00: '#151515',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#B0B0B0',
	  base05: '#D0D0D0',
	  base06: '#E0E0E0',
	  base07: '#FFFFFF',
	  base08: '#FF0086',
	  base09: '#FD8900',
	  base0A: '#ABA800',
	  base0B: '#00C918',
	  base0C: '#1faaaa',
	  base0D: '#3777E6',
	  base0E: '#AD00A1',
	  base0F: '#cc6633'
	};
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'threezerotwofour',
	  author: 'jan t. sott (http://github.com/idleberg)',
	  base00: '#090300',
	  base01: '#3a3432',
	  base02: '#4a4543',
	  base03: '#5c5855',
	  base04: '#807d7c',
	  base05: '#a5a2a2',
	  base06: '#d6d5d4',
	  base07: '#f7f7f7',
	  base08: '#db2d20',
	  base09: '#e8bbd0',
	  base0A: '#fded02',
	  base0B: '#01a252',
	  base0C: '#b5e4f4',
	  base0D: '#01a0e4',
	  base0E: '#a16a94',
	  base0F: '#cdab53'
	};
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'tomorrow',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#cc6666',
	  base09: '#de935f',
	  base0A: '#f0c674',
	  base0B: '#b5bd68',
	  base0C: '#8abeb7',
	  base0D: '#81a2be',
	  base0E: '#b294bb',
	  base0F: '#a3685a'
	};
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'london tube',
	  author: 'jan t. sott',
	  base00: '#231f20',
	  base01: '#1c3f95',
	  base02: '#5a5758',
	  base03: '#737171',
	  base04: '#959ca1',
	  base05: '#d9d8d8',
	  base06: '#e7e7e8',
	  base07: '#ffffff',
	  base08: '#ee2e24',
	  base09: '#f386a1',
	  base0A: '#ffd204',
	  base0B: '#00853e',
	  base0C: '#85cebc',
	  base0D: '#009ddc',
	  base0E: '#98005d',
	  base0F: '#b06110'
	};
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'twilight',
	  author: 'david hart (http://hart-dev.com)',
	  base00: '#1e1e1e',
	  base01: '#323537',
	  base02: '#464b50',
	  base03: '#5f5a60',
	  base04: '#838184',
	  base05: '#a7a7a7',
	  base06: '#c3c3c3',
	  base07: '#ffffff',
	  base08: '#cf6a4c',
	  base09: '#cda869',
	  base0A: '#f9ee98',
	  base0B: '#8f9d6a',
	  base0C: '#afc4db',
	  base0D: '#7587a6',
	  base0E: '#9b859d',
	  base0F: '#9b703f'
	};
	module.exports = exports['default'];

/***/ },
/* 490 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (hexColor, lightness) {
	  var hex = String(hexColor).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex.replace(/(.)/g, '$1$1');
	  }
	  var lum = lightness || 0;
	
	  var rgb = '#';
	  var c = undefined;
	  for (var i = 0; i < 3; ++i) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	  return rgb;
	};
	
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _JSONArrow = __webpack_require__(128);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	var _grabNode = __webpack_require__(85);
	
	var _grabNode2 = _interopRequireDefault(_grabNode);
	
	var styles = {
	  base: {
	    position: 'relative',
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    margin: 0,
	    padding: 0,
	    display: 'inline-block'
	  },
	  span: {
	    cursor: 'default'
	  },
	  spanType: {
	    marginLeft: 5,
	    marginRight: 5
	  }
	};
	
	var JSONArrayNode = (function (_React$Component) {
	  _inherits(JSONArrayNode, _React$Component);
	
	  function JSONArrayNode(props) {
	    _classCallCheck(this, _JSONArrayNode);
	
	    _React$Component.call(this, props);
	    this.defaultProps = {
	      data: [],
	      initialExpanded: false
	    };
	    this.needsChildNodes = true;
	    this.renderedChildren = [];
	    this.itemString = false;
	    this.state = {
	      expanded: this.props.initialExpanded,
	      createdChildNodes: false
	    };
	  }
	
	  // Returns the child nodes for each element in the array. If we have
	  // generated them previously, we return from cache, otherwise we create
	  // them.
	
	  JSONArrayNode.prototype.getChildNodes = function getChildNodes() {
	    var _this = this;
	
	    if (this.state.expanded && this.needsChildNodes) {
	      (function () {
	        var childNodes = [];
	        _this.props.data.forEach(function (element, idx) {
	          var prevData = undefined;
	          if (typeof _this.props.previousData !== 'undefined' && _this.props.previousData !== null) {
	            prevData = _this.props.previousData[idx];
	          }
	          var node = _grabNode2['default'](idx, element, prevData, _this.props.theme);
	          if (node !== false) {
	            childNodes.push(node);
	          }
	        });
	        _this.needsChildNodes = false;
	        _this.renderedChildren = childNodes;
	      })();
	    }
	    return this.renderedChildren;
	  };
	
	  // Returns the "n Items" string for this node, generating and
	  // caching it if it hasn't been created yet.
	
	  JSONArrayNode.prototype.getItemString = function getItemString() {
	    if (!this.itemString) {
	      this.itemString = this.props.data.length + ' item' + (this.props.data.length !== 1 ? 's' : '');
	    }
	    return this.itemString;
	  };
	
	  JSONArrayNode.prototype.render = function render() {
	    var childNodes = this.getChildNodes();
	    var childListStyle = {
	      padding: 0,
	      margin: 0,
	      listStyle: 'none',
	      display: this.state.expanded ? 'block' : 'none'
	    };
	    var containerStyle = undefined;
	    var spanStyle = _extends({}, styles.span, {
	      color: this.props.theme.base0E
	    });
	    containerStyle = _extends({}, styles.base);
	    if (this.state.expanded) {
	      spanStyle = _extends({}, spanStyle, {
	        color: this.props.theme.base03
	      });
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: containerStyle },
	      _react2['default'].createElement(_JSONArrow2['default'], { theme: this.props.theme, open: this.state.expanded, onClick: this.handleClick.bind(this) }),
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }), onClick: this.handleClick.bind(this) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: spanStyle, onClick: this.handleClick.bind(this) },
	        _react2['default'].createElement(
	          'span',
	          { style: styles.spanType },
	          '[]'
	        ),
	        this.getItemString()
	      ),
	      _react2['default'].createElement(
	        'ol',
	        { style: childListStyle },
	        childNodes
	      )
	    );
	  };
	
	  var _JSONArrayNode = JSONArrayNode;
	  JSONArrayNode = _reactMixin2['default'].decorate(_mixins.ExpandedStateHandlerMixin)(JSONArrayNode) || JSONArrayNode;
	  return JSONArrayNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONArrayNode;
	module.exports = exports['default'];
	
	// flag to see if we still need to render our child nodes
	
	// cache store for our child nodes
	
	// cache store for the number of items string we display

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _utilsHexToRgb = __webpack_require__(66);
	
	var _utilsHexToRgb2 = _interopRequireDefault(_utilsHexToRgb);
	
	var styles = {
	  base: {
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    display: 'inline-block',
	    marginRight: 5
	  }
	};
	
	var JSONBooleanNode = (function (_React$Component) {
	  _inherits(JSONBooleanNode, _React$Component);
	
	  function JSONBooleanNode() {
	    _classCallCheck(this, _JSONBooleanNode);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  JSONBooleanNode.prototype.render = function render() {
	    var truthString = this.props.value ? 'true' : 'false';
	    var backgroundColor = 'transparent';
	    if (this.props.previousValue !== this.props.value) {
	      var bgColor = _utilsHexToRgb2['default'](this.props.theme.base06);
	      backgroundColor = 'rgba(' + bgColor.r + ', ' + bgColor.g + ', ' + bgColor.b + ', 0.1)';
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: _extends({}, styles.base, { backgroundColor: backgroundColor }), onClick: this.handleClick.bind(this) },
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: { color: this.props.theme.base09 } },
	        truthString
	      )
	    );
	  };
	
	  var _JSONBooleanNode = JSONBooleanNode;
	  JSONBooleanNode = _reactMixin2['default'].decorate(_mixins.SquashClickEventMixin)(JSONBooleanNode) || JSONBooleanNode;
	  return JSONBooleanNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONBooleanNode;
	module.exports = exports['default'];

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _utilsHexToRgb = __webpack_require__(66);
	
	var _utilsHexToRgb2 = _interopRequireDefault(_utilsHexToRgb);
	
	var styles = {
	  base: {
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    display: 'inline-block',
	    marginRight: 5
	  }
	};
	
	var JSONDateNode = (function (_React$Component) {
	  _inherits(JSONDateNode, _React$Component);
	
	  function JSONDateNode() {
	    _classCallCheck(this, _JSONDateNode);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  JSONDateNode.prototype.render = function render() {
	    var backgroundColor = 'transparent';
	    if (this.props.previousValue !== this.props.value) {
	      var bgColor = _utilsHexToRgb2['default'](this.props.theme.base06);
	      backgroundColor = 'rgba(' + bgColor.r + ', ' + bgColor.g + ', ' + bgColor.b + ', 0.1)';
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: _extends({}, styles.base, { backgroundColor: backgroundColor }), onClick: this.handleClick.bind(this) },
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: { color: this.props.theme.base0B } },
	        this.props.value.toISOString()
	      )
	    );
	  };
	
	  var _JSONDateNode = JSONDateNode;
	  JSONDateNode = _reactMixin2['default'].decorate(_mixins.SquashClickEventMixin)(JSONDateNode) || JSONDateNode;
	  return JSONDateNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONDateNode;
	module.exports = exports['default'];

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _getIterator = __webpack_require__(503)['default'];
	
	var _Number$isSafeInteger = __webpack_require__(504)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _JSONArrow = __webpack_require__(128);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	var _grabNode = __webpack_require__(85);
	
	var _grabNode2 = _interopRequireDefault(_grabNode);
	
	var styles = {
	  base: {
	    position: 'relative',
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    margin: 0,
	    padding: 0,
	    display: 'inline-block'
	  },
	  span: {
	    cursor: 'default'
	  },
	  spanType: {
	    marginLeft: 5,
	    marginRight: 5
	  }
	};
	
	var JSONIterableNode = (function (_React$Component) {
	  _inherits(JSONIterableNode, _React$Component);
	
	  function JSONIterableNode(props) {
	    _classCallCheck(this, _JSONIterableNode);
	
	    _React$Component.call(this, props);
	    this.defaultProps = {
	      data: [],
	      initialExpanded: false
	    };
	    this.needsChildNodes = true;
	    this.renderedChildren = [];
	    this.itemString = false;
	    this.state = {
	      expanded: this.props.initialExpanded,
	      createdChildNodes: false
	    };
	  }
	
	  // Returns the child nodes for each entry in iterable. If we have
	  // generated them previously, we return from cache, otherwise we create
	  // them.
	
	  JSONIterableNode.prototype.getChildNodes = function getChildNodes() {
	    if (this.state.expanded && this.needsChildNodes) {
	      var childNodes = [];
	      for (var _iterator = this.props.data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var entry = _ref;
	
	        var key = null;
	        var value = null;
	        if (Array.isArray(entry)) {
	          key = entry[0];
	          value = entry[1];
	        } else {
	          key = childNodes.length;
	          value = entry;
	        }
	
	        var prevData = undefined;
	        if (typeof this.props.previousData !== 'undefined' && this.props.previousData !== null) {
	          prevData = this.props.previousData[key];
	        }
	        var node = _grabNode2['default'](key, value, prevData, this.props.theme);
	        if (node !== false) {
	          childNodes.push(node);
	        }
	      }
	      this.needsChildNodes = false;
	      this.renderedChildren = childNodes;
	    }
	    return this.renderedChildren;
	  };
	
	  // Returns the "n entries" string for this node, generating and
	  // caching it if it hasn't been created yet.
	
	  JSONIterableNode.prototype.getItemString = function getItemString() {
	    if (!this.itemString) {
	      var data = this.props.data;
	
	      var count = 0;
	      if (_Number$isSafeInteger(data.size)) {
	        count = data.size;
	      } else {
	        for (var _iterator2 = data, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	          var _ref2;
	
	          if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i2++];
	          } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref2 = _i2.value;
	          }
	
	          var entry = _ref2;
	          // eslint-disable-line no-unused-vars
	          count += 1;
	        }
	      }
	      this.itemString = count + ' entr' + (count !== 1 ? 'ies' : 'y');
	    }
	    return this.itemString;
	  };
	
	  JSONIterableNode.prototype.render = function render() {
	    var childNodes = this.getChildNodes();
	    var childListStyle = {
	      padding: 0,
	      margin: 0,
	      listStyle: 'none',
	      display: this.state.expanded ? 'block' : 'none'
	    };
	    var containerStyle = undefined;
	    var spanStyle = _extends({}, styles.span, {
	      color: this.props.theme.base0E
	    });
	    containerStyle = _extends({}, styles.base);
	    if (this.state.expanded) {
	      spanStyle = _extends({}, spanStyle, {
	        color: this.props.theme.base03
	      });
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: containerStyle },
	      _react2['default'].createElement(_JSONArrow2['default'], { theme: this.props.theme, open: this.state.expanded, onClick: this.handleClick.bind(this) }),
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }), onClick: this.handleClick.bind(this) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: spanStyle, onClick: this.handleClick.bind(this) },
	        _react2['default'].createElement(
	          'span',
	          { style: styles.spanType },
	          '()'
	        ),
	        this.getItemString()
	      ),
	      _react2['default'].createElement(
	        'ol',
	        { style: childListStyle },
	        childNodes
	      )
	    );
	  };
	
	  var _JSONIterableNode = JSONIterableNode;
	  JSONIterableNode = _reactMixin2['default'].decorate(_mixins.ExpandedStateHandlerMixin)(JSONIterableNode) || JSONIterableNode;
	  return JSONIterableNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONIterableNode;
	module.exports = exports['default'];
	
	// flag to see if we still need to render our child nodes
	
	// cache store for our child nodes
	
	// cache store for the number of items string we display

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _utilsHexToRgb = __webpack_require__(66);
	
	var _utilsHexToRgb2 = _interopRequireDefault(_utilsHexToRgb);
	
	var styles = {
	  base: {
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    display: 'inline-block',
	    marginRight: 5
	  }
	};
	
	var JSONNullNode = (function (_React$Component) {
	  _inherits(JSONNullNode, _React$Component);
	
	  function JSONNullNode() {
	    _classCallCheck(this, _JSONNullNode);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  JSONNullNode.prototype.render = function render() {
	    var backgroundColor = 'transparent';
	    if (this.props.previousValue !== this.props.value) {
	      var bgColor = _utilsHexToRgb2['default'](this.props.theme.base06);
	      backgroundColor = 'rgba(' + bgColor.r + ', ' + bgColor.g + ', ' + bgColor.b + ', 0.1)';
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: _extends({}, styles.base, { backgroundColor: backgroundColor }), onClick: this.handleClick.bind(this) },
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: { color: this.props.theme.base08 } },
	        'null'
	      )
	    );
	  };
	
	  var _JSONNullNode = JSONNullNode;
	  JSONNullNode = _reactMixin2['default'].decorate(_mixins.SquashClickEventMixin)(JSONNullNode) || JSONNullNode;
	  return JSONNullNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONNullNode;
	module.exports = exports['default'];

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _utilsHexToRgb = __webpack_require__(66);
	
	var _utilsHexToRgb2 = _interopRequireDefault(_utilsHexToRgb);
	
	var styles = {
	  base: {
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    display: 'inline-block',
	    marginRight: 5
	  }
	};
	
	var JSONNumberNode = (function (_React$Component) {
	  _inherits(JSONNumberNode, _React$Component);
	
	  function JSONNumberNode() {
	    _classCallCheck(this, _JSONNumberNode);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  JSONNumberNode.prototype.render = function render() {
	    var backgroundColor = 'transparent';
	    if (this.props.previousValue !== this.props.value) {
	      var bgColor = _utilsHexToRgb2['default'](this.props.theme.base06);
	      backgroundColor = 'rgba(' + bgColor.r + ', ' + bgColor.g + ', ' + bgColor.b + ', 0.1)';
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: _extends({}, styles.base, { backgroundColor: backgroundColor }), onClick: this.handleClick.bind(this) },
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: { color: this.props.theme.base09 } },
	        this.props.value
	      )
	    );
	  };
	
	  var _JSONNumberNode = JSONNumberNode;
	  JSONNumberNode = _reactMixin2['default'].decorate(_mixins.SquashClickEventMixin)(JSONNumberNode) || JSONNumberNode;
	  return JSONNumberNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONNumberNode;
	module.exports = exports['default'];

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _Object$keys = __webpack_require__(508)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _JSONArrow = __webpack_require__(128);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	var _grabNode = __webpack_require__(85);
	
	var _grabNode2 = _interopRequireDefault(_grabNode);
	
	var styles = {
	  base: {
	    position: 'relative',
	    paddingTop: 3,
	    paddingBottom: 3,
	    marginLeft: 14
	  },
	  label: {
	    margin: 0,
	    padding: 0,
	    display: 'inline-block'
	  },
	  span: {
	    cursor: 'default'
	  },
	  spanType: {
	    marginLeft: 5,
	    marginRight: 5
	  }
	};
	
	var JSONObjectNode = (function (_React$Component) {
	  _inherits(JSONObjectNode, _React$Component);
	
	  function JSONObjectNode(props) {
	    _classCallCheck(this, _JSONObjectNode);
	
	    _React$Component.call(this, props);
	    this.defaultProps = {
	      data: [],
	      initialExpanded: false
	    };
	    this.itemString = false;
	    this.needsChildNodes = true;
	    this.renderedChildren = [];
	    this.state = {
	      expanded: this.props.initialExpanded,
	      createdChildNodes: false
	    };
	  }
	
	  // Returns the child nodes for each element in the object. If we have
	  // generated them previously, we return from cache, otherwise we create
	  // them.
	
	  JSONObjectNode.prototype.getChildNodes = function getChildNodes() {
	    if (this.state.expanded && this.needsChildNodes) {
	      var obj = this.props.data;
	      var childNodes = [];
	      for (var k in obj) {
	        if (obj.hasOwnProperty(k)) {
	          var prevData = undefined;
	          if (typeof this.props.previousData !== 'undefined' && this.props.previousData !== null) {
	            prevData = this.props.previousData[k];
	          }
	          var node = _grabNode2['default'](k, obj[k], prevData, this.props.theme);
	          if (node !== false) {
	            childNodes.push(node);
	          }
	        }
	      }
	      this.needsChildNodes = false;
	      this.renderedChildren = childNodes;
	    }
	    return this.renderedChildren;
	  };
	
	  // Returns the "n Items" string for this node, generating and
	  // caching it if it hasn't been created yet.
	
	  JSONObjectNode.prototype.getItemString = function getItemString() {
	    if (!this.itemString) {
	      var len = _Object$keys(this.props.data).length;
	      this.itemString = len + ' key' + (len !== 1 ? 's' : '');
	    }
	    return this.itemString;
	  };
	
	  JSONObjectNode.prototype.render = function render() {
	    var childListStyle = {
	      padding: 0,
	      margin: 0,
	      listStyle: 'none',
	      display: this.state.expanded ? 'block' : 'none'
	    };
	    var containerStyle = undefined;
	    var spanStyle = _extends({}, styles.span, {
	      color: this.props.theme.base0B
	    });
	    containerStyle = _extends({}, styles.base);
	    if (this.state.expanded) {
	      spanStyle = _extends({}, spanStyle, {
	        color: this.props.theme.base03
	      });
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: containerStyle },
	      _react2['default'].createElement(_JSONArrow2['default'], { theme: this.props.theme, open: this.state.expanded, onClick: this.handleClick.bind(this) }),
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }), onClick: this.handleClick.bind(this) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: spanStyle, onClick: this.handleClick.bind(this) },
	        _react2['default'].createElement(
	          'span',
	          { style: styles.spanType },
	          '{}'
	        ),
	        this.getItemString()
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { style: childListStyle },
	        this.getChildNodes()
	      )
	    );
	  };
	
	  var _JSONObjectNode = JSONObjectNode;
	  JSONObjectNode = _reactMixin2['default'].decorate(_mixins.ExpandedStateHandlerMixin)(JSONObjectNode) || JSONObjectNode;
	  return JSONObjectNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONObjectNode;
	module.exports = exports['default'];
	
	// cache store for the number of items string we display
	
	// flag to see if we still need to render our child nodes
	
	// cache store for our child nodes

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _inherits = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(26)['default'];
	
	var _extends = __webpack_require__(27)['default'];
	
	var _interopRequireDefault = __webpack_require__(22)['default'];
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMixin = __webpack_require__(40);
	
	var _reactMixin2 = _interopRequireDefault(_reactMixin);
	
	var _mixins = __webpack_require__(37);
	
	var _utilsHexToRgb = __webpack_require__(66);
	
	var _utilsHexToRgb2 = _interopRequireDefault(_utilsHexToRgb);
	
	var styles = {
	  base: {
	    paddingTop: 3,
	    paddingBottom: 3,
	    paddingRight: 0,
	    marginLeft: 14
	  },
	  label: {
	    display: 'inline-block',
	    marginRight: 5
	  }
	};
	
	var JSONStringNode = (function (_React$Component) {
	  _inherits(JSONStringNode, _React$Component);
	
	  function JSONStringNode() {
	    _classCallCheck(this, _JSONStringNode);
	
	    _React$Component.apply(this, arguments);
	  }
	
	  JSONStringNode.prototype.render = function render() {
	    var backgroundColor = 'transparent';
	    if (this.props.previousValue !== this.props.value) {
	      var bgColor = _utilsHexToRgb2['default'](this.props.theme.base06);
	      backgroundColor = 'rgba(' + bgColor.r + ', ' + bgColor.g + ', ' + bgColor.b + ', 0.1)';
	    }
	    return _react2['default'].createElement(
	      'li',
	      { style: _extends({}, styles.base, { backgroundColor: backgroundColor }), onClick: this.handleClick.bind(this) },
	      _react2['default'].createElement(
	        'label',
	        { style: _extends({}, styles.label, {
	            color: this.props.theme.base0D
	          }) },
	        this.props.keyName,
	        ':'
	      ),
	      _react2['default'].createElement(
	        'span',
	        { style: { color: this.props.theme.base0B } },
	        '"',
	        this.props.value,
	        '"'
	      )
	    );
	  };
	
	  var _JSONStringNode = JSONStringNode;
	  JSONStringNode = _reactMixin2['default'].decorate(_mixins.SquashClickEventMixin)(JSONStringNode) || JSONStringNode;
	  return JSONStringNode;
	})(_react2['default'].Component);
	
	exports['default'] = JSONStringNode;
	module.exports = exports['default'];

/***/ },
/* 499 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  handleClick: function handleClick(e) {
	    e.stopPropagation();
	    this.setState({
	      expanded: !this.state.expanded
	    });
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    // resets our caches and flags we need to build child nodes again
	    this.renderedChildren = [];
	    this.itemString = false;
	    this.needsChildNodes = true;
	  }
	};
	module.exports = exports["default"];

/***/ },
/* 500 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  handleClick: function handleClick(e) {
	    e.stopPropagation();
	  }
	};
	module.exports = exports["default"];

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Symbol$iterator = __webpack_require__(510)['default'];
	
	exports.__esModule = true;
	
	exports['default'] = function (obj) {
	  if (obj !== null && typeof obj === 'object' && !Array.isArray(obj) && typeof obj[_Symbol$iterator] === 'function') {
	    return 'Iterable';
	  }
	  return Object.prototype.toString.call(obj).slice(8, -1);
	};
	
	module.exports = exports['default'];

/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'solarized',
	  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#839496',
	  base05: '#93a1a1',
	  base06: '#eee8d5',
	  base07: '#fdf6e3',
	  base08: '#dc322f',
	  base09: '#cb4b16',
	  base0A: '#b58900',
	  base0B: '#859900',
	  base0C: '#2aa198',
	  base0D: '#268bd2',
	  base0E: '#6c71c4',
	  base0F: '#d33682'
	};
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(513), __esModule: true };

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(514), __esModule: true };

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(515), __esModule: true };

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(516), __esModule: true };

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(517), __esModule: true };

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(518), __esModule: true };

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(519), __esModule: true };

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(520), __esModule: true };

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$defineProperty = __webpack_require__(507)["default"];
	
	exports["default"] = (function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	
	      _Object$defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	})();
	
	exports.__esModule = true;

/***/ },
/* 512 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj["default"] : obj;
	};
	
	exports.__esModule = true;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(213);
	__webpack_require__(212);
	module.exports = __webpack_require__(539);

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(541);
	module.exports = __webpack_require__(38).Number.isSafeInteger;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(542);
	module.exports = __webpack_require__(38).Object.assign;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(39);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(39);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(543);
	module.exports = __webpack_require__(38).Object.keys;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(544);
	module.exports = __webpack_require__(38).Object.setPrototypeOf;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(212);
	__webpack_require__(213);
	module.exports = __webpack_require__(52)('iterator');

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(204)
	  , TAG = __webpack_require__(52)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(130)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(133)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(39)
	  , descriptor     = __webpack_require__(209)
	  , setToStringTag = __webpack_require__(210)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(132)(IteratorPrototype, __webpack_require__(52)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 527 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 528 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(39)
	  , toObject = __webpack_require__(211)
	  , IObject  = __webpack_require__(207);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(130)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(67)
	  , core    = __webpack_require__(38)
	  , fails   = __webpack_require__(130);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(132);

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(39).getDesc
	  , isObject = __webpack_require__(133)
	  , anObject = __webpack_require__(203);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(205)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(131)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(535)
	  , defined   = __webpack_require__(129);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 535 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(207)
	  , defined = __webpack_require__(129);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 537 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(523)
	  , ITERATOR  = __webpack_require__(52)('iterator')
	  , Iterators = __webpack_require__(86);
	module.exports = __webpack_require__(38).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(203)
	  , get      = __webpack_require__(538);
	module.exports = __webpack_require__(38).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(522)
	  , step             = __webpack_require__(527)
	  , Iterators        = __webpack_require__(86)
	  , toIObject        = __webpack_require__(536);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(208)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(67)
	  , isInteger = __webpack_require__(525)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(67);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(529)});

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(211);
	
	__webpack_require__(530)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(67);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(532).set});

/***/ },
/* 545 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 546 */
/***/ function(module, exports) {

	var objToStr = function(x){ return Object.prototype.toString.call(x); };
	
	var thrower = function(error){
	    throw error;
	};
	
	var mixins = module.exports = function makeMixinFunction(rules, _opts){
	    var opts = _opts || {};
	    if (!opts.unknownFunction) {
	        opts.unknownFunction = mixins.ONCE;
	    }
	
	    if (!opts.nonFunctionProperty) {
	        opts.nonFunctionProperty = function(left, right, key){
	            if (left !== undefined && right !== undefined) {
	                var getTypeName = function(obj){
	                    if (obj && obj.constructor && obj.constructor.name) {
	                        return obj.constructor.name;
	                    }
	                    else {
	                        return objToStr(obj).slice(8, -1);
	                    }
	                };
	                throw new TypeError('Cannot mixin key ' + key + ' because it is provided by multiple sources, '
	                        + 'and the types are ' + getTypeName(left) + ' and ' + getTypeName(right));
	            }
	            return left === undefined ? right : left;
	        };
	    }
	
	    function setNonEnumerable(target, key, value){
	        if (key in target){
	            target[key] = value;
	        }
	        else {
	            Object.defineProperty(target, key, {
	                value: value,
	                writable: true,
	                configurable: true
	            });
	        }
	    }
	
	    return function applyMixin(source, mixin){
	        Object.keys(mixin).forEach(function(key){
	            var left = source[key], right = mixin[key], rule = rules[key];
	
	            // this is just a weird case where the key was defined, but there's no value
	            // behave like the key wasn't defined
	            if (left === undefined && right === undefined) return;
	
	            var wrapIfFunction = function(thing){
	                return typeof thing !== "function" ? thing
	                : function(){
	                    return thing.call(this, arguments);
	                };
	            };
	
	            // do we have a rule for this key?
	            if (rule) {
	                // may throw here
	                var fn = rule(left, right, key);
	                setNonEnumerable(source, key, wrapIfFunction(fn));
	                return;
	            }
	
	            var leftIsFn = typeof left === "function";
	            var rightIsFn = typeof right === "function";
	
	            // check to see if they're some combination of functions or undefined
	            // we already know there's no rule, so use the unknown function behavior
	            if (leftIsFn && right === undefined
	             || rightIsFn && left === undefined
	             || leftIsFn && rightIsFn) {
	                // may throw, the default is ONCE so if both are functions
	                // the default is to throw
	                setNonEnumerable(source, key, wrapIfFunction(opts.unknownFunction(left, right, key)));
	                return;
	            }
	
	            // we have no rule for them, one may be a function but one or both aren't
	            // our default is MANY_MERGED_LOOSE which will merge objects, concat arrays
	            // and throw if there's a type mismatch or both are primitives (how do you merge 3, and "foo"?)
	            source[key] = opts.nonFunctionProperty(left, right, key);
	        });
	    };
	};
	
	mixins._mergeObjects = function(obj1, obj2) {
	    var assertObject = function(obj, obj2){
	        var type = objToStr(obj);
	        if (type !== '[object Object]') {
	            var displayType = obj.constructor ? obj.constructor.name : 'Unknown';
	            var displayType2 = obj2.constructor ? obj2.constructor.name : 'Unknown';
	            thrower('cannot merge returned value of type ' + displayType + ' with an ' + displayType2);
	        }
	    };
	
	    if (Array.isArray(obj1) && Array.isArray(obj2)) {
	        return obj1.concat(obj2);
	    }
	
	    assertObject(obj1, obj2);
	    assertObject(obj2, obj1);
	
	    var result = {};
	    Object.keys(obj1).forEach(function(k){
	        if (Object.prototype.hasOwnProperty.call(obj2, k)) {
	            thrower('cannot merge returns because both have the ' + JSON.stringify(k) + ' key');
	        }
	        result[k] = obj1[k];
	    });
	
	    Object.keys(obj2).forEach(function(k){
	        // we can skip the conflict check because all conflicts would already be found
	        result[k] = obj2[k];
	    });
	    return result;
	
	}
	
	// define our built-in mixin types
	mixins.ONCE = function(left, right, key){
	    if (left && right) {
	        throw new TypeError('Cannot mixin ' + key + ' because it has a unique constraint.');
	    }
	
	    var fn = left || right;
	
	    return function(args){
	        return fn.apply(this, args);
	    };
	};
	
	mixins.MANY = function(left, right, key){
	    return function(args){
	        if (right) right.apply(this, args);
	        return left ? left.apply(this, args) : undefined;
	    };
	};
	
	mixins.MANY_MERGED_LOOSE = function(left, right, key) {
	    if(left && right) {
	        return mixins._mergeObjects(left, right);
	    }
	
	    return left || right;
	}
	
	mixins.MANY_MERGED = function(left, right, key){
	    return function(args){
	        var res1 = right && right.apply(this, args);
	        var res2 = left && left.apply(this, args);
	        if (res1 && res2) {
	            return mixins._mergeObjects(res1, res2)
	        }
	        return res2 || res1;
	    };
	};
	
	
	mixins.REDUCE_LEFT = function(_left, _right, key){
	    var left = _left || function(x){ return x };
	    var right = _right || function(x){ return x };
	    return function(args){
	        return right.call(this, left.apply(this, args));
	    };
	};
	
	mixins.REDUCE_RIGHT = function(_left, _right, key){
	    var left = _left || function(x){ return x };
	    var right = _right || function(x){ return x };
	    return function(args){
	        return left.call(this, right.apply(this, args));
	    };
	};
	


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createAll;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _createProvider = __webpack_require__(549);
	
	var _createProvider2 = _interopRequireDefault(_createProvider);
	
	var _createConnect = __webpack_require__(548);
	
	var _createConnect2 = _interopRequireDefault(_createConnect);
	
	function createAll(React) {
	  var Provider = _createProvider2['default'](React);
	  var connect = _createConnect2['default'](React);
	
	  return { Provider: Provider, connect: connect };
	}
	
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = createConnect;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _utilsCreateStoreShape = __webpack_require__(214);
	
	var _utilsCreateStoreShape2 = _interopRequireDefault(_utilsCreateStoreShape);
	
	var _utilsShallowEqual = __webpack_require__(551);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsIsPlainObject = __webpack_require__(550);
	
	var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);
	
	var _utilsWrapActionCreators = __webpack_require__(552);
	
	var _utilsWrapActionCreators2 = _interopRequireDefault(_utilsWrapActionCreators);
	
	var _hoistNonReactStatics = __webpack_require__(553);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(554);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var defaultMapStateToProps = function defaultMapStateToProps() {
	  return {};
	};
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function createConnect(React) {
	  var Component = React.Component;
	  var PropTypes = React.PropTypes;
	
	  var storeShape = _utilsCreateStoreShape2['default'](PropTypes);
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    var shouldSubscribe = Boolean(mapStateToProps);
	    var finalMapStateToProps = mapStateToProps || defaultMapStateToProps;
	    var finalMapDispatchToProps = _utilsIsPlainObject2['default'](mapDispatchToProps) ? _utilsWrapActionCreators2['default'](mapDispatchToProps) : mapDispatchToProps || defaultMapDispatchToProps;
	    var finalMergeProps = mergeProps || defaultMergeProps;
	    var shouldUpdateStateProps = finalMapStateToProps.length > 1;
	    var shouldUpdateDispatchProps = finalMapDispatchToProps.length > 1;
	    var _options$pure = options.pure;
	    var pure = _options$pure === undefined ? true : _options$pure;
	
	    // Helps track hot reloading.
	    var version = nextVersion++;
	
	    function computeStateProps(store, props) {
	      var state = store.getState();
	      var stateProps = shouldUpdateStateProps ? finalMapStateToProps(state, props) : finalMapStateToProps(state);
	
	      _invariant2['default'](_utilsIsPlainObject2['default'](stateProps), '`mapStateToProps` must return an object. Instead received %s.', stateProps);
	      return stateProps;
	    }
	
	    function computeDispatchProps(store, props) {
	      var dispatch = store.dispatch;
	
	      var dispatchProps = shouldUpdateDispatchProps ? finalMapDispatchToProps(dispatch, props) : finalMapDispatchToProps(dispatch);
	
	      _invariant2['default'](_utilsIsPlainObject2['default'](dispatchProps), '`mapDispatchToProps` must return an object. Instead received %s.', dispatchProps);
	      return dispatchProps;
	    }
	
	    function _computeNextState(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      _invariant2['default'](_utilsIsPlainObject2['default'](mergedProps), '`mergeProps` must return an object. Instead received %s.', mergedProps);
	      return mergedProps;
	    }
	
	    return function wrapWithConnect(WrappedComponent) {
	      var Connect = (function (_Component) {
	        _inherits(Connect, _Component);
	
	        Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	          if (!pure) {
	            this.updateStateProps(nextProps);
	            this.updateDispatchProps(nextProps);
	            this.updateState(nextProps);
	            return true;
	          }
	
	          var storeChanged = nextState.storeState !== this.state.storeState;
	          var propsChanged = !_utilsShallowEqual2['default'](nextProps, this.props);
	          var mapStateProducedChange = false;
	          var dispatchPropsChanged = false;
	
	          if (storeChanged || propsChanged && shouldUpdateStateProps) {
	            mapStateProducedChange = this.updateStateProps(nextProps);
	          }
	
	          if (propsChanged && shouldUpdateDispatchProps) {
	            dispatchPropsChanged = this.updateDispatchProps(nextProps);
	          }
	
	          if (propsChanged || mapStateProducedChange || dispatchPropsChanged) {
	            this.updateState(nextProps);
	            return true;
	          }
	
	          return false;
	        };
	
	        function Connect(props, context) {
	          _classCallCheck(this, Connect);
	
	          _Component.call(this, props, context);
	          this.version = version;
	          this.store = props.store || context.store;
	
	          _invariant2['default'](this.store, 'Could not find "store" in either the context or ' + ('props of "' + this.constructor.displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + this.constructor.displayName + '".'));
	
	          this.stateProps = computeStateProps(this.store, props);
	          this.dispatchProps = computeDispatchProps(this.store, props);
	          this.state = { storeState: null };
	          this.updateState();
	        }
	
	        Connect.prototype.computeNextState = function computeNextState() {
	          var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	          return _computeNextState(this.stateProps, this.dispatchProps, props);
	        };
	
	        Connect.prototype.updateStateProps = function updateStateProps() {
	          var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	          var nextStateProps = computeStateProps(this.store, props);
	          if (_utilsShallowEqual2['default'](nextStateProps, this.stateProps)) {
	            return false;
	          }
	
	          this.stateProps = nextStateProps;
	          return true;
	        };
	
	        Connect.prototype.updateDispatchProps = function updateDispatchProps() {
	          var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	          var nextDispatchProps = computeDispatchProps(this.store, props);
	          if (_utilsShallowEqual2['default'](nextDispatchProps, this.dispatchProps)) {
	            return false;
	          }
	
	          this.dispatchProps = nextDispatchProps;
	          return true;
	        };
	
	        Connect.prototype.updateState = function updateState() {
	          var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	          this.nextState = this.computeNextState(props);
	        };
	
	        Connect.prototype.isSubscribed = function isSubscribed() {
	          return typeof this.unsubscribe === 'function';
	        };
	
	        Connect.prototype.trySubscribe = function trySubscribe() {
	          if (shouldSubscribe && !this.unsubscribe) {
	            this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	            this.handleChange();
	          }
	        };
	
	        Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	          if (this.unsubscribe) {
	            this.unsubscribe();
	            this.unsubscribe = null;
	          }
	        };
	
	        Connect.prototype.componentDidMount = function componentDidMount() {
	          this.trySubscribe();
	        };
	
	        Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	          this.tryUnsubscribe();
	        };
	
	        Connect.prototype.handleChange = function handleChange() {
	          if (!this.unsubscribe) {
	            return;
	          }
	
	          this.setState({
	            storeState: this.store.getState()
	          });
	        };
	
	        Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	          return this.refs.wrappedInstance;
	        };
	
	        Connect.prototype.render = function render() {
	          return React.createElement(WrappedComponent, _extends({ ref: 'wrappedInstance'
	          }, this.nextState));
	        };
	
	        return Connect;
	      })(Component);
	
	      Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	      Connect.WrappedComponent = WrappedComponent;
	      Connect.contextTypes = {
	        store: storeShape
	      };
	      Connect.propTypes = {
	        store: storeShape
	      };
	
	      if (false) {
	        Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	          if (this.version === version) {
	            return;
	          }
	
	          // We are hot reloading!
	          this.version = version;
	
	          // Update the state and bindings.
	          this.trySubscribe();
	          this.updateStateProps();
	          this.updateDispatchProps();
	          this.updateState();
	        };
	      }
	
	      return _hoistNonReactStatics2['default'](Connect, WrappedComponent);
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createProvider;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _utilsCreateStoreShape = __webpack_require__(214);
	
	var _utilsCreateStoreShape2 = _interopRequireDefault(_utilsCreateStoreShape);
	
	function isUsingOwnerContext(React) {
	  var version = React.version;
	
	  if (typeof version !== 'string') {
	    return true;
	  }
	
	  var sections = version.split('.');
	  var major = parseInt(sections[0], 10);
	  var minor = parseInt(sections[1], 10);
	
	  return major === 0 && minor === 13;
	}
	
	function createProvider(React) {
	  var Component = React.Component;
	  var PropTypes = React.PropTypes;
	  var Children = React.Children;
	
	  var storeShape = _utilsCreateStoreShape2['default'](PropTypes);
	  var requireFunctionChild = isUsingOwnerContext(React);
	
	  var didWarnAboutChild = false;
	  function warnAboutFunctionChild() {
	    if (didWarnAboutChild || requireFunctionChild) {
	      return;
	    }
	
	    didWarnAboutChild = true;
	    console.error( // eslint-disable-line no-console
	    'With React 0.14 and later versions, you no longer need to ' + 'wrap <Provider> child into a function.');
	  }
	  function warnAboutElementChild() {
	    if (didWarnAboutChild || !requireFunctionChild) {
	      return;
	    }
	
	    didWarnAboutChild = true;
	    console.error( // eslint-disable-line no-console
	    'With React 0.13, you need to ' + 'wrap <Provider> child into a function. ' + 'This restriction will be removed with React 0.14.');
	  }
	
	  var didWarnAboutReceivingStore = false;
	  function warnAboutReceivingStore() {
	    if (didWarnAboutReceivingStore) {
	      return;
	    }
	
	    didWarnAboutReceivingStore = true;
	    console.error( // eslint-disable-line no-console
	    '<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/rackt/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	  }
	
	  var Provider = (function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      return { store: this.store };
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      _Component.call(this, props, context);
	      this.store = props.store;
	    }
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var store = this.store;
	      var nextStore = nextProps.store;
	
	      if (store !== nextStore) {
	        warnAboutReceivingStore();
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      var children = this.props.children;
	
	      if (typeof children === 'function') {
	        warnAboutFunctionChild();
	        children = children();
	      } else {
	        warnAboutElementChild();
	      }
	
	      return Children.only(children);
	    };
	
	    return Provider;
	  })(Component);
	
	  Provider.childContextTypes = {
	    store: storeShape.isRequired
	  };
	  Provider.propTypes = {
	    store: storeShape.isRequired,
	    children: (requireFunctionChild ? PropTypes.func : PropTypes.element).isRequired
	  };
	
	  return Provider;
	}
	
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isPlainObject;
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	
	function isPlainObject(obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}
	
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = wrapActionCreators;
	
	var _redux = __webpack_require__(41);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return _redux.bindActionCreators(actionCreators, dispatch);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 553 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent) {
	    var keys = Object.getOwnPropertyNames(sourceComponent);
	    for (var i=0; i<keys.length; ++i) {
	        if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]]) {
	            try {
	                targetComponent[keys[i]] = sourceComponent[keys[i]];
	            } catch (error) {
	
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(215);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 556 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(216);
	
	var _isPlainObject = __webpack_require__(218);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(217);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 558 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 559 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** www/dist/app.js
 **/